(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ecCom"), require("antd"), require("ReactDOM"), require("weaPortalPublic"), require("mobxReact"), require("mobx"), require("loadjs"), require("ReactRouter"), require("comsMobx"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ecCom", "antd", "ReactDOM", "weaPortalPublic", "mobxReact", "mobx", "loadjs", "ReactRouter", "comsMobx"], factory);
	else if(typeof exports === 'object')
		exports["weaPortal"] = factory(require("React"), require("ecCom"), require("antd"), require("ReactDOM"), require("weaPortalPublic"), require("mobxReact"), require("mobx"), require("loadjs"), require("ReactRouter"), require("comsMobx"));
	else
		root["weaPortal"] = factory(root["React"], root["ecCom"], root["antd"], root["ReactDOM"], root["weaPortalPublic"], root["mobxReact"], root["mobx"], root["loadjs"], root["ReactRouter"], root["comsMobx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_47__, __WEBPACK_EXTERNAL_MODULE_103__, __WEBPACK_EXTERNAL_MODULE_107__, __WEBPACK_EXTERNAL_MODULE_114__, __WEBPACK_EXTERNAL_MODULE_115__, __WEBPACK_EXTERNAL_MODULE_258__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/portal/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 161);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(123);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(188);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(192);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(184), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(86);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46), __webpack_require__(76)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _ActionTypes=__webpack_require__(99);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var RSS=_ActionTypes.ELEMENT_TYPES.RSS,NEWS=_ActionTypes.ELEMENT_TYPES.NEWS,WORKFLOW=_ActionTypes.ELEMENT_TYPES.WORKFLOW,CUSTOMPAGE=_ActionTypes.ELEMENT_TYPES.CUSTOMPAGE,REPORTFORM=_ActionTypes.ELEMENT_TYPES.REPORTFORM,OUTDATA=_ActionTypes.ELEMENT_TYPES.OUTDATA,FORMMODECUSTOMSEARCH=_ActionTypes.ELEMENT_TYPES.FORMMODECUSTOMSEARCH,ADDWF=_ActionTypes.ELEMENT_TYPES.ADDWF,TASK=_ActionTypes.ELEMENT_TYPES.TASK,BLOGSTATUS=_ActionTypes.ELEMENT_TYPES.BLOGSTATUS,CONTACTS=_ActionTypes.ELEMENT_TYPES.CONTACTS,UNREAD_DOCS=_ActionTypes.ELEMENT_TYPES.UNREAD_DOCS,MESSAGE_REMINDING=_ActionTypes.ELEMENT_TYPES.MESSAGE_REMINDING,MY_PROJECTS=_ActionTypes.ELEMENT_TYPES.MY_PROJECTS,NEW_CUSTOMERS=_ActionTypes.ELEMENT_TYPES.NEW_CUSTOMERS,NEW_MEETING=_ActionTypes.ELEMENT_TYPES.NEW_MEETING,UNREAD_COOPERATION=_ActionTypes.ELEMENT_TYPES.UNREAD_COOPERATION,MONTH_TARGET=_ActionTypes.ELEMENT_TYPES.MONTH_TARGET,DAY_PLAN=_ActionTypes.ELEMENT_TYPES.DAY_PLAN,SUBSCRIBE_KONWLEDG=_ActionTypes.ELEMENT_TYPES.SUBSCRIBE_KONWLEDG,MORE_NEWS=_ActionTypes.ELEMENT_TYPES.MORE_NEWS,MAGAZINE=_ActionTypes.ELEMENT_TYPES.MAGAZINE,STOCK=_ActionTypes.ELEMENT_TYPES.STOCK,DOC_CONTENT=_ActionTypes.ELEMENT_TYPES.DOC_CONTENT,AUDIO=_ActionTypes.ELEMENT_TYPES.AUDIO,FAVOURITE=_ActionTypes.ELEMENT_TYPES.FAVOURITE,FLASH=_ActionTypes.ELEMENT_TYPES.FLASH,PICTURE=_ActionTypes.ELEMENT_TYPES.PICTURE,MYCALENDAR=_ActionTypes.ELEMENT_TYPES.MYCALENDAR,IMGSLIDE=_ActionTypes.ELEMENT_TYPES.IMGSLIDE,NEWNOTICE=_ActionTypes.ELEMENT_TYPES.NEWNOTICE,OUTTERSYS=_ActionTypes.ELEMENT_TYPES.OUTTERSYS,SCRATCHPAD=_ActionTypes.ELEMENT_TYPES.SCRATCHPAD,WEATHER=_ActionTypes.ELEMENT_TYPES.WEATHER,VIDEO=_ActionTypes.ELEMENT_TYPES.VIDEO,SLIDE=_ActionTypes.ELEMENT_TYPES.SLIDE,DATACENTER=_ActionTypes.ELEMENT_TYPES.DATACENTER,JOBSINFO=_ActionTypes.ELEMENT_TYPES.JOBSINFO,SEARCHENGINE=_ActionTypes.ELEMENT_TYPES.SEARCHENGINE,NOTICE=_ActionTypes.ELEMENT_TYPES.NOTICE,PLAN=_ActionTypes.ELEMENT_TYPES.PLAN,CUSTOMMENU=_ActionTypes.ELEMENT_TYPES.CUSTOMMENU,WORKTASK=_ActionTypes.ELEMENT_TYPES.WORKTASK,MAIL=_ActionTypes.ELEMENT_TYPES.MAIL,MEETINGCALENDAR=_ActionTypes.ELEMENT_TYPES.MEETINGCALENDAR,LOGIN_NEWS=_ActionTypes.ELEMENT_TYPES.LOGIN_NEWS,MYTASK=_ActionTypes.ELEMENT_TYPES.MYTASK,NEW_DY=_ActionTypes.ELEMENT_TYPES.NEW_DY;//判断元素是否为E9改造后的元素
var isE9Element=function isE9Element(ebaseid){for(var key in _ActionTypes.ELEMENT_TYPES){if(ebaseid===_ActionTypes.ELEMENT_TYPES[key])return true;}return false;};//无权访问的元素的组件
var NoRightCom=function(_React$Component){(0,_inherits3.default)(NoRightCom,_React$Component);function NoRightCom(){(0,_classCallCheck3.default)(this,NoRightCom);return(0,_possibleConstructorReturn3.default)(this,(NoRightCom.__proto__||(0,_getPrototypeOf2.default)(NoRightCom)).apply(this,arguments));}(0,_createClass3.default)(NoRightCom,[{key:'render',value:function render(){return _react2.default.createElement('div',{style:{width:'100%',height:'50px',lineHeight:'50px',textAlign:'center'}},_react2.default.createElement(_antd.Icon,{type:'exclamation-circle',style:{marginRight:'8px',color:'#fa0'}}),_react2.default.createElement('span',null,getLabel(2012,'对不起，您暂时没有权限！')));}}]);return NoRightCom;}(_react2.default.Component);//处理计算E9元素高度
var handleHeight=function handleHeight(oldstyle){var style={};if(!(0,_lodash.isEmpty)(oldstyle)){style=(0,_extends3.default)({},oldstyle);if(style.height){var height=style.height.replace("px","");var nherght=parseInt((parseInt(height)-32+1)/25)*31+32;style['height']=nherght+'px';}}return style;};//返回前一个tab
var doPrev=function doPrev(eid){$("#tabContainer_"+eid).scrollTo({top:'0px',left:$("#tabContainer_"+eid).get(0).scrollLeft-77+'px'},500);};//进入下一个tab
var doNext=function doNext(eid){$("#tabContainer_"+eid).scrollTo({top:'0px',left:$("#tabContainer_"+eid).get(0).scrollLeft+77+'px'},500);};//处理多tab的宽度，并判断是否显示左右箭头导航
var handleWidth=function handleWidth(eid,hpid,length,canHeadbar,displayPosition){var divWidth=length*77+36;var hpWidth=$("#content_"+eid).width();if(parseInt(hpid)<0){// var hpdom = $("#item_"+eid).parents("div[class='homepage']")[0];
var hpdom=$("#item_"+eid).parents('div.homepage')[0];hpWidth=$(hpdom).parent().width();hpWidth=hpWidth-20;divWidth=divWidth-36;}var titleWidth=hpWidth-10;if(!canHeadbar){hpWidth=hpWidth-$("#content_"+eid).find(".optoolbar").width();}if(parseFloat(divWidth)>parseFloat(hpWidth)){$("#tabnavprev_"+eid).css("display","block");$("#tabnavnext_"+eid).css("display","block");if(length>1){if(!canHeadbar){var width=$("#content_"+eid).find(".optoolbar").width()+5;$("#tabContainer_"+eid).css("width",hpWidth-55);$("#tabnavnext_"+eid).css("right",width+'px');}else{$("#tabContainer_"+eid).css("width",hpWidth-55);if(displayPosition&&displayPosition=='bottom'){$("#titleContainer_"+eid).css("width",hpWidth);}}$("#tabContainer_"+eid).css("display","");$("#tabContainer_"+eid).css("margin-left","0px");$("#tabContainer_"+eid).css("margin-right","0px");}else{$("#tabnavprev_"+eid).css("display","none");$("#tabnavnext_"+eid).css("display","none");$("#tabContainer_"+eid).css("display","none");}}else{$("#tabnavprev_"+eid).css("display","none");$("#tabnavnext_"+eid).css("display","none");if(length>1){if(!canHeadbar){$("#tabContainer_"+eid).css("width",hpWidth-50);}else{$("#tabContainer_"+eid).css("width",hpWidth);}$("#tabContainer_"+eid).css("display","");$("#tabContainer_"+eid).css("margin-left","0");$("#tabContainer_"+eid).css("margin-right","0");}else{$("#tabContainer_"+eid).css("display","none");}}$("#tabContainer_"+eid+" table").css("min-width",length*77);};//处理antd Table数据，返回columns
var formatData=function formatData(obj,esetting,fun,currentTab){var imgSymbol=esetting.imgSymbol,linkmode=esetting.linkmode,isremind=esetting.isremind,widths=esetting.widths,titles=esetting.titles,ebaseid=esetting.ebaseid,eid=esetting.eid,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle,isPageAutoWrap=esetting.isPageAutoWrap,_esetting$dataColoums=esetting.dataColoums,dataColoums=_esetting$dataColoums===undefined?[]:_esetting$dataColoums,_esetting$showHeader=esetting.showHeader,showHeader=_esetting$showHeader===undefined?'0':_esetting$showHeader;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var columns=new Array();var i=0;//加载行小图标
if(imgSymbol){var iObj={dataIndex:'imgSymbol',key:'imgSymbol',width:ebaseid=='FormModeCustomSearch'?'1%':'8px',render:function render(){return _react2.default.createElement('img',{style:{marginBottom:'4px'},name:'esymbol',src:imgSymbol});}};columns.push(iObj);}var dataColoumsNew=dataColoums;if(ebaseid=='7'){dataColoumsNew=dataColoums.filter(function(item){if(item.id!='11'){return item;}});}for(var k in obj){if(k==='key')continue;var colObj=new Object();var kv=obj[k];if(kv&&(typeof kv==='undefined'?'undefined':(0,_typeof3.default)(kv))==='object'&&kv.constructor===Object){//判断属性值的类型，Object类型
colObj={dataIndex:k,className:ebaseid===_ActionTypes.ELEMENT_TYPES.WORKFLOW&&k==='requestname'?'reqdetail':'',key:k,render:function render(text){return loadRemind(text,linkmode,isremind,fun,contentfontsize,ebaseid,eid,{},isPageAutoWrap,currentTab);}};}else if(kv&&(typeof kv==='undefined'?'undefined':(0,_typeof3.default)(kv))==='object'&&kv.constructor===Array){//判断属性值的类型，List类型，建模查询中心元素用到
colObj={dataIndex:k,key:k,render:function render(text){return loadListName(contentfontsize,text,linkmode);}};}else{//判断属性值的类型，字符串类型
colObj={dataIndex:k,key:k,render:function render(text){if(typeof text==='string'){if(_isHtml(text)){//判断字符串是否含有html
return _react2.default.createElement('font',{className:text.indexOf("class='font'")==-1?'font wea-f'+contentfontsize:'wea-f'+contentfontsize,dangerouslySetInnerHTML:{__html:text}});}else{return _react2.default.createElement('font',{className:'font wea-f'+contentfontsize},text);}}else{return _react2.default.createElement('font',{className:'font wea-f'+contentfontsize});}}};}if(k=='finish'){colObj={dataIndex:'finish',key:'finish',render:function render(text){return _react2.default.createElement(_ecCom.WeaProgress,{percent:text,strokeColor:'#B37BFA'});}};}if(titles)colObj['title']=titles[i];if(!(0,_lodash.isEmpty)(dataColoumsNew)&&dataColoumsNew[i]){colObj['title']=_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},dataColoumsNew[i].fieldName);};var width=colObj.dataIndex&&widths[colObj.dataIndex];if(ebaseid=='contacts'&&(width<50||width==='*')){width="50px";}if(widths[colObj.dataIndex]!=''&&widths[colObj.dataIndex]!='*'){if(width&&width.indexOf('%')==-1){width+='px';}}if(widths)colObj['width']=width;columns.push(colObj);i+=1;}/*if (ebaseid === ELEMENT_TYPES.WORKFLOW) {                                               //加载流程签字意见查看小图标
        const iObj = {
            dataIndex: 'requestname',
            key: 'imgdetail',
            width: '10px',
            render: (text= {}) => <img title={'查看流转意见'} data_requestid={text.requestid||'-1'} className="imgdetail" style={{cursor:'pointer',display:'none',marginLeft:'-8px',marginBottom:'-1px'}} src="/images/ecology8/homepage/req_wev8.png" width="12px" height="12px"/>
        }
        columns.push(iObj);
    }*/return columns;};//处理属性为集合的数据
var loadListName=function loadListName(contentfontsize,list,linkmode){if(!list||list.length===0)return _react2.default.createElement('span',null);var html=list.map(function(obj,o){var dotstr=o===0?"":" , ";if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Object){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";if(obj.usertype&&obj.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+obj.userid+"' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";}return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('font',null,dotstr,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name)));}else if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Array){var shtml=obj.map(function(obj,s){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";if(obj.usertype&&obj.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+obj.userid+"' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";}return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name));});return _react2.default.createElement('font',null,dotstr,shtml);}});return _react2.default.createElement('span',{className:'td-span-formmodecustomsearch'},html);};//加载提醒方式
var loadRemind=function loadRemind(obj,linkmode,isremind,fun,contentfontsize,ebaseid,eid,style,isPageAutoWrap,currentTab){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font class='font wea-f"+contentfontsize+"'>"+obj.name+"</font></a>";if(obj.usertype&&obj.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+obj.userid+"' title="+obj.name+"><font class='font wea-f"+contentfontsize+"'>"+obj.name+"</font></a>";}return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}var pageAutoWrapStyle={};if(isPageAutoWrap&&isPageAutoWrap=='1'&&(ebaseid=='7'||ebaseid=='8')){pageAutoWrapStyle={whiteSpace:'normal',wordBreak:'break-all',wordWrap:'break-word',display:'block'};}var nametitle=obj.name;if(obj.pretitle)nametitle=obj.pretitle+nametitle;if(obj.lasttitle)nametitle=nametitle+obj.lasttitle;if(obj.coworkTitle)nametitle=obj.coworkTitle;var showName=_react2.default.createElement('font',{style:pageAutoWrapStyle,dangerouslySetInnerHTML:{__html:obj.name}});var nametitle_new='';if(nametitle){nametitle_new=nametitle.replace(/<\/?[^>]*>/g,'');//去除HTML Tag
nametitle_new=nametitle_new.replace(/[\r\n]/g,"");//去除换行
}var lasttitle_new=_react2.default.createElement('font',{dangerouslySetInnerHTML:{__html:obj.lasttitle}});var signNturesIcon='';if(window.tabids&&tabids.length>0&&tabids.findIndex(function(item){return item.curid==currentTab&&item.eid==eid||!item.curid&&item.eid==eid;})>-1){if(obj.img){signNturesIcon=ebaseid=='8'&&obj.requestid>0?_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('img',{style:{marginLeft:'22px'},onClick:function onClick(){return fun(obj.requestid,obj.f_weaver_belongto_userid,obj.f_weaver_belongto_usertype,obj.isurger);},title:getLabel(386528,'查看流转意见'),'data-requestid':obj.requestid||'-1',className:'portal_workflow_signaturesIcon ',src:'/images/ecology8/homepage/req_wev8.png',width:'14px',height:'16px',alt:''}),_react2.default.createElement('span',{className:'zsj_fivelogo',style:{color:'red',marginLeft:'10px',position:'absolute',top:'30%',marginTop:'-8px',fontSize:'16px'}},_react2.default.createElement('img',{style:{width:'16px',height:'17px'},src:window.imgs.imgred,title:'未阅未办'}))):_react2.default.createElement('span',{style:{color:'red',marginLeft:'10px',position:'absolute',top:'30%',marginTop:'-8px',fontSize:'16px'}},_react2.default.createElement('img',{style:{width:'16px',height:'17px'},src:window.imgs.imgred,title:'未阅未办'}));}else{signNturesIcon=ebaseid=='8'&&obj.requestid>0?_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('img',{style:{marginLeft:'22px'},onClick:function onClick(){return fun(obj.requestid,obj.f_weaver_belongto_userid,obj.f_weaver_belongto_usertype,obj.isurger);},title:getLabel(386528,'查看流转意见'),'data-requestid':obj.requestid||'-1',className:'portal_workflow_signaturesIcon ',src:'/images/ecology8/homepage/req_wev8.png',width:'14px',height:'16px',alt:''}),_react2.default.createElement('span',{className:'zsj_fivelogo',style:{color:'#efc942',marginLeft:'10px',position:'absolute',top:'30%',marginTop:'-8px',fontSize:'16px'}},_react2.default.createElement('img',{style:{width:'16px',height:'17px'},src:window.imgs.imgyell,title:'已阅未办'}))):_react2.default.createElement('span',{style:{color:'#efc942',marginLeft:'10px',position:'absolute',top:'30%',marginTop:'-8px',fontSize:'16px'}},_react2.default.createElement('img',{style:{width:'16px',height:'17px'},src:window.imgs.imgyell,title:'已阅未办'}));}}else{signNturesIcon=ebaseid=='8'&&obj.requestid>0?_react2.default.createElement('img',{onClick:function onClick(){return fun(obj.requestid,obj.f_weaver_belongto_userid,obj.f_weaver_belongto_usertype,obj.isurger);},title:getLabel(386528,'查看流转意见'),'data-requestid':obj.requestid||'-1',className:'portal_workflow_signaturesIcon ',src:'/images/ecology8/homepage/req_wev8.png',width:'14px',height:'16px',alt:''}):'';}// signNturesIcon = (ebaseid == '8' && obj.requestid > 0 ? <img onClick={() => fun(obj.requestid, obj.f_weaver_belongto_userid, obj.f_weaver_belongto_usertype, obj.isurger)} title={getLabel(386528, '查看流转意见')} data-requestid={obj.requestid || '-1'} className="portal_workflow_signaturesIcon " src={'/images/ecology8/homepage/req_wev8.png'} width="14px" height="16px" alt="" /> : '');
var wfremindimgId='portal_wfremindimg_'+obj.requestid;if(!obj.requestid&&obj.link&&(ebaseid=='7'||ebaseid=='7_DY')){var index=obj.link.indexOf('&');if(index>0)wfremindimgId='portal_wfremindimg_news_'+obj.link.substring(0,index).replace(/[^0-9]/ig,"");};if(obj.img){if(isremind){var style={};var tempremind="";if(isremind.indexOf("#")>-1){tempremind=isremind.substring(0,isremind.indexOf("#")-1);}else{tempremind=isremind;}if(tempremind.indexOf("3")!==-1){var color=isremind.substr(isremind.indexOf("#"));style['color']=color;}if(tempremind.indexOf("1")!==-1){style['fontWeight']='bold';}if(tempremind.indexOf("2")!==-1){style['fontStyle']='italic';}if(tempremind.indexOf("0")===-1){return _react2.default.createElement('span',{className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,(0,_extends3.default)({},obj,{ebaseid:ebaseid,eid:eid}));},'data-link':obj.link,id:obj.requestid,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{style:{width:'100%'},className:'font wea-f'+contentfontsize},_react2.default.createElement('font',{style:style},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},lasttitle_new):null))),signNturesIcon);}else{return _react2.default.createElement('span',{id:wfremindimgId,className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,(0,_extends3.default)({},obj,{ebaseid:ebaseid,id:wfremindimgId,eid:eid}));},'data-link':obj.link,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{width:"100%"}},_react2.default.createElement('font',{style:style},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},lasttitle_new):null))),_react2.default.createElement('img',{className:'wfremindimg',src:obj.img}),signNturesIcon);}}var isshow=window.tabids&&tabids.length>0&&tabids.findIndex(function(item){return item.curid==currentTab&&item.eid==eid||!item.curid&&item.eid==eid;})>-1;return _react2.default.createElement('span',{id:wfremindimgId,className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,(0,_extends3.default)({},obj,{ebaseid:ebaseid,id:wfremindimgId,eid:eid}));},'data-link':obj.link,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{width:"100%"}},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},lasttitle_new):null)),_react2.default.createElement('img',{className:'wfremindimg',src:obj.img,style:{display:isshow?'none':'inline-block'}}),signNturesIcon);}if(style){return _react2.default.createElement('span',{className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,obj.requestid);},'data-link':obj.link,id:obj.requestid,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{style:style,className:'font wea-f'+contentfontsize},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},obj.lasttitle):null)),signNturesIcon);}else return _react2.default.createElement('span',{className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,obj.requestid);},'data-link':obj.link,id:obj.requestid,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{width:'100%'}},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},obj.lasttitle):null)),signNturesIcon);};//获取当前时间戳(以s为单位)
var formatDate=function formatDate(_date,format){var date={"M+":_date.getMonth()+1,"d+":_date.getDate(),"h+":_date.getHours(),"m+":_date.getMinutes(),"s+":_date.getSeconds(),"q+":Math.floor((_date.getMonth()+3)/3),"S+":_date.getMilliseconds()};if(/(y+)/i.test(format)){format=format.replace(RegExp.$1,(_date.getFullYear()+'').substr(4-RegExp.$1.length));}for(var k in date){if(new RegExp("("+k+")").test(format)){format=format.replace(RegExp.$1,RegExp.$1.length==1?date[k]:("00"+date[k]).substr((""+date[k]).length));}}return format;};//数组contains函数
var isContain=function isContain(arr,element){for(var i=0;i<arr.length;i++){if(arr[i]==element){return true;}}return false;};//定义map函数，实现间隔遍历
var intervalMap=function intervalMap(arr,fn){var mul=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var a=[];if(mul>0){for(var i=0;i<arr.length;i+=mul){var value=fn(arr[i],i);if(value==null){continue;//如果函数fn返回null，则从数组中删除该项
}a.push(value);}}return a;};/** --------- 元素工具栏功能js函数 -----------**/function onSetting(eid,ebaseid,hpid,subCompanyId){// 获取设置页面内容
var settingUrl="/page/element/setting.jsp"+"?eid="+eid+"&ebaseid="+ebaseid+"&hpid="+hpid+"&subcompanyid="+subCompanyId;$.post(settingUrl,null,function(data){if($.trim(data)!=""){$("#setting_"+eid).hide();$("#setting_"+eid).remove();$("#content_"+eid).prepend($.trim(data));$(".tabs").PortalTabs({getLine:1,topHeight:40});$(".tab_box").height(0);$("#setting_"+eid).show();$("#weavertabs-content-"+eid).show();var urlContent=$.trim($("#weavertabs-content-"+eid).attr("url")).replace(/&amp;/g,"&");var urlStyle=$.trim($("#weavertabs-style-"+eid).attr("url")).replace(/&amp;/g,"&");var urlShare=$.trim($("#weavertabs-share-"+eid).attr("url")).replace(/&amp;/g,"&");if(urlContent!=""){var randomValue=new Date().getTime();if(ebaseid==7||ebaseid==8||ebaseid==1||ebaseid=='news'||ebaseid==29||ebaseid=='reportForm'){$("#setting_"+eid).attr("randomValue",randomValue);}urlContent=urlContent+"&random="+randomValue;$("#weavertabs-content-"+eid).html("");$("#weavertabs-content-"+eid).html("<img src=/images/loading2_wev8.gif> loading...");$("#weavertabs-content-"+eid).load(urlContent,{},function(){//$("#sync_datacenter_"+eid).tzCheckbox({labels:['','']});
$(".filetree").filetree();//$(".vtip").simpletooltip();
//fixedPosition(eid);
jscolor.init();// 初始化layout组件
initLayout();});}if(urlStyle!=""){$("#weavertabs-style-"+eid).load(urlStyle,{},function(){// 初始化layout组件
initLayout();$("#weavertabs-style-"+eid).hide();});}if(urlShare!=""){$("#weavertabs-share-"+eid).load(urlShare,{},function(){$("#weavertabs-share-"+eid).hide();});}}});}//处理hpid页面元素缓存数据
var hpinfoHandle=function hpinfoHandle(){var param=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var eid=arguments[1];var _param$hpinfo=param.hpinfo,hpinfo=_param$hpinfo===undefined?{}:_param$hpinfo;var _hpinfo$layoutFlags=hpinfo.layoutFlags,layoutFlags=_hpinfo$layoutFlags===undefined?{}:_hpinfo$layoutFlags;layoutFlags.map(function(item){if(item.areaElements.length>0){for(var i=0;i<item.areaElements.length;i++){if(item.areaElements[i].item.eid==eid){item.areaElements.splice(i,1);break;}}}return item;});return(0,_objectAssign2.default)({},param,{hpinfo:(0,_objectAssign2.default)({},param.hpinfo,{layoutFlags:layoutFlags})});};var getMoreRouteUrl=function getMoreRouteUrl(eid,ebaseid){var paramsObj=window.elements_more_params[eid]||{};switch(ebaseid){//公告元素
case NEWNOTICE:if(paramsObj.createMethod&&paramsObj.createMethod=='1'){return'/spa/portal/moreStatic/index_more.html#/more?ebaseid='+ebaseid+'&eid='+eid+'&canAddNotice='+paramsObj.canAddNotice;// return '/spa/portal/moreStatic/index_more.html#/more?ebaseid=${ebaseid}&eid=${eid}&canAdd=${paramsObj.canAddNotice};
}return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//RSS阅读器
case RSS:return'/spa/portal/moreStatic/index_more.html#/more?ebaseid='+ebaseid+'&eid='+eid+'&tabid='+paramsObj.tabid;//流程中心
case WORKFLOW:var urger=paramsObj.urger||false;if(urger){return'/spa/workflow/index_mobx.jsp#/main/workflow/supervise?fromwhere=jsonFilter';}return'/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult?fromwhere=jsonFilter';//集成登录
case OUTTERSYS:return'/spa/portal/moreStatic/index_more.html#/more?ebaseid='+ebaseid+'&eid='+eid;//外部数据
case OUTDATA:return'/spa/inte/static/index.html#/main/inte/portal/'+eid+'/'+paramsObj.tabid;//我的项目
case MY_PROJECTS:return'/spa/prj/index.html#/main/prj/queryProjectResult';//未读协作
case UNREAD_COOPERATION:return'/spa/cowork/static/index.html#/main/cowork/main';//通讯录
case CONTACTS:return'/spa/hrm/index_mobx.html#/main/hrm/addressBook';//微博
case BLOGSTATUS:return'/spa/blog/index_mobx.html#/main/blog/myBlog';//最新客户
case NEW_CUSTOMERS:return'/spa/crm/static4report/index.html#/main/crmReport/customer/newList';//建模查询中心元素
case FORMMODECUSTOMSEARCH:if(paramsObj.morehref||paramsObj.morehref!=''){return paramsObj.morehref;}return'/spa/cube/index.html#/main/cube/search?customid='+paramsObj.customid;//最新会议
case NEW_MEETING:return'/spa/meeting/static/index.html#/main/meeting/CalView';//日程
case DAY_PLAN:return'/spa/workplan/static/index.html#/main/wp/myWorkPlan';//新建流程
case ADDWF:return'/spa/workflow/static/index.html#/main/workflow/add';//未读文档
case UNREAD_DOCS:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter&isNew=1';//文档中心
case NEWS:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//文档中心(特殊)
case NEW_DY:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//我的邮件
case MAIL:return'/spa/email/static/index.html#/main/email/inbox?folderid=0';//公司新闻
case LOGIN_NEWS:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//自定义页面元素
case CUSTOMPAGE:return paramsObj.moreurl;//收藏元素
case FAVOURITE:return'/spa/favourite/index.html#/main/favourite/tree';//日历日程
case MYCALENDAR:return'/spa/workplan/static/index.html#/main/wp/myWorkPlan ';// 会议日历
case MEETINGCALENDAR:return'/spa/meeting/static/index.html#/main/meeting/CalView';// 我的任务
case MYTASK:return'/spa/prj/index.html#/main/prj/queryTaskResult?searchfrom=portal';default:return'';}};//没有more页面的元素
var isNoMoreElement=function isNoMoreElement(ebaseid){switch(ebaseid){//任务计划
case WORKTASK://多图元素
case IMGSLIDE://视频元素
case VIDEO://便签元素
case SCRATCHPAD://天气元素
case WEATHER://个人数据
case DATACENTER://多岗位办理事项
case JOBSINFO://音频元素
case AUDIO://flash元素
case FLASH://自定义菜单
case CUSTOMMENU://图片元素
case PICTURE://图表元素
case REPORTFORM://搜索元素
case SEARCHENGINE://幻灯片
case SLIDE://消息提醒
case MESSAGE_REMINDING://多新闻中心
case MORE_NEWS://期刊中心
case MAGAZINE://股票元素
case STOCK://文档内容
case DOC_CONTENT:return true;default:return false;}};//  OUTTERSYS  OUTDATA  UNREAD_COOPERATION  MY_PROJECTS  NEWNOTICE(0)  NEW_CUSTOMERS  NEW_MEETING  DAY_PLAN  ADDWF
//  ADDWF  CONTACTS  RSS  CUSTOMPAGE  WORKFLOW
var openMoreWin=function openMoreWin(eid,ebaseid,_moreurl,moreRouteurl){if(!_moreurl&&ebaseid!==ADDWF&&ebaseid!==MEETINGCALENDAR&&ebaseid!==MYCALENDAR&&ebaseid!==NEW_DY)return;//没有more页面的元素
if(isNoMoreElement(ebaseid)&&!moreRouteurl)return;if(moreRouteurl!=''){openLinkUrl(moreRouteurl);return;}var routeurl=getMoreRouteUrl(eid,ebaseid);var url=routeurl||_moreurl;var paramsObj=window.elements_more_params[eid];var getTimestamp=new Date().getTime();if(paramsObj){var moreurl=paramsObj.moreurl,isRouteUrl=paramsObj.isRouteUrl,_paramsObj$paramsStr=paramsObj.paramsStr,paramsStr=_paramsObj$paramsStr===undefined?'':_paramsObj$paramsStr;if(moreurl!==undefined){url=moreurl;}else{if(isRouteUrl){url=routeurl+paramsStr;}else{url=_moreurl+paramsStr;}}if(url.indexOf("?")>-1){url=url+"&timestamp="+getTimestamp;}else{url=url+"?timestamp="+getTimestamp;}}openLinkUrl(url);};var _s2Int=function _s2Int(s){return _str2Int(s,-1);};var _str2Int=function _str2Int(s,def){return isNaN(parseInt(s))?isNaN(parseInt(def))?-1:parseInt(def):parseInt(s);};var _isHtml=function _isHtml(htmlStr){if(!htmlStr)return false;var reg=/<[^>]+>/g;return reg.test(htmlStr)||htmlStr.indexOf("&")>-1;};window.openHref=function(url){if(window.doThemeAction){window.doThemeAction('onLoadMain',{url:url});}else{window.location.href=url;}};var openLinkUrl=function openLinkUrl(url,linkmode){var obj=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(!url)return;if(linkmode=='1'){// 当前页打开
if(window.doThemeAction){window.doThemeAction('onLoadMain',{url:url});}else{window.location.href=url;}}else{// 弹出页打开
var redirectUrl=url;var width=screen.availWidth;var height=screen.availHeight;var szFeatures="top=0,";szFeatures+="left=0,";if(url.indexOf("ebaseid=15")!=-1){//td61285
//szFeatures +="width=800," ;
szFeatures+="width="+(width-10)+",";}else{szFeatures+="width="+(width-10)+",";}szFeatures+="height="+(height-60)+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";if(obj&&obj>0){window.open(redirectUrl,'_blank');}else{var opebObj=window.open(redirectUrl,'_blank')||{};if(obj.ebaseid=='6'){var loop1=setInterval(function(){clearInterval(loop1);setTimeout(function(){try{if(obj.eid){window.element_unReadDoc_reLoad(obj.eid);}}catch(e){}},500);},1000);}if(obj.ebaseid=='13'){var _loop=setInterval(function(){clearInterval(_loop);setTimeout(function(){try{if(obj.eid){window.element_cooperation_reLoad(obj.eid);}}catch(e){}},500);},1000);}var loop=setInterval(function(){if(opebObj.closed){clearInterval(loop);setTimeout(function(){try{// obj.ebaseid == '7' || obj.ebaseid == '7_DY' && window.element_news_reLoad();
if((obj.ebaseid=='7'||obj.ebaseid=='7_DY')&&obj.eid&&window.element_workflow_reLoad){// // 去掉未读标识
// $(`#${obj.id}`).find("img.wfremindimg").remove();
// //去掉提醒方式样式
// $(`#${obj.id}`).find("a font").removeAttr('style');
window.element_news_reLoad(obj.eid);}obj.ebaseid=='8'&&window.element_workflow_reLoad();}catch(e){}},500);}},1000);}}};function onShowOrHideE(eid){$("#content_"+eid).toggle();}module.exports={NoRightCom:NoRightCom,handleHeight:handleHeight,doPrev:doPrev,doNext:doNext,handleWidth:handleWidth,isE9Element:isE9Element,formatData:formatData,loadRemind:loadRemind,formatDate:formatDate,isContain:isContain,intervalMap:intervalMap,onSetting:onSetting,_s2Int:_s2Int,_str2Int:_str2Int,openMoreWin:openMoreWin,openLinkUrl:openLinkUrl,onShowOrHideE:onShowOrHideE,hpinfoHandle:hpinfoHandle,isNoMoreElement:isNoMoreElement//流程元素全局刷新方法
};window.element_workflow_reLoad=function(){if(window.element_workflow_refresh&&(0,_typeof3.default)(window.element_workflow_refresh)=='object'){for(var eid in element_workflow_refresh){if(typeof element_workflow_refresh[eid]=='function'){element_workflow_refresh[eid]();}}}};//文档中心元素全局刷新方法
window.element_news_reLoad=function(eid){if(window.element_news_refresh&&(0,_typeof3.default)(window.element_news_refresh)=='object'&&eid){element_news_refresh[eid]();}};//文档中心元素全局刷新方法
window.element_news_reLoad_all=function(){if(window.element_news_refresh&&(0,_typeof3.default)(window.element_news_refresh)=='object'){for(var eid in element_news_refresh){if(typeof element_news_refresh[eid]=='function'){element_news_refresh[eid]();}}}};//未读文档元素全局刷新方法
window.element_unReadDoc_reLoad=function(eid){if(window.element_unReadDoc_refresh&&(0,_typeof3.default)(window.element_unReadDoc_refresh)=='object'){element_unReadDoc_refresh[eid]();}};//未读文档元素全局刷新方法
window.element_unReadDoc_reLoad_all=function(){if(window.element_unReadDoc_refresh&&(0,_typeof3.default)(window.element_unReadDoc_refresh)=='object'){for(var eid in element_unReadDoc_refresh){if(typeof element_unReadDoc_refresh[eid]=='function'){element_unReadDoc_refresh[eid]();}}}};//未读协作元素全局刷新方法
window.element_cooperation_reLoad=function(eid){if(window.element_cooperation_refresh&&(0,_typeof3.default)(window.element_cooperation_refresh)=='object'){element_cooperation_refresh[eid]();}};//未读协作元素全局刷新方法
window.element_cooperation_reLoad_all=function(){if(window.element_cooperation_refresh&&(0,_typeof3.default)(window.element_cooperation_refresh)=='object'){for(var eid in element_cooperation_refresh){if(typeof element_cooperation_refresh[eid]=='function'){element_cooperation_refresh[eid]();}}}};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素类型
var EType=function(_React$Component){(0,_inherits3.default)(EType,_React$Component);function EType(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EType);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EType.__proto__||(0,_getPrototypeOf2.default)(EType)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EType,[{key:'render',value:function render(){return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(382251,'元素类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.value,viewAttr:1}));}}]);return EType;}(_react2.default.Component);exports.default=EType;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素标题
var ETitle=function(_React$Component){(0,_inherits3.default)(ETitle,_React$Component);function ETitle(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ETitle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ETitle.__proto__||(0,_getPrototypeOf2.default)(ETitle)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ETitle,[{key:'render',value:function render(){var _this2=this;var _props$hasLink=this.props.hasLink,hasLink=_props$hasLink===undefined?true:_props$hasLink;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19491,'元素标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{id:'element_title_name_input_'+this.props.eid,inputType:'multilang',isBase64:true,value:this.state.value,onChange:function onChange(value){return _this2.setState({value:value});}}),hasLink&&_react2.default.createElement('i',{className:'icon-coms-link portal-esetting-content-title-icon',title:getLabel(16208,'链接地址'),onClick:function onClick(){return window.open('/spa/portal/element/index.html#/main/portal/element?eid='+_this2.props.eid);}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return ETitle;}(_react2.default.Component);exports.default=ETitle;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ActionTypes=__webpack_require__(99);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _drag=__webpack_require__(209);var _Toolbar=__webpack_require__(210);var _Toolbar2=_interopRequireDefault(_Toolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//头部组件  元素标题 设置图标等
var getLabel=_ecCom.WeaLocaleProvider.getLabel;var EHeader=function(_React$Component){(0,_inherits3.default)(EHeader,_React$Component);function EHeader(props){(0,_classCallCheck3.default)(this,EHeader);var _this=(0,_possibleConstructorReturn3.default)(this,(EHeader.__proto__||(0,_getPrototypeOf2.default)(EHeader)).call(this,props));_this.state={};_this.handleDragStart=_this.handleDragStart.bind(_this);_this.setPosition=_this.setPosition.bind(_this);return _this;}(0,_createClass3.default)(EHeader,[{key:'handleDragStart',value:function handleDragStart(event){var _props=this.props,config=_props.config,handleRefresh=_props.handleRefresh;if(!config.item.header.onmousedown)return;var callback=void 0;if(config.item.ebaseid===_ActionTypes.ELEMENT_TYPES.CUSTOMPAGE)callback=handleRefresh;(0,_drag.dragStart)(event,event.target,callback);}},{key:'componentDidMount',value:function componentDidMount(){this.setPosition();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setPosition();}},{key:'setPosition',value:function setPosition(){var config=this.props.config;var _state=this.state,left=_state.left,width=_state.width;var eid=config.item.eid;var titleWidth=$('#title_'+eid).width();var titleLeft=$('#title_'+eid).position()&&$('#title_'+eid).position().left;var toolbarWidth=$('#toolbar_'+eid).width();if((!width||!(0,_lodash.isEqual)(width,titleWidth+titleLeft+90+20+5))&&titleWidth!=null){this.setState({left:titleWidth+titleLeft+10,width:titleWidth+titleLeft+90+20+5});}}},{key:'render',value:function render(){var _state2=this.state,_state2$left=_state2.left,left=_state2$left===undefined?0:_state2$left,_state2$width=_state2.width,width=_state2$width===undefined?0:_state2$width;var _props2=this.props,config=_props2.config,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,_props2$fontSizeMp=_props2.fontSizeMp,fontSizeMp=_props2$fontSizeMp===undefined?{}:_props2$fontSizeMp,_props2$datas=_props2.datas,datas=_props2$datas===undefined?{}:_props2$datas;var _datas$tabids=datas.tabids,tabids=_datas$tabids===undefined?[]:_datas$tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header,ebaseid=_config$item.ebaseid;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';return _react2.default.createElement('div',{className:'header',style:header.style,'data-issetting':'false','data-sharelevel':'2',id:'header_'+eid,onMouseDown:this.handleDragStart},_react2.default.createElement('span',{className:'icon',id:'icon_'+eid,style:{position:'absolute',cursor:'pointer'}},_react2.default.createElement('img',{alt:'',border:'0',src:header.iconimg.src,title:header.iconimg.title,onClick:_common.onShowOrHideE.bind(this,eid)})),_react2.default.createElement('span',{className:fontStyle.titlefontsize?'wea-f'+fontStyle.titlefontsize+' title':'title',id:'title_'+eid,style:{position:'absolute',lineHeight:1}},_react2.default.createElement('font',{'class':'title-font',id:'element_title_name_'+eid,dangerouslySetInnerHTML:{__html:header.title}}),_react2.default.createElement('span',{id:'count_'+eid})),header.displayPosition&&header.displayPosition=='right'&&_react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className,style:{position:'relative',left:left+'px',width:'calc(100% - '+width+'px)',zIndex:'1',backgroundColor:'white'}},_react2.default.createElement(_TitleTabPane2.default,{datas:datas,fontStyle:fontStyle,ebaseid:ebaseid})),_react2.default.createElement(_Toolbar2.default,{datas:datas,config:config,handleDelete:handleDelete,handleRefresh:handleRefresh,getElementStyle:this.props.getElementStyle}),_react2.default.createElement('span',{className:'toolbarSub',id:'toolbarSub_'+eid}));}}]);return EHeader;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EHeader=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EHeader);exports.default=EHeader;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FooterMore=function(_React$Component){(0,_inherits3.default)(FooterMore,_React$Component);function FooterMore(props){(0,_classCallCheck3.default)(this,FooterMore);var _this=(0,_possibleConstructorReturn3.default)(this,(FooterMore.__proto__||(0,_getPrototypeOf2.default)(FooterMore)).call(this,props));_this.state={};return _this;}(0,_createClass3.default)(FooterMore,[{key:"render",value:function render(){var config=this.props.config;var isSetting=config.isSetting,item=config.item;var eid=item.eid,header=item.header,ebaseid=item.ebaseid;var toolbar=header.toolbar;var more=toolbar.more;if(more&&more.position=="footer"){var moreRouteurl="";if(ebaseid=='8'||ebaseid=='7'){_ecCom.WeaTools.callApi('/api/portal/customMore/getRouteurl','POST',{ebaseid:ebaseid,eid:eid}).then(function(result){if(result.status=='200'&&result.moreRouteurl){moreRouteurl=result.moreRouteurl;}});}return _react2.default.createElement("div",null,_react2.default.createElement("a",{id:"more_"+eid,href:"javascript:void(0);",onClick:_common.openMoreWin.bind(this,eid,ebaseid,more.morehref,moreRouteurl)},_react2.default.createElement("img",{className:"img_more",id:"imgMore",border:"0",src:more.img,title:more.title,alt:""})));}else{return _react2.default.createElement("div",null);}}}]);return FooterMore;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:"render",value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FooterMore=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FooterMore);exports.default=FooterMore;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 链接方式
var ELinkMode=function(_React$Component){(0,_inherits3.default)(ELinkMode,_React$Component);function ELinkMode(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ELinkMode);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ELinkMode.__proto__||(0,_getPrototypeOf2.default)(ELinkMode)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ELinkMode,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19494,'链接方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.value,detailtype:3,onChange:function onChange(value){_this2.setState({value:value});}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return ELinkMode;}(_react2.default.Component);exports.default=ELinkMode;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(123);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 显示条数
var EShowNum=function(_React$Component){(0,_inherits3.default)(EShowNum,_React$Component);function EShowNum(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EShowNum);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EShowNum.__proto__||(0,_getPrototypeOf2.default)(EShowNum)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EShowNum,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19493,'显示条数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInputNumber,{min:0,value:this.state.value,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({value:value});}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return EShowNum;}(_react2.default.Component);exports.default=EShowNum;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(327)();
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);__webpack_require__(130);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 流程中心，数据来源，排序字段
var EField_New=function(_React$Component){(0,_inherits3.default)(EField_New,_React$Component);function EField_New(props){(0,_classCallCheck3.default)(this,EField_New);var _this=(0,_possibleConstructorReturn3.default)(this,(EField_New.__proto__||(0,_getPrototypeOf2.default)(EField_New)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.state={visible:true,eFieldNewDataSource:props.eFieldNewDataSource||[],eFieldNewUsedKeys:props.eFieldNewUsedKeys||[],leftSearchName:'',rightSearchName:''};return _this;}(0,_createClass3.default)(EField_New,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,searchName=_state.searchName;return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(32317,'显示字段设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTransfer,{className:'portal-element-showfieldnew',data:eFieldNewDataSource,selectedKeys:eFieldNewUsedKeys,onChange:function onChange(keys){return _this2.setState({eFieldNewUsedKeys:keys});},leftHeader:_react2.default.createElement('div',{style:{display:'inline-block',position:'relative'}},_react2.default.createElement('span',{style:{paddingLeft:'15px',position:'absolute',width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'block',top:'-25px'}},getLabel(83302,'待选')),_react2.default.createElement('div',{style:{position:'absolute',top:'-25px',width:'90px',left:'238px'}},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearch:function onSearch(value){return _this2.setState({leftSearchName:value});}}))),rightHeader:_react2.default.createElement('div',{style:{display:'inline-block',position:'relative'}},_react2.default.createElement('span',{style:{paddingLeft:'15px',position:'absolute',width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'block',top:'-25px'}},getLabel(83303,'已选')),_react2.default.createElement('div',{style:{position:'absolute',top:'-25px',width:'90px',left:'238px'}},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearch:function onSearch(value){return _this2.setState({rightSearchName:value});}}))),filterLeft:this.filterLeft.bind(this,eFieldNewDataSource),filterRight:this.filterRight.bind(this,eFieldNewUsedKeys)}));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'filterLeft',value:function filterLeft(items){var leftSearchName=this.state.leftSearchName;if(leftSearchName){items=items.filter(function(item){return item.name.indexOf(leftSearchName.trim())!=-1;});}return items;}},{key:'filterRight',value:function filterRight(items){var _state2=this.state,rightSearchName=_state2.rightSearchName,eFieldNewDataSource=_state2.eFieldNewDataSource;var itemss=[];for(var i=0;i<items.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(items[i]==eFieldNewDataSource[j].key){itemss.push(eFieldNewDataSource[j]);continue;}}}if(rightSearchName){itemss=itemss.filter(function(item){return item.name.indexOf(rightSearchName.trim())!=-1;});}return itemss;}}]);return EField_New;}(_react2.default.Component);exports.default=EField_New;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(165);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(174);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcTabs=__webpack_require__(371);var _rcTabs2=_interopRequireDefault(_rcTabs);var _TabContent=__webpack_require__(384);var _TabContent2=_interopRequireDefault(_TabContent);var _ScrollableInkTabBar=__webpack_require__(385);var _ScrollableInkTabBar2=_interopRequireDefault(_ScrollableInkTabBar);__webpack_require__(400);var _lodash=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TitleTabPane=function(_React$Component){(0,_inherits3.default)(TitleTabPane,_React$Component);function TitleTabPane(props){(0,_classCallCheck3.default)(this,TitleTabPane);var _this=(0,_possibleConstructorReturn3.default)(this,(TitleTabPane.__proto__||(0,_getPrototypeOf2.default)(TitleTabPane)).call(this,props));_this.state={tabid:props.datas.currentTab};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(TitleTabPane,[{key:'handleTabData',value:function handleTabData(tabid){var _props$datas=this.props.datas,datas=_props$datas===undefined?{}:_props$datas;var _datas$handleTabData=datas.handleTabData,handleTabData=_datas$handleTabData===undefined?{}:_datas$handleTabData;handleTabData(tabid);this.setState({tabid:tabid});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var tabid=this.state.tabid;if(!(0,_lodash.isEqual)(tabid,nextProps.datas.currentTab)){this.setState({tabid:nextProps.datas.currentTab});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$datas2=_props.datas,datas=_props$datas2===undefined?{}:_props$datas2,fontStyle=_props.fontStyle,_props$ebaseid=_props.ebaseid,ebaseid=_props$ebaseid===undefined?'':_props$ebaseid;var tabid=this.state.tabid;var _datas$config=datas.config,config=_datas$config===undefined?{}:_datas$config,_datas$isShowSettingS=datas.isShowSettingShowType,isShowSettingShowType=_datas$isShowSettingS===undefined?'0':_datas$isShowSettingS;var _config$item=config.item,item=_config$item===undefined?{}:_config$item;var _item$header=item.header,header=_item$header===undefined?{}:_item$header;if((0,_lodash.isEmpty)(datas))return _react2.default.createElement('div',null);var _datas$currentTab=datas.currentTab,currentTab=_datas$currentTab===undefined?'1':_datas$currentTab,_datas$tabids=datas.tabids,tabids=_datas$tabids===undefined?[]:_datas$tabids,_datas$titles=datas.titles,titles=_datas$titles===undefined?[]:_datas$titles,methodvalue=datas.methodvalue,tabwidth=datas.tabwidth,counts=datas.counts;var tdStyle={width:'auto',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',lineHeight:'32px',paddingTop:'0px'};var tdStyle1={width:'auto',marginRight:'10px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',lineHeight:'32px',paddingTop:'0px'};var style={marginLeft:'10px',marginRight:'10px'};var style1={width:tabwidth+'px',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',display:'block'};var titleStyle={width:'100%'};// if(header.canHeadbar) titleStyle={width: 'calc( 100% - 95px )'}
var tHtml_new=_react2.default.createElement(_rcTabs2.default,{activeKey:tabid,renderTabBar:function renderTabBar(){return _react2.default.createElement(_ScrollableInkTabBar2.default,null);},renderTabContent:function renderTabContent(){return _react2.default.createElement(_TabContent2.default,null);},className:'tabcontainer tab2',style:titleStyle},titles.map(function(title,i){if(ebaseid=='8'&&counts&&counts[i]!==-1&&counts[i]!==''&&counts[i]!==null){if(counts[i]>99){title+='(99+)';}else{title+=' ('+counts[i]+')';}}else if(ebaseid=='blogStatus'&&counts&&'0'!==counts[i]){title+=' ('+counts[i]+')';}else if(ebaseid=='7_DY'&&counts&&'0'!==counts[i]){title+=' ('+counts[i].noReadNum+')';}else if(isShowSettingShowType=='1'&&ebaseid=='7'&&counts&&counts[i]&&counts[i].noReadNum){title+=' ('+counts[i].noReadNum+')';}else if(ebaseid=='7'&&counts&&counts[i]&&counts[i].isHaveNoRead&&counts[i].isHaveNoRead=='1'){title=title;}var className=tabids[i]==tabid?'tab2selected wea-f'+(fontStyle.tab1fontsize||12):'tab2unselected wea-f'+(fontStyle.tab2fontsize||12);var pointClassName=ebaseid=='7'&&counts&&counts[i]&&counts[i].isHaveNoRead&&counts[i].isHaveNoRead=='1'?'portal-new-unreadpoint':'';return _react2.default.createElement(_rcTabs.TabPane,{key:i+1,style:{width:'200px'},tab:_react2.default.createElement('div',{title:title,className:className,style:methodvalue=='2'?tdStyle1:tdStyle,'data-tabid':tabids[i],onClick:function onClick(){return _this2.handleTabData(tabids[i]);}},_react2.default.createElement('span',{style:methodvalue=='2'?style:style1},title,_react2.default.createElement('div',{className:pointClassName})))});}));return tHtml_new;}}]);return TitleTabPane;}(_react2.default.Component);exports.default=TitleTabPane;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(22);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _ESetting=__webpack_require__(126);var _ESetting2=_interopRequireDefault(_ESetting);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var OpToolbar=function(_React$Component){(0,_inherits3.default)(OpToolbar,_React$Component);function OpToolbar(props){(0,_classCallCheck3.default)(this,OpToolbar);var _this=(0,_possibleConstructorReturn3.default)(this,(OpToolbar.__proto__||(0,_getPrototypeOf2.default)(OpToolbar)).call(this,props));_this.state={islock:'',icon:'',moreRouteurl:''};_this.handleLock=_this.handleLock.bind(_this);_this.handleOnSetting=_this.handleOnSetting.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(OpToolbar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//判断流程元素是否存在自定义more页面
var config=this.props.config;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var moreRouteurl='';if(ebaseid=='8'||ebaseid=='7'){_ecCom.WeaTools.callApi('/api/portal/customMore/getRouteurl','POST',{ebaseid:ebaseid,eid:eid}).then(function(result){if(result.status=='200'&&result.moreRouteurl){_this2.setState({moreRouteurl:result.moreRouteurl});}});}}},{key:'handleDelete',value:function handleDelete(){var _props=this.props,config=_props.config,handleDelete=_props.handleDelete;var _config$params2=config.params,eid=_config$params2.eid,hpid=_config$params2.hpid,subCompanyId=_config$params2.subCompanyId;var group=$($("#item_"+eid).parents(".group")[0]);var flag=group.attr('data-areaflag');portal-4-false;var eids="";group.find(".item").each(function(){if($(this).attr("data-eid")!=eid)eids+=$(this).attr("data-eid")+",";});var portalHpinfo_setting=ls.getJSONObj('portal-'+hpid+'-true');var portalHpinfo=ls.getJSONObj('portal-'+hpid+'-false');ls.set('portal-'+hpid+'-true',(0,_common.hpinfoHandle)(portalHpinfo_setting,eid));ls.set('portal-'+hpid+'-false',(0,_common.hpinfoHandle)(portalHpinfo,eid));_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/delete','POST',{hpid:hpid,eid:eid,delFlag:flag,delAreaElement:eids,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){handleDelete();}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleLock',value:function handleLock(){var _this3=this;var islock=this.state.islock;var _props$config$params=this.props.config.params,eid=_props$config$params.eid,hpid=_props$config$params.hpid,subCompanyId=_props$config$params.subCompanyId;_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/'+(islock?'unlock':'lock'),'POST',{eid:eid,hpid:hpid,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){_this3.setState({islock:!islock,icon:result.icon});}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleOnSetting',value:function handleOnSetting(){var _props2=this.props,config=_props2.config,handleRefresh=_props2.handleRefresh;var isSynergySetting=config.isSynergySetting,synergyParams=config.synergyParams;var _config$params3=config.params,eid=_config$params3.eid,ebaseid=_config$params3.ebaseid,hpid=_config$params3.hpid,subCompanyId=_config$params3.subCompanyId;var readyElement=['1','7','8','11','12','6','13','14','15','16','9','10','17','18','19','25','29','32','34','audio','blogStatus','favourite','Flash','menu','notice','picture','reportForm','searchengine','Slide','video','weather','scratchpad','DataCenter','MyCalendar','Task','plan','jobsinfo','outterSys','contacts','addwf','imgSlide','newNotice','OutData','FormModeCustomSearch','MeetingCalendar','CalendarEle','bookshelf','newMobilePicture','fnaBudgetAssistant','fnaBudgetAssistant1','CoreMail','news','processTask','login','NEW_DY','quickEntry','ecodeElement'];if((0,_common.isContain)(readyElement,ebaseid)||/^Custom_/.test(ebaseid)){_reactDom2.default.render(_react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_antd.Spin,null)),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);_ecCom.WeaTools.callApi('/api/portal/setting/esetting','POST',{eid:eid,ebaseid:ebaseid,hpid:hpid,subCompanyId:subCompanyId},'json').then(function(result){result.hpid=hpid;result.subCompanyId=subCompanyId;result.eid=eid;result.ebaseid=ebaseid;_reactDom2.default.render(_react2.default.createElement(_ESetting2.default,{data:result,isSynergySetting:isSynergySetting,synergyParams:synergyParams,handleRefresh:handleRefresh,isSetting:config.isSetting}),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);});}else{(0,_common.onSetting)(eid,ebaseid,hpid,subCompanyId);}}},{key:'render',value:function render(){var _props3=this.props,config=_props3.config,clsname=_props3.clsname,islock=_props3.islock,handleRefresh=_props3.handleRefresh;var _config$item=config.item,eid=_config$item.eid,ebaseid=_config$item.ebaseid,header=_config$item.header;var toolbar=header.toolbar;var lock=toolbar.lock,refresh=toolbar.refresh,setting=toolbar.setting,close=toolbar.close,more=toolbar.more;var _state=this.state,icon=_state.icon,moreRouteurl=_state.moreRouteurl;return _react2.default.createElement('div',{className:'optoolbar '+clsname,id:'toolbar_'+eid},_react2.default.createElement('ul',null,lock?_react2.default.createElement('li',{style:{width:'11px'}},_react2.default.createElement(_antd.Popconfirm,{title:getLabel(19745,'此操作可能花较长的时间，是否继续？'),onConfirm:this.handleLock,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{'data-status':islock?'locked':'unlocked',href:'javascript:void(0);',title:lock.title},_react2.default.createElement('img',{src:icon||lock.img,border:'0',alt:''})))):'',refresh?_react2.default.createElement('li',{style:{width:'11px'}},_react2.default.createElement('a',{href:'javascript:void(0);',name:'refreshbtn',id:'refresh_'+eid,onClick:handleRefresh,title:refresh.title},_react2.default.createElement('img',{src:refresh.img,border:'0',alt:''}))):'',setting?_react2.default.createElement('li',{style:{width:'12px'}},_react2.default.createElement('a',{href:'javascript:void(0)',onClick:this.handleOnSetting,title:setting.title},_react2.default.createElement('img',{className:'img_setting',src:setting.img,border:'0',alt:''}))):'',close?_react2.default.createElement('li',{style:{width:'12px'}},_react2.default.createElement(_antd.Popconfirm,{placement:'leftTop',title:getLabel(19747,'此元素被删除后将不能被恢复，是否继续？'),onConfirm:this.handleDelete,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{href:'javascript:void(0);',title:close.title},_react2.default.createElement('img',{src:close.img,border:'0',alt:''})))):'',more&&more.position=='title'?(0,_common.isNoMoreElement)(ebaseid)&&!moreRouteurl?'':_react2.default.createElement('li',{style:{width:'34px'}},_react2.default.createElement('a',{id:'more_'+eid,href:'javascript:void(0);',onClick:_common.openMoreWin.bind(this,eid,ebaseid,more.morehref,moreRouteurl)},_react2.default.createElement('img',{className:'img_more',id:'imgMore',border:'0',src:more.img,title:more.title,alt:''}))):''));}}]);return OpToolbar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OpToolbar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OpToolbar);exports.default=OpToolbar;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _SynergySetting4Designer=__webpack_require__(100);var _SynergySetting4Designer2=_interopRequireDefault(_SynergySetting4Designer);var _SynergySetting4WfVersions=__webpack_require__(233);var _SynergySetting4WfVersions2=_interopRequireDefault(_SynergySetting4WfVersions);var _Content_1_DataSource=__webpack_require__(234);var _Content_1_DataSource2=_interopRequireDefault(_Content_1_DataSource);var _Content_7_DataSource=__webpack_require__(235);var _Content_7_DataSource2=_interopRequireDefault(_Content_7_DataSource);var _Content_8_DataSource=__webpack_require__(236);var _Content_8_DataSource2=_interopRequireDefault(_Content_8_DataSource);var _Content_29_DataSource=__webpack_require__(237);var _Content_29_DataSource2=_interopRequireDefault(_Content_29_DataSource);var _Content_reportForm_DataSource=__webpack_require__(238);var _Content_reportForm_DataSource2=_interopRequireDefault(_Content_reportForm_DataSource);var _Content_OutData_DataSource=__webpack_require__(259);var _Content_OutData_DataSource2=_interopRequireDefault(_Content_OutData_DataSource);var _Content_13_DataSource=__webpack_require__(260);var _Content_13_DataSource2=_interopRequireDefault(_Content_13_DataSource);var _Content_10_DataSource=__webpack_require__(261);var _Content_10_DataSource2=_interopRequireDefault(_Content_10_DataSource);var _Content_news_DataSource=__webpack_require__(262);var _Content_news_DataSource2=_interopRequireDefault(_Content_news_DataSource);var _Content_QuickEntry_DataSource=__webpack_require__(263);var _Content_QuickEntry_DataSource2=_interopRequireDefault(_Content_QuickEntry_DataSource);var _Content_ecodeElement_DataSource=__webpack_require__(264);var _Content_ecodeElement_DataSource2=_interopRequireDefault(_Content_ecodeElement_DataSource);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var DataSourceTable=function(_React$Component){(0,_inherits3.default)(DataSourceTable,_React$Component);function DataSourceTable(props){(0,_classCallCheck3.default)(this,DataSourceTable);var _this=(0,_possibleConstructorReturn3.default)(this,(DataSourceTable.__proto__||(0,_getPrototypeOf2.default)(DataSourceTable)).call(this,props));_this.state={tabNew:_this.props.tabNew,tabCount:_this.props.tabCount,tabIds:_this.props.tabIds,tabList:_this.props.tabList,dsVisible:false,tabData:{},selectedTabIds:[]};_this.onAddTab=_this.onAddTab.bind(_this);_this.onEditTab=_this.onEditTab.bind(_this);_this.onSortTab=_this.onSortTab.bind(_this);_this.onDeleteTab=_this.onDeleteTab.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.getSaveValues=_this.getSaveValues.bind(_this);_this.guid=_this.guid.bind(_this);return _this;}(0,_createClass3.default)(DataSourceTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,_props$synergyParams=_props.synergyParams,synergyParams=_props$synergyParams===undefined?{}:_props$synergyParams;var stype=synergyParams.stype;var _state=this.state,tabNew=_state.tabNew,tabData=_state.tabData,tabList=_state.tabList,dsVisible=_state.dsVisible,selectedTabIds=_state.selectedTabIds;var dataSourceComponent=_react2.default.createElement('div',null);var columns=[{key:'tabTitle',title:getLabel(24986,'标题'),dataIndex:'tabTitle',width:'50%'},{key:'operation',title:getLabel(30585,'操作'),width:'50%',render:function render(text,record){return _react2.default.createElement('span',null,_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){return _this2.onEditTab(record.tabId);}},getLabel(30747,'设置')),_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){return _this2.onAddTab('saveas',record.tabId);}},getLabel(350,'另存为')),hpid<0&&ebaseid=='8'&&(stype=='wf'||stype=='wf_form')?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4wv.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,tabid:record.tabId,isGlobal:false}));}},getLabel(17632,'参数设置')):'');}}];if(ebaseid=='quickEntry'){var _props$userid=this.props.userid,_userid=_props$userid===undefined?'':_props$userid;columns=[{key:'tabTitle',title:getLabel(24986,'标题'),dataIndex:'tabTitle',width:'50%'},{key:'operation',title:getLabel(30585,'操作'),width:'25%',render:function render(text,record){var _record$data=record.data,data=_record$data===undefined?{}:_record$data;var _props$userid2=_this2.props.userid,userid=_props$userid2===undefined?'':_props$userid2;if(data.userid=='1'&&userid!='1'){return _react2.default.createElement('span',null,_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){return _this2.onAddTab('saveas',record.tabId);}},getLabel(350,'另存为')),hpid<0&&ebaseid=='8'&&(stype=='wf'||stype=='wf_form')?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4wv.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,tabid:record.tabId,isGlobal:false}));}},getLabel(17632,'参数设置')):'');}return _react2.default.createElement('span',null,_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){if(userid!='1'&&record.data.userid==="1"){return;}_this2.onEditTab(record.tabId);}},getLabel(30747,'设置')),_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){return _this2.onAddTab('saveas',record.tabId);}},getLabel(350,'另存为')),hpid<0&&ebaseid=='8'&&(stype=='wf'||stype=='wf_form')?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4wv.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,tabid:record.tabId,isGlobal:false}));}},getLabel(17632,'参数设置')):'');}},{key:'isShow',title:getLabel(26523,'显示'),width:'25%',render:function render(text,record,index){var _record$data2=record.data,data=_record$data2===undefined?{}:_record$data2;var _props$userid3=_this2.props.userid,userid=_props$userid3===undefined?'':_props$userid3;var disabled=false;if(data.userid!='1'||userid=='1'){disabled=true;data.isShow='1';}var _datas=_this2.state.tabList;return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},_react2.default.createElement(_ecCom.WeaCheckbox,{value:data.isShow,disabled:disabled,onChange:function onChange(value){_datas[index].data.isShow=value;_this2.setState({tabList:_datas});}})));}}];}if(dsVisible){var props={eid:eid,tabNew:tabNew,tabData:tabData,onOk:this.onOk,onCancel:this.onCancel};switch(this.props.ebaseid){// RSS阅读器
case'1':dataSourceComponent=_react2.default.createElement(_Content_1_DataSource2.default,props);break;// 文档中心
case'7':dataSourceComponent=_react2.default.createElement(_Content_7_DataSource2.default,props);break;// 流程中心
case'8':dataSourceComponent=_react2.default.createElement(_Content_8_DataSource2.default,props);break;//我的协作
case'13':dataSourceComponent=_react2.default.createElement(_Content_13_DataSource2.default,props);break;// 自定义页面
case'29':dataSourceComponent=_react2.default.createElement(_Content_29_DataSource2.default,props);break;// 图表
case'reportForm':dataSourceComponent=_react2.default.createElement(_Content_reportForm_DataSource2.default,(0,_extends3.default)({},props,{synergyParams:synergyParams}));break;// 外部数据元素
case'OutData':dataSourceComponent=_react2.default.createElement(_Content_OutData_DataSource2.default,props);break;// 我的项目元素
case'10':dataSourceComponent=_react2.default.createElement(_Content_10_DataSource2.default,props);break;// 公司新闻元素
case'news':dataSourceComponent=_react2.default.createElement(_Content_news_DataSource2.default,props);break;// 快捷方式元素
case'quickEntry':dataSourceComponent=_react2.default.createElement(_Content_QuickEntry_DataSource2.default,props);break;// ecode自定义元素
case'ecodeElement':dataSourceComponent=_react2.default.createElement(_Content_ecodeElement_DataSource2.default,props);break;default:dataSourceComponent=_react2.default.createElement('div',null);}}// 记录选中的行
var _self=this;var _props$userid4=this.props.userid,userid=_props$userid4===undefined?'':_props$userid4;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedTabIds:selectedRowKeys});},getCheckboxProps:function getCheckboxProps(record){if(ebaseid=='quickEntry'){return{disabled:userid!='1'&&record.data.userid==="1"};}else{return false;}}};var draggable=true;if(ebaseid=='quickEntry'&&userid!='1'){draggable=false;}return _react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(20885,'内容来源'),needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',null,hpid<0&&(ebaseid=='8'||ebaseid=='7')?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4d.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,isGlobal:true}));}},getLabel(17632,'参数设置')):'',_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',onClick:function onClick(){return _this2.onAddTab('add');}},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedTabIds&&selectedTabIds.length),className:'portal-esetting-wsg-btn',onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},dataSourceComponent,_react2.default.createElement(_SynergySetting4Designer2.default,{ref:function ref(ss4d){return _this2.ss4d=ss4d;}}),_react2.default.createElement(_SynergySetting4WfVersions2.default,{ref:function ref(ss4wv){return _this2.ss4wv=ss4wv;}}),_react2.default.createElement(_ecCom.WeaTable,{rowSelection:rowSelection,columns:columns,dataSource:tabList,pagination:false,draggable:draggable,onDrop:this.onSortTab}));}},{key:'onAddTab',value:function onAddTab(type,tabId){if('saveas'==type){var tabData={};var tabList=this.state.tabList;for(var i=0;i<tabList.length;i++){if(tabList[i].tabId==tabId){tabData=(0,_lodash.cloneDeep)(tabList[i].data);break;}}tabData.id='';this.setState({tabData:tabData,dsVisible:true});}else{this.setState({tabData:{},dsVisible:true});}}},{key:'onDeleteTabs',value:function onDeleteTabs(){var selectedTabIds=this.state.selectedTabIds;for(var i=0,len=selectedTabIds.length;i<len;i++){this.onDeleteTab(selectedTabIds[i]);}this.setState({selectedTabIds:[]});}},{key:'onDeleteTab',value:function onDeleteTab(tabId){var tabList=this.state.tabList;for(var i=0,len=tabList.length;i<len;i++){if(tabList[i].tabId==tabId){tabList.splice(i,1);break;}}this.setState({tabList:tabList});}},{key:'onEditTab',value:function onEditTab(tabId){var tabData={};var tabList=this.state.tabList;for(var i=0,len=tabList.length;i<len;i++){if(tabList[i].tabId==tabId){tabData=tabList[i].data;break;}}this.setState({tabData:tabData,dsVisible:true});}},{key:'guid',value:function guid(){return'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0,v=c=='x'?r:r&0x3|0x8;return v.toString(16);});}},{key:'onOk',value:function onOk(values){var tabList=this.state.tabList;var tabCount=this.state.tabCount||0;var id=values.id;// 根据id是否存在判断是新增还是编辑
if(!!id){// 编辑保存
for(var i=0,len=tabList.length;i<len;i++){if(tabList[i].tabId==id){tabList[i].tabTitle=_ecCom.WeaInputLocale.getCurrentLabel(values.title);tabList[i].data=values;}}}else{// 新建保存
id=String(++tabCount);values.id=id;if(this.props.ebaseid=='quickEntry'){id=this.guid();values.id=id;tabList.push({key:id,tabId:id,tabTitle:_ecCom.WeaInputLocale.getCurrentLabel(values.title),data:values});}else{tabList.push({key:id,tabId:id,tabTitle:_ecCom.WeaInputLocale.getCurrentLabel(values.title),data:values});}}this.setState({tabCount:tabCount,tabList:tabList,dsVisible:false});}},{key:'onCancel',value:function onCancel(){this.setState({dsVisible:false});}},{key:'onSortTab',value:function onSortTab(tabList){this.setState({tabList:tabList});}},{key:'getSaveValues',value:function getSaveValues(){return{tabIds:this.state.tabIds,tabList:this.state.tabList};}}]);return DataSourceTable;}(_react2.default.Component);exports.default=DataSourceTable;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(30)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var core = __webpack_require__(20);
var ctx = __webpack_require__(56);
var hide = __webpack_require__(40);
var has = __webpack_require__(34);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(61)('wks');
var uid = __webpack_require__(51);
var Symbol = __webpack_require__(27).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(37);
var IE8_DOM_DEFINE = __webpack_require__(71);
var toPrimitive = __webpack_require__(57);
var dP = Object.defineProperty;

exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var EShowHeader=function(_React$Component){(0,_inherits3.default)(EShowHeader,_React$Component);function EShowHeader(props){(0,_classCallCheck3.default)(this,EShowHeader);var _this=(0,_possibleConstructorReturn3.default)(this,(EShowHeader.__proto__||(0,_getPrototypeOf2.default)(EShowHeader)).call(this,props));_this.state={showHeader:_this.props.value||'0'};return _this;}(0,_createClass3.default)(EShowHeader,[{key:'getSaveValues',value:function getSaveValues(){return this.state.showHeader;}},{key:'render',value:function render(){var _this2=this;var showHeader=this.state.showHeader;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84582,'是否显示表头'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'90px',display:'inline-block',float:'left'}},_react2.default.createElement(_ecCom.WeaCheckbox,{display:'switch',value:showHeader,onChange:function onChange(v){_this2.setState({showHeader:v});}// disabled={disabled}
})));}}]);return EShowHeader;}(_react2.default.Component);exports.default=EShowHeader;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(144);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(58);
var defined = __webpack_require__(45);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var createDesc = __webpack_require__(43);
module.exports = __webpack_require__(28) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(45);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(216);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(73);
var enumBugKeys = __webpack_require__(62);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_47__;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MarqueeCom=function(_React$Component){(0,_inherits3.default)(MarqueeCom,_React$Component);function MarqueeCom(props){(0,_classCallCheck3.default)(this,MarqueeCom);var _this2=(0,_possibleConstructorReturn3.default)(this,(MarqueeCom.__proto__||(0,_getPrototypeOf2.default)(MarqueeCom)).call(this,props));_this2.autoMarquee=_this2.autoMarquee.bind(_this2);_this2.isMarquee=_this2.isMarquee.bind(_this2);_this2.marquee=_this2.marquee.bind(_this2);_this2.myScroll=_this2.myScroll.bind(_this2);return _this2;}(0,_createClass3.default)(MarqueeCom,[{key:'autoMarquee',value:function autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid,showModeId){var _this3=this;if(this.intId){this.intId.map(function(item){clearInterval(item);});}$('.homepage').find('#tabcontant_'+eid).css("overflow-y","auto");var box=$('#content_'+eid+' .wea-new-table .ant-table-body>table');if(ebaseid=='7'){var box1=$('#content_'+eid+' .portal-news-content');var box2=$('#tabcontant_'+eid+' .ant-spin-container>div>div')[0];$(box1).unbind('mouseenter').unbind('mouseleave');if(showModeId=='2'||showModeId=='3'||showModeId=='6'){//上图式、左图式、摘要式
box=$('#content_'+eid+' .portal-news-content');}$(box2).unbind('mouseenter').unbind('mouseleave');$(box2).css('margin-top','0px');}else if(ebaseid=='notice'){box=$('#content_'+eid+' .portal-element-newnotice-com');}$(box).unbind('mouseenter').unbind('mouseleave');$(box).css('margin-top','0px');$("#titleContainer_"+eid).css({'position':'relative','z-index':'1'});var div=$("#content_"+eid+" .ant-spin-container")[1];var div2=$("#content_"+eid+" .ant-spin-container")[0];if(!div&&!div2){return;}if(!div){div=div2;}if(ebaseid&&ebaseid=='notice'){div=$("#content_"+eid+" .newnotice-add-Carousel")[0];}div.onmouseout=function(){};div.style.left="0px";if(ebaseid=='7'){if(showModeId=='11'){//上图式3
$('.homepage').find('#tabcontant_'+eid).css("overflow-y","auto");return;}}if((scolltype=='up'||scolltype=='down')&&(ebaseid=='7'||ebaseid=='8'||ebaseid=='notice'||ebaseid==='FormModeCustomSearch')){$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");$('.homepage').find('#tabcontant_'+eid).css("overflow-y","hidden");$('#content_'+eid+' .wea-new-table .ant-table-body>table').css("position","relative");$('#content_'+eid+' .wea-new-table .ant-table-thead').css("display","none");var elementHight=$('#content_'+eid).height();if(ebaseid=='7'){var sh=$('#content_'+eid+' .wea-new-table .ant-table-row').height();var row=$('#content_'+eid+' .wea-new-table .ant-table-row');var _box=$('#content_'+eid+' .wea-new-table .ant-table-body>table');if(showModeId=='2'||showModeId=='3'||showModeId=='6'){//上图式、左图式、摘要式
sh=$('#content_'+eid+' .portal-news-content .portal-news-com').height();_box=$('#content_'+eid+' .portal-news-content');row=$('#content_'+eid+' .portal-news-content .portal-news-com');}else if(showModeId=='10'){//上图式2
var pictureHieght=$('#content_'+eid+' .mews-img').height();var summaryHieght=$('#content_'+eid+' .mews-content').height();elementHight=parseInt(elementHight)-parseInt(pictureHieght)-parseInt(summaryHieght)-10;}else if(showModeId=='8'||showModeId=='9'){//头条式、头条式2
var _summaryHieght=$('#content_'+eid+' .mews-summary').height();elementHight=parseInt(elementHight)-parseInt(_summaryHieght);}else if(showModeId=='5'||showModeId=='7'){//双列式、摘要式2
$('.homepage').find('#tabcontant_'+eid).css("overflow-y","auto");return;}this.myScroll({elementHight:elementHight,box:_box,rowHeight:sh,//li的高度
marquee:this.marquee//
});}else if(ebaseid=='8'||ebaseid==='FormModeCustomSearch'){var _sh=$('#content_'+eid+' .wea-new-table .ant-table-row').height();var _row=$('#content_'+eid+' .wea-new-table .ant-table-row');var _box2=$('#content_'+eid+' .wea-new-table .ant-table-body>table');this.myScroll({elementHight:elementHight,box:_box2,rowHeight:_sh,//li的高度
marquee:this.marquee//
});}else if(ebaseid=='notice'){var _sh2=$('#content_'+eid+' .portal-element-newnotice-item').height();var _row2=$('#content_'+eid+' .portal-element-newnotice-item');var _box3=$('#content_'+eid+' .portal-element-newnotice-com');elementHight=$('#content_'+eid).height();this.myScroll({elementHight:elementHight,box:_box3,rowHeight:_sh2,//li的高度
marquee:this.marquee//
});}}else{$("#titleContainer_"+eid).css({'position':'relative','z-index':'1'});var _div=$("#content_"+eid+" .ant-spin-container")[1];var _div2=$("#content_"+eid+" .ant-spin-container")[0];if(!_div&&!_div2){return;}if(!_div){_div=_div2;}if(ebaseid&&ebaseid=='notice'){_div=$("#content_"+eid+" .newnotice-add-Carousel")[0];}var offsetWidth=parseInt(_div.offsetWidth);var offsetHeight=parseInt($("#tabcontant_"+eid)[0].offsetHeight);_div.style.left=0;_div.style.top=0;if(this.isMarquee(scolltype)){if(scolltype=='right'){_div.style.left=-offsetWidth+"px";this.myInterval=setInterval(function(){var left=parseInt(_div.style.left.split("px")[0]);if(left>=offsetWidth){_div.style.left=-_div.offsetWidth+"px";}else{var i=(_div.style.left+"").split('px')[0];_div.style.left=parseInt(i)+1+"px";}}.bind(this),scrollSpeed);}else if(scolltype=='left'){_div.style.left=offsetWidth+"px";this.myInterval=setInterval(function(){var left=parseInt(_div.style.left.split("px")[0]);if(left<=-offsetWidth){_div.style.left=_div.offsetWidth+"px";}else{var i=(_div.style.left+"").split('px')[0];_div.style.left=parseInt(i)-1+"px";}}.bind(this),scrollSpeed);}else if(scolltype=='up'){if(ebaseid==='FormModeCustomSearch'){// 建模查询中心自动上下滚动单独处理
$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");_div.style.top=offsetHeight+"px";this.myInterval=setInterval(function(){var top=parseInt(_div.style.top.split("px")[0]);if(top<=-_div.offsetHeight){_div.style.top=offsetHeight+"px";}else{var i=(_div.style.top+"").split('px')[0];_div.style.top=parseInt(i)-1+"px";}}.bind(this),scrollSpeed);}else{$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");_div.style.top=offsetHeight+"px";this.myInterval=setInterval(function(){var top=parseInt(_div.style.top.split("px")[0]);if(top<=-offsetHeight){_div.style.top=_div.offsetHeight+"px";}else{var i=(_div.style.top+"").split('px')[0];_div.style.top=parseInt(i)-1+"px";}}.bind(this),scrollSpeed);}}else if(scolltype=='down'){if(ebaseid==='FormModeCustomSearch'){// 建模查询中心自动上下滚动单独处理
$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");_div.style.top=-_div.offsetHeight+"px";this.myInterval=setInterval(function(){var top=parseInt(_div.style.top.split("px")[0]);if(top>=offsetHeight){_div.style.top=-_div.offsetHeight+"px";}else{var i=(_div.style.top+"").split('px')[0];_div.style.top=parseInt(i)+1+"px";}}.bind(this),scrollSpeed);}else{$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");_div.style.top=-offsetHeight+"px";this.myInterval=setInterval(function(){var top=parseInt(_div.style.top.split("px")[0]);if(top>=offsetHeight){_div.style.top=-_div.offsetHeight+"px";}else{var i=(_div.style.top+"").split('px')[0];_div.style.top=parseInt(i)+1+"px";}}.bind(this),scrollSpeed);}}}else{$('.homepage').find('#content_view_id_'+eid).css("overflow-y","auto");}_div.onmouseover=function(){clearInterval(_this3.myInterval);};_div.onmouseout=function(){var div=$("#content_"+eid+" .ant-spin-container")[1];if(ebaseid&&ebaseid=='notice'){div=$("#content_"+eid+" .newnotice-add-Carousel")[0];}if(scolltype=='right'){_this3.myInterval=setInterval(function(){var left=parseInt(div.style.left.split("px")[0]);if(left>=offsetWidth){div.style.left=-div.offsetWidth+"px";}else{var i=(div.style.left+"").split('px')[0];div.style.left=parseInt(i)+1+"px";}}.bind(_this3),scrollSpeed);}else if(scolltype=='left'){_this3.myInterval=setInterval(function(){var left=parseInt(div.style.left.split("px")[0]);if(left<=-offsetWidth){div.style.left=div.offsetWidth+"px";}else{var i=(div.style.left+"").split('px')[0];div.style.left=parseInt(i)-1+"px";}}.bind(_this3),scrollSpeed);}else if(scolltype=='up'){if(ebaseid==='FormModeCustomSearch'){// 建模查询中心上下自动滚动单独处理
_this3.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top<=-div.offsetHeight){div.style.top=offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)-1+"px";}}.bind(_this3),scrollSpeed);}else{_this3.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top<=-offsetHeight){div.style.top=div.offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)-1+"px";}}.bind(_this3),scrollSpeed);}}else if(scolltype=='down'){_this3.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top>=offsetHeight){div.style.top=-div.offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)+1+"px";}}.bind(_this3),scrollSpeed);}};}}},{key:'marquee',value:function marquee(obj,step,box){var _props=this.props,scolltype=_props.scolltype,eid=_props.eid,showModeId=_props.showModeId,ebaseid=_props.ebaseid;var marginTop="-=1";if(scolltype=='down'){marginTop="-=-1";}$(box).animate({marginTop:marginTop},0,function(){var s=Math.abs(parseInt($(this).css("margin-top")));var row=$('#content_'+eid+' .wea-new-table .ant-table-row');if(ebaseid=='7'){if(showModeId=='2'||showModeId=='3'||showModeId=='6'){//上图式、左图式、摘要式
row=$('#content_'+eid+' .portal-news-content .portal-news-com');}}else if(ebaseid=='notice'){row=$('#content_'+eid+' .portal-element-newnotice-item');}var length=row.length;if(s>=step){if(scolltype=='up'){row.slice(0,1).appendTo($(this));}else{row.slice(length-1,length).prependTo($(this));}$(this).css("margin-top",0);}});}},{key:'myScroll',value:function myScroll(options){//默认配置
var defaults={rowHeight:24,//每行的高度
scolltype:'up'//方向
};var _props2=this.props,_props2$scrollSpeed=_props2.scrollSpeed,scrollSpeed=_props2$scrollSpeed===undefined?'20':_props2$scrollSpeed,ebaseid=_props2.ebaseid;var opts=$.extend({},defaults,options);var sh=opts["rowHeight"];var box=opts["box"];var elementHight=opts["elementHight"];var marquee=opts["marquee"];var _this=$(box);this.intId=[];var _self=this;box.each(function(i){_self.intId[i]=setInterval(function(){if(box.height()<=elementHight){clearInterval(_self.intId[i]);}else{marquee(_this,sh,box);}},scrollSpeed);_this.hover(function(){clearInterval(_self.intId[i]);},function(){clearInterval(_self.intId[i]);_self.intId[i]=setInterval(function(){if(box.height()<=elementHight){clearInterval(_self.intId[i]);}else{marquee(_this,sh,box);}},scrollSpeed);});});}},{key:'componentWillMount',value:function componentWillMount(){var _this4=this;var _props3=this.props,eid=_props3.eid,scolltype=_props3.scolltype,height=_props3.height,tabdata=_props3.tabdata,_props3$scrollSpeed=_props3.scrollSpeed,scrollSpeed=_props3$scrollSpeed===undefined?'20':_props3$scrollSpeed,ebaseid=_props3.ebaseid,showModeId=_props3.showModeId;if(tabdata&&tabdata.data&&tabdata.data.length==0){this.autoMarquee(eid,"none",height,scrollSpeed);}else{var loop1=setInterval(function(){if($('#content_'+eid+' .wea-new-table .ant-table-body>table').length>0){clearInterval(loop1);_this4.autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid,showModeId);}},500);}}},{key:'componentDidMount',value:function componentDidMount(){var _this5=this;var _props4=this.props,eid=_props4.eid,scolltype=_props4.scolltype,height=_props4.height,tabdata=_props4.tabdata,_props4$scrollSpeed=_props4.scrollSpeed,scrollSpeed=_props4$scrollSpeed===undefined?'20':_props4$scrollSpeed,ebaseid=_props4.ebaseid,showModeId=_props4.showModeId;if(tabdata&&tabdata.data&&tabdata.data.length==0){this.autoMarquee(eid,"none",height,scrollSpeed);}else{var loop1=setInterval(function(){if($('#content_'+eid+' .wea-new-table .ant-table-body>table').length>0){clearInterval(loop1);_this5.autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid,showModeId);}},500);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this6=this;var _props5=this.props,eid=_props5.eid,scolltype=_props5.scolltype,height=_props5.height,tabdata=_props5.tabdata,_props5$scrollSpeed=_props5.scrollSpeed,scrollSpeed=_props5$scrollSpeed===undefined?'20':_props5$scrollSpeed,ebaseid=_props5.ebaseid,showModeId=_props5.showModeId;clearInterval(this.myInterval);if(tabdata&&tabdata.data&&tabdata.data.length==0){this.autoMarquee(eid,"none",height,scrollSpeed);}else{var loop1=setInterval(function(){if($('#content_'+eid+' .wea-new-table .ant-table-body>table').length>0){clearInterval(loop1);_this6.autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid,showModeId);}},500);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var scolltype=this.props.scolltype;if(this.isMarquee(scolltype)){clearInterval(this.myInterval);}}},{key:'isMarquee',value:function isMarquee(scolltype){var arr=['up','down','left','right'];return(0,_common.isContain)(arr,scolltype);}},{key:'addMarqueeAttrs',value:function addMarqueeAttrs(eid,scolltype,height){var attrs={direction:scolltype,onmouseover:'this.stop()',onmouseout:'this.start()',scrolldelay:'200'};if(scolltype==='up'||scolltype==='down'){attrs['width']='100%';attrs['height']=height;}$("#webjx_"+eid).attr(attrs);}},{key:'render',value:function render(){var _props6=this.props,eid=_props6.eid,children=_props6.children,scolltype=_props6.scolltype,height=_props6.height,ebaseid=_props6.ebaseid;$(children);if(this.isMarquee(scolltype)){//return <marquee id={`webjx_${eid}`}> { children } </marquee>
if(ebaseid&&ebaseid=='notice'){return _react2.default.createElement('div',{style:{position:'relative',display:'inline-block',width:'100%',overflow:'hidden'}},children);}return _react2.default.createElement('div',{style:{position:'relative',display:'inline-block',width:'100%'}},children);}else return _react2.default.createElement('div',null,children);}}]);return MarqueeCom;}(_react2.default.Component);exports.default=MarqueeCom;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(164), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(418),
    getValue = __webpack_require__(421);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(89);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(33);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(59);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(61)('keys');
var uid = __webpack_require__(51);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var global = __webpack_require__(27);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(50) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 63 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _weaPortalPublic=__webpack_require__(47);exports.default=_weaPortalPublic.WeaMaterialLib;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tinycolor = __webpack_require__(349);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Color = function () {
  function Color(input) {
    var _this = this;

    _classCallCheck(this, Color);

    this.initRgb = function () {
      var _color$toRgb = _this.color.toRgb(),
          r = _color$toRgb.r,
          g = _color$toRgb.g,
          b = _color$toRgb.b;

      _this.redValue = r;
      _this.greenValue = g;
      _this.blueValue = b;
    };

    this.initHsb = function () {
      var _color$toHsv = _this.color.toHsv(),
          h = _color$toHsv.h,
          s = _color$toHsv.s,
          v = _color$toHsv.v;

      _this.hueValue = h;
      _this.saturationValue = s;
      _this.brightnessValue = v;
    };

    this.toHexString = function () {
      return _this.color.toHexString();
    };

    this.toRgbString = function () {
      return _this.color.toRgbString();
    };

    this.color = (0, _tinycolor2["default"])(input);

    this.initRgb();
    this.initHsb();

    var initAlpha = input && input.alpha || this.color.toRgb().a;
    this.alphaValue = Math.min(1, initAlpha) * 100;
  }

  Color.isValidHex = function isValidHex(hex) {
    return (0, _tinycolor2["default"])(hex).isValid();
  };

  _createClass(Color, [{
    key: 'hex',
    get: function get() {
      return this.color.toHex();
    }

    // 色调

  }, {
    key: 'hue',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: value,
        s: this.saturation,
        v: this.brightness
      });

      this.initRgb();
      this.hueValue = value;
    },
    get: function get() {
      return this.hueValue;
    }

    // 饱和度

  }, {
    key: 'saturation',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: this.hue,
        s: value,
        v: this.brightness
      });

      this.initRgb();
      this.saturationValue = value;
    },
    get: function get() {
      return this.saturationValue;
    }

    // 亮度

  }, {
    key: 'lightness',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: this.hue,
        s: this.saturation,
        l: value
      });

      this.initRgb();
      this.lightnessValue = value;
    },
    get: function get() {
      return this.lightnessValue;
    }
  }, {
    key: 'brightness',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: this.hue,
        s: this.saturation,
        v: value
      });

      this.initRgb();
      this.brightnessValue = value;
    },
    get: function get() {
      return this.brightnessValue;
    }

    // red

  }, {
    key: 'red',
    set: function set(value) {
      var rgb = this.color.toRgb();
      this.color = (0, _tinycolor2["default"])(_extends({}, rgb, {
        r: value
      }));

      this.initHsb();
      this.redValue = value;
    },
    get: function get() {
      return this.redValue;
    }

    // green

  }, {
    key: 'green',
    set: function set(value) {
      var rgb = this.color.toRgb();
      this.color = (0, _tinycolor2["default"])(_extends({}, rgb, {
        g: value
      }));

      this.initHsb();
      this.greenValue = value;
    },
    get: function get() {
      return this.greenValue;
    }

    // blue

  }, {
    key: 'blue',
    set: function set(value) {
      var rgb = this.color.toRgb();
      this.color = (0, _tinycolor2["default"])(_extends({}, rgb, {
        b: value
      }));

      this.initHsb();
      this.blueValue = value;
    },
    get: function get() {
      return this.blueValue;
    }

    // alpha

  }, {
    key: 'alpha',
    set: function set(value) {
      this.color.setAlpha(value / 100);
    },
    get: function get() {
      return this.color.getAlpha() * 100;
    }
  }, {
    key: 'RGB',
    get: function get() {
      return [this.red, this.green, this.blue];
    }
  }, {
    key: 'HSB',
    get: function get() {
      return [this.hue, this.saturation, this.brightness];
    }
  }]);

  return Color;
}();

exports["default"] = Color;
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.toArray = toArray;
exports.getActiveIndex = getActiveIndex;
exports.getActiveKey = getActiveKey;
exports.setTransform = setTransform;
exports.isTransform3dSupported = isTransform3dSupported;
exports.setTransition = setTransition;
exports.getTransformPropValue = getTransformPropValue;
exports.isVertical = isVertical;
exports.getTransformByIndex = getTransformByIndex;
exports.getMarginStyle = getMarginStyle;
exports.getStyle = getStyle;
exports.setPxStyle = setPxStyle;
exports.getDataAttr = getDataAttr;
exports.getLeft = getLeft;
exports.getTop = getTop;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  _react2['default'].Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransform3dSupported(style) {
  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}

function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ltr';

  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';

  if (!isVertical(tabBarPosition) && direction === 'rtl') {
    return translate + '(' + index * 100 + '%) translateZ(0)';
  }
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, 'padding-' + start);
  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;

  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, 'margin-' + start);
      total += node[current];
      total += toNum(style, 'margin-' + end);

      if (style.boxSizing === 'content-box') {
        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
      }
      return false;
    }

    // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
    total += toNum(style, 'margin-' + start);

    return true;
  });

  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}

function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(110),
    getRawTag = __webpack_require__(397),
    objectToString = __webpack_require__(398);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(53);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _PortalSetting=__webpack_require__(124);var _PortalSetting2=_interopRequireDefault(_PortalSetting);var _LayoutFlags=__webpack_require__(196);var _LayoutFlags2=_interopRequireDefault(_LayoutFlags);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);var _rcmenu=__webpack_require__(77);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ls=_ecCom.WeaTools.ls;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//引入元素组件
//门户组件
var Homepage=function(_React$Component){(0,_inherits3.default)(Homepage,_React$Component);function Homepage(props){(0,_classCallCheck3.default)(this,Homepage);var _this=(0,_possibleConstructorReturn3.default)(this,(Homepage.__proto__||(0,_getPrototypeOf2.default)(Homepage)).call(this,props));_this.state={hpdata:null,params:{},isShrink:false};_this.handleParams=_this.handleParams.bind(_this);_this.getPortalData=_this.getPortalData.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.handleAddElement=_this.handleAddElement.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.onChangeLabel=_this.onChangeLabel.bind(_this);window.portalGetElementStyle=_this.getPortalData.bind(_this);return _this;}(0,_createClass3.default)(Homepage,[{key:'handleParams',value:function handleParams(props){var query={};if(props.location)query=props.location.query;var params=(0,_objectAssign2.default)({},props.params,query);if(props.hpid){if(props.formData&&(0,_typeof3.default)(props.formData)==='object')props.formData=(0,_stringify2.default)(props.formData);params=(0,_objectAssign2.default)(params,props);if(!params.isSetting)params.isSetting=false;}else{params.isSetting=false;params.isfromportal=1;params.isfromhp=0;}window.element_custompage_loadIframe=params.loadIframe!='false';return params;}},{key:'getPortalData',value:function getPortalData(params){var _this2=this;var hpid=params.hpid,isSetting=params.isSetting;var hpdata=ls.getJSONObj('portal-'+hpid+'-'+isSetting);if(hpdata&&this.state.params.hpid!=hpid){hpdata.islsdata=true;this.setState({hpdata:hpdata,params:params});}_ecCom.WeaTools.callApi('/api/portal/homepage/hpdata','POST',params).then(function(data){if(data.status==='failed'){_antd.message.error(data.errormsg);}else{ls.set('portal-'+hpid+'-'+isSetting,data);_this2.timestamp=new Date().getTime();_this2.setState({hpdata:data,params:params});}});}},{key:'handleRefresh',value:function handleRefresh(nParams){var params=this.handleParams(this.props);this.getPortalData((0,_extends3.default)({},params,nParams));}},{key:'handleAddElement',value:function handleAddElement(element,areaflag,index){var _state$params=this.state.params,hpid=_state$params.hpid,isSetting=_state$params.isSetting;//获取当前设置门户信息
var hpdata=(0,_extends3.default)({},this.state.hpdata);var layoutFlags=hpdata.hpinfo.layoutFlags;for(var i=0;i<layoutFlags.length;i++){var layoutFlag=layoutFlags[i];if(layoutFlag.areaflag===areaflag){var areaElements=layoutFlag.areaElements;areaElements.splice(index,0,element.config);break;}}hpdata.hpCss+=element.eCss;ls.set('portal-'+hpid+'-'+isSetting,hpdata);this.setState({hpdata:hpdata});}},{key:'getHpRefreshData',value:function getHpRefreshData(params){var _this3=this;clearInterval(this.portalRefreshInterval);_ecCom.WeaTools.callApi('/api/portal/portalSetting/getHpRefreshData','GET').then(function(result){var _result$data=result.data,data=_result$data===undefined?{}:_result$data;var needRefresh=data.needRefresh,_data$refreshMins=data.refreshMins,refreshMins=_data$refreshMins===undefined?999:_data$refreshMins,refreshEbaseid=data.refreshEbaseid,refreshType=data.refreshType;if(needRefresh){if(refreshType=='1'){_this3.portalRefreshInterval=setInterval(function(){return _this3.getPortalData((0,_extends3.default)({},params,{isPortalRefresh:true}));},refreshMins*60*1000);}else if(refreshType=='2'){var refreshEbaseidArr=refreshEbaseid.split(',');_this3.portalRefreshInterval=setInterval(function(){//未读文档元素刷新
refreshEbaseidArr.indexOf("6")>-1&&window.element_unReadDoc_reLoad_all();//流程元素刷新
refreshEbaseidArr.indexOf("8")>-1&&window.element_workflow_reLoad();//文档中心元素刷新
refreshEbaseidArr.indexOf("7")>-1&&window.element_news_reLoad_all();},refreshMins*60*1000);}}});}},{key:'componentWillMount',value:function componentWillMount(){var params=this.handleParams(this.props);this.getPortalData(params);this.getHpRefreshData(params);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.portalRefreshInterval);}},{key:'componentDidMount',value:function componentDidMount(){var _this4=this;var params=this.handleParams(this.props);if(this.refs.btnWfCenterReload)this.refs.btnWfCenterReload.setAttribute("onclick","element_workflow_reLoad()");if(this.refs.homepageContainer)$(this.refs.homepageContainer).css("min-height",$(".homepage[data-isSetting="+params.isSetting+"]").height());$(window).resize(function(){//当浏览器大小变化时
if(_this4.refs.homepageContainer)$(_this4.refs.homepageContainer).css("min-height",$(".homepage[data-isSetting="+params.isSetting+"]").height());});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var params=this.handleParams(this.props);var nParams=this.handleParams(nextProps);if(window.isPortalRender||!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(params,nParams)){this.getPortalData(nParams);this.getHpRefreshData(nParams);}}},{key:'render',value:function render(){var _props=this.props,isSynergySetting=_props.isSynergySetting,synergyParams=_props.synergyParams,location=_props.location;var _state=this.state,params=_state.params,hpdata=_state.hpdata;if(params.hpid){var style={};var hpHtml=_react2.default.createElement('div',null);var styleStr="";var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;var layoutid='';if(hpdata){if(hpdata.hasRight){layoutid=hpdata.hpinfo.bLayoutid;style={background:hpdata.hpinfo.bgcolor};var queryParams={};if(location)queryParams=location.query;var layoutObj={config:{isRender:true,timestamp:this.timestamp,islsdata:!!hpdata.islsdata,isremembertab:hpdata.hpinfo.isremembertab,isSetting:hpdata.hpinfo.isSetting,isSynergySetting:isSynergySetting,synergyParams:(0,_objectAssign2.default)({},synergyParams,queryParams)},layoutFlags:hpdata.hpinfo.layoutFlags,layoutid:hpdata.hpinfo.bLayoutid,layoutHtml:hpdata.hpinfo.html};styleStr=hpdata.hpCss.replace(/\"/g,"");hpHtml=_react2.default.createElement(_LayoutFlags2.default,layoutObj);}else{hpHtml=_react2.default.createElement(NoRightPage,{msg:hpdata.msg});}}if(jQuery('#portal-style')&&jQuery('#portal-style').length){jQuery('#portal-style').html(styleStr);}else{jQuery(jQuery('head')[0]).append('<style id="portal-style" type="text/css">'+styleStr+'</style>');}var classname='homepage';if(isSetting){classname='homepage homepage-setting';}return _react2.default.createElement('div',{className:classname,'data-hpid':hpid,'data-subcompanyid':subCompanyId,'data-issetting':isSetting,'data-layoutid':layoutid,style:style},!isSetting?_react2.default.createElement(_PortalSetting2.default,{ref:'portalsetting'}):'',_react2.default.createElement('div',{style:{margin:'-10px -10px 0 0'}},_react2.default.createElement('input',{type:'hidden',ref:'btnWfCenterReload',value:'btnWfCenterReload',id:'btnWfCenterReload',name:'btnWfCenterReload'}),isSetting?hpHtml:_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{ref:'homepageContainer',style:{height:'100%'}},hpHtml))));}else{return _react2.default.createElement('div',{className:'homepage'});}}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];var hpdata=this.state.hpdata;if(hpdata){hpdata.rcmenu.map(function(menu){btns.push({key:menu.key,icon:_react2.default.createElement('i',{className:menu.icon}),content:menu.label});});}return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var _state2=this.state,params=_state2.params,hpdata=_state2.hpdata;var _params=(0,_extends3.default)({},params);_params.isSetting=true;_params.viewtype='edit';_params.from='addElement';_params.isfromportal=undefined;_params.title=hpdata.hpinfo.hpname;switch(key){case'resethp':case'updatesynihp':case'completesynihp':(0,_rcmenu.handlePortalSynize)({hpid:_params.hpid,subCompanyId:_params.subCompanyId,method:key});break;case'shrinkAll':this.setState({isShrink:!this.state.isShrink});this.onChangeLabel(this.state.hpdata.rcmenu,'shrinkAll',this.state.isShrink);(0,_rcmenu.onShowOrHideAllE)(params.isSetting);break;case'settingElement':window.handlePortalSetting(_params);break;case'store':(0,_rcmenu.openFavouriteBrowser)();break;case'help':(0,_rcmenu.showHelp)();break;case'5':break;}}},{key:'onChangeLabel',value:function onChangeLabel(rcmenu,key,bool){var lable1=getLabel(18466,'全部收缩');var lable2=getLabel(16216,'全部展开');rcmenu.map(function(item){if(item.key==key){if(bool){item.label=lable1;item.icon="icon-coms-All-contraction";}else{item.label=lable2;item.icon="icon-coms-All-unfolding";}}});}}]);return Homepage;}(_react2.default.Component);//无权限门户
var NoRightPage=function NoRightPage(_ref){var msg=_ref.msg;return _react2.default.createElement('div',{className:'page-noright'},_react2.default.createElement('img',{src:'/images/ecology8/noright_wev8.png',width:'162px',height:'162px'}),_react2.default.createElement('div',{style:{color:'rgb(255,187,14)'}},msg));};var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Homepage=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Homepage);exports.default=Homepage;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(28) && !__webpack_require__(30)(function () {
  return Object.defineProperty(__webpack_require__(72)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var document = __webpack_require__(27).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(34);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(91)(false);
var IE_PROTO = __webpack_require__(60)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(167)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(117)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;function handlePortalSynize(params,callback){var hpid=params.hpid,subCompanyId=params.subCompanyId,method=params.method;var content='';if(method=='resethp'){content=getLabel(388036,"确定重置首页吗？");}else if(method=='updatesynihp'){content=getLabel(388037,"确定同步首页吗？");}else if(method=='completesynihp'){content=getLabel(127000,"同步后，用户在此门户中的个性化设置会丢失。确定要同步吗？");}_antd.Modal.confirm({title:getLabel(386786,"信息确认"),content:content,onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/portalrcmenu/'+(method=='resethp'?'updatesynihp':method),'POST',{hpid:hpid,subCompanyId:subCompanyId}).then(function(data){if(data.status==='2'){_antd.message.error(getLabel(83322,"处理失败！"));}else{_antd.message.success(getLabel(83323,"处理成功！"));if(callback&&typeof callback=='function')callback();}});}});}function onShowOrHideAllE(isSetting){$(".homepage[data-issetting="+isSetting+"]").find(".content").toggle();}function openFavouriteBrowser(){var BacoTitle=jQuery("#BacoTitle");var pagename="";var navName="";var fav_uri="%2Fhomepage%2FHomepage.jsp";var fav_querystring="isfromportal%3D1%5Ee71494489609747%3D%5Ehpid%3D26%5EsubCompanyId%3D34%5Eisfromhp%3D0";try{var e8tabcontainer=jQuery("div[_e8tabcontainer='true']",parent.document);if(e8tabcontainer.length>0){fav_uri=escape(parent.window.location.pathname);fav_querystring=escape(parent.window.location.search);navName=e8tabcontainer.find("#objName").text();}else{navName=jQuery("#objName").text();}}catch(e){}if(BacoTitle){pagename=BacoTitle.text();}if(!pagename){pagename=navName;}pagename=escape(pagename);//window.showModalDialog('/systeminfo/BrowserMain.jsp?url=/favourite/FavouriteBrowser.jsp&fav_pagename='+pagename+'&fav_uri='+fav_uri+'&fav_querystring='+fav_querystring+'&mouldID=doc');
var e8tabcontainer2=jQuery("div[_e8tabcontainer='true']",parent.document);var dialogurl="";if(e8tabcontainer2.length>0){dialogurl='/systeminfo/BrowserMain.jsp?url=/favourite/FavouriteBrowser.jsp&fav_pagename='+pagename+'&fav_uri='+fav_uri+'&fav_querystring='+fav_querystring+'&mouldID=doc';}else{dialogurl='/systeminfo/BrowserMain.jsp?url=/favourite/FavouriteBrowser.jsp&fav_uri='+fav_uri+'&mouldID=doc';//fav_pagename和fav_querystring不通过url传值，而通过session获取，避免url过长时，导致问题
}var dialog=new window.Dialog();dialog.currentWindow=window;dialog.URL=dialogurl;dialog.Title=getLabel(2081,"收藏夹");dialog.Width=550;dialog.Height=600;dialog.Drag=true;dialog.show();}function showHelp(){var pathKey="%2Fhomepage%2FHomepage.jsp%3Fhpid%3D1%26subCompanyId%3D1%26isfromportal%3D1%26isfromhp%3D0%26e71494487903719%3D";var operationPage="https://help.e-cology.com.cn/help/RemoteHelp.jsp";var screenWidth=window.screen.width*1;var screenHeight=window.screen.height*1;var isEnableExtranetHelp=1;if(isEnableExtranetHelp==1){//operationPage = "http://e-cology.com.cn/formmode/apps/ktree/ktreeHelp.jsp";
operationPage='https://www.e-cology.com.cn/formmode/apps/ktree/ktreeHelp.jsp';}window.open(operationPage+"?pathKey="+pathKey,"_blank","top=0,left="+(screenWidth-800)/2+",height="+(screenHeight-90)+",width=1000,status=no,scrollbars=yes,toolbar=yes,menubar=no,location=no");}module.exports={handlePortalSynize:handlePortalSynize,onShowOrHideAllE:onShowOrHideAllE,openFavouriteBrowser:openFavouriteBrowser,showHelp:showHelp,dragBaseElement:dragBaseElement/**-----------左边栏baseelement拖动特效------------**/};function dragBaseElement(ebaseid,callback){return;var hoveritem=void 0;var itemholder=$("#itemholder");var itemholderClass=$(".itemholderClass");var index=0;$(".portal-setting-left-hpbaseelement-item div a").draggable({helper:"clone",start:function start(event,ui){var helper=ui.helper;helper.addClass("dragitemholder");},drag:function drag(event,ui){if(hoveritem!==undefined){var items=hoveritem.find(".item");var itemtemp;var offset=ui.offset;var itemoffset;var itemheight;var flag=true;for(var i=0,len=items.length;i<len;i++){itemtemp=$(items[i]);itemoffset=itemtemp.offset();itemheight=itemtemp.height();if(offset.top>itemoffset.top&&offset.top<itemoffset.top+itemheight){if(itemtemp.prev()===itemholder){return;}itemholder.insertBefore(itemtemp);itemholder.show();index=i;return;}if(i===len-1)flag=false;}if(!flag||items.length===0){hoveritem.find(".group").append(itemholder);itemholder.show();}}}});//将td注册drop事件
$(".group").parent().droppable({over:function over(event,ui){hoveritem=$(event.target);},drop:function drop(event,ui){var areaflag=hoveritem.find(".group").attr("data-areaflag");if(ebaseid==null){return;}callback(ebaseid,areaflag,index);//鼠标移除则隐藏占位框
},out:function out(event,ui){// itemholderClass.hide();
$(".dragitemholder").hide();}});}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(8);var _extends4=_interopRequireDefault(_extends3);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 提醒方式
var ERemindMode=function(_React$Component){(0,_inherits3.default)(ERemindMode,_React$Component);function ERemindMode(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ERemindMode);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ERemindMode.__proto__||(0,_getPrototypeOf2.default)(ERemindMode)).call.apply(_ref,[this].concat(args))),_this),_this.state={eRemindMode:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ERemindMode,[{key:'render',value:function render(){var _this2=this;var eRemindMode=this.state.eRemindMode;var eRemindModeList=[];var _loop=function _loop(key){if(eRemindMode.hasOwnProperty(key)){eRemindModeList.push(_react2.default.createElement('li',{style:{display:'inline-block'}},_react2.default.createElement(_antd.Checkbox,{checked:eRemindMode[key].checked,onChange:function onChange(e){return _this2.setState({eRemindMode:(0,_extends4.default)({},eRemindMode,(0,_defineProperty3.default)({},key,(0,_extends4.default)({},eRemindMode[key],{checked:e.target.checked})))});}},eRemindMode[key].label),key=='color'?_react2.default.createElement('div',{style:{display:'inline-block',width:'100px'}},_react2.default.createElement(_ecCom.WeaColorPicker,{value:eRemindMode[key].color,onChange:function onChange(value){return _this2.setState({eRemindMode:(0,_extends4.default)({},eRemindMode,{'color':(0,_extends4.default)({},eRemindMode['color'],{color:value})})});}})):''));}};for(var key in eRemindMode){_loop(key);}return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(18713,'提醒方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{ref:'eRemindMode'},eRemindModeList));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.eRemindMode;}}]);return ERemindMode;}(_react2.default.Component);exports.default=ERemindMode;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;

var _addDomEventListener = _interopRequireDefault(__webpack_require__(135));

var _reactDom = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener.default)(target, eventType, callback, option);
}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(408),
    listCacheDelete = __webpack_require__(409),
    listCacheGet = __webpack_require__(410),
    listCacheHas = __webpack_require__(411),
    listCacheSet = __webpack_require__(412);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(146);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(430);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88);
module.exports = __webpack_require__(20).Object.assign;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(29);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(90) });


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(28);
var getKeys = __webpack_require__(44);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(52);
var toObject = __webpack_require__(41);
var IObject = __webpack_require__(58);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(30)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(74);
var toAbsoluteIndex = __webpack_require__(92);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(37);
var dPs = __webpack_require__(169);
var enumBugKeys = __webpack_require__(62);
var IE_PROTO = __webpack_require__(60)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(72)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(170).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(32).f;
var has = __webpack_require__(34);
var TAG = __webpack_require__(31)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
var global = __webpack_require__(27);
var hide = __webpack_require__(40);
var Iterators = __webpack_require__(54);
var TO_STRING_TAG = __webpack_require__(31)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(31);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var core = __webpack_require__(20);
var LIBRARY = __webpack_require__(50);
var wksExt = __webpack_require__(96);
var defineProperty = __webpack_require__(32).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(198);__webpack_require__(116);__webpack_require__(203);var _components=__webpack_require__(207);var _components2=_interopRequireDefault(_components);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.elements_more_params={};module.exports={Element:_components2.default};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//元素类型统一管理
var ELEMENT_TYPES={/** ---------- 可变tab元素 ---------- **/RSS:'1',// RSS元素
NEWS:'7',// 文档元素
WORKFLOW:'8',// 流程元素
CUSTOMPAGE:'29',// 自定义页面元素
REPORTFORM:'reportForm',// 图表元素
OUTDATA:'OutData',// 外部数据元素
FORMMODECUSTOMSEARCH:'FormModeCustomSearch',// 建模查询中心元素
/** ---------- 不可变tab元素 ---------- **/MAIL:'16',// 我的邮件
ADDWF:'addwf',// 新建流程
TASK:'Task',// 任务元素
BLOGSTATUS:'blogStatus',// 微博元素
CONTACTS:'contacts',// 通讯录
/** ---------- 以view.jsp页面显示的元素 ---------- **/UNREAD_DOCS:'6',// 未读文档
MESSAGE_REMINDING:'9',// 消息提醒 
MY_PROJECTS:'10',// 我的项目 
NEW_CUSTOMERS:'11',// 最新客户 
NEW_MEETING:'12',// 最新会议 
UNREAD_COOPERATION:'13',// 未读协作  
MONTH_TARGET:'14',// 当月目标 
DAY_PLAN:'15',// 当日计划
SUBSCRIBE_KONWLEDG:'34',// 知识订阅
/** ---------- 元素 ---------- **/MORE_NEWS:'17',// 多新闻中心
MAGAZINE:'18',// 期刊元素
STOCK:'19',// 股票元素
DOC_CONTENT:'25',// 文档内容
AUDIO:'audio',// 音频元素 
FAVOURITE:'favourite',// 收藏元素
FLASH:'Flash',// Flash元素
PICTURE:'picture',// 图片元素
MYCALENDAR:'MyCalendar',// 日历日程
MEETINGCALENDAR:'MeetingCalendar',// 会议日历
IMGSLIDE:'imgSlide',// 多图元素
NEWNOTICE:'newNotice',// 最新通告  
OUTTERSYS:'outterSys',// 集成登录
SCRATCHPAD:'scratchpad',// 便签元素
WEATHER:'weather',// 天气元素
VIDEO:'video',// 视频元素 
SLIDE:'Slide',// 幻灯片元素 
DATACENTER:'DataCenter',// 个人中心
JOBSINFO:'jobsinfo',// 多岗位办理事项
SEARCHENGINE:'searchengine',// 搜索元素
NOTICE:'notice',// 通告栏元素
PLAN:'plan',// 计划元素
CUSTOMMENU:'menu',// 自定义菜单
WORKTASK:'32',// 任务计划
LOGIN:'login',// 登录系统
LOGIN_NEWS:'news',// 公司新闻
CALENDARELE:'CalendarEle',// 日历元素
BOOKSHELF:'bookshelf',// 书柜元素
NEWMOBILEPICTURE:'newMobilePicture',// 移动门户图片
FNABUDGETASSISTANT:'fnaBudgetAssistant',// 费用报销智能助手
FNABUDGETASSISTANT1:'fnaBudgetAssistant1',// 审批助手元素
COREMAIL:'CoreMail',// CoreMail邮箱
MYTASK:'processTask',// 我的任务元素      
ELEMENTTABLE:'elementTable',// 通用列表组件           
CUSTOMELEMENT:'customElement',// 自定义元素
QUICKEENTRY:'quickEntry',// 快捷入口元素
ECODEELEMENT:'ecodeElement',// ecode自定义元素
// DY_DOCUMENTCENTER: 'DY_documentCenter',         // 自定义元素
NEW_DY:'7_DY'// 自定义元素
};module.exports={ELEMENT_TYPES:ELEMENT_TYPES};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _slicedToArray2=__webpack_require__(223);var _slicedToArray3=_interopRequireDefault(_slicedToArray2);var _stringify=__webpack_require__(53);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _util=__webpack_require__(230);__webpack_require__(231);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SynergySetting4Designer=function(_React$Component){(0,_inherits3.default)(SynergySetting4Designer,_React$Component);function SynergySetting4Designer(props){(0,_classCallCheck3.default)(this,SynergySetting4Designer);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergySetting4Designer.__proto__||(0,_getPrototypeOf2.default)(SynergySetting4Designer)).call(this,props));_this.state={visible:false,loading:false,settingParams:{},paramObj:{},compareTypeObj:{},valueTypeObj:{},paramValueOptions:[],paramValueObj:{},expsObj:{},selectedExps:[],selectedExpsPKey:''};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onParamObjChange=_this.onParamObjChange.bind(_this);_this.onCompareTypeObjChange=_this.onCompareTypeObjChange.bind(_this);_this.onValueTypeObjChange=_this.onValueTypeObjChange.bind(_this);_this.onParamValueObjChange=_this.onParamValueObjChange.bind(_this);_this.onParamValueObj4DateChange=_this.onParamValueObj4DateChange.bind(_this);_this.getExpsComp=_this.getExpsComp.bind(_this);_this.onExpClick=_this.onExpClick.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onDel=_this.onDel.bind(_this);_this.onAnd=_this.onAnd.bind(_this);_this.onOr=_this.onOr.bind(_this);_this.onSplit=_this.onSplit.bind(_this);return _this;}(0,_createClass3.default)(SynergySetting4Designer,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,settingParams=_state.settingParams,paramObj=_state.paramObj,compareTypeObj=_state.compareTypeObj,valueTypeObj=_state.valueTypeObj,paramValueOptions=_state.paramValueOptions,paramValueObj=_state.paramValueObj,expsObj=_state.expsObj,selectedExps=_state.selectedExps;var hpid=settingParams.hpid,ebaseid=settingParams.ebaseid,wfid=settingParams.wfid;var _paramObj$paramData=paramObj.paramData,paramData=_paramObj$paramData===undefined?{id:'0',name:'请选择参数'}:_paramObj$paramData,htmlType=paramObj.htmlType,fieldType=paramObj.fieldType,isMulti=paramObj.isMulti;var compareTypeOptions=compareTypeObj.compareTypeOptions,compareType=compareTypeObj.compareType;var valueTypeOptions=valueTypeObj.valueTypeOptions,valueType=valueTypeObj.valueType;var paramValue=paramValueObj.paramValue,_paramValueObj$paramV=paramValueObj.paramValueData,paramValueData=_paramValueObj$paramV===undefined?{id:'0',name:''}:_paramValueObj$paramV;var paramComp=_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,"请选择"),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',type:'synergyParams',modalStyle:{width:500},isSingle:true,dataParams:{type:'param',ebaseid:ebaseid,wfid:wfid},replaceDatas:[paramData],onChange:this.onParamObjChange});var compareTypeComp=_react2.default.createElement('div',null);var valueTypeComp=_react2.default.createElement('div',null);var paramValueComp=_react2.default.createElement('div',null);if(paramData.id&&paramData.id!='0'){compareTypeComp=_react2.default.createElement(_ecCom.WeaSelect,{options:compareTypeOptions,value:compareType,onChange:function onChange(key){return _this2.onCompareTypeObjChange(key,(0,_util.getSelectedName)(compareTypeOptions,key));}});valueTypeComp=_react2.default.createElement(_ecCom.WeaSelect,{options:valueTypeOptions,value:valueType,onChange:function onChange(key){return _this2.onValueTypeObjChange(key,(0,_util.getSelectedName)(valueTypeOptions,key));}});if(htmlType=='1'||htmlType=='2'){// 单行文本框、多行文本框
paramValueComp=_react2.default.createElement(_ecCom.WeaInput,{value:paramValue,onChange:function onChange(value){return _this2.onParamValueObjChange(value,value);}});}else if(htmlType=='3'){// 浏览框
if(valueType=='2'){// 固定值
if(fieldType=='2'){// 日期类型
paramValueComp=_react2.default.createElement(_ecCom.WeaDateGroup,{isMobx:true,datas:_util.DATE_TYPES,value:paramValue.split(','),onChange:this.onParamValueObj4DateChange});}else{paramValueComp=_react2.default.createElement(_ecCom.WeaBrowser,{type:fieldType,isSingle:!isMulti,replaceDatas:isMulti?[]:[paramValueData],onChange:this.onParamValueObjChange});}}else if(valueType=='3'){// 系统变量
paramValueComp=_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,"请选择"),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',type:'synergyParams',modalStyle:{width:500},isSingle:true,dataParams:{type:'paramvalue',ebaseid:'sysparam',htmlType:htmlType,fieldType:fieldType},replaceDatas:[paramValueData],onChange:this.onParamValueObjChange});}}else if(htmlType=='5'){// 单选框
paramValueComp=_react2.default.createElement(_ecCom.WeaSelect,{options:paramValueOptions,value:paramValue,style:{width:'100px'},onChange:function onChange(key){return _this2.onParamValueObjChange(key,(0,_util.getSelectedName)(paramValueOptions,key));}});}if(valueType=='6'){// 表单变量
paramValueComp=_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,"请选择"),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',type:'synergyParams',modalStyle:{width:500},isSingle:true,dataParams:{type:'paramvalue',ebaseid:ebaseid,hpid:hpid,htmlType:htmlType,fieldType:fieldType},replaceDatas:[paramValueData],onChange:this.onParamValueObjChange});}}return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:'\u5143\u7D20\u53C2\u6570\u8BBE\u7F6E',icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',style:{width:800,height:400},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement('div',{className:'synergy-setting-designer'},_react2.default.createElement('div',{className:'synergy-setting-select'},_react2.default.createElement(_antd.Row,{gutter:8},_react2.default.createElement(_antd.Col,{span:6},paramComp),_react2.default.createElement(_antd.Col,{span:4},compareTypeComp),_react2.default.createElement(_antd.Col,{span:4},valueTypeComp),_react2.default.createElement(_antd.Col,{span:10},paramValueComp))),_react2.default.createElement('div',{className:'synergy-setting-op'},_react2.default.createElement('div',{className:'synergy-setting-op-add',title:'\u6DFB\u52A0',onClick:this.onAdd}),_react2.default.createElement('div',{className:'synergy-setting-op-del',title:'\u5220\u9664',onClick:this.onDel}),_react2.default.createElement('div',{className:'synergy-setting-op-and',title:'\u6DFB\u52A0\u4E0E\u5173\u7CFB',onClick:this.onAnd}),_react2.default.createElement('div',{className:'synergy-setting-op-or',title:'\u6DFB\u52A0\u6216\u5173\u7CFB',onClick:this.onOr}),_react2.default.createElement('div',{className:'synergy-setting-op-split',title:'\u62C6\u5206\u5173\u7CFB',onClick:this.onSplit})),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement('div',{className:'synergy-setting-preview'},this.getExpsComp(expsObj,selectedExps)))));}},{key:'onShow',value:function onShow(params){var _this3=this;this.setState({visible:true,loading:true,settingParams:params});_ecCom.WeaTools.callApi('/api/portal/synergy/getParams','GET',params).then(function(data){_this3.setState({loading:false,expsObj:data.expsObj});});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _state2=this.state,settingParams=_state2.settingParams,expsObj=_state2.expsObj;_ecCom.WeaTools.callApi('/api/portal/synergy/setParams','POST',(0,_extends3.default)({},settingParams,{expsStr:(0,_stringify2.default)(expsObj)})).then(function(data){});this.onCancel();}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,settingParams:{},paramObj:{},compareTypeObj:{},valueTypeObj:{},paramValueOptions:[],paramValueObj:{},expsObj:{},selectedExps:[],selectedExpsPKey:''});}},{key:'onParamObjChange',value:function onParamObjChange(ids,names,datas){var _this4=this;var settingParams=this.state.settingParams;var stype=settingParams.stype,pagetype=settingParams.pagetype,ispagedeal=settingParams.ispagedeal;var _ref=datas[0]||{},id=_ref.id,fromtype=_ref.fromtype,formid=_ref.formid,isbill=_ref.isbill,htmltype=_ref.htmltype,fieldtype=_ref.fieldtype;if(fieldtype=='17'){fieldtype='1';}var isMulti=(0,_util.isMultiBrowserType)(fieldtype);// 判断当前字段是否是多选类型
this.setState({paramObj:{paramData:datas[0]||{},fromType:fromtype,formId:formid,isBill:isbill,paramId:ids,paramName:names,htmlType:htmltype,fieldType:fieldtype,isMulti:isMulti}});var compareTypeOptions4={key:'4',selected:false,showname:'等于'};var compareTypeOptions5={key:'5',selected:false,showname:'不等于'};var compareTypeOptions6={key:'6',selected:false,showname:'包含'};var compareTypeOptions7={key:'7',selected:false,showname:'不包含'};var compareTypeOptions8={key:'8',selected:false,showname:'属于'};var compareTypeOptions9={key:'9',selected:false,showname:'不属于'};var valueTypeOption0={key:'0',selected:false,showname:'输入值'};var valueTypeOption2={key:'2',selected:false,showname:'固定值'};var valueTypeOption3={key:'3',selected:false,showname:'系统变量'};var valueTypeOption4={key:'4',selected:false,showname:'下拉选择'};var valueTypeOption6={key:'6',selected:false,showname:'表单变量'};// 流程查看处理页和流程表单才有表单变量
var isNeedFormVar=stype=='wf'&&pagetype=='operat'&&ispagedeal=='1'||stype=='wf_form';if(htmltype=='1'||htmltype=='2'){// 单行文本框、多行文本框
var compareTypeOptions=[compareTypeOptions4,compareTypeOptions5,compareTypeOptions6,compareTypeOptions7];var valueTypeOptions=[valueTypeOption0];if(isNeedFormVar){valueTypeOptions.push(valueTypeOption6);}this.setState({compareTypeObj:{compareTypeOptions:compareTypeOptions,compareType:compareTypeOptions[0].key,compareName:compareTypeOptions[0].showname},valueTypeObj:{valueTypeOptions:valueTypeOptions,valueType:valueTypeOptions[0].key,valueTypeName:valueTypeOptions[0].showname},paramValueOptions:[],paramValueObj:{paramValue:'',paramValueName:''}});}else if(htmltype=='3'){// 浏览框
var _compareTypeOptions=isMulti?[compareTypeOptions6,compareTypeOptions7]:[compareTypeOptions8,compareTypeOptions9];var _valueTypeOptions=[valueTypeOption2,valueTypeOption3];if(isNeedFormVar){_valueTypeOptions.push(valueTypeOption6);}this.setState({compareTypeObj:{compareTypeOptions:_compareTypeOptions,compareType:_compareTypeOptions[0].key,compareName:_compareTypeOptions[0].showname},valueTypeObj:{valueTypeOptions:_valueTypeOptions,valueType:_valueTypeOptions[0].key,valueTypeName:_valueTypeOptions[0].showname},paramValueOptions:[],paramValueObj:{paramValue:fieldtype=='2'?'0':'',// fieldtype == '2' 为日期类型
paramValueName:fieldtype=='2'?(0,_util.getDateTypeName)('0'):''}});}else if(htmltype=='5'){// 单选框
var _compareTypeOptions2=[compareTypeOptions4,compareTypeOptions5];var _valueTypeOptions2=[valueTypeOption4];if(isNeedFormVar){_valueTypeOptions2.push(valueTypeOption6);}_ecCom.WeaTools.callApi('/api/portal/synergy/getWfSelectItems','GET',{fieldtype:fieldtype,fieldid:id}).then(function(data){var selectItems=data.data||[];var paramValueOptions=[];for(var i=0,len=selectItems.length;i<len;i++){paramValueOptions.push({key:selectItems[i].value,selected:false,showname:selectItems[i].name});}_this4.setState({compareTypeObj:{compareTypeOptions:_compareTypeOptions2,compareType:_compareTypeOptions2[0].key,compareName:_compareTypeOptions2[0].showname},valueTypeObj:{valueTypeOptions:_valueTypeOptions2,valueType:_valueTypeOptions2[0].key,valueTypeName:_valueTypeOptions2[0].showname},paramValueOptions:paramValueOptions,paramValueObj:{paramValue:paramValueOptions.length?paramValueOptions[0].key:'',paramValueName:paramValueOptions.length?paramValueOptions[0].showname:''}});});}}},{key:'onCompareTypeObjChange',value:function onCompareTypeObjChange(type,name){var compareTypeObj=this.state.compareTypeObj;this.setState({compareTypeObj:(0,_extends3.default)({},compareTypeObj,{compareType:type,compareName:name})});}},{key:'onValueTypeObjChange',value:function onValueTypeObjChange(type,name){var _state3=this.state,paramObj=_state3.paramObj,valueTypeObj=_state3.valueTypeObj,paramValueOptions=_state3.paramValueOptions;var htmlType=paramObj.htmlType,fieldType=paramObj.fieldType;var paramValueObj={};if(htmlType=='3'){// 浏览框
if(type=='2'&&fieldType=='2'){// 固定值，并且为日期类型
paramValueObj={paramValue:'0',paramValueName:(0,_util.getDateTypeName)('0')};}}else if(htmlType=='5'){// 单选框
if(type=='4'){// 下拉选择
paramValueObj={paramValue:paramValueOptions.length?paramValueOptions[0].key:'',paramValueName:paramValueOptions.length?paramValueOptions[0].showname:''};}}this.setState({valueTypeObj:(0,_extends3.default)({},valueTypeObj,{valueType:type,valueTypeName:name}),paramValueObj:paramValueObj});}},{key:'onParamValueObjChange',value:function onParamValueObjChange(ids,names,datas){var _state4=this.state,valueTypeObj=_state4.valueTypeObj,paramValueObj=_state4.paramValueObj;var valueType=valueTypeObj.valueType;if(valueType=='6'&&datas&&datas.length){// 表单变量
var _datas$=datas[0],formid=_datas$.formid,isbill=_datas$.isbill,id=_datas$.id;this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:ids,paramValueName:names,paramValueData:datas[0],filterFormId:formid,filterIsBill:isbill,filterId:id})});}else{if(datas&&datas.length){this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:ids,paramValueName:names,paramValueData:datas[0]})});}else{this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:ids,paramValueName:names})});}}}},{key:'onParamValueObj4DateChange',value:function onParamValueObj4DateChange(value){var paramValueObj=this.state.paramValueObj;var _value=(0,_slicedToArray3.default)(value,3),dateType=_value[0],startDate=_value[1],endDate=_value[2];var paramValue=dateType;var paramValueName=(0,_util.getDateTypeName)(dateType);if(dateType=='6'){// 指定日期范围
paramValue=value.join(',');paramValueName+='('+startDate+' 至 '+endDate+')';}this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:paramValue,paramValueName:paramValueName})});}},{key:'getExpsComp',value:function getExpsComp(expsObj,selectedExps){var _this5=this;var _expsObj$relation=expsObj.relation,relation=_expsObj$relation===undefined?'1':_expsObj$relation,_expsObj$expressions=expsObj.expressions,expressions=_expsObj$expressions===undefined?[]:_expsObj$expressions;var expsComp=_react2.default.createElement('div',null);if(expressions&&expressions.length){expsComp=_react2.default.createElement('div',{className:'synergy-setting-exps'},_react2.default.createElement('div',{className:'synergy-setting-relation'},relation=='1'?'AND':'OR'),_react2.default.createElement('div',{className:'synergy-setting-line'}),expressions.map(function(item){var selected=false;for(var i=0,len=selectedExps.length;i<len;i++){if(selectedExps[i].key==item.key){selected=true;}}var style={border:selected?'2px dashed #17d68c':'2px solid #fff'};if(item.relation==0||item.relation==1){return _react2.default.createElement('div',{key:item.key,className:'synergy-setting-exps-child',style:style,onClick:function onClick(e){return _this5.onExpClick(e,selected,item);}},_this5.getExpsComp(item,selectedExps));}else{return _react2.default.createElement('div',{key:item.key,className:'synergy-setting-exp'},_react2.default.createElement('span',{style:style,onClick:function onClick(e){return _this5.onExpClick(e,selected,item);}},item.paramName,' ',item.compareName,' ',item.paramValueName));}}));}return expsComp;}},{key:'onExpClick',value:function onExpClick(e,selected,exp){e.stopPropagation();var _state5=this.state,selectedExps=_state5.selectedExps,selectedExpsPKey=_state5.selectedExpsPKey;if(selected){var _selectedExps=[];for(var i=0,len=selectedExps.length;i<len;i++){if(selectedExps[i].key!=exp.key){_selectedExps.push(selectedExps[i]);}}selectedExps=_selectedExps;}else{if(selectedExpsPKey&&selectedExpsPKey!=exp.parentKey){selectedExps=[];}selectedExps.push(exp);}this.setState({selectedExps:selectedExps,selectedExpsPKey:exp.parentKey});}},{key:'onAdd',value:function onAdd(){var _state6=this.state,paramObj=_state6.paramObj,compareTypeObj=_state6.compareTypeObj,valueTypeObj=_state6.valueTypeObj,paramValueObj=_state6.paramValueObj;var fromType=paramObj.fromType,formId=paramObj.formId,isBill=paramObj.isBill,paramId=paramObj.paramId,paramName=paramObj.paramName,fieldType=paramObj.fieldType;var compareType=compareTypeObj.compareType,compareName=compareTypeObj.compareName;var valueType=valueTypeObj.valueType;var paramValue=paramValueObj.paramValue,paramValueName=paramValueObj.paramValueName,filterFormId=paramValueObj.filterFormId,filterIsBill=paramValueObj.filterIsBill,filterId=paramValueObj.filterId;if(!paramId||paramId=='0'){_antd.message.warning('请选择参数！');}else if(!paramValue){_antd.message.warning('请选择参数值！');}else{var expsObj=this.state.expsObj;var curTime=new Date().getTime();var expression={key:'exp_'+curTime,parentKey:expsObj.key||'exps_'+curTime,id:'exp_'+curTime,variableId:'exp_'+curTime,fromType:fromType,formId:formId,isBill:isBill,paramId:paramId,paramName:paramName,paramType:valueType=='0'?'0':'1',fieldType:fieldType,compareType:compareType,compareName:compareName,valueType:valueType,paramValue:paramValue,paramValueName:paramValueName,valueVariableId:fieldType,filterFormId:filterFormId,filterIsBill:filterIsBill,filterId:filterId};var _expsObj2=expsObj,_expsObj2$expressions=_expsObj2.expressions,expressions=_expsObj2$expressions===undefined?[]:_expsObj2$expressions;if(expressions&&expressions.length){expressions.push(expression);}else{expsObj={key:'exps_'+curTime,parentKey:'exps_0',relation:'1',expressions:[expression]};}this.setState({expsObj:expsObj});}}},{key:'onDel',value:function onDel(){var _state7=this.state,expsObj=_state7.expsObj,selectedExps=_state7.selectedExps,selectedExpsPKey=_state7.selectedExpsPKey;if(selectedExps&&selectedExps.length){this._onDel(expsObj,selectedExps,selectedExpsPKey,false);this.setState({expsObj:expsObj,selectedExps:[],selectedExpsPKey:''});}else{_antd.message.warning('请选择需要删除的条件！');}}},{key:'_onDel',value:function _onDel(expsObj,selectedExps,selectedExpsPKey,flag){var key=expsObj.key,_expsObj$expressions2=expsObj.expressions,expressions=_expsObj$expressions2===undefined?[]:_expsObj$expressions2;if(key==selectedExpsPKey){var _expressions=[];for(var i=0,len=expressions.length;i<len;i++){var count=0;for(var j=0,len2=selectedExps.length;j<len2;j++){if(expressions[i].key==selectedExps[j].key){count++;}}if(count==0){_expressions.push(expressions[i]);}}expsObj.expressions=_expressions;}else{var _expressions2=[];for(var _i=0,_len=expressions.length;_i<_len;_i++){var _expsObj=expressions[_i];if(_expsObj.expressions){this._onDel(_expsObj,selectedExps,selectedExpsPKey,flag);if(flag||_expsObj.expressions&&_expsObj.expressions.length){_expressions2.push(_expsObj);}}else{_expressions2.push(_expsObj);}}expsObj.expressions=_expressions2;}}},{key:'onAnd',value:function onAnd(){this.onAndOr('1');}},{key:'onOr',value:function onOr(){this.onAndOr('0');}},{key:'onAndOr',value:function onAndOr(relation){var _state8=this.state,expsObj=_state8.expsObj,selectedExps=_state8.selectedExps,selectedExpsPKey=_state8.selectedExpsPKey;if(selectedExps&&selectedExps.length){this._onDel(expsObj,selectedExps,selectedExpsPKey,true);var curTime=new Date().getTime();for(var i=0,len=selectedExps.length;i<len;i++){selectedExps[i].parentKey='exps_'+curTime;}var exps={key:'exps_'+curTime,parentKey:selectedExpsPKey,relation:relation,expressions:selectedExps};this._onAndOr(expsObj,selectedExpsPKey,exps);this.setState({expsObj:expsObj,selectedExps:[],selectedExpsPKey:''});}}},{key:'_onAndOr',value:function _onAndOr(expsObj,selectedExpsPKey,exps){var key=expsObj.key,_expsObj$expressions3=expsObj.expressions,expressions=_expsObj$expressions3===undefined?[]:_expsObj$expressions3;if(key==selectedExpsPKey){expressions.push(exps);expsObj.expressions=expressions;}else{for(var i=0,len=expressions.length;i<len;i++){var _expsObj=expressions[i];if(_expsObj.expressions){this._onAndOr(_expsObj,selectedExpsPKey,exps);}}}}},{key:'onSplit',value:function onSplit(){var _state9=this.state,expsObj=_state9.expsObj,selectedExps=_state9.selectedExps,selectedExpsPKey=_state9.selectedExpsPKey;for(var i=0,len=selectedExps.length;i<len;i++){var _selectedExps$i=selectedExps[i],key=_selectedExps$i.key,expressions=_selectedExps$i.expressions;if(expressions&&expressions.length){for(var j=0,len2=expressions.length;j<len2;j++){expressions[j].parentKey=selectedExpsPKey;}this._onSplit(expsObj,key,expressions);}}this.setState({expsObj:expsObj,selectedExps:[],selectedExpsPKey:''});}},{key:'_onSplit',value:function _onSplit(expsObj,selectedExpsKey,exps){var _expsObj$expressions4=expsObj.expressions,expressions=_expsObj$expressions4===undefined?[]:_expsObj$expressions4;for(var i=0,len=expressions.length;i<len;i++){if(expressions[i].key==selectedExpsKey){expressions.splice.apply(expressions,[i,1].concat((0,_toConsumableArray3.default)(exps)));break;}else if(expressions[i].expressions){this._onSplit(expressions[i],selectedExpsKey,exps);}}}}]);return SynergySetting4Designer;}(_react2.default.Component);exports.default=SynergySetting4Designer;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素数据来源，排序字段
var Content_8_DataSource_OrderCol=function(_React$Component){(0,_inherits3.default)(Content_8_DataSource_OrderCol,_React$Component);function Content_8_DataSource_OrderCol(props){(0,_classCallCheck3.default)(this,Content_8_DataSource_OrderCol);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_8_DataSource_OrderCol.__proto__||(0,_getPrototypeOf2.default)(Content_8_DataSource_OrderCol)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onOrderTypeChange=_this.onOrderTypeChange.bind(_this);_this.state={visible:true,orderColDataSource:props.orderColDataSource||[],orderColUsedKeys:props.orderColUsedKeys||[]};return _this;}(0,_createClass3.default)(Content_8_DataSource_OrderCol,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,orderColDataSource=_state.orderColDataSource,orderColUsedKeys=_state.orderColUsedKeys;return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(386541,'排序字段设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:500,height:312},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTransfer,{height:300,data:orderColDataSource,selectedKeys:orderColUsedKeys,renderItem:function renderItem(item){if(item.orderType=='')item.orderType='0';var orderTypeComp=_react2.default.createElement('div',null);if(orderColUsedKeys.indexOf(item.key)!=-1){orderTypeComp=_react2.default.createElement('span',{style:{float:'right',cursor:'pointer'},onClick:function onClick(e){return _this2.onOrderTypeChange(e,item);},onDoubleClick:function onDoubleClick(e){return e.stopPropagation();}},item.orderType=='0'?getLabel(340,'降序'):getLabel(339,'升序'));}return _react2.default.createElement('div',{style:{height:'37px',lineHeight:'37px',padding:'0 15px',borderBottom:'1px solid #e2e2e2'},title:item.fieldName},_react2.default.createElement('span',null,item.fieldName),orderTypeComp);},onChange:function onChange(keys){return _this2.setState({orderColUsedKeys:keys});}}));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'onOrderTypeChange',value:function onOrderTypeChange(e,item){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();var ds=this.state.orderColDataSource;for(var i=0,len=ds.length;i<len;i++){if(ds[i].key==item.key){ds[i].orderType=ds[i].orderType=='0'?'1':'0';}}this.setState({orderColDataSource:ds});}}]);return Content_8_DataSource_OrderCol;}(_react2.default.Component);exports.default=Content_8_DataSource_OrderCol;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _antd=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 缩略图设置
var ELinkMode=function(_React$Component){(0,_inherits3.default)(ELinkMode,_React$Component);function ELinkMode(){(0,_classCallCheck3.default)(this,ELinkMode);return(0,_possibleConstructorReturn3.default)(this,(ELinkMode.__proto__||(0,_getPrototypeOf2.default)(ELinkMode)).apply(this,arguments));}(0,_createClass3.default)(ELinkMode,[{key:'render',value:function render(){var _props=this.props,pictureWidth=_props.pictureWidth,pictureHeight=_props.pictureHeight,widthUnit=_props.widthUnit,heightUnit=_props.heightUnit,autoHeight=_props.autoHeight,authoHeight=_props.authoHeight,onChangeSize=_props.onChangeSize;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386551,'缩略图设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{style:{lineHeight:'29px'}},_react2.default.createElement('li',{style:{display:'inline-block'}},_react2.default.createElement('span',null,_react2.default.createElement('span',null,_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:pictureWidth,style:{width:'40px',marginRight:'8px',marginBottom:'4px'},onChange:function onChange(value){return onChangeSize('pictureWidth',value);}}),_react2.default.createElement(_ecCom.WeaSelect,{className:'portal-news-picture',value:widthUnit=='px'?'1':'2',onChange:function onChange(value){return onChangeSize('widthUnit',value=='1'?'px':'%');},options:[{key:"1",selected:true,showname:"px"},{key:"2",selected:false,showname:"%"}],style:{width:'50px',marginRight:'8px',marginBottom:'4px'}})),autoHeight?'':_react2.default.createElement('span',{style:{marginLeft:'12px'}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:pictureHeight,style:{width:'40px',marginRight:'8px',marginBottom:'4px'},onChange:function onChange(value){return onChangeSize('pictureHeight',value);}}),_react2.default.createElement(_ecCom.WeaSelect,{className:'portal-news-picture',value:heightUnit=='px'?'1':'2',onChange:function onChange(value){return onChangeSize('heightUnit',value=='1'?'px':'%');},options:[{key:"1",selected:true,showname:"px"},{key:"2",selected:false,showname:"%"}],style:{width:'50px',marginRight:'8px',marginBottom:'4px'}})),_react2.default.createElement(_antd.Checkbox,{className:authoHeight,style:{marginLeft:'0px'},checked:autoHeight,onChange:function onChange(e){return onChangeSize('autoHeight',e.target.checked);}},getLabel(22494,'自适应高度'))))));}}]);return ELinkMode;}(_react2.default.Component);exports.default=ELinkMode;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_103__;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 滚动方向
var EScrollDirection=function(_React$Component){(0,_inherits3.default)(EScrollDirection,_React$Component);function EScrollDirection(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EScrollDirection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EScrollDirection.__proto__||(0,_getPrototypeOf2.default)(EScrollDirection)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EScrollDirection,[{key:'render',value:function render(){var _this2=this;var _onChange=this.props.onChange;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.value,style:{width:'100px'},onChange:function onChange(value){_this2.setState({value:value});if(_onChange&&typeof _onChange=='function'){_onChange(value);}}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return EScrollDirection;}(_react2.default.Component);exports.default=EScrollDirection;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 新闻模板
var ENewsMould=function(_React$Component){(0,_inherits3.default)(ENewsMould,_React$Component);function ENewsMould(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ENewsMould);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ENewsMould.__proto__||(0,_getPrototypeOf2.default)(ENewsMould)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ENewsMould,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23088,'新闻模板'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.value,style:{width:'100px'},onChange:function onChange(value){_this2.setState({value:value});}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return ENewsMould;}(_react2.default.Component);exports.default=ENewsMould;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(292), __esModule: true };

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_107__;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends6=__webpack_require__(8);var _extends7=_interopRequireDefault(_extends6);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 显示字段
var EField=function(_React$Component){(0,_inherits3.default)(EField,_React$Component);function EField(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EField.__proto__||(0,_getPrototypeOf2.default)(EField)).call.apply(_ref,[this].concat(args))),_this),_this.state={eField:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EField,[{key:'render',value:function render(){var _this2=this;var eField=this.state.eField;var eFieldList=[];var _loop=function _loop(key){if(eField.hasOwnProperty(key)){eFieldList.push(_react2.default.createElement('li',{style:{display:'inline-block'}},_react2.default.createElement(_antd.Checkbox,{checked:eField[key].checked,onChange:function onChange(e){_this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{checked:e.target.checked})))});}},eField[key].label),_this2.props.eShareLevel=='2'&&eField[key].type=='image'?_react2.default.createElement('span',null,_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eField[key].width,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{width:value})))});}}),!eField[key].autoHeight?_react2.default.createElement('span',null,_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eField[key].height,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{height:value})))});}})):'',_react2.default.createElement(_antd.Checkbox,{checked:eField[key].autoHeight,onChange:function onChange(e){return _this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{autoHeight:e.target.checked})))});}},getLabel(22494,'自适应高度'))):''));}};for(var key in eField){_loop(key);}return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{style:{lineHeight:'29px'}},eFieldList));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.eField;}}]);return EField;}(_react2.default.Component);exports.default=EField;

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveIndex;
/* unused harmony export getActiveKey */
/* unused harmony export setTransform */
/* unused harmony export isTransform3dSupported */
/* unused harmony export setTransition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransformPropValue;
/* unused harmony export isVertical */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransformByIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMarginStyle;
/* unused harmony export getStyle */
/* unused harmony export setPxStyle */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataAttr;
/* unused harmony export getLeft */
/* unused harmony export getTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransform3dSupported(style) {
  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}

function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ltr';

  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';

  if (!isVertical(tabBarPosition) && direction === 'rtl') {
    return translate + '(' + index * 100 + '%) translateZ(0)';
  }
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, 'padding-' + start);
  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;

  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, 'margin-' + start);
      total += node[current];
      total += toNum(style, 'margin-' + end);

      if (style.boxSizing === 'content-box') {
        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
      }
      return false;
    }

    // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
    total += toNum(style, 'margin-' + start);

    return true;
  });

  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}

function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(485);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_114__;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_115__;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(162);__webpack_require__(163);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(50);
var $export = __webpack_require__(29);
var redefine = __webpack_require__(118);
var hide = __webpack_require__(40);
var Iterators = __webpack_require__(54);
var $iterCreate = __webpack_require__(168);
var setToStringTag = __webpack_require__(94);
var getPrototypeOf = __webpack_require__(119);
var ITERATOR = __webpack_require__(31)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(34);
var toObject = __webpack_require__(41);
var IE_PROTO = __webpack_require__(60)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(73);
var hiddenKeys = __webpack_require__(62).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(52);
var createDesc = __webpack_require__(43);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(57);
var has = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(71);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(29);
var core = __webpack_require__(20);
var fails = __webpack_require__(30);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(186), __esModule: true };

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _HpBaseElement=__webpack_require__(125);var _HpBaseElement2=_interopRequireDefault(_HpBaseElement);var _Homepage=__webpack_require__(70);var _Homepage2=_interopRequireDefault(_Homepage);var _PortalMenu=__webpack_require__(195);var _PortalMenu2=_interopRequireDefault(_PortalMenu);var _rcmenu=__webpack_require__(77);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=_antd.Menu.Item;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var PortalSetting=function(_React$Component){(0,_inherits3.default)(PortalSetting,_React$Component);function PortalSetting(props){(0,_classCallCheck3.default)(this,PortalSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(PortalSetting.__proto__||(0,_getPrototypeOf2.default)(PortalSetting)).call(this,props));_this.state={params:{},visible:false,loading:false,title:getLabel(19650,'设置元素'),data:{portalinfo:{},hpbaseelements:[],hpsettingmenu:[],rcmenu:[]},showLeft:true,portalmenu:{},showDrop:false,isShrink:false};_this.onChangeLabel=_this.onChangeLabel.bind(_this);_this.onShowDrop=_this.onShowDrop.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.handleOnSetting=_this.handleOnSetting.bind(_this);_this.handleCancel=_this.handleCancel.bind(_this);_this.handleRefreshPortal=_this.handleRefreshPortal.bind(_this);_this.handleAddElementToPortalStart=_this.handleAddElementToPortalStart.bind(_this);_this.handleAddElementToPortal=_this.handleAddElementToPortal.bind(_this);return _this;}(0,_createClass3.default)(PortalSetting,[{key:'onShowDrop',value:function onShowDrop(){this.setState({showDrop:!this.state.showDrop});}},{key:'getButtons',value:function getButtons(){var _this2=this;var isRedirectUrl='0';if(this.state.data.portalinfo){isRedirectUrl=this.state.data.portalinfo.isRedirectUrl;}var btns=[];if(isRedirectUrl!='1'){var hpsettingmenu=this.state.data.hpsettingmenu;if(hpsettingmenu&&hpsettingmenu.length){hpsettingmenu.map(function(menu,i){if(menu.key=='more'){btns.push(_react2.default.createElement(OperateMenu,{dropMenuDatas:_this2.getRightMenu(),onShowDrop:_this2.onShowDrop,onDropMenuClick:_this2.onRightMenuClick,showDrop:_this2.state.showDrop},_react2.default.createElement(_antd.Button,{onClick:_this2.onShowDrop},menu.label)));}else{btns.push(_react2.default.createElement(_antd.Button,{type:i===4?'':'primary',onClick:_this2.onRightMenuClick.bind(_this2,menu.key)},menu.label));}});}else{btns.push(_react2.default.createElement(_ecCom.WeaMoreButton,{datas:[]}));}}return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];var isRedirectUrl='0';if(this.state.data.portalinfo){isRedirectUrl=this.state.data.portalinfo.isRedirectUrl;}if(isRedirectUrl!='1'){var rcmenu=this.state.data.rcmenu;if(rcmenu){rcmenu.map(function(menu){btns.push({key:menu.key,icon:_react2.default.createElement('i',{className:menu.icon}),content:menu.label});});}}return btns;}},{key:'onChangeLabel',value:function onChangeLabel(list,key,bool,label1,lable2){for(var i=0;i<list.length;i++){var item=list[i]||{};if(item.key==key){if(bool){item.label=label1;if(item.label=="全部收缩"){item.icon="icon-coms-All-contraction";}if(item.label=="显示元素库"){item.icon="icon-coms-display";}}else{item.label=lable2;if(item.label=="全部展开"){item.icon="icon-coms-All-unfolding";}if(item.label=="隐藏元素库"){item.icon="icon-coms-hide";}}break;}}}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var _state=this.state,params=_state.params,showLeft=_state.showLeft,isShrink=_state.isShrink,data=_state.data;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;switch(key){case'updatesynihp':case'completesynihp':(0,_rcmenu.handlePortalSynize)({hpid:hpid,subCompanyId:subCompanyId,method:key});break;case'shrinkAll':this.setState({isShrink:!isShrink});this.onChangeLabel(data.rcmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(16216,'全部展开'));this.onChangeLabel(data.hpsettingmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(16216,'全部展开'));(0,_rcmenu.onShowOrHideAllE)(isSetting);break;case'store':(0,_rcmenu.openFavouriteBrowser)();break;case'help':(0,_rcmenu.showHelp)();break;case'hiddenElementLib':this.setState({showLeft:!showLeft});this.onChangeLabel(data.rcmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));this.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));break;}}},{key:'handleOnSetting',value:function handleOnSetting(params){var _this3=this;this.setState({visible:true,loading:true});var title=params.title||'';if(params.viewtype==='priview'){_ecCom.WeaTools.callApi('/api/portal/hpsetting/hpsettinginfo','POST',params).then(function(result){if(result.status=='2'){_antd.message.error(result.errormsg);return;}if(params.module==='mainpage'){_ecCom.WeaTools.callApi('/api/portal/hpsetting/portalmenu','POST',{hpid:params.hpid}).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);return;}window.isPortalRender=true;_this3.setState({params:params,loading:false,portalmenu:data,data:{hpbaseelements:[],hpsettingmenu:[],rcmenu:[],portalinfo:result.portalinfo},title:title?title+' - '+getLabel(221,'预览'):getLabel(221,'预览')});});}else{_this3.setState({params:params,loading:false,data:{hpbaseelements:[],hpsettingmenu:[],rcmenu:[],portalinfo:result.portalinfo},portalmenu:{},title:title?title+' - '+getLabel(221,'预览'):getLabel(221,'预览')});}});}else{_ecCom.WeaTools.callApi('/api/portal/hpsetting/hpsettinginfo','POST',params).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);return;}window.isPortalRender=true;_this3.setState({params:params,loading:false,data:data,portalmenu:{},title:title?title+' - '+getLabel(19650,'设置元素'):getLabel(19650,'设置元素')});});}}},{key:'handleCancel',value:function handleCancel(){this.setState({visible:false});}},{key:'handleRefreshPortal',value:function handleRefreshPortal(params){if(this.refs.homepage)this.refs.homepage.handleRefresh(params);}},{key:'handleAddElementToPortalStart',value:function handleAddElementToPortalStart(){this.setState({loading:true});}},{key:'handleAddElementToPortal',value:function handleAddElementToPortal(element,areaflag,index){this.setState({loading:false});window.isPortalRender=true;this.refs.homepage.handleAddElement(element,areaflag,index);}},{key:'componentDidMount',value:function componentDidMount(){window.handlePortalSetting=this.handleOnSetting.bind(this);}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,params=_state2.params,title=_state2.title,visible=_state2.visible,loading=_state2.loading,data=_state2.data,portalmenu=_state2.portalmenu,showLeft=_state2.showLeft;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting,viewtype=params.viewtype,module=params.module;var portalinfo=data.portalinfo;var html=_react2.default.createElement('div',null);if(hpid){if(portalinfo.isRedirectUrl=='1'){html=_react2.default.createElement('iframe',{frameBorder:'no',className:'custompageIframe',src:portalinfo.redirectUrl,style:{borderCollapse:'collapse',width:'100%',height:'100%'}});}else{html=_react2.default.createElement('div',{id:'e9PortalSetting',className:'portal-e9setting'},_react2.default.createElement(_Homepage2.default,(0,_extends3.default)({},params,{ref:'homepage'})));if(viewtype!=='priview'){html=visible&&_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement(_ecCom.WeaLeftRightLayout,{isNew:true,showLeft:showLeft,leftWidth:150,leftCom:_react2.default.createElement(_HpBaseElement2.default,{handleRefreshPortal:this.handleRefreshPortal,handleAddStart:this.handleAddElementToPortalStart,handleAdd:this.handleAddElementToPortal,params:params,list:data.hpbaseelements}),onCollapse:function onCollapse(bool){_this4.setState({showLeft:bool});_this4.onChangeLabel(data.rcmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel('19613',"显示元素库"));_this4.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel('19613',"显示元素库"));}},html));}}}return _react2.default.createElement(_ecCom.WeaDialog,{title:title,visible:visible,scalable:true,loading:loading,closable:true,onCancel:this.handleCancel,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:document.body.clientWidth-100,height:document.body.clientHeight-180},zIndex:800},module==='mainpage'?_react2.default.createElement(_PortalMenu2.default,{hpid:hpid,subCompanyId:subCompanyId,portalmenu:portalmenu,handleRefresh:this.handleRefreshPortal}):'',html);}}]);return PortalSetting;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);PortalSetting=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(PortalSetting);exports.default=PortalSetting;var OperateMenu=function(_React$Component3){(0,_inherits3.default)(OperateMenu,_React$Component3);function OperateMenu(){(0,_classCallCheck3.default)(this,OperateMenu);return(0,_possibleConstructorReturn3.default)(this,(OperateMenu.__proto__||(0,_getPrototypeOf2.default)(OperateMenu)).apply(this,arguments));}(0,_createClass3.default)(OperateMenu,[{key:'render',value:function render(){var _props=this.props,dropMenuDatas=_props.dropMenuDatas,onDropMenuClick=_props.onDropMenuClick,onShowDrop=_props.onShowDrop,showDrop=_props.showDrop,children=_props.children;var menu=dropMenuDatas?_react2.default.createElement(_antd.Menu,{mode:'vertical',onClick:function onClick(o){if(typeof onDropMenuClick==='function')onDropMenuClick(o.key);dropMenuDatas.forEach(function(d){if(d.key===o.key&&typeof d.onClick==='function')d.onClick(o.key);});}},dropMenuDatas.map(function(d,i){return _react2.default.createElement(Item,{key:d.key||i,disabled:d.disabled},_react2.default.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return _react2.default.createElement('div',{className:'portal-portalsetting-moremenu-pop'},_react2.default.createElement('div',{className:'wea-new-top-drop-menu wea-right-menu',style:{display:showDrop?'block':'none'},onMouseLeave:onShowDrop},_react2.default.createElement('div',{className:'wea-right-menu-icon-background'}),menu),children);}}]);return OperateMenu;}(_react2.default.Component);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _rcmenu=__webpack_require__(77);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HpBaseElement=function(_React$Component){(0,_inherits3.default)(HpBaseElement,_React$Component);function HpBaseElement(props){(0,_classCallCheck3.default)(this,HpBaseElement);var _this=(0,_possibleConstructorReturn3.default)(this,(HpBaseElement.__proto__||(0,_getPrototypeOf2.default)(HpBaseElement)).call(this,props));_this.state={value:'',addFinish:true};_this.handleOnShow=_this.handleOnShow.bind(_this);_this.handleAddElement=_this.handleAddElement.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.handleOnSearch=_this.handleOnSearch.bind(_this);_this.onSave=_this.onSave.bind(_this);return _this;}(0,_createClass3.default)(HpBaseElement,[{key:'handleOnShow',value:function handleOnShow(){this.refs.ElementTemplate.onShow();}},{key:'handleAddElement',value:function handleAddElement(ebaseid){var _this2=this;var areaflag=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'A';var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;if(!this.state.addFinish)return;if($("#e9PortalSetting").find(".item").length===10){_antd.Modal.confirm({title:getLabel(15172,"系统提示"),content:getLabel(84090,"继续添加会影响页面性能，还要继续吗？"),onOk:function onOk(){_this2.onAdd(ebaseid,areaflag,index);}});}else{this.onAdd(ebaseid,areaflag,index);}}},{key:'onAdd',value:function onAdd(ebaseid,areaflag,index){var _this3=this;var _props=this.props,params=_props.params,handleAddStart=_props.handleAddStart,handleAdd=_props.handleAdd;var hpid=params.hpid,isSetting=params.isSetting;params.ebaseid=ebaseid;params.areaflag=areaflag;params.index=index;this.setState({addFinish:false});handleAddStart();_ecCom.WeaTools.callApi('/api/portal/hpbaseelement/addElement','POST',params).then(function(data){if(data.status==='2'){_antd.message.error(data.errormsg,2);}else{_this3.setState({addFinish:true});try{handleAdd(data,areaflag,index);}catch(e){window.console?console.log(getLabel(387990,"添加元素后刷新门户异常："),e):alert(getLabel(387990,"添加元素后刷新门户异常：")+e);}}});}},{key:'handleOnSearch',value:function handleOnSearch(value){this.setState({value:value});}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,isSynergySetting=_props2.isSynergySetting,list=_props2.list,params=_props2.params,handleRefreshPortal=_props2.handleRefreshPortal;var hpid=params.hpid,subCompanyId=params.subCompanyId;var pageType=subCompanyId=='-1'||subCompanyId==''?'1':'2';var value=this.state.value;//特殊处理抽藏元素（zang）多音字
if(value=='sc')value='sz';else if(value=='scy')value='szy';else if(value=='scys')value='szys';var htmlArr=new Array();list.map(function(item){if(value&&item.title.toLowerCase().indexOf(value.toLowerCase())==-1&&item.id.toLowerCase()!==value.toLowerCase()&&item.pinyin.toLowerCase().indexOf(value.toLowerCase())==-1){return;}htmlArr.push(_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-item',title:item.title,onMouseDown:_rcmenu.dragBaseElement.bind(_this4,item.id,_this4.handleAddElement)},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-icon'},_react2.default.createElement('img',{src:item.icon,alt:'',onError:function onError(e){return e.target.src='/spa/portal/images/icon-element.png';}})),_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-name'},_react2.default.createElement('span',{onClick:_this4.handleAddElement.bind(_this4,item.id,'A',0)},item.title))));});return _react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement'},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-addElement'},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-search',style:{width:isSynergySetting?'140px':'110px'}},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearchChange:this.handleOnSearch})),!isSynergySetting?_react2.default.createElement(_ecCom.WeaBrowser,{tabs:[{name:getLabel(387984,"已有元素"),key:'1',dataParams:{sourcetype:'1',pageType:pageType},conditionDataParams:{sourcetype:'1',pageType:pageType}},{name:getLabel(386539,'元素模板'),key:'2',selected:true,dataParams:{sourcetype:'2',pageType:pageType},conditionDataParams:{sourcetype:'2',pageType:pageType}}],type:'element',inputStyle:{width:'373px',marginLeft:'15px'},title:getLabel(386382,"请选择"),isSingle:false,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',customized:true,onChange:this.onSave},_react2.default.createElement(_antd.Tooltip,{placement:'right',title:getLabel(32385,"从模板导入")},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-template'},_react2.default.createElement('i',{className:'icon-coms-leading-in'})))):''),_react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'hpbaseelement',height:'100%'},htmlArr));}},{key:'onSave',value:function onSave(ids){var _props3=this.props,params=_props3.params,handleRefreshPortal=_props3.handleRefreshPortal;if(ids!=''){_ecCom.WeaTools.callApi('/api/portal/elementtemplateadd/save','POST',(0,_extends3.default)({areaflag:'A'},params,{ids:ids})).then(function(result){if(status=='2'){_antd.message.error(result.errormsg);return;}_antd.message.success(getLabel(83880,"添加成功！"));handleRefreshPortal();});}}}]);return HpBaseElement;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);HpBaseElement=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(HpBaseElement);exports.default=HpBaseElement;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(53);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(22);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);__webpack_require__(127);var _Tab4Content=__webpack_require__(213);var _Tab4Content2=_interopRequireDefault(_Tab4Content);var _Tab4Style=__webpack_require__(367);var _Tab4Style2=_interopRequireDefault(_Tab4Style);var _Tab4Share=__webpack_require__(369);var _Tab4Share2=_interopRequireDefault(_Tab4Share);var _ElementTemplate=__webpack_require__(370);var _ElementTemplate2=_interopRequireDefault(_ElementTemplate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabPane=_antd.Tabs.TabPane;var ls=_ecCom.WeaTools.ls;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ESetting=function(_React$Component){(0,_inherits3.default)(ESetting,_React$Component);function ESetting(props){(0,_classCallCheck3.default)(this,ESetting);var _this=(0,_possibleConstructorReturn3.default)(this,(ESetting.__proto__||(0,_getPrototypeOf2.default)(ESetting)).call(this,props));_this.state={loading:false};_this.onSave=_this.onSave.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onSaveTemplate=_this.onSaveTemplate.bind(_this);return _this;}(0,_createClass3.default)(ESetting,[{key:'onSaveTemplate',value:function onSaveTemplate(){this.refs.ElementTemplate.onShow();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,isSynergySetting=_props.isSynergySetting,synergyParams=_props.synergyParams;var loading=this.state.loading;var canSaveTemplate=!/^Custom_/.test(data.ebaseid)&&data.eShareLevel=='2'&&!isSynergySetting;return _react2.default.createElement('div',{className:'portal-esetting-container'},_react2.default.createElement(_ElementTemplate2.default,{ref:'ElementTemplate',eid:data.eid,templateTitle:data.eContent.eTitle,onSave:this.onSave}),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_antd.Tabs,{defaultActiveKey:'1',className:'portal-esetting-tabs'},_react2.default.createElement(TabPane,{tab:getLabel(33368,'内容'),key:'1'},_react2.default.createElement(_Tab4Content2.default,(0,_extends3.default)({ref:'tab4Content'},data,{synergyParams:synergyParams}))),_react2.default.createElement(TabPane,{tab:getLabel(1014,'样式'),key:'2'},_react2.default.createElement(_Tab4Style2.default,(0,_extends3.default)({ref:'tab4Style'},data))),_react2.default.createElement(TabPane,{tab:getLabel(119,'共享'),key:'3'},_react2.default.createElement(_Tab4Share2.default,(0,_extends3.default)({ref:'tab4Share'},data)))),_react2.default.createElement('div',{className:'portal-esetting-confirm'},_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.onSave();}},getLabel(30986,'保存')),canSaveTemplate&&_react2.default.createElement(_antd.Button,{type:'primary',style:{marginLeft:'10px'},onClick:this.onSaveTemplate},getLabel(386538,'保存并存为模板')),_react2.default.createElement(_antd.Button,{type:'ghost',style:{marginLeft:'10px'},onClick:this.onCancel},getLabel(31129,'取消')))));}},{key:'onSave',value:function onSave(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fn=arguments[1];var _props2=this.props,data=_props2.data,handleRefresh=_props2.handleRefresh,isSetting=_props2.isSetting,getElementStyle=_props2.getElementStyle;var hpid=data.hpid,subCompanyId=data.subCompanyId,eid=data.eid,ebaseid=data.ebaseid,_data$eStyle=data.eStyle,eStyle=_data$eStyle===undefined?{}:_data$eStyle;var _eStyle$eHeight=eStyle.eHeight,eHeight=_eStyle$eHeight===undefined?'':_eStyle$eHeight;var contentValues=this.refs['tab4Content']?this.refs['tab4Content'].getSaveValues(ebaseid):null;if(!contentValues)return;this.setState({loading:true});// const contentValues = this.refs['tab4Content'] ? this.refs['tab4Content'].getSaveValues(ebaseid) : {};
var styleValues=this.refs['tab4Style']?this.refs['tab4Style'].getSaveValues():{};var shareValues=this.refs['tab4Share']?this.refs['tab4Share'].getSaveValues():{};_ecCom.WeaTools.callApi('/api/portal/setting/saveSetting','POST',{jsonStr:(0,_stringify2.default)((0,_extends3.default)({hpid:hpid,subCompanyId:subCompanyId,eid:eid,ebaseid:ebaseid},contentValues,styleValues,shareValues,params))}).then(function(result){// 刷新元素标题
var name=jQuery('#element_title_name_input_'+eid).val();if(isSetting){// true: 门户设置页面
jQuery('#e9PortalSetting').find('#element_title_name_'+eid).text(name);}else{jQuery('#element_title_name_'+eid).html(name);}// 刷新元素内容
handleRefresh(eid,ebaseid);//刷新元素样式
_ecCom.WeaTools.callApi('/api/portal/setting/getStyle','POST',{hpid:hpid,eid:eid,subCompanyId:subCompanyId,ebaseid:ebaseid}).then(function(result){if(result){var styleStr=result.hpCss.replace(/\"/g,"");if(jQuery('#portal-element-style-'+eid)&&jQuery('#portal-element-style-'+eid).length){jQuery('#portal-element-style-'+eid).html(styleStr);}else{jQuery(jQuery('head')[0]).append('<style id="portal-element-style-'+eid+'" type="text/css">'+styleStr+'</style>');}getElementStyle&&getElementStyle(eid,result.fontSizeMp);}});!(0,_lodash.isEmpty)(styleValues)&&window.portalGetElementStyle({hpid:hpid,isSetting:isSetting,subCompanyId:subCompanyId,isfromportal:1,isfromhp:0});// 卸载设置界面
_reactDom2.default.render(_react2.default.createElement('div',null),$('.homepage[data-isSetting='+_this3.props.isSetting+'] #setting_'+_this3.props.data.eid)[0]);});if(fn&&typeof fn=='function')fn();}},{key:'onCancel',value:function onCancel(){_reactDom2.default.render(_react2.default.createElement('div',null),$('.homepage[data-isSetting='+this.props.isSetting+'] #setting_'+this.props.data.eid)[0]);}}]);return ESetting;}(_react2.default.Component);exports.default=ESetting;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(211);__webpack_require__(212);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(129);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(54);
module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(59);
var TAG = __webpack_require__(31)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(240);var _EChartView=__webpack_require__(241);var _EChartView2=_interopRequireDefault(_EChartView);var _EchartTemplate=__webpack_require__(242);var _EchartTemplate2=_interopRequireDefault(_EchartTemplate);var _options=__webpack_require__(257);var _options2=_interopRequireDefault(_options);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}module.exports={EchartView:_EChartView2.default,EchartTemplate:_EchartTemplate2.default,getEChartOption:_options2.default};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content_imgSlide_img=function(_React$Component){(0,_inherits3.default)(Content_imgSlide_img,_React$Component);function Content_imgSlide_img(){(0,_classCallCheck3.default)(this,Content_imgSlide_img);return(0,_possibleConstructorReturn3.default)(this,(Content_imgSlide_img.__proto__||(0,_getPrototypeOf2.default)(Content_imgSlide_img)).apply(this,arguments));}(0,_createClass3.default)(Content_imgSlide_img,[{key:'render',value:function render(){var _props=this.props,title=_props.title,imgSrc=_props.imgSrc,fontSize=_props.fontSize,showTitle=_props.showTitle;return _react2.default.createElement('div',{style:{padding:'0px',position:'relative',width:'230px'}},_react2.default.createElement('div',{style:{position:'relative',zIndex:1}},_react2.default.createElement('img',{alt:'',src:imgSrc,style:{width:'230px',height:'150px',verticalAlign:'middle'}})),showTitle=='1'?_react2.default.createElement('div',{style:{position:'absolute',bottom:0,zIndex:2,background:'#000',height:'30px',lineHeight:'20px',width:'100%',textAlign:'center',opacity:0.5}}):'',showTitle=='1'?_react2.default.createElement('div',{style:{position:'absolute',zIndex:3,bottom:0,color:'#fff',height:'35px',lineHeight:'35px',textAlign:'center',width:'100%',fontSize:fontSize+'px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},title):'');}}]);return Content_imgSlide_img;}(_react2.default.Component);exports.default=Content_imgSlide_img;

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(332);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LazyRenderBox, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.hiddenClassName || nextProps.visible;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hiddenClassName = _props.hiddenClassName,
          visible = _props.visible,
          props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

      if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(props.children) > 1) {
        if (!visible && hiddenClassName) {
          props.className += ' ' + hiddenClassName;
        }
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', props);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(props.children);
    }
  }]);

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPopupClassNameFromAlign;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = __webpack_require__(66);

var _color2 = _interopRequireDefault(_color);

var _Board = __webpack_require__(350);

var _Board2 = _interopRequireDefault(_Board);

var _Preview = __webpack_require__(351);

var _Preview2 = _interopRequireDefault(_Preview);

var _Ribbon = __webpack_require__(352);

var _Ribbon2 = _interopRequireDefault(_Ribbon);

var _Alpha = __webpack_require__(353);

var _Alpha2 = _interopRequireDefault(_Alpha);

var _Params = __webpack_require__(354);

var _Params2 = _interopRequireDefault(_Params);

var _classnames = __webpack_require__(26);

var _classnames2 = _interopRequireDefault(_classnames);

var _validationColor = __webpack_require__(356);

var _validationColor2 = _interopRequireDefault(_validationColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function noop() {}

var Panel = function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel(props) {
    _classCallCheck(this, Panel);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var alpha = typeof props.alpha === 'undefined' ? props.defaultAlpha : Math.min(props.alpha, props.defaultAlpha);

    var color = new _color2["default"](props.color || props.defaultColor);

    _this.state = {
      color: color,
      alpha: alpha
    };
    return _this;
  }

  Panel.prototype.componentDidMount = function componentDidMount() {
    this.props.onMount(this.ref);
  };

  Panel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.color) {
      var color = new _color2["default"](nextProps.color);
      this.setState({
        color: color
      });
    }
    if (nextProps.alpha !== undefined) {
      this.setState({
        alpha: nextProps.alpha
      });
    }
  };

  /**
   * 响应 alpha 的变更
   * @param  {Number} alpha Range 0~100
   */


  /**
   * color change
   * @param  {Object}  color      tinycolor instance
   * @param  {Boolean} syncParams Sync to <Params />
   */


  Panel.prototype.render = function render() {
    var _cx,
        _this2 = this;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        enableAlpha = _props.enableAlpha;
    var _state = this.state,
        color = _state.color,
        alpha = _state.alpha;


    var wrapClasses = (0, _classnames2["default"])((_cx = {}, _defineProperty(_cx, prefixCls + '-wrap', true), _defineProperty(_cx, prefixCls + '-wrap-has-alpha', enableAlpha), _cx));

    return _react2["default"].createElement(
      'div',
      {
        ref: function ref(_ref) {
          return _this2.ref = _ref;
        },
        className: [prefixCls, this.props.className].join(' '),
        style: this.props.style,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        tabIndex: '0'
      },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-inner' },
        _react2["default"].createElement(_Board2["default"], { rootPrefixCls: prefixCls, color: color, onChange: this.handleChange }),
        _react2["default"].createElement(
          'div',
          { className: wrapClasses },
          _react2["default"].createElement(
            'div',
            { className: prefixCls + '-wrap-ribbon' },
            _react2["default"].createElement(_Ribbon2["default"], { rootPrefixCls: prefixCls, color: color, onChange: this.handleChange })
          ),
          enableAlpha && _react2["default"].createElement(
            'div',
            { className: prefixCls + '-wrap-alpha' },
            _react2["default"].createElement(_Alpha2["default"], {
              rootPrefixCls: prefixCls,
              alpha: alpha,
              color: color,
              onChange: this.handleAlphaChange
            })
          ),
          _react2["default"].createElement(
            'div',
            { className: prefixCls + '-wrap-preview' },
            _react2["default"].createElement(_Preview2["default"], {
              rootPrefixCls: prefixCls,
              alpha: alpha,
              onChange: this.handleChange,
              onInputClick: this.onSystemColorPickerOpen,
              color: color
            })
          )
        ),
        _react2["default"].createElement(
          'div',
          { className: prefixCls + '-wrap', style: { height: 40, marginTop: 6 } },
          _react2["default"].createElement(_Params2["default"], {
            rootPrefixCls: prefixCls,
            color: color,
            alpha: alpha,
            onAlphaChange: this.handleAlphaChange,
            onChange: this.handleChange,
            mode: this.props.mode,
            enableAlpha: this.props.enableAlpha
          })
        )
      )
    );
  };

  return Panel;
}(_react2["default"].Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSystemColorPickerOpen = function (e) {
    // only work with broswer which support color input
    if (e.target.type === 'color') {
      _this3.systemColorPickerOpen = true;
    }
  };

  this.onFocus = function () {
    if (_this3._blurTimer) {
      clearTimeout(_this3._blurTimer);
      _this3._blurTimer = null;
    } else {
      _this3.props.onFocus();
    }
  };

  this.onBlur = function () {
    if (_this3._blurTimer) {
      clearTimeout(_this3._blurTimer);
    }
    _this3._blurTimer = setTimeout(function () {
      // if is system color picker open, then stop run blur
      if (_this3.systemColorPickerOpen) {
        _this3.systemColorPickerOpen = false;
        return;
      }

      _this3.props.onBlur();
    }, 100);
  };

  this.handleAlphaChange = function (alpha) {
    var color = _this3.state.color;

    color.alpha = alpha;

    _this3.setState({
      alpha: alpha,
      color: color
    });
    _this3.props.onChange({
      color: color.toHexString(),
      alpha: alpha
    });
  };

  this.handleChange = function (color) {
    var alpha = _this3.state.alpha;

    color.alpha = alpha;

    _this3.setState({ color: color });
    _this3.props.onChange({
      color: color.toHexString(),
      alpha: color.alpha
    });
  };
};

exports["default"] = Panel;


Panel.propTypes = {
  alpha: _propTypes2["default"].number,
  className: _propTypes2["default"].string,
  color: _validationColor2["default"], // Hex string
  defaultAlpha: _propTypes2["default"].number,
  defaultColor: _validationColor2["default"], // Hex string
  enableAlpha: _propTypes2["default"].bool,
  mode: _propTypes2["default"].oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: _propTypes2["default"].func,
  onChange: _propTypes2["default"].func,
  onFocus: _propTypes2["default"].func,
  onMount: _propTypes2["default"].func,
  prefixCls: _propTypes2["default"].string,
  style: _propTypes2["default"].object
};

Panel.defaultProps = {
  className: '',
  defaultAlpha: 100,
  defaultColor: '#ff0000',
  enableAlpha: true,
  mode: 'RGB',
  onBlur: noop,
  onChange: noop,
  onFocus: noop,
  onMount: noop,
  prefixCls: 'rc-color-picker-panel',
  style: {}
};
module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素设置
var EPortalBrowser=function(_React$Component){(0,_inherits3.default)(EPortalBrowser,_React$Component);function EPortalBrowser(props){(0,_classCallCheck3.default)(this,EPortalBrowser);var _this=(0,_possibleConstructorReturn3.default)(this,(EPortalBrowser.__proto__||(0,_getPrototypeOf2.default)(EPortalBrowser)).call(this,props));_this.state={visible:false,loading:false,value:_this.props.value};_this.getButtons=_this.getButtons.bind(_this);_this.onLoading=_this.onLoading.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onClear=_this.onClear.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onShow=_this.onShow.bind(_this);_this.onChange=_this.onChange.bind(_this);return _this;}(0,_createClass3.default)(EPortalBrowser,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({value:nextProps.value});}},{key:'render',value:function render(){var _props=this.props,type=_props.type,value=_props.value,disabled=_props.disabled,multiCheck=_props.multiCheck,_props$getTooltipCont=_props.getTooltipContainer,getTooltipContainer=_props$getTooltipCont===undefined?function(){return document.body;}:_props$getTooltipCont,isShow=_props.isShow,_props$itemData=_props.itemData,itemData=_props$itemData===undefined?[]:_props$itemData,title=_props.title;var _state=this.state,visible=_state.visible,loading=_state.loading;var displayComp=_react2.default.createElement('div',null);if(type=='button'){displayComp=_react2.default.createElement('div',{onClick:this.onShow},this.props.children);}else{displayComp=_react2.default.createElement(_ecCom.WeaInputSearch,{style:{width:'100%'},value:itemData[value]?itemData[value].name:value,onSearchChange:this.onChange,onSearch:this.onShow});}if(disabled){displayComp=_react2.default.createElement(_ecCom.WeaInput,{value:itemData[value]?itemData[value].name:value,disabled:true});}return _react2.default.createElement('div',null,displayComp,_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:title,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:800,height:489},zIndex:1050,buttons:this.getButtons(),onCancel:this.onCancel,layout:getTooltipContainer()},_react2.default.createElement(PortalBrowserLib,{ref:'ml',multiCheck:multiCheck,onLoading:this.onLoading,isShow:isShow,itemData:itemData,value:value})));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));// buttons.push(<Button type="primary" onClick={this.onClear}>{getLabel(311, '清除')}</Button>);
buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onLoading',value:function onLoading(loading){this.setState({loading:loading});}},{key:'onShow',value:function onShow(){this.setState({visible:true});this.refs['ml']&&this.refs['ml'].setVisible({visible:true});}},{key:'onOk',value:function onOk(){var checkedFiles=this.refs['ml'].getCheckedFiles();if(checkedFiles&&checkedFiles.length||this.state.value){if(checkedFiles&&checkedFiles.length){var id=checkedFiles.map(function(item){return item.id;});var name=checkedFiles.map(function(item){return item.name;});this.onChange(id.join(','),name.join(','),checkedFiles);}else{this.onChange(this.state.value,'',checkedFiles);}this.refs['ml'].setVisible(false);this.setState({visible:false});}else{_antd.message.warning(getLabel(84570,'请选择目标！'));}}},{key:'onClear',value:function onClear(){this.onChange('');this.refs['ml'].setVisible(false);this.setState({visible:false,value:''});}},{key:'onCancel',value:function onCancel(){this.refs['ml'].setVisible(false);this.setState({visible:false});}},{key:'onChange',value:function onChange(value){this.props.onChange(value);}}]);return EPortalBrowser;}(_react2.default.Component);exports.default=EPortalBrowser;var PortalBrowserLib=function(_React$Component2){(0,_inherits3.default)(PortalBrowserLib,_React$Component2);function PortalBrowserLib(props){(0,_classCallCheck3.default)(this,PortalBrowserLib);var _this2=(0,_possibleConstructorReturn3.default)(this,(PortalBrowserLib.__proto__||(0,_getPrototypeOf2.default)(PortalBrowserLib)).call(this,props));_this2.state={visible:true,hasRight:false,checkedFiles:""};_this2.setVisible=_this2.setVisible.bind(_this2);_this2.onCheck=_this2.onCheck.bind(_this2);return _this2;}(0,_createClass3.default)(PortalBrowserLib,[{key:'onCheck',value:function onCheck(file){var _props$multiCheck=this.props.multiCheck,multiCheck=_props$multiCheck===undefined?false:_props$multiCheck;var checkedFiles=this.state.checkedFiles;if(_.findIndex(checkedFiles,function(item){return item.id==file.id;})!=-1){_.remove(checkedFiles,function(item){return item.id==file.id;});}else{if(multiCheck){checkedFiles.push(file);}else{checkedFiles=[file];}}this.setState({checkedFiles:checkedFiles});}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,itemData=_props2.itemData,value=_props2.value;var visible=this.state.visible;var checkedFiles=this.state.checkedFiles;var row=[],col=[];for(var i=0,len=itemData.length;i<len;i++){col.push(itemData[i]);if(i%5==4||i==len-1){row.push(col);col=[];}}if(visible){return _react2.default.createElement('div',{className:'portal-esetting-browser'},_react2.default.createElement('div',{className:'portal-esetting-browser-middle'},row&&row.length?_react2.default.createElement('div',{className:'portal-esetting-browser-table'},row.map(function(row,index){return _react2.default.createElement('ul',{key:index,className:'portal-esetting-browser-tr'},row.map(function(col){var checked=_.findIndex(checkedFiles,function(item){return item.id==col.id;})!=-1;if((0,_lodash.isEmpty)(checkedFiles)){checked=col.id==value;}return _react2.default.createElement('li',{key:col.id,className:'portal-esetting-browser-td'},_react2.default.createElement('div',{className:'portal-esetting-browser-item',style:checked?{border:'1px solid #408de2'}:{}},_react2.default.createElement('div',{className:'portal-esetting-browser-chk',onClick:function onClick(){return _this3.onCheck(col);}},_react2.default.createElement(_antd.Checkbox,{checked:checked}),'\xA0\xA0',col.name),_react2.default.createElement('div',{className:'portal-esetting-browser-preview'},_react2.default.createElement('img',{className:'portal-esetting-browser-img',src:col.filepath,alt:''}))));}));}),_react2.default.createElement('div',{style:{clear:'both'}})):_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据'))));}else{return"";}}},{key:'setVisible',value:function setVisible(visible){this.setState({visible:visible});}},{key:'getCheckedFiles',value:function getCheckedFiles(){return this.state.checkedFiles;}}]);return PortalBrowserLib;}(_react2.default.Component);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sentinel__ = __webpack_require__(143);













var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TabPane, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          id = _props.id,
          className = _props.className,
          destroyInactiveTabPane = _props.destroyInactiveTabPane,
          active = _props.active,
          forceRender = _props.forceRender,
          rootPrefixCls = _props.rootPrefixCls,
          style = _props.style,
          children = _props.children,
          placeholder = _props.placeholder,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);

      this._isActived = this._isActived || active;
      var prefixCls = rootPrefixCls + '-tabpane';
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-inactive', !active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, className), _classnames));
      var isRender = destroyInactiveTabPane ? active : this._isActived;
      var shouldRender = isRender || forceRender;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__Sentinel__["a" /* SentinelConsumer */],
        null,
        function (_ref) {
          var sentinelStart = _ref.sentinelStart,
              sentinelEnd = _ref.sentinelEnd,
              setPanelSentinelStart = _ref.setPanelSentinelStart,
              setPanelSentinelEnd = _ref.setPanelSentinelEnd;

          // Create sentinel
          var panelSentinelStart = void 0;
          var panelSentinelEnd = void 0;
          if (active && shouldRender) {
            panelSentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
              setRef: setPanelSentinelStart,
              prevElement: sentinelStart
            });
            panelSentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
              setRef: setPanelSentinelEnd,
              nextElement: sentinelEnd
            });
          }

          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              style: style,
              role: 'tabpanel',
              'aria-hidden': active ? 'false' : 'true',
              className: cls,
              id: id
            }, Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getDataAttr */])(restProps)),
            panelSentinelStart,
            shouldRender ? children : placeholder,
            panelSentinelEnd
          );
        }
      );
    }
  }]);

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabPane);


TabPane.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

TabPane.defaultProps = {
  placeholder: null
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SentinelProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentinelConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_create_react_context__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_create_react_context__);




/* eslint-disable jsx-a11y/no-noninteractive-tabindex */





var SentinelContext = __WEBPACK_IMPORTED_MODULE_7__ant_design_create_react_context___default()({});
var SentinelProvider = SentinelContext.Provider;
var SentinelConsumer = SentinelContext.Consumer;

var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', position: 'absolute' };

var Sentinel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sentinel, _React$Component);

  function Sentinel() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sentinel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sentinel.__proto__ || Object.getPrototypeOf(Sentinel)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (_ref2) {
      var target = _ref2.target,
          which = _ref2.which,
          shiftKey = _ref2.shiftKey;
      var _this$props = _this.props,
          nextElement = _this$props.nextElement,
          prevElement = _this$props.prevElement;

      if (which !== __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB || document.activeElement !== target) return;

      // Tab next
      if (!shiftKey && nextElement) {
        nextElement.focus();
      }

      // Tab prev
      if (shiftKey && prevElement) {
        prevElement.focus();
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sentinel, [{
    key: 'render',
    value: function render() {
      var setRef = this.props.setRef;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', {
        tabIndex: 0,
        ref: setRef,
        style: sentinelStyle,
        onKeyDown: this.onKeyDown,
        role: 'presentation'
      });
    }
  }]);

  return Sentinel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Sentinel.propTypes = {
  setRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  prevElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  nextElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["c"] = (Sentinel);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isObject = __webpack_require__(80);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(422),
    mapCacheDelete = __webpack_require__(429),
    mapCacheGet = __webpack_require__(431),
    mapCacheHas = __webpack_require__(432),
    mapCacheSet = __webpack_require__(433);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(434),
    arraySome = __webpack_require__(437),
    cacheHas = __webpack_require__(438);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(36),
    stubFalse = __webpack_require__(455);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(457),
    baseUnary = __webpack_require__(458),
    nodeUtil = __webpack_require__(459);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(483);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _NewsType=__webpack_require__(484);var _NewsType2=_interopRequireDefault(_NewsType);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,counts:props.edata.counts,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.canOnclick=_this.canOnclick.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);if(window.element_news_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_news_refresh[props.config.params.eid]=_this.refreshTabData.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.refreshTabData.bind(_this);window.element_news_refresh=obj;}return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillMount',value:function componentWillMount(){this.canOnclick();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,counts:nextProps.edata.counts,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'refreshTabData',value:function refreshTabData(){var currentTab=this.state.currentTab;this.setState({refresh:true});this.handleTabData(currentTab);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var onChangeCanEdit=this.props.onChangeCanEdit;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({currentTab:tabid,refresh:tabid!==currentTab,tabdata:tabdata_local==null?{}:tabdata_local});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=tabdata_local;ls.set('edata-'+params.eid,edata);}}_ecCom.WeaTools.callApi('/api/portal/element/newstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){var _result$docParams=result.docParams,docParams1=_result$docParams===undefined?{}:_result$docParams;var _docParams1$docCatalo=docParams1.docCatalogIds,docCatalogIds1=_docParams1$docCatalo===undefined?[]:_docParams1$docCatalo;if(tabdata_local!=null){var _tabdata_local$docPar=tabdata_local.docParams,docParams=_tabdata_local$docPar===undefined?{}:_tabdata_local$docPar;var _docParams$docCatalog=docParams.docCatalogIds,docCatalogIds=_docParams$docCatalog===undefined?[]:_docParams$docCatalog;if((0,_lodash.isEmpty)(docCatalogIds1)){onChangeCanEdit(false);}else if(!(0,_lodash.isEqual)(docCatalogIds1,docCatalogIds)){_this2.canOnclick(tabid,docCatalogIds1,true);}else{var rightArr=ls.getJSONObj('portal-doc-right');rightArr!=null&&rightArr.map(function(item){if(item!==null&&item.eid==params.eid&&item.tabid==tabid){onChangeCanEdit(item.right);}});}}else{_this2.canOnclick(tabid,docCatalogIds1);}ls.set('tabdata-'+params.eid+'-'+tabid,result);var _result$tabids=result.tabids,tabids=_result$tabids===undefined?[]:_result$tabids,_result$titles=result.titles,titles=_result$titles===undefined?[]:_result$titles,_result$tabsetting=result.tabsetting,tabsetting=_result$tabsetting===undefined?{}:_result$tabsetting;var edata=_this2.props.edata;var counts=edata.counts;if(tabid===_this2.state.currentTab){var currCount="";if(result.data){for(var i=0;i<tabids.length;i++){currCount=tabsetting.count;if(currCount&&currCount.noReadNum){var noReadNum=parseInt(currCount.noReadNum);if(noReadNum>99){noReadNum=99;}if(tabids[i]===currentTab){counts[i].noReadNum=currCount.noReadNum;}}else if(currCount&&currCount.isHaveNoRead){var isHaveNoRead=currCount.isHaveNoRead;if(tabids[i]===currentTab){counts[i].isHaveNoRead=currCount.isHaveNoRead;}}}}_this2.setState({tabdata:result,refresh:false,counts:counts});if(!tabsetting.count.isHaveNoRead||tabsetting.count.isHaveNoRead=='0'){$('.homepage #titleContainer_'+params.eid+' .rc-tabs-nav-container .rc-tabs-nav-wrap .tab2selected').find("div.portal-new-unreadpoint").remove();}if(isremembertab){var _edata=ls.getJSONObj('edata-'+params.eid);if(_edata){_edata.currenttab=tabid;_edata.data=result;ls.set('edata-'+params.eid,_edata);}}}});}},{key:'handleOpen',value:function handleOpen(){var tabdata=this.state.tabdata;var _tabdata$tabsetting=tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{var catalogIdsNew=catalogIds;if(catalogIds.substr(0,1)==','){catalogIdsNew=catalogIds.substr(1);}(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIdsNew,'2');}}},{key:'canOnclick',value:function canOnclick(){var currentTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.state.currentTab;var docCatalogIds1=arguments[1];var bol=arguments[2];var _props=this.props,config=_props.config,edata=_props.edata,onChangeCanEdit=_props.onChangeCanEdit;var _state$tabdata=this.state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata;var data=edata.data;var eid=config.params.eid;var _tabdata$docParams=tabdata.docParams,docParams=_tabdata$docParams===undefined?{}:_tabdata$docParams;var _docParams$docCatalog2=docParams.docCatalogIds,docCatalogIds=_docParams$docCatalog2===undefined?[]:_docParams$docCatalog2;if(docCatalogIds&&docCatalogIds.length>0||docCatalogIds1&&docCatalogIds1.length>0){var rightArr=ls.getJSONObj('portal-doc-right');var params={ids:docCatalogIds.join()};if(docCatalogIds1){params={ids:docCatalogIds1.join()};}if(rightArr==null){if(!this.isTrue){this.isTrue=true;var _self=this;_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);ls.set('portal-doc-right',[{eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right}]);_self.isTrue=false;});}}else{var isHave=false;if(bol){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;rightArr=rightArr.map(function(item){if(item==null){return item;}else if(item.eid==eid&&item.tabid==currentTab){item.right=right;onChangeCanEdit(right);isHave=true;}return item;});ls.set('portal-doc-right',rightArr);});}else{rightArr.map(function(item){if(item!==null&&item.eid==eid&&item.tabid==currentTab){onChangeCanEdit(item.right);isHave=true;return;}});}if(!isHave){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);rightArr.push({eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right});ls.set('portal-doc-right',rightArr);});}}}else{onChangeCanEdit(false);}}},{key:'render',value:function render(){var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh,counts=_state.counts;var _edata$tabids=edata.tabids,tabids=_edata$tabids===undefined?[]:_edata$tabids,_edata$titles=edata.titles,titles=_edata$titles===undefined?[]:_edata$titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var _tabdata$tabsetting2=tabdata.tabsetting,tabsetting=_tabdata$tabsetting2===undefined?{}:_tabdata$tabsetting2,_tabdata$dataColoums=tabdata.dataColoums,dataColoums=_tabdata$dataColoums===undefined?[]:_tabdata$dataColoums;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var fontStyle=config.item.fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;esetting.dataColoums=dataColoums;var cstyle=tabids&&tabids.length>=1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var more='';var tabdata_img={};if(!(0,_lodash.isEmpty)(tabdata)){tabdata_img=_.cloneDeep(tabdata);tabdata_img.tabsetting.imgs=[];}if(tabdata&&tabdata.data){more=tabsetting.more;contentHtml=_react2.default.createElement(_MarqueeCom2.default,{tabdata:!refresh?tabdata:tabdata_img,eid:eid,scolltype:tabsetting.rollDirection,scrollSpeed:tabsetting.scrollSpeed,showModeId:tabsetting.showModeId,ebaseid:ebaseid},_react2.default.createElement(_NewsType2.default,{contentview:contentview,eid:eid,data:!refresh?tabdata:tabdata_img,esetting:esetting}));}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,more:more,counts:counts,isShowSettingShowType:tabsetting.isShowSettingShowType,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,isAlwaysShow:esetting.isAlwaysShow,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(160);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(116);var _Homepage=__webpack_require__(70);var _Homepage2=_interopRequireDefault(_Homepage);var _PortalSetting=__webpack_require__(124);var _PortalSetting2=_interopRequireDefault(_PortalSetting);var _ElementIndie=__webpack_require__(623);var _ElementIndie2=_interopRequireDefault(_ElementIndie);var _Synergy=__webpack_require__(624);var _Synergy2=_interopRequireDefault(_Synergy);var _SynergyPortalSetting=__webpack_require__(626);var _SynergyPortalSetting2=_interopRequireDefault(_SynergyPortalSetting);var _EPortalBrowser=__webpack_require__(141);var _EPortalBrowser2=_interopRequireDefault(_EPortalBrowser);var _reactRouter=__webpack_require__(115);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//协同区门户设置组件
//元素组件
//门户相关
var PortalCom=function PortalCom(props){return React.createElement(_Homepage2.default,props);};//协同区组件
//门户设置
//门户样式
var getLocaleLabel=_ecCom.WeaLocaleProvider.getLocaleLabel.bind(undefined,'portal');var PortalRoute=React.createElement(_reactRouter.Route,{path:'portal',onEnter:getLocaleLabel},React.createElement(_reactRouter.Route,{path:'portal-:hpid-:subCompanyId',component:_Homepage2.default}));module.exports={Route:PortalRoute,store:{},Homepage:_Homepage2.default,PortalSetting:_PortalSetting2.default,ElementIndie:_ElementIndie2.default,Synergy:_Synergy2.default,SynergyPortalSetting:_SynergyPortalSetting2.default,PortalCom:PortalCom,EPortalBrowser:_EPortalBrowser2.default};

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(166), __esModule: true };

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(95);
module.exports = __webpack_require__(96).f('iterator');


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(45);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(93);
var descriptor = __webpack_require__(43);
var setToStringTag = __webpack_require__(94);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(40)(IteratorPrototype, __webpack_require__(31)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var anObject = __webpack_require__(37);
var getKeys = __webpack_require__(44);

module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(27).document;
module.exports = document && document.documentElement;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(172);
var step = __webpack_require__(173);
var Iterators = __webpack_require__(54);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(117)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(175), __esModule: true };

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
module.exports = __webpack_require__(20).Symbol;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(27);
var has = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(28);
var $export = __webpack_require__(29);
var redefine = __webpack_require__(118);
var META = __webpack_require__(177).KEY;
var $fails = __webpack_require__(30);
var shared = __webpack_require__(61);
var setToStringTag = __webpack_require__(94);
var uid = __webpack_require__(51);
var wks = __webpack_require__(31);
var wksExt = __webpack_require__(96);
var wksDefine = __webpack_require__(97);
var enumKeys = __webpack_require__(178);
var isArray = __webpack_require__(179);
var anObject = __webpack_require__(37);
var isObject = __webpack_require__(33);
var toObject = __webpack_require__(41);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(57);
var createDesc = __webpack_require__(43);
var _create = __webpack_require__(93);
var gOPNExt = __webpack_require__(180);
var $GOPD = __webpack_require__(121);
var $GOPS = __webpack_require__(63);
var $DP = __webpack_require__(32);
var $keys = __webpack_require__(44);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(120).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(52).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(50)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(40)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(51)('meta');
var isObject = __webpack_require__(33);
var has = __webpack_require__(34);
var setDesc = __webpack_require__(32).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(30)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(44);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(52);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(59);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(120).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {



/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97)('asyncIterator');


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97)('observable');


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185);
module.exports = __webpack_require__(20).Object.getPrototypeOf;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(41);
var $getPrototypeOf = __webpack_require__(119);

__webpack_require__(122)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(187);
var $Object = __webpack_require__(20).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(189), __esModule: true };

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
module.exports = __webpack_require__(20).Object.setPrototypeOf;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(29);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(191).set });


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(33);
var anObject = __webpack_require__(37);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(56)(Function.call, __webpack_require__(121).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(194);
var $Object = __webpack_require__(20).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(93) });


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SubMenu=_antd.Menu.SubMenu;var MenuItemGroup=_antd.Menu.ItemGroup;var PortalMenu1=function(_React$Component){(0,_inherits3.default)(PortalMenu1,_React$Component);function PortalMenu1(props){(0,_classCallCheck3.default)(this,PortalMenu1);var _this=(0,_possibleConstructorReturn3.default)(this,(PortalMenu1.__proto__||(0,_getPrototypeOf2.default)(PortalMenu1)).call(this,props));_this.state={key:props.hpid+'-'+props.subCompanyId};_this.handleList=_this.handleList.bind(_this);_this.handleClick=_this.handleClick.bind(_this);return _this;}(0,_createClass3.default)(PortalMenu1,[{key:'handleClick',value:function handleClick(_ref){var item=_ref.item,key=_ref.key,keyPath=_ref.keyPath;var handleRefresh=this.props.handleRefresh;if(key){this.setState({key:key});var arr=key.split("-");handleRefresh({hpid:arr[0],subCompanyId:arr[1]});}}},{key:'handleList',value:function handleList(list){var _this2=this;var html=list.map(function(menu){var hpid=menu.hpid,subCompanyId=menu.subCompanyId,name=menu.name,children=menu.children;if(children&&children.length){return _react2.default.createElement(SubMenu,{key:hpid+'-'+subCompanyId,title:name},_this2.handleList(children));}else{return _react2.default.createElement(_antd.Menu.Item,{key:hpid+'-'+subCompanyId},name);}});return html;}},{key:'render',value:function render(){var portalmenu=this.props.portalmenu;var pList=portalmenu.pList;return _react2.default.createElement('div',{className:'portal-portalmenu'},_react2.default.createElement(_antd.Menu,{theme:'dark',selectedKeys:[this.state.key],mode:'horizontal',onClick:this.handleClick},this.handleList(pList)));}}]);return PortalMenu1;}(_react2.default.Component);var PortalMenu=function(_React$Component2){(0,_inherits3.default)(PortalMenu,_React$Component2);function PortalMenu(props){(0,_classCallCheck3.default)(this,PortalMenu);var _this3=(0,_possibleConstructorReturn3.default)(this,(PortalMenu.__proto__||(0,_getPrototypeOf2.default)(PortalMenu)).call(this,props));var num=props.portalmenu.pList.length;var isshow=false;if(120*num>document.body.clientWidth-100){isshow=true;}_this3.state={hpid:props.hpid,isshow:isshow};_this3.handleList=_this3.handleList.bind(_this3);_this3.handleClick=_this3.handleClick.bind(_this3);_this3.handleIconClick=_this3.handleIconClick.bind(_this3);_this3.handleMouseLeave=_this3.handleMouseLeave.bind(_this3);_this3.doScroll=_this3.doScroll.bind(_this3);return _this3;}(0,_createClass3.default)(PortalMenu,[{key:'handleClick',value:function handleClick(hpid,subCompanyId,e){e.stopPropagation();this.setState({hpid:hpid});this.props.handleRefresh({hpid:hpid,subCompanyId:subCompanyId});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.state.hpid!==nextState.hpid;}},{key:'handleIconClick',value:function handleIconClick(hpid,e){e.stopPropagation();$(".portal-portalmenu-menu[data-pid="+hpid+"]").css({display:'inline-block'});}},{key:'handleMouseLeave',value:function handleMouseLeave(pid,hpid,e){if(pid=='0')return;e.stopPropagation();$(".portal-portalmenu-menu[data-hpid="+hpid+"]").css({display:'none'});}},{key:'handleList',value:function handleList(list){var _this4=this;var _pid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'0';var _hpid=this.state.hpid;var html=list.map(function(menu,i){var pid=menu.pid,hpid=menu.hpid,subCompanyId=menu.subCompanyId,name=menu.name,children=menu.children;var style=_pid=='0'?{left:i*120,top:0}:{left:i*120,top:42,display:'none'};var icon='';var sub='';if(children&&children.length){icon=_react2.default.createElement('i',{onClick:_this4.handleIconClick.bind(_this4,hpid),className:'icon-coms-organization-down portal-menu-sub-icon'});sub=_this4.handleList(children,hpid);}return _react2.default.createElement('div',{id:'portalmenu_'+hpid,'data-pid':pid,'data-hpid':hpid,onMouseLeave:_this4.handleMouseLeave.bind(_this4,_pid,hpid),onClick:_this4.handleClick.bind(_this4,hpid,subCompanyId),className:'portal-portalmenu-menu '+(_hpid==hpid?'portal-portalmenu-selected':''),style:style},name,icon,sub);});return html;}},{key:'doScroll',value:function doScroll(type){var pList=this.props.portalmenu.pList;var width=type==='prev'?-120:120;$("#portalMenuContainer").scrollTo({top:'0px',left:$("#portalMenuContainer").get(0).scrollLeft+width+'px'},500);if(type==='prev'){$("#menuNext").css({color:'#FFFFFF',cursor:'pointer'});if($("#portalMenuContainer").get(0).scrollLeft<=120){$("#menuPrev").css({color:'#acacac',cursor:'default'});}}else{$("#menuPrev").css({color:'#FFFFFF',cursor:'pointer'});if($("#portalMenuContainer").get(0).scrollLeft>=pList.length*120+40-document.body.clientWidth+100){$("#menuNext").css({color:'#acacac',cursor:'default'});}}}},{key:'render',value:function render(){var portalmenu=this.props.portalmenu;var isshow=this.state.isshow;var pList=portalmenu.pList;var html=this.handleList(pList);if(isshow){html=_react2.default.createElement('div',{id:'portalMenuContainer',style:{width:document.body.clientWidth-140+'px'},className:'portal-portalmenu-container'},_react2.default.createElement('div',{style:{width:pList.length*120+'px',height:'40px',position:'relative'}},html));}return _react2.default.createElement('div',{className:'portal-portalmenu'},isshow?_react2.default.createElement('div',{id:'menuPrev',className:'portal-portalmenu-nav menu-prev'},_react2.default.createElement(_antd.Icon,{type:'caret-left',onClick:this.doScroll.bind(this,'prev')})):'',html,isshow?_react2.default.createElement('div',{id:'menuNext',className:'portal-portalmenu-nav menu-next'},_react2.default.createElement(_antd.Icon,{type:'caret-right',onClick:this.doScroll.bind(this,'next')})):'');}}]);return PortalMenu;}(_react2.default.Component);module.exports=PortalMenu;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _CustomLayoutFlags=__webpack_require__(197);var _CustomLayoutFlags2=_interopRequireDefault(_CustomLayoutFlags);var _elements=__webpack_require__(98);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LayoutFlags=function(_React$Component){(0,_inherits3.default)(LayoutFlags,_React$Component);function LayoutFlags(){(0,_classCallCheck3.default)(this,LayoutFlags);return(0,_possibleConstructorReturn3.default)(this,(LayoutFlags.__proto__||(0,_getPrototypeOf2.default)(LayoutFlags)).apply(this,arguments));}(0,_createClass3.default)(LayoutFlags,[{key:'render',value:function render(){//定义布局id全局变量
if(this.props.layoutHtml!==undefined){return _react2.default.createElement(_CustomLayoutFlags2.default,this.props);}else{return _react2.default.createElement(CommonLayoutFlags,this.props);}}}]);return LayoutFlags;}(_react2.default.Component);//引入元素组件
var getLabel=_ecCom.WeaLocaleProvider.getLabel;var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);LayoutFlags=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(LayoutFlags);exports.default=LayoutFlags;var CommonLayoutFlags=function(_React$Component3){(0,_inherits3.default)(CommonLayoutFlags,_React$Component3);function CommonLayoutFlags(){(0,_classCallCheck3.default)(this,CommonLayoutFlags);return(0,_possibleConstructorReturn3.default)(this,(CommonLayoutFlags.__proto__||(0,_getPrototypeOf2.default)(CommonLayoutFlags)).apply(this,arguments));}(0,_createClass3.default)(CommonLayoutFlags,[{key:'render',value:function render(){var eHtml=_react2.default.createElement('div',null);var _props=this.props,config=_props.config,layoutid=_props.layoutid,layoutFlags=_props.layoutFlags,layoutHtml=_props.layoutHtml;switch(layoutid){case"1"://一栏布局
case"2"://两栏布局
case"3"://三栏布局
var lfhtml=_react2.default.createElement('td',null);if(layoutFlags&&layoutFlags.length){lfhtml=layoutFlags.map(function(layoutFlag,i){return _react2.default.createElement('td',{width:layoutFlag.areasize,className:'valign'},_react2.default.createElement(GroupDiv,{key:layoutFlag.areaflag,config:(0,_extends3.default)({},config,{layoutid:layoutid}),layoutFlag:layoutFlag}));});}eHtml=_react2.default.createElement('table',{id:'Container'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,lfhtml)));break;case"4"://其他布局1
eHtml=_react2.default.createElement(SYSOtherRowOne,{config:(0,_extends3.default)({},config,{layoutid:layoutid}),layoutFlags:layoutFlags});break;case"5"://其他布局2
eHtml=_react2.default.createElement(SYSOtherRowTwo,{config:(0,_extends3.default)({},config,{layoutid:layoutid}),layoutFlags:layoutFlags});break;default:break;}return _react2.default.createElement('div',null,eHtml);}}]);return CommonLayoutFlags;}(_react2.default.Component);//其他布局1
var SYSOtherRowOne=function(_React$Component4){(0,_inherits3.default)(SYSOtherRowOne,_React$Component4);function SYSOtherRowOne(){(0,_classCallCheck3.default)(this,SYSOtherRowOne);return(0,_possibleConstructorReturn3.default)(this,(SYSOtherRowOne.__proto__||(0,_getPrototypeOf2.default)(SYSOtherRowOne)).apply(this,arguments));}(0,_createClass3.default)(SYSOtherRowOne,[{key:'render',value:function render(){var layoutFlag=new Object();var _props2=this.props,config=_props2.config,layoutFlags=_props2.layoutFlags;layoutFlags.map(function(item){return layoutFlag['flag'+item.areaflag]=item;});var aflag=layoutFlag.flagA;var bflag=layoutFlag.flagB;var cflag=layoutFlag.flagC;var dflag=layoutFlag.flagD;return _react2.default.createElement('table',{id:'Container'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:aflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign',border:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{colspan:'2',className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:aflag.areaflag,layoutFlag:aflag})))),_react2.default.createElement('table',{width:'100%',className:'valign',border:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:cflag.areasize,className:'valign',border:'0'},_react2.default.createElement(GroupDiv,{config:config,key:cflag.areaflag,layoutFlag:cflag})),_react2.default.createElement('td',{width:dflag.areasize,className:'valign',border:'0'},_react2.default.createElement(GroupDiv,{config:config,key:dflag.areaflag,layoutFlag:dflag}))))),_react2.default.createElement('td',{width:bflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign',border:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:bflag.areaflag,layoutFlag:bflag})))))));}}]);return SYSOtherRowOne;}(_react2.default.Component);//其他布局2
var SYSOtherRowTwo=function(_React$Component5){(0,_inherits3.default)(SYSOtherRowTwo,_React$Component5);function SYSOtherRowTwo(){(0,_classCallCheck3.default)(this,SYSOtherRowTwo);return(0,_possibleConstructorReturn3.default)(this,(SYSOtherRowTwo.__proto__||(0,_getPrototypeOf2.default)(SYSOtherRowTwo)).apply(this,arguments));}(0,_createClass3.default)(SYSOtherRowTwo,[{key:'render',value:function render(){var layoutFlag=new Object();var _props3=this.props,config=_props3.config,layoutFlags=_props3.layoutFlags;layoutFlags.map(function(item){return layoutFlag['flag'+item.areaflag]=item;});var aflag=layoutFlag.flagA;var bflag=layoutFlag.flagB;var cflag=layoutFlag.flagC;var dflag=layoutFlag.flagD;return _react2.default.createElement('table',{id:'Container'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:dflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:aflag.areasize,className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:aflag.areaflag,layoutFlag:aflag})),_react2.default.createElement('td',{width:bflag.areasize,className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:bflag.areaflag,layoutFlag:bflag})))),_react2.default.createElement('table',{width:'100%',className:'valign'},_react2.default.createElement('tr',{className:'valign'},_react2.default.createElement('td',{colspan:2,className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:dflag.areaflag,layoutFlag:dflag}))))),_react2.default.createElement('td',{width:cflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:cflag.areaflag,layoutFlag:cflag})))))));}}]);return SYSOtherRowTwo;}(_react2.default.Component);//group Div组件
var GroupDiv=function(_React$Component6){(0,_inherits3.default)(GroupDiv,_React$Component6);function GroupDiv(){(0,_classCallCheck3.default)(this,GroupDiv);return(0,_possibleConstructorReturn3.default)(this,(GroupDiv.__proto__||(0,_getPrototypeOf2.default)(GroupDiv)).apply(this,arguments));}(0,_createClass3.default)(GroupDiv,[{key:'render',value:function render(){var layoutFlag=this.props.layoutFlag;var _config=this.props.config;return _react2.default.createElement('div',{className:'group','data-areaflag':layoutFlag.areaflag},layoutFlag.areaElements.map(function(config){return _react2.default.createElement(_elements.Element,{key:"element-"+config.item.eid,config:(0,_extends3.default)({},config,_config)});}));}}]);return GroupDiv;}(_react2.default.Component);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(22);var _reactDom2=_interopRequireDefault(_reactDom);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _elements=__webpack_require__(98);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//引入元素组件
var CustomLayoutFlags=function(_React$Component){(0,_inherits3.default)(CustomLayoutFlags,_React$Component);function CustomLayoutFlags(){(0,_classCallCheck3.default)(this,CustomLayoutFlags);return(0,_possibleConstructorReturn3.default)(this,(CustomLayoutFlags.__proto__||(0,_getPrototypeOf2.default)(CustomLayoutFlags)).apply(this,arguments));}(0,_createClass3.default)(CustomLayoutFlags,[{key:'renderCustomLayout',//加载自定义布局门户
value:function renderCustomLayout(){var _props=this.props,layoutid=_props.layoutid,layoutFlags=_props.layoutFlags,layoutHtml=_props.layoutHtml;var _config=this.props.config;if(layoutHtml){layoutFlags.map(function(layoutFlag,i){var lhtml=layoutFlag.areaElements.map(function(config){return _react2.default.createElement(_elements.Element,{key:"element-"+config.item.eid,config:(0,_extends3.default)({},config,{layoutid:layoutid},_config)});});var groupdom=$(".homepage[data-issetting="+_config.isSetting+"]").find(".group[areaflag='"+layoutFlag.areaflag+"']")[0]||$(".homepage[data-issetting="+_config.isSetting+"]").find(".group[data-areaflag='"+layoutFlag.areaflag+"']")[0];if(groupdom){var renderdom=groupdom.parentNode;_reactDom2.default.render(_react2.default.createElement('div',{className:'group','data-areaflag':layoutFlag.areaflag},lhtml),renderdom);}});}}},{key:'componentDidMount',value:function componentDidMount(){this.renderCustomLayout();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var prelayoutid=prevProps.layoutid;var _props2=this.props,layoutid=_props2.layoutid,config=_props2.config,layoutFlags=_props2.layoutFlags;if(prevProps.hpid!==this.props.hpid||prelayoutid!==layoutid||config.isRender||!(0,_lodash.isEqual)(prevProps.layoutFlags,layoutFlags)){this.renderCustomLayout();}}},{key:'render',value:function render(){var eHtml=_react2.default.createElement('div',null);var layoutHtml=this.props.layoutHtml;if(layoutHtml){eHtml=_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:layoutHtml}});}return _react2.default.createElement('div',null,eHtml);}}]);return CustomLayoutFlags;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomLayoutFlags=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomLayoutFlags);exports.default=CustomLayoutFlags;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(199);__webpack_require__(200);__webpack_require__(201);__webpack_require__(202);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
jQuery.curCSS=function(elem,name){var ret='0px';var style=elem.style;if(window.getComputedStyle){var computed=window.getComputedStyle(elem,null);if(computed){//getPropertyValue兼容ie9获取filter:Alpha(opacity=50)
ret=computed.getPropertyValue(name)||computed[name];//如果是动态创建的元素，则使用style方法获取样式
if(ret===""&&!jQuery.contains(elem.ownerDocument,elem)){ret=jQuery.style(elem,name);}}}return ret;};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * jCarouselLite - jQuery plugin to navigate images/any content in a carousel style widget.
 * @requires jQuery v1.2 or above
 *
 * http://gmarwaha.com/jquery/jcarousellite/
 *
 * Copyright (c) 2007 Ganeshji Marwaha (gmarwaha.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Version: 1.0.1
 * Note: Requires jquery 1.2 or above from version 1.0.1
 *//**
btnPrev : ��һ�Ű�ť
btnNext : ��һ�Ű�ť
btnGo : ��ǩ���ƣ�Ҳ�����á�1,2,3,4����������
mouseWheel : �Ƿ�֧����껬�ֹ���������ֵ��false / true��Ĭ��Ϊfalse �򿪴�����ҪjQuery UI���֧��
auto : �����Զ����ŵ��ٶȣ�Ĭ���Զ������ǹرյģ���ʽ auto: 800 (Ϊ�����ٶ�)
speed : ����Ч���ٶ�
easing : ����Ч���Ż���������ô���� ��Ҫ�ⲿ���֧��
vertical : ���������������Ϊtrue�����ʾ��ֱ������Ĭ��Ϊfalse
circular : �Ƿ��ظ����ţ��������Ϊfalse�������һ����һ�Ű�ť�͵㲻���ˣ�����һ����һ�Ű�ť�͵㲻��
visible : ����Ĭ����ʾ����li��Ĭ����3��
start : Ч���ӵڼ�����ʼ��Ĭ��Ϊ0
scroll : һ�λ�������li��Ĭ����2
beforeStart : ����ǽӿڣ�ÿ�λ���Ч��ִ��֮ǰִ�е��Զ��庯��
afterEnd : ����ǽӿڣ�ÿ�λ���Ч��ִ��֮��ִ�е��Զ��庯��
 *//**
 * Creates a carousel-style navigation widget for images/any-content from a simple HTML markup.
 *
 * The HTML markup that is used to build the carousel can be as simple as...
 *
 *  <div class="carousel">
 *      <ul>
 *          <li><img src="image/1.jpg" alt="1"></li>
 *          <li><img src="image/2.jpg" alt="2"></li>
 *          <li><img src="image/3.jpg" alt="3"></li>
 *      </ul>
 *  </div>
 *
 * As you can see, this snippet is nothing but a simple div containing an unordered list of images.
 * You don't need any special "class" attribute, or a special "css" file for this plugin.
 * I am using a class attribute just for the sake of explanation here.
 *
 * To navigate the elements of the carousel, you need some kind of navigation buttons.
 * For example, you will need a "previous" button to go backward, and a "next" button to go forward.
 * This need not be part of the carousel "div" itself. It can be any element in your page.
 * Lets assume that the following elements in your document can be used as next, and prev buttons...
 *
 * <button class="prev">&lt;&lt;</button>
 * <button class="next">&gt;&gt;</button>
 *
 * Now, all you need to do is call the carousel component on the div element that represents it, and pass in the
 * navigation buttons as options.
 *
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev"
 * });
 *
 * That's it, you would have now converted your raw div, into a magnificient carousel.
 *
 * There are quite a few other options that you can use to customize it though.
 * Each will be explained with an example below.
 *
 * @param an options object - You can specify all the options shown below as an options object param.
 *
 * @option btnPrev, btnNext : string - no defaults
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev"
 * });
 * @desc Creates a basic carousel. Clicking "btnPrev" navigates backwards and "btnNext" navigates forward.
 *
 * @option btnGo - array - no defaults
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      btnGo: [".0", ".1", ".2"]
 * });
 * @desc If you don't want next and previous buttons for navigation, instead you prefer custom navigation based on
 * the item number within the carousel, you can use this option. Just supply an array of selectors for each element
 * in the carousel. The index of the array represents the index of the element. What i mean is, if the
 * first element in the array is ".0", it means that when the element represented by ".0" is clicked, the carousel
 * will slide to the first element and so on and so forth. This feature is very powerful. For example, i made a tabbed
 * interface out of it by making my navigation elements styled like tabs in css. As the carousel is capable of holding
 * any content, not just images, you can have a very simple tabbed navigation in minutes without using any other plugin.
 * The best part is that, the tab will "slide" based on the provided effect. :-)
 *
 * @option mouseWheel : boolean - default is false
 * @example
 * $(".carousel").jCarouselLite({
 *      mouseWheel: true
 * });
 * @desc The carousel can also be navigated using the mouse wheel interface of a scroll mouse instead of using buttons.
 * To get this feature working, you have to do 2 things. First, you have to include the mouse-wheel plugin from brandon.
 * Second, you will have to set the option "mouseWheel" to true. That's it, now you will be able to navigate your carousel
 * using the mouse wheel. Using buttons and mouseWheel or not mutually exclusive. You can still have buttons for navigation
 * as well. They complement each other. To use both together, just supply the options required for both as shown below.
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      mouseWheel: true
 * });
 *
 * @option auto : number - default is null, meaning autoscroll is disabled by default
 * @example
 * $(".carousel").jCarouselLite({
 *      auto: 800,
 *      speed: 500
 * });
 * @desc You can make your carousel auto-navigate itself by specfying a millisecond value in this option.
 * The value you specify is the amount of time between 2 slides. The default is null, and that disables auto scrolling.
 * Specify this value and magically your carousel will start auto scrolling.
 *
 * @option speed : number - 200 is default
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      speed: 800
 * });
 * @desc Specifying a speed will slow-down or speed-up the sliding speed of your carousel. Try it out with
 * different speeds like 800, 600, 1500 etc. Providing 0, will remove the slide effect.
 *
 * @option easing : string - no easing effects by default.
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      easing: "bounceout"
 * });
 * @desc You can specify any easing effect. Note: You need easing plugin for that. Once specified,
 * the carousel will slide based on the provided easing effect.
 *
 * @option vertical : boolean - default is false
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      vertical: true
 * });
 * @desc Determines the direction of the carousel. true, means the carousel will display vertically. The next and
 * prev buttons will slide the items vertically as well. The default is false, which means that the carousel will
 * display horizontally. The next and prev items will slide the items from left-right in this case.
 *
 * @option circular : boolean - default is true
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      circular: false
 * });
 * @desc Setting it to true enables circular navigation. This means, if you click "next" after you reach the last
 * element, you will automatically slide to the first element and vice versa. If you set circular to false, then
 * if you click on the "next" button after you reach the last element, you will stay in the last element itself
 * and similarly for "previous" button and first element.
 *
 * @option visible : number - default is 3
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      visible: 4
 * });
 * @desc This specifies the number of items visible at all times within the carousel. The default is 3.
 * You are even free to experiment with real numbers. Eg: "3.5" will have 3 items fully visible and the
 * last item half visible. This gives you the effect of showing the user that there are more images to the right.
 *
 * @option start : number - default is 0
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      start: 2
 * });
 * @desc You can specify from which item the carousel should start. Remember, the first item in the carousel
 * has a start of 0, and so on.
 *
 * @option scrool : number - default is 1
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      scroll: 2
 * });
 * @desc The number of items that should scroll/slide when you click the next/prev navigation buttons. By
 * default, only one item is scrolled, but you may set it to any number. Eg: setting it to "2" will scroll
 * 2 items when you click the next or previous buttons.
 *
 * @option beforeStart, afterEnd : function - callbacks
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      beforeStart: function(a) {
 *          alert("Before animation starts:" + a);
 *      },
 *      afterEnd: function(a) {
 *          alert("After animation ends:" + a);
 *      }
 * });
 * @desc If you wanted to do some logic in your page before the slide starts and after the slide ends, you can
 * register these 2 callbacks. The functions will be passed an argument that represents an array of elements that
 * are visible at the time of callback.
 *
 *
 * @cat Plugins/Image Gallery
 * @author Ganeshji Marwaha/ganeshread@gmail.com
 */(function($){// Compliant with jquery.noConflict()
jQuery.fx.prototype.cur=function(force){if(this.elem[this.prop]!=null&&this.elem.style[this.prop]==null)return this.elem[this.prop];var r=parseFloat(jQuery.css(this.elem,this.prop,force));return r?r:parseFloat(jQuery.curCSS(this.elem,this.prop))||0;//&& r > -10000 cacel the limit
};$.fn.jCarouselLite=function(o){o=$.extend({btnPrev:null,btnNext:null,btnGo:null,mouseWheel:false,auto:null,speed:200,easing:null,vertical:false,circular:true,visible:3,start:0,scroll:1,beforeStart:null,afterEnd:null},o||{});return this.each(function(){// Returns the element collection. Chainable.
var running=false,animCss=o.vertical?"top":"left",sizeCss=o.vertical?"height":"width";var div=$(this),ul=$("ul",div),tLi=$("li",ul),tl=tLi.size(),v=o.visible;if(o.circular){ul.prepend(tLi.slice(tl-v-1+1).clone()).append(tLi.slice(0,v).clone());o.start+=v;}var li=$("li",ul),itemLength=li.size(),curr=o.start;div.css("visibility","visible");li.css({overflow:"hidden",float:o.vertical?"none":"left"});ul.css({margin:"0",padding:"0",position:"relative","list-style-type":"none","z-index":"1"});div.css({overflow:"hidden",position:"relative","z-index":"2",left:"0px"});var liSize=o.vertical?height(li):width(li);// Full li size(incl margin)-Used for animation
var ulSize=liSize*itemLength;// size of full ul(total length, not just for the visible items)
var divSize=liSize*v;// size of entire div(total length for just the visible items)
li.css({width:li.width(),height:li.height()});ul.css(sizeCss,ulSize+"px").css(animCss,-(curr*liSize));div.css(sizeCss,divSize+"px");// Width of the DIV. length of visible images
if(o.btnPrev)$(o.btnPrev).click(function(){return go(curr-o.scroll);});if(o.btnNext)$(o.btnNext).click(function(){return go(curr+o.scroll);});if(o.btnGo)$.each(o.btnGo,function(i,val){$(val).click(function(){return go(o.circular?o.visible+i:i);});});if(o.mouseWheel&&div.mousewheel)div.mousewheel(function(e,d){return d>0?go(curr-o.scroll):go(curr+o.scroll);});if(o.auto)setInterval(function(){go(curr+o.scroll);},o.auto+o.speed);function vis(){return li.slice(curr).slice(0,v);};function go(to){if(!running){if(o.beforeStart)o.beforeStart.call(this,vis());if(o.circular){// If circular we are in first or last, then goto the other end
if(to<=o.start-v-1){// If first, then goto last
ul.css(animCss,-((itemLength-v*2)*liSize)+"px");// If "scroll" > 1, then the "to" might not be equal to the condition; it can be lesser depending on the number of elements.
curr=to==o.start-v-1?itemLength-v*2-1:itemLength-v*2-o.scroll;}else if(to>=itemLength-v+1){// If last, then goto first
ul.css(animCss,-(v*liSize)+"px");// If "scroll" > 1, then the "to" might not be equal to the condition; it can be greater depending on the number of elements.
curr=to==itemLength-v+1?v+1:v+o.scroll;}else curr=to;}else{// If non-circular and to points to first or last, we just return.
if(to<0||to>itemLength-v)return;else curr=to;}// If neither overrides it, the curr will still be "to" and we can proceed.
running=true;ul.animate(animCss=="left"?{left:-(curr*liSize)}:{top:-(curr*liSize)},o.speed,o.easing,function(){if(o.afterEnd)o.afterEnd.call(this,vis());running=false;});// Disable buttons when the carousel reaches the last/first, and enable when not
if(!o.circular){$(o.btnPrev+","+o.btnNext).removeClass("disabled");$(curr-o.scroll<0&&o.btnPrev||curr+o.scroll>itemLength-v&&o.btnNext||[]).addClass("disabled");}}return false;};});};function css(el,prop){return parseInt($.css(el[0],prop))||0;};function width(el){return el.length&&el[0].offsetWidth+css(el,'marginLeft')+css(el,'marginRight');};function height(el){return el.length&&el[0].offsetHeight+css(el,'marginTop')+css(el,'marginBottom');};})(jQuery);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * jQuery Cycle Plugin (with Transition Definitions)
 * Examples and documentation at: http://jquery.malsup.com/cycle/
 * Copyright (c) 2007-2010 M. Alsup
 * Version: 2.88 (08-JUN-2010)
 * Dual licensed under the MIT and GPL licenses.
 * http://jquery.malsup.com/license.html
 * Requires: jQuery v1.2.6 or later
 */var slideTimeout={};;(function($){var ver='2.88';// if $.support is not defined (pre jQuery 1.3) add what I need
if($.support==undefined){$.support={opacity:!$.browser.msie};}function debug(s){if($.fn.cycle.debug)log(s);}function log(){if(window.console&&window.console.log)window.console.log('[cycle] '+Array.prototype.join.call(arguments,' '));};// the options arg can be...
//   a number  - indicates an immediate transition should occur to the given slide index
//   a string  - 'pause', 'resume', 'toggle', 'next', 'prev', 'stop', 'destroy' or the name of a transition effect (ie, 'fade', 'zoom', etc)
//   an object - properties to control the slideshow
//
// the arg2 arg can be...
//   the name of an fx (only used in conjunction with a numeric value for 'options')
//   the value true (only used in first arg == 'resume') and indicates
//	 that the resume should occur immediately (not wait for next timeout)
$.fn.cycle=function(options,arg2){var o={s:this.selector,c:this.context};// in 1.3+ we can fix mistakes with the ready state
if(this.length===0&&options!='stop'){if(!$.isReady&&o.s){log('DOM not ready, queuing slideshow');$(function(){$(o.s,o.c).cycle(options,arg2);});return this;}// is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
log('terminating; zero elements found by selector'+($.isReady?'':' (DOM not ready)'));return this;}// iterate the matched nodeset
return this.each(function(){var opts=handleArguments(this,options,arg2);if(opts===false)return;opts.updateActivePagerLink=opts.updateActivePagerLink||$.fn.cycle.updateActivePagerLink;// stop existing slideshow for this container (if there is one)
if(slideTimeout[opts.pager.split(" ")[0].substring(1)])clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=this.cyclePause=0;var $cont=$(this);var $slides=opts.slideExpr?$(opts.slideExpr,this):$cont.children();var els=$slides.get();if(els.length<2){log('terminating; too few slides: '+els.length);return;}var opts2=buildOptions($cont,$slides,els,opts,o);if(opts2===false)return;var startTime=opts2.continuous?10:getTimeout(els[opts2.currSlide],els[opts2.nextSlide],opts2,!opts2.rev);// if it's an auto slideshow, kick it off
if(startTime){startTime+=opts2.delay||0;if(startTime<10)startTime=10;debug('first timeout: '+startTime);slideTimeout[opts.pager.split(" ")[0].substring(1)]=setTimeout(function(){go(els,opts2,0,!opts2.rev&&!opts.backwards);},startTime);}});};// process the args that were passed to the plugin fn
function handleArguments(cont,options,arg2){if(cont.cycleStop==undefined)cont.cycleStop=0;if(options===undefined||options===null)options={};if(options.constructor==String){switch(options){case'destroy':case'stop':var opts=$(cont).data('cycle.opts');if(!opts)return false;cont.cycleStop++;// callbacks look for change
if(slideTimeout[opts.pager.split(" ")[0].substring(1)])clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;$(cont).removeData('cycle.opts');if(options=='destroy')destroy(opts);return false;case'toggle':cont.cyclePause=cont.cyclePause===1?0:1;checkInstantResume(cont.cyclePause,arg2,cont);return false;case'pause':cont.cyclePause=1;return false;case'resume':cont.cyclePause=0;checkInstantResume(false,arg2,cont);return false;case'prev':case'next':var opts=$(cont).data('cycle.opts');if(!opts){log('options not found, "prev/next" ignored');return false;}$.fn.cycle[options](opts);return false;default:options={fx:options};};return options;}else if(options.constructor==Number){// go to the requested slide
var num=options;options=$(cont).data('cycle.opts');if(!options){log('options not found, can not advance slide');return false;}if(num<0||num>=options.elements.length){log('invalid slide index: '+num);return false;}options.nextSlide=num;if(slideTimeout[opts.pager.split(" ")[0].substring(1)]){clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}if(typeof arg2=='string')options.oneTimeFx=arg2;go(options.elements,options,1,num>=options.currSlide);return false;}return options;function checkInstantResume(isPaused,arg2,cont){if(!isPaused&&arg2===true){// resume now!
var options=$(cont).data('cycle.opts');if(!options){log('options not found, can not resume');return false;}if(slideTimeout[opts.pager.split(" ")[0].substring(1)]){clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}go(options.elements,options,1,!opts.rev&&!opts.backwards);}}};function removeFilter(el,opts){if(!$.support.opacity&&opts.cleartype&&el.style.filter){try{el.style.removeAttribute('filter');}catch(smother){}// handle old opera versions
}};// unbind event handlers
function destroy(opts){if(opts.next)$(opts.next).unbind(opts.prevNextEvent);if(opts.prev)$(opts.prev).unbind(opts.prevNextEvent);if(opts.pager||opts.pagerAnchorBuilder)$.each(opts.pagerAnchors||[],function(){this.unbind().remove();});opts.pagerAnchors=null;if(opts.destroy)// callback
opts.destroy(opts);};// one-time initialization
function buildOptions($cont,$slides,els,options,o){// support metadata plugin (v1.0 and v2.0)
var opts=$.extend({},$.fn.cycle.defaults,options||{},$.metadata?$cont.metadata():$.meta?$cont.data():{});if(opts.autostop)opts.countdown=opts.autostopCount||els.length;var cont=$cont[0];$cont.data('cycle.opts',opts);opts.$cont=$cont;opts.stopCount=cont.cycleStop;opts.elements=els;opts.before=opts.before?[opts.before]:[];opts.after=opts.after?[opts.after]:[];opts.after.unshift(function(){opts.busy=0;});// push some after callbacks
if(!$.support.opacity&&opts.cleartype)opts.after.push(function(){removeFilter(this,opts);});if(opts.continuous)opts.after.push(function(){go(els,opts,0,!opts.rev&&!opts.backwards);});saveOriginalOpts(opts);// clearType corrections
if(!$.support.opacity&&opts.cleartype&&!opts.cleartypeNoBg)clearTypeFix($slides);// container requires non-static position so that slides can be position within
if($cont.css('position')=='static')$cont.css('position','relative');if(opts.width)$cont.width(opts.width);if(opts.height&&opts.height!='auto')$cont.height(opts.height);if(opts.startingSlide)opts.startingSlide=parseInt(opts.startingSlide);else if(opts.backwards)opts.startingSlide=els.length-1;// if random, mix up the slide array
if(opts.random){opts.randomMap=[];for(var i=0;i<els.length;i++){opts.randomMap.push(i);}opts.randomMap.sort(function(a,b){return Math.random()-0.5;});opts.randomIndex=1;opts.startingSlide=opts.randomMap[1];}else if(opts.startingSlide>=els.length)opts.startingSlide=0;// catch bogus input
opts.currSlide=opts.startingSlide||0;var first=opts.startingSlide;// set position and zIndex on all the slides
$slides.css({position:'absolute',top:0,left:0}).hide().each(function(i){var z;if(opts.backwards)z=first?i<=first?els.length+(i-first):first-i:els.length-i;else z=first?i>=first?els.length-(i-first):first-i:els.length-i;$(this).css('z-index',z);});// make sure first slide is visible
$(els[first]).css('opacity',1).show();// opacity bit needed to handle restart use case
removeFilter(els[first],opts);// stretch slides
if(opts.fit&&opts.width)$slides.width(opts.width);if(opts.fit&&opts.height&&opts.height!='auto')$slides.height(opts.height);// stretch container
var reshape=opts.containerResize&&!$cont.innerHeight();if(reshape){// do this only if container has no size http://tinyurl.com/da2oa9
var maxw=0,maxh=0;for(var j=0;j<els.length;j++){var $e=$(els[j]),e=$e[0],w=$e.outerWidth(),h=$e.outerHeight();if(!w)w=e.offsetWidth||e.width||$e.attr('width');if(!h)h=e.offsetHeight||e.height||$e.attr('height');maxw=w>maxw?w:maxw;maxh=h>maxh?h:maxh;}if(maxw>0&&maxh>0)$cont.css({width:maxw+'px',height:maxh+'px'});}if(opts.pause)$cont.hover(function(){this.cyclePause++;},function(){this.cyclePause--;});if(supportMultiTransitions(opts)===false)return false;// apparently a lot of people use image slideshows without height/width attributes on the images.
// Cycle 2.50+ requires the sizing info for every slide; this block tries to deal with that.
var requeue=false;options.requeueAttempts=options.requeueAttempts||0;$slides.each(function(){// try to get height/width of each slide
var $el=$(this);this.cycleH=opts.fit&&opts.height?opts.height:$el.height()||this.offsetHeight||this.height||$el.attr('height')||0;this.cycleW=opts.fit&&opts.width?opts.width:$el.width()||this.offsetWidth||this.width||$el.attr('width')||0;if($el.is('img')){// sigh..  sniffing, hacking, shrugging...  this crappy hack tries to account for what browsers do when
// an image is being downloaded and the markup did not include sizing info (height/width attributes);
// there seems to be some "default" sizes used in this situation
var loadingIE=$.browser.msie&&this.cycleW==28&&this.cycleH==30&&!this.complete;var loadingFF=$.browser.mozilla&&this.cycleW==34&&this.cycleH==19&&!this.complete;var loadingOp=$.browser.opera&&(this.cycleW==42&&this.cycleH==19||this.cycleW==37&&this.cycleH==17)&&!this.complete;var loadingOther=this.cycleH==0&&this.cycleW==0&&!this.complete;// don't requeue for images that are still loading but have a valid size
if(loadingIE||loadingFF||loadingOp||loadingOther){if(o.s&&opts.requeueOnImageNotLoaded&&++options.requeueAttempts<100){// track retry count so we don't loop forever
log(options.requeueAttempts,' - img slide not loaded, requeuing slideshow: ',this.src,this.cycleW,this.cycleH);setTimeout(function(){$(o.s,o.c).cycle(options);},opts.requeueTimeout);requeue=true;return false;// break each loop
}else{log('could not determine size of image: '+this.src,this.cycleW,this.cycleH);}}}return true;});if(requeue)return false;opts.cssBefore=opts.cssBefore||{};opts.animIn=opts.animIn||{};opts.animOut=opts.animOut||{};$slides.not(':eq('+first+')').css(opts.cssBefore);if(opts.cssFirst)$($slides[first]).css(opts.cssFirst);if(opts.timeout){opts.timeout=parseInt(opts.timeout);// ensure that timeout and speed settings are sane
if(opts.speed.constructor==String)opts.speed=$.fx.speeds[opts.speed]||parseInt(opts.speed);if(!opts.sync)opts.speed=opts.speed/2;var buffer=opts.fx=='shuffle'?500:250;while(opts.timeout-opts.speed<buffer){// sanitize timeout
opts.timeout+=opts.speed;}}if(opts.easing)opts.easeIn=opts.easeOut=opts.easing;if(!opts.speedIn)opts.speedIn=opts.speed;if(!opts.speedOut)opts.speedOut=opts.speed;opts.slideCount=els.length;opts.currSlide=opts.lastSlide=first;if(opts.random){if(++opts.randomIndex==els.length)opts.randomIndex=0;opts.nextSlide=opts.randomMap[opts.randomIndex];}else if(opts.backwards)opts.nextSlide=opts.startingSlide==0?els.length-1:opts.startingSlide-1;else opts.nextSlide=opts.startingSlide>=els.length-1?0:opts.startingSlide+1;// run transition init fn
if(!opts.multiFx){var init=$.fn.cycle.transitions[opts.fx];if($.isFunction(init))init($cont,$slides,opts);else if(opts.fx!='custom'&&!opts.multiFx){log('unknown transition: '+opts.fx,'; slideshow terminating');return false;}}// fire artificial events
var e0=$slides[first];if(opts.before.length)opts.before[0].apply(e0,[e0,e0,opts,true]);if(opts.after.length>1)opts.after[1].apply(e0,[e0,e0,opts,true]);if(opts.next)$(opts.next).bind(opts.prevNextEvent,function(){return advance(opts,opts.rev?-1:1);});if(opts.prev)$(opts.prev).bind(opts.prevNextEvent,function(){return advance(opts,opts.rev?1:-1);});if(opts.pager||opts.pagerAnchorBuilder)buildPager(els,opts);exposeAddSlide(opts,els);return opts;};// save off original opts so we can restore after clearing state
function saveOriginalOpts(opts){opts.original={before:[],after:[]};opts.original.cssBefore=$.extend({},opts.cssBefore);opts.original.cssAfter=$.extend({},opts.cssAfter);opts.original.animIn=$.extend({},opts.animIn);opts.original.animOut=$.extend({},opts.animOut);$.each(opts.before,function(){opts.original.before.push(this);});$.each(opts.after,function(){opts.original.after.push(this);});};function supportMultiTransitions(opts){var i,tx,txs=$.fn.cycle.transitions;// look for multiple effects
if(opts.fx.indexOf(',')>0){opts.multiFx=true;opts.fxs=opts.fx.replace(/\s*/g,'').split(',');// discard any bogus effect names
for(i=0;i<opts.fxs.length;i++){var fx=opts.fxs[i];tx=txs[fx];if(!tx||!txs.hasOwnProperty(fx)||!$.isFunction(tx)){log('discarding unknown transition: ',fx);opts.fxs.splice(i,1);i--;}}// if we have an empty list then we threw everything away!
if(!opts.fxs.length){log('No valid transitions named; slideshow terminating.');return false;}}else if(opts.fx=='all'){// auto-gen the list of transitions
opts.multiFx=true;opts.fxs=[];for(p in txs){tx=txs[p];if(txs.hasOwnProperty(p)&&$.isFunction(tx))opts.fxs.push(p);}}if(opts.multiFx&&opts.randomizeEffects){// munge the fxs array to make effect selection random
var r1=Math.floor(Math.random()*20)+30;for(i=0;i<r1;i++){var r2=Math.floor(Math.random()*opts.fxs.length);opts.fxs.push(opts.fxs.splice(r2,1)[0]);}debug('randomized fx sequence: ',opts.fxs);}return true;};// provide a mechanism for adding slides after the slideshow has started
function exposeAddSlide(opts,els){opts.addSlide=function(newSlide,prepend){var $s=$(newSlide),s=$s[0];if(!opts.autostopCount)opts.countdown++;els[prepend?'unshift':'push'](s);if(opts.els)opts.els[prepend?'unshift':'push'](s);// shuffle needs this
opts.slideCount=els.length;$s.css('position','absolute');$s[prepend?'prependTo':'appendTo'](opts.$cont);if(prepend){opts.currSlide++;opts.nextSlide++;}if(!$.support.opacity&&opts.cleartype&&!opts.cleartypeNoBg)clearTypeFix($s);if(opts.fit&&opts.width)$s.width(opts.width);if(opts.fit&&opts.height&&opts.height!='auto')$slides.height(opts.height);s.cycleH=opts.fit&&opts.height?opts.height:$s.height();s.cycleW=opts.fit&&opts.width?opts.width:$s.width();$s.css(opts.cssBefore);if(opts.pager||opts.pagerAnchorBuilder)$.fn.cycle.createPagerAnchor(els.length-1,s,$(opts.pager),els,opts);if($.isFunction(opts.onAddSlide))opts.onAddSlide($s);else $s.hide();// default behavior
};}// reset internal state; we do this on every pass in order to support multiple effects
$.fn.cycle.resetState=function(opts,fx){fx=fx||opts.fx;opts.before=[];opts.after=[];opts.cssBefore=$.extend({},opts.original.cssBefore);opts.cssAfter=$.extend({},opts.original.cssAfter);opts.animIn=$.extend({},opts.original.animIn);opts.animOut=$.extend({},opts.original.animOut);opts.fxFn=null;$.each(opts.original.before,function(){opts.before.push(this);});$.each(opts.original.after,function(){opts.after.push(this);});// re-init
var init=$.fn.cycle.transitions[fx];if($.isFunction(init))init(opts.$cont,$(opts.elements),opts);};// this is the main engine fn, it handles the timeouts, callbacks and slide index mgmt
function go(els,opts,manual,fwd){// opts.busy is true if we're in the middle of an animation
if(manual&&opts.busy&&opts.manualTrump){// let manual transitions requests trump active ones
debug('manualTrump in go(), stopping active transition');$(els).stop(true,true);opts.busy=false;}// don't begin another timeout-based transition if there is one active
if(opts.busy){debug('transition active, ignoring new tx request');return;}var p=opts.$cont[0],curr=els[opts.currSlide],next=els[opts.nextSlide];// stop cycling if we have an outstanding stop request
if(p.cycleStop!=opts.stopCount||slideTimeout[opts.pager.split(" ")[0].substring(1)]===0&&!manual)return;// check to see if we should stop cycling based on autostop options
if(!manual&&!p.cyclePause&&!opts.bounce&&(opts.autostop&&--opts.countdown<=0||opts.nowrap&&!opts.random&&opts.nextSlide<opts.currSlide)){if(opts.end)opts.end(opts);return;}// if slideshow is paused, only transition on a manual trigger
var changed=false;if((manual||!p.cyclePause)&&opts.nextSlide!=opts.currSlide){changed=true;var fx=opts.fx;// keep trying to get the slide size if we don't have it yet
curr.cycleH=curr.cycleH||$(curr).height();curr.cycleW=curr.cycleW||$(curr).width();next.cycleH=next.cycleH||$(next).height();next.cycleW=next.cycleW||$(next).width();// support multiple transition types
if(opts.multiFx){if(opts.lastFx==undefined||++opts.lastFx>=opts.fxs.length)opts.lastFx=0;fx=opts.fxs[opts.lastFx];opts.currFx=fx;}// one-time fx overrides apply to:  $('div').cycle(3,'zoom');
if(opts.oneTimeFx){fx=opts.oneTimeFx;opts.oneTimeFx=null;}$.fn.cycle.resetState(opts,fx);// run the before callbacks
if(opts.before.length)$.each(opts.before,function(i,o){if(p.cycleStop!=opts.stopCount)return;o.apply(next,[curr,next,opts,fwd]);});// stage the after callacks
var after=function after(){$.each(opts.after,function(i,o){if(p.cycleStop!=opts.stopCount)return;o.apply(next,[curr,next,opts,fwd]);});};debug('tx firing; currSlide: '+opts.currSlide+'; nextSlide: '+opts.nextSlide);// get ready to perform the transition
opts.busy=1;if(opts.fxFn)// fx function provided?
opts.fxFn(curr,next,opts,after,fwd,manual&&opts.fastOnEvent);else if($.isFunction($.fn.cycle[opts.fx]))// fx plugin ?
$.fn.cycle[opts.fx](curr,next,opts,after,fwd,manual&&opts.fastOnEvent);else $.fn.cycle.custom(curr,next,opts,after,fwd,manual&&opts.fastOnEvent);}if(changed||opts.nextSlide==opts.currSlide){// calculate the next slide
opts.lastSlide=opts.currSlide;if(opts.random){opts.currSlide=opts.nextSlide;if(++opts.randomIndex==els.length)opts.randomIndex=0;opts.nextSlide=opts.randomMap[opts.randomIndex];if(opts.nextSlide==opts.currSlide)opts.nextSlide=opts.currSlide==opts.slideCount-1?0:opts.currSlide+1;}else if(opts.backwards){var roll=opts.nextSlide-1<0;if(roll&&opts.bounce){opts.backwards=!opts.backwards;opts.nextSlide=1;opts.currSlide=0;}else{opts.nextSlide=roll?els.length-1:opts.nextSlide-1;opts.currSlide=roll?0:opts.nextSlide+1;}}else{// sequence
var roll=opts.nextSlide+1==els.length;if(roll&&opts.bounce){opts.backwards=!opts.backwards;opts.nextSlide=els.length-2;opts.currSlide=els.length-1;}else{opts.nextSlide=roll?0:opts.nextSlide+1;opts.currSlide=roll?els.length-1:opts.nextSlide-1;}}}if(changed&&opts.pager)opts.updateActivePagerLink(opts.pager,opts.currSlide,opts.activePagerClass);// stage the next transition
var ms=0;if(opts.timeout&&!opts.continuous)ms=getTimeout(els[opts.currSlide],els[opts.nextSlide],opts,fwd);else if(opts.continuous&&p.cyclePause)// continuous shows work off an after callback, not this timer logic
ms=10;if(ms>0)slideTimeout[opts.pager.split(" ")[0].substring(1)]=setTimeout(function(){go(els,opts,0,!opts.rev&&!opts.backwards);},ms);};// invoked after transition
$.fn.cycle.updateActivePagerLink=function(pager,currSlide,clsName){$(pager).each(function(){$(this).children().removeClass(clsName).eq(currSlide).addClass(clsName);});};// calculate timeout value for current transition
function getTimeout(curr,next,opts,fwd){if(opts.timeoutFn){// call user provided calc fn
var t=opts.timeoutFn.call(curr,curr,next,opts,fwd);while(t-opts.speed<250){// sanitize timeout
t+=opts.speed;}debug('calculated timeout: '+t+'; speed: '+opts.speed);if(t!==false)return t;}return opts.timeout;};// expose next/prev function, caller must pass in state
$.fn.cycle.next=function(opts){advance(opts,opts.rev?-1:1);};$.fn.cycle.prev=function(opts){advance(opts,opts.rev?1:-1);};// advance slide forward or back
function advance(opts,val){var els=opts.elements;var p=opts.$cont[0],timeout=slideTimeout[opts.pager.split(" ")[0].substring(1)];if(timeout){clearTimeout(timeout);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}if(opts.random&&val<0){// move back to the previously display slide
opts.randomIndex--;if(--opts.randomIndex==-2)opts.randomIndex=els.length-2;else if(opts.randomIndex==-1)opts.randomIndex=els.length-1;opts.nextSlide=opts.randomMap[opts.randomIndex];}else if(opts.random){opts.nextSlide=opts.randomMap[opts.randomIndex];}else{opts.nextSlide=opts.currSlide+val;if(opts.nextSlide<0){if(opts.nowrap)return false;opts.nextSlide=els.length-1;}else if(opts.nextSlide>=els.length){if(opts.nowrap)return false;opts.nextSlide=0;}}var cb=opts.onPrevNextEvent||opts.prevNextClick;// prevNextClick is deprecated
if($.isFunction(cb))cb(val>0,opts.nextSlide,els[opts.nextSlide]);go(els,opts,1,val>=0);return false;};function buildPager(els,opts){var $p=$(opts.pager);$.each(els,function(i,o){$.fn.cycle.createPagerAnchor(i,o,$p,els,opts);});opts.updateActivePagerLink(opts.pager,opts.startingSlide,opts.activePagerClass);};$.fn.cycle.createPagerAnchor=function(i,el,$p,els,opts){var a;if($.isFunction(opts.pagerAnchorBuilder)){a=opts.pagerAnchorBuilder(i,el);debug('pagerAnchorBuilder('+i+', el) returned: '+a);}else a='<a href="#">'+(i+1)+'</a>';if(!a)return;var $a=$(a);// don't reparent if anchor is in the dom
if($a.parents('body').length===0){var arr=[];if($p.length>1){$p.each(function(){var $clone=$a.clone(true);$(this).append($clone);arr.push($clone[0]);});$a=$(arr);}else{$a.appendTo($p);}}opts.pagerAnchors=opts.pagerAnchors||[];opts.pagerAnchors.push($a);$a.bind(opts.pagerEvent,function(e){e.preventDefault();opts.nextSlide=i;var p=opts.$cont[0],timeout=slideTimeout[opts.pager.split(" ")[0].substring(1)];if(timeout){clearTimeout(timeout);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}var cb=opts.onPagerEvent||opts.pagerClick;// pagerClick is deprecated
if($.isFunction(cb))cb(opts.nextSlide,els[opts.nextSlide]);go(els,opts,1,opts.currSlide<i);// trigger the trans
//		return false; // <== allow bubble
});if(!/^click/.test(opts.pagerEvent)&&!opts.allowPagerClickBubble)$a.bind('click.cycle',function(){return false;});// suppress click
if(opts.pauseOnPagerHover)$a.hover(function(){opts.$cont[0].cyclePause++;},function(){opts.$cont[0].cyclePause--;});};// helper fn to calculate the number of slides between the current and the next
$.fn.cycle.hopsFromLast=function(opts,fwd){var hops,l=opts.lastSlide,c=opts.currSlide;if(fwd)hops=c>l?c-l:opts.slideCount-l;else hops=c<l?l-c:l+opts.slideCount-c;return hops;};// fix clearType problems in ie6 by setting an explicit bg color
// (otherwise text slides look horrible during a fade transition)
function clearTypeFix($slides){debug('applying clearType background-color hack');function hex(s){s=parseInt(s).toString(16);return s.length<2?'0'+s:s;};function getBg(e){for(;e&&e.nodeName.toLowerCase()!='html';e=e.parentNode){var v=$.css(e,'background-color');if(v.indexOf('rgb')>=0){var rgb=v.match(/\d+/g);return'#'+hex(rgb[0])+hex(rgb[1])+hex(rgb[2]);}if(v&&v!='transparent')return v;}return'#ffffff';//return 'transparent';
};//$slides.each(function() { $(this).css('background-color', getBg(this)); });
};// reset common props before the next transition
$.fn.cycle.commonReset=function(curr,next,opts,w,h,rev){$(opts.elements).not(curr).hide();opts.cssBefore.opacity=1;opts.cssBefore.display='block';if(w!==false&&next.cycleW>0)opts.cssBefore.width=next.cycleW;if(h!==false&&next.cycleH>0)opts.cssBefore.height=next.cycleH;opts.cssAfter=opts.cssAfter||{};opts.cssAfter.display='none';$(curr).css('zIndex',opts.slideCount+(rev===true?1:0));$(next).css('zIndex',opts.slideCount+(rev===true?0:1));};// the actual fn for effecting a transition
$.fn.cycle.custom=function(curr,next,opts,cb,fwd,speedOverride){var $l=$(curr),$n=$(next);var speedIn=opts.speedIn,speedOut=opts.speedOut,easeIn=opts.easeIn,easeOut=opts.easeOut;$n.css(opts.cssBefore);if(speedOverride){if(typeof speedOverride=='number')speedIn=speedOut=speedOverride;else speedIn=speedOut=1;easeIn=easeOut=null;}var fn=function fn(){$n.animate(opts.animIn,speedIn,easeIn,cb);};$l.animate(opts.animOut,speedOut,easeOut,function(){if(opts.cssAfter)$l.css(opts.cssAfter);if(!opts.sync)fn();});if(opts.sync)fn();};// transition definitions - only fade is defined here, transition pack defines the rest
$.fn.cycle.transitions={fade:function fade($cont,$slides,opts){$slides.not(':eq('+opts.currSlide+')').css('opacity',0);opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.cssBefore.opacity=0;});opts.animIn={opacity:1};opts.animOut={opacity:0};opts.cssBefore={top:0,left:0};}};$.fn.cycle.ver=function(){return ver;};// override these globally if you like (they are all optional)
$.fn.cycle.defaults={fx:'fade',// name of transition effect (or comma separated names, ex: 'fade,scrollUp,shuffle')
timeout:4000,// milliseconds between slide transitions (0 to disable auto advance)
timeoutFn:null,// callback for determining per-slide timeout value:  function(currSlideElement, nextSlideElement, options, forwardFlag)
continuous:0,// true to start next transition immediately after current one completes
speed:1000,// speed of the transition (any valid fx speed value)
speedIn:null,// speed of the 'in' transition
speedOut:null,// speed of the 'out' transition
next:null,// selector for element to use as event trigger for next slide
prev:null,// selector for element to use as event trigger for previous slide
//	prevNextClick: null,  // @deprecated; please use onPrevNextEvent instead
onPrevNextEvent:null,// callback fn for prev/next events: function(isNext, zeroBasedSlideIndex, slideElement)
prevNextEvent:'click.cycle',// event which drives the manual transition to the previous or next slide
pager:null,// selector for element to use as pager container
//pagerClick   null,  // @deprecated; please use onPagerEvent instead
onPagerEvent:null,// callback fn for pager events: function(zeroBasedSlideIndex, slideElement)
pagerEvent:'click.cycle',// name of event which drives the pager navigation
allowPagerClickBubble:false,// allows or prevents click event on pager anchors from bubbling
pagerAnchorBuilder:null,// callback fn for building anchor links:  function(index, DOMelement)
before:null,// transition callback (scope set to element to be shown):	 function(currSlideElement, nextSlideElement, options, forwardFlag)
after:null,// transition callback (scope set to element that was shown):  function(currSlideElement, nextSlideElement, options, forwardFlag)
end:null,// callback invoked when the slideshow terminates (use with autostop or nowrap options): function(options)
easing:null,// easing method for both in and out transitions
easeIn:null,// easing for "in" transition
easeOut:null,// easing for "out" transition
shuffle:null,// coords for shuffle animation, ex: { top:15, left: 200 }
animIn:null,// properties that define how the slide animates in
animOut:null,// properties that define how the slide animates out
cssBefore:null,// properties that define the initial state of the slide before transitioning in
cssAfter:null,// properties that defined the state of the slide after transitioning out
fxFn:null,// function used to control the transition: function(currSlideElement, nextSlideElement, options, afterCalback, forwardFlag)
height:'auto',// container height
startingSlide:0,// zero-based index of the first slide to be displayed
sync:1,// true if in/out transitions should occur simultaneously
random:0,// true for random, false for sequence (not applicable to shuffle fx)
fit:0,// force slides to fit container
containerResize:1,// resize container to fit largest slide
pause:0,// true to enable "pause on hover"
pauseOnPagerHover:0,// true to pause when hovering over pager link
autostop:0,// true to end slideshow after X transitions (where X == slide count)
autostopCount:0,// number of transitions (optionally used with autostop to define X)
delay:0,// additional delay (in ms) for first transition (hint: can be negative)
slideExpr:null,// expression for selecting slides (if something other than all children is required)
cleartype:!$.support.opacity,// true if clearType corrections should be applied (for IE)
cleartypeNoBg:false,// set to true to disable extra cleartype fixing (leave false to force background color setting on slides)
nowrap:0,// true to prevent slideshow from wrapping
fastOnEvent:0,// force fast transitions when triggered manually (via pager or prev/next); value == time in ms
randomizeEffects:1,// valid when multiple effects are used; true to make the effect sequence random
rev:0,// causes animations to transition in reverse
manualTrump:true,// causes manual transition to stop an active transition instead of being ignored
requeueOnImageNotLoaded:true,// requeue the slideshow if any image slides are not yet loaded
requeueTimeout:250,// ms delay for requeue
activePagerClass:'activeSlide',// class name used for the active pager link
updateActivePagerLink:null,// callback fn invoked to update the active pager link (adds/removes activePagerClass style)
backwards:false// true to start slideshow at last slide and move backwards through the stack
};})(jQuery);/*!
 * jQuery Cycle Plugin Transition Definitions
 * This script is a plugin for the jQuery Cycle Plugin
 * Examples and documentation at: http://malsup.com/jquery/cycle/
 * Copyright (c) 2007-2010 M. Alsup
 * Version:	 2.72
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */(function($){//
// These functions define one-time slide initialization for the named
// transitions. To save file size feel free to remove any of these that you
// don't need.
//
$.fn.cycle.transitions.none=function($cont,$slides,opts){opts.fxFn=function(curr,next,opts,after){$(next).show();$(curr).hide();after();};};// scrollUp/Down/Left/Right
$.fn.cycle.transitions.scrollUp=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var h=$cont.height();opts.cssBefore={top:h,left:0};opts.cssFirst={top:0};opts.animIn={top:0};opts.animOut={top:-h};};$.fn.cycle.transitions.scrollDown=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var h=$cont.height();opts.cssFirst={top:0};opts.cssBefore={top:-h,left:0};opts.animIn={top:0};opts.animOut={top:h};};$.fn.cycle.transitions.scrollLeft=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var w=$cont.width();opts.cssFirst={left:0};opts.cssBefore={left:w,top:0};opts.animIn={left:0};opts.animOut={left:0-w};};$.fn.cycle.transitions.scrollRight=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var w=$cont.width();opts.cssFirst={left:0};opts.cssBefore={left:-w,top:0};opts.animIn={left:0};opts.animOut={left:w};};$.fn.cycle.transitions.scrollHorz=function($cont,$slides,opts){$cont.css('overflow','hidden').width();opts.before.push(function(curr,next,opts,fwd){$.fn.cycle.commonReset(curr,next,opts);opts.cssBefore.left=fwd?next.cycleW-1:1-next.cycleW;opts.animOut.left=fwd?-curr.cycleW:curr.cycleW;});opts.cssFirst={left:0};opts.cssBefore={top:0};opts.animIn={left:0};opts.animOut={top:0};};$.fn.cycle.transitions.scrollVert=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push(function(curr,next,opts,fwd){$.fn.cycle.commonReset(curr,next,opts);opts.cssBefore.top=fwd?1-next.cycleH:next.cycleH-1;opts.animOut.top=fwd?curr.cycleH:-curr.cycleH;});opts.cssFirst={top:0};opts.cssBefore={left:0};opts.animIn={top:0};opts.animOut={left:0};};// slideX/slideY
$.fn.cycle.transitions.slideX=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$(opts.elements).not(curr).hide();$.fn.cycle.commonReset(curr,next,opts,false,true);opts.animIn.width=next.cycleW;});opts.cssBefore={left:0,top:0,width:0};opts.animIn={width:'show'};opts.animOut={width:0};};$.fn.cycle.transitions.slideY=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$(opts.elements).not(curr).hide();$.fn.cycle.commonReset(curr,next,opts,true,false);opts.animIn.height=next.cycleH;});opts.cssBefore={left:0,top:0,height:0};opts.animIn={height:'show'};opts.animOut={height:0};};// shuffle
$.fn.cycle.transitions.shuffle=function($cont,$slides,opts){var i,w=$cont.css('overflow','visible').width();$slides.css({left:0,top:0});opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,true,true);});// only adjust speed once!
if(!opts.speedAdjusted){opts.speed=opts.speed/2;// shuffle has 2 transitions
opts.speedAdjusted=true;}opts.random=0;opts.shuffle=opts.shuffle||{left:-w,top:15};opts.els=[];for(i=0;i<$slides.length;i++){opts.els.push($slides[i]);}for(i=0;i<opts.currSlide;i++){opts.els.push(opts.els.shift());}// custom transition fn (hat tip to Benjamin Sterling for this bit of sweetness!)
opts.fxFn=function(curr,next,opts,cb,fwd){var $el=fwd?$(curr):$(next);$(next).css(opts.cssBefore);var count=opts.slideCount;$el.animate(opts.shuffle,opts.speedIn,opts.easeIn,function(){var hops=$.fn.cycle.hopsFromLast(opts,fwd);for(var k=0;k<hops;k++){fwd?opts.els.push(opts.els.shift()):opts.els.unshift(opts.els.pop());}if(fwd){for(var i=0,len=opts.els.length;i<len;i++){$(opts.els[i]).css('z-index',len-i+count);}}else{var z=$(curr).css('z-index');$el.css('z-index',parseInt(z)+1+count);}$el.animate({left:0,top:0},opts.speedOut,opts.easeOut,function(){$(fwd?this:curr).hide();if(cb)cb();});});};opts.cssBefore={display:'block',opacity:1,top:0,left:0};};// turnUp/Down/Left/Right
$.fn.cycle.transitions.turnUp=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false);opts.cssBefore.top=next.cycleH;opts.animIn.height=next.cycleH;});opts.cssFirst={top:0};opts.cssBefore={left:0,height:0};opts.animIn={top:0};opts.animOut={height:0};};$.fn.cycle.transitions.turnDown=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false);opts.animIn.height=next.cycleH;opts.animOut.top=curr.cycleH;});opts.cssFirst={top:0};opts.cssBefore={left:0,top:0,height:0};opts.animOut={height:0};};$.fn.cycle.transitions.turnLeft=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true);opts.cssBefore.left=next.cycleW;opts.animIn.width=next.cycleW;});opts.cssBefore={top:0,width:0};opts.animIn={left:0};opts.animOut={width:0};};$.fn.cycle.transitions.turnRight=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true);opts.animIn.width=next.cycleW;opts.animOut.left=curr.cycleW;});opts.cssBefore={top:0,left:0,width:0};opts.animIn={left:0};opts.animOut={width:0};};// zoom
$.fn.cycle.transitions.zoom=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,false,true);opts.cssBefore.top=next.cycleH/2;opts.cssBefore.left=next.cycleW/2;opts.animIn={top:0,left:0,width:next.cycleW,height:next.cycleH};opts.animOut={width:0,height:0,top:curr.cycleH/2,left:curr.cycleW/2};});opts.cssFirst={top:0,left:0};opts.cssBefore={width:0,height:0};};// fadeZoom
$.fn.cycle.transitions.fadeZoom=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,false);opts.cssBefore.left=next.cycleW/2;opts.cssBefore.top=next.cycleH/2;opts.animIn={top:0,left:0,width:next.cycleW,height:next.cycleH};});opts.cssBefore={width:0,height:0};opts.animOut={opacity:0};};// blindX
$.fn.cycle.transitions.blindX=function($cont,$slides,opts){var w=$cont.css('overflow','hidden').width();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.animIn.width=next.cycleW;opts.animOut.left=curr.cycleW;});opts.cssBefore={left:w,top:0};opts.animIn={left:0};opts.animOut={left:w};};// blindY
$.fn.cycle.transitions.blindY=function($cont,$slides,opts){var h=$cont.css('overflow','hidden').height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.animIn.height=next.cycleH;opts.animOut.top=curr.cycleH;});opts.cssBefore={top:h,left:0};opts.animIn={top:0};opts.animOut={top:h};};// blindZ
$.fn.cycle.transitions.blindZ=function($cont,$slides,opts){var h=$cont.css('overflow','hidden').height();var w=$cont.width();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.animIn.height=next.cycleH;opts.animOut.top=curr.cycleH;});opts.cssBefore={top:h,left:w};opts.animIn={top:0,left:0};opts.animOut={top:h,left:w};};// growX - grow horizontally from centered 0 width
$.fn.cycle.transitions.growX=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true);opts.cssBefore.left=this.cycleW/2;opts.animIn={left:0,width:this.cycleW};opts.animOut={left:0};});opts.cssBefore={width:0,top:0};};// growY - grow vertically from centered 0 height
$.fn.cycle.transitions.growY=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false);opts.cssBefore.top=this.cycleH/2;opts.animIn={top:0,height:this.cycleH};opts.animOut={top:0};});opts.cssBefore={height:0,left:0};};// curtainX - squeeze in both edges horizontally
$.fn.cycle.transitions.curtainX=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true,true);opts.cssBefore.left=next.cycleW/2;opts.animIn={left:0,width:this.cycleW};opts.animOut={left:curr.cycleW/2,width:0};});opts.cssBefore={top:0,width:0};};// curtainY - squeeze in both edges vertically
$.fn.cycle.transitions.curtainY=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false,true);opts.cssBefore.top=next.cycleH/2;opts.animIn={top:0,height:next.cycleH};opts.animOut={top:curr.cycleH/2,height:0};});opts.cssBefore={left:0,height:0};};// cover - curr slide covered by next slide
$.fn.cycle.transitions.cover=function($cont,$slides,opts){var d=opts.direction||'left';var w=$cont.css('overflow','hidden').width();var h=$cont.height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);if(d=='right')opts.cssBefore.left=-w;else if(d=='up')opts.cssBefore.top=h;else if(d=='down')opts.cssBefore.top=-h;else opts.cssBefore.left=w;});opts.animIn={left:0,top:0};opts.animOut={opacity:1};opts.cssBefore={top:0,left:0};};// uncover - curr slide moves off next slide
$.fn.cycle.transitions.uncover=function($cont,$slides,opts){var d=opts.direction||'left';var w=$cont.css('overflow','hidden').width();var h=$cont.height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,true,true);if(d=='right')opts.animOut.left=w;else if(d=='up')opts.animOut.top=-h;else if(d=='down')opts.animOut.top=h;else opts.animOut.left=-w;});opts.animIn={left:0,top:0};opts.animOut={opacity:1};opts.cssBefore={top:0,left:0};};// toss - move top slide and fade away
$.fn.cycle.transitions.toss=function($cont,$slides,opts){var w=$cont.css('overflow','visible').width();var h=$cont.height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,true,true);// provide default toss settings if animOut not provided
if(!opts.animOut.left&&!opts.animOut.top)opts.animOut={left:w*2,top:-h/2,opacity:0};else opts.animOut.opacity=0;});opts.cssBefore={left:0,top:0};opts.animIn={left:0};};// wipe - clip animation
$.fn.cycle.transitions.wipe=function($cont,$slides,opts){var w=$cont.css('overflow','hidden').width();var h=$cont.height();opts.cssBefore=opts.cssBefore||{};var clip;if(opts.clip){if(/l2r/.test(opts.clip))clip='rect(0px 0px '+h+'px 0px)';else if(/r2l/.test(opts.clip))clip='rect(0px '+w+'px '+h+'px '+w+'px)';else if(/t2b/.test(opts.clip))clip='rect(0px '+w+'px 0px 0px)';else if(/b2t/.test(opts.clip))clip='rect('+h+'px '+w+'px '+h+'px 0px)';else if(/zoom/.test(opts.clip)){var top=parseInt(h/2);var left=parseInt(w/2);clip='rect('+top+'px '+left+'px '+top+'px '+left+'px)';}}opts.cssBefore.clip=opts.cssBefore.clip||clip||'rect(0px 0px 0px 0px)';var d=opts.cssBefore.clip.match(/(\d+)/g);var t=parseInt(d[0]),r=parseInt(d[1]),b=parseInt(d[2]),l=parseInt(d[3]);opts.before.push(function(curr,next,opts){if(curr==next)return;var $curr=$(curr),$next=$(next);$.fn.cycle.commonReset(curr,next,opts,true,true,false);opts.cssAfter.display='block';var step=1,count=parseInt(opts.speedIn/13)-1;(function f(){var tt=t?t-parseInt(step*(t/count)):0;var ll=l?l-parseInt(step*(l/count)):0;var bb=b<h?b+parseInt(step*((h-b)/count||1)):h;var rr=r<w?r+parseInt(step*((w-r)/count||1)):w;$next.css({clip:'rect('+tt+'px '+rr+'px '+bb+'px '+ll+'px)'});step++<=count?setTimeout(f,13):$curr.css('display','none');})();});opts.cssBefore={display:'block',opacity:1,top:0,left:0};opts.animIn={left:0};opts.animOut={left:0};};})(jQuery);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * fancyBox - jQuery Plugin
 * version: 2.1.5 (Fri, 14 Jun 2013)
 * @requires jQuery v1.6 or later
 *
 * Examples at http://fancyapps.com/fancybox/
 * License: www.fancyapps.com/fancybox/#license
 *
 * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
 *
 */(function(window,document,$,undefined){"use strict";var H=$("html"),W=$(window),D=$(document),F=$.fancybox=function(){F.open.apply(this,arguments);},IE=navigator.userAgent.match(/msie/i),didUpdate=null,isTouch=document.createTouch!==undefined,isQuery=function isQuery(obj){return obj&&obj.hasOwnProperty&&obj instanceof $;},isString=function isString(str){return str&&$.type(str)==="string";},isPercentage=function isPercentage(str){return isString(str)&&str.indexOf('%')>0;},isScrollable=function isScrollable(el){return el&&!(el.style.overflow&&el.style.overflow==='hidden')&&(el.clientWidth&&el.scrollWidth>el.clientWidth||el.clientHeight&&el.scrollHeight>el.clientHeight);},getScalar=function getScalar(orig,dim){var value=parseInt(orig,10)||0;if(dim&&isPercentage(orig)){value=F.getViewport()[dim]/100*value;}return Math.ceil(value);},getValue=function getValue(value,dim){return getScalar(value,dim)+'px';};$.extend(F,{// The current version of fancyBox
version:'2.1.5',defaults:{padding:15,margin:20,width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,// Set to 2 for retina display support
autoSize:true,autoHeight:false,autoWidth:false,autoResize:true,autoCenter:!isTouch,fitToView:true,aspectRatio:false,topRatio:0.5,leftRatio:0.5,scrolling:'auto',// 'auto', 'yes' or 'no'
wrapCSS:'',arrows:true,closeBtn:true,closeClick:false,nextClick:false,mouseWheel:true,autoPlay:false,playSpeed:3000,preload:3,modal:false,loop:true,ajax:{dataType:'html',headers:{'X-fancyBox':true}},iframe:{scrolling:'auto',preload:true},swf:{wmode:'transparent',allowfullscreen:'true',allowscriptaccess:'always'},keys:{next:{13:'left',// enter
34:'up',// page down
39:'left',// right arrow
40:'up'// down arrow
},prev:{8:'right',// backspace
33:'down',// page up
37:'right',// left arrow
38:'down'// up arrow
},close:[27],// escape key
play:[32],// space - start/stop slideshow
toggle:[70]// letter "f" - toggle fullscreen
},direction:{next:'left',prev:'right'},scrollOutside:true,// Override some properties
index:0,type:null,href:null,content:null,title:null,ref:null,// HTML templates
tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+(IE?' allowtransparency="true"':'')+'></iframe>',error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},// Properties for each animation type
// Opening fancyBox
openEffect:'fade',// 'elastic', 'fade' or 'none'
openSpeed:250,openEasing:'swing',openOpacity:true,openMethod:'zoomIn',// Closing fancyBox
closeEffect:'fade',// 'elastic', 'fade' or 'none'
closeSpeed:250,closeEasing:'swing',closeOpacity:true,closeMethod:'zoomOut',// Changing next gallery item
nextEffect:'elastic',// 'elastic', 'fade' or 'none'
nextSpeed:250,nextEasing:'swing',nextMethod:'changeIn',// Changing previous gallery item
prevEffect:'elastic',// 'elastic', 'fade' or 'none'
prevSpeed:250,prevEasing:'swing',prevMethod:'changeOut',// Enable default helpers
helpers:{overlay:true,title:true},// Callbacks
onCancel:$.noop,// If canceling
beforeLoad:$.noop,// Before loading
afterLoad:$.noop,// After loading
beforeShow:$.noop,// Before changing in current item
afterShow:$.noop,// After opening
beforeChange:$.noop,// Before changing gallery item
beforeClose:$.noop,// Before closing
afterClose:$.noop// After closing
},//Current state
group:{},// Selected group
opts:{},// Group options
previous:null,// Previous element
coming:null,// Element being loaded
current:null,// Currently loaded element
isActive:false,// Is activated
isOpen:false,// Is currently open
isOpened:false,// Have been fully opened at least once
wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:false},// Loaders
ajaxLoad:null,imgPreload:null,// Some collections
transitions:{},helpers:{},/*
		 *	Static methods
		 */open:function open(group,opts){if(!group){return;}if(!$.isPlainObject(opts)){opts={};}// Close if already active
if(false===F.close(true)){return;}// Normalize group
if(!$.isArray(group)){group=isQuery(group)?$(group).get():[group];}// Recheck if the type of each element is `object` and set content type (image, ajax, etc)
$.each(group,function(i,element){var obj={},href,title,ref,content,type,rez,hrefParts,selector;if($.type(element)==="object"){// Check if is DOM element
if(element.nodeType){element=$(element);}if(isQuery(element)){obj={href:element.data('fancybox-href')||element.attr('href'),title:element.data('fancybox-title')||element.attr('title'),ref:element.data('fancybox-ref')||element.attr('ref'),isDom:true,element:element};if($.metadata){$.extend(true,obj,element.metadata());}}else{obj=element;}}href=opts.href||obj.href||(isString(element)?element:null);title=opts.title!==undefined?opts.title:obj.title||'';ref=opts.ref!==undefined?opts.ref:obj.ref||'';content=opts.content||obj.content;type=content?'html':opts.type||obj.type;if(!type&&obj.isDom){type=element.data('fancybox-type');if(!type){rez=element.attr('class').match(/fancybox\.(\w+)/);type=rez?rez[1]:null;}}if(isString(href)){// Try to guess the content type
if(!type){if(F.isImage(href)){type='image';}else if(F.isSWF(href)){type='swf';}else if(href.charAt(0)==='#'){type='inline';}else if(isString(element)){type='html';content=element;}}// Split url into two pieces with source url and content selector, e.g,
// "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
if(type==='ajax'){hrefParts=href.split(/\s+/,2);href=hrefParts.shift();selector=hrefParts.shift();}}if(!content){if(type==='inline'){if(href){content=$(isString(href)?href.replace(/.*(?=#[^\s]+$)/,''):href);//strip for ie7
}else if(obj.isDom){content=element;}}else if(type==='html'){content=href;}else if(!type&&!href&&obj.isDom){type='inline';content=element;}}$.extend(obj,{href:href,type:type,content:content,title:title,selector:selector,ref:ref});group[i]=obj;});// Extend the defaults
F.opts=$.extend(true,{},F.defaults,opts);// All options are merged recursive except keys
if(opts.keys!==undefined){F.opts.keys=opts.keys?$.extend({},F.defaults.keys,opts.keys):false;}F.group=group;return F._start(F.opts.index);},// Cancel image loading or abort ajax request
cancel:function cancel(){var coming=F.coming;if(!coming||false===F.trigger('onCancel')){return;}F.hideLoading();if(F.ajaxLoad){F.ajaxLoad.abort();}F.ajaxLoad=null;if(F.imgPreload){F.imgPreload.onload=F.imgPreload.onerror=null;}if(coming.wrap){coming.wrap.stop(true,true).trigger('onReset').remove();}F.coming=null;// If the first item has been canceled, then clear everything
if(!F.current){F._afterZoomOut(coming);}},// Start closing animation if is open; remove immediately if opening/closing
close:function close(event){F.cancel();if(false===F.trigger('beforeClose')){return;}F.unbindEvents();if(!F.isActive){return;}if(!F.isOpen||event===true){$('.fancybox-wrap').stop(true).trigger('onReset').remove();F._afterZoomOut();}else{F.isOpen=F.isOpened=false;F.isClosing=true;$('.fancybox-item, .fancybox-nav').remove();F.wrap.stop(true,true).removeClass('fancybox-opened');F.transitions[F.current.closeMethod]();}},// Manage slideshow:
//   $.fancybox.play(); - toggle slideshow
//   $.fancybox.play( true ); - start
//   $.fancybox.play( false ); - stop
play:function play(action){var clear=function clear(){clearTimeout(F.player.timer);},set=function set(){clear();if(F.current&&F.player.isActive){F.player.timer=setTimeout(F.next,F.current.playSpeed);}},stop=function stop(){clear();D.unbind('.player');F.player.isActive=false;F.trigger('onPlayEnd');},start=function start(){if(F.current&&(F.current.loop||F.current.index<F.group.length-1)){F.player.isActive=true;D.bind({'onCancel.player beforeClose.player':stop,'onUpdate.player':set,'beforeLoad.player':clear});set();F.trigger('onPlayStart');}};if(action===true||!F.player.isActive&&action!==false){start();}else{stop();}},// Navigate to next gallery item
next:function next(direction){var current=F.current;if(current){if(!isString(direction)){direction=current.direction.next;}F.jumpto(current.index+1,direction,'next');}},// Navigate to previous gallery item
prev:function prev(direction){var current=F.current;if(current){if(!isString(direction)){direction=current.direction.prev;}F.jumpto(current.index-1,direction,'prev');}},// Navigate to gallery item by index
jumpto:function jumpto(index,direction,router){var current=F.current;if(!current){return;}index=getScalar(index);F.direction=direction||current.direction[index>=current.index?'next':'prev'];F.router=router||'jumpto';if(current.loop){if(index<0){index=current.group.length+index%current.group.length;}index=index%current.group.length;}if(current.group[index]!==undefined){F.cancel();F._start(index);}},// Center inside viewport and toggle position type to fixed or absolute if needed
reposition:function reposition(e,onlyAbsolute){var current=F.current,wrap=current?current.wrap:null,pos;if(wrap){pos=F._getPosition(onlyAbsolute);if(e&&e.type==='scroll'){delete pos.position;wrap.stop(true,true).animate(pos,200);}else{wrap.css(pos);current.pos=$.extend({},current.dim,pos);}}},update:function update(e){var type=e&&e.type,anyway=!type||type==='orientationchange';if(anyway){clearTimeout(didUpdate);didUpdate=null;}if(!F.isOpen||didUpdate){return;}didUpdate=setTimeout(function(){var current=F.current;if(!current||F.isClosing){return;}F.wrap.removeClass('fancybox-tmp');if(anyway||type==='load'||type==='resize'&&current.autoResize){F._setDimension();}if(!(type==='scroll'&&current.canShrink)){F.reposition(e);}F.trigger('onUpdate');didUpdate=null;},anyway&&!isTouch?0:300);},// Shrink content to fit inside viewport or restore if resized
toggle:function toggle(action){if(F.isOpen){F.current.fitToView=$.type(action)==="boolean"?action:!F.current.fitToView;// Help browser to restore document dimensions
if(isTouch){F.wrap.removeAttr('style').addClass('fancybox-tmp');F.trigger('onUpdate');}F.update();}},hideLoading:function hideLoading(){D.unbind('.loading');$('#fancybox-loading').remove();},showLoading:function showLoading(){var el,viewport;F.hideLoading();el=$('<div id="fancybox-loading"><div></div></div>').click(F.cancel).appendTo('body');// If user will press the escape-button, the request will be canceled
D.bind('keydown.loading',function(e){if((e.which||e.keyCode)===27){e.preventDefault();F.cancel();}});if(!F.defaults.fixed){viewport=F.getViewport();el.css({position:'absolute',top:viewport.h*0.5+viewport.y,left:viewport.w*0.5+viewport.x});}},getViewport:function getViewport(){var locked=F.current&&F.current.locked||false,rez={x:W.scrollLeft(),y:W.scrollTop()};if(locked){rez.w=locked[0].clientWidth;rez.h=locked[0].clientHeight;}else{// See http://bugs.jquery.com/ticket/6724
rez.w=isTouch&&window.innerWidth?window.innerWidth:W.width();rez.h=isTouch&&window.innerHeight?window.innerHeight:W.height();}return rez;},// Unbind the keyboard / clicking actions
unbindEvents:function unbindEvents(){if(F.wrap&&isQuery(F.wrap)){F.wrap.unbind('.fb');}D.unbind('.fb');W.unbind('.fb');},bindEvents:function bindEvents(){var current=F.current,keys;if(!current){return;}// Changing document height on iOS devices triggers a 'resize' event,
// that can change document height... repeating infinitely
W.bind('orientationchange.fb'+(isTouch?'':' resize.fb')+(current.autoCenter&&!current.locked?' scroll.fb':''),F.update);keys=current.keys;if(keys){D.bind('keydown.fb',function(e){var code=e.which||e.keyCode,target=e.target||e.srcElement;// Skip esc key if loading, because showLoading will cancel preloading
if(code===27&&F.coming){return false;}// Ignore key combinations and key events within form elements
if(!e.ctrlKey&&!e.altKey&&!e.shiftKey&&!e.metaKey&&!(target&&(target.type||$(target).is('[contenteditable]')))){$.each(keys,function(i,val){if(current.group.length>1&&val[code]!==undefined){F[i](val[code]);e.preventDefault();return false;}if($.inArray(code,val)>-1){F[i]();e.preventDefault();return false;}});}});}if($.fn.mousewheel&&current.mouseWheel){F.wrap.bind('mousewheel.fb',function(e,delta,deltaX,deltaY){var target=e.target||null,parent=$(target),canScroll=false;while(parent.length){if(canScroll||parent.is('.fancybox-skin')||parent.is('.fancybox-wrap')){break;}canScroll=isScrollable(parent[0]);parent=$(parent).parent();}if(delta!==0&&!canScroll){if(F.group.length>1&&!current.canShrink){if(deltaY>0||deltaX>0){F.prev(deltaY>0?'down':'left');}else if(deltaY<0||deltaX<0){F.next(deltaY<0?'up':'right');}e.preventDefault();}}});}},trigger:function trigger(event,o){var ret,obj=o||F.coming||F.current;if(!obj){return;}if($.isFunction(obj[event])){ret=obj[event].apply(obj,Array.prototype.slice.call(arguments,1));}if(ret===false){return false;}if(obj.helpers){$.each(obj.helpers,function(helper,opts){if(opts&&F.helpers[helper]&&$.isFunction(F.helpers[helper][event])){F.helpers[helper][event]($.extend(true,{},F.helpers[helper].defaults,opts),obj);}});}D.trigger(event);},isImage:function isImage(str){return isString(str)&&str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);},isSWF:function isSWF(str){return isString(str)&&str.match(/\.(swf)((\?|#).*)?$/i);},_start:function _start(index){var coming={},obj,href,type,margin,padding;index=getScalar(index);obj=F.group[index]||null;if(!obj){return false;}coming=$.extend(true,{},F.opts,obj);// Convert margin and padding properties to array - top, right, bottom, left
margin=coming.margin;padding=coming.padding;if($.type(margin)==='number'){coming.margin=[margin,margin,margin,margin];}if($.type(padding)==='number'){coming.padding=[padding,padding,padding,padding];}// 'modal' propery is just a shortcut
if(coming.modal){$.extend(true,coming,{closeBtn:false,closeClick:false,nextClick:false,arrows:false,mouseWheel:false,keys:null,helpers:{overlay:{closeClick:false}}});}// 'autoSize' property is a shortcut, too
if(coming.autoSize){coming.autoWidth=coming.autoHeight=true;}if(coming.width==='auto'){coming.autoWidth=true;}if(coming.height==='auto'){coming.autoHeight=true;}/*
			 * Add reference to the group, so it`s possible to access from callbacks, example:
			 * afterLoad : function() {
			 *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
			 * }
			 */coming.group=F.group;coming.index=index;// Give a chance for callback or helpers to update coming item (type, title, etc)
F.coming=coming;if(false===F.trigger('beforeLoad')){F.coming=null;return;}type=coming.type;href=coming.href;if(!type){F.coming=null;//If we can not determine content type then drop silently or display next/prev item if looping through gallery
if(F.current&&F.router&&F.router!=='jumpto'){F.current.index=index;return F[F.router](F.direction);}return false;}F.isActive=true;if(type==='image'||type==='swf'){coming.autoHeight=coming.autoWidth=false;coming.scrolling='visible';}if(type==='image'){coming.aspectRatio=true;}if(type==='iframe'&&isTouch){coming.scrolling='scroll';}// Build the neccessary markup
coming.wrap=$(coming.tpl.wrap).addClass('fancybox-'+(isTouch?'mobile':'desktop')+' fancybox-type-'+type+' fancybox-tmp '+coming.wrapCSS).appendTo(coming.parent||'body');$.extend(coming,{skin:$('.fancybox-skin',coming.wrap),outer:$('.fancybox-outer',coming.wrap),inner:$('.fancybox-inner',coming.wrap)});$.each(["Top","Right","Bottom","Left"],function(i,v){coming.skin.css('padding'+v,getValue(coming.padding[i]));});F.trigger('onReady');// Check before try to load; 'inline' and 'html' types need content, others - href
if(type==='inline'||type==='html'){if(!coming.content||!coming.content.length){return F._error('content');}}else if(!href){return F._error('href');}if(type==='image'){F._loadImage();}else if(type==='ajax'){F._loadAjax();}else if(type==='iframe'){F._loadIframe();}else{F._afterLoad();}},_error:function _error(type){$.extend(F.coming,{type:'html',autoWidth:true,autoHeight:true,minWidth:0,minHeight:0,scrolling:'no',hasError:type,content:F.coming.tpl.error});F._afterLoad();},_loadImage:function _loadImage(){// Reset preload image so it is later possible to check "complete" property
var img=F.imgPreload=new Image();img.onload=function(){this.onload=this.onerror=null;F.coming.width=this.width/F.opts.pixelRatio;F.coming.height=this.height/F.opts.pixelRatio;F._afterLoad();};img.onerror=function(){this.onload=this.onerror=null;F._error('image');};img.src=F.coming.href;if(img.complete!==true){F.showLoading();}},_loadAjax:function _loadAjax(){var coming=F.coming;F.showLoading();F.ajaxLoad=$.ajax($.extend({},coming.ajax,{url:coming.href,error:function error(jqXHR,textStatus){if(F.coming&&textStatus!=='abort'){F._error('ajax',jqXHR);}else{F.hideLoading();}},success:function success(data,textStatus){if(textStatus==='success'){coming.content=data;F._afterLoad();}}}));},_loadIframe:function _loadIframe(){var coming=F.coming,iframe=$(coming.tpl.iframe.replace(/\{rnd\}/g,new Date().getTime())).attr('scrolling',isTouch?'auto':coming.iframe.scrolling).attr('src',coming.href);// This helps IE
$(coming.wrap).bind('onReset',function(){try{$(this).find('iframe').hide().attr('src','//about:blank').end().empty();}catch(e){}});if(coming.iframe.preload){F.showLoading();iframe.one('load',function(){$(this).data('ready',1);// iOS will lose scrolling if we resize
if(!isTouch){$(this).bind('load.fb',F.update);}// Without this trick:
//   - iframe won't scroll on iOS devices
//   - IE7 sometimes displays empty iframe
$(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();F._afterLoad();});}coming.content=iframe.appendTo(coming.inner);if(!coming.iframe.preload){F._afterLoad();}},_preloadImages:function _preloadImages(){var group=F.group,current=F.current,len=group.length,cnt=current.preload?Math.min(current.preload,len-1):0,item,i;for(i=1;i<=cnt;i+=1){item=group[(current.index+i)%len];if(item.type==='image'&&item.href){new Image().src=item.href;}}},_afterLoad:function _afterLoad(){var coming=F.coming,previous=F.current,placeholder='fancybox-placeholder',current,content,type,scrolling,href,embed;F.hideLoading();if(!coming||F.isActive===false){return;}if(false===F.trigger('afterLoad',coming,previous)){coming.wrap.stop(true).trigger('onReset').remove();F.coming=null;return;}if(previous){F.trigger('beforeChange',previous);previous.wrap.stop(true).removeClass('fancybox-opened').find('.fancybox-item, .fancybox-nav').remove();}F.unbindEvents();current=coming;content=coming.content;type=coming.type;scrolling=coming.scrolling;$.extend(F,{wrap:current.wrap,skin:current.skin,outer:current.outer,inner:current.inner,current:current,previous:previous});href=current.href;switch(type){case'inline':case'ajax':case'html':if(current.selector){content=$('<div>').html(content).find(current.selector);}else if(isQuery(content)){if(!content.data(placeholder)){content.data(placeholder,$('<div class="'+placeholder+'"></div>').insertAfter(content).hide());}content=content.show().detach();current.wrap.bind('onReset',function(){if($(this).find(content).length){content.hide().replaceAll(content.data(placeholder)).data(placeholder,false);}});}break;case'image':content=current.tpl.image.replace('{href}',href);break;case'swf':content='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+href+'"></param>';embed='';$.each(current.swf,function(name,val){content+='<param name="'+name+'" value="'+val+'"></param>';embed+=' '+name+'="'+val+'"';});content+='<embed src="'+href+'" type="application/x-shockwave-flash" width="100%" height="100%"'+embed+'></embed></object>';break;}if(!(isQuery(content)&&content.parent().is(current.inner))){current.inner.append(content);}// Give a chance for helpers or callbacks to update elements
F.trigger('beforeShow');// Set scrolling before calculating dimensions
current.inner.css('overflow',scrolling==='yes'?'scroll':scrolling==='no'?'hidden':scrolling);// Set initial dimensions and start position
F._setDimension();F.reposition();F.isOpen=false;F.coming=null;F.bindEvents();if(!F.isOpened){$('.fancybox-wrap').not(current.wrap).stop(true).trigger('onReset').remove();}else if(previous.prevMethod){F.transitions[previous.prevMethod]();}F.transitions[F.isOpened?current.nextMethod:current.openMethod]();F._preloadImages();},_setDimension:function _setDimension(){var viewport=F.getViewport(),steps=0,canShrink=false,canExpand=false,wrap=F.wrap,skin=F.skin,inner=F.inner,current=F.current,width=current.width,height=current.height,minWidth=current.minWidth,minHeight=current.minHeight,maxWidth=current.maxWidth,maxHeight=current.maxHeight,scrolling=current.scrolling,scrollOut=current.scrollOutside?current.scrollbarWidth:0,margin=current.margin,wMargin=getScalar(margin[1]+margin[3]),hMargin=getScalar(margin[0]+margin[2]),wPadding,hPadding,wSpace,hSpace,origWidth,origHeight,origMaxWidth,origMaxHeight,ratio,width_,height_,maxWidth_,maxHeight_,iframe,body;// Reset dimensions so we could re-check actual size
wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');wPadding=getScalar(skin.outerWidth(true)-skin.width());hPadding=getScalar(skin.outerHeight(true)-skin.height());// Any space between content and viewport (margin, padding, border, title)
wSpace=wMargin+wPadding;hSpace=hMargin+hPadding;origWidth=isPercentage(width)?(viewport.w-wSpace)*getScalar(width)/100:width;origHeight=isPercentage(height)?(viewport.h-hSpace)*getScalar(height)/100:height;if(current.type==='iframe'){iframe=current.content;if(current.autoHeight&&iframe.data('ready')===1){try{if(iframe[0].contentWindow.document.location){inner.width(origWidth).height(9999);body=iframe.contents().find('body');if(scrollOut){body.css('overflow-x','hidden');}origHeight=body.outerHeight(true);}}catch(e){}}}else if(current.autoWidth||current.autoHeight){inner.addClass('fancybox-tmp');// Set width or height in case we need to calculate only one dimension
if(!current.autoWidth){inner.width(origWidth);}if(!current.autoHeight){inner.height(origHeight);}if(current.autoWidth){origWidth=inner.width();}if(current.autoHeight){origHeight=inner.height();}inner.removeClass('fancybox-tmp');}width=getScalar(origWidth);height=getScalar(origHeight);ratio=origWidth/origHeight;// Calculations for the content
minWidth=getScalar(isPercentage(minWidth)?getScalar(minWidth,'w')-wSpace:minWidth);maxWidth=getScalar(isPercentage(maxWidth)?getScalar(maxWidth,'w')-wSpace:maxWidth);minHeight=getScalar(isPercentage(minHeight)?getScalar(minHeight,'h')-hSpace:minHeight);maxHeight=getScalar(isPercentage(maxHeight)?getScalar(maxHeight,'h')-hSpace:maxHeight);// These will be used to determine if wrap can fit in the viewport
origMaxWidth=maxWidth;origMaxHeight=maxHeight;if(current.fitToView){maxWidth=Math.min(viewport.w-wSpace,maxWidth);maxHeight=Math.min(viewport.h-hSpace,maxHeight);}maxWidth_=viewport.w-wMargin;maxHeight_=viewport.h-hMargin;if(current.aspectRatio){if(width>maxWidth){width=maxWidth;height=getScalar(width/ratio);}if(height>maxHeight){height=maxHeight;width=getScalar(height*ratio);}if(width<minWidth){width=minWidth;height=getScalar(width/ratio);}if(height<minHeight){height=minHeight;width=getScalar(height*ratio);}}else{width=Math.max(minWidth,Math.min(width,maxWidth));if(current.autoHeight&&current.type!=='iframe'){inner.width(width);height=inner.height();}height=Math.max(minHeight,Math.min(height,maxHeight));}// Try to fit inside viewport (including the title)
if(current.fitToView){inner.width(width).height(height);wrap.width(width+wPadding);// Real wrap dimensions
width_=wrap.width();height_=wrap.height();if(current.aspectRatio){while((width_>maxWidth_||height_>maxHeight_)&&width>minWidth&&height>minHeight){if(steps++>19){break;}height=Math.max(minHeight,Math.min(maxHeight,height-10));width=getScalar(height*ratio);if(width<minWidth){width=minWidth;height=getScalar(width/ratio);}if(width>maxWidth){width=maxWidth;height=getScalar(width/ratio);}inner.width(width).height(height);wrap.width(width+wPadding);width_=wrap.width();height_=wrap.height();}}else{width=Math.max(minWidth,Math.min(width,width-(width_-maxWidth_)));height=Math.max(minHeight,Math.min(height,height-(height_-maxHeight_)));}}if(scrollOut&&scrolling==='auto'&&height<origHeight&&width+wPadding+scrollOut<maxWidth_){width+=scrollOut;}inner.width(width).height(height);wrap.width(width+wPadding);width_=wrap.width();height_=wrap.height();canShrink=(width_>maxWidth_||height_>maxHeight_)&&width>minWidth&&height>minHeight;canExpand=current.aspectRatio?width<origMaxWidth&&height<origMaxHeight&&width<origWidth&&height<origHeight:(width<origMaxWidth||height<origMaxHeight)&&(width<origWidth||height<origHeight);$.extend(current,{dim:{width:getValue(width_),height:getValue(height_)},origWidth:origWidth,origHeight:origHeight,canShrink:canShrink,canExpand:canExpand,wPadding:wPadding,hPadding:hPadding,wrapSpace:height_-skin.outerHeight(true),skinSpace:skin.height()-height});if(!iframe&&current.autoHeight&&height>minHeight&&height<maxHeight&&!canExpand){inner.height('auto');}},_getPosition:function _getPosition(onlyAbsolute){var current=F.current,viewport=F.getViewport(),margin=current.margin,width=F.wrap.width()+margin[1]+margin[3],height=F.wrap.height()+margin[0]+margin[2],rez={position:'absolute',top:margin[0],left:margin[3]};if(current.autoCenter&&current.fixed&&!onlyAbsolute&&height<=viewport.h&&width<=viewport.w){rez.position='fixed';}else if(!current.locked){rez.top+=viewport.y;rez.left+=viewport.x;}rez.top=getValue(Math.max(rez.top,rez.top+(viewport.h-height)*current.topRatio));rez.left=getValue(Math.max(rez.left,rez.left+(viewport.w-width)*current.leftRatio));return rez;},_afterZoomIn:function _afterZoomIn(){var current=F.current;if(!current){return;}F.isOpen=F.isOpened=true;F.wrap.css('overflow','visible').addClass('fancybox-opened');F.update();// Assign a click event
if(current.closeClick||current.nextClick&&F.group.length>1){F.inner.css('cursor','pointer').bind('click.fb',function(e){if(!$(e.target).is('a')&&!$(e.target).parent().is('a')){e.preventDefault();F[current.closeClick?'close':'next']();}});}// Create a close button
if(current.closeBtn){$(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb',function(e){e.preventDefault();F.close();});}// Create navigation arrows
if(current.arrows&&F.group.length>1){if(current.loop||current.index>0){$(current.tpl.prev).appendTo(F.outer).bind('click.fb',F.prev);}if(current.loop||current.index<F.group.length-1){$(current.tpl.next).appendTo(F.outer).bind('click.fb',F.next);}}F.trigger('afterShow');// Stop the slideshow if this is the last item
if(!current.loop&&current.index===current.group.length-1){F.play(false);}else if(F.opts.autoPlay&&!F.player.isActive){F.opts.autoPlay=false;F.play();}},_afterZoomOut:function _afterZoomOut(obj){obj=obj||F.current;$('.fancybox-wrap').trigger('onReset').remove();$.extend(F,{group:{},opts:{},router:false,current:null,isActive:false,isOpened:false,isOpen:false,isClosing:false,wrap:null,skin:null,outer:null,inner:null});F.trigger('afterClose',obj);}});/*
	 *	Default transitions
	 */F.transitions={getOrigPosition:function getOrigPosition(){var current=F.current,element=current.element,orig=current.orig,pos={},width=50,height=50,hPadding=current.hPadding,wPadding=current.wPadding,viewport=F.getViewport();if(!orig&&current.isDom&&element.is(':visible')){orig=element.find('img:first');if(!orig.length){orig=element;}}if(isQuery(orig)){pos=orig.offset();if(orig.is('img')){width=orig.outerWidth();height=orig.outerHeight();}}else{pos.top=viewport.y+(viewport.h-height)*current.topRatio;pos.left=viewport.x+(viewport.w-width)*current.leftRatio;}if(F.wrap.css('position')==='fixed'||current.locked){pos.top-=viewport.y;pos.left-=viewport.x;}pos={top:getValue(pos.top-hPadding*current.topRatio),left:getValue(pos.left-wPadding*current.leftRatio),width:getValue(width+wPadding),height:getValue(height+hPadding)};return pos;},step:function step(now,fx){var ratio,padding,value,prop=fx.prop,current=F.current,wrapSpace=current.wrapSpace,skinSpace=current.skinSpace;if(prop==='width'||prop==='height'){ratio=fx.end===fx.start?1:(now-fx.start)/(fx.end-fx.start);if(F.isClosing){ratio=1-ratio;}padding=prop==='width'?current.wPadding:current.hPadding;value=now-padding;F.skin[prop](getScalar(prop==='width'?value:value-wrapSpace*ratio));F.inner[prop](getScalar(prop==='width'?value:value-wrapSpace*ratio-skinSpace*ratio));}},zoomIn:function zoomIn(){var current=F.current,startPos=current.pos,effect=current.openEffect,elastic=effect==='elastic',endPos=$.extend({opacity:1},startPos);// Remove "position" property that breaks older IE
delete endPos.position;if(elastic){startPos=this.getOrigPosition();if(current.openOpacity){startPos.opacity=0.1;}}else if(effect==='fade'){startPos.opacity=0.1;}F.wrap.css(startPos).animate(endPos,{duration:effect==='none'?0:current.openSpeed,easing:current.openEasing,step:elastic?this.step:null,complete:F._afterZoomIn});},zoomOut:function zoomOut(){var current=F.current,effect=current.closeEffect,elastic=effect==='elastic',endPos={opacity:0.1};if(elastic){endPos=this.getOrigPosition();if(current.closeOpacity){endPos.opacity=0.1;}}F.wrap.animate(endPos,{duration:effect==='none'?0:current.closeSpeed,easing:current.closeEasing,step:elastic?this.step:null,complete:F._afterZoomOut});},changeIn:function changeIn(){var current=F.current,effect=current.nextEffect,startPos=current.pos,endPos={opacity:1},direction=F.direction,distance=200,field;startPos.opacity=0.1;if(effect==='elastic'){field=direction==='down'||direction==='up'?'top':'left';if(direction==='down'||direction==='right'){startPos[field]=getValue(getScalar(startPos[field])-distance);endPos[field]='+='+distance+'px';}else{startPos[field]=getValue(getScalar(startPos[field])+distance);endPos[field]='-='+distance+'px';}}// Workaround for http://bugs.jquery.com/ticket/12273
if(effect==='none'){F._afterZoomIn();}else{F.wrap.css(startPos).animate(endPos,{duration:current.nextSpeed,easing:current.nextEasing,complete:F._afterZoomIn});}},changeOut:function changeOut(){var previous=F.previous,effect=previous.prevEffect,endPos={opacity:0.1},direction=F.direction,distance=200;if(effect==='elastic'){endPos[direction==='down'||direction==='up'?'top':'left']=(direction==='up'||direction==='left'?'-':'+')+'='+distance+'px';}previous.wrap.animate(endPos,{duration:effect==='none'?0:previous.prevSpeed,easing:previous.prevEasing,complete:function complete(){$(this).trigger('onReset').remove();}});}};/*
	 *	Overlay helper
	 */F.helpers.overlay={defaults:{closeClick:true,// if true, fancyBox will be closed when user clicks on the overlay
speedOut:200,// duration of fadeOut animation
showEarly:true,// indicates if should be opened immediately or wait until the content is ready
css:{},// custom CSS properties
locked:!isTouch,// if true, the content will be locked into overlay
fixed:true// if false, the overlay CSS position property will not be set to "fixed"
},overlay:null,// current handle
fixed:false,// indicates if the overlay has position "fixed"
el:$('html'),// element that contains "the lock"
// Public methods
create:function create(opts){opts=$.extend({},this.defaults,opts);if(this.overlay){this.close();}this.overlay=$('<div class="fancybox-overlay"></div>').appendTo(F.coming?F.coming.parent:opts.parent);this.fixed=false;if(opts.fixed&&F.defaults.fixed){this.overlay.addClass('fancybox-overlay-fixed');this.fixed=true;}},open:function open(opts){var that=this;opts=$.extend({},this.defaults,opts);if(this.overlay){this.overlay.unbind('.overlay').width('auto').height('auto');}else{this.create(opts);}if(!this.fixed){W.bind('resize.overlay',$.proxy(this.update,this));this.update();}if(opts.closeClick){this.overlay.bind('click.overlay',function(e){if($(e.target).hasClass('fancybox-overlay')){if(F.isActive){F.close();}else{that.close();}return false;}});}this.overlay.css(opts.css).show();},close:function close(){var scrollV,scrollH;W.unbind('resize.overlay');if(this.el.hasClass('fancybox-lock')){$('.fancybox-margin').removeClass('fancybox-margin');scrollV=W.scrollTop();scrollH=W.scrollLeft();this.el.removeClass('fancybox-lock');W.scrollTop(scrollV).scrollLeft(scrollH);}$('.fancybox-overlay').remove().hide();$.extend(this,{overlay:null,fixed:false});},// Private, callbacks
update:function update(){var width='100%',offsetWidth;// Reset width/height so it will not mess
this.overlay.width(width).height('100%');// jQuery does not return reliable result for IE
if(IE){offsetWidth=Math.max(document.documentElement.offsetWidth,document.body.offsetWidth);if(D.width()>offsetWidth){width=D.width();}}else if(D.width()>W.width()){width=D.width();}this.overlay.width(width).height(D.height());},// This is where we can manipulate DOM, because later it would cause iframes to reload
onReady:function onReady(opts,obj){var overlay=this.overlay;$('.fancybox-overlay').stop(true,true);if(!overlay){this.create(opts);}if(opts.locked&&this.fixed&&obj.fixed){if(!overlay){this.margin=D.height()>W.height()?$('html').css('margin-right').replace("px",""):false;}obj.locked=this.overlay.append(obj.wrap);obj.fixed=false;}if(opts.showEarly===true){this.beforeShow.apply(this,arguments);}},beforeShow:function beforeShow(opts,obj){var scrollV,scrollH;if(obj.locked){if(this.margin!==false){$('*').filter(function(){return $(this).css('position')==='fixed'&&!$(this).hasClass("fancybox-overlay")&&!$(this).hasClass("fancybox-wrap");}).addClass('fancybox-margin');this.el.addClass('fancybox-margin');}scrollV=W.scrollTop();scrollH=W.scrollLeft();this.el.addClass('fancybox-lock');W.scrollTop(scrollV).scrollLeft(scrollH);}this.open(opts);},onUpdate:function onUpdate(){if(!this.fixed){this.update();}},afterClose:function afterClose(opts){// Remove overlay if exists and fancyBox is not opening
// (e.g., it is not being open using afterClose callback)
//if (this.overlay && !F.isActive) {
if(this.overlay&&!F.coming){this.overlay.fadeOut(opts.speedOut,$.proxy(this.close,this));}}};/*
	 *	Title helper
	 */F.helpers.title={defaults:{type:'float',// 'float', 'inside', 'outside' or 'over',
position:'bottom'// 'top' or 'bottom'
},beforeShow:function beforeShow(opts){var current=F.current,text=current.title,type=opts.type,title,target;if($.isFunction(text)){text=text.call(current.element,current);}if(!isString(text)||$.trim(text)===''){return;}title=$('<div class="fancybox-title fancybox-title-'+type+'-wrap">'+text+'</div>');switch(type){case'inside':target=F.skin;break;case'outside':target=F.wrap;break;case'over':target=F.inner;break;default:// 'float'
target=F.skin;title.appendTo('body');if(IE){title.width(title.width());}title.wrapInner('<span class="child"></span>');//Increase bottom margin so this title will also fit into viewport
F.current.margin[2]+=Math.abs(getScalar(title.css('margin-bottom')));break;}title[opts.position==='top'?'prependTo':'appendTo'](target);}};// jQuery plugin initialization
$.fn.fancybox=function(options){var index,that=$(this),selector=this.selector||'',run=function run(e){var what=$(this).blur(),idx=index,relType,relVal;if(!(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&!what.is('.fancybox-wrap')){relType=options.groupAttr||'data-fancybox-group';relVal=what.attr(relType);if(!relVal){relType='rel';relVal=what.get(0)[relType];}if(relVal&&relVal!==''&&relVal!=='nofollow'){what=selector.length?$(selector):that;what=what.filter('['+relType+'="'+relVal+'"]');idx=what.index(this);}options.index=idx;// Stop an event from bubbling if everything is fine
if(F.open(what,options)!==false){e.preventDefault();}}};options=options||{};index=options.index||0;if(!selector||options.live===false){that.unbind('click.fb-start').bind('click.fb-start',run);}else{D.undelegate(selector,'click.fb-start').delegate(selector+":not('.fancybox-item, .fancybox-nav')",'click.fb-start',run);}this.filter('[data-fancybox-start=1]').trigger('click');return this;};// Tests that need a body at doc ready
D.ready(function(){var w1,w2;if($.scrollbarWidth===undefined){// http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
$.scrollbarWidth=function(){var parent=$('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),child=parent.children(),width=child.innerWidth()-child.height(99).innerWidth();parent.remove();return width;};}if($.support.fixedPosition===undefined){$.support.fixedPosition=function(){var elem=$('<div style="position:fixed;top:20px;"></div>').appendTo('body'),fixed=elem[0].offsetTop===20||elem[0].offsetTop===15;elem.remove();return fixed;}();}$.extend(F.defaults,{scrollbarWidth:$.scrollbarWidth(),fixed:$.support.fixedPosition,parent:$('body')});//Get real width of page scroll-bar
w1=$(window).width();H.addClass('fancybox-lock-test');w2=$(window).width();H.removeClass('fancybox-lock-test');// $("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head");
});})(window,document,jQuery);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(204);__webpack_require__(205);__webpack_require__(206);

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _ActionTypes=__webpack_require__(99);var _workflow=__webpack_require__(208);var _workflow2=_interopRequireDefault(_workflow);var _mycalendar=__webpack_require__(470);var _mycalendar2=_interopRequireDefault(_mycalendar);var _rss=__webpack_require__(475);var _rss2=_interopRequireDefault(_rss);var _custompage=__webpack_require__(478);var _custompage2=_interopRequireDefault(_custompage);var _news=__webpack_require__(482);var _news2=_interopRequireDefault(_news);var _reportform=__webpack_require__(499);var _reportform2=_interopRequireDefault(_reportform);var _outdata=__webpack_require__(502);var _outdata2=_interopRequireDefault(_outdata);var _formmodecustomsearch=__webpack_require__(505);var _formmodecustomsearch2=_interopRequireDefault(_formmodecustomsearch);var _picture=__webpack_require__(510);var _picture2=_interopRequireDefault(_picture);var _view=__webpack_require__(520);var _view2=_interopRequireDefault(_view);var _morenews=__webpack_require__(521);var _morenews2=_interopRequireDefault(_morenews);var _stock=__webpack_require__(522);var _stock2=_interopRequireDefault(_stock);var _magazine=__webpack_require__(523);var _magazine2=_interopRequireDefault(_magazine);var _doccontent=__webpack_require__(525);var _doccontent2=_interopRequireDefault(_doccontent);var _audio=__webpack_require__(527);var _audio2=_interopRequireDefault(_audio);var _favourite=__webpack_require__(529);var _favourite2=_interopRequireDefault(_favourite);var _flash=__webpack_require__(530);var _flash2=_interopRequireDefault(_flash);var _imgslide=__webpack_require__(531);var _imgslide2=_interopRequireDefault(_imgslide);var _datacenter=__webpack_require__(534);var _datacenter2=_interopRequireDefault(_datacenter);var _video=__webpack_require__(536);var _video2=_interopRequireDefault(_video);var _weather=__webpack_require__(538);var _weather2=_interopRequireDefault(_weather);var _outtersys=__webpack_require__(540);var _outtersys2=_interopRequireDefault(_outtersys);var _scratchpad=__webpack_require__(542);var _scratchpad2=_interopRequireDefault(_scratchpad);var _slide=__webpack_require__(544);var _slide2=_interopRequireDefault(_slide);var _jobsinfo=__webpack_require__(546);var _jobsinfo2=_interopRequireDefault(_jobsinfo);var _searchengine=__webpack_require__(547);var _searchengine2=_interopRequireDefault(_searchengine);var _custommenu=__webpack_require__(549);var _custommenu2=_interopRequireDefault(_custommenu);var _notice=__webpack_require__(555);var _notice2=_interopRequireDefault(_notice);var _mail=__webpack_require__(557);var _mail2=_interopRequireDefault(_mail);var _coremail=__webpack_require__(561);var _coremail2=_interopRequireDefault(_coremail);var _blogstatus=__webpack_require__(562);var _blogstatus2=_interopRequireDefault(_blogstatus);var _contacts=__webpack_require__(565);var _contacts2=_interopRequireDefault(_contacts);var _addwf=__webpack_require__(570);var _addwf2=_interopRequireDefault(_addwf);var _task=__webpack_require__(574);var _task2=_interopRequireDefault(_task);var _newnotice=__webpack_require__(578);var _newnotice2=_interopRequireDefault(_newnotice);var _worktask=__webpack_require__(580);var _worktask2=_interopRequireDefault(_worktask);var _fnaBudgetAssistant=__webpack_require__(581);var _fnaBudgetAssistant2=_interopRequireDefault(_fnaBudgetAssistant);var _fnaBudgetAssistant3=__webpack_require__(582);var _fnaBudgetAssistant4=_interopRequireDefault(_fnaBudgetAssistant3);var _noreact=__webpack_require__(583);var _noreact2=_interopRequireDefault(_noreact);var _cooperation=__webpack_require__(584);var _cooperation2=_interopRequireDefault(_cooperation);var _meetingcalendar=__webpack_require__(587);var _meetingcalendar2=_interopRequireDefault(_meetingcalendar);var _myprojects=__webpack_require__(589);var _myprojects2=_interopRequireDefault(_myprojects);var _loginnews=__webpack_require__(592);var _loginnews2=_interopRequireDefault(_loginnews);var _login=__webpack_require__(596);var _login2=_interopRequireDefault(_login);var _newmeeting=__webpack_require__(606);var _newmeeting2=_interopRequireDefault(_newmeeting);var _dayplan=__webpack_require__(607);var _dayplan2=_interopRequireDefault(_dayplan);var _processtask=__webpack_require__(608);var _processtask2=_interopRequireDefault(_processtask);var _unreaddocs=__webpack_require__(609);var _unreaddocs2=_interopRequireDefault(_unreaddocs);var _newcustomers=__webpack_require__(610);var _newcustomers2=_interopRequireDefault(_newcustomers);var _messagereminding=__webpack_require__(611);var _messagereminding2=_interopRequireDefault(_messagereminding);var _news_dy=__webpack_require__(612);var _news_dy2=_interopRequireDefault(_news_dy);var _customelement=__webpack_require__(616);var _customelement2=_interopRequireDefault(_customelement);var _quickentry=__webpack_require__(617);var _quickentry2=_interopRequireDefault(_quickentry);var _ecodeelement=__webpack_require__(620);var _ecodeelement2=_interopRequireDefault(_ecodeelement);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//ecode自定义元素
/*//通用列表组件
import ElementTable from './elementtable/';*///自定义元素
//消息提醒元素
//未读文档元素
//每日计划元素
//登录前门户元素
var Element=function(_React$Component){(0,_inherits3.default)(Element,_React$Component);function Element(props){(0,_classCallCheck3.default)(this,Element);var _this=(0,_possibleConstructorReturn3.default)(this,(Element.__proto__||(0,_getPrototypeOf2.default)(Element)).call(this,props));_this.state={fontSizeMp:{}};_this.getElementStyle=_this.getElementStyle.bind(_this);return _this;}(0,_createClass3.default)(Element,[{key:'getElementStyle',value:function getElementStyle(id,fontSizeMp){var config=this.props.config;var eid=config.item.eid;if(!(0,_lodash.isEmpty)(fontSizeMp)&&id==eid){this.setState({fontSizeMp:fontSizeMp});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var config=this.props.config;var fontSizeMp=this.state.fontSizeMp;var _config$item=config.item,eid=_config$item.eid,ebaseid=_config$item.ebaseid;if(/^Custom_/.test(ebaseid)){return _react2.default.createElement(_customelement2.default,{key:eid,config:config});}switch(ebaseid){case _ActionTypes.ELEMENT_TYPES.WORKFLOW:return _react2.default.createElement(_workflow2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.RSS:return _react2.default.createElement(_rss2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.CUSTOMPAGE:return _react2.default.createElement(_custompage2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEWS:return _react2.default.createElement(_news2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.REPORTFORM:return _react2.default.createElement(_reportform2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.OUTDATA:return _react2.default.createElement(_outdata2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FORMMODECUSTOMSEARCH:return _react2.default.createElement(_formmodecustomsearch2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});//case ELEMENT_TYPES.MESSAGE_REMINDING:
//case ELEMENT_TYPES.NEW_CUSTOMERS:
//case ELEMENT_TYPES.NEW_MEETING:
case _ActionTypes.ELEMENT_TYPES.MONTH_TARGET://case ELEMENT_TYPES.DAY_PLAN:
case _ActionTypes.ELEMENT_TYPES.SUBSCRIBE_KONWLEDG://case ELEMENT_TYPES.UNREAD_DOCS:
//case ELEMENT_TYPES.UNREAD_COOPERATION:
//case ELEMENT_TYPES.MY_PROJECTS:
return _react2.default.createElement(_view2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.PICTURE:return _react2.default.createElement(_picture2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MORE_NEWS:return _react2.default.createElement(_morenews2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.STOCK:return _react2.default.createElement(_stock2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MAGAZINE:return _react2.default.createElement(_magazine2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.DOC_CONTENT:return _react2.default.createElement(_doccontent2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.AUDIO:return _react2.default.createElement(_audio2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FAVOURITE:return _react2.default.createElement(_favourite2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FLASH:return _react2.default.createElement(_flash2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.IMGSLIDE:return _react2.default.createElement(_imgslide2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.DATACENTER:return _react2.default.createElement(_datacenter2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.VIDEO:return _react2.default.createElement(_video2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.WEATHER:return _react2.default.createElement(_weather2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.OUTTERSYS:return _react2.default.createElement(_outtersys2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.SCRATCHPAD:return _react2.default.createElement(_scratchpad2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.SLIDE:return _react2.default.createElement(_slide2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.JOBSINFO:return _react2.default.createElement(_jobsinfo2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.SEARCHENGINE:return _react2.default.createElement(_searchengine2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.CUSTOMMENU:return _react2.default.createElement(_custommenu2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NOTICE:return _react2.default.createElement(_notice2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MAIL:return _react2.default.createElement(_mail2.default,{key:eid,config:config,fontSizeMp:fontSizeMp,getElementStyle:this.getElementStyle});case _ActionTypes.ELEMENT_TYPES.COREMAIL:return _react2.default.createElement(_coremail2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.BLOGSTATUS:return _react2.default.createElement(_blogstatus2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.CONTACTS:return _react2.default.createElement(_contacts2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.ADDWF:return _react2.default.createElement(_addwf2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.TASK:return _react2.default.createElement(_task2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEWNOTICE:return _react2.default.createElement(_newnotice2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.WORKTASK:return _react2.default.createElement(_worktask2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FNABUDGETASSISTANT:return _react2.default.createElement(_fnaBudgetAssistant2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FNABUDGETASSISTANT1:return _react2.default.createElement(_fnaBudgetAssistant4.default,{key:eid,config:config,fontSizeMp:fontSizeMp});// case ELEMENT_TYPES.PLAN:
//     return <Plan key={eid} config={config}/>
case _ActionTypes.ELEMENT_TYPES.MYCALENDAR:return _react2.default.createElement(_mycalendar2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.UNREAD_COOPERATION:return _react2.default.createElement(_cooperation2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MEETINGCALENDAR:return _react2.default.createElement(_meetingcalendar2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MY_PROJECTS:return _react2.default.createElement(_myprojects2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.LOGIN:return _react2.default.createElement(_login2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.LOGIN_NEWS:return _react2.default.createElement(_loginnews2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEW_MEETING:return _react2.default.createElement(_newmeeting2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.DAY_PLAN:return _react2.default.createElement(_dayplan2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MYTASK:return _react2.default.createElement(_processtask2.default,{key:eid,config:config});case _ActionTypes.ELEMENT_TYPES.UNREAD_DOCS:return _react2.default.createElement(_unreaddocs2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEW_CUSTOMERS:return _react2.default.createElement(_newcustomers2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MESSAGE_REMINDING:return _react2.default.createElement(_messagereminding2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEW_DY:return _react2.default.createElement(_news_dy2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.QUICKEENTRY:return _react2.default.createElement(_quickentry2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.ECODEELEMENT:return _react2.default.createElement(_ecodeelement2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});default:return _react2.default.createElement(_noreact2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});}}}]);return Element;}(_react2.default.Component);//个性化菜单
//宁波市中级人民法院文档中心元素
//最新客户元素
//我的任务元素
//最新会议元素
//import Plan from './plan/';
//import MyCalendar from './mycalendar_fs/';
exports.default=Element;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(401);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Workflow=function(_React$Component){(0,_inherits3.default)(Workflow,_React$Component);function Workflow(props){(0,_classCallCheck3.default)(this,Workflow);var _this=(0,_possibleConstructorReturn3.default)(this,(Workflow.__proto__||(0,_getPrototypeOf2.default)(Workflow)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Workflow,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(window.element_workflow_refresh&&(0,_typeof3.default)(window.element_workflow_refresh)=='object'){delete element_workflow_refresh[this.props.config.params.eid];}}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});var params=this.props.config.params;this.handleEData(params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/workflow','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentWillMount',value:function componentWillMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting,counts=edata.counts,_edata$data=edata.data,data=_edata$data===undefined?{}:_edata$data;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var _tabsetting$showTab=tabsetting.showTab,showTab=_tabsetting$showTab===undefined?'2':_tabsetting$showTab;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,counts:counts,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Workflow;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Workflow=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Workflow);exports.default=Workflow;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var ls=_ecCom.WeaTools.ls;var homepage=void 0;var isSetting=void 0;var hpid=void 0;var subCompanyId=void 0;var intMoveEid=void 0;var srcItem=void 0;var srcGroupFlag=void 0;var divLoc=void 0;var dragobj={};var _callback=void 0;var topHeight=0;var leftWidth=0;var scrolldom_scrollTop=0;var scrolldom_scrollLeft=0;var onerror=function onerror(){return false;};function on_ini(){var agent=navigator.userAgent;window.isOpr=agent.indexOf("Opera")>-1;window.isIE=agent.indexOf("IE")>-1&&!isOpr;window.isMoz=agent.indexOf("Mozilla")>-1&&!isOpr&&!isIE;if(isMoz){Event.prototype.__defineGetter__("x",function(){return this.clientX+2;});Event.prototype.__defineGetter__("y",function(){return this.clientY+2;});}}var oDel=function oDel(obj){if($(obj)!=null){$(obj).remove();}};$(function(){on_ini();//初始化拖动
var o=$(".header");});function dragStart(e,target,callback){window.global_event=e;if(e)e=e.nativeEvent;_callback=callback;//alert("target");
e=e||event;//if(e) e = e.
var srcElement=e.srcElement||e.target;if(!(srcElement.className=="header"||srcElement.className=="title"||srcElement.className=="rc-tabs-nav-wrap"||srcElement.className=="title-font"))return;if(!(e.button==1||e.button==0)){return;}if(dragobj.o){return;}if(target.className=="rc-tabs-nav-wrap")target=target.parentNode.parentNode.parentNode.parentNode.parentNode;if(target.className=="title-font")target=target.parentNode.parentNode;homepage=$(target.parentNode).parents(".homepage")[0];isSetting=$(homepage).attr("data-issetting");hpid=$(homepage).attr("data-hpid");subCompanyId=$(homepage).attr("data-subcompanyid");leftWidth=$(homepage).offset().left;topHeight=$(homepage).offset().top;scrolldom_scrollTop=$(homepage).scrollTop();scrolldom_scrollLeft=$(homepage).scrollLeft();dragobj.o=target.parentNode;//alert(dragobj.o.className+"------"+target.className);
srcGroupFlag=$($(target).parents(".group")[0]).attr('data-areaflag');//对象左上的坐标
dragobj.xy=getxy(dragobj.o);//鼠标的相对位置
dragobj.xx=new Array(e.x-dragobj.xy[1]+leftWidth,e.y-dragobj.xy[0]+topHeight);dragobj.o.style.width=dragobj.xy[2]+"px";dragobj.o.style.height=dragobj.xy[3]+"px";dragobj.o.style.left=e.x-dragobj.xx[0]+"px";dragobj.o.style.top=e.y-dragobj.xx[1]+"px";dragobj.o.style.position="absolute";//创建临时对象用于记住其原始位置，占位
var om=document.createElement("div");dragobj.otemp=om;om.style.width=dragobj.xy[2]+"px";om.style.height=dragobj.xy[3]+"px";om.className="location";om.style.width="auto";dragobj.o.parentNode.insertBefore(om,dragobj.o);return false;}document.onselectstart=function(){if(dragobj.o!=null){return false;}};document.onmouseup=function(e){if(dragobj.o!=null){var _eid=-1;try{_eid=dragobj.o.id.split("item_")[1];}catch(e){}dragobj.otemp.parentNode.insertBefore(dragobj.o,dragobj.otemp);dragobj.o.style.position="static";dragobj.o.style.width="auto";dragobj.o.style.height="auto";var targetAreaFlag=$(dragobj.otemp).parents(".group").attr('data-areaflag');//自定义页面拖动后刷新元素
if(_callback)_callback();MoveEData(srcGroupFlag,targetAreaFlag,_eid);oDel(dragobj.otemp);//停止拖放
dragobj={};}};document.onmousemove=function(e){e=e||event;if(dragobj.o!=null){dragobj.o.style.zIndex="1";dragobj.o.style.left=e.x-dragobj.xx[0]+"px";dragobj.o.style.top=e.y-dragobj.xx[1]+"px";dragobj.o.style.left=e.clientX;dragobj.o.style.top=e.clientY+document.body.scrollTop;//自动调整布局，显示拖放效果
createtmpl(e);}};//取得鼠标的坐标
function mouseCoords(ev){if(ev.pageX||ev.pageY){return{x:ev.pageX+scrolldom_scrollLeft,y:ev.pageY+scrolldom_scrollTop};}return{x:ev.clientX+scrolldom_scrollLeft-leftWidth,y:ev.clientY+scrolldom_scrollTop-topHeight};}//取得位置分别为上，左，宽，高,所有元素必须在同一容器内
function getxy(e){var a=new Array();var t=e.offsetTop;var l=e.offsetLeft;var w=e.offsetWidth;var h=e.offsetHeight;while(e=e.offsetParent){t+=e.offsetTop;l+=e.offsetLeft;}a[0]=t;a[1]=l;a[2]=w;a[3]=h;return a;}//判断e与o的位置
function inner(o,e){var a=getxy(o);//鼠标是否在o的内部
if(e.x>a[1]&&e.x<a[1]+a[2]&&e.y>a[0]&&e.y<a[0]+a[3]){if(e.y<a[0]+a[3]/2)//上半部分
return 1;else return 2;}else{return 0;}}//
function createtmpl(e){var items=$(homepage).find(".item");for(var i=0;i<items.length;i++){if(!items[i]||items[i]==dragobj.o)continue;//修正鼠标坐标
var mousePos=mouseCoords(e);var b=inner(items[i],mousePos);if(b==0)continue;dragobj.otemp.style.width="auto";if(b==1){items[i].parentNode.insertBefore(dragobj.otemp,items[i]);}else{if(items[i].nextSibling==null){items[i].parentNode.appendChild(dragobj.otemp);}else{items[i].parentNode.insertBefore(dragobj.otemp,items[i].nextSibling);}}}//处理拖放至边界外的情况
var groups=$(homepage).find(".group");for(var j=0;j<groups.length;j++){if(groups[j].innerHTML.indexOf("div")>-1||groups[j].innerHTML.indexOf("DIV")>-1)continue;var op=getxy(groups[j]);if(e.x+scrolldom_scrollLeft>op[1]&&e.x+scrolldom_scrollLeft<op[1]+op[2]&&e.y+scrolldom_scrollTop>op[0]&&e.y+scrolldom_scrollTop<op[0]+op[3]){groups[j].appendChild(dragobj.otemp);dragobj.otemp.style.width=op[2]-10+"px";}}}function MoveEData(srcFlag,targetFlag,eid){var srcItemEids="";var areaflag='data-areaflag';$(homepage).find(".group["+areaflag+"="+srcFlag+"]>.item").each(function(i){if(this.className=="item"){srcItemEids+=$(this).attr("data-eid")+",";}});var targetItemEids="";$(homepage).find(".group["+areaflag+"="+targetFlag+"]>.item").each(function(i){if(this.className=="item"){targetItemEids+=$(this).attr("data-eid")+",";}});if(targetItemEids=="")return;var params={hpid:hpid,subCompanyId:subCompanyId,eid:eid,srcFlag:srcFlag,targetFlag:targetFlag,srcStr:srcItemEids,targetStr:targetItemEids};_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/drag','POST',params).then(function(result){if(result.status==='failed'){_antd.message.error(result.errormsg);}else{ls.set('portal-'+hpid+'-'+isSetting,null);}});}module.exports={dragStart:dragStart};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(22);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _ESetting=__webpack_require__(126);var _ESetting2=_interopRequireDefault(_ESetting);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Toolbar=function(_React$Component){(0,_inherits3.default)(Toolbar,_React$Component);function Toolbar(props){(0,_classCallCheck3.default)(this,Toolbar);var _this=(0,_possibleConstructorReturn3.default)(this,(Toolbar.__proto__||(0,_getPrototypeOf2.default)(Toolbar)).call(this,props));_this.state={islock:'',icon:'',moreRouteurl:''};_this.handleLock=_this.handleLock.bind(_this);_this.handleOnSetting=_this.handleOnSetting.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Toolbar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//判断流程元素是否存在自定义more页面
var config=this.props.config;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var moreRouteurl='';if(ebaseid=='8'||ebaseid=='7'){_ecCom.WeaTools.callApi('/api/portal/customMore/getRouteurl','POST',{ebaseid:ebaseid,eid:eid}).then(function(result){if(result.status=='200'&&result.moreRouteurl){_this2.setState({moreRouteurl:result.moreRouteurl});}});}}},{key:'handleDelete',value:function handleDelete(){var _props=this.props,config=_props.config,handleDelete=_props.handleDelete;var _config$params2=config.params,eid=_config$params2.eid,hpid=_config$params2.hpid,ebaseid=_config$params2.ebaseid,subCompanyId=_config$params2.subCompanyId;var ls=_ecCom.WeaTools.ls;var group=$($("#item_"+eid).parents(".group")[0]);var flag=group.attr('data-areaflag');var eids="";group.find(".item").each(function(){if($(this).attr("data-eid")!=eid)eids+=$(this).attr("data-eid")+",";});var portalHpinfo_setting=ls.getJSONObj('portal-'+hpid+'-true');var portalHpinfo=ls.getJSONObj('portal-'+hpid+'-false');portalHpinfo_setting&&ls.set('portal-'+hpid+'-true',(0,_common.hpinfoHandle)(portalHpinfo_setting,eid));portalHpinfo&&ls.set('portal-'+hpid+'-false',(0,_common.hpinfoHandle)(portalHpinfo,eid));_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/delete','POST',{ebaseid:ebaseid,hpid:hpid,eid:eid,delFlag:flag,delAreaElement:eids,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){handleDelete();}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleLock',value:function handleLock(){var _this3=this;var islock=this.state.islock;var _props$config$params=this.props.config.params,eid=_props$config$params.eid,hpid=_props$config$params.hpid,subCompanyId=_props$config$params.subCompanyId;_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/'+(islock?'unlock':'lock'),'POST',{eid:eid,hpid:hpid,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){_this3.setState({islock:!islock,icon:result.icon});}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleOnSetting',value:function handleOnSetting(){var _props2=this.props,config=_props2.config,handleRefresh=_props2.handleRefresh,getElementStyle=_props2.getElementStyle,datas=_props2.datas;var isSynergySetting=config.isSynergySetting,synergyParams=config.synergyParams;var _config$params3=config.params,eid=_config$params3.eid,ebaseid=_config$params3.ebaseid,hpid=_config$params3.hpid,subCompanyId=_config$params3.subCompanyId;var readyElement=['1','7','8','11','12','6','13','14','15','16','9','10','17','18','19','25','29','32','34','audio','blogStatus','favourite','Flash','menu','notice','picture','reportForm','searchengine','Slide','video','weather','scratchpad','DataCenter','MyCalendar','Task','plan','jobsinfo','outterSys','contacts','addwf','imgSlide','newNotice','OutData','FormModeCustomSearch','MeetingCalendar','CalendarEle','bookshelf','newMobilePicture','fnaBudgetAssistant','fnaBudgetAssistant1','CoreMail','news','processTask','login','7_DY','quickEntry','ecodeElement'];if((0,_common.isContain)(readyElement,ebaseid)||/^Custom_/.test(ebaseid)){_reactDom2.default.render(_react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_antd.Spin,null)),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);_ecCom.WeaTools.callApi('/api/portal/setting/esetting','POST',{eid:eid,ebaseid:ebaseid,hpid:hpid,subCompanyId:subCompanyId},'json').then(function(result){result.hpid=hpid;result.subCompanyId=subCompanyId;result.eid=eid;result.ebaseid=ebaseid;result.dyParams=datas.dyParams;result.sebaseid=datas.sebaseid;_reactDom2.default.render(_react2.default.createElement(_ESetting2.default,{data:result,isSynergySetting:isSynergySetting,synergyParams:synergyParams,handleRefresh:handleRefresh,isSetting:config.isSetting,getElementStyle:getElementStyle}),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);});}else{(0,_common.onSetting)(eid,ebaseid,hpid,subCompanyId);}}},{key:'render',value:function render(){var _props3=this.props,config=_props3.config,islock=_props3.islock,actions=_props3.actions,handleRefresh=_props3.handleRefresh;var _config$item=config.item,eid=_config$item.eid,ebaseid=_config$item.ebaseid,header=_config$item.header;var toolbar=header.toolbar;var lock=toolbar.lock,refresh=toolbar.refresh,setting=toolbar.setting,close=toolbar.close,more=toolbar.more;var _state=this.state,icon=_state.icon,moreRouteurl=_state.moreRouteurl;return _react2.default.createElement('span',{className:'toolbar',style:{position:'absolute'},id:'toolbar_'+eid},_react2.default.createElement('ul',null,lock?_react2.default.createElement('li',null,_react2.default.createElement(_antd.Popconfirm,{title:getLabel(19745,'此操作可能花较长的时间，是否继续？'),onConfirm:this.handleLock,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{'data-status':islock?'locked':'unlocked',href:'javascript:void(0);',title:lock.title},_react2.default.createElement('img',{src:icon||lock.img,border:'0',alt:''})))):'',refresh?_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'javascript:void(0);',name:'refreshbtn',id:'refresh_'+eid,onClick:handleRefresh,title:refresh.title},_react2.default.createElement('img',{src:refresh.img,border:'0',alt:''}))):'',setting?_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'javascript:void(0)',onClick:this.handleOnSetting,title:setting.title},_react2.default.createElement('img',{className:'img_setting',src:setting.img,border:'0',alt:''}))):'',close?_react2.default.createElement('li',null,_react2.default.createElement(_antd.Popconfirm,{placement:'leftTop',title:getLabel(19747,'此元素被删除后将不能被恢复，是否继续？'),onConfirm:this.handleDelete,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{href:'javascript:void(0);',title:close.title},_react2.default.createElement('img',{src:close.img,border:'0',alt:''})))):'',more&&more.position=='title'?(0,_common.isNoMoreElement)(ebaseid)&&!moreRouteurl?'':_react2.default.createElement('li',{style:{width:'34px'}},_react2.default.createElement('a',{id:'more_'+eid,href:'javascript:void(0);',onClick:_common.openMoreWin.bind(this,eid,ebaseid,more.morehref,moreRouteurl)},_react2.default.createElement('img',{className:'img_more',id:'imgMore',border:'0',src:more.img,title:more.title,alt:''}))):''));}}]);return Toolbar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Toolbar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Toolbar);exports.default=Toolbar;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Content_mobilePicture=__webpack_require__(214);var _Content_mobilePicture2=_interopRequireDefault(_Content_mobilePicture);var _Content_=__webpack_require__(215);var _Content_2=_interopRequireDefault(_Content_);var _Content_3=__webpack_require__(265);var _Content_4=_interopRequireDefault(_Content_3);var _Content_5=__webpack_require__(266);var _Content_6=_interopRequireDefault(_Content_5);var _Content_7=__webpack_require__(267);var _Content_8=_interopRequireDefault(_Content_7);var _Content_9=__webpack_require__(268);var _Content_10=_interopRequireDefault(_Content_9);var _Content_11=__webpack_require__(269);var _Content_12=_interopRequireDefault(_Content_11);var _Content_13_new=__webpack_require__(270);var _Content_13_new2=_interopRequireDefault(_Content_13_new);var _Content_13=__webpack_require__(271);var _Content_14=_interopRequireDefault(_Content_13);var _Content_15=__webpack_require__(272);var _Content_16=_interopRequireDefault(_Content_15);var _Content_17=__webpack_require__(273);var _Content_18=_interopRequireDefault(_Content_17);var _Content_19=__webpack_require__(274);var _Content_20=_interopRequireDefault(_Content_19);var _Content_10_new=__webpack_require__(275);var _Content_10_new2=_interopRequireDefault(_Content_10_new);var _Content_21=__webpack_require__(276);var _Content_22=_interopRequireDefault(_Content_21);var _Content_23=__webpack_require__(277);var _Content_24=_interopRequireDefault(_Content_23);var _Content_25=__webpack_require__(278);var _Content_26=_interopRequireDefault(_Content_25);var _Content_27=__webpack_require__(279);var _Content_28=_interopRequireDefault(_Content_27);var _Content_29=__webpack_require__(280);var _Content_30=_interopRequireDefault(_Content_29);var _Content_31=__webpack_require__(281);var _Content_32=_interopRequireDefault(_Content_31);var _Content_Task=__webpack_require__(282);var _Content_Task2=_interopRequireDefault(_Content_Task);var _Content_33=__webpack_require__(283);var _Content_34=_interopRequireDefault(_Content_33);var _Content_audio=__webpack_require__(284);var _Content_audio2=_interopRequireDefault(_Content_audio);var _Content_blogStatus=__webpack_require__(285);var _Content_blogStatus2=_interopRequireDefault(_Content_blogStatus);var _Content_favourite=__webpack_require__(286);var _Content_favourite2=_interopRequireDefault(_Content_favourite);var _Content_Flash=__webpack_require__(287);var _Content_Flash2=_interopRequireDefault(_Content_Flash);var _Content_menu=__webpack_require__(288);var _Content_menu2=_interopRequireDefault(_Content_menu);var _Content_notice=__webpack_require__(289);var _Content_notice2=_interopRequireDefault(_Content_notice);var _Content_picture=__webpack_require__(290);var _Content_picture2=_interopRequireDefault(_Content_picture);var _Content_reportForm=__webpack_require__(294);var _Content_reportForm2=_interopRequireDefault(_Content_reportForm);var _Content_searchengine=__webpack_require__(295);var _Content_searchengine2=_interopRequireDefault(_Content_searchengine);var _Content_Slide=__webpack_require__(296);var _Content_Slide2=_interopRequireDefault(_Content_Slide);var _Content_video=__webpack_require__(298);var _Content_video2=_interopRequireDefault(_Content_video);var _Content_weather=__webpack_require__(301);var _Content_weather2=_interopRequireDefault(_Content_weather);var _Content_scratchpad=__webpack_require__(302);var _Content_scratchpad2=_interopRequireDefault(_Content_scratchpad);var _Content_MyCalendar=__webpack_require__(303);var _Content_MyCalendar2=_interopRequireDefault(_Content_MyCalendar);var _Content_DataCenter=__webpack_require__(304);var _Content_DataCenter2=_interopRequireDefault(_Content_DataCenter);var _Content_plan=__webpack_require__(305);var _Content_plan2=_interopRequireDefault(_Content_plan);var _Content_jobsinfo=__webpack_require__(306);var _Content_jobsinfo2=_interopRequireDefault(_Content_jobsinfo);var _Content_outterSys=__webpack_require__(307);var _Content_outterSys2=_interopRequireDefault(_Content_outterSys);var _Content_contacts=__webpack_require__(308);var _Content_contacts2=_interopRequireDefault(_Content_contacts);var _Content_addwf=__webpack_require__(310);var _Content_addwf2=_interopRequireDefault(_Content_addwf);var _Content_imgSlide=__webpack_require__(311);var _Content_imgSlide2=_interopRequireDefault(_Content_imgSlide);var _Content_newNotice=__webpack_require__(313);var _Content_newNotice2=_interopRequireDefault(_Content_newNotice);var _Content_OutData=__webpack_require__(314);var _Content_OutData2=_interopRequireDefault(_Content_OutData);var _Content_FormModeCustomSearch=__webpack_require__(315);var _Content_FormModeCustomSearch2=_interopRequireDefault(_Content_FormModeCustomSearch);var _Content_MeetingCalendar=__webpack_require__(316);var _Content_MeetingCalendar2=_interopRequireDefault(_Content_MeetingCalendar);var _Content_CalendarEle=__webpack_require__(317);var _Content_CalendarEle2=_interopRequireDefault(_Content_CalendarEle);var _Content_bookshelf=__webpack_require__(318);var _Content_bookshelf2=_interopRequireDefault(_Content_bookshelf);var _Content_newMobilePicture=__webpack_require__(319);var _Content_newMobilePicture2=_interopRequireDefault(_Content_newMobilePicture);var _Content_fnaBudgetAssistant=__webpack_require__(320);var _Content_fnaBudgetAssistant2=_interopRequireDefault(_Content_fnaBudgetAssistant);var _Content_fnaBudgetAssistant3=__webpack_require__(321);var _Content_fnaBudgetAssistant4=_interopRequireDefault(_Content_fnaBudgetAssistant3);var _Content_CoreMail=__webpack_require__(322);var _Content_CoreMail2=_interopRequireDefault(_Content_CoreMail);var _Content_news=__webpack_require__(360);var _Content_news2=_interopRequireDefault(_Content_news);var _Content_ProcessTask=__webpack_require__(361);var _Content_ProcessTask2=_interopRequireDefault(_Content_ProcessTask);var _Content_login=__webpack_require__(362);var _Content_login2=_interopRequireDefault(_Content_login);var _Content_CustomElement=__webpack_require__(363);var _Content_CustomElement2=_interopRequireDefault(_Content_CustomElement);var _Content_dy=__webpack_require__(364);var _Content_dy2=_interopRequireDefault(_Content_dy);var _Content_QuickEntry=__webpack_require__(365);var _Content_QuickEntry2=_interopRequireDefault(_Content_QuickEntry);var _Content_ecodeElement=__webpack_require__(366);var _Content_ecodeElement2=_interopRequireDefault(_Content_ecodeElement);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//ecode自定义元素
//
// 登录系统元素
// 公司新闻
// 审批助手元素
// 移动图片
// 会议元素
// 建模查询中心
// 公告元素
// 新建流程
// 集成登录
// 计划报告元素
// 日历日程
// 天气元素
// 幻灯片
// 图表元素
// 公告栏元素
// Flash元素
// 微博动态
// 知识订阅
// 计划任务
// 文档内容
// 期刊中心
// 我的项目
// 我的邮件
// 当月目标
// 未读文档
//import Content_13 from './content/Content_13'; // 未读协作
// 最新客户
// 文档中心
// 手机图片元素
var Tab4Content=function(_React$Component){(0,_inherits3.default)(Tab4Content,_React$Component);function Tab4Content(){(0,_classCallCheck3.default)(this,Tab4Content);return(0,_possibleConstructorReturn3.default)(this,(Tab4Content.__proto__||(0,_getPrototypeOf2.default)(Tab4Content)).apply(this,arguments));}(0,_createClass3.default)(Tab4Content,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,eContent=_props.eContent,synergyParams=_props.synergyParams,dyParams=_props.dyParams,sebaseid=_props.sebaseid;var props=(0,_extends3.default)({hpid:hpid,eid:eid,ebaseid:ebaseid,eShareLevel:eShareLevel,dyParams:dyParams,sebaseid:sebaseid},eContent);if(/_DY$/.test(ebaseid)){return _react2.default.createElement(_Content_dy2.default,(0,_extends3.default)({ref:ebaseid},props));}if(/^Custom_/.test(ebaseid)){return _react2.default.createElement(_Content_CustomElement2.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));}var tab4Content=_react2.default.createElement('div',null);switch(ebaseid){// 手机图片元素
case'mobilePicture':tab4Content=_react2.default.createElement(_Content_mobilePicture2.default,(0,_extends3.default)({ref:ebaseid},props));break;// RSS阅读器
case'1':tab4Content=_react2.default.createElement(_Content_2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 文档中心
case'7':tab4Content=_react2.default.createElement(_Content_4.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 流程中心
case'8':tab4Content=_react2.default.createElement(_Content_6.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 最新客户
case'11':tab4Content=_react2.default.createElement(_Content_8.default,(0,_extends3.default)({ref:ebaseid},props));break;// 最新会议
case'12':tab4Content=_react2.default.createElement(_Content_10.default,(0,_extends3.default)({ref:ebaseid},props));break;// 未读文档
case'6':tab4Content=_react2.default.createElement(_Content_12.default,(0,_extends3.default)({ref:ebaseid},props));break;// 未读协作
//case '13':tab4Content=<Content_13 ref={ebaseid} {...props}/>;break;
case'13':tab4Content=_react2.default.createElement(_Content_13_new2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 当月目标
case'14':tab4Content=_react2.default.createElement(_Content_14.default,(0,_extends3.default)({ref:ebaseid},props));break;// 当日计划
case'15':tab4Content=_react2.default.createElement(_Content_16.default,(0,_extends3.default)({ref:ebaseid},props));break;// 我的邮件
case'16':tab4Content=_react2.default.createElement(_Content_18.default,(0,_extends3.default)({ref:ebaseid},props));break;// 消息提醒
case'9':tab4Content=_react2.default.createElement(_Content_20.default,(0,_extends3.default)({ref:ebaseid},props));break;// 我的项目
//case '10':tab4Content=<Content_10 ref={ebaseid} {...props}/>;break;
case'10':tab4Content=_react2.default.createElement(_Content_10_new2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 多新闻中心
case'17':tab4Content=_react2.default.createElement(_Content_22.default,(0,_extends3.default)({ref:ebaseid},props));break;// 期刊中心
case'18':tab4Content=_react2.default.createElement(_Content_24.default,(0,_extends3.default)({ref:ebaseid},props));break;// 股票元素
case'19':tab4Content=_react2.default.createElement(_Content_26.default,(0,_extends3.default)({ref:ebaseid},props));break;// 文档内容
case'25':tab4Content=_react2.default.createElement(_Content_28.default,(0,_extends3.default)({ref:ebaseid},props));break;// 自定义页面
case'29':tab4Content=_react2.default.createElement(_Content_30.default,(0,_extends3.default)({ref:ebaseid},props));break;// 计划任务
case'32':tab4Content=_react2.default.createElement(_Content_32.default,(0,_extends3.default)({ref:ebaseid},props));break;// 任务元素
case'Task':tab4Content=_react2.default.createElement(_Content_Task2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 知识订阅
case'34':tab4Content=_react2.default.createElement(_Content_34.default,(0,_extends3.default)({ref:ebaseid},props));break;// 音频元素
case'audio':tab4Content=_react2.default.createElement(_Content_audio2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 微博动态
case'blogStatus':tab4Content=_react2.default.createElement(_Content_blogStatus2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 收藏元素
case'favourite':tab4Content=_react2.default.createElement(_Content_favourite2.default,(0,_extends3.default)({ref:ebaseid},props));break;// Flash元素
case'Flash':tab4Content=_react2.default.createElement(_Content_Flash2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 自定义菜单
case'menu':tab4Content=_react2.default.createElement(_Content_menu2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 公告栏元素
case'notice':tab4Content=_react2.default.createElement(_Content_notice2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 图片元素
case'picture':tab4Content=_react2.default.createElement(_Content_picture2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 图表元素
case'reportForm':tab4Content=_react2.default.createElement(_Content_reportForm2.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 搜索元素
case'searchengine':tab4Content=_react2.default.createElement(_Content_searchengine2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 幻灯片
case'Slide':tab4Content=_react2.default.createElement(_Content_Slide2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 视频元素
case'video':tab4Content=_react2.default.createElement(_Content_video2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 天气元素
case'weather':tab4Content=_react2.default.createElement(_Content_weather2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 便签元素
case'scratchpad':tab4Content=_react2.default.createElement(_Content_scratchpad2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 日历日程
case'MyCalendar':tab4Content=_react2.default.createElement(_Content_MyCalendar2.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 个人数据
case'DataCenter':tab4Content=_react2.default.createElement(_Content_DataCenter2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 计划报告元素
case'plan':tab4Content=_react2.default.createElement(_Content_plan2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 多岗位办理事项
case'jobsinfo':tab4Content=_react2.default.createElement(_Content_jobsinfo2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 集成登录
case'outterSys':tab4Content=_react2.default.createElement(_Content_outterSys2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 通讯录
case'contacts':tab4Content=_react2.default.createElement(_Content_contacts2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 新建流程
case'addwf':tab4Content=_react2.default.createElement(_Content_addwf2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 多图元素
case'imgSlide':tab4Content=_react2.default.createElement(_Content_imgSlide2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 公告元素
case'newNotice':tab4Content=_react2.default.createElement(_Content_newNotice2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 外部数据元素
case'OutData':tab4Content=_react2.default.createElement(_Content_OutData2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 建模查询中心
case'FormModeCustomSearch':tab4Content=_react2.default.createElement(_Content_FormModeCustomSearch2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 会议日历元素
case'MeetingCalendar':tab4Content=_react2.default.createElement(_Content_MeetingCalendar2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 会议元素
case'CalendarEle':tab4Content=_react2.default.createElement(_Content_CalendarEle2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 书柜元素
case'bookshelf':tab4Content=_react2.default.createElement(_Content_bookshelf2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 移动门户图片
case'newMobilePicture':tab4Content=_react2.default.createElement(_Content_newMobilePicture2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 移动门户图片
case'fnaBudgetAssistant':tab4Content=_react2.default.createElement(_Content_fnaBudgetAssistant2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 移动门户图片
case'fnaBudgetAssistant1':tab4Content=_react2.default.createElement(_Content_fnaBudgetAssistant4.default,(0,_extends3.default)({ref:ebaseid},props));break;// CoreMail邮箱
case'CoreMail':tab4Content=_react2.default.createElement(_Content_CoreMail2.default,(0,_extends3.default)({ref:ebaseid},props));break;// CoreMail邮箱
case'news':tab4Content=_react2.default.createElement(_Content_news2.default,(0,_extends3.default)({ref:ebaseid},props));break;//登录系统元素
case'login':tab4Content=_react2.default.createElement(_Content_login2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 我的任务元素
case'processTask':tab4Content=_react2.default.createElement(_Content_ProcessTask2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 快捷入口元素
case'quickEntry':tab4Content=_react2.default.createElement(_Content_QuickEntry2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 快捷入口元素
//ecode自定义元素
case'ecodeElement':tab4Content=_react2.default.createElement(_Content_ecodeElement2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 默认
default:tab4Content=_react2.default.createElement('div',null);}return tab4Content;}},{key:'getSaveValues',value:function getSaveValues(ebaseid){return this.refs[ebaseid].getSaveValues();}}]);return Tab4Content;}(_react2.default.Component);//快捷入口元素
// 自定义元素
// CoreMail邮箱
// 费用报销智能助手
// 书柜元素
// 会议日历元素
// 外部数据元素
// 多图元素
// 通讯录
// 多岗位办理事项
// 个人数据
// 便签元素
// 视频元素
// 搜索元素
// 图片元素
// 自定义菜单
// 收藏元素
// 音频元素
// 任务元素
// 自定义页面
// 股票元素
// 多新闻中心
// 消息提醒
//import Content_10 from './content/Content_10'; // 我的项目
// 当日计划
// 未读协作
// 最新会议
// 流程中心
// RSS阅读器
exports.default=Tab4Content;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 手机图片元素
var Content_mobilePicture=function(_React$Component){(0,_inherits3.default)(Content_mobilePicture,_React$Component);function Content_mobilePicture(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_mobilePicture);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_mobilePicture.__proto__||(0,_getPrototypeOf2.default)(Content_mobilePicture)).call.apply(_ref,[this].concat(args))),_this),_this.state={eScrollSpeed:_this.props.eScrollSpeed,eImageSource:_this.props.eImageSource},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_mobilePicture,[{key:'render',value:function render(){var _this2=this;var columns=[{title:getLabel(350,'图片'),dataIndex:'src',width:'40%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'src')});}},{title:getLabel(22931,'图片名称'),dataIndex:'title',width:'15%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'title')});}},{title:getLabel(22932,'图片链接'),dataIndex:'link',width:'25%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'link')});}},{title:getLabel(88,'顺序'),dataIndex:'orderNum',width:'10%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'orderNum')});}},{title:getLabel(30585,'操作'),dataIndex:'operation',width:'10%',render:function render(text,record){return _react2.default.createElement('span',{onClick:_this2.onDetailDelete.bind(_this2,record.key)},getLabel(91,'删除'));}}];return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,"滚动速度"),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.eScrollSpeed,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eScrollSpeed:value});}}))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:'\u56FE\u7247\u6765\u6E90',needTigger:true,showGroup:true,customComponent:_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'},onClick:this.onDetailAdd.bind(this)},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}}))},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:this.state.eImageSource,pagination:false})));}},{key:'onDetailChange',value:function onDetailChange(key,type,value){var eImageSource=this.state.eImageSource;eImageSource[key][type]=value;this.setState({eImageSource:eImageSource});}},{key:'onDetailDelete',value:function onDetailDelete(key){var eImageSource=this.state.eImageSource;for(var i=0,len=eImageSource.length;i<len;i++){if(eImageSource[i].key==key){eImageSource.splice(i,1);break;}}this.setState({eImageSource:eImageSource});}},{key:'onDetailAdd',value:function onDetailAdd(){var eImageSource=this.state.eImageSource;eImageSource.push({key:eImageSource.length,src:'',title:'',link:'',orderNum:'0'});this.setState({eImageSource:eImageSource});}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentScrollSpeed:this.state.eScrollSpeed,eContentImageSource:this.state.eImageSource};}}]);return Content_mobilePicture;}(_react2.default.Component);exports.default=Content_mobilePicture;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// RSS阅读器
var Content_1=function(_React$Component){(0,_inherits3.default)(Content_1,_React$Component);function Content_1(){(0,_classCallCheck3.default)(this,Content_1);return(0,_possibleConstructorReturn3.default)(this,(Content_1.__proto__||(0,_getPrototypeOf2.default)(Content_1)).apply(this,arguments));}(0,_createClass3.default)(Content_1,[{key:'render',value:function render(){var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'1'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_1;}(_react2.default.Component);exports.default=Content_1;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(217), __esModule: true };

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(218);
module.exports = __webpack_require__(20).Array.from;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(56);
var $export = __webpack_require__(29);
var toObject = __webpack_require__(41);
var call = __webpack_require__(219);
var isArrayIter = __webpack_require__(220);
var toLength = __webpack_require__(74);
var createProperty = __webpack_require__(221);
var getIterFn = __webpack_require__(128);

$export($export.S + $export.F * !__webpack_require__(222)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(37);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(54);
var ITERATOR = __webpack_require__(31)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(32);
var createDesc = __webpack_require__(43);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(31)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(224);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(227);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(225), __esModule: true };

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
__webpack_require__(75);
module.exports = __webpack_require__(226);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(129);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(54);
module.exports = __webpack_require__(20).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(228), __esModule: true };

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
__webpack_require__(75);
module.exports = __webpack_require__(229);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(37);
var get = __webpack_require__(128);
module.exports = __webpack_require__(20).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getMultiBrowserType=exports.getSingleBrowserType=exports.isMultiBrowserType=exports.MULTI_BROWSER_TYPE=exports.getDateTypeName=exports.DATE_TYPES=exports.getSelectedName=undefined;var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 获取下拉选择框中选中项的名称
var getSelectedName=exports.getSelectedName=function getSelectedName(options,key){var name='';for(var i=0,len=options.length;i<len;i++){if(options[i].key==key){name=options[i].showname;break;}}return name;};// 日期类型
var DATE_TYPES=exports.DATE_TYPES=[{value:'0',name:getLabel(332,'全部')},{value:'1',name:getLabel(15537,'今天')},{value:'2',name:getLabel(15539,'本周')},{value:'3',name:getLabel(15541,'本月')},{value:'4',name:getLabel(21904,'本季')},{value:'5',name:getLabel(15384,'本年')},{value:'7',name:getLabel(27347,'上个月')},{value:'8',name:getLabel(81716,'上一年')},{value:'6',name:getLabel(32530,'指定日期范围')}];// 获取日期类型名称
var getDateTypeName=exports.getDateTypeName=function getDateTypeName(type){var name='';for(var i=0,len=DATE_TYPES.length;i<len;i++){if(DATE_TYPES[i].value==type){name=DATE_TYPES[i].name;break;}}return name;};// 多选浏览框类型
var MULTI_BROWSER_TYPE=exports.MULTI_BROWSER_TYPE=[17,18,37,57,65,135,152,162,166,168,170,184,194,257,278];// 判断是否是多选浏览框类型
var isMultiBrowserType=exports.isMultiBrowserType=function isMultiBrowserType(type){var isMulti=false;for(var i=0,len=MULTI_BROWSER_TYPE.length;i<len;i++){if(MULTI_BROWSER_TYPE[i]==type){isMulti=true;break;}}return isMulti;};// 获取单选浏览框类型
var getSingleBrowserType=exports.getSingleBrowserType=function getSingleBrowserType(type){return{17:1,18:7,37:9,57:4,65:267,135:8,152:16,162:161,166:165,168:167,170:169,184:87,194:164,257:256,278:24}[type];};// 获取多选浏览框类型
var getMultiBrowserType=exports.getMultiBrowserType=function getMultiBrowserType(type){return{1:17,7:18,9:37,4:57,267:65,8:135,16:152,161:162,165:166,167:168,169:170,87:184,164:194,256:257,24:278}[type];};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(232);

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _SynergySetting4Designer=__webpack_require__(100);var _SynergySetting4Designer2=_interopRequireDefault(_SynergySetting4Designer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SynergySetting4WfVersions=function(_React$Component){(0,_inherits3.default)(SynergySetting4WfVersions,_React$Component);function SynergySetting4WfVersions(props){(0,_classCallCheck3.default)(this,SynergySetting4WfVersions);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergySetting4WfVersions.__proto__||(0,_getPrototypeOf2.default)(SynergySetting4WfVersions)).call(this,props));_this.state={visible:false,loading:false,data:[],settingParams:{}};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(SynergySetting4WfVersions,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,data=_state.data,settingParams=_state.settingParams;var columns=[{key:'workflowname',title:'流程名称',dataIndex:'workflowname',width:'70%'},{key:'operation',title:getLabel(30585,'操作'),width:'30%',render:function render(text,record){return _react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4d.onShow((0,_extends3.default)({},settingParams,{wfid:record.id}));}},getLabel(17632,'参数设置'));}}];return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:'\u6D41\u7A0B\u53C2\u6570\u8BBE\u7F6E',icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',style:{width:500,height:240},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_SynergySetting4Designer2.default,{ref:function ref(ss4d){return _this2.ss4d=ss4d;}}),_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:data,pagination:false}));}},{key:'onShow',value:function onShow(params){var _this3=this;this.setState({visible:true,loading:true,settingParams:params});var eid=params.eid,tabid=params.tabid;_ecCom.WeaTools.callApi('/api/portal/synergy/getWfVersions','GET',{eid:eid,tabid:tabid}).then(function(data){_this3.setState({loading:false,data:data.data||[]});});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(309,'关闭')));return buttons;}},{key:'onOk',value:function onOk(){this.onCancel();}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,data:[]});}}]);return SynergySetting4WfVersions;}(_react2.default.Component);exports.default=SynergySetting4WfVersions;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器，数据来源
var Content_1_DataSource=function(_React$Component){(0,_inherits3.default)(Content_1_DataSource,_React$Component);function Content_1_DataSource(props){(0,_classCallCheck3.default)(this,Content_1_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_1_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_1_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',showContent:_this.props.tabData.showContent,position:_this.props.tabData.position||_this.props.tabNew.position.selected,searchGroup:_this.props.tabData.searchGroup||_this.props.tabNew.searchGroup.selected,readType:_this.props.tabData.readType||_this.props.tabNew.readType.selected,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_1_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,showContent=_state.showContent,position=_state.position,searchGroup=_state.searchGroup,readType=_state.readType,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var tabNew=this.props.tabNew;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog portal-rss-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:285},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:showContent,viewAttr:3,onChange:function onChange(value){return _this2.setState({showContent:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'30px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-showfield'},'\xA0\xA0\xA0\xA0',eFieldNewUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19669,'所在位置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'//  width: '150px'
}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.position.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:position,detailtype:3,onChange:function onChange(value){_this2.setState({position:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24020,'查询组合'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'//  width: '108px'
}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.searchGroup.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:searchGroup,detailtype:3,onChange:function onChange(value){_this2.setState({searchGroup:value});}})),_react2.default.createElement('div',{style:{paddingLeft:'8px',paddingBottom:'6px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaHelpfulTip// width =  {196} //如果要自定义宽度，在这里设置
,{title:getLabel(386550,'关键字之间以空格分隔，选择 and 搜索包含全部关键词的信息；选择 or 搜索包含任意一个关键词的信息。'),isCenter:true}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24661,'读取方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.readType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:readType,detailtype:3// style={{width: '150px'}}
,onChange:function onChange(value){_this2.setState({readType:value});}}))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title||this.state.showContent==undefined){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_1_DataSource;}(_react2.default.Component);exports.default=Content_1_DataSource;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);var _EOrderCol=__webpack_require__(101);var _EOrderCol2=_interopRequireDefault(_EOrderCol);var _EPicturesSettings=__webpack_require__(102);var _EPicturesSettings2=_interopRequireDefault(_EPicturesSettings);__webpack_require__(131);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 文档中心，数据来源
var Content_7_DataSource=function(_React$Component){(0,_inherits3.default)(Content_7_DataSource,_React$Component);function Content_7_DataSource(props){(0,_classCallCheck3.default)(this,Content_7_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_7_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_7_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',topDocs:_this.props.tabData.topDocs,docSourceType:_this.props.tabData.docSourceType||_this.props.tabNew.docSourceType.selected,newsCenters:_this.props.tabData.newsCenters,docCatalogs:_this.props.tabData.docCatalogs,virtualCatalogs:_this.props.tabData.virtualCatalogs,appointDocs:_this.props.tabData.appointDocs,showMode:_this.props.tabData.showMode||_this.props.tabNew.showMode.selected,scrollDirection:_this.props.tabData.scrollDirection||_this.props.tabNew.scrollDirection.selected,isOpenAttachment:_this.props.tabData.isOpenAttachment||_this.props.tabNew.isOpenAttachment.selected,isOrderUnRead:_this.props.tabData.isOrderUnRead,topDocsNames:_this.props.tabData.topDocsNames,newsCentersNames:_this.props.tabData.newsCentersNames,docCatalogsNames:_this.props.tabData.docCatalogsNames,virtualCatalogsNames:_this.props.tabData.virtualCatalogsNames,appointDocsNames:_this.props.tabData.appointDocsNames,topStyle:_this.props.tabData.topStyle||_this.props.tabNew.topStyle.selected,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false,pictureWidth:_this.props.tabData.pictureWidth,pictureHeight:_this.props.tabData.pictureHeight,widthUnit:_this.props.tabData.widthUnit||'px',heightUnit:_this.props.tabData.heightUnit||'px',autoHeight:_this.props.tabData.autoHeight||false,orderColDataSource:lodash.isEmpty(_this.props.tabData.orderColDataSource)?_this.props.tabNew.orderColDataSource:_this.props.tabData.orderColDataSource,orderColUsedKeys:_this.props.tabData.orderColUsedKeys||[],orderColVisible:false,isShowSettingShowType:_this.props.tabData.isShowSettingShowType||_this.props.tabNew.isShowSettingShowType,showType:_this.props.tabData.showType||'0',scrollSpeed:_this.props.tabData.scrollSpeed||'20'};_this.getButtons=_this.getButtons.bind(_this);_this.onDocSourceTypeChange=_this.onDocSourceTypeChange.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeSize=_this.onChangeSize.bind(_this);return _this;}(0,_createClass3.default)(Content_7_DataSource,[{key:'render',value:function render(){var _this2=this,_React$createElement;var _state=this.state,title=_state.title,docSourceType=_state.docSourceType,showMode=_state.showMode,scrollDirection=_state.scrollDirection,isOpenAttachment=_state.isOpenAttachment,isOrderUnRead=_state.isOrderUnRead,topDocsNames=_state.topDocsNames,newsCentersNames=_state.newsCentersNames,docCatalogs=_state.docCatalogs,docCatalogsNames=_state.docCatalogsNames,virtualCatalogsNames=_state.virtualCatalogsNames,topStyle=_state.topStyle,appointDocsNames=_state.appointDocsNames,eFieldNewVisible=_state.eFieldNewVisible,eFieldNewDataSource=_state.eFieldNewDataSource,_state$pictureWidth=_state.pictureWidth,pictureWidth=_state$pictureWidth===undefined?'120':_state$pictureWidth,_state$pictureHeight=_state.pictureHeight,pictureHeight=_state$pictureHeight===undefined?'108':_state$pictureHeight,widthUnit=_state.widthUnit,heightUnit=_state.heightUnit,autoHeight=_state.autoHeight,orderColDataSource=_state.orderColDataSource,orderColUsedKeys=_state.orderColUsedKeys,orderColVisible=_state.orderColVisible,isShowSettingShowType=_state.isShowSettingShowType;var eFieldNewUsedKeys=this.state.eFieldNewUsedKeys;var tabNew=this.props.tabNew;var type={newsCenters:'docnews',docCatalogs:'doccategory',virtualCatalogs:'docdummy',appointDocs:37};var isMultCheckbox={newsCenters:true,docCatalogs:true,virtualCatalogs:true,appointDocs:true};var replaceDatas={newsCenters:newsCentersNames,docCatalogs:docCatalogsNames,virtualCatalogs:virtualCatalogsNames,appointDocs:appointDocsNames};var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}var orderColComp=_react2.default.createElement('div',null);if(orderColVisible){var orderColProps={orderColDataSource:_.cloneDeep(orderColDataSource),orderColUsedKeys:_.cloneDeep(orderColUsedKeys),onOk:function onOk(data){_this2.setState({orderColDataSource:data.orderColDataSource,orderColUsedKeys:data.orderColUsedKeys,orderColVisible:false});},onCancel:function onCancel(){_this2.setState({orderColVisible:false});}};orderColComp=_react2.default.createElement(_EOrderCol2.default,orderColProps);}var orderColUsedNames=[];for(var _i=0,len=orderColUsedKeys.length;_i<len;_i++){for(var _j=0,len2=orderColDataSource.length;_j<len2;_j++){if(orderColUsedKeys[_i]==orderColDataSource[_j].key){orderColUsedNames.push(orderColDataSource[_j].fieldName+'-'+(orderColDataSource[_j].orderType=='0'?getLabel(340,'降序'):getLabel(339,'升序')));}}}var authoHeight=autoHeight?"portal-news-authoheight":'';var radioStyle={display:'inline-block',height:'30px',lineHeight:'30px',position:'relative'};return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog portal-news-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(507373,'标签页显示未读'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:isShowSettingShowType=='1'?[{key:'0',selected:true,showname:getLabel(23857,'不显示')},{key:'1',selected:false,showname:_react2.default.createElement('div',null,getLabel(507374,'显示未读标记'),_react2.default.createElement(_ecCom.WeaHelpfulTip,{className:'portal-news-showtype-tip',width:196,title:getLabel(507375,'只统计显示条数中的未读文档'),placement:'bottomLeft'}))},{key:'2',selected:false,showname:_react2.default.createElement('div',null,getLabel(81437,'显示未读数量'),_react2.default.createElement(_ecCom.WeaHelpfulTip,(_React$createElement={className:'portal-news-showtype-tip'},(0,_defineProperty3.default)(_React$createElement,'className','AAAAAAAA'),(0,_defineProperty3.default)(_React$createElement,'width',196),(0,_defineProperty3.default)(_React$createElement,'title',getLabel(507376,'开启后，只统计显示条数中的未读文档，且涉及跨目录统计，可能会有性能问题。')),(0,_defineProperty3.default)(_React$createElement,'placement','bottomLeft'),_React$createElement)))}]:[{key:'0',selected:true,showname:getLabel(23857,'不显示')},{key:'1',selected:false,showname:_react2.default.createElement('div',null,getLabel(507374,'显示未读标记'),_react2.default.createElement(_ecCom.WeaHelpfulTip,{className:'portal-news-showtype-tip',width:196,title:getLabel(507375,'只统计显示条数中的未读文档'),placement:'bottomLeft'}))}],value:isShowSettingShowType=='0'&&this.state.showType=='2'?'0':this.state.showType,detailtype:3,onChange:function onChange(value){_this2.setState({showType:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23784,'文档置顶'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:37,title:getLabel(386382,'请选择'),isSingle:false,replaceDatas:topDocsNames,onChange:function onChange(ids,names,datas){return _this2.setState({topDocs:ids,topDocsNames:datas});},layout:document.body})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'160px'}},_react2.default.createElement(_antd.Select,{ref:'fillStyleSelect',size:'large',className:'eStyle-7 wea-select eeStyle-7',dropdownClassName:'droptwo',dropdownMatchSelectWidth:true,onChange:function onChange(value){_this2.setState({showMode:value,topStyle:''});},style:{width:'175px'},value:showMode},_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'1'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(19525,'列表式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',style:{marginRight:'15px'},src:'/spa/portal/images/news/listStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(19525,'列表式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'4'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(387382,"列表式2")},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/listStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(387382,"列表式2")))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'2'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82760,'上图式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/abovePictureStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82760,'上图式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'10'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82760,'上图式')+2},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/abovePictureStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82760,'上图式')+2))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'11'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82760,'上图式')+3},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/abovePictureStyle3.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82760,'上图式')+3))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'3'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82759,'左图式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/leftPictureStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82759,'左图式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'5'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(23804,'双列式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/doubleListStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(23804,'双列式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'6'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(387383,"摘要式")},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/summaryStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(387383,"摘要式")))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'7'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(387384,"摘要式2")},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/summaryStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(387384,"摘要式2")))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'8'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(127292,'头条式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/topNewsStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(127292,'头条式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'9'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:'头条式2'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/topNewsStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},'头条式2'))))),this.state.showMode=='8'||this.state.showMode=='9'||this.state.showMode=='10'||showMode=='11'?_react2.default.createElement('span',{className:'portal-new-topStyle-select',style:{display:'inline-block',marginLeft:'66px',width:'160px'}},_react2.default.createElement(_antd.Select,{dropdownClassName:'droptwo',dropdownMatchSelectWidth:true,className:'eStyle-7 wea-select',style:{paddingTop:'0px!important',width:175},ref:'fillStyleSelect',size:'large',value:topStyle==''?'1':topStyle,onChange:function onChange(value){_this2.setState({topStyle:value});}},tabNew.topStyle.options.map(function(d){return _react2.default.createElement(Option,{value:d.key},d.showname);}))):''),showMode=='6'||showMode=='7'?'':_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'100%',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12",top:5},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('div',{title:eFieldNewUsedNames.join('，'),style:{marginTop:-18,"-webkit-line-clamp":2,"-webkit-box-orient":"vertical","cursor":"pointer"}},'\xA0\xA0\xA0\xA0',eFieldNewUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15512,'排序字段'),labelCol:{span:6},wrapperCol:{span:16}},orderColComp,_react2.default.createElement('div',{style:{height:'100%',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12",top:5},onClick:function onClick(){return _this2.setState({orderColVisible:true});}}),_react2.default.createElement('div',{title:orderColUsedNames.join('，'),style:{marginTop:-18,"-webkit-box-orient":"vertical","cursor":"pointer","-webkit-line-clamp":2}},'\xA0\xA0\xA0\xA0',orderColUsedNames.join('，')))),this.state.showMode=='1'||this.state.showMode=='5'||this.state.showMode=='8'?'':_react2.default.createElement(_EPicturesSettings2.default,{onChangeSize:this.onChangeSize,pictureWidth:pictureWidth,widthUnit:widthUnit,authoHeight:authoHeight,autoHeight:autoHeight,pictureHeight:pictureHeight,heightUnit:heightUnit}),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',{className:'portal-new-topStyle-select',style:{display:'inline-block',width:'160px'}},_react2.default.createElement(_antd.Select,{dropdownClassName:'dropcdone',dropdownMatchSelectWidth:true,className:'eStyle-7 wea-select ',ref:'fillStyleSelect',size:'large',style:{paddingTop:'0px!important',width:160},value:showMode=='11'&&(scrollDirection=='Up'||scrollDirection=='Down')?'Left':scrollDirection,onChange:function onChange(value){_this2.setState({scrollDirection:value});}},tabNew.scrollDirection.options.map(function(d){if(showMode=='11'){if(d.key!='Up'&&d.key!='Down'){return _react2.default.createElement(Option,{value:d.key},d.value);}else{return _react2.default.createElement(Option,{style:{display:'none'},value:d.key},d.value);}}else return _react2.default.createElement(Option,{value:d.key},d.value);})))),showMode=='11'?(scrollDirection=='Left'||scrollDirection=='Right')&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.scrollSpeed,style:{width:'100px'},onChange:function onChange(value){_this2.setState({scrollSpeed:value});}}),_react2.default.createElement('span',{style:{top:' -7px',position:'relative'}},'ms')):(scrollDirection=='Down'||scrollDirection=='Up')&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.scrollSpeed,style:{width:'100px'},onChange:function onChange(value){_this2.setState({scrollSpeed:value});}}),_react2.default.createElement('span',{style:{top:' -7px',position:'relative'}},'ms')),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20895,'直接打开附件'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'45px',"line-height":27,height:27}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:isOpenAttachment,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){_this2.setState({isOpenAttachment:value});}})),_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(20896,'当文档内容为空，且此文档仅有一个附件时')})),_react2.default.createElement(_ecCom.WeaFormItem,{label:"未读优先显示",labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'45px',"line-height":27,height:27}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:isOrderUnRead,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){_this2.setState({isOrderUnRead:value});}})))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(127253,'来源设置'),showGroup:true,center:true},tabNew.docSourceType.options.map(function(item,index){var dataParams={};var _type=item.type;if('docCatalogs'==_type)dataParams={filtercategoryid:docCatalogs,filtertype:3,noAllDirName:'1'};else dataParams={};var _typeNames=item.type+'Names';return _react2.default.createElement('div',{style:{position:'relative',padding:'8px 0'}},_react2.default.createElement(_antd.Checkbox,{key:index,checked:lodash.indexOf(docSourceType.split(','),item.value)!=-1,style:{position:'absolute',top:'14px',left:-26,width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},onChange:function onChange(e){return _this2.onDocSourceTypeChange(item.value,e.target.checked);}},_react2.default.createElement('span',{title:item.label},item.label)),_react2.default.createElement('div',{style:{paddingLeft:121,width:507}},_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,'请选择'),type:type[_type],dataParams:dataParams,isSingle:false,replaceDatas:replaceDatas[_type],onChange:function onChange(ids,names,datas){var _this2$setState;_this2.setState((_this2$setState={},(0,_defineProperty3.default)(_this2$setState,_type,ids),(0,_defineProperty3.default)(_this2$setState,_typeNames,datas),_this2$setState));if(ids!=''){_this2.onDocSourceTypeChange(item.value,true);}},layout:document.body})));})));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onChangeSize',value:function onChangeSize(string,value){this.setState((0,_defineProperty3.default)({},string,value));}},{key:'onDocSourceTypeChange',value:function onDocSourceTypeChange(value,checked){var docSourceType=this.state.docSourceType;var docSourceTypeArr=docSourceType.split(',');lodash.pull(docSourceTypeArr,value);if(checked){docSourceTypeArr.push(value);}this.setState({docSourceType:docSourceTypeArr.join(',')});}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{var _state2=this.state,ds=_state2.orderColDataSource,keys=_state2.orderColUsedKeys,showMode=_state2.showMode;var orderColUsed=[];for(var i=0,len=keys.length;i<len;i++){for(var j=0,len2=ds.length;j<len2;j++){if(keys[i]==ds[j].key){orderColUsed.push(ds[j]);}}}if(showMode=='6'||showMode=='7'){this.props.onOk((0,_extends3.default)({},this.state,{orderColUsed:orderColUsed,eFieldNewUsedKeys:["7","10","11"]}));}else this.props.onOk((0,_extends3.default)({},this.state,{orderColUsed:orderColUsed}));}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_7_DataSource;}(_react2.default.Component);exports.default=Content_7_DataSource;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _EOrderCol=__webpack_require__(101);var _EOrderCol2=_interopRequireDefault(_EOrderCol);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TreeNode=_antd.Tree.TreeNode;// 流程中心，数据来源
var Content_8_DataSource=function(_React$Component){(0,_inherits3.default)(Content_8_DataSource,_React$Component);function Content_8_DataSource(props){(0,_classCallCheck3.default)(this,Content_8_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_8_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_8_DataSource)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.getTreeData=_this.getTreeData.bind(_this);_this.getTreeNodes=_this.getTreeNodes.bind(_this);_this.onLoadData=_this.onLoadData.bind(_this);_this.onExpand=_this.onExpand.bind(_this);_this.onCheck=_this.onCheck.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);var _props$tabNew=props.tabNew,tabNew=_props$tabNew===undefined?{}:_props$tabNew,_props$tabData=props.tabData,tabData=_props$tabData===undefined?{}:_props$tabData;var _tabData$workflowSour=tabData.workflowSource,workflowSource=_tabData$workflowSour===undefined?{}:_tabData$workflowSour;var typeids=workflowSource.typeids,flowids=workflowSource.flowids,nodeids=workflowSource.nodeids;var wftypeCheckedKeys=typeids?typeids.split(',').map(function(item){return'wftype_'+item;}):[];var wfCheckedKeys=flowids?flowids.split(',').map(function(item){return'wf_'+item;}):[];var nodeCheckedKeys=nodeids?nodeids.split(',').map(function(item){return'node_'+item;}):[];var viewType=tabData.viewType||tabNew.viewType.selected;var isShowNodeBtn=viewType=='1'||viewType=='2'||viewType=='4';// 待办、已办和我的请求显示是否开启节点按钮
var hasNodeData=!!nodeids;_this.state={visible:true,id:tabData.id,title:tabData.title||'',viewType:viewType,isComplete:tabData.isComplete||'0',showCopy:tabData.showCopy||'1',showCount:tabData.showCount||'0',isArrangement:tabData.isArrangement||'0',orderColVisible:false,eFieldNewVisible:false,orderColDataSource:lodash.isEmpty(tabData.orderColDataSource)?tabNew.orderColDataSource:tabData.orderColDataSource,orderColUsedKeys:tabData.orderColUsedKeys||[],isExclude:tabData.isExclude||tabNew.isExclude.selected,workflowSource:workflowSource,treeLoading:false,treeData:[],checkedKeys:{checked:[].concat((0,_toConsumableArray3.default)(wftypeCheckedKeys),(0,_toConsumableArray3.default)(wfCheckedKeys),(0,_toConsumableArray3.default)(nodeCheckedKeys)),halfChecked:[]},expandedKeys:wftypeCheckedKeys,isShowNodeBtn:isShowNodeBtn,isNeedNode:hasNodeData,hasNodeData:hasNodeData,eFieldNewDataSource:tabData.eFieldNewDataSource||tabNew.eFieldNewDataSource,eFieldNewUsedKeys:tabData.eFieldNewUsedKeys||[],scrollDirection:tabData.scrollDirection||tabNew.scrollDirection.selected,showView:tabData.showView||1,showReject:tabData.showReject||1,showTimeout:tabData.showTimeout,showNoReply:tabData.showNoReply||'1',showForward:tabData.showForward||'1',showCY:tabData.showCY||'1',scrollSpeed:tabData.scrollSpeed||'20'};return _this;}(0,_createClass3.default)(Content_8_DataSource,[{key:'componentWillMount',value:function componentWillMount(){var _state=this.state,isExclude=_state.isExclude,isShowNodeBtn=_state.isShowNodeBtn,hasNodeData=_state.hasNodeData,viewType=_state.viewType;if(isExclude!='2'){// 选择或排除选择
this.getTreeData(isShowNodeBtn&&hasNodeData,viewType,isExclude);}}},{key:'render',value:function render(){var _this2=this;var tabNew=this.props.tabNew;var esettingDatas=tabNew.esettingDatas;var _state2=this.state,visible=_state2.visible,title=_state2.title,viewType=_state2.viewType,isComplete=_state2.isComplete,showCopy=_state2.showCopy,isArrangement=_state2.isArrangement,showCount=_state2.showCount,orderColVisible=_state2.orderColVisible,eFieldNewVisible=_state2.eFieldNewVisible,orderColDataSource=_state2.orderColDataSource,orderColUsedKeys=_state2.orderColUsedKeys,showTimeout=_state2.showTimeout,isExclude=_state2.isExclude,treeLoading=_state2.treeLoading,treeData=_state2.treeData,checkedKeys=_state2.checkedKeys,expandedKeys=_state2.expandedKeys,isShowNodeBtn=_state2.isShowNodeBtn,isNeedNode=_state2.isNeedNode,hasNodeData=_state2.hasNodeData,eFieldNewDataSource=_state2.eFieldNewDataSource,eFieldNewUsedKeys=_state2.eFieldNewUsedKeys,scrollDirection=_state2.scrollDirection,showView=_state2.showView,showReject=_state2.showReject,showNoReply=_state2.showNoReply,status=_state2.status,showForward=_state2.showForward,showCY=_state2.showCY;var field={showView:showView,showReject:showReject,showTimeout:showTimeout,isArrangement:isArrangement,showNoReply:showNoReply,showCopy:showCopy,showForward:showForward,showCY:showCY};var fieldTitle={showView:getLabel(391236,"勾选后，显示包含“转发给我”、“抄送给我”这些提交或查看均不影响流程流转的流程"),showReject:getLabel(391237,"勾选后，显示包含退回给“我”的流程"),showTimeout:getLabel(391238,"勾选后，将优先显示超时流程，再按设置的排序字段排序")};var orderColComp=_react2.default.createElement('div',null);if(orderColVisible){var orderColProps={orderColDataSource:_.cloneDeep(orderColDataSource),orderColUsedKeys:_.cloneDeep(orderColUsedKeys),onOk:function onOk(data){_this2.setState({orderColDataSource:data.orderColDataSource,orderColUsedKeys:data.orderColUsedKeys,orderColVisible:false});},onCancel:function onCancel(){_this2.setState({orderColVisible:false});}};orderColComp=_react2.default.createElement(_EOrderCol2.default,orderColProps);}var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var orderColUsedNames=[];for(var i=0,len=orderColUsedKeys.length;i<len;i++){for(var j=0,len2=orderColDataSource.length;j<len2;j++){if(orderColUsedKeys[i]==orderColDataSource[j].key){orderColUsedNames.push(orderColDataSource[j].fieldName+'-'+(orderColDataSource[j].orderType=='0'?getLabel(340,"降序"):getLabel(339,"升序")));}}}var eFieldNewUsedNames=[];for(var _i=0;_i<eFieldNewUsedKeys.length;_i++){for(var _j=0;_j<eFieldNewDataSource.length;_j++){if(eFieldNewUsedKeys[_i]==eFieldNewDataSource[_j].key){eFieldNewUsedNames.push(eFieldNewDataSource[_j].name);}}}var orderTitles="";for(var _i2=0;_i2<orderColUsedNames.length;_i2++){orderTitles=orderTitles+orderColUsedNames[_i2];}var eFieldTitles="";for(var _i3=0;_i3<eFieldNewUsedNames.length;_i3++){eFieldTitles=eFieldTitles+eFieldNewUsedNames[_i3];}var spanWidth='92px';var divWidth='136px';if(esettingDatas[viewType]&&esettingDatas[viewType].typesetting.typedatas&&esettingDatas[viewType].typesetting.typedatas.length<=1){spanWidth='auto';divWidth='auto';}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:visible,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:'700px',height:$(document).height()+"px"},resize:true,hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement('div',{style:{minHeight:'440px'}},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true,style:{maxHeight:parseInt(window.innerHeight)-300+'px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(17483,'查看类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaSelect,{options:esettingDatas.options,value:viewType,onChange:function onChange(value){var isShowNodeBtn=value=='1'||value=='2'||value=='4';_this2.getTreeData(isShowNodeBtn&&hasNodeData,value);_this2.setState({viewType:value,isShowNodeBtn:isShowNodeBtn,showCount:'0',showView:'1',showReject:'0',showTimeout:'0'});}})),esettingDatas[viewType]&&esettingDatas[viewType].typesetting&&_react2.default.createElement('div',{style:{height:'30px',marginTop:'10px'}},esettingDatas[viewType].typesetting.typedatas?esettingDatas[viewType].typesetting.typedatas.map(function(item){return _react2.default.createElement('div',{style:{"top":"3px",position:"relative","width":divWidth,"display":'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:field[item.field]||item.defaultVal,onChange:function onChange(value){_this2.setState((0,_defineProperty3.default)({},item.field,value));}})),_react2.default.createElement('span',{style:{margin:'0px 4px -3px 7px',width:spanWidth,overflow:" hidden",textOverflow:'ellipsis',whiteSpace:" nowrap",display:'inline-block'},title:item.labelname},item.labelname),item.field!='isArrangement'&&fieldTitle[item.field]&&_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:fieldTitle[item.field]}));}):_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:esettingDatas[viewType].typesetting.option,value:isComplete,onChange:function onChange(value){return _this2.setState({isComplete:value});}})))),esettingDatas[viewType]&&esettingDatas[viewType].showcount&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(390629,'显示数量 '),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{height:'30px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:esettingDatas[viewType].showcount.option,detailtype:3,value:showCount,onChange:function onChange(value){_this2.setState({showCount:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-showfield',title:eFieldTitles},'\xA0\xA0\xA0\xA0',eFieldNewUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15512,'排序字段'),labelCol:{span:6},wrapperCol:{span:16}},orderColComp,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({orderColVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-ordercol',title:orderTitles},'\xA0\xA0\xA0\xA0',orderColUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.scrollDirection.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:scrollDirection,onChange:function onChange(value){_this2.setState({scrollDirection:value});}}))),(scrollDirection=='Down'||scrollDirection=='Up')&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.scrollSpeed,style:{width:'100px'},onChange:function onChange(value){_this2.setState({scrollSpeed:value});}}),_react2.default.createElement('span',{style:{top:' -7px',position:'relative'}},'ms')),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21672,'流程来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.isExclude.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:isExclude,onChange:function onChange(value){_this2.setState({isExclude:value});if(isExclude=='2')_this2.setState({workflowSource:{}});if(value!='2'){_this2.getTreeData(isShowNodeBtn&&hasNodeData,viewType,value);}}})),isExclude!='2'?_react2.default.createElement(_antd.Spin,{spinning:treeLoading},_react2.default.createElement('div',{style:{width:'465px',height:'300px',overflow:'auto',msOverflowStyle:'auto'}},isExclude!='3'&&isExclude!='4'&&_react2.default.createElement('div',{style:{display:isShowNodeBtn?'block':'none',position:'absolute',top:'10px',right:'20px'}},_react2.default.createElement(_antd.Button,{size:'small',title:isNeedNode?getLabel(386556,'包含节点'):getLabel(386557,'不包含节点'),onClick:function onClick(){return _this2.getTreeData(!isNeedNode,viewType);}},_react2.default.createElement('i',{className:isNeedNode?'icon-coms-DisplaySubordinates':'icon-coms-NoDisplayOfSubordinates',style:{color:isNeedNode?'rgb(45, 183, 245)':''}}))),_react2.default.createElement(_antd.Tree,{checkable:true,checkStrictly:true,expandedKeys:expandedKeys,checkedKeys:checkedKeys,onExpand:this.onExpand,loadData:this.onLoadData,onCheck:this.onCheck},this.getTreeNodes(treeData)))):''))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'getTreeData',value:function getTreeData(isNeedNode,viewType,isExclude){var _this3=this;this.setState({treeLoading:true,isNeedNode:isNeedNode});var api='/api/public/browser/data/-99991';if(isExclude=='3'||isExclude=='4'){api='/api/portal/workFlowType/getWorkFlowTypeDatas';}_ecCom.WeaTools.callApi(api||'/api/public/browser/data/-99991','GET',{isWfTree:1,needNode:isNeedNode?1:0,containsOfs:1,viewtype:viewType}).then(function(data){if(isExclude=='3'||isExclude=='4'){_this3.setState({treeLoading:false,treeData:data.wfType.datas});}else{_this3.setState({treeLoading:false,treeData:data.datas.subs});}if(isNeedNode&&isExclude!='3'&&isExclude=='4'){var workflowSource=_this3.state.workflowSource;var _workflowSource$flowi=workflowSource.flowids,flowids=_workflowSource$flowi===undefined?'':_workflowSource$flowi;var flowidarr=flowids.split(',');if(flowidarr&&flowidarr.length){for(var i=0,len=flowidarr.length;i<len;i++){_this3.onLoadData({props:{id:flowidarr[i]}},true);}}}});}},{key:'getTreeNodes',value:function getTreeNodes(treeData){var loop=function loop(data,pids){return data.map(function(item){var _pids=_.cloneDeep(pids);_pids.push(item.type+'_'+item.id);var children=item.subs;if(children&&children.length){return _react2.default.createElement(TreeNode,{key:item.type+'_'+item.id,id:item.id,pids:_pids,title:item.name,isLeaf:!item.isParent},loop(children,_pids));}else{return _react2.default.createElement(TreeNode,{key:item.type+'_'+item.id,id:item.id,pids:_pids,title:item.name,isLeaf:!item.isParent});}});};return loop(treeData,[]);}},{key:'onLoadData',value:function onLoadData(node,isInit){var _this4=this;var id=node.props.id;if(!isInit){this.setState({treeLoading:true});}_ecCom.WeaTools.callApi('/api/public/browser/data/-99991','GET',{isWfTree:1,needNode:1,type:'wf',id:id}).then(function(data){var loop=function loop(treeData,pid,data){for(var i=0,len=treeData.length;i<len;i++){if(treeData[i].id==pid&&treeData[i].type=='wf'){treeData[i].subs=data||[];break;}else{var children=treeData[i].subs;if(children&&children.length){loop(children,pid,data);}}}};var _state3=_this4.state,treeData=_state3.treeData,expandedKeys=_state3.expandedKeys;loop(treeData,id,data.datas);_this4.setState({treeLoading:false,treeData:treeData,expandedKeys:[].concat((0,_toConsumableArray3.default)(expandedKeys),['wf_'+id])});});}},{key:'onExpand',value:function onExpand(expandedKeys){this.setState({expandedKeys:expandedKeys});}},{key:'onCheck',value:function onCheck(checkedKeys,e){var _this5=this;var _e$node$props=e.node.props,eventKey=_e$node$props.eventKey,pids=_e$node$props.pids,_e$node$props$childre=_e$node$props.children,children=_e$node$props$childre===undefined?[]:_e$node$props$childre;var childrenKeys=this.getChildrenKeys(children);var grandSonKey='';children.map(function(item){if(item.props.children){var itemChildren=_this5.getChildrenKeys(item.props.children);if(itemChildren){grandSonKey=grandSonKey+','+itemChildren;};};});var grandSonKeys=grandSonKey.split(',');var checked=[];if(e.checked){var _ref;checked=(_ref=_).concat.apply(_ref,(0,_toConsumableArray3.default)(pids).concat((0,_toConsumableArray3.default)(childrenKeys),(0,_toConsumableArray3.default)(grandSonKeys),[checkedKeys.checked]));}else{checked=_.pullAll(checkedKeys.checked,_.concat(childrenKeys,grandSonKeys));}var _checked=_.uniq(checked);var _state4=this.state,isShowNodeBtn=_state4.isShowNodeBtn,isNeedNode=_state4.isNeedNode;var typeids='',flowids='',nodeids='';for(var i=0,len=_checked.length;i<len;i++){var _keys=_checked[i].split('_');if(_keys[0]=='wftype'){typeids+=_keys[1]+',';}else if(_keys[0]=='wf'){flowids+=_keys[1]+',';}else if(isShowNodeBtn&&isNeedNode&&_keys[0]=='node'){nodeids+=_keys[1]+',';}}this.setState({checkedKeys:{checked:_checked,halfChecked:[]},workflowSource:{typeids:typeids,flowids:flowids,nodeids:nodeids}});}},{key:'getChildrenKeys',value:function getChildrenKeys(children){var keys=[];for(var i=0,len=children.length;i<len;i++){var _children$i=children[i],key=_children$i.key,props=_children$i.props;keys.push(key);if(props.children){var _keys2=this.getChildrenKeys(props.children);_keys2.push.apply(_keys2,(0,_toConsumableArray3.default)(_keys2));}}return keys;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{var _state5=this.state,ds=_state5.orderColDataSource,keys=_state5.orderColUsedKeys;var orderColUsed=[];for(var i=0,len=keys.length;i<len;i++){for(var j=0,len2=ds.length;j<len2;j++){if(keys[i]==ds[j].key){orderColUsed.push(ds[j]);}}}var _state6=this.state,workflowSource=_state6.workflowSource,isShowNodeBtn=_state6.isShowNodeBtn,isNeedNode=_state6.isNeedNode,isExclude=_state6.isExclude;var typeids=workflowSource.typeids,flowids=workflowSource.flowids,nodeids=workflowSource.nodeids;if(isExclude=='3'||isExclude=='4'){flowids="";nodeids="";}nodeids=isShowNodeBtn&&isNeedNode?nodeids:'';this.props.onOk(_.omit((0,_extends3.default)({},this.state,{orderColUsed:orderColUsed,workflowSource:{typeids:typeids,flowids:flowids,nodeids:nodeids}}),'treeData'));}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_8_DataSource;}(_react2.default.Component);exports.default=Content_8_DataSource;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义页面，数据来源
var Content_29_DataSource=function(_React$Component){(0,_inherits3.default)(Content_29_DataSource,_React$Component);function Content_29_DataSource(props){(0,_classCallCheck3.default)(this,Content_29_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_29_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_29_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',href:_this.props.tabData.href,moreHref:_this.props.tabData.moreHref,showtype:_this.props.tabData.showtype||_this.props.tabNew.showtype.selected,pageHeight:_this.props.tabData.pageHeight,componentProps:_this.props.tabData.componentProps||[],contenttype:_this.props.tabData.contenttype||'1',isdelshow:-1};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.delProps=_this.delProps.bind(_this);_this.setProps=_this.setProps.bind(_this);_this.addProps=_this.addProps.bind(_this);return _this;}(0,_createClass3.default)(Content_29_DataSource,[{key:'addProps',value:function addProps(){var componentProps=this.state.componentProps;componentProps.push({name:'',value:''});this.setState({componentProps:componentProps});}},{key:'delProps',value:function delProps(i){var componentProps=this.state.componentProps;componentProps.splice(i,1);this.setState({componentProps:componentProps});}},{key:'setProps',value:function setProps(value,type,i){var componentProps=this.state.componentProps;var item=componentProps[i];item[type]=value;componentProps.splice(i,1,item);this.setState({componentProps:componentProps});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,href=_state.href,moreHref=_state.moreHref,showtype=_state.showtype,pageHeight=_state.pageHeight,contenttype=_state.contenttype,componentProps=_state.componentProps,isdelshow=_state.isdelshow;var tabNew=this.props.tabNew;var height=316;if(contenttype=='2'){var length=componentProps.length;if(length>3)length=3;height=362+length*35;}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:height},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20017,'引用地址'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:href,onChange:function onChange(value){return _this2.setState({href:value});}}),_react2.default.createElement('div',{style:{position:'absolute',top:'6px',right:'-22px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(386567,'外部地址，请在地址前加上http://或https://'),isCenter:true}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386568,'加载方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.showtype.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:showtype,style:{width:'100px'},onChange:function onChange(value){_this2.setState({showtype:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386563,'More地址'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:moreHref,onChange:function onChange(value){return _this2.setState({moreHref:value});}}),_react2.default.createElement('div',{style:{position:'absolute',top:'6px',right:'-22px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(386567,'外部地址，请在地址前加上http://或https://'),isCenter:true}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21568,'页面高度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:pageHeight,onChange:function onChange(value){return _this2.setState({pageHeight:value});}}),_react2.default.createElement('div',{style:{position:'absolute',top:'6px',right:'-22px'}},'px'))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_29_DataSource;}(_react2.default.Component);exports.default=Content_29_DataSource;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _SynergyParams4Report=__webpack_require__(239);var _SynergyParams4Report2=_interopRequireDefault(_SynergyParams4Report);var _echart=__webpack_require__(132);var _comsMobx=__webpack_require__(258);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 图表元素，数据来源
var Content_reportForm_DataSource=function(_React$Component){(0,_inherits3.default)(Content_reportForm_DataSource,_React$Component);function Content_reportForm_DataSource(props){(0,_classCallCheck3.default)(this,Content_reportForm_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_reportForm_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_reportForm_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',reportFormType:_this.props.tabData.reportFormType||_this.props.tabNew.reportFormType.selected,decimalDigits:_this.props.tabData.decimalDigits||_this.props.tabNew.decimalDigits,reportFormWidth:_this.props.tabData.reportFormWidth||_this.props.tabNew.reportFormWidth,reportFormHeight:_this.props.tabData.reportFormHeight||_this.props.tabNew.reportFormHeight,dataSource:_this.props.tabData.dataSource||_this.props.tabNew.dataSource.selected,reportFormSql:_this.props.tabData.reportFormSql,showLegend:_this.props.tabData.showLegend||'1',isSaveTemplate:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_reportForm_DataSource,[{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,tabNew=_props.tabNew,tabData=_props.tabData,synergyParams=_props.synergyParams;var stype=synergyParams.stype,pagetype=synergyParams.pagetype,ispagedeal=synergyParams.ispagedeal;var _state=this.state,title=_state.title,reportFormType=_state.reportFormType,decimalDigits=_state.decimalDigits,reportFormWidth=_state.reportFormWidth,reportFormHeight=_state.reportFormHeight,dataSource=_state.dataSource,reportFormSql=_state.reportFormSql,isSaveTemplate=_state.isSaveTemplate,showLegend=_state.showLegend;var _reportFormWidth=reportFormWidth;if(reportFormWidth==undefined){_reportFormWidth=this.props.tabNew.reportFormWidth;}var _reportFormHeight=reportFormHeight;if(reportFormHeight==undefined){_reportFormHeight=this.props.tabNew.reportFormHeight;}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:426},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84022,'图表标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaError,{style:{width:'100%'},ref:function ref(el){_this2.title=el;},error:getLabel(385021,'数据为空'),tipPosition:'bottom'},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84021,'图表类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_echart.EchartTemplate,{sysDatas:tabNew.reportFormType.options,value:reportFormType,onChange:function onChange(value){return _this2.setState({reportFormType:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15212,'小数位数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInputNumber,{value:decimalDigits,min:0,onChange:function onChange(value){return _this2.setState({decimalDigits:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84023,'图表大小'),labelCol:{span:6},wrapperCol:{span:16},style:{lineHeight:'30px'}},_react2.default.createElement('div',{style:{verticalAlign:'middle',width:'50px',display:'inline-block'}},getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInputNumber,{value:_reportFormWidth,min:1,style:{width:'128px',marginRight:'26px'},onBlur:function onBlur(value){if(value==''){_this2.setState({reportFormWidth:200});}},onChange:function onChange(value){_this2.setState({reportFormWidth:value});}}),_react2.default.createElement('div',{style:{verticalAlign:'middle',width:'50px',display:'inline-block'}},getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInputNumber,{value:_reportFormHeight,min:1,style:{width:'128px'},onBlur:function onBlur(value){if(value==''){_this2.setState({reportFormHeight:200});}},onChange:function onChange(value){_this2.setState({reportFormHeight:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28006,'数据来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.dataSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:dataSource// style={{width: '200px'}}
,onChange:function onChange(value){_this2.setState({dataSource:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84025,'图表来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-reportform-template-btns'},_react2.default.createElement('div',{style:{display:'inline-block',paddingRight:'45px',lineHeight:'16px'}},_react2.default.createElement('span',{style:{paddingRight:'5px'}},getLabel(127215,"保存到模板库")),_react2.default.createElement(_ecCom.WeaCheckbox,{helpfulTip:getLabel(390861,"是否保存到模板库"),onChange:function onChange(){return _this2.setState({isSaveTemplate:!isSaveTemplate});}})),_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.sp4r.onShow();}},getLabel(33749,'系统变量')),stype=='wf'&&pagetype=='operat'&&ispagedeal=='1'?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.sp4r.onShow(synergyParams);}},getLabel(130009,'表单变量')):'',_react2.default.createElement(_ecCom.WeaBrowser,{type:'reportformsqltemplate',inputStyle:{width:'373px'},title:getLabel(386595,'选择SQL模板'),hasAdvanceSerach:true,isSingle:true,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',customized:true,onChange:function onChange(ids,names,datas){if(datas[0]){_this2.setState({reportFormSql:datas[0].reportformsql});}}},_react2.default.createElement('span',{className:'synergy-setting-btn'},getLabel(386596,'SQL模板'))),_react2.default.createElement(SQLTemplate,{ref:'SQLTemplate',onEdit:function onEdit(sqlitem){return _this2.refs.SaveSQLTemplate.setState((0,_extends3.default)({},sqlitem,{visible:true}));}})),_react2.default.createElement(_ecCom.WeaTextarea,{value:reportFormSql,minRows:5,onChange:function onChange(value){_this2.setState({reportFormSql:value});}}),_react2.default.createElement(_SynergyParams4Report2.default,{ref:function ref(sp4r){return _this2.sp4r=sp4r;}}),_react2.default.createElement(SaveSQLTemplate,{ref:'SaveSQLTemplate',onRefresh:function onRefresh(){return _this2.refs.SQLTemplate.getSessionKey();},reportFormSql:reportFormSql}),_react2.default.createElement(_ecCom.WeaCheckbox,{value:showLegend,onChange:function onChange(v){return _this2.setState({showLegend:v});},style:{margin:'12px 10px 0px 0px'}}),_react2.default.createElement('span',null,'显示图例'))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var isSaveTemplate=this.state.isSaveTemplate;if(!this.state.title){this.title.showError();}else{this.props.onOk(this.state);isSaveTemplate&&this.onAddSqlTemplate();}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'onAddSqlTemplate',value:function onAddSqlTemplate(){var _this3=this;var _state2=this.state,title=_state2.title,reportFormSql=_state2.reportFormSql;_ecCom.WeaTools.callApi('/api/portal/sqltemplate/update','POST',{id:'',title:title,reportFormSql:reportFormSql}).then(function(result){if(result.api_status=='2'){_antd.message.error(result.error_msg);}else{_antd.message.success(getLabel(83551,"保存成功！"));_this3.setState({visible:false});}});}}]);return Content_reportForm_DataSource;}(_react2.default.Component);exports.default=Content_reportForm_DataSource;var LogStore=_comsMobx.WeaLogView.LogStore;var logStore=new LogStore();var WeaLogViewComp=_comsMobx.WeaLogView.Component;var WeaTable=_comsMobx.WeaTableNew.WeaTable,TableStore=_comsMobx.WeaTableNew.TableStore;var tableStore=new TableStore();var SQLTemplate=function(_React$Component2){(0,_inherits3.default)(SQLTemplate,_React$Component2);function SQLTemplate(props){(0,_classCallCheck3.default)(this,SQLTemplate);var _this4=(0,_possibleConstructorReturn3.default)(this,(SQLTemplate.__proto__||(0,_getPrototypeOf2.default)(SQLTemplate)).call(this,props));_this4.getButtons=_this4.getButtons.bind(_this4);_this4.getSessionKey=_this4.getSessionKey.bind(_this4);_this4.getRightMenu=_this4.getRightMenu.bind(_this4);_this4.onRightMenuClick=_this4.onRightMenuClick.bind(_this4);_this4.onOperatesClick=_this4.onOperatesClick.bind(_this4);_this4.onSubmit=_this4.onSubmit.bind(_this4);_this4.doDelete=_this4.doDelete.bind(_this4);_this4.deleteRows=_this4.deleteRows.bind(_this4);_this4.onLogVisibleChange=_this4.onLogVisibleChange.bind(_this4);_this4.state={sessionkey:'',loading:false,visible:false,title:'',creator:'',replaceDatas:[],showSearchAd:false,selectedRowKeys:'',logVisible:false};return _this4;}(0,_createClass3.default)(SQLTemplate,[{key:'getSessionKey',value:function getSessionKey(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({visible:true,loading:true});if(this.state.sessionkey){var _tableStore$current=tableStore.current,current=_tableStore$current===undefined?1:_tableStore$current;if(!params.current){params.current=current;}}if(params.title===undefined){params.title=this.state.title;}if(params.creator===undefined){params.creator=this.state.creator;}_ecCom.WeaTools.callApi('/api/portal/sqltemplate/datas','POST',params).then(function(data){var status=data.status||'1';if(status=='1'){_this5.setState({sessionkey:data.sessionkey,loading:false,title:params.title,creator:params.creator,showSearchAd:false,selectedRowKeys:''});tableStore.getDatas(data.sessionkey,params.current||1);}else if(status=='2'){_antd.message.error(data.errormsg);return;}});}},{key:'onSubmit',value:function onSubmit(){var _state3=this.state,id=_state3.id,reportFormSql=_state3.reportFormSql;if(id){this.props.onChange(reportFormSql);}this.setState({visible:false});}},{key:'getButtons',value:function getButtons(){var _this6=this;var selectedRowKeys=this.state.selectedRowKeys;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this6.props.onEdit({id:'',title:'',reportFormSql:'',type:'add'});}},getLabel(365,'新建')));btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.deleteRows,disabled:!selectedRowKeys},getLabel(32136,'批量删除')));return btns;}},{key:'deleteRows',value:function deleteRows(){var ids="";if(this.state.sessionkey){var selectedRowKeys=tableStore.selectedRowKeys;ids=selectedRowKeys.join(",");}this.doDelete(ids);}},{key:'doDelete',value:function doDelete(ids){var _this7=this;_antd.Modal.confirm({title:'信息确认',content:getLabel(15097,'确定要删除吗？'),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/sqltemplate/delete','POST',{ids:ids}).then(function(data){if(data.api_status==='success'){_antd.message.success(getLabel(83472,"删除成功！"));_this7.getSessionKey();}else{_antd.message.error(getLabel(83473,"删除失败！"));}});}});}},{key:'getRightMenu',value:function getRightMenu(){var selectedRowKeys=this.state.selectedRowKeys;var btns=[];btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(365,'新建')});btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),disabled:!selectedRowKeys,content:getLabel(32136,'批量删除')});btns.push({key:'log',icon:_react2.default.createElement('i',{className:'icon-coms-Print-log'}),content:getLabel(83,'日志'),onClick:this.onLogVisibleChange});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.props.onEdit({id:'',title:'',reportFormSql:'',type:'add'});break;case'1':this.deleteRows();break;}}},{key:'onOperatesClick',value:function onOperatesClick(record,index,operate,flag){var id=record.randomFieldId;switch(operate.index){case'0':this.props.onEdit({id:id,title:record.title,reportFormSql:record.reportformsql,type:'edit'});break;case'1':this.doDelete(id);break;case'2':break;}}},{key:'onLogVisibleChange',value:function onLogVisibleChange(){var logVisible=this.state.logVisible;this.setState({logVisible:!logVisible});}},{key:'render',value:function render(){var _this8=this;var _state4=this.state,visible=_state4.visible,loading=_state4.loading,datas=_state4.datas,title=_state4.title,replaceDatas=_state4.replaceDatas,logVisible=_state4.logVisible;var rowSelection={onChange:function onChange(selectedRowKeys,selectedRows){_this8.setState({selectedRowKeys:''+selectedRowKeys});}};return _react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',null,_react2.default.createElement(_antd.Icon,{type:'setting',title:getLabel(388014,"sql模板管理"),className:'synergy-setting-btn synergy-setting-btn-setting',onClick:function onClick(){return _this8.getSessionKey({title:'',creator:'',current:1});}})),_react2.default.createElement(WeaLogViewComp,{visible:logVisible,onCancel:this.onLogVisibleChange,logStore:logStore,logType:'6',logSmallType:'25'}),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel(388014,"sql模板管理"),visible:visible,closable:true,onCancel:function onCancel(){return _this8.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:900,height:520}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',null,_react2.default.createElement('div',{style:{lineHeight:'60px'}},_react2.default.createElement(_ecCom.WeaTab,{datas:[],searchType:['base','advanced'],showSearchAd:this.state.showSearchAd,searchsBaseValue:title,setShowSearchAd:function setShowSearchAd(bool){_this8.setState({showSearchAd:bool});},buttonsAd:[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this8.getSessionKey();}},getLabel(197,'搜索')),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return _this8.setState({title:'',creator:'',replaceDatas:[]});}},getLabel(2022,'重置')),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return _this8.setState({showSearchAd:false});}},getLabel(31129,'取消'))],advanceHeight:108,searchsAd:_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:false,showGroup:true,items:[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33439,"名称"),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement('div',{style:{marginTop:'5px'}},_react2.default.createElement(_ecCom.WeaInput,{value:title,onChange:function onChange(value){return _this8.setState({title:value});}}))),colSpan:1},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(882,"创建人"),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement('div',{style:{marginTop:'19px'}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'17',replaceDatas:replaceDatas,hasAdvanceSerach:true,title:getLabel(83496,"多人力资源"),isSingle:false,onChange:function onChange(ids,names,datas){_this8.setState({creator:''+ids,replaceDatas:datas});}}))),colSpan:1}]}),keyParam:'viewcondition'//主键
,countParam:'groupid'//数量
,onSearch:function onSearch(){return _this8.getSessionKey();},onSearchChange:function onSearchChange(value){return _this8.setState({title:value});}})),_react2.default.createElement('div',null,_react2.default.createElement(WeaTable,{needScroll:true,rowSelection:rowSelection,comsWeaTableStore:tableStore,onOperatesClick:this.onOperatesClick}))))));}}]);return SQLTemplate;}(_react2.default.Component);var SaveSQLTemplate=function(_React$Component3){(0,_inherits3.default)(SaveSQLTemplate,_React$Component3);function SaveSQLTemplate(props){(0,_classCallCheck3.default)(this,SaveSQLTemplate);var _this9=(0,_possibleConstructorReturn3.default)(this,(SaveSQLTemplate.__proto__||(0,_getPrototypeOf2.default)(SaveSQLTemplate)).call(this,props));_this9.getButtons=_this9.getButtons.bind(_this9);_this9.getRightMenu=_this9.getRightMenu.bind(_this9);_this9.onRightMenuClick=_this9.onRightMenuClick.bind(_this9);_this9.onSubmit=_this9.onSubmit.bind(_this9);_this9.state={visible:false,id:'',type:'',title:'',reportFormSql:''};return _this9;}(0,_createClass3.default)(SaveSQLTemplate,[{key:'onSubmit',value:function onSubmit(){var _this10=this;var _state5=this.state,id=_state5.id,type=_state5.type,title=_state5.title,reportFormSql=_state5.reportFormSql;if(!title.trim()){this.title.showError();return;}_ecCom.WeaTools.callApi('/api/portal/sqltemplate/update','POST',{id:id,title:title,reportFormSql:reportFormSql}).then(function(result){if(result.api_status=='2'){_antd.message.error(result.error_msg);}else{_this10.props.onRefresh();_antd.message.success(getLabel(83551,"保存成功！"));_this10.setState({visible:false});}});}},{key:'getButtons',value:function getButtons(){var _this11=this;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onSubmit},getLabel(826,'确定')));btns.push(_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this11.setState({visible:false});}},getLabel(31129,'取消')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(826,'确定')});btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.onSubmit();break;case'1':this.setState({visible:false});break;}}},{key:'render',value:function render(){var _this12=this;var _state6=this.state,title=_state6.title,visible=_state6.visible,reportFormSql=_state6.reportFormSql;var d_title=getLabel(388015,"编辑sql模板");return _react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaDialog,{title:d_title,visible:visible,closable:true,onCancel:function onCancel(){return _this12.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),zIndex:1051,style:{width:600,height:300}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{style:{width:'90%',margin:'0 auto',paddingTop:'22px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33439,'名称'),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaError,{style:{width:'100%'},ref:function ref(el){_this12.title=el;},error:getLabel(385021,'数据为空'),tipPosition:'bottom'},_react2.default.createElement(_ecCom.WeaInput,{viewAttr:3,style:{width:280},fieldName:'title',value:title,onChange:function onChange(value){return _this12.setState({title:value});}}))),_react2.default.createElement('div',{style:{marginTop:'35px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28479,"SQL语句"),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaTextarea,{value:reportFormSql,minRows:5,onChange:function onChange(value){_this12.setState({reportFormSql:value});}})))))));}}]);return SaveSQLTemplate;}(_react2.default.Component);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SynergyParams4Report=function(_React$Component){(0,_inherits3.default)(SynergyParams4Report,_React$Component);function SynergyParams4Report(props){(0,_classCallCheck3.default)(this,SynergyParams4Report);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergyParams4Report.__proto__||(0,_getPrototypeOf2.default)(SynergyParams4Report)).call(this,props));_this.state={visible:false,loading:false,data:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(SynergyParams4Report,[{key:'render',value:function render(){var _state=this.state,visible=_state.visible,loading=_state.loading,data=_state.data;var columns=[{key:'paramName',title:getLabel(386542,'变量名'),dataIndex:'paramName',width:'50%'},{key:'paramShowName',title:getLabel(386543,'变量显示名'),dataIndex:'paramShowName',width:'25%'},{key:'paramType',title:getLabel(386544,'变量类型'),dataIndex:'paramType',width:'25%'}];return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:getLabel(84027,'图表参数信息'),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',style:{width:500,height:460},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:data,pagination:false}));}},{key:'onShow',value:function onShow(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({visible:true,loading:true});var _params$hpid=params.hpid,hpid=_params$hpid===undefined?'':_params$hpid;_ecCom.WeaTools.callApi('/api/portal/synergy/getReportParams','GET',{hpid:hpid}).then(function(data){_this2.setState({loading:false,data:data.data});});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(309,'关闭')));return buttons;}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,data:[]});}}]);return SynergyParams4Report;}(_react2.default.Component);exports.default=SynergyParams4Report;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//图表元素
var EChartView=function(_React$Component){(0,_inherits3.default)(EChartView,_React$Component);function EChartView(){(0,_classCallCheck3.default)(this,EChartView);return(0,_possibleConstructorReturn3.default)(this,(EChartView.__proto__||(0,_getPrototypeOf2.default)(EChartView)).apply(this,arguments));}(0,_createClass3.default)(EChartView,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.refs.chart&&this.refs.chart.resize();}},{key:'render',value:function render(){var _React$createElement;var _props=this.props,eid=_props.eid,width=_props.width,height=_props.height,option=_props.option,charttype=_props.charttype,key=_props.key;return _react2.default.createElement('div',{style:{width:width,height:height,margin:'0 auto'},id:'reportformchart_'+eid},option&&_react2.default.createElement(_ecCom.WeaEchart,(_React$createElement={chartName:'',ref:'chart',key:key,useDefault:true},(0,_defineProperty3.default)(_React$createElement,'key',charttype),(0,_defineProperty3.default)(_React$createElement,'option',option),(0,_defineProperty3.default)(_React$createElement,'series',option.series),_React$createElement)));}}]);return EChartView;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EChartView=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EChartView);exports.default=EChartView;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);var _ecCom=__webpack_require__(5);var _EchartList=__webpack_require__(243);var _EchartList2=_interopRequireDefault(_EchartList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EchartTemplate=function(_React$Component){(0,_inherits3.default)(EchartTemplate,_React$Component);function EchartTemplate(props){(0,_classCallCheck3.default)(this,EchartTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(EchartTemplate.__proto__||(0,_getPrototypeOf2.default)(EchartTemplate)).call(this,props));_this.state={datas:[]};_this.onSetDatas=_this.onSetDatas.bind(_this);_this.onEdit=_this.onEdit.bind(_this);return _this;}(0,_createClass3.default)(EchartTemplate,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;_ecCom.WeaTools.callApi('/api/portal/hpEcharts/datas','POST',{}).then(function(result){_this2.setState(result);});}},{key:'onSetDatas',value:function onSetDatas(type,item){var datas=[].concat((0,_toConsumableArray3.default)(this.state.datas));if(type=="add"){datas.push(item);}else if(type=="update"){datas.filter(function(obj,index,arr){if(obj.id==item.id){datas.splice(index,1,(0,_objectAssign2.default)({},obj,item));return true;}return false;});}this.setState({datas:datas});}},{key:'onEdit',value:function onEdit(){this.refs.EChartList.setState({visible:true});}},{key:'render',value:function render(){var _props=this.props,_onChange=_props.onChange,value=_props.value,sysDatas=_props.sysDatas;var _state=this.state,id=_state.id,datas=_state.datas;return _react2.default.createElement('div',{className:'portal-esetting-reportform-template'},_react2.default.createElement(_EchartList2.default,{ref:'EChartList',sysDatas:sysDatas,datas:datas,onChangeDatas:this.onSetDatas}),_react2.default.createElement(_ecCom.WeaSelect,{options:sysDatas.map(function(item,i){return{key:item.key,selected:false,showname:item.value};}),value:value// style={{width: '200px'}}
,onChange:function onChange(value){return _onChange(value);}}));}}]);return EchartTemplate;}(_react2.default.Component);exports.default=EchartTemplate;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EchartEditor=__webpack_require__(244);var _EchartEditor2=_interopRequireDefault(_EchartEditor);var _examples=__webpack_require__(247);var _examples2=_interopRequireDefault(_examples);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var EChartList=function(_React$Component){(0,_inherits3.default)(EChartList,_React$Component);function EChartList(props){(0,_classCallCheck3.default)(this,EChartList);var _this=(0,_possibleConstructorReturn3.default)(this,(EChartList.__proto__||(0,_getPrototypeOf2.default)(EChartList)).call(this,props));_this.state={visible:false};_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.onEdit=_this.onEdit.bind(_this);return _this;}(0,_createClass3.default)(EChartList,[{key:'getButtons',value:function getButtons(){var btns=[];btns.push(_react2.default.createElement('div',null,_react2.default.createElement('a',{href:'http://echarts.baidu.com/',target:'_blank'},getLabel(388003,"点击查看ECharts官方文档"))));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.setState({visible:false});break;}}},{key:'onDelete',value:function onDelete(item){var _this2=this;_antd.Modal.confirm({title:getLabel(386786,"信息确认"),content:getLabel(15097,"确定要删除吗？"),onOk:function onOk(){var _props=_this2.props,datas=_props.datas,onChangeDatas=_props.onChangeDatas;_ecCom.WeaTools.callApi('/api/portal/hpEcharts/delete','POST',{id:item.id}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(83472,"删除成功！"));datas.remove(item);onChangeDatas(datas);}else{_antd.message.error(getLabel(83473,"删除失败！"));}});}});}},{key:'onEdit',value:function onEdit(state){this.refs.EChartEditor.setState(state);}},{key:'render',value:function render(){var _this3=this;var visible=this.state.visible;var _props2=this.props,sysDatas=_props2.sysDatas,datas=_props2.datas,onChangeDatas=_props2.onChangeDatas;return _react2.default.createElement(_ecCom.WeaDialog,{title:getLabel(388004,"图表库"),visible:visible,closable:true,onCancel:function onCancel(){return _this3.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:1080,height:660}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{id:'portal-echartlist-container',className:'portal-echartlist-container'},_react2.default.createElement(_EchartEditor2.default,{ref:'EChartEditor',callback:onChangeDatas}),sysDatas.map(function(item){return _react2.default.createElement(EChartItem,{key:'sys-'+item.id,isSys:true,item:item,onEdit:_this3.onEdit,onDelete:_this3.onDelete});}),datas.map(function(item){return _react2.default.createElement(EChartItem,{key:'sys-'+item.id,item:item,onEdit:_this3.onEdit,onDelete:_this3.onDelete});}))));}}]);return EChartList;}(_react2.default.Component);var EChartItem=function(_React$Component2){(0,_inherits3.default)(EChartItem,_React$Component2);function EChartItem(props){(0,_classCallCheck3.default)(this,EChartItem);return(0,_possibleConstructorReturn3.default)(this,(EChartItem.__proto__||(0,_getPrototypeOf2.default)(EChartItem)).call(this,props));}(0,_createClass3.default)(EChartItem,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!(0,_lodash.isEqual)(prevProps.item,this.props.item)||prevProps.isSys!=this.props.isSys){this.refs.chart.clear();this.refs.chart.paint();}}},{key:'render',value:function render(){var _props3=this.props,item=_props3.item,isSys=_props3.isSys,onEdit=_props3.onEdit,onDelete=_props3.onDelete;var obj=item;if(isSys){obj={id:item.key,title:item.value,isSys:true,option:_examples2.default[item.key]};}else{obj.isSys=false;}var _obj=obj,title=_obj.title,option=_obj.option;return _react2.default.createElement('div',{className:'portal-echartlist-item',title:title,onMouseOver:function onMouseOver(e){$(e.currentTarget).find(".portal-echartlist-item-opts").show();},onMouseLeave:function onMouseLeave(e){$(e.currentTarget).find(".portal-echartlist-item-opts").hide();}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'chart',useDefault:true,chartName:title,option:option}),_react2.default.createElement('div',{className:'portal-echartlist-item-shadow'}),_react2.default.createElement('div',{className:'portal-echartlist-item-opts'},_react2.default.createElement('div',{'class':'portal-echartlist-item-edit',title:getLabel(26473,'编辑')},_react2.default.createElement(_antd.Icon,{type:'edit',onClick:onEdit.bind(this,(0,_extends3.default)({},obj,{visible:true}))})),!isSys&&_react2.default.createElement('div',{'class':'portal-echartlist-item-delete'},_react2.default.createElement(_antd.Icon,{type:'delete',onClick:onDelete.bind(this,obj)}))));}}]);return EChartItem;}(_react2.default.Component);var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EChartList=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EChartList);exports.default=EChartList;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _stringify=__webpack_require__(53);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EchartSaveAs=__webpack_require__(245);var _EchartSaveAs2=_interopRequireDefault(_EchartSaveAs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prettyJSONStringify=__webpack_require__(246);// import AceEditor from 'react-ace';
var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var EChartEditor=function(_React$Component){(0,_inherits3.default)(EChartEditor,_React$Component);function EChartEditor(props){(0,_classCallCheck3.default)(this,EChartEditor);var _this=(0,_possibleConstructorReturn3.default)(this,(EChartEditor.__proto__||(0,_getPrototypeOf2.default)(EChartEditor)).call(this,props));_this.state={visible:false,id:0,title:'',isSys:false,option:null,value:'',width:'60%',left:'40%',iserror:false,isMouseDown:false};_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onReplace=_this.onReplace.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onRun=_this.onRun.bind(_this);return _this;}(0,_createClass3.default)(EChartEditor,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){$(window).mousemove(function(e){if(_this2.state.isMouseDown){var left_rate=e.clientX/window.innerWidth;left_rate=Math.min(0.9,Math.max(0.1,left_rate));var left=left_rate*100;_this2.setState({left:left+'%',width:100-left+'%'});_this2.onRun();}}).mouseup(function(){_this2.setState({isMouseDown:false});});},100);}},{key:'getButtons',value:function getButtons(){var _this3=this;var isSys=this.state.isSys;var btns=[];if(!isSys){btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onSave.bind(this,{})},getLabel(30986,'保存')));}btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){_this3.refs.EchartSaveAs.onSetState({visible:true});}},getLabel(350,'另存为')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var isSys=this.state.isSys;var btns=[];btns.push({key:'run',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(131308,"运行")});if(!isSys){btns.push({key:'save',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(30986,'保存')});}btns.push({key:'saveas',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(350,'另存为')});btns.push({key:'cancel',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'run':this.onRun();break;case'save':this.onSave();break;case'saveas':this.refs.EchartSaveAs.onSetState({visible:true});break;case'cancel':this.setState({visible:false});break;}}},{key:'onSave',value:function onSave(_ref){var _this4=this;var type=_ref.type,title=_ref.title;var callback=this.props.callback;var _state=this.state,id=_state.id,option=_state.option;_ecCom.WeaTools.callApi('/api/portal/hpEcharts/update','POST',{id:type=='saveas'?'':id,option:(0,_stringify2.default)(option),title:title,type:type}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(83551,"保存成功！"));if(type=='saveas'){var maxid=result.maxid;if(typeof callback==='function'){callback('add',{id:maxid,title:title,option:option});}}else{if(typeof callback==='function'){callback('update',{id:id,option:option});}}_this4.setState({visible:false});}else{_antd.message.error(getLabel(84544,"保存失败！"));}});}},{key:'onRun',value:function onRun(){this.refs.ViewEChart.onPaint();}},{key:'onReplace',value:function onReplace(js_str){var _this5=this;var option=void 0;var app={};try{eval(js_str);if(!option||(typeof option==='undefined'?'undefined':(0,_typeof3.default)(option))!='object'){option=null;}setTimeout(function(){_this5.setState({option:option,iserror:false});_this5.refs.ViewEChart.getChart().paint();},500);}catch(e){window.console?console.log(getLabel(387999,"组件异常："),e):alert(getLabel(387999,"组件异常：")+e);this.setState({iserror:true});}}},{key:'render',value:function render(){var _this6=this;var _state2=this.state,title=_state2.title,visible=_state2.visible,left=_state2.left,width=_state2.width,option=_state2.option,iserror=_state2.iserror;var editor_value="";if(option){editor_value='option = '+prettyJSONStringify(option,{shouldExpand:function shouldExpand(object,level,key){if(Array.isArray(object))return false;return true;}}).replace(/"(\w+)" :/g,"$1 :");}return _react2.default.createElement(_ecCom.WeaDialog,{title:getLabel(388000,"图表编辑"),visible:visible,closable:true,onCancel:function onCancel(){return _this6.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:document.body.clientWidth-100,height:document.body.clientHeight-150,overflow:'hidden'}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{id:'content-container',className:'portal-echart-container'},_react2.default.createElement(_EchartSaveAs2.default,{ref:'EchartSaveAs',onSave:this.onSave}),_react2.default.createElement('div',{id:'code-container',className:'echart-code-container',style:{width:left}},_react2.default.createElement('div',{className:'echart-code-top'},_react2.default.createElement('div',{className:'echart-code-input'},_react2.default.createElement(ShowTime,null),_react2.default.createElement('span',{'class':'code-info-type-'+(iserror?'error':'info')},iserror?getLabel(388001,"编辑器内容有误！"):getLabel(388002,"图表已生成")+'}')),_react2.default.createElement('div',{className:'echart-code-run'},_react2.default.createElement('div',{onClick:this.onRun,className:'echart-code-run-btn'},getLabel(131308,"运行"))))),_react2.default.createElement('div',{id:'handler-container',className:'echart-handler',style:{left:left},onMouseDown:function onMouseDown(){return _this6.setState({isMouseDown:true});}}),_react2.default.createElement('div',{id:'view-container',className:'echart-view-container',style:{width:width,left:left}},_react2.default.createElement(EChartView,{ref:'ViewEChart',title:title,option:option})))));}}]);return EChartEditor;}(_react2.default.Component);var timer=null;var ShowTime=function(_React$Component2){(0,_inherits3.default)(ShowTime,_React$Component2);function ShowTime(props){(0,_classCallCheck3.default)(this,ShowTime);var _this7=(0,_possibleConstructorReturn3.default)(this,(ShowTime.__proto__||(0,_getPrototypeOf2.default)(ShowTime)).call(this,props));_this7.state={time:formatTime(new Date())};return _this7;}(0,_createClass3.default)(ShowTime,[{key:'componentDidMount',value:function componentDidMount(){var _this8=this;timer=window.setInterval(function(){_this8.setState({time:formatTime(new Date())});},1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.clearTimeout(timer);}},{key:'render',value:function render(){return _react2.default.createElement('span',{'class':'code-info-time'},this.state.time);}}]);return ShowTime;}(_react2.default.Component);var ViewEChart=function(_React$Component3){(0,_inherits3.default)(ViewEChart,_React$Component3);function ViewEChart(props){(0,_classCallCheck3.default)(this,ViewEChart);var _this9=(0,_possibleConstructorReturn3.default)(this,(ViewEChart.__proto__||(0,_getPrototypeOf2.default)(ViewEChart)).call(this,props));_this9.getChart=_this9.getChart.bind(_this9);_this9.onPaint=_this9.onPaint.bind(_this9);return _this9;}(0,_createClass3.default)(ViewEChart,[{key:'getChart',value:function getChart(){return this.refs.chart;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!(0,_lodash.isEqual)(prevProps.option,this.props.option)||prevProps.title!=this.props.title){this.onPaint();}}},{key:'onPaint',value:function onPaint(){this.refs.chart.clear();this.refs.chart.paint();}},{key:'render',value:function render(){var _props=this.props,title=_props.title,option=_props.option;return _react2.default.createElement(_ecCom.WeaEchart,{ref:'chart',useDefault:true,chartName:title,option:option});}}]);return ViewEChart;}(_react2.default.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);var EChartView=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ViewEChart);EChartEditor=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EChartEditor);exports.default=EChartEditor;function formatTime(time){var digits=[time.getHours(),time.getMinutes(),time.getSeconds()];var timeStr='';for(var i=0,len=digits.length;i<len;++i){timeStr+=(digits[i]<10?'0':'')+digits[i];if(i<len-1){timeStr+=':';}}return timeStr;}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _mobxReact=__webpack_require__(103);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var EchartSaveAs=function(_React$Component){(0,_inherits3.default)(EchartSaveAs,_React$Component);function EchartSaveAs(props){(0,_classCallCheck3.default)(this,EchartSaveAs);var _this=(0,_possibleConstructorReturn3.default)(this,(EchartSaveAs.__proto__||(0,_getPrototypeOf2.default)(EchartSaveAs)).call(this,props));_this.onSetState=_this.onSetState.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.state={visible:false,title:''};return _this;}(0,_createClass3.default)(EchartSaveAs,[{key:'onSetState',value:function onSetState(state){this.setState(state);}},{key:'onSubmit',value:function onSubmit(){var onSave=this.props.onSave;var title=this.state.title;if(!title.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(127697,"模板名称不能为空！")});return;}onSave({type:'saveas',title:title});this.setState({visible:false});}},{key:'getButtons',value:function getButtons(){var btns=[];btns.push(React.createElement(_antd.Button,{type:'primary',onClick:this.onSubmit},getLabel(826,'确定')));btns.push(React.createElement(_antd.Button,{onClick:this.onSetState.bind(this,{visible:false})},getLabel(31129,'取消')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({icon:React.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存')});btns.push({icon:React.createElement('i',{className:'icon-coms-go-back'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.onSubmit();break;case'1':this.setState({visible:false});break;}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,visible=_state.visible;return React.createElement(_ecCom.WeaDialog,{title:getLabel(350,'另存为'),visible:visible,closable:true,onCancel:this.onSetState.bind(this,{visible:false}),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:520,height:237}},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},React.createElement('div',{className:'portal-esetting-echart-saveas-title'},React.createElement(_ecCom.WeaFormItem,{label:getLabel(28050,"模板名称"),labelCol:{span:6},wrapperCol:{span:18}},React.createElement(_ecCom.WeaInput,{viewAttr:3,style:{width:280},fieldName:'title',value:title,onChange:function onChange(value){return _this2.setState({title:value});}})))));}}]);return EchartSaveAs;}(React.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);EchartSaveAs=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(EchartSaveAs);exports.default=EchartSaveAs;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var defaultParams = {
    tab : '    ',
    spaceBeforeColon : ' ',
    spaceAfterColon : ' ',
    spaceAfterComma : ' ',
    spaceInsideObject : ' ',
    spaceInsideArray : '',
    shouldExpand : function(obj, level, index) {
        return JSON.stringify(obj).length > 25;
    }
}

function stringify(object, params, level, index) {
    if (!level) {
        var fullParams = {};
        Object.keys(defaultParams).forEach(function(key) {
            fullParams[key] = (params && key in params)? params[key] : defaultParams[key];
        });
        params = fullParams;
        object = JSON.parse(JSON.stringify(object));
        level = 0;
    }

    if (typeof object !== 'object' || object === null) return JSON.stringify(object);

    var isArray = Array.isArray(object),
        bra = isArray? '[' : '{',
        ket = isArray? ']' : '}';

    if (!Object.keys(object).length) return bra + ket;

    var hasExpandedChildren = false,
        children = (isArray? object : Object.keys(object)).reduce(function(children, item, itemIndex) {
            if (!isArray) {
                itemIndex = item;
                item = object[item];
            }
            if (!hasExpandedChildren && typeof item === 'object' && item !== null && params.shouldExpand(item, level + 1, itemIndex)) {
                hasExpandedChildren = true;
            }
            children[itemIndex] = stringify(item, params, level + 1, itemIndex);
            return children;
        }, isArray? [] : {}),
        shouldExpand = hasExpandedChildren || params.shouldExpand(object, level, index),
        indent = new Array(level + 1).join(params.tab),
        spaceInside = shouldExpand?
            '\n' + indent :
            params['spaceInside' + (isArray? 'Array' : 'Object')],
        joiner = shouldExpand?
            ',\n' + indent + params.tab :
            ',' + params.spaceAfterComma;

    if (!isArray) {
        children = Object.keys(children).reduce(function(res, key) {
            return res.concat(JSON.stringify(key) + params.spaceBeforeColon + ':' + params.spaceAfterColon + children[key]);
        }, []);
    }

    return bra + spaceInside + (shouldExpand? params.tab : '') + children.join(joiner) + spaceInside + ket;
}

if (typeof module == 'object' && typeof module.exports == 'object') {
    module.exports = stringify;
} else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return stringify; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else { 
    (window || global).prettyJSONStringify = stringify;
}


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _area=__webpack_require__(248);var _area2=_interopRequireDefault(_area);var _bar2d=__webpack_require__(249);var _bar2d2=_interopRequireDefault(_bar2d);var _bar3d=__webpack_require__(250);var _bar3d2=_interopRequireDefault(_bar3d);var _bargraph=__webpack_require__(251);var _bargraph2=_interopRequireDefault(_bargraph);var _doughnut=__webpack_require__(252);var _doughnut2=_interopRequireDefault(_doughnut);var _gauge=__webpack_require__(253);var _gauge2=_interopRequireDefault(_gauge);var _line=__webpack_require__(254);var _line2=_interopRequireDefault(_line);var _pie2d=__webpack_require__(255);var _pie2d2=_interopRequireDefault(_pie2d);var _pie3d=__webpack_require__(256);var _pie3d2=_interopRequireDefault(_pie3d);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//饼图2d
//仪表盘
//柱状图3d
//柱状图2d
exports.default={1:_bar2d2.default,2:_bar3d2.default,3:_line2.default,4:_area2.default,5:_bargraph2.default,6:_pie2d2.default,7:_pie3d2.default,8:_doughnut2.default,11:_gauge2.default};//饼图3d
//折线图
//环形图
//柱状图3d
//面积图

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',boundaryGap:false,data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[820,932,901,934,1290,1330,1320],type:'line',areaStyle:{}}]};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[120,200,150,80,70,110,130],type:'bar'}]};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[120,200,150,80,70,110,130],type:'bar'}]};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'value'},yAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},series:[{data:[120,200,150,80,70,110,130],type:'bar'}]};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)"},legend:{orient:'vertical',x:'left',data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]},series:[{name:getLabel(387997,"访问来源"),type:'pie',radius:['50%','70%'],avoidLabelOverlap:false,label:{normal:{show:false,position:'center'},emphasis:{show:true,textStyle:{fontSize:'30',fontWeight:'bold'}}},labelLine:{normal:{show:false}},data:[{value:335,name:getLabel(387994,"直接访问")},{value:310,name:getLabel(387995,"邮件营销")},{value:234,name:getLabel(387996,"联盟广告")}]}]};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={tooltip:{formatter:"{a} <br/>{b} : {c}%"},toolbox:{feature:{restore:{},saveAsImage:{}}},series:[{name:getLabel(387998,"业务指标"),type:'gauge',detail:{formatter:'{value}%'},data:[{value:50,name:getLabel(30447,"完成率")}]}]};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[820,932,901,934,1290,1330,1320],type:'line'}]};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={title:{x:'center'},tooltip:{trigger:'item',formatter:"{a} <br/>{b} : {c} ({d}%)"},legend:{orient:'vertical',left:'left',data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]},series:[{name:getLabel(387997,"访问来源"),type:'pie',radius:'55%',center:['50%','60%'],data:[{value:335,name:getLabel(387994,"直接访问")},{value:310,name:getLabel(387995,"邮件营销")},{value:234,name:getLabel(387996,"联盟广告")}],itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={title:{x:'center'},tooltip:{trigger:'item',formatter:"{a} <br/>{b} : {c} ({d}%)"},legend:{orient:'vertical',left:'left',data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]},series:[{name:getLabel(387997,"访问来源"),type:'pie',radius:'55%',center:['50%','60%'],data:[{value:335,name:getLabel(387994,"直接访问")},{value:310,name:getLabel(387995,"邮件营销")},{value:234,name:getLabel(387996,"联盟广告")}],itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;//获取柱状图option
function getBarOption(xAxisData){var series=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var nowfontsize=arguments[5];series=series.map(function(item){item.itemStyle={normal:{label:{show:true,//是否展示
position:'top'}}};return item;});var legendData=series.map(function(item){item.type='bar';return item.name;});var option={title:{text:title,subtext:subTitle,textStyle:{fontSize:nowfontsize}},tooltip:{trigger:'axis',axisPointer:{type:'shadow'},textStyle:{fontSize:nowfontsize}},legend:{show:showLegend=='1',data:legendData,textStyle:{fontSize:nowfontsize}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true,tooltip:{textStyle:{fontSize:nowfontsize}}},yAxis:{type:'value',boundaryGap:[0,0.01],axisLabel:{fontSize:nowfontsize}},xAxis:{type:'category',data:xAxisData,axisLabel:{fontSize:nowfontsize}},series:series,textStyle:{fontSize:nowfontsize}};return option;}//获取柱状图option
function getBar3dOption(xAxisData,series){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var nowfontsize=arguments[5];var dimensions=['xName'];var source=[];var encode={x:'xName'};var tooltip=[0];series.map(function(item,i){if(i==0&&!encode.y)encode.y=item.name;if(i==1&&!encode.z)encode.z=item.name;tooltip.push(i+1);dimensions.push(item.name);});encode.tooltip=tooltip;xAxisData.map(function(xName,i){var arr=[];arr.push(xAxisData[i]);series.map(function(item,j){arr.push(item.data[i]);});source.push(arr);});var option={grid3D:{axisPointer:{label:{textStyle:{fontSize:nowfontsize}}},axisLabel:{textStyle:{fontSize:nowfontsize}}},tooltip:{textStyle:{fontSize:nowfontsize}},xAxis3D:{type:'category',axisLabel:{textStyle:{fontSize:nowfontsize}}},yAxis3D:{type:'category',axisLabel:{textStyle:{fontSize:nowfontsize}}},zAxis3D:{axisLabel:{textStyle:{fontSize:nowfontsize}}},visualMap:{show:showLegend=='1',max:1e8,dimension:'Population',textStyle:{fontSize:nowfontsize}},dataset:{dimensions:dimensions,source:source},series:[{type:'bar3D',// symbolSize: symbolSize,
shading:'lambert',encode:encode}],textStyle:{fontSize:nowfontsize}};return option;}function getLineOption(xAxisData,series){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var nowfontsize=arguments[5];var legendData=series.map(function(item){item.type='line';return item.name;});var option={title:{text:title,textStyle:{fontSize:nowfontsize}},tooltip:{trigger:'axis',textStyle:{fontSize:nowfontsize}},legend:{show:showLegend=='1',data:legendData,textStyle:{fontSize:nowfontsize}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true,tooltip:{textStyle:{fontSize:nowfontsize}}},toolbox:{feature:{saveAsImage:{}}},xAxis:{type:'category',boundaryGap:false,data:xAxisData,axisLabel:{fontSize:nowfontsize}},yAxis:{type:'value',axisLabel:{fontSize:nowfontsize}},series:series,textStyle:{fontSize:nowfontsize}};return option;}function getAreaOption(xAxisData){var series=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var nowfontsize=arguments[5];var legendData=series.map(function(item){item.type='line';item.stack=getLabel(388005,"总量");item.areaStyle={normal:{}};return item.name;});var option={title:{text:title,textStyle:{fontSize:nowfontsize}},tooltip:{trigger:'axis',axisPointer:{type:'cross',label:{backgroundColor:'#6a7985'}},textStyle:{fontSize:nowfontsize}},legend:{show:showLegend=='1',data:legendData,textStyle:{fontSize:nowfontsize}},toolbox:{feature:{saveAsImage:{}}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true,tooltip:{textStyle:{fontSize:nowfontsize}}},xAxis:[{type:'category',boundaryGap:false,data:xAxisData.Number,axisLabel:{fontSize:nowfontsize}}],yAxis:[{type:'value',axisLabel:{fontSize:nowfontsize}}],series:series,textStyle:{fontSize:nowfontsize}};return option;}function getBarGraphOption(xAxisData){var series=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var nowfontsize=arguments[5];var legendData=series.map(function(item){item.type='bar';item.itemStyle={normal:{label:{show:true,//是否展示
position:'right'}}};item.data=item.data.reverse();return item.name;});var option={title:{text:title,subtext:subTitle,textStyle:{fontSize:nowfontsize}},tooltip:{trigger:'axis',axisPointer:{type:'shadow'},textStyle:{fontSize:nowfontsize}},legend:{show:showLegend=='1',data:legendData.reverse(),textStyle:{fontSize:nowfontsize}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true,tooltip:{textStyle:{fontSize:nowfontsize}}},xAxis:{type:'value',boundaryGap:[0,0.01],axisLabel:{fontSize:nowfontsize}},yAxis:{type:'category',data:xAxisData.reverse(),axisLabel:{fontSize:nowfontsize}},series:series,textStyle:{fontSize:nowfontsize}};return option;}function getPieOption(){var series=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var subTitle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var showLegend=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'1';var nowfontsize=arguments[4];var data=[];var legendData=series.data.map(function(item){data.push({name:item[0],value:item[1]});return item[0];});var option={title:{text:title,subtext:subTitle,x:'center',textStyle:{fontSize:nowfontsize}},grid:{left:'3%',right:'4%',bottom:'-5%',containLabel:true},tooltip:{trigger:'item',formatter:"{b} : {d}%",textStyle:{fontSize:nowfontsize}},legend:{show:showLegend=='1',orient:'vertical',left:'left',data:legendData,textStyle:{fontSize:nowfontsize}},series:[{type:'pie',radius:'55%',center:['50%','60%'],data:data,itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}],textStyle:{fontSize:nowfontsize}};return option;}function getCircleOption(){var series=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var subTitle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var showLegend=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'1';var nowfontsize=arguments[4];var data=[];var legendData=series.data.map(function(item){data.push({name:item[0],value:item[1]});return item[0];});var option={title:{text:title,subtext:subTitle,x:'center',textStyle:{fontSize:nowfontsize}},tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)",textStyle:{fontSize:nowfontsize}},legend:{show:showLegend=='1',orient:'vertical',x:'left',data:legendData,textStyle:{fontSize:nowfontsize}},series:[{type:'pie',radius:['10%','80%'],avoidLabelOverlap:false,label:{normal:{show:false,position:'center'},emphasis:{show:false,textStyle:{fontSize:'30',fontWeight:'bold'}}},labelLine:{normal:{show:false}},data:data}]};return option;}function getGaugeOption(datas){var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var subTitle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var showLegend=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'1';var nowfontsize=arguments[4];var series=datas.series;var data=series.data;var startval=data.startval,middleval=data.middleval,realval=data.realval,endval=data.endval;var myIsNaN=function myIsNaN(value){var def=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;value=Number(value);if(typeof value==='number'&&isNaN(value)){return def;}return value;};var option={tooltip:{formatter:"{a} <br/>{c} {b}",textStyle:{fontSize:nowfontsize}},toolbox:{show:true,feature:{restore:{show:true},saveAsImage:{show:true}}},series:[{type:'gauge',z:3,min:myIsNaN(startval,0),max:myIsNaN(endval,1),splitNumber:10,radius:'50%',axisLine:{// 坐标轴线
lineStyle:{// 属性lineStyle控制线条样式
width:10}},axisTick:{// 坐标轴小标记
length:15,// 属性length控制线长
lineStyle:{// 属性lineStyle控制线条样式
color:'auto'}},splitLine:{// 分隔线
length:20,// 属性length控制线长
lineStyle:{// 属性lineStyle（详见lineStyle）控制线条样式
color:'auto'}},axisLabel:{backgroundColor:'auto',borderRadius:2,color:'#eee',padding:3,textShadowBlur:2,textShadowOffsetX:1,textShadowOffsetY:1,textShadowColor:'#222'},title:{// 其余属性默认使用全局文本样式，详见TEXTSTYLE
fontWeight:'bolder',fontSize:20,fontStyle:'italic'},// data: [{value: myIsNaN(realval, 0), name: '完成率'}]
data:[{value:myIsNaN(realval,0)}]}]};return option;}function getEChartOption(data,nowfontsize){var charttype=data.charttype,showLegend=data.showLegend;var categories=data.categories,dot=data.dot,series=data.series,title=data.title,subTitle=data.subTitle;switch(charttype){case'bar':return getBarOption(categories,series,title,subTitle,showLegend,nowfontsize);break;case'bar3d':return getBar3dOption(categories,series,title,subTitle,showLegend,nowfontsize);break;case'line':return getLineOption(categories,series,title,subTitle,showLegend,nowfontsize);break;case'area':return getAreaOption(categories,series,title,subTitle,showLegend,nowfontsize);break;case'bar-graph':return getBarGraphOption(categories,series,title,subTitle,showLegend,nowfontsize);break;case'pie':return getPieOption(series,title,subTitle,showLegend,nowfontsize);break;case'circle':return getCircleOption(series,title,subTitle,showLegend,nowfontsize);break;case'gauge':return getGaugeOption(data,title,subTitle,nowfontsize);break;}}exports.default=getEChartOption;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_258__;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 外部数据元素，数据来源
var Content_OutData_DataSource=function(_React$Component){(0,_inherits3.default)(Content_OutData_DataSource,_React$Component);function Content_OutData_DataSource(props){(0,_classCallCheck3.default)(this,Content_OutData_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_OutData_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_OutData_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',sourceType:_this.props.tabData.sourceType||_this.props.tabNew.sourceType,dataSourceList:_this.props.tabData.dataSourceList||[],dataSourceType:_this.props.tabData.dataSourceType||_this.props.tabNew.dataSourceType.selected,dataSource:_this.props.tabData.dataSource||_this.props.tabNew.dataSource.selected,content:_this.props.tabData.content,primaryKey:_this.props.tabData.primaryKey,linkAddress:_this.props.tabData.linkAddress,integrateLogin:_this.props.tabData.integrateLogin||_this.props.tabNew.integrateLogin.selected,showFieldSetting:_this.props.tabData.showFieldSetting||[],dsModalVisible:true,wsaddress:'',method:'',parameters:'',ismatch:true,selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.onShowFieldChange=_this.onShowFieldChange.bind(_this);return _this;}(0,_createClass3.default)(Content_OutData_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,sourceType=_state.sourceType,dataSourceList=_state.dataSourceList,dataSourceType=_state.dataSourceType,dataSource=_state.dataSource,content=_state.content,primaryKey=_state.primaryKey,linkAddress=_state.linkAddress,integrateLogin=_state.integrateLogin,showFieldSetting=_state.showFieldSetting,wsaddress=_state.wsaddress,method=_state.method,parameters=_state.parameters;var tabNew=this.props.tabNew;var existSetting=_react2.default.createElement('div',null);var customSetting=_react2.default.createElement('div',null);var fieldSetting=_react2.default.createElement('div',null);var dataSourceSetting=_react2.default.createElement('div',null);if(dataSourceType=='1'){dataSourceSetting=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(18076,"数据源"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.dataSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:dataSource,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({dataSource:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33368,"内容"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.content=el;},tipPosition:'bottom',error:getLabel(388425,"内容未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaTextarea,{className:'portal-eoutdata-submit',value:content,viewAttr:3,minRows:4,onChange:function onChange(value){_this2.setState({content:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21027,"主键"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.primaryKey=el;},tipPosition:'bottom',error:getLabel(388424,"主键未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{className:'portal-eoutdata-submit',value:primaryKey,viewAttr:3,onChange:function onChange(value){return _this2.setState({primaryKey:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16208,"链接地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:linkAddress,onChange:function onChange(value){return _this2.setState({linkAddress:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388008,"参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；并以'id='结束。")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125405,"集成登录设置"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:integrateLogin,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({integrateLogin:value});}})));}else if(dataSourceType=='2'){dataSourceSetting=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(110,"地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.wsaddress=el;},tipPosition:'bottom',error:getLabel(388427,"地址未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:wsaddress,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({wsaddress:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(604,"方法"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.method=el;},tipPosition:'bottom',error:getLabel(388426,"方法未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:method,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({method:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(561,"参数"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:parameters,onChange:function onChange(value){return _this2.setState({parameters:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388009,"参数以xml格式输入,以root为根元素，并以属性名为子标签名（如：myName）")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21027,"主键"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.primaryKey=el;},tipPosition:'bottom',error:getLabel(388424,"主键未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:primaryKey,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({primaryKey:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16208,"链接地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:linkAddress,onChange:function onChange(value){return _this2.setState({linkAddress:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388008,"参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；并以'id='结束。")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125405,"集成登录设置"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:integrateLogin,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({integrateLogin:value});}})));}else if(dataSourceType=='3'){dataSourceSetting=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33368,"内容"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.content=el;},tipPosition:'bottom',error:getLabel(388425,"内容未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaTextarea,{value:content,viewAttr:3,minRows:4,onChange:function onChange(value){_this2.setState({content:value});},className:'portal-eoutdata-submit'})),_react2.default.createElement('div',{style:{position:'absolute',right:'-24px',top:'40%'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388010,"可设置http链接，比如http://ip:端口/.../*.jsp、*.php、*.asp，或者servlet等，输出格式必须为xml格式。参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21027,"主键"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.primaryKey=el;},tipPosition:'bottom',error:getLabel(388424,"主键未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:primaryKey,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({primaryKey:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16208,"链接地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:linkAddress,onChange:function onChange(value){return _this2.setState({linkAddress:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388008,"参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；并以'id='结束。")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125405,"集成登录设置"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:integrateLogin,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({integrateLogin:value});}})));}if(sourceType=='1'){var columns=[{key:'sourceName',title:getLabel(30231,"数据来源名称"),dataIndex:'sourceName',width:'50%',render:function render(text,record){return _react2.default.createElement('span',null,record.sourceName);}},{key:'integrateLogin',title:getLabel(125405,"集成登录设置"),width:'50%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:record.integrateLogin,onChange:function onChange(value){for(var i=0,len=_dataSourceList.length;i<len;i++){if(_dataSourceList[i].sourceId==record.sourceId){_dataSourceList[i].integrateLogin=value;break;}}_this2.setState({dataSourceList:_dataSourceList});}});}}];var _dataSourceList=this.state.dataSourceList;var sourceNamed=void 0;if(_dataSourceList.length>0){var sourceNames=_dataSourceList[0].sourceName;var sourceId=_dataSourceList[0].sourceId;sourceNamed=[{id:sourceId,name:sourceNames}];}existSetting=_react2.default.createElement('div',null,_react2.default.createElement('div',{style:{margin:'8px 0'}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.exterbaldata=el;},tipPosition:'bottom',error:getLabel(388428,"此项必写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'exterbaldata',isSingle:true,replaceDatas:sourceNamed||[],onChange:function onChange(id,name){_this2.setState({dataSourceList:[{key:id,sourceId:id,sourceName:name,integrateLogin:''}]});},viewAttr:3}))),_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:_dataSourceList,pagination:false}));}else if(this.state.sourceType=='2'){customSetting=_react2.default.createElement('div',{style:{marginLeft:'-30px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28006,"数据来源"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.dataSourceType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:dataSourceType,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({dataSourceType:value,content:'',primaryKey:'',linkAddress:'',wsaddress:'',method:'',parameters:''});}})),dataSourceSetting);// 记录选中的行
var _self=this;var rowSelection={selectedRowKeys:_self.state.selectedRowKeys,onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};var _columns=[{key:'showName',title:getLabel(15456,'字段显示名'),dataIndex:'showName',width:'30%',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2['showName'+index]=el;},tipPosition:'bottom',error:getLabel(388456,"字段显示名未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:record.showName,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.onShowFieldChange(record.key,'showName',value);}}));}},{key:'showField',title:getLabel(32320,"显示字段/XML路径"),width:'30%',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2['showField'+index]=el;},tipPosition:'bottom',error:getLabel(388457,"显示字段/XML路径未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:record.showField,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.onShowFieldChange(record.key,'showField',value);}}));}},{key:'isTitle',title:getLabel(22965,'标题栏'),width:'10%',render:function render(text,record){return _react2.default.createElement(_antd.Checkbox,{checked:record.isTitle,onChange:function onChange(e){return _this2.onShowFieldChange(record.key,'isTitle',e.target.checked);}});}},{key:'transformMethod',title:_react2.default.createElement('div',null,_react2.default.createElement('span',null,getLabel(32321,"转换方法")),_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(131015,"参数可设置如下内容，格式为：select 最终字段 from tablename where 条件字段={?currentvalue}，{?currentvalue}表示当前值")})),width:'30%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:record.transformMethod,onChange:function onChange(value){return _this2.onShowFieldChange(record.key,'transformMethod',value);}});}}];var selectedRowKeys=this.state.selectedRowKeys;fieldSetting=_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(21903,"字段设置"),needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',null,_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',onClick:this.onAdd},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',disabled:!(selectedRowKeys&&selectedRowKeys.length),onClick:this.onDelete},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,{rowSelection:rowSelection,columns:_columns,dataSource:showFieldSetting,pagination:false}));}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:500},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(24128,'基本设置'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:4},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.title=el;},tipPosition:'bottom',error:getLabel(388176,"标题未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,className:'portal-eoutdata-submit',value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value,oldtitle:title});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125929,"数据类型"),labelCol:{span:4},wrapperCol:{span:18}},_react2.default.createElement('div',{style:{paddingTop:'5px'}},_react2.default.createElement(RadioGroup,{value:sourceType,onChange:function onChange(e){return _this2.setState({sourceType:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'1'},getLabel(81511,"已有数据集成")),_react2.default.createElement(_antd.Radio,{value:'2'},getLabel(32219,"自定义方式"))),existSetting,customSetting))),fieldSetting);}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this3=this;var _state2=this.state,title=_state2.title,_state2$content=_state2.content,content=_state2$content===undefined?'':_state2$content,dataSourceType=_state2.dataSourceType,sourceType=_state2.sourceType,dataSourceList=_state2.dataSourceList,showFieldSetting=_state2.showFieldSetting,_state2$primaryKey=_state2.primaryKey,primaryKey=_state2$primaryKey===undefined?'':_state2$primaryKey,wsaddress=_state2.wsaddress,method=_state2.method;var isPass=true;if(title==''){this.title.showError();isPass=false;}if(sourceType=='1'&&dataSourceList.length==0||dataSourceList[0]&&!dataSourceList[0].sourceName){this.exterbaldata.showError();isPass=false;}else if(sourceType=='2'){if(showFieldSetting.length=='0'){_antd.Modal.warning({title:getLabel(15172,'系统提示'),content:getLabel(388012,'必须设置显示字段！')});return;}else{var length=0;if(dataSourceType=='1'||dataSourceType=='3'){if(content==''){this.content.showError();isPass=false;}else if(primaryKey==''){this.primaryKey.showError();isPass=false;}}else if(dataSourceType=='2'){if(wsaddress==''){this.wsaddress.showError();isPass=false;}else if(method==''){this.method.showError();isPass=false;}else if(primaryKey==''){this.primaryKey.showError();isPass=false;}}if(isPass)this.props.onOk(this.state);showFieldSetting.map(function(item,index){_this3['tableEdit'+index]&&_this3['tableEdit'+index].refs.edit.doRequiredCheck();if(item.showName==''){_this3['showName'+index].showError();isPass=false;return;}else if(item.showField==''){_this3['showField'+index].showError();isPass=false;return;}if(!item.isTitle){length=length+1;}});if(length==showFieldSetting.length){_antd.Modal.warning({title:getLabel(15172,'系统提示'),content:getLabel(388013,'请设置标题栏字段！')});return;}}}if(isPass)this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'onAdd',value:function onAdd(){var showFieldSetting=this.state.showFieldSetting;var key=showFieldSetting.length;showFieldSetting.push({key:key,showName:'',showField:'',isTitle:false,transformMethod:''});this.setState({showFieldSetting:showFieldSetting});}},{key:'onDelete',value:function onDelete(){var _this4=this;var showFieldSetting=this.state.showFieldSetting;var selectedRowKeys=this.state.selectedRowKeys;_antd.Modal.confirm({title:getLabel(386786,'信息确认'),content:getLabel(385625,'确定要删除选择的记录吗？'),onOk:function onOk(){if(selectedRowKeys&&selectedRowKeys.length){var __selectedRowKeys=selectedRowKeys.slice();for(var i=0,len=__selectedRowKeys.length;i<len;i++){selectedRowKeys.splice(i,1);for(var j=0,len2=showFieldSetting.length;j<len2;j++){if(showFieldSetting[j].key==__selectedRowKeys[i]){showFieldSetting.splice(j,1);break;}}}_this4.setState({showFieldSetting:showFieldSetting});_this4.setState({selectedRowKeys:[]});}}});}},{key:'onShowFieldChange',value:function onShowFieldChange(key,type,value){var showFieldSetting=this.state.showFieldSetting;if(type=='isTitle'){for(var i=0,len=showFieldSetting.length;i<len;i++){showFieldSetting[i]['isTitle']=false;}showFieldSetting[key]['isTitle']=value;}else{showFieldSetting[key][type]=value;}this.setState({showFieldSetting:showFieldSetting});}}]);return Content_OutData_DataSource;}(_react2.default.Component);exports.default=Content_OutData_DataSource;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 我的协作，数据来源
var Content_13_DataSource=function(_React$Component){(0,_inherits3.default)(Content_13_DataSource,_React$Component);function Content_13_DataSource(props){(0,_classCallCheck3.default)(this,Content_13_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_13_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_13_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',cooperationSource:_this.props.tabData.cooperationSource,cooperationModule:_this.props.tabData.cooperationModule,viewType:_this.props.tabData.viewType,cooperationState:_this.props.tabData.cooperationState,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_13_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,cooperationSource=_state.cooperationSource,cooperationModule=_state.cooperationModule,viewType=_state.viewType,cooperationState=_state.cooperationState,id=_state.id,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var tabNew=this.props.tabNew;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386559,'协作来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.cooperationSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:cooperationSource||tabNew.cooperationSource.selected,onChange:function onChange(value){_this2.setState({cooperationSource:value});}})))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(83265,'协作板块'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.cooperationModule.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:cooperationModule||tabNew.cooperationModule.selected,onChange:function onChange(value){_this2.setState({cooperationModule:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(17483,'查看类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.viewType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:viewType||tabNew.viewType.selected,onChange:function onChange(value){_this2.setState({viewType:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386560,'协作状态'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.cooperationState.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:cooperationState||tabNew.cooperationState.selected,onChange:function onChange(value){_this2.setState({cooperationState:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，'))))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_13_DataSource;}(_react2.default.Component);exports.default=Content_13_DataSource;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 我的项目，数据来源
var Content_10_DataSource=function(_React$Component){(0,_inherits3.default)(Content_10_DataSource,_React$Component);function Content_10_DataSource(props){(0,_classCallCheck3.default)(this,Content_10_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_10_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_10_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',projectsSource:_this.props.tabData.projectsSource||_this.props.tabNew.projectsSource.selected,projectsState:_this.props.tabData.projectsState||_this.props.tabNew.projectsState.selected,isinclude:_this.props.tabData.isinclude||'0',eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_10_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,id=_state.id,projectsSource=_state.projectsSource,projectsState=_state.projectsState,isinclude=_state.isinclude,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var tabNew=this.props.tabNew;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28104,'项目来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{width:'100px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.projectsSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:projectsSource,onChange:function onChange(value){_this2.setState({projectsSource:value,isinclude:'0'});}})),this.state.projectsSource==='2'?_react2.default.createElement('div',{style:{marginLeft:10,display:'inline-flex'}},_react2.default.createElement('div',{style:{display:'inline-flex'}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:isinclude=='1',id:'test',onChange:function onChange(value){_this2.setState({isinclude:value});}})),_react2.default.createElement('span',{style:{margin:'5px 5px',display:'inline-block'}},getLabel(386558,'包含我负责的'))):_react2.default.createElement('div',null))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(587,'项目状态'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.projectsState.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:projectsState,onChange:function onChange(value){_this2.setState({projectsState:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-showfield',style:{"margin-left":"20px"}},eFieldNewUsedNames.join('，'))))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_10_DataSource;}(_react2.default.Component);exports.default=Content_10_DataSource;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);var _EPicturesSettings=__webpack_require__(102);var _EPicturesSettings2=_interopRequireDefault(_EPicturesSettings);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 公司新闻，数据来源
var Content_news_DataSource=function(_React$Component){(0,_inherits3.default)(Content_news_DataSource,_React$Component);function Content_news_DataSource(props){(0,_classCallCheck3.default)(this,Content_news_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_news_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_news_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',newsCenter:_this.props.tabData.newsCenter,newsCentersNames:_this.props.tabData.newsCentersNames,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false,eShowMoudle:_this.props.tabData.eShowMoudle||'1',pictureWidth:_this.props.tabData.pictureWidth,pictureHeight:_this.props.tabData.pictureHeight,widthUnit:_this.props.tabData.widthUnit||'px',heightUnit:_this.props.tabData.heightUnit||'px',autoHeight:_this.props.tabData.autoHeight||false};_this.getButtons=_this.getButtons.bind(_this);_this.onDocSourceTypeChange=_this.onDocSourceTypeChange.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeSize=_this.onChangeSize.bind(_this);return _this;}(0,_createClass3.default)(Content_news_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,newsCenter=_state.newsCenter,newsCentersNames=_state.newsCentersNames,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible,_state$eShowMoudle=_state.eShowMoudle,eShowMoudle=_state$eShowMoudle===undefined?'1':_state$eShowMoudle,_state$pictureWidth=_state.pictureWidth,pictureWidth=_state$pictureWidth===undefined?'120':_state$pictureWidth,_state$pictureHeight=_state.pictureHeight,pictureHeight=_state$pictureHeight===undefined?'108':_state$pictureHeight,widthUnit=_state.widthUnit,heightUnit=_state.heightUnit,autoHeight=_state.autoHeight;var authoHeight=autoHeight?"portal-news-authoheight":'';var tabNew=this.props.tabNew;var _tabNew$showMode=tabNew.showMode,showMode=_tabNew$showMode===undefined?{}:_tabNew$showMode;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22919,'新闻来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'docnews',isSingle:true,replaceDatas:newsCentersNames,onChange:function onChange(ids,names,datas){return _this2.setState({newsCenter:ids,newsCentersNames:datas});},layout:document.body})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{value:eShowMoudle,options:showMode.options||[],style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eShowMoudle:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))),this.state.eShowMoudle=='1'||this.state.eShowMoudle==''?'':_react2.default.createElement(_EPicturesSettings2.default,{onChangeSize:this.onChangeSize,pictureWidth:pictureWidth,widthUnit:widthUnit,authoHeight:authoHeight,pictureHeight:pictureHeight,heightUnit:heightUnit,autoHeight:autoHeight})));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onChangeSize',value:function onChangeSize(string,value){this.setState((0,_defineProperty3.default)({},string,value));}},{key:'onDocSourceTypeChange',value:function onDocSourceTypeChange(value,checked){var docSourceType=this.state.docSourceType;var docSourceTypeArr=docSourceType.split(',');lodash.pull(docSourceTypeArr,value);if(checked){docSourceTypeArr.push(value);}this.setState({docSourceType:docSourceTypeArr.join(',')});}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_news_DataSource;}(_react2.default.Component);exports.default=Content_news_DataSource;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(53);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(47);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 快捷入口元素，数据来源
var Content_QuickEntry_DataSource=function(_React$Component){(0,_inherits3.default)(Content_QuickEntry_DataSource,_React$Component);function Content_QuickEntry_DataSource(props){(0,_classCallCheck3.default)(this,Content_QuickEntry_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_QuickEntry_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_QuickEntry_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',picture:_this.props.tabData.picture||'',link:_this.props.tabData.link||'',backGroundColor:_this.props.tabData.backGroundColor||'#FFFFFF',linkMode:'normal',replaceDatas:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_QuickEntry_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,id=_state.id,title=_state.title,linkMode=_state.linkMode,picture=_state.picture,link=_state.link,backGroundColor=_state.backGroundColor,replaceDatas=_state.replaceDatas;var colProps={labelCol:{span:6},wrapperCol:{span:16}};return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-quickentry-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:210},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:title,viewAttr:'3',onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(515770,'快捷入口图标'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:false,value:picture,isShow:true,onChange:function onChange(value){return _this2.setState({picture:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends3.default)({label:getLabel(16208,'链接地址')},colProps),_react2.default.createElement(_antd.Row,{gutter:8},_react2.default.createElement(_antd.Col,{span:6},_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'normal',selected:false,showname:getLabel(385809,'自定义URL')},{key:'advance',selected:false,showname:getLabel(33496,'系统菜单')},{key:'advance2',selected:false,showname:getLabel(31560,'系统页面')}],value:linkMode,onChange:function onChange(value){return _this2.setState({linkMode:value});}})),_react2.default.createElement(_antd.Col,{span:17},linkMode=='normal'?_react2.default.createElement(_ecCom.WeaInput,{value:link,onChange:function onChange(value){return _this2.setState({link:value});}}):'',linkMode=='advance'?_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(33496,'系统菜单'),type:'portalmenu',tabs:[{name:getLabel(33675,'前端菜单'),key:'1',dataParams:{sourcetype:'1'},conditionDataParams:{sourcetype:'1'}},{name:getLabel(33676,'后端菜单'),key:'2',dataParams:{sourcetype:'2'},conditionDataParams:{sourcetype:'2'}},{name:getLabel(18773,'自定义菜单'),key:'3',dataParams:{sourcetype:'3'},conditionDataParams:{sourcetype:'3'}},{name:getLabel(23094,'系统门户页面'),key:'4',dataParams:{sourcetype:'4'},conditionDataParams:{sourcetype:'4'}}],onChange:function onChange(id,name,data){return _this2.setState({link:data.length=='0'?'':data[0].fullrouteurl||data[0].linkAddress});}// onChange={(id, name, data) => this.onChange({'fullrouteurl': data.length == '0' ? '' :data[0].fullrouteurl || data[0].linkAddress, 'linkAddress': data.length == '0' ? '' : data[0].fullrouteurl || data[0].linkAddress || '', 'mobxrouteurl': ''})}
}):'',linkMode=='advance2'?_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(31560,'系统页面'),type:'systempage',isSingle:false,replaceDatas:replaceDatas,tabs:[{name:getLabel(22243,'文档'),key:'1',dataParams:{sourcetype:'1'}},{name:getLabel(30045,'流程'),key:'2',dataParams:{sourcetype:'2'}}],onChange:function onChange(id,name,data){var menuhref='';if(data[0].activeKey=='1'){menuhref=data[0].dropMenuUrl+id;_this2.setState({link:menuhref,replaceDatas:data});}else if(data[0].activeKey=='2'){var arr=id.split(',');var wftypeIds=[];var wfIds=[];arr.map(function(item){if(item.lastIndexOf('wftype')!=-1){wftypeIds.push(item.split('wftype_').join(''));}else{wfIds.push(item.split('wf_').join(''));}});data.map(function(item){if(item.allVersionIds&&item.allVersionIds!=''){var allVersionIdsArrs=item.allVersionIds.split(',');if(allVersionIdsArrs.length>1){allVersionIdsArrs.map(function(allVersionIdsItem){if(allVersionIdsItem!=''){wfIds.push(allVersionIdsItem);}});}else{wfIds.push(allVersionIdsArrs.join(''));}}});var viewType='';if(data[0].dropMenuValue=='1'){var _jsonstr='wfRange='+wfIds.toString();menuhref=data[0].dropMenuUrl+_jsonstr;_this2.setState({link:menuhref,replaceDatas:data});return;}else if(data[0].dropMenuValue=='2'){viewType="1";}else if(data[0].dropMenuValue=='3'){viewType="2";}else if(data[0].dropMenuValue=='4'){viewType="3";}else if(data[0].dropMenuValue=='5'){viewType="5";}else if(data[0].dropMenuValue=='6'){viewType="6";}else if(data[0].dropMenuValue=='7'){viewType="4";}var jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0};if(viewType=='2'){jsonstr.isArrangement=1;}else if(viewType=='1'){jsonstr.showView=1;}menuhref=data[0].dropMenuUrl+escape((0,_stringify2.default)(jsonstr));_this2.setState({link:menuhref,replaceDatas:data});}}}):''),_react2.default.createElement(_antd.Col,{span:1},_react2.default.createElement('div',{style:{position:'absolute',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel('386567','外部地址，请在地址前加上http://或https://')}))))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(83749,'背景色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaColorPicker,{value:backGroundColor,onChange:function onChange(v){return _this2.setState({backGroundColor:v});}}),_react2.default.createElement(_ecCom.WeaHelpfulTip,{style:{position:'absolute',top:'7px',left:'110px'},title:getLabel(516344,'仅在显示样式为有背景色时有效')}))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_QuickEntry_DataSource;}(_react2.default.Component);exports.default=Content_QuickEntry_DataSource;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);var _EOrderCol=__webpack_require__(101);var _EOrderCol2=_interopRequireDefault(_EOrderCol);var _EPicturesSettings=__webpack_require__(102);var _EPicturesSettings2=_interopRequireDefault(_EPicturesSettings);__webpack_require__(131);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// ecode自定义元素数据来源
var Content_ecodeElement_DataSource=function(_React$Component){(0,_inherits3.default)(Content_ecodeElement_DataSource,_React$Component);function Content_ecodeElement_DataSource(props){(0,_classCallCheck3.default)(this,Content_ecodeElement_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_ecodeElement_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_ecodeElement_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',boundID:_this.props.tabData.boundID||'',moreUrl:_this.props.tabData.moreUrl||''};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_ecodeElement_DataSource,[{key:'render',value:function render(){var _this2=this;var title=this.state.title;console.log("--------------this.props.tabData.title: ",this.props.tabData);return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog portal-news-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}}))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(127253,'来源设置'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:'ecode boundID',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.boundID,onChange:function onChange(value){_this2.setState({boundID:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:'more地址',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.moreUrl,onChange:function onChange(value){_this2.setState({moreUrl:value});}}))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_ecodeElement_DataSource;}(_react2.default.Component);exports.default=Content_ecodeElement_DataSource;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 文档中心
var Content_7=function(_React$Component){(0,_inherits3.default)(Content_7,_React$Component);function Content_7(){(0,_classCallCheck3.default)(this,Content_7);return(0,_possibleConstructorReturn3.default)(this,(Content_7.__proto__||(0,_getPrototypeOf2.default)(Content_7)).apply(this,arguments));}(0,_createClass3.default)(Content_7,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),_react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:this.props.eRemindMode})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentNewsMould:this.refs['eNewsMould']?this.refs['eNewsMould'].getSaveValues():this.props.eNewsMould.selected,eContentRemindMode:this.refs['eRemindMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_7;}(_react2.default.Component);exports.default=Content_7;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EScrollDirection=__webpack_require__(104);var _EScrollDirection2=_interopRequireDefault(_EScrollDirection);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 流程中心
var Content_8=function(_React$Component){(0,_inherits3.default)(Content_8,_React$Component);function Content_8(){(0,_classCallCheck3.default)(this,Content_8);return(0,_possibleConstructorReturn3.default)(this,(Content_8.__proto__||(0,_getPrototypeOf2.default)(Content_8)).apply(this,arguments));}(0,_createClass3.default)(Content_8,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),_react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:this.props.eRemindMode})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentScrollDirection:this.refs['eScrollDirection']?this.refs['eScrollDirection'].getSaveValues():this.props.eScrollDirection.selected,eContentRemindMode:this.refs['eRemindMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_8;}(_react2.default.Component);exports.default=Content_8;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 最新客户
var Content_11=function(_React$Component){(0,_inherits3.default)(Content_11,_React$Component);function Content_11(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_11);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_11.__proto__||(0,_getPrototypeOf2.default)(Content_11)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_11,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected==''?'2':this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_11;}(_react2.default.Component);exports.default=Content_11;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 最新会议
var Content_12=function(_React$Component){(0,_inherits3.default)(Content_12,_React$Component);function Content_12(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_12);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_12.__proto__||(0,_getPrototypeOf2.default)(Content_12)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_12,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_12;}(_react2.default.Component);exports.default=Content_12;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 未读文档
var Content_6=function(_React$Component){(0,_inherits3.default)(Content_6,_React$Component);function Content_6(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_6);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_6.__proto__||(0,_getPrototypeOf2.default)(Content_6)).call.apply(_ref,[this].concat(args))),_this),_this.state={docSourceType:_this.props.eDocSourceType.selected,docCatalogs:_this.props.docCatalogs,virtualCatalogs:_this.props.virtualCatalogs,docCatalogsNames:_this.props.docCatalogsNames,virtualCatalogsNames:_this.props.virtualCatalogsNames,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_6,[{key:'render',value:function render(){var _this2=this;var _state=this.state,docSourceType=_state.docSourceType,docCatalogs=_state.docCatalogs,docCatalogsNames=_state.docCatalogsNames,virtualCatalogsNames=_state.virtualCatalogsNames,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EDocFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){var type={docCatalogs:'doccategory',virtualCatalogs:'docdummy'};var isMultCheckbox={docCatalogs:true,virtualCatalogs:true};var replaceDatas={docCatalogs:docCatalogsNames,virtualCatalogs:virtualCatalogsNames};EDocFrom=_react2.default.createElement('div',{className:'portal_unreadDoc_dataSources'},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20532,'文档来源'),labelCol:{span:6},wrapperCol:{span:16},className:'portal_unreadDoc_dataSources'},_react2.default.createElement(RadioGroup,{value:docSourceType,onChange:function onChange(e){return _this2.setState({docSourceType:e.target.value});}},this.props.eDocSourceType.options.map(function(item,index){var __type=item.type;var __typeNames=item.type+'Names';var dataParams={};if('docCatalogs'==__type)dataParams={filtercategoryid:docCatalogs,filtertype:3,noAllDirName:'1'};else dataParams={};var style=item.type!='allDocs'?{display:'inline-block',width:'25%',textOverflow:'ellipsis',overflow:'hidden'}:{display:'inline-block',width:'74px',textOverflow:'ellipsis',overflow:'hidden',paddingBottom:'6px'};return _react2.default.createElement(_antd.Radio,{key:index,value:item.value,style:{display:'block'}},_react2.default.createElement('div',{style:{paddingTop:'11px'}},_react2.default.createElement('div',{title:item.label,style:style},item.label),item.type!='allDocs'?_react2.default.createElement('div',{style:{display:'inline-block',width:'75%',margin:'5px 10px',verticalAlign:'middle'}},_react2.default.createElement(_ecCom.WeaBrowser,{type:type[__type],dataParams:dataParams,isSingle:false,replaceDatas:replaceDatas[__type],onChange:function onChange(ids,names,datas){var _this2$setState;_this2.setState((_this2$setState={},(0,_defineProperty3.default)(_this2$setState,__type,ids),(0,_defineProperty3.default)(_this2$setState,__typeNames,datas),_this2$setState));if(ids!=''){_this2.setState({docSourceType:item.value});}}})):''));}))));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),EFieldNew,EDocFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentDocSourceType:this.state.docSourceType,eContentDocCatalogs:this.state.docCatalogs,eContentVirtualCatalogs:this.state.virtualCatalogs};}}]);return Content_6;}(_react2.default.Component);exports.default=Content_6;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 未读协作
var Content_13=function(_React$Component){(0,_inherits3.default)(Content_13,_React$Component);function Content_13(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_13);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_13.__proto__||(0,_getPrototypeOf2.default)(Content_13)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_13,[{key:'render',value:function render(){var eShowContent=this.state.eShowContent;var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'13'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_13;}(_react2.default.Component);exports.default=Content_13;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 当月目标
var Content_14=function(_React$Component){(0,_inherits3.default)(Content_14,_React$Component);function Content_14(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_14);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_14.__proto__||(0,_getPrototypeOf2.default)(Content_14)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_14,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_14;}(_react2.default.Component);exports.default=Content_14;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 当日计划
var Content_15=function(_React$Component){(0,_inherits3.default)(Content_15,_React$Component);function Content_15(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_15);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_15.__proto__||(0,_getPrototypeOf2.default)(Content_15)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowDays:_this.props.eShowDays,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_15,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowDays=_state.eShowDays,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowDays=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowDays=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24021,'显示天数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eShowDays,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eShowDays:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EShowDays));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentShowDays:this.state.eShowDays};}}]);return Content_15;}(_react2.default.Component);exports.default=Content_15;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 我的邮件
var Content_16=function(_React$Component){(0,_inherits3.default)(Content_16,_React$Component);function Content_16(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_16);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_16.__proto__||(0,_getPrototypeOf2.default)(Content_16)).call.apply(_ref,[this].concat(args))),_this),_this.state={eContentFrom:_this.props.eContentFrom.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_16,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eContentFrom=_state.eContentFrom,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EContentFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EContentFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20885,'内容来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eContentFrom.options,value:eContentFrom,onChange:function onChange(checkedValue){return _this2.setState({eContentFrom:checkedValue});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'30px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EContentFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eContentFrom:this.state.eContentFrom};}}]);return Content_16;}(_react2.default.Component);exports.default=Content_16;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 消息提醒
var Content_9=function(_React$Component){(0,_inherits3.default)(Content_9,_React$Component);function Content_9(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_9);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_9.__proto__||(0,_getPrototypeOf2.default)(Content_9)).call.apply(_ref,[this].concat(args))),_this),_this.state={eMessageRemind:_this.props.eMessageRemind.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource||[],eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys||[],eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_9,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eMessageRemind=_state.eMessageRemind,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EMessageRemind=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EMessageRemind=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19085,'消息提醒'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-checkbox-group'},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eMessageRemind.options,value:eMessageRemind,onChange:function onChange(checkedValue){return _this2.setState({eMessageRemind:checkedValue});}})));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EMessageRemind));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentMessageRemind:this.state.eMessageRemind};}}]);return Content_9;}(_react2.default.Component);exports.default=Content_9;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 我的项目
var Content_10_new=function(_React$Component){(0,_inherits3.default)(Content_10_new,_React$Component);function Content_10_new(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_10_new);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_10_new.__proto__||(0,_getPrototypeOf2.default)(Content_10_new)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_10_new,[{key:'render',value:function render(){var eShowContent=this.state.eShowContent;var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'10'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_10_new;}(_react2.default.Component);exports.default=Content_10_new;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);var _ENewsMould=__webpack_require__(105);var _ENewsMould2=_interopRequireDefault(_ENewsMould);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 多新闻中心
var Content_17=function(_React$Component){(0,_inherits3.default)(Content_17,_React$Component);function Content_17(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_17);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_17.__proto__||(0,_getPrototypeOf2.default)(Content_17)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNewsPageId:_this.props.eNewsPageId,eNewsMoreAddress:_this.props.eNewsMoreAddress,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_17,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eNewsPageId=_state.eNewsPageId,eNewsMoreAddress=_state.eNewsMoreAddress,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var ENewsModule=_react2.default.createElement('div',null);var ENewsPageId=_react2.default.createElement('div',null);var ENewsMoreAddress=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENewsModule=_react2.default.createElement(_ENewsMould2.default,{ref:'eNewsMould',options:this.props.eNewsMould.options,value:this.props.eNewsMould.selected});ENewsPageId=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386561,'新闻页ID'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNewsPageId,style:{width:'80%'},onChange:function onChange(value){return _this2.setState({eNewsPageId:value});}}),_react2.default.createElement('div',null,getLabel(386562,'多新闻页请用半角分号分开。如（1;2）')));ENewsMoreAddress=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386563,'More地址'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNewsMoreAddress,style:{width:'80%'},onChange:function onChange(value){return _this2.setState({eNewsMoreAddress:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,ENewsModule,ENewsPageId,ENewsMoreAddress,_react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:this.props.eRemindMode})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentNewsMould:this.refs['eNewsMould'].getSaveValues(),eContentNewsPageId:this.state.eNewsPageId,eContentNewsMoreAddress:this.state.eNewsMoreAddress,eContentRemindMode:this.refs['eRemindMode'].getSaveValues()};}}]);return Content_17;}(_react2.default.Component);exports.default=Content_17;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 期刊中心
var Content_18=function(_React$Component){(0,_inherits3.default)(Content_18,_React$Component);function Content_18(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_18);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_18.__proto__||(0,_getPrototypeOf2.default)(Content_18)).call.apply(_ref,[this].concat(args))),_this),_this.state={eMagazine:_this.props.eMagazine.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_18,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eMagazine=_state.eMagazine,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EMagazine=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EMagazine=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20052,'期刊列表'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-checkbox-group'},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eMagazine.options,value:eMagazine,onChange:function onChange(checkedValue){return _this2.setState({eMagazine:checkedValue});}})));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EMagazine));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentMagazine:this.state.eMagazine};}}]);return Content_18;}(_react2.default.Component);exports.default=Content_18;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 股票元素
var Content_19=function(_React$Component){(0,_inherits3.default)(Content_19,_React$Component);function Content_19(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_19);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_19.__proto__||(0,_getPrototypeOf2.default)(Content_19)).call.apply(_ref,[this].concat(args))),_this),_this.state={eStockImageSize:_this.props.eStockImageSize,eStockCode:_this.props.eStockCode,eAutoSwitch:_this.props.eAutoSwitch||'1',eSpeedSwitch:_this.props.eSpeedSwitch||3000},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_19,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eStockImageSize=_state.eStockImageSize,eStockCode=_state.eStockCode,eAutoSwitch=_state.eAutoSwitch,eSpeedSwitch=_state.eSpeedSwitch;var EStockImageSize='';var EStockCode='';var EAutoSwitch='';var ESpeedSwitch='';if(this.props.eShareLevel=='2'){EStockImageSize=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386564,'图片大小'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eStockImageSize.width,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eStockImageSize:(0,_extends3.default)({},eStockImageSize,{width:value})});}}),_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eStockImageSize.height,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eStockImageSize:(0,_extends3.default)({},eStockImageSize,{height:value})});}}));EStockCode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20048,'股票代码'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eStockCode,style:{width:'80%'},onChange:function onChange(value){return _this2.setState({eStockCode:value});}}),_react2.default.createElement('div',null,getLabel(386565,'多股票请用半角分号分隔（SHA:000001;SHE:399001）')));}EAutoSwitch=_react2.default.createElement(_ecCom.WeaFormItem,{label:'自动切换',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eAutoSwitch,display:'switch',onChange:function onChange(value){return _this2.setState({eAutoSwitch:value});},style:{display:'inline'}}));ESpeedSwitch=_react2.default.createElement(_ecCom.WeaFormItem,{label:'切换速度',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eSpeedSwitch,style:{width:'10%',float:'left'},onChange:function onChange(value){return _this2.setState({eSpeedSwitch:value});}}),_react2.default.createElement('span',{style:{float:'left',marginTop:'5px'}},'ms'));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EStockImageSize,EStockCode,EAutoSwitch,eAutoSwitch=='1'&&ESpeedSwitch));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentStockImageSize:this.state.eStockImageSize,eContentStockCode:this.state.eStockCode,eContentAutoSwitch:this.state.eAutoSwitch,eContentSpeedSwitch:this.state.eSpeedSwitch};}}]);return Content_19;}(_react2.default.Component);exports.default=Content_19;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 文档内容
var Content_25=function(_React$Component){(0,_inherits3.default)(Content_25,_React$Component);function Content_25(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_25);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_25.__proto__||(0,_getPrototypeOf2.default)(Content_25)).call.apply(_ref,[this].concat(args))),_this),_this.state={eDocContentFormIds:_this.props.eDocContentFormIds,eDocContentForm:_this.props.eDocContentForm},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_25,[{key:'render',value:function render(){var _this2=this;var eDocContentForm=this.state.eDocContentForm;var linkUrl='';if(eDocContentForm.length>0){linkUrl='/spa/document/index.jsp?id='+eDocContentForm[0].id+'&router=1#/main/document/detail?id=';}var EDocContentFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EDocContentFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20885,'内容来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:9,hasAdvanceSerach:true,isUseTest:true,icon:'icon-toolbar-Organization-list',iconBgcolor:'#b32e37',quickSearchName:'docsubject',searchsubject:false,isSingle:true,replaceDatas:eDocContentForm||[],linkUrl:linkUrl,onChange:function onChange(ids,names,datas){return _this2.setState({eDocContentFormIds:ids,eDocContentForm:datas});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EDocContentFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentDocContentForm:this.state.eDocContentFormIds};}}]);return Content_25;}(_react2.default.Component);exports.default=Content_25;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义页面
var Content_29=function(_React$Component){(0,_inherits3.default)(Content_29,_React$Component);function Content_29(){(0,_classCallCheck3.default)(this,Content_29);return(0,_possibleConstructorReturn3.default)(this,(Content_29.__proto__||(0,_getPrototypeOf2.default)(Content_29)).apply(this,arguments));}(0,_createClass3.default)(Content_29,[{key:'render',value:function render(){var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'29'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_29;}(_react2.default.Component);exports.default=Content_29;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 计划任务
var Content_32=function(_React$Component){(0,_inherits3.default)(Content_32,_React$Component);function Content_32(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_32);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_32.__proto__||(0,_getPrototypeOf2.default)(Content_32)).call.apply(_ref,[this].concat(args))),_this),_this.state={ePlanCreator:_this.props.ePlanCreator.checked,eUserRole:_this.props.eUserRole.checked,ePlanState:_this.props.ePlanState.checked,ePlanType:_this.props.ePlanType.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_32,[{key:'render',value:function render(){var _this2=this;var _state=this.state,ePlanCreator=_state.ePlanCreator,eUserRole=_state.eUserRole,ePlanState=_state.ePlanState,ePlanType=_state.ePlanType,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EPlanCreator=_react2.default.createElement('div',null);var EUserRole=_react2.default.createElement('div',null);var EPlanState=_react2.default.createElement('div',null);var EPlanType=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EPlanCreator=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22319,'计划任务创建人'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.ePlanCreator.options,value:ePlanCreator,onChange:function onChange(checkedValue){return _this2.setState({ePlanCreator:checkedValue});}}));EUserRole=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22320,'用户扮演角色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eUserRole.options,value:eUserRole,onChange:function onChange(checkedValue){return _this2.setState({eUserRole:checkedValue});}}));EPlanState=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21947,'计划任务状态'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.ePlanState.options,value:ePlanState,onChange:function onChange(checkedValue){return _this2.setState({ePlanState:checkedValue});}}));EPlanType=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22321,'计划任务类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-checkbox-group'},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.ePlanType.options,value:ePlanType,onChange:function onChange(checkedValue){return _this2.setState({ePlanType:checkedValue});}})));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EPlanCreator,EUserRole,EPlanState,EPlanType));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentPlanCreator:this.state.ePlanCreator,eContentUserRole:this.state.eUserRole,eContentPlanState:this.state.ePlanState,eContentPlanType:this.state.ePlanType};}}]);return Content_32;}(_react2.default.Component);exports.default=Content_32;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 任务元素
var Content_Task=function(_React$Component){(0,_inherits3.default)(Content_Task,_React$Component);function Content_Task(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_Task);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_Task.__proto__||(0,_getPrototypeOf2.default)(Content_Task)).call.apply(_ref,[this].concat(args))),_this),_this.state={eCreator:_this.props.eCreator,eUser:_this.props.eUser,eStartDate:_this.props.eStartDate,eEndDate:_this.props.eEndDate,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_Task,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eCreator=_state.eCreator,eUser=_state.eUser,eStartDate=_state.eStartDate,eEndDate=_state.eEndDate,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentCreator:this.state.eCreator,eContentUser:this.state.eUser,eContentStartDate:this.state.eStartDate,eContentEndDate:this.state.eEndDate,eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_Task;}(_react2.default.Component);exports.default=Content_Task;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 知识订阅
var Content_34=function(_React$Component){(0,_inherits3.default)(Content_34,_React$Component);function Content_34(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_34);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_34.__proto__||(0,_getPrototypeOf2.default)(Content_34)).call.apply(_ref,[this].concat(args))),_this),_this.state={eSubscribeDocCatalogIds:_this.props.eSubscribeDocCatalogIds,eSubscribeDocCatalog:_this.props.eSubscribeDocCatalog,eSubscribeTheme:_this.props.eSubscribeTheme,eSubscribeStartDate:_this.props.eSubscribeStartDate,eSubscribeEndDate:_this.props.eSubscribeEndDate,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_34,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eSubscribeDocCatalog=_state.eSubscribeDocCatalog,eSubscribeTheme=_state.eSubscribeTheme,eSubscribeStartDate=_state.eSubscribeStartDate,eSubscribeEndDate=_state.eSubscribeEndDate,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var ESubscribeDocCatalog=_react2.default.createElement('div',null);var ESubscribeTheme=_react2.default.createElement('div',null);var ESubscribeStartDate=_react2.default.createElement('div',null);var ESubscribeEndDate=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ESubscribeDocCatalog=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16398,'文档目录'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'doccategory',isMultCheckbox:true,isSingle:false,replaceDatas:eSubscribeDocCatalog||[],onChange:function onChange(ids,names,datas){return _this2.setState({eSubscribeDocCatalogIds:ids,eSubscribeDocCatalog:datas});}}));ESubscribeTheme=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24611,'订阅主题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eSubscribeTheme,onChange:function onChange(value){return _this2.setState({eSubscribeTheme:value});}}));ESubscribeStartDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24609,'订阅起始日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaDatePicker,{value:eSubscribeStartDate,onChange:function onChange(value){return _this2.setState({eSubscribeStartDate:value});}}));ESubscribeEndDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24610,'订阅最终日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaDatePicker,{value:eSubscribeEndDate,onChange:function onChange(value){return _this2.setState({eSubscribeEndDate:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,ESubscribeDocCatalog,ESubscribeTheme,ESubscribeStartDate,ESubscribeEndDate));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentSubscribeDocCatalog:this.state.eSubscribeDocCatalogIds,eContentSubscribeTheme:this.state.eSubscribeTheme,eContentSubscribeStartDate:this.state.eSubscribeStartDate,eContentSubscribeEndDate:this.state.eSubscribeEndDate};}}]);return Content_34;}(_react2.default.Component);exports.default=Content_34;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 音频元素
var Content_audio=function(_React$Component){(0,_inherits3.default)(Content_audio,_React$Component);function Content_audio(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_audio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_audio.__proto__||(0,_getPrototypeOf2.default)(Content_audio)).call.apply(_ref,[this].concat(args))),_this),_this.state={eAudioShow:_this.props.eAudioShow,eAudioForm:_this.props.eAudioForm},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_audio,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eAudioShow=_state.eAudioShow,eAudioForm=_state.eAudioForm;var EShowSetting=_react2.default.createElement('div',null);var EAudioFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33549,'显示设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement('div',{style:{width:'70px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInputNumber,{min:0,style:{width:'70px'},value:eAudioShow.height,onChange:function onChange(value){return _this2.setState({eAudioShow:(0,_extends3.default)({},eAudioShow,{height:value})});}})),_react2.default.createElement(_antd.Checkbox,{checked:eAudioShow.autoPlay,style:{marginLeft:'10px'},onChange:function onChange(e){return _this2.setState({eAudioShow:(0,_extends3.default)({},eAudioShow,{autoPlay:e.target.checked})});}},getLabel(22840,'自动播放')));var radioStyle={display:'block',height:'30px',lineHeight:'30px',marginBottom:'5px'};EAudioFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23786,'音频来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eAudioForm.type||'1',onChange:function onChange(e){return _this2.setState({eAudioForm:(0,_extends3.default)({},eAudioForm,{type:e.target.value})});}},_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'1'},getLabel(125333,'选择文件')),_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'2'},getLabel(386575,'URL路径'))),_react2.default.createElement('div',{style:{position:'absolute',top:0,left:0,width:'100%',marginLeft:'85px',paddingRight:'85px'}},_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_WeaMaterialLib2.default,{value:eAudioForm.src,onChange:function onChange(value){return _this2.setState({eAudioForm:(0,_extends3.default)({},eAudioForm,{src:value})});}})),_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_ecCom.WeaInput,{value:eAudioForm.url,onChange:function onChange(value){return _this2.setState({eAudioForm:(0,_extends3.default)({},eAudioForm,{url:value})});}}))));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowSetting,EAudioFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentAudioShow_height:this.state.eAudioShow.height,eContentAudioShow_autoPlay:this.state.eAudioShow.autoPlay,eContentAudioForm_type:this.state.eAudioForm.type||'1',eContentAudioForm_src:this.state.eAudioForm.src,eContentAudioForm_url:this.state.eAudioForm.url};}}]);return Content_audio;}(_react2.default.Component);exports.default=Content_audio;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 微博动态
var Content_blogStatus=function(_React$Component){(0,_inherits3.default)(Content_blogStatus,_React$Component);function Content_blogStatus(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_blogStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_blogStatus.__proto__||(0,_getPrototypeOf2.default)(Content_blogStatus)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_blogStatus,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_blogStatus;}(_react2.default.Component);exports.default=Content_blogStatus;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 收藏元素
var Content_favourite=function(_React$Component){(0,_inherits3.default)(Content_favourite,_React$Component);function Content_favourite(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_favourite);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_favourite.__proto__||(0,_getPrototypeOf2.default)(Content_favourite)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_favourite,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_favourite;}(_react2.default.Component);exports.default=Content_favourite;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// Flash元素
var Content_Flash=function(_React$Component){(0,_inherits3.default)(Content_Flash,_React$Component);function Content_Flash(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_Flash);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_Flash.__proto__||(0,_getPrototypeOf2.default)(Content_Flash)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFlashShow:_this.props.eFlashShow,eFlashForm:_this.props.eFlashForm},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_Flash,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFlashShow=_state.eFlashShow,eFlashForm=_state.eFlashForm;var EShowSetting=_react2.default.createElement('div',null);var EFlashFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33549,'显示设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eFlashShow.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eFlashShow:(0,_extends3.default)({},eFlashShow,{height:value})});}}));var radioStyle={display:'block',height:'30px',lineHeight:'30px',marginBottom:'5px'};EFlashFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386579,'Flash来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eFlashForm.type||'1',onChange:function onChange(e){return _this2.setState({eFlashForm:(0,_extends3.default)({},eFlashForm,{type:e.target.value})});}},_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'1'},getLabel(125333,'选择文件')),_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'2'},getLabel(386575,'URL路径'))),_react2.default.createElement('div',{style:{position:'absolute',top:0,left:0,width:'100%',marginLeft:'85px',paddingRight:'85px'}},_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_WeaMaterialLib2.default,{value:eFlashForm.src,onChange:function onChange(value){return _this2.setState({eFlashForm:(0,_extends3.default)({},eFlashForm,{src:value})});}})),_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_ecCom.WeaInput,{value:eFlashForm.url,onChange:function onChange(value){return _this2.setState({eFlashForm:(0,_extends3.default)({},eFlashForm,{url:value})});}}),_react2.default.createElement(_ecCom.WeaHelpfulTip,{style:{position:'absolute',paddingLeft:'10px'},title:getLabel(516348,'因chrome浏览器禁用flash，故chrome下不支持上传.swf、.flv格式视频')}))));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowSetting,EFlashFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentFlashShow_height:this.state.eFlashShow.height,eContentFlashShow_autoPlay:this.state.eFlashShow.autoPlay,eContentFlashForm_type:this.state.eFlashForm.type||'1',eContentFlashForm_src:this.state.eFlashForm.src,eContentFlashForm_url:this.state.eFlashForm.url};}}]);return Content_Flash;}(_react2.default.Component);exports.default=Content_Flash;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义菜单
var Content_menu=function(_React$Component){(0,_inherits3.default)(Content_menu,_React$Component);function Content_menu(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_menu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_menu.__proto__||(0,_getPrototypeOf2.default)(Content_menu)).call.apply(_ref,[this].concat(args))),_this),_this.state={eMenuFrom:_this.props.eMenuFrom.selected,eMenuStyleType:_this.props.eMenuStyleType,eMenuHStyle:_this.props.eMenuHStyle.selected,eMenuVStyle:_this.props.eMenuVStyle.selected},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_menu,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eMenuFrom=_state.eMenuFrom,eMenuStyleType=_state.eMenuStyleType,eMenuHStyle=_state.eMenuHStyle,eMenuVStyle=_state.eMenuVStyle;var EMenuFrom=_react2.default.createElement('div',null);var EMenuStyle=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EMenuFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(18773,'自定义菜单'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eMenuFrom.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eMenuFrom,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eMenuFrom:value});}}));EMenuStyle=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22916,'菜单样式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eMenuStyleType,onChange:function onChange(e){return _this2.setState({eMenuStyleType:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'menuh'},getLabel(386591,'横向样式（仅支持一级菜单）')),_react2.default.createElement(_antd.Radio,{value:'menuv'},getLabel(386592,'纵向样式（仅支持二级菜单）'))),eMenuStyleType=='menuh'?_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eMenuHStyle.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eMenuHStyle,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eMenuHStyle:value});}}):_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eMenuVStyle.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eMenuVStyle,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eMenuVStyle:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EMenuFrom,EMenuStyle));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,// eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
eContentMenuFrom:this.state.eMenuFrom,eContentMenuStyleType:this.state.eMenuStyleType,eContentMenuHStyle:this.state.eMenuHStyle,eContentMenuVStyle:this.state.eMenuVStyle};}}]);return Content_menu;}(_react2.default.Component);exports.default=Content_menu;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 公告栏元素
var Content_notice=function(_React$Component){(0,_inherits3.default)(Content_notice,_React$Component);function Content_notice(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_notice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_notice.__proto__||(0,_getPrototypeOf2.default)(Content_notice)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNoticeIcon:_this.props.eNoticeIcon,eNoticeTitle:_this.props.eNoticeTitle,eNoticeContent:_this.props.eNoticeContent,eNoticeScrollDirection:_this.props.eNoticeScrollDirection,eNoticeScrollSpeed:_this.props.eNoticeScrollSpeed,eNoticeIsText:_this.props.eNoticeIsText},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_notice,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eNoticeIcon=_state.eNoticeIcon,eNoticeTitle=_state.eNoticeTitle,eNoticeContent=_state.eNoticeContent,eNoticeScrollDirection=_state.eNoticeScrollDirection,eNoticeScrollSpeed=_state.eNoticeScrollSpeed,eNoticeIsText=_state.eNoticeIsText;var ENoticeIcon=_react2.default.createElement('div',null);var ENoticeTitle=_react2.default.createElement('div',null);var ENoticeContent=_react2.default.createElement('div',null);var ENoticeScrollDirection=_react2.default.createElement('div',null);var ENoticeScrollSpeed=_react2.default.createElement('div',null);var ENoticeIsText=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENoticeIcon=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(82757,'图标'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_WeaMaterialLib2.default,{value:eNoticeIcon,onChange:function onChange(value){return _this2.setState({eNoticeIcon:value});}}));ENoticeTitle=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:eNoticeTitle,onChange:function onChange(value){return _this2.setState({eNoticeTitle:value});}}));ENoticeContent=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33368,'内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNoticeContent,onChange:function onChange(value){return _this2.setState({eNoticeContent:value});}}));ENoticeScrollDirection=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eNoticeScrollDirection.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eNoticeScrollDirection,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eNoticeScrollDirection:value});}}));ENoticeScrollSpeed=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNoticeScrollSpeed,style:{width:'200px'},onChange:function onChange(value){return _this2.setState({eNoticeScrollSpeed:value});}}));ENoticeIsText=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19111,'纯文本格式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eNoticeIsText.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eNoticeIsText,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eNoticeIsText:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ENoticeIcon,ENoticeTitle,ENoticeContent,ENoticeScrollDirection,ENoticeScrollSpeed,ENoticeIsText));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentNoticeIcon:this.state.eNoticeIcon,eContentNoticeTitle:this.state.eNoticeTitle,eContentNoticeContent:this.state.eNoticeContent,eContentNoticeScrollDirection:this.state.eNoticeScrollDirection,eContentNoticeScrollSpeed:this.state.eNoticeScrollSpeed,eContentNoticeIsText:this.state.eNoticeIsText};}}]);return Content_notice;}(_react2.default.Component);exports.default=Content_notice;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_picture_detail_new=__webpack_require__(291);var _Content_picture_detail_new2=_interopRequireDefault(_Content_picture_detail_new);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// import Content_picture_detail from './Content_picture_detail';
// 图片元素
var Content_picture=function(_React$Component){(0,_inherits3.default)(Content_picture,_React$Component);function Content_picture(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_picture);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_picture.__proto__||(0,_getPrototypeOf2.default)(Content_picture)).call.apply(_ref,[this].concat(args))),_this),_this.state={ePopupSetting:_this.props.ePopupSetting,eDisplayMode:_this.props.eDisplayMode,eImageWidth:_this.props.eImageWidth,eImageHeight:_this.props.eImageHeight,eScrollAuto:_this.props.eScrollAuto,eScrollSpeed:_this.props.eScrollSpeed,eScrollPoint:_this.props.eScrollPoint,eInfoWordNum:_this.props.eInfoWordNum,eImageSource:_this.props.eImageSource,eIsAutoHiehgt:_this.props.isAutoHiehgt||'0',eImageWidthUnit:_this.props.imageWidthUnit||'px',eImageHeightUnit:_this.props.imageHeightUnit||'px',eRollingDirection:_this.props.rollingDirection||'1',showTitle:_this.props.showTitle||'1',fontSize:_this.props.fontSize||'16',detailModalVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_picture,[{key:'render',value:function render(){var _this2=this;var _state=this.state,ePopupSetting=_state.ePopupSetting,eDisplayMode=_state.eDisplayMode,eImageWidth=_state.eImageWidth,eImageHeight=_state.eImageHeight,eScrollAuto=_state.eScrollAuto,eScrollSpeed=_state.eScrollSpeed,eScrollPoint=_state.eScrollPoint,eInfoWordNum=_state.eInfoWordNum,eImageSource=_state.eImageSource,detailModalVisible=_state.detailModalVisible,eRollingDirection=_state.eRollingDirection,eImageWidthUnit=_state.eImageWidthUnit,eImageHeightUnit=_state.eImageHeightUnit,showTitle=_state.showTitle,fontSize=_state.fontSize;var eIsAutoHiehgt=this.state.eIsAutoHiehgt;if(eRollingDirection=='2'){eIsAutoHiehgt='0';}var options=[{key:"px",selected:true,showname:"px"},{key:"%",showname:"%"}];var EPopupSetting=_react2.default.createElement('div',null);var EDisplayMode=_react2.default.createElement('div',null);var EImageSize=_react2.default.createElement('div',null);var EPictureFrom=_react2.default.createElement('div',null);var ERollingDirection=_react2.default.createElement('div',null);var EScrollSpeed=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){var _ref2,_ref3,_ref4;EPopupSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24051,'弹出设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePopupSetting,onChange:function onChange(e){return _this2.setState({ePopupSetting:e.target.checked});}},getLabel(24052,"弹出图片")));EDisplayMode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eDisplayMode,onChange:function onChange(e){return _this2.setState({eDisplayMode:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'1'},getLabel(22920,'单张显示')),_react2.default.createElement(_antd.Radio,{value:'2'},getLabel(22921,'多张显示'))),this.state.eDisplayMode=='2'&&_react2.default.createElement('div',{style:{display:'inline-block',bottom:'3px'}},_react2.default.createElement('span',null,'\u5E03\u5C40'),_react2.default.createElement(_ecCom.WeaSelect,{value:eRollingDirection,options:[{key:"1",selected:true,showname:'横向'},{key:"2",showname:'纵向'}],style:{width:'80px',marginLeft:'10px'},onChange:function onChange(value){return _this2.setState({eRollingDirection:value});}})));EImageSize=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386564,'图片大小'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eImageWidth,style:{width:'40px',marginRight:'10px'},onChange:function onChange(value){return _this2.setState({eImageWidth:value});}}),_react2.default.createElement(_ecCom.WeaSelect,{value:eImageWidthUnit,options:options,style:{width:'70px',marginRight:'10px'},onChange:function onChange(value){return _this2.setState({eImageWidthUnit:value});}}),eIsAutoHiehgt!='1'&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eImageHeight,style:{width:'40px'},onChange:function onChange(value){return _this2.setState({eImageHeight:value});}}),_react2.default.createElement(_ecCom.WeaSelect,{value:eImageHeightUnit,options:options,style:{width:'70px',marginLeft:'10px'},onChange:function onChange(value){return _this2.setState({eImageHeightUnit:value});}})),eRollingDirection=='1'&&_react2.default.createElement('div',{style:(_ref2={display:'inline-block',position:'relative'},(0,_defineProperty3.default)(_ref2,'display','inline-block'),(0,_defineProperty3.default)(_ref2,'left','22px'),_ref2)},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eIsAutoHiehgt==1,onChange:function onChange(e){_this2.setState({eIsAutoHiehgt:e.target.checked?1:0});}},'自适应高度')));var modal2Detail=_react2.default.createElement('div',null);if(detailModalVisible){var detailProps={datas:eImageSource,showTitle:showTitle,fontSize:fontSize,onOk:function onOk(datas,showTitle,fontSize){_this2.setState({eImageSource:datas,detailModalVisible:false,showTitle:showTitle,fontSize:fontSize});},onCancel:function onCancel(){_this2.setState({detailModalVisible:false});}};modal2Detail=_react2.default.createElement(_Content_picture_detail_new2.default,detailProps);}EPictureFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22930,'图片来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{marginTop:'10px'}},_react2.default.createElement(_antd.Button,{type:'primary',size:'small',onClick:function onClick(){return _this2.setState({detailModalVisible:true});}},getLabel(22923,'图片设置'))),modal2Detail);EScrollSpeed=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eScrollSpeed,style:{width:'80px'},onChange:function onChange(value){return _this2.setState({eScrollSpeed:value});}}),_react2.default.createElement('span',{style:{top:' -4px',position:'relative'}},'ms'),_react2.default.createElement('div',{style:(_ref3={display:'inline-block',position:'relative'},(0,_defineProperty3.default)(_ref3,'display','inline-block'),(0,_defineProperty3.default)(_ref3,'left','22px'),_ref3)},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eScrollAuto,onChange:function onChange(e){_this2.setState({eScrollAuto:e.target.checked});}},getLabel(24548,'自动滚动'))),_react2.default.createElement('div',{style:(_ref4={display:'inline-block',position:'relative'},(0,_defineProperty3.default)(_ref4,'display','inline-block'),(0,_defineProperty3.default)(_ref4,'left','22px'),_ref4)},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eScrollPoint,onChange:function onChange(e){return _this2.setState({eScrollPoint:e.target.checked});}},getLabel(22928,'滚动指向'))));// ERollingDirection= (
//     <WeaFormItem label={'滚动方向'} labelCol={{span: 6}} wrapperCol={{span: 16}}>
//         <WeaSelect value={eRollingDirectionDetial} options={
//             eRollingDirection == '2' ?[{
//                 key: "0",
//                 selected: true,
//                 showname: '无'
//             },{
//                 key: "3",
//                 showname: '向上'
//             },{
//                 key: "4",
//                 showname: '向下',
//             }]:[{
//                 key: "0",
//                 selected: true,
//                 showname: '无'
//             },{
//                 key: "1",
//                 showname: '向左'
//             },{
//                 key: "2",
//                 showname: '向右',
//             }]
//         } style={{width: '80px', marginRight: '10px'}} onChange={value => this.setState({eRollingDirectionDetial: value})}></WeaSelect>
//         <Checkbox size="default" checked={eScrollPoint} onChange={e => this.setState({eScrollPoint: e.target.checked})}>{getLabel(22928, '滚动指向')}</Checkbox>
//     </WeaFormItem>
// );
}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EPopupSetting,EDisplayMode,EImageSize,eDisplayMode=='2'&&EScrollSpeed,EPictureFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentPopupSetting:this.state.ePopupSetting,eContentDisplayMode:this.state.eDisplayMode,eContentImageWidth:this.state.eImageWidth,eContentImageHeight:this.state.eImageHeight,eContentScrollAuto:this.state.eScrollAuto,eContentScrollSpeed:this.state.eScrollSpeed,eContentScrollPoint:this.state.eScrollPoint,eContentInfoWordNum:this.state.eInfoWordNum,eContentImageSource:this.state.eImageSource,eRollingDirection:this.state.eRollingDirection,eIsAutoHiehgt:this.state.eIsAutoHiehgt,eImageWidthUnit:this.state.eImageWidthUnit,eImageHeightUnit:this.state.eImageHeightUnit,eContentShowTitle:this.state.showTitle,eContentFontSize:this.state.fontSize};}}]);return Content_picture;}(_react2.default.Component);exports.default=Content_picture;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(106);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(47);var _Content_imgSlide_img=__webpack_require__(133);var _Content_imgSlide_img2=_interopRequireDefault(_Content_imgSlide_img);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 图片元素详细设置
var Content_picture_detail_new=function(_React$Component){(0,_inherits3.default)(Content_picture_detail_new,_React$Component);function Content_picture_detail_new(props){(0,_classCallCheck3.default)(this,Content_picture_detail_new);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_picture_detail_new.__proto__||(0,_getPrototypeOf2.default)(Content_picture_detail_new)).call(this,props));_this.state={visible:true,showTitle:props.showTitle,fontSize:props.fontSize,titles:getLabel(507,'图片上传'),datas:props.datas,selectedDatas:{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.getUuid=_this.getUuid.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeBgImage=_this.onChangeBgImage.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.getItems=_this.getItems.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.deleteTabs=_this.deleteTabs.bind(_this);return _this;}(0,_createClass3.default)(Content_picture_detail_new,[{key:'onRowSelect',value:function onRowSelect(sRowKeys,rows,dataIndex,selectedDatas){var newState={};newState.selectedRowKeys=sRowKeys;if(selectedDatas){newState.selectedDatas=selectedDatas;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:'getUuid',value:function getUuid(){var s=[];var hexDigits="0123456789abcdef";for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]="4";// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]=s[13]=s[18]=s[23]="-";var uuid=s.join("");return uuid;}},{key:'onChangeBgImage',value:function onChangeBgImage(index,value){if(value){var _state$datas=this.state.datas,datas=_state$datas===undefined?[]:_state$datas;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var _value=value.split(",");if("multiCheck"==index){for(var i=0;i<_value.length;i++){_datas.push({src:_value[i],title:'',link:''});}}else{_datas[index].src=value;}var __datas=_datas.map(function(item,index){return(0,_extends3.default)({},item,{key:index});});this.setState({datas:__datas});}}},{key:'getColumns',value:function getColumns(){var _this2=this;var _state=this.state,datas=_state.datas,fontSize=_state.fontSize,showTitle=_state.showTitle;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var columns=[{title:getLabel(126949,'图片预览'),display:'true',key:'src',width:'30%',className:'wea-table-edit-prew',render:function render(text,record,index){return _react2.default.createElement(_Content_imgSlide_img2.default,{title:record.title,imgSrc:record.src,fontSize:fontSize,showTitle:showTitle});}},{title:getLabel(386586,'图片标题'),display:'true',width:'25%',key:'title',className:'wea-table-edit-title',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this2['weaError_'+record.key]=el;},error:'\u6570\u636E\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title||'',viewAttr:showTitle=='1'?3:2,onChange:function onChange(value){_datas[record.key].title=value;_this2.setState({datas:_datas});}}));}},{title:getLabel(22932,'图片链接'),display:'true',width:'25%',key:'link',className:'wea-table-edit-imgAddress',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaInput,{value:record.link,onChange:function onChange(value){_datas[record.key].link=value;_this2.setState({datas:_datas});}});}},{title:getLabel(20001,'上传图片'),display:'true',width:'15%',className:'wea-table-edit-upload',render:function render(text,record,index){return _react2.default.createElement('div',{className:'e9login-bg-images-btns-materiallib'},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:false,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary'},getLabel(127538,'更改图片'))));}}];return columns;}},{key:'getItems',value:function getItems(){var _this3=this;var _state2=this.state,showTitle=_state2.showTitle,fontSize=_state2.fontSize;var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this3.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:fontSize,onChange:function onChange(value){return _this3.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))}];return items;}},{key:'onDeleteTabs',value:function onDeleteTabs(){var _state3=this.state,selectedRowKeys=_state3.selectedRowKeys,datas=_state3.datas;for(var i=0;i<selectedRowKeys.length;i++){this.deleteTabs(selectedRowKeys[i]);}this.setState({selectedRowKeys:[]});}},{key:'deleteTabs',value:function deleteTabs(dataId){var _state4=this.state,datas=_state4.datas,selectedRowKeys=_state4.selectedRowKeys;for(var i=0;i<datas.length;i++){if(datas[i].key==dataId){datas.splice(i,1);break;}}this.setState({datas:datas,selectedRowKeys:[]});}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _state5=this.state,visible=_state5.visible,eFieldNewDataSource=_state5.eFieldNewDataSource,eFieldNewUsedKeys=_state5.eFieldNewUsedKeys,searchName=_state5.searchName,title=_state5.title,items=_state5.items,isModalEdit=_state5.isModalEdit,datas=_state5.datas,titles=_state5.titles,selectedDatas=_state5.selectedDatas,selectedRowKeys=_state5.selectedRowKeys;// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};console.log("--------datas :",datas);return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel,hasScroll:true},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:titles,needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:true,onChange:function onChange(value){return _this4.onChangeBgImage("multiCheck",value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'}},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})))),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),style:{borderRadius:0,margin:'0 10px',padding:'0 4px'},onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,(_React$createElement={ref:'tableEdit',draggable:true,isModalEdit:isModalEdit,dataSource:datas//title={titles}
},(0,_defineProperty3.default)(_React$createElement,'ref',function ref(el){_this4.table=el;}),(0,_defineProperty3.default)(_React$createElement,'rowSelection',rowSelection),(0,_defineProperty3.default)(_React$createElement,'selectedData',selectedDatas),(0,_defineProperty3.default)(_React$createElement,'selectedRowKeys',selectedRowKeys),(0,_defineProperty3.default)(_React$createElement,'columns',this.getColumns()),_React$createElement))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this5=this;var _state6=this.state,datas=_state6.datas,showTitle=_state6.showTitle,fontSize=_state6.fontSize;var isPass=true;var datasNew=datas.map(function(item,index){if(showTitle=='1'&&item.title==''){_this5['weaError_'+index]&&_this5['weaError_'+index].showError();isPass=false;return;}return(0,_extends3.default)({},item,{orderNum:index,key:index});});isPass&&this.props.onOk(datasNew,showTitle,fontSize);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_picture_detail_new;}(_react2.default.Component);exports.default=Content_picture_detail_new;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(293);
module.exports = __webpack_require__(20).Object.keys;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(41);
var $keys = __webpack_require__(44);

__webpack_require__(122)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 图表元素
var Content_reportForm=function(_React$Component){(0,_inherits3.default)(Content_reportForm,_React$Component);function Content_reportForm(){(0,_classCallCheck3.default)(this,Content_reportForm);return(0,_possibleConstructorReturn3.default)(this,(Content_reportForm.__proto__||(0,_getPrototypeOf2.default)(Content_reportForm)).apply(this,arguments));}(0,_createClass3.default)(Content_reportForm,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_reportForm;}(_react2.default.Component);exports.default=Content_reportForm;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ENewsMould=__webpack_require__(105);var _ENewsMould2=_interopRequireDefault(_ENewsMould);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 搜索元素
var Content_searchengine=function(_React$Component){(0,_inherits3.default)(Content_searchengine,_React$Component);function Content_searchengine(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_searchengine);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_searchengine.__proto__||(0,_getPrototypeOf2.default)(Content_searchengine)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNewsFrom:_this.props.eNewsFrom},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_searchengine,[{key:'render',value:function render(){var _this2=this;var eNewsFrom=this.state.eNewsFrom;var ENewsFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENewsFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22919,'新闻来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'docnews',isMultCheckbox:false,isSingle:true,replaceDatas:eNewsFrom,dataParams:{publishtype:0},completeParams:{publishtype:0},onChange:function onChange(ids,names,datas){return _this2.setState({eNewsFromIds:ids,eNewsFrom:datas});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ENewsFrom,_react2.default.createElement(_ENewsMould2.default,{ref:'eNewsMould',options:this.props.eNewsMould.options,value:this.props.eNewsMould.selected})));}},{key:'getSaveValues',value:function getSaveValues(){var eNewsFrom=this.state.eNewsFrom;return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentNewsFrom:eNewsFrom&&eNewsFrom.length?eNewsFrom[0].id:'',eContentNewsMould:this.refs['eNewsMould'].getSaveValues()};}}]);return Content_searchengine;}(_react2.default.Component);exports.default=Content_searchengine;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_Slide_detail=__webpack_require__(297);var _Content_Slide_detail2=_interopRequireDefault(_Content_Slide_detail);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 幻灯片
var Content_Slide=function(_React$Component){(0,_inherits3.default)(Content_Slide,_React$Component);function Content_Slide(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_Slide);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_Slide.__proto__||(0,_getPrototypeOf2.default)(Content_Slide)).call.apply(_ref,[this].concat(args))),_this),_this.state={eAutoScrollTime:_this.props.eAutoScrollTime||1000,eChangeEffect:_this.props.eChangeEffect.selected,eSmoothMoveTime:_this.props.eSmoothMoveTime||1000,eNavDisplayPosition:_this.props.eNavDisplayPosition,eSlideDetail:_this.props.eSlideDetail,showTitle:_this.props.showTitle||'0',fontSize:_this.props.fontSize||'16',showType:_this.props.showType||'1',eDisplayMode:_this.props.eDisplayMode.selected,detailModalVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_Slide,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eAutoScrollTime=_state.eAutoScrollTime,eChangeEffect=_state.eChangeEffect,eSmoothMoveTime=_state.eSmoothMoveTime,eNavDisplayPosition=_state.eNavDisplayPosition,eSlideDetail=_state.eSlideDetail,detailModalVisible=_state.detailModalVisible,eDisplayMode=_state.eDisplayMode,showTitle=_state.showTitle,fontSize=_state.fontSize,showType=_state.showType;var EAutoScrollTime=_react2.default.createElement('div',null);var EChangeEffect=_react2.default.createElement('div',null);var ESmoothMoveTime=_react2.default.createElement('div',null);var ENavDisplayPosition=_react2.default.createElement('div',null);var EModal2Detail=_react2.default.createElement('div',null);var EDisplayMode=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EAutoScrollTime=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(26286,'自动滚动时间'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'70px',marginRight:'10px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInputNumber,{value:eAutoScrollTime,min:0,onChange:function onChange(value){return _this2.setState({eAutoScrollTime:value});}})),_react2.default.createElement('span',null,getLabel(26287,'毫秒')));EChangeEffect=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(26288,'切换效果'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eChangeEffect.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eChangeEffect,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eChangeEffect:value});}}));ESmoothMoveTime=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(26289,'平滑移动时间'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'70px',marginRight:'10px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInputNumber,{min:0,value:eSmoothMoveTime,onChange:function onChange(value){return _this2.setState({eSmoothMoveTime:value});}})),_react2.default.createElement('span',null,getLabel(26287,'毫秒')));var modal2Detail=_react2.default.createElement('div',null);if(detailModalVisible){var detailProps={eSlideDetail:eSlideDetail,showTitle:showTitle,fontSize:fontSize,showType:showType,onOk:function onOk(eSlideDetail,showTitle,fontSize,showType){_this2.setState({eSlideDetail:eSlideDetail,fontSize:fontSize,showTitle:showTitle,showType:showType,detailModalVisible:false});},onCancel:function onCancel(){_this2.setState({detailModalVisible:false});}};modal2Detail=_react2.default.createElement(_Content_Slide_detail2.default,detailProps);}EModal2Detail=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19342,'详细设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Button,{style:{marginTop:5},type:'primary',size:'small',onClick:function onClick(){return _this2.setState({detailModalVisible:true});}},getLabel(19342,'详细设置')),modal2Detail);ENavDisplayPosition=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386597,'导航显示位置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eNavDisplayPosition,onChange:function onChange(e){return _this2.setState({eNavDisplayPosition:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'1'},getLabel(22986,'左')),_react2.default.createElement(_antd.Radio,{value:'2'},getLabel(22988,'右')),_react2.default.createElement(_antd.Radio,{value:'3'},getLabel(23010,'下'))));EDisplayMode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(81763,'图片显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eDisplayMode.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eDisplayMode,style:{width:'200px'},detailtype:3,onChange:function onChange(value){_this2.setState({eDisplayMode:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EAutoScrollTime,EChangeEffect,ESmoothMoveTime,ENavDisplayPosition,EDisplayMode,EModal2Detail));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentAutoScrollTime:this.state.eAutoScrollTime,eContentChangeEffect:this.state.eChangeEffect,eContentSmoothMoveTime:this.state.eSmoothMoveTime,eContentNavDisplayPosition:this.state.eNavDisplayPosition,eContentSlideDetail:this.state.eSlideDetail,showTitle:this.state.showTitle,fontSize:this.state.fontSize,showType:this.state.showType,eContenteDisplayMode:this.state.eDisplayMode};}}]);return Content_Slide;}(_react2.default.Component);exports.default=Content_Slide;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 幻灯片详细设置
var Content_Slide_detail=function(_React$Component){(0,_inherits3.default)(Content_Slide_detail,_React$Component);function Content_Slide_detail(props){(0,_classCallCheck3.default)(this,Content_Slide_detail);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_Slide_detail.__proto__||(0,_getPrototypeOf2.default)(Content_Slide_detail)).call(this,props));_this.state={eSlideDetail:_this.props.eSlideDetail,showTitle:_this.props.showTitle||'0',fontSize:_this.props.fontSize||'16',showType:_this.props.showType||'1'};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.getItems=_this.getItems.bind(_this);return _this;}(0,_createClass3.default)(Content_Slide_detail,[{key:'getItems',value:function getItems(){var _this2=this;var _state=this.state,showTitle=_state.showTitle,fontSize=_state.fontSize,showType=_state.showType;var options=[{key:"1",showname:getLabel(514068,'黑底白字'),selected:true},{key:"2",showname:getLabel(514069,'白底黑字'),selected:false}];var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this2.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block',width:'82px'}},_react2.default.createElement(_ecCom.WeaInputNumber,{min:0,value:fontSize,onChange:function onChange(value){return _this2.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}})),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(501242,'标题栏样式'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaSelect,{options:options,value:showType,detailtype:3,onChange:function onChange(value){return _this2.setState({showType:value});},style:{display:'inline-block'}})))}];return items;}},{key:'render',value:function render(){var _this3=this;var showTitle=this.state.showTitle;var columns=[{title:getLabel(26283,'主图片'),dataIndex:'mainImage',render:function render(text,record){return _react2.default.createElement(_WeaMaterialLib2.default,{value:text,onChange:_this3.onDetailChange.bind(_this3,record.key,'mainImage')});}},{title:getLabel(26284,'导航样式背景图'),dataIndex:'bgImage',render:function render(text,record){return _react2.default.createElement(_WeaMaterialLib2.default,{value:text,onChange:_this3.onDetailChange.bind(_this3,record.key,'bgImage')});}},{title:getLabel(386598,'导航样式前景图'),dataIndex:'fgImage',render:function render(text,record){return _react2.default.createElement(_WeaMaterialLib2.default,{value:text,onChange:_this3.onDetailChange.bind(_this3,record.key,'fgImage')});}},{title:getLabel(24986,'标题'),dataIndex:'title',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this3['weaError_'+record.key]=el;},error:'\u6807\u9898\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:text,viewAttr:showTitle=='1'?3:2,onChange:_this3.onDetailChange.bind(_this3,record.key,'title')}));}},{title:getLabel(433,'描述'),dataIndex:'desc',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this3.onDetailChange.bind(_this3,record.key,'desc')});}},{title:getLabel(22932,'图片链接'),dataIndex:'link',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this3.onDetailChange.bind(_this3,record.key,'link')});}}];return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:1037,height:492},zIndex:1000,hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:this.state.eSlideDetail,pagination:false}),_react2.default.createElement('div',{style:{margin:'25px'}},_react2.default.createElement('div',null,_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(125776,"说明:"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(390855,"1、建议主图片大小为2000像素*160像素"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(390856,"2、建议导航样式背景图大小为150像素*40像素"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(390857,"3、建议导航样式前景图大小为165像素*40像素"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(502246,"4、设置了主图片，建议设置导航图"))))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onDetailChange',value:function onDetailChange(key,type,value){var eSlideDetail=this.state.eSlideDetail;eSlideDetail[key][type]=value;this.setState({eSlideDetail:eSlideDetail});}},{key:'onOk',value:function onOk(){var _this4=this;var _state2=this.state,eSlideDetail=_state2.eSlideDetail,showTitle=_state2.showTitle,fontSize=_state2.fontSize,showType=_state2.showType;var isPass=true;if(this.state.showTitle=='1'){eSlideDetail.map(function(item,index){if(item.title==''){_this4['weaError_'+index].showError();isPass=false;return;}});}isPass&&this.props.onOk(eSlideDetail,showTitle,fontSize,showType);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_Slide_detail;}(_react2.default.Component);exports.default=Content_Slide_detail;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_video_detailedSetting=__webpack_require__(299);var _Content_video_detailedSetting2=_interopRequireDefault(_Content_video_detailedSetting);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 视频元素
var Content_video=function(_React$Component){(0,_inherits3.default)(Content_video,_React$Component);function Content_video(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_video);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_video.__proto__||(0,_getPrototypeOf2.default)(Content_video)).call.apply(_ref,[this].concat(args))),_this),_this.state={eVideoShow:_this.props.eVideoShow,eVideoForm:_this.props.eVideoForm,eShowType:_this.props.eVideoShowType||'1',eAutoHeight:_this.props.eAutoHeight||false,eShowMulitline:_this.props.showMulitline||false,eShowNums:_this.props.showNums||1,eDetailedSettingible:false,showTitle:_this.props.showTitle||'0',fontSize:_this.props.fontSize||'16',datas:_this.props.datas},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_video,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eVideoShow=_state.eVideoShow,eVideoForm=_state.eVideoForm,eShowType=_state.eShowType,eAutoHeight=_state.eAutoHeight,eDetailedSettingible=_state.eDetailedSettingible,datas=_state.datas,showTitle=_state.showTitle,fontSize=_state.fontSize,eShowMulitline=_state.eShowMulitline,eShowNums=_state.eShowNums;var VideoDetailedSetting=_react2.default.createElement('div',null);var eDSProps={};if(eDetailedSettingible){var videoDatas=datas.map(function(item,index){item.key=index;return item;});eDSProps={datas:videoDatas,showTitle:showTitle,fontSize:fontSize,onOk:function onOk(datas,showTitle,fontSize){_this2.setState({datas:datas,showTitle:showTitle,fontSize:fontSize,eDetailedSettingible:false});},onCancel:function onCancel(){_this2.setState({eDetailedSettingible:false});}};VideoDetailedSetting=_react2.default.createElement(_Content_video_detailedSetting2.default,eDSProps);}var options=[{key:"1",selected:true,showname:"单个显示"},{key:"2",selected:false,showname:"多个显示"}];var EShowSetting=_react2.default.createElement('div',null);var EVideoFrom=_react2.default.createElement('div',null);var EShowType=_react2.default.createElement('div',null);var EShowFullScreen=_react2.default.createElement('div',null);var EAutoPlay=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:"视频高度",labelCol:{span:6},wrapperCol:{span:16}},!eAutoHeight&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eVideoShow.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eVideoShow:(0,_extends3.default)({},eVideoShow,{height:value})});}}),_react2.default.createElement('span',{style:{display:'inline-block',marginBottom:'6px',marginLeft:'9px'}},'px')),_react2.default.createElement(_antd.Checkbox,{checked:eAutoHeight,style:{marginLeft:!eAutoHeight?'10px':0},onChange:function onChange(e){return _this2.setState({eAutoHeight:e.target.checked});}},'自适应高度'));EShowType=_react2.default.createElement(_ecCom.WeaFormItem,{label:"显示方式",labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{style:{width:'200px'},options:options,detailtype:3,value:eShowType,onChange:function onChange(value){if(value=='1'){_this2.setState({eShowType:value,eShowMulitline:false,eShowNums:1});}else{_this2.setState({eShowType:value});}}}),eShowType=='2'&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_antd.Checkbox,{checked:eShowMulitline,style:{marginLeft:!eAutoHeight?'10px':0,display:'inline-block'},onChange:function onChange(e){return _this2.setState({eShowMulitline:e.target.checked});}},'多行显示'),_react2.default.createElement('span',{style:{display:'inline-block'}},'每行显示个数'),_react2.default.createElement(_ecCom.WeaInput,{value:eShowNums,onChange:function onChange(value){return _this2.setState({eShowNums:value});},style:{display:'inline-block',width:'100px',position:'absolute',top:'-3px'}})));EShowFullScreen=_react2.default.createElement(_ecCom.WeaFormItem,{label:"允许全屏显示",labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{display:'switch',value:eVideoShow.showFullScreen,onChange:function onChange(v){_this2.setState({eVideoShow:(0,_extends3.default)({},eVideoShow,{showFullScreen:v==1})});}}));EAutoPlay=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22840,'自动播放'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{display:'switch',value:eVideoShow.autoPlay,onChange:function onChange(v){_this2.setState({eVideoShow:(0,_extends3.default)({},eVideoShow,{autoPlay:v==1})});}}));EVideoFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22841,'视频来源'),labelCol:{span:6},wrapperCol:{span:16}},VideoDetailedSetting,_react2.default.createElement('div',{style:{marginTop:7},onClick:function onClick(){return _this2.setState({eDetailedSettingible:true});}},_react2.default.createElement('a',{href:'javascript:void(0);'},'设置')));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowSetting,EShowType,EShowFullScreen,eShowType=='1'&&EAutoPlay,EVideoFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentVideoShow_height:this.state.eVideoShow.height,eContentShowType:this.state.eShowType,eContentAutoHeight:this.state.eAutoHeight,eContentShowMulitline:this.state.eShowMulitline,eContentShowNums:this.state.eShowNums,eContentVideoShow_showFullScreen:this.state.eVideoShow.showFullScreen,eContentVideoShow_autoPlay:this.state.eVideoShow.autoPlay,eContentDatas:this.state.datas,eContentShowTitle:this.state.showTitle,eContentFontSize:this.state.fontSize};}}]);return Content_video;}(_react2.default.Component);exports.default=Content_video;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(106);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(47);var _Content_video_prew=__webpack_require__(300);var _Content_video_prew2=_interopRequireDefault(_Content_video_prew);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 多图元素详细设置
var Content_video_detailedSetting=function(_React$Component){(0,_inherits3.default)(Content_video_detailedSetting,_React$Component);function Content_video_detailedSetting(props){(0,_classCallCheck3.default)(this,Content_video_detailedSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_video_detailedSetting.__proto__||(0,_getPrototypeOf2.default)(Content_video_detailedSetting)).call(this,props));_this.state={visible:true,showTitle:props.showTitle,fontSize:props.fontSize,titles:_react2.default.createElement('div',{style:{display:'-webkit-box',position:'absolute'}},getLabel(508352,'视频设置'),_react2.default.createElement('span',{style:{whiteSpace:'nowrap',fontSize:'12px',color:'rgb(153, 153, 153)',display:'table',position:'absolute',top:'0',left:'70px'}},getLabel(501054,'视频元素目前只支持Ogg、MPEG4、WebM三种格式'))),datas:props.datas,selectedDatas:{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.getUuid=_this.getUuid.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeBgImage=_this.onChangeBgImage.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.getItems=_this.getItems.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.deleteTabs=_this.deleteTabs.bind(_this);_this.onAddTabs=_this.onAddTabs.bind(_this);return _this;}(0,_createClass3.default)(Content_video_detailedSetting,[{key:'onRowSelect',value:function onRowSelect(sRowKeys,rows,dataIndex,selectedDatas){var newState={};newState.selectedRowKeys=sRowKeys;if(selectedDatas){newState.selectedDatas=selectedDatas;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:'getUuid',value:function getUuid(){var s=[];var hexDigits="0123456789abcdef";for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]="4";// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]=s[13]=s[18]=s[23]="-";var uuid=s.join("");return uuid;}},{key:'onChangeBgImage',value:function onChangeBgImage(index,value){if(value){var _state$datas=this.state.datas,datas=_state$datas===undefined?{}:_state$datas;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var _value=value.split(",");if("multiCheck"==index){for(var i=0;i<_value.length;i++){_datas.push({key:this.getUuid(),videoUrl:_value[i],title:'',addType:'1'});}}else{_datas[index].videoUrl=value;}var __datas=_datas.map(function(item,index){return(0,_extends3.default)({},item,{key:index});});this.setState({datas:__datas});}}},{key:'getColumns',value:function getColumns(){var _this2=this;var _state=this.state,_state$datas2=_state.datas,datas=_state$datas2===undefined?{}:_state$datas2,fontSize=_state.fontSize,showTitle=_state.showTitle;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var options=[{key:"1",selected:true,showname:"选择文件"},{key:"2",showname:"URL路径"}];var columns=[{title:'视频来源',display:'true',width:'33%',className:'wea-table-edit-upload',render:function render(text,record,index){return _react2.default.createElement('div',{className:'e9login-bg-images-btns-materiallib'},_react2.default.createElement(_ecCom.WeaSelect,{style:{width:'60%',paddingBottom:'30px'},options:options,value:record.addType,onChange:function onChange(value){_datas[record.key].addType=value;_this2.setState({datas:_datas});}}),record.addType=='1'?_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{value:record.videoUrl,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);}}):_react2.default.createElement(_ecCom.WeaInput,{value:record.videoUrl,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);}}));}},{title:'视频预览',display:'true',key:'img',width:'33%',className:'wea-table-edit-prew',render:function render(text,record,index){return _react2.default.createElement(_Content_video_prew2.default,{title:record.title,imgSrc:record.videoUrl,fontSize:fontSize,showTitle:showTitle});}},{title:'视频标题',display:'true',width:'33%',key:'title',className:'wea-table-edit-title',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this2['weaError_'+index]=el;},error:'\u6570\u636E\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title||'',viewAttr:showTitle=='1'?3:2,onChange:function onChange(value){_datas[record.key].title=value;_this2.setState({datas:_datas});}}));}}];return columns;}},{key:'getItems',value:function getItems(){var _this3=this;var _state2=this.state,showTitle=_state2.showTitle,fontSize=_state2.fontSize;var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this3.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:fontSize,onChange:function onChange(value){return _this3.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))}];return items;}},{key:'onDeleteTabs',value:function onDeleteTabs(){var _state3=this.state,selectedRowKeys=_state3.selectedRowKeys,datas=_state3.datas;for(var i=0;i<selectedRowKeys.length;i++){this.deleteTabs(selectedRowKeys[i]);}this.setState({selectedRowKeys:[]});}},{key:'onAddTabs',value:function onAddTabs(){var _state$datas3=this.state.datas,datas=_state$datas3===undefined?{}:_state$datas3;var _datas=[].concat((0,_toConsumableArray3.default)(datas));_datas.push({key:_datas.length,videoUrl:'',title:'',addType:'2'});this.setState({datas:_datas});}},{key:'deleteTabs',value:function deleteTabs(dataId){var _state4=this.state,datas=_state4.datas,selectedRowKeys=_state4.selectedRowKeys;for(var i=0;i<datas.length;i++){if(datas[i].key==dataId){datas.splice(i,1);break;}}this.setState({datas:datas,selectedRowKeys:[]});}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _state5=this.state,visible=_state5.visible,eFieldNewDataSource=_state5.eFieldNewDataSource,eFieldNewUsedKeys=_state5.eFieldNewUsedKeys,searchName=_state5.searchName,title=_state5.title,items=_state5.items,isModalEdit=_state5.isModalEdit,datas=_state5.datas,titles=_state5.titles,selectedDatas=_state5.selectedDatas,selectedRowKeys=_state5.selectedRowKeys;// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};console.log("-------datas :",datas);return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel,hasScroll:true},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:titles,needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'},title:getLabel(125333,'选择文件')},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:true,onChange:function onChange(value){return _this4.onChangeBgImage("multiCheck",value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'}},_react2.default.createElement(_antd.Icon,{type:'search',style:{color:'#fff'}})))),_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,margin:'0 10px',padding:'0 4px'},onClick:this.onAddTabs,title:getLabel(384113,'添加')},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),title:getLabel(506969,'删除'),style:{borderRadius:0,padding:'0 4px'},onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,(_React$createElement={ref:'tableEdit',draggable:true,isModalEdit:isModalEdit,dataSource:datas//title={titles}
},(0,_defineProperty3.default)(_React$createElement,'ref',function ref(el){_this4.table=el;}),(0,_defineProperty3.default)(_React$createElement,'rowSelection',rowSelection),(0,_defineProperty3.default)(_React$createElement,'selectedData',selectedDatas),(0,_defineProperty3.default)(_React$createElement,'selectedRowKeys',selectedRowKeys),(0,_defineProperty3.default)(_React$createElement,'columns',this.getColumns()),_React$createElement))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this5=this;var _state6=this.state,datas=_state6.datas,showTitle=_state6.showTitle,fontSize=_state6.fontSize;var isPass=true;if(showTitle=='1'){datas.map(function(item,index){if(item.title==''){_this5['weaError_'+index]&&_this5['weaError_'+index].showError();isPass=false;return;}});}isPass&&this.props.onOk(datas,showTitle,fontSize);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_video_detailedSetting;}(_react2.default.Component);exports.default=Content_video_detailedSetting;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content_video_prew=function(_React$Component){(0,_inherits3.default)(Content_video_prew,_React$Component);function Content_video_prew(){(0,_classCallCheck3.default)(this,Content_video_prew);return(0,_possibleConstructorReturn3.default)(this,(Content_video_prew.__proto__||(0,_getPrototypeOf2.default)(Content_video_prew)).apply(this,arguments));}(0,_createClass3.default)(Content_video_prew,[{key:'render',value:function render(){var _props=this.props,title=_props.title,imgSrc=_props.imgSrc,fontSize=_props.fontSize,showTitle=_props.showTitle;return _react2.default.createElement('div',{style:{padding:'0px',position:'relative',width:'230px'}},_react2.default.createElement('div',{style:{position:'relative',zIndex:1}},_react2.default.createElement('video',{src:imgSrc,ref:this.vidRef,style:{width:'230px',height:'150px',verticalAlign:'middle'},height:'150px',loop:'loop',controlsList:'nodownload',controls:'controls'})),_react2.default.createElement('div',{style:{zIndex:3,bottom:0,color:'black',height:'35px',lineHeight:'35px',textAlign:'center',width:'100%',fontSize:fontSize+'px',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},showTitle=='1'?title:''));}}]);return Content_video_prew;}(_react2.default.Component);exports.default=Content_video_prew;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 天气元素
var Content_weather=function(_React$Component){(0,_inherits3.default)(Content_weather,_React$Component);function Content_weather(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_weather);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_weather.__proto__||(0,_getPrototypeOf2.default)(Content_weather)).call.apply(_ref,[this].concat(args))),_this),_this.state={eCityName:_this.props.eCityName,eAutoScroll:_this.props.eAutoScroll.selected,eShowWidth:_this.props.eShowWidth},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_weather,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eCityName=_state.eCityName,eAutoScroll=_state.eAutoScroll,eShowWidth=_state.eShowWidth;var ECityName=_react2.default.createElement('div',null);var EAutoScroll=_react2.default.createElement('div',null);var EShowWidth=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ECityName=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15246,'城市名称'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eCityName,style:{width:'50%'},onChange:function onChange(value){return _this2.setState({eCityName:value});}}),_react2.default.createElement('div',{style:{padding:'7px 7px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(386599,'请确认服务器可以访问www.weather.com.cn'),isCenter:true})),_react2.default.createElement('div',null,getLabel(25899,'多城市名称请用半角逗号分隔（上海,北京）')));EAutoScroll=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24548,'自动滚动'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{size:'default',value:eAutoScroll,onChange:function onChange(e){return _this2.setState({eAutoScroll:e.target.value});}},this.props.eAutoScroll.options.map(function(item,index){return _react2.default.createElement(_antd.Radio,{key:index,value:item.value},item.label);})));EShowWidth=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24561,'显示宽度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInputNumber,{min:0,value:eShowWidth,style:{width:'50%'},onChange:function onChange(value){return _this2.setState({eShowWidth:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ECityName,EAutoScroll,EShowWidth));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentCityName:this.state.eCityName,eContentAutoScroll:this.state.eAutoScroll,eContentShowWidth:this.state.eShowWidth};}}]);return Content_weather;}(_react2.default.Component);exports.default=Content_weather;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 便签元素
var Content_scratchpad=function(_React$Component){(0,_inherits3.default)(Content_scratchpad,_React$Component);function Content_scratchpad(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_scratchpad);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_scratchpad.__proto__||(0,_getPrototypeOf2.default)(Content_scratchpad)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNoteSetting:_this.props.eNoteSetting},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_scratchpad,[{key:'render',value:function render(){var _this2=this;var eNoteSetting=this.state.eNoteSetting;var ENoteSetting=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENoteSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33549,'显示设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eNoteSetting.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eNoteSetting:(0,_extends3.default)({},eNoteSetting,{height:value})});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ENoteSetting));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentNoteHeight:this.state.eNoteSetting.height};}}]);return Content_scratchpad;}(_react2.default.Component);exports.default=Content_scratchpad;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _SynergySetting4Designer=__webpack_require__(100);var _SynergySetting4Designer2=_interopRequireDefault(_SynergySetting4Designer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 日历日程
var Content_MyCalendar=function(_React$Component){(0,_inherits3.default)(Content_MyCalendar,_React$Component);function Content_MyCalendar(props){(0,_classCallCheck3.default)(this,Content_MyCalendar);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_MyCalendar.__proto__||(0,_getPrototypeOf2.default)(Content_MyCalendar)).call(this,props));_this.state={value:_this.props.isShowLunarDatas||'0'};return _this;}(0,_createClass3.default)(Content_MyCalendar,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var stype=synergyParams.stype,pagetype=synergyParams.pagetype,ispagedeal=synergyParams.ispagedeal;var customComponent=_react2.default.createElement('div',null);if(eShareLevel=='2'){customComponent=_react2.default.createElement('div',null,hpid<0&&stype=='wf'&&pagetype=='operat'&&ispagedeal=='1'?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4d.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,isGlobal:true}));}},getLabel(17632,'参数设置')):'');}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true,customComponent:customComponent},_react2.default.createElement(_SynergySetting4Designer2.default,{ref:function ref(ss4d){return _this2.ss4d=ss4d;}}),_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:'是否显示农历',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{display:'switch',value:this.state.value,onChange:function onChange(value){return _this2.setState({value:value});}})):''));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,isShowLunarDatas:this.state.value};}}]);return Content_MyCalendar;}(_react2.default.Component);exports.default=Content_MyCalendar;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends4=__webpack_require__(8);var _extends5=_interopRequireDefault(_extends4);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 个人数据
var Content_DataCenter=function(_React$Component){(0,_inherits3.default)(Content_DataCenter,_React$Component);function Content_DataCenter(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_DataCenter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_DataCenter.__proto__||(0,_getPrototypeOf2.default)(Content_DataCenter)).call.apply(_ref,[this].concat(args))),_this),_this.state={eSyncContent:_this.props.eSyncContent,eSyncContentAll:false,eContentShowType:_this.props.eContentShowType||'0',eShowContent4Person:_this.props.eShowContent4Person},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_DataCenter,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eSyncContent=_state.eSyncContent,eSyncContentAll=_state.eSyncContentAll,eShowContent4Person=_state.eShowContent4Person;var ESyncContent=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'&&!!eSyncContent){ESyncContent=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(32328,'同步内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Switch,{size:'small',checked:eSyncContentAll,onChange:function onChange(checked){return _this2.setState({eSyncContentAll:checked});}}));}var eShowContent4PersonList=[];var _loop=function _loop(key){if(eShowContent4Person.hasOwnProperty(key)){eShowContent4PersonList.push(_react2.default.createElement('li',{style:{height:'35px'}},_react2.default.createElement('div',{style:{width:120,display:"inline-block"}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eShowContent4Person[key].checked,onChange:function onChange(e){return _this2.setState({eShowContent4Person:(0,_extends5.default)({},eShowContent4Person,(0,_defineProperty3.default)({},key,(0,_extends5.default)({},eShowContent4Person[key],{checked:e.target.checked})))});}},eShowContent4Person[key].label)),_react2.default.createElement(_ecCom.WeaColorPicker,{value:eShowContent4Person[key].color,onChange:function onChange(value){return _this2.setState({eShowContent4Person:(0,_extends5.default)({},eShowContent4Person,(0,_defineProperty3.default)({},key,(0,_extends5.default)({},eShowContent4Person[key],{color:value})))});}})));}};for(var key in eShowContent4Person){_loop(key);}var EShowContent4Person=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{ref:'eShowContent4Person'},eShowContent4PersonList));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_ecCom.WeaFormItem,{label:'展现方式',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:"0",showname:"图标"},{key:"1",showname:"内容文字"}],value:this.state.eContentShowType,detailtype:3,onChange:function onChange(value){_this2.setState({eContentShowType:value});}})),ESyncContent,EShowContent4Person));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentSync:this.state.eSyncContent,eContentShowType:this.state.eContentShowType,eContentSyncAll:this.state.eSyncContentAll,eContentShow:this.state.eShowContent4Person};}}]);return Content_DataCenter;}(_react2.default.Component);exports.default=Content_DataCenter;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 计划报告元素
var Content_plan=function(_React$Component){(0,_inherits3.default)(Content_plan,_React$Component);function Content_plan(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_plan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_plan.__proto__||(0,_getPrototypeOf2.default)(Content_plan)).call.apply(_ref,[this].concat(args))),_this),_this.state={eClassify:_this.props.eClassify,ePlanStartDate:_this.props.ePlanStartDate,ePlanEndDate:_this.props.ePlanEndDate,ePlanDays:_this.props.ePlanDays,eWeekly:_this.props.eWeekly,eMonthly:_this.props.eMonthly},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_plan,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eClassify=_state.eClassify,ePlanStartDate=_state.ePlanStartDate,ePlanEndDate=_state.ePlanEndDate,ePlanDays=_state.ePlanDays,eWeekly=_state.eWeekly,eMonthly=_state.eMonthly;var EClassify=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(455,'分类'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eClassify,onChange:function onChange(e){return _this2.setState({eClassify:e.target.checked});}}));var EPlanStartDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22168,'计划开始日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePlanStartDate,onChange:function onChange(e){return _this2.setState({ePlanStartDate:e.target.checked});}}));var EPlanEndDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22170,'计划结束日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePlanEndDate,onChange:function onChange(e){return _this2.setState({ePlanEndDate:e.target.checked});}}));var EPlanDays=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33625,'计划天数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePlanDays,onChange:function onChange(e){return _this2.setState({ePlanDays:e.target.checked});}}));var EWeekly=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20619,'周报'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eWeekly,onChange:function onChange(e){return _this2.setState({eWeekly:e.target.checked});}}));var EMonthly=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20617,'月报'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eMonthly,onChange:function onChange(e){return _this2.setState({eMonthly:e.target.checked});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EClassify,EPlanStartDate,EPlanEndDate,EPlanDays,EWeekly,EMonthly));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentClassify:this.state.eClassify,eContentPlanStartDate:this.state.ePlanStartDate,eContentPlanEndDate:this.state.ePlanEndDate,eContentPlanDays:this.state.ePlanDays,eContentWeekly:this.state.eWeekly,eContentMonthly:this.state.eMonthly};}}]);return Content_plan;}(_react2.default.Component);exports.default=Content_plan;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 多岗位办理事项
var Content_jobsinfo=function(_React$Component){(0,_inherits3.default)(Content_jobsinfo,_React$Component);function Content_jobsinfo(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_jobsinfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_jobsinfo.__proto__||(0,_getPrototypeOf2.default)(Content_jobsinfo)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowClassify:_this.props.eShowClassify.checked},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_jobsinfo,[{key:'render',value:function render(){var _this2=this;var eShowClassify=this.state.eShowClassify;var EShowClassify=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowClassify=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386590,'显示类别'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eShowClassify.options,value:eShowClassify,onChange:function onChange(checkedValue){return _this2.setState({eShowClassify:checkedValue});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EShowClassify));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowClassify:this.state.eShowClassify};}}]);return Content_jobsinfo;}(_react2.default.Component);exports.default=Content_jobsinfo;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(8);var _extends4=_interopRequireDefault(_extends3);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 集成登录
var Content_outterSys=function(_React$Component){(0,_inherits3.default)(Content_outterSys,_React$Component);function Content_outterSys(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_outterSys);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_outterSys.__proto__||(0,_getPrototypeOf2.default)(Content_outterSys)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowField:_this.props.eShowField,eShowMode:_this.props.eShowMode.selected,eShowLayout:_this.props.eShowLayout.selected,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_outterSys,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowField=_state.eShowField,eShowMode=_state.eShowMode,eShowLayout=_state.eShowLayout,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowField=_react2.default.createElement('div',null);var EShowMode=_react2.default.createElement('div',null);var EShowLayout=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){var eShowFieldList=[];var _loop=function _loop(key){if(eShowField.hasOwnProperty(key)){eShowFieldList.push(_react2.default.createElement('li',null,_react2.default.createElement(_antd.Checkbox,{checked:eShowField[key].checked,onChange:function onChange(e){_this2.setState({eShowField:(0,_extends4.default)({},eShowField,(0,_defineProperty3.default)({},key,(0,_extends4.default)({},eShowField[key],{checked:e.target.checked})))});}},eShowField[key].label)));}};for(var key in eShowField){_loop(key);}EShowField=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{style:{lineHeight:'23px'}},eShowFieldList));EShowMode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eShowMode.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eShowMode,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eShowMode:value});}}));EShowLayout=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(82134,'显示布局'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eShowLayout.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eShowLayout,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eShowLayout:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'30px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EShowMode,EShowLayout));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentShowMode:this.state.eShowMode,eContentShowLayout:this.state.eShowLayout};}}]);return Content_outterSys;}(_react2.default.Component);exports.default=Content_outterSys;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);var _EField_Contacts=__webpack_require__(309);var _EField_Contacts2=_interopRequireDefault(_EField_Contacts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
//  import EField_New from './base/EField_New';
// 通讯录
var Content_contacts=function(_React$Component){(0,_inherits3.default)(Content_contacts,_React$Component);function Content_contacts(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_contacts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_contacts.__proto__||(0,_getPrototypeOf2.default)(Content_contacts)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowSubordinates:_this.props.eShowSubordinates,eFieldNewDataSource:_this.props.eFieldNewDataSource,options:_this.props.options,optionsinfo:_this.props.optionsinfo,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_contacts,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowSubordinates=_state.eShowSubordinates,eFieldNewDataSource=_state.eFieldNewDataSource,options=_state.options,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible,optionsinfo=_state.optionsinfo;var EShowSubordinates=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSubordinates=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(83783,'显示下级下属'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eShowSubordinates,onChange:function onChange(e){return _this2.setState({eShowSubordinates:e.target.checked});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),options:_.cloneDeep(options),optionsinfo:_.cloneDeep(optionsinfo),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_Contacts2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),EFieldNew,_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),EShowSubordinates));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentShowSubordinates:this.state.eShowSubordinates,eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue}};}}]);return Content_contacts;}(_react2.default.Component);exports.default=Content_contacts;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom2=__webpack_require__(5);__webpack_require__(130);var _mobx=__webpack_require__(107);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom2.WeaLocaleProvider.getLabel;var _ecCom=ecCom,WeaTools=_ecCom.WeaTools;// 通讯录字段显示设置
var EField_Contants=function(_React$Component){(0,_inherits3.default)(EField_Contants,_React$Component);function EField_Contants(props){(0,_classCallCheck3.default)(this,EField_Contants);var _this=(0,_possibleConstructorReturn3.default)(this,(EField_Contants.__proto__||(0,_getPrototypeOf2.default)(EField_Contants)).call(this,props));_this.convertSrcDatas=function(datas){var transferDatas=[];datas.forEach(function(data){var dataIndex=data.dataIndex,title=data.title,group=data.group;transferDatas.push({id:dataIndex,name:title,group:group});});return transferDatas;};_this.convertDestdatas=function(datas){var transferKeys=[];datas.forEach(function(data){var dataIndex=data.dataIndex;transferKeys.push(dataIndex);});return transferKeys;};_this.filterLeft=function(datas){var _this$state=_this.state,value=_this$state.value,leftSearchName=_this$state.leftSearchName;var searchVal=leftSearchName.trim();//根据搜索条件过滤
var searchFilter=datas.filter(function(data){return data.name.indexOf(searchVal)>-1;});if(value==='all'){return searchFilter;}else{//下拉框选项不为【全部】时，根据下拉选项再进行一轮过滤
return searchFilter.filter(function(data){return data.group===value;});}};_this.onSelectChange=function(value){_this.setState({value:value});};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.renderItem=_this.renderItem.bind(_this);_this.state={visible:true,eFieldNewDataSource:props.eFieldNewDataSource||[],eFieldNewUsedKeys:props.eFieldNewUsedKeys||[],value:'all',options:props.options||[],optionsinfo:props.optionsinfo||[],leftSearchName:'',rightSearchName:''};return _this;}/**
     * 过滤列数据
     * @param datas
     * @returns {[]}
     */(0,_createClass3.default)(EField_Contants,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,options=_state.options,value=_state.value,searchName=_state.searchName,optionsinfo=_state.optionsinfo;var bool=options&&options.length>0?"true":"false";return _react2.default.createElement(_ecCom2.WeaDialog,{visible:visible,title:getLabel(32317,'显示字段设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom2.WeaTransfer,{className:'portal-element-showfieldnew',data:eFieldNewDataSource,renderItem:this.renderItem,selectedKeys:eFieldNewUsedKeys,onChange:function onChange(keys){return _this2.setState({eFieldNewUsedKeys:keys});},leftHeader:_react2.default.createElement('div',{className:'header',style:{paddingLeft:'24px'}},_react2.default.createElement('span',null,getLabel('385971',"待选列名")),bool==="true"?_react2.default.createElement(_ecCom2.WeaSelect,{options:optionsinfo,value:value,onChange:function onChange(val){return _this2.onSelectChange(val);},style:{width:90,marginLeft:10}}):"",_react2.default.createElement(_ecCom2.WeaInputSearch,{style:{width:'100px',float:'right',margin:'5px 10px 5px 0px'},onSearch:function onSearch(value){return _this2.setState({leftSearchName:value});}})),rightHeader:_react2.default.createElement('div',{style:{display:'inline-block',position:'relative'}},_react2.default.createElement('span',{style:{paddingLeft:'15px',position:'absolute',width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'block',top:'-25px'}},getLabel('385972',"已选列名")),_react2.default.createElement('div',{style:{position:'absolute',top:'-25px',width:'90px',left:'238px'}},_react2.default.createElement(_ecCom2.WeaInputSearch,{onSearch:function onSearch(value){return _this2.setState({rightSearchName:value});}}))),filterLeft:this.filterLeft.bind(this,eFieldNewDataSource),filterRight:this.filterRight.bind(this,eFieldNewUsedKeys)}));}/**
     * 渲染transfer
     * @param item
     * @returns {*}
     */},{key:'renderItem',value:function renderItem(item){var optionsinfo=this.state.optionsinfo;var option=optionsinfo.find(function(option){return option.key===item.group;});return _react2.default.createElement('div',{style:{padding:'10px 0 10px 24px',borderBottom:'1px solid #e2e2e2',color:'#333',position:'relative'}},_react2.default.createElement('div',null,item.name),_react2.default.createElement('div',{style:{paddingTop:'10px',color:'#333'}},option&&option.showname));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}// filterLeft(items){
//     const { leftSearchName } = this.state;
//     if (leftSearchName) {
//         items = items.filter((item)=>item.name.indexOf(leftSearchName.trim()) != -1);
//     }
//     return items;
// }
},{key:'filterRight',value:function filterRight(items){var _state2=this.state,rightSearchName=_state2.rightSearchName,eFieldNewDataSource=_state2.eFieldNewDataSource;var itemss=[];for(var i=0;i<items.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(items[i]==eFieldNewDataSource[j].id){itemss.push(eFieldNewDataSource[j]);continue;}}}if(rightSearchName){itemss=itemss.filter(function(item){return item.name.indexOf(rightSearchName.trim())!=-1;});}return itemss;}}]);return EField_Contants;}(_react2.default.Component);exports.default=EField_Contants;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 新建流程
var Content_addwf=function(_React$Component){(0,_inherits3.default)(Content_addwf,_React$Component);function Content_addwf(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_addwf);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_addwf.__proto__||(0,_getPrototypeOf2.default)(Content_addwf)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowLayout4AddWf:_this.props.eShowLayout4AddWf.selected},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_addwf,[{key:'render',value:function render(){var _this2=this;var eShowLayout4AddWf=this.state.eShowLayout4AddWf;var EShowLayout4AddWf=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowLayout4AddWf=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(82134,'显示布局'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eShowLayout4AddWf.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eShowLayout4AddWf,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eShowLayout4AddWf:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowLayout4AddWf));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eContentShowLayout:this.state.eShowLayout4AddWf};}}]);return Content_addwf;}(_react2.default.Component);exports.default=Content_addwf;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_imgSlide_detailedSetting=__webpack_require__(312);var _Content_imgSlide_detailedSetting2=_interopRequireDefault(_Content_imgSlide_detailedSetting);var _antd=__webpack_require__(7);__webpack_require__(127);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Option=_antd.Select.Option;// 多图元素
var Content_imgSlide=function(_React$Component){(0,_inherits3.default)(Content_imgSlide,_React$Component);function Content_imgSlide(props){(0,_classCallCheck3.default)(this,Content_imgSlide);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_imgSlide.__proto__||(0,_getPrototypeOf2.default)(Content_imgSlide)).call(this,props));_this.state={eAutoSwitchTime:_this.props.autoSwitchTime||4000,datas:_this.props.datas,showTitle:_this.props.showTitle,fontSize:_this.props.fontSize||'16',eDetailedSettingible:false,fillStyle:_this.props.fillStyle||'fill'};return _this;}(0,_createClass3.default)(Content_imgSlide,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eAutoSwitchTime=_state.eAutoSwitchTime,eDetailedSettingible=_state.eDetailedSettingible,datas=_state.datas,showTitle=_state.showTitle,fontSize=_state.fontSize,fillStyle=_state.fillStyle;var eDSProps={};var ImgSlideDetailedSetting=_react2.default.createElement('div',null);if(eDetailedSettingible){eDSProps={datas:datas,showTitle:showTitle,fontSize:fontSize,onOk:function onOk(datas,showTitle,fontSize){_this2.setState({datas:datas,showTitle:showTitle,fontSize:fontSize,eDetailedSettingible:false});},onCancel:function onCancel(){_this2.setState({eDetailedSettingible:false});}};ImgSlideDetailedSetting=_react2.default.createElement(_Content_imgSlide_detailedSetting2.default,eDSProps);}var EAutoSwitchTime=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386581,'自动切换时间'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:eAutoSwitchTime,onChange:function onChange(value){return _this2.setState({eAutoSwitchTime:value});},style:{width:'40%',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'12px'}},_react2.default.createElement('span',null,getLabel(26287,'毫秒')))));var EFillStyle=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{className:'portal-imgSlide-images_select',label:getLabel(386582,'填充方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Select,{ref:'fillStyleSelect',size:'large',onChange:function onChange(value){return _this2.setState({fillStyle:value});},style:{width:'216px',height:'46px'},value:fillStyle||'stretch'},_react2.default.createElement(Option,{value:'fill'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/fill.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(128030,'填充')))),_react2.default.createElement(Option,{value:'adapt'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/adapt.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(386583,'适应')))),_react2.default.createElement(Option,{value:'stretch'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/stretch.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(386584,'拉伸')))),_react2.default.createElement(Option,{value:'tile'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/tile.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(19852,'平铺')))),_react2.default.createElement(Option,{value:'center'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/center.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(16203,'居中'))))));var EDetailedSetting=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386585,'图片详细设置'),labelCol:{span:6},wrapperCol:{span:16}},ImgSlideDetailedSetting,_react2.default.createElement('div',{style:{marginTop:7},onClick:function onClick(){return _this2.setState({eDetailedSettingible:true});}},_react2.default.createElement('a',{href:'javascript:void(0);'},getLabel(19342,'详细设置'))));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EAutoSwitchTime,EFillStyle,EDetailedSetting));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentDatas:this.state.datas,eContentShowTitle:this.state.showTitle,eContentFontSize:this.state.fontSize,eContentFillStyle:this.state.fillStyle,eContentAutoSwitchTime:this.state.eAutoSwitchTime};}}]);return Content_imgSlide;}(_react2.default.Component);exports.default=Content_imgSlide;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(106);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(47);var _Content_imgSlide_img=__webpack_require__(133);var _Content_imgSlide_img2=_interopRequireDefault(_Content_imgSlide_img);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 多图元素详细设置
var Content_imgSlide_detailedSetting=function(_React$Component){(0,_inherits3.default)(Content_imgSlide_detailedSetting,_React$Component);function Content_imgSlide_detailedSetting(props){(0,_classCallCheck3.default)(this,Content_imgSlide_detailedSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_imgSlide_detailedSetting.__proto__||(0,_getPrototypeOf2.default)(Content_imgSlide_detailedSetting)).call(this,props));_this.state={visible:true,showTitle:props.showTitle,fontSize:props.fontSize,titles:getLabel(507,'图片上传'),datas:props.datas,selectedDatas:{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.getUuid=_this.getUuid.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeBgImage=_this.onChangeBgImage.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.getItems=_this.getItems.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.deleteTabs=_this.deleteTabs.bind(_this);return _this;}(0,_createClass3.default)(Content_imgSlide_detailedSetting,[{key:'onRowSelect',value:function onRowSelect(sRowKeys,rows,dataIndex,selectedDatas){var newState={};newState.selectedRowKeys=sRowKeys;if(selectedDatas){newState.selectedDatas=selectedDatas;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:'getUuid',value:function getUuid(){var s=[];var hexDigits="0123456789abcdef";for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]="4";// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]=s[13]=s[18]=s[23]="-";var uuid=s.join("");return uuid;}},{key:'onChangeBgImage',value:function onChangeBgImage(index,value){if(value){var datas=this.state.datas;var length=datas.length;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var _value=value.split(",");if("multiCheck"==index){for(var i=0;i<_value.length;i++){_datas.push({key:length+i,imgsrc:_value[i],title:'',imgaddress:''});}}else{_datas[index].imgsrc=value;}this.setState({datas:_datas});}}},{key:'getColumns',value:function getColumns(){var _this2=this;var _state=this.state,datas=_state.datas,fontSize=_state.fontSize,showTitle=_state.showTitle;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var columns=[{title:getLabel(126949,'图片预览'),display:'true',key:'img',width:'30%',className:'wea-table-edit-prew',render:function render(text,record,index){return _react2.default.createElement(_Content_imgSlide_img2.default,{title:record.title,imgSrc:record.imgsrc,fontSize:fontSize,showTitle:showTitle});}},{title:getLabel(386586,'图片标题'),display:'true',width:'25%',key:'title',className:'wea-table-edit-title',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this2['weaError_'+record.key]=el;},error:'\u6570\u636E\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title,viewAttr:showTitle=='1'?3:2,onChange:function onChange(value){_datas[record.key].title=value;_this2.setState({datas:_datas});}}));}},{title:getLabel(22932,'图片链接'),display:'true',width:'25%',key:'imgAddress',className:'wea-table-edit-imgAddress',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaInput,{value:record.imgAddress,onChange:function onChange(value){_datas[record.key].imgAddress=value;_this2.setState({datas:_datas});}});}},{title:getLabel(20001,'上传图片'),display:'true',width:'15%',className:'wea-table-edit-upload',render:function render(text,record,index){return _react2.default.createElement('div',{className:'e9login-bg-images-btns-materiallib'},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:false,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary'},getLabel(127538,'更改图片'))));}}];return columns;}},{key:'getItems',value:function getItems(){var _this3=this;var _state2=this.state,showTitle=_state2.showTitle,fontSize=_state2.fontSize;var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this3.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:fontSize,onChange:function onChange(value){return _this3.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))}];return items;}},{key:'onDeleteTabs',value:function onDeleteTabs(){var _state3=this.state,selectedRowKeys=_state3.selectedRowKeys,datas=_state3.datas;for(var i=0;i<selectedRowKeys.length;i++){this.deleteTabs(selectedRowKeys[i]);}this.setState({selectedRowKeys:[]});}},{key:'deleteTabs',value:function deleteTabs(dataId){var _state4=this.state,datas=_state4.datas,selectedRowKeys=_state4.selectedRowKeys;for(var i=0;i<datas.length;i++){if(datas[i].key==dataId){datas.splice(i,1);break;}}var datasNew=datas.map(function(item,idnex){return(0,_extends3.default)({},item,{key:idnex});});this.setState({datas:datasNew,selectedRowKeys:[]});}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _state5=this.state,visible=_state5.visible,eFieldNewDataSource=_state5.eFieldNewDataSource,eFieldNewUsedKeys=_state5.eFieldNewUsedKeys,searchName=_state5.searchName,title=_state5.title,items=_state5.items,isModalEdit=_state5.isModalEdit,datas=_state5.datas,titles=_state5.titles,selectedDatas=_state5.selectedDatas,selectedRowKeys=_state5.selectedRowKeys;// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel,hasScroll:true},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:titles,needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:true,onChange:function onChange(value){return _this4.onChangeBgImage("multiCheck",value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'}},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})))),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),style:{borderRadius:0,margin:'0 10px',padding:'0 4px'},onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,(_React$createElement={ref:'tableEdit',draggable:true,isModalEdit:isModalEdit,dataSource:datas//title={titles}
},(0,_defineProperty3.default)(_React$createElement,'ref',function ref(el){_this4.table=el;}),(0,_defineProperty3.default)(_React$createElement,'rowSelection',rowSelection),(0,_defineProperty3.default)(_React$createElement,'selectedData',selectedDatas),(0,_defineProperty3.default)(_React$createElement,'selectedRowKeys',selectedRowKeys),(0,_defineProperty3.default)(_React$createElement,'columns',this.getColumns()),_React$createElement))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this5=this;var _state6=this.state,datas=_state6.datas,showTitle=_state6.showTitle,fontSize=_state6.fontSize;var isPass=true;if(showTitle=='1'){datas.map(function(item,index){if(item.title==''){_this5['weaError_'+index].showError();isPass=false;return;}});}isPass&&this.props.onOk(datas,showTitle,fontSize);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_imgSlide_detailedSetting;}(_react2.default.Component);exports.default=Content_imgSlide_detailedSetting;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);var _EScrollDirection=__webpack_require__(104);var _EScrollDirection2=_interopRequireDefault(_EScrollDirection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 公告元素
var Content_newNotice=function(_React$Component){(0,_inherits3.default)(Content_newNotice,_React$Component);function Content_newNotice(props){(0,_classCallCheck3.default)(this,Content_newNotice);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_newNotice.__proto__||(0,_getPrototypeOf2.default)(Content_newNotice)).call(this,props));_this.state={eNewNoticeFrom:_this.props.eNewNoticeFrom.selected,eNewNoticePublisher:_this.props.eNewNoticePublisher,eNewNoticePublisherNames:_this.props.eNewNoticePublisherNames,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false,eNoticeIsText:_this.props.eNewNoticeIsText,eMultiPage:_this.props.eNewNoticeMultiPage,eNoticeScrollSpeed:_this.props.eNewScrollSpeed||'3',eNoticeNew:_this.props.eNewNoticeNew||'0',ePageSize:_this.props.eNewNoticePageSize||'3',status:_this.props.eScrollDirection.selected||'0'};_this.onChangeStatus=_this.onChangeStatus.bind(_this);return _this;}(0,_createClass3.default)(Content_newNotice,[{key:'onChangeStatus',value:function onChangeStatus(v){this.setState({status:v});if(v!='0')this.setState({eMultiPage:'0'});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,eNewNoticeFrom=_state.eNewNoticeFrom,eNewNoticePublisherNames=_state.eNewNoticePublisherNames,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible,eNoticeIsText=_state.eNoticeIsText,eMultiPage=_state.eMultiPage,eNoticeScrollSpeed=_state.eNoticeScrollSpeed,eNoticeNew=_state.eNoticeNew,ePageSize=_state.ePageSize,status=_state.status;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';var ENewNoticeFrom=_react2.default.createElement('div',null);var ENewNoticePublisher=_react2.default.createElement('div',null);var ENoticeIsText=_react2.default.createElement('div',null);var EMultiPage=_react2.default.createElement('div',null);var ENoticeScrollSpeed=_react2.default.createElement('div',null);var ENoticeNew=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENewNoticeFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20885,'内容来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eNewNoticeFrom.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eNewNoticeFrom,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eNewNoticeFrom:value});}}));ENewNoticePublisher=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(1861,'发布人'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:17,isSingle:false,replaceDatas:eNewNoticePublisherNames||[],onChange:function onChange(ids,names,datas){return _this2.setState({eNewNoticePublisher:ids,eNewNoticePublisherNames:datas});},layout:document.body}));EMultiPage=_react2.default.createElement(_ecCom.WeaFormItem,{label:'多页显示',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'60px',position:'relative'}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eMultiPage,display:'switch',style:{display:'inline'},onChange:function onChange(v){var value=v;if(v=='1')value=0;_this2.setState({eMultiPage:v,eNoticeIsText:value});}})),eMultiPage=='1'&&_react2.default.createElement('div',{style:{display:'inline-block',position:'absolute',left:'42px',bottom:'7px'}},_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'15px'}},'\u6BCF\u9875\u6761\u6570'),_react2.default.createElement('div',{style:{display:'inline-flex',width:'60px',marginLeft:'20px'}},_react2.default.createElement(_ecCom.WeaInput,{value:ePageSize,onChange:function onChange(v){_this2.setState({ePageSize:v});}}))));ENoticeScrollSpeed=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNoticeScrollSpeed,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eNoticeScrollSpeed:value});}}),_react2.default.createElement('div',{style:{display:'inline-block',margin:'8px 15px'}},'ms'));ENoticeNew=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(-81503,'显示新建按钮'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eNoticeNew,display:'switch',style:{display:'inline'},onChange:function onChange(v){_this2.setState({eNoticeNew:v});}}));ENoticeIsText=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19111,'纯文本格式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eNoticeIsText,display:'switch',style:{display:'inline'},onChange:function onChange(v){var value=v;if(v=='1')value=0;_this2.setState({eNoticeIsText:v,eMultiPage:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),eNewNoticeFrom=='2'&&_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,ENewNoticeFrom,ENewNoticePublisher,this.props.eShareLevel=='2'?_react2.default.createElement(_EScrollDirection2.default,{ref:'eScrollDirection',options:this.props.eScrollDirection.options,value:this.props.eScrollDirection.selected,onChange:this.onChangeStatus}):'',status=='0'?EMultiPage:ENoticeScrollSpeed,eNewNoticeFrom=='2'&&(status=='2'||status=='4')?ENoticeIsText:null,eNewNoticeFrom=='2'?ENoticeNew:null));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode']&&this.refs['eLinkMode'].getSaveValues()||'1',eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentNewNoticeFrom:this.state.eNewNoticeFrom,eContentNewNoticePublisher:this.state.eNewNoticePublisher,eContentScrollDirection:this.refs['eScrollDirection']?this.refs['eScrollDirection'].getSaveValues():this.props.eScrollDirection.selected,eContentNoticeIsText:this.state.eNoticeIsText,eContentNoticeNew:this.state.eNoticeNew,eContentMultiPage:this.state.eMultiPage,eContentNoticeScrollSpeed:this.state.eNoticeScrollSpeed,eContentPageSize:this.state.ePageSize};}}]);return Content_newNotice;}(_react2.default.Component);exports.default=Content_newNotice;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 外部数据元素
var Content_OutData=function(_React$Component){(0,_inherits3.default)(Content_OutData,_React$Component);function Content_OutData(){(0,_classCallCheck3.default)(this,Content_OutData);return(0,_possibleConstructorReturn3.default)(this,(Content_OutData.__proto__||(0,_getPrototypeOf2.default)(Content_OutData)).apply(this,arguments));}(0,_createClass3.default)(Content_OutData,[{key:'render',value:function render(){var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'OutData'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_OutData;}(_react2.default.Component);exports.default=Content_OutData;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EScrollDirection=__webpack_require__(104);var _EScrollDirection2=_interopRequireDefault(_EScrollDirection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 建模查询中心
var Content_FormModeCustomSearch=function(_React$Component){(0,_inherits3.default)(Content_FormModeCustomSearch,_React$Component);function Content_FormModeCustomSearch(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_FormModeCustomSearch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_FormModeCustomSearch.__proto__||(0,_getPrototypeOf2.default)(Content_FormModeCustomSearch)).call.apply(_ref,[this].concat(args))),_this),_this.state={eIsShowTitle:_this.props.eIsShowTitle,weaCubeLoaded:false,cubeQueryCenterStore:undefined},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_FormModeCustomSearch,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载表单建模模块静态资源
eventRegister.loadModule('b_cube',function(){setTimeout(function(){var cubeQueryCenterStore=new window.weaCubeEngine.com.CubeQueryCenterStore();_this2.setState({weaCubeLoaded:true,cubeQueryCenterStore:cubeQueryCenterStore});},100);},function(){});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,eIsShowTitle=_state.eIsShowTitle,weaCubeLoaded=_state.weaCubeLoaded,cubeQueryCenterStore=_state.cubeQueryCenterStore;return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:(this.props.eLinkMode.selected=='-1'?'2':this.props.eLinkMode.selected)||'2'}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(127782,'是否显示标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-FormModeCustomSearch-perpage'},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eIsShowTitle,onChange:function onChange(value){return _this3.setState({eIsShowTitle:value=='1'});}}))):'',this.props.eShareLevel=='2'?_react2.default.createElement(_EScrollDirection2.default,{ref:'eScrollDirection',options:this.props.eScrollDirection.options,value:this.props.eScrollDirection.selected}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{wrapperCol:{span:22}},weaCubeLoaded&&window.weaCubeEngine&&window.weaCubeEngine.com?_react2.default.createElement(window.weaCubeEngine.com.CubeQueryCenterSet,{CubeQueryCenterStore:cubeQueryCenterStore,isCustom:true,eid:this.props.eid,hpid:this.props.hpid}):_react2.default.createElement('div',null)):''));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentIsShowTitle:this.state.eIsShowTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eContentScrollDirection:this.refs['eScrollDirection']?this.refs['eScrollDirection'].getSaveValues():this.props.eScrollDirection.selected};}}]);return Content_FormModeCustomSearch;}(_react2.default.Component);exports.default=Content_FormModeCustomSearch;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 日历日程
var Content_MeetingCalendar=function(_React$Component){(0,_inherits3.default)(Content_MeetingCalendar,_React$Component);function Content_MeetingCalendar(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_MeetingCalendar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_MeetingCalendar.__proto__||(0,_getPrototypeOf2.default)(Content_MeetingCalendar)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:_this.props.meetingType.selected},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_MeetingCalendar,[{key:'render',value:function render(){var _this2=this;var meetingType=this.props.meetingType;var ShowContents=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:meetingType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.selected,onChange:function onChange(value){_this2.setState({selected:value});}})));var ShowContents1=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px',textAlign:'center',lineHeight:'2.3'}},_react2.default.createElement(_ecCom.WeaSelect,{options:meetingType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),viewAttr:1,value:this.state.selected,onChange:function onChange(value){_this2.setState({selected:value});}})));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',this.props.eShareLevel=='2'?ShowContents:ShowContents1));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentMeetingType:this.state.selected};}}]);return Content_MeetingCalendar;}(_react2.default.Component);exports.default=Content_MeetingCalendar;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField=__webpack_require__(108);var _EField2=_interopRequireDefault(_EField);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器
var Content_CalendarEle=function(_React$Component){(0,_inherits3.default)(Content_CalendarEle,_React$Component);function Content_CalendarEle(){(0,_classCallCheck3.default)(this,Content_CalendarEle);return(0,_possibleConstructorReturn3.default)(this,(Content_CalendarEle.__proto__||(0,_getPrototypeOf2.default)(Content_CalendarEle)).apply(this,arguments));}(0,_createClass3.default)(Content_CalendarEle,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues()};}}]);return Content_CalendarEle;}(_react2.default.Component);exports.default=Content_CalendarEle;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField=__webpack_require__(108);var _EField2=_interopRequireDefault(_EField);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器
var Content_bookshelf=function(_React$Component){(0,_inherits3.default)(Content_bookshelf,_React$Component);function Content_bookshelf(){(0,_classCallCheck3.default)(this,Content_bookshelf);return(0,_possibleConstructorReturn3.default)(this,(Content_bookshelf.__proto__||(0,_getPrototypeOf2.default)(Content_bookshelf)).apply(this,arguments));}(0,_createClass3.default)(Content_bookshelf,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues()};}}]);return Content_bookshelf;}(_react2.default.Component);exports.default=Content_bookshelf;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField=__webpack_require__(108);var _EField2=_interopRequireDefault(_EField);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器
var Content_newMobilePicture=function(_React$Component){(0,_inherits3.default)(Content_newMobilePicture,_React$Component);function Content_newMobilePicture(){(0,_classCallCheck3.default)(this,Content_newMobilePicture);return(0,_possibleConstructorReturn3.default)(this,(Content_newMobilePicture.__proto__||(0,_getPrototypeOf2.default)(Content_newMobilePicture)).apply(this,arguments));}(0,_createClass3.default)(Content_newMobilePicture,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues()};}}]);return Content_newMobilePicture;}(_react2.default.Component);exports.default=Content_newMobilePicture;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 费用报销智能助手
var Content_fnaBudgetAssistant=function(_React$Component){(0,_inherits3.default)(Content_fnaBudgetAssistant,_React$Component);function Content_fnaBudgetAssistant(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_fnaBudgetAssistant);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_fnaBudgetAssistant.__proto__||(0,_getPrototypeOf2.default)(Content_fnaBudgetAssistant)).call.apply(_ref,[this].concat(args))),_this),_this.state={ePersonalBorrowinInformation:_this.props.ePersonalBorrowinInformation,eReimbursementInformation:_this.props.eReimbursementInformation,eReimbursementChart:_this.props.eReimbursementChart},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_fnaBudgetAssistant,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eReimbursementInformation=_state.eReimbursementInformation,ePersonalBorrowinInformation=_state.ePersonalBorrowinInformation,eReimbursementChart=_state.eReimbursementChart;var EPersonalBorrowinInformation=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126747,'个人借款信息'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:ePersonalBorrowinInformation,onChange:function onChange(value){return _this2.setState({ePersonalBorrowinInformation:value});}}));var EReimbursementInformation=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126748,'报销信息'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eReimbursementInformation,onChange:function onChange(value){return _this2.setState({eReimbursementInformation:value});}}));var EReimbursementChart=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126750,'报销图表'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eReimbursementChart,onChange:function onChange(value){return _this2.setState({eReimbursementChart:value});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EPersonalBorrowinInformation,EReimbursementInformation,EReimbursementChart));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentPersonalBorrowinInformation:this.state.ePersonalBorrowinInformation,eContentReimbursementInformation:this.state.eReimbursementInformation,eContentReimbursementChart:this.state.eReimbursementChart};}}]);return Content_fnaBudgetAssistant;}(_react2.default.Component);exports.default=Content_fnaBudgetAssistant;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 审批助手元素
var Content_fnaBudgetAssistant1=function(_React$Component){(0,_inherits3.default)(Content_fnaBudgetAssistant1,_React$Component);function Content_fnaBudgetAssistant1(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_fnaBudgetAssistant1);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_fnaBudgetAssistant1.__proto__||(0,_getPrototypeOf2.default)(Content_fnaBudgetAssistant1)).call.apply(_ref,[this].concat(args))),_this),_this.state={eDepartment:_this.props.eDepartment||0,eBranch:_this.props.eBranch||0,ePersonal:_this.props.ePersonal||0,eCostCenter:_this.props.eCostCenter||0},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_fnaBudgetAssistant1,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eDepartment=_state.eDepartment,eBranch=_state.eBranch,ePersonal=_state.ePersonal,eCostCenter=_state.eCostCenter;var EDepartment=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(6087,'个人'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eDepartment,onChange:function onChange(value){return _this2.setState({eDepartment:value});}}));var EBranch=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(27511,'部门'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eBranch,onChange:function onChange(value){return _this2.setState({eBranch:value});}}));var EPersonal=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33553,'分部'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:ePersonal,onChange:function onChange(value){return _this2.setState({ePersonal:value});}}));var ECostCenter=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(515,'成本中心'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eCostCenter,onChange:function onChange(value){return _this2.setState({eCostCenter:value});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EDepartment,EBranch,EPersonal,ECostCenter));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentDepartment:this.state.eDepartment,eContentBranch:this.state.eBranch,ContentPersonal:this.state.ePersonal,ContentCostCenter:this.state.eCostCenter};}}]);return Content_fnaBudgetAssistant1;}(_react2.default.Component);exports.default=Content_fnaBudgetAssistant1;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaColorInput=__webpack_require__(323);var _weaColorInput2=_interopRequireDefault(_weaColorInput);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// CoreMail邮件
var Content_CoreMail=function(_React$Component){(0,_inherits3.default)(Content_CoreMail,_React$Component);function Content_CoreMail(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_CoreMail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_CoreMail.__proto__||(0,_getPrototypeOf2.default)(Content_CoreMail)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowUnreadList:_this.props.eShowUnreadList,eCoreMailPerpage:_this.props.eCoreMailPerpage,eShowPromptInformation:_this.props.eShowPromptInformation,eSingleSignOn:_this.props.eSingleSignOn||'',eHintText:_this.props.eHintText,eUnreadMailQuantityColor:_this.props.eUnreadMailQuantityColor,eSingleSignOnLinkColor:_this.props.eSingleSignOnLinkColor,eExplain:_this.props.eExplain,eCoreMailLinkMode:_this.props.eCoreMailLinkMode,// 链接方式
eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_CoreMail,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowUnreadList=_state.eShowUnreadList,eCoreMailPerpage=_state.eCoreMailPerpage,eShowPromptInformation=_state.eShowPromptInformation,eSingleSignOn=_state.eSingleSignOn,eHintText=_state.eHintText,eUnreadMailQuantityColor=_state.eUnreadMailQuantityColor,eSingleSignOnLinkColor=_state.eSingleSignOnLinkColor,eCoreMailTitle=_state.eCoreMailTitle,eCoreMailUser=_state.eCoreMailUser,eCoreMailTime=_state.eCoreMailTime,eCoreMailLinkMode=_state.eCoreMailLinkMode,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowUnreadList=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386576,'显示未读列表'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eShowUnreadList,onChange:function onChange(value){return _this2.setState({eShowUnreadList:value});}}));var ECoreMailPerpage=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19493,'显示条数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eCoreMailPerpage,onChange:function onChange(value){return _this2.setState({eCoreMailPerpage:value});},style:{width:'22%'}}));var EShowPromptInformation=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386577,'显示提示信息'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eShowPromptInformation,onChange:function onChange(value){return _this2.setState({eShowPromptInformation:value});}}));var ESingleSignOn=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126789,'单点登录'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.weaError=el;},error:getLabel(129952,'请选择或新建CoreMail集成登录设置！'),style:{width:'22%'}},_react2.default.createElement(_ecCom.WeaSelect,{value:eSingleSignOn,viewAttr:'3',options:this.props.coreMailSysids.options,onChange:function onChange(value){return _this2.setState({eSingleSignOn:value});},style:{width:'100%'}})));var EHintText=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(129937,'提示文字'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaTextarea,{value:eHintText,onChange:function onChange(value){return _this2.setState({eHintText:value});},style:{width:'300px'}}));var EUnreadMailQuantityColor=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(129938,'未读邮件数量颜色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_weaColorInput2.default,{color:eUnreadMailQuantityColor,onChange:function onChange(value){return _this2.setState({eUnreadMailQuantityColor:value});}}));var ESingleSignOnLinkColor=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(129939,'单点登录链接颜色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_weaColorInput2.default,{color:eSingleSignOnLinkColor,onChange:function onChange(value){return _this2.setState({eSingleSignOnLinkColor:value});}}));var EExplain=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(25734,'说明'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaTextarea,{value:"&nbsp;$NoReadCnt$ : "+getLabel(129940,'未读邮件数量')+"\n $LoginLinkStart$ : "+getLabel(129941,'单点登录链接开始')+"\n $LoginLinkEnd$ : "+getLabel(129942,'单点登录链接结束'),viewAttr:1}));var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(386578,'未读列表'),needTigger:true,showGroup:true},EShowUnreadList,ECoreMailPerpage,_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),ESingleSignOn,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，'))))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(24960,'提示信息'),needTigger:true,showGroup:true},EShowPromptInformation,EHintText,EUnreadMailQuantityColor,ESingleSignOnLinkColor,EExplain));}},{key:'getSaveValues',value:function getSaveValues(){if(this.state.eSingleSignOn==''){this.weaError.showError();return false;}return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,//eContentShowNum: this.refs['eShowNum'].getSaveValues(),
eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentShowUnreadList:this.state.eShowUnreadList,eContentCoreMailPerpage:this.state.eCoreMailPerpage,eContentSingleSignOn:this.state.eSingleSignOn,eContentShowPromptInformation:this.state.eShowPromptInformation,eContentHintText:this.state.eHintText,eContentUnreadMailQuantityColor:this.state.eUnreadMailQuantityColor,eContentSingleSignOnLinkColor:this.state.eSingleSignOnLinkColor,eContentCoreMailLinkMode:this.state.eCoreMailLinkMode,eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_CoreMail;}(_react2.default.Component);exports.default=Content_CoreMail;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);__webpack_require__(324);var _rcColorPicker=__webpack_require__(325);var _ecCom=__webpack_require__(5);__webpack_require__(358);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaColorInput=function(_React$Component){(0,_inherits3.default)(WeaColorInput,_React$Component);function WeaColorInput(props){(0,_classCallCheck3.default)(this,WeaColorInput);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaColorInput.__proto__||(0,_getPrototypeOf2.default)(WeaColorInput)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}(0,_createClass3.default)(WeaColorInput,[{key:'onChange',value:function onChange(value){this.props.onChange(value);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$color=_props.color,color=_props$color===undefined?'#000':_props$color,layout=_props.layout;return _react2.default.createElement('div',{className:'portal-wea-ci'},_react2.default.createElement(_antd.Popover,{content:_react2.default.createElement(_rcColorPicker.Panel,{enableAlpha:false,color:color,onChange:function onChange(obj){return _this2.onChange(obj.color);},mode:'RGB'}),trigger:'click',getTooltipContainer:function getTooltipContainer(){return layout||document.body;},overlayClassName:'portal-wea-ci-popover'},_react2.default.createElement('div',{className:'portal-wea-ci-btn',style:{backgroundColor:color}})),_react2.default.createElement(_ecCom.WeaInput,{value:color,onChange:this.onChange}));}}]);return WeaColorInput;}(_react2.default.Component);exports.default=WeaColorInput;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(326);
module.exports.Panel = __webpack_require__(140);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTrigger = __webpack_require__(329);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

var _Panel = __webpack_require__(140);

var _Panel2 = _interopRequireDefault(_Panel);

var _placements = __webpack_require__(357);

var _placements2 = _interopRequireDefault(_placements);

var _color = __webpack_require__(66);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function refFn(field, component) {
  this[field] = component;
}

function prevent(e) {
  e.preventDefault();
}

var ColorPicker = function (_React$Component) {
  _inherits(ColorPicker, _React$Component);

  function ColorPicker(props) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var alpha = typeof props.alpha === 'undefined' ? props.defaultAlpha : Math.min(props.alpha, props.defaultAlpha);

    _this.state = {
      color: props.color || props.defaultColor,
      alpha: alpha,
      open: false
    };

    var events = ['onTriggerClick', 'onChange', 'onBlur', 'getPickerElement', 'getRootDOMNode', 'getTriggerDOMNode', 'onVisibleChange', 'onPanelMount', 'setOpen', 'open', 'close', 'focus'];

    events.forEach(function (e) {
      _this[e] = _this[e].bind(_this);
    });

    _this.saveTriggerRef = refFn.bind(_this, 'triggerInstance');
    return _this;
  }

  ColorPicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.color) {
      this.setState({
        color: nextProps.color
      });
    }
    if (nextProps.alpha !== null && nextProps.alpha !== undefined) {
      this.setState({
        alpha: nextProps.alpha
      });
    }
  };

  ColorPicker.prototype.onTriggerClick = function onTriggerClick() {
    this.setState({
      open: !this.state.open
    });
  };

  ColorPicker.prototype.onChange = function onChange(colors) {
    var _this2 = this;

    this.setState(_extends({}, colors), function () {
      _this2.props.onChange(_this2.state);
    });
  };

  ColorPicker.prototype.onBlur = function onBlur() {
    this.setOpen(false);
  };

  ColorPicker.prototype.onVisibleChange = function onVisibleChange(open) {
    this.setOpen(open);
  };

  ColorPicker.prototype.onPanelMount = function onPanelMount(panelDOMRef) {
    if (this.state.open) {
      setTimeout(function () {
        panelDOMRef.focus();
      }, 1);
    }
  };

  ColorPicker.prototype.setOpen = function setOpen(open, callback) {
    var _this3 = this;

    if (this.state.open !== open) {
      this.setState({
        open: open
      }, function () {
        if (typeof callback === 'function') callback();
        var _props = _this3.props,
            onOpen = _props.onOpen,
            onClose = _props.onClose;

        if (_this3.state.open) {
          onOpen(_this3.state);
        } else {
          onClose(_this3.state);
        }
      });
    }
  };

  ColorPicker.prototype.getRootDOMNode = function getRootDOMNode() {
    return (0, _reactDom.findDOMNode)(this);
  };

  ColorPicker.prototype.getTriggerDOMNode = function getTriggerDOMNode() {
    return (0, _reactDom.findDOMNode)(this.triggerInstance);
  };

  ColorPicker.prototype.getPickerElement = function getPickerElement() {
    // const state = this.state;
    return _react2["default"].createElement(_Panel2["default"], {
      onMount: this.onPanelMount,
      defaultColor: this.state.color,
      alpha: this.state.alpha,
      enableAlpha: this.props.enableAlpha,
      prefixCls: this.props.prefixCls + '-panel',
      onChange: this.onChange,
      onBlur: this.onBlur,
      mode: this.props.mode,
      className: this.props.className
    });
  };

  ColorPicker.prototype.open = function open(callback) {
    this.setOpen(true, callback);
  };

  ColorPicker.prototype.close = function close(callback) {
    this.setOpen(false, callback);
  };

  ColorPicker.prototype.focus = function focus() {
    if (!this.state.open) {
      (0, _reactDom.findDOMNode)(this).focus();
    }
  };

  ColorPicker.prototype.render = function render() {
    var props = this.props;
    var state = this.state;
    var classes = [props.prefixCls + '-wrap', props.className];
    if (state.open) {
      classes.push(props.prefixCls + '-open');
    }

    var children = props.children;

    var _RGB = _slicedToArray(new _color2["default"](this.state.color).RGB, 3),
        r = _RGB[0],
        g = _RGB[1],
        b = _RGB[2];

    var RGBA = [r, g, b];

    RGBA.push(this.state.alpha / 100);

    if (children) {
      children = _react2["default"].cloneElement(children, {
        ref: this.saveTriggerRef,
        unselectable: 'unselectable',
        style: {
          backgroundColor: 'rgba(' + RGBA.join(',') + ')'
        },
        onClick: this.onTriggerClick,
        onMouseDown: prevent
      });
    }

    var prefixCls = props.prefixCls,
        placement = props.placement,
        style = props.style,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        transitionName = props.transitionName;


    return _react2["default"].createElement(
      'div',
      { className: classes.join(' ') },
      _react2["default"].createElement(
        _rcTrigger2["default"],
        {
          popup: this.getPickerElement(),
          popupAlign: align,
          builtinPlacements: _placements2["default"],
          popupPlacement: placement,
          action: disabled ? [] : ['click'],
          destroyPopupOnHide: true,
          getPopupContainer: getCalendarContainer,
          popupStyle: style,
          popupAnimation: animation,
          popupTransitionName: transitionName,
          popupVisible: state.open,
          onPopupVisibleChange: this.onVisibleChange,
          prefixCls: prefixCls
        },
        children
      )
    );
  };

  return ColorPicker;
}(_react2["default"].Component);

exports["default"] = ColorPicker;


ColorPicker.propTypes = {
  defaultColor: _propTypes2["default"].string,
  defaultAlpha: _propTypes2["default"].number,
  // can custom
  alpha: _propTypes2["default"].number,
  children: _propTypes2["default"].node.isRequired,
  className: _propTypes2["default"].string,
  color: _propTypes2["default"].string,
  enableAlpha: _propTypes2["default"].bool,
  mode: _propTypes2["default"].oneOf(['RGB', 'HSL', 'HSB']),
  onChange: _propTypes2["default"].func,
  onClose: _propTypes2["default"].func,
  onOpen: _propTypes2["default"].func,
  placement: _propTypes2["default"].oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  prefixCls: _propTypes2["default"].string.isRequired,
  style: _propTypes2["default"].object
};

ColorPicker.defaultProps = {
  defaultColor: '#F00',
  defaultAlpha: 100,
  onChange: function onChange() {},
  onOpen: function onOpen() {},
  onClose: function onClose() {},

  children: _react2["default"].createElement('span', { className: 'rc-color-picker-trigger' }),
  className: '',
  enableAlpha: true,
  placement: 'topLeft',
  prefixCls: 'rc-color-picker',
  style: {}
};
module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(328);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin__);











function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var isMobile = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i);

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];

var Trigger = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'Trigger',
  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    action: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)]),
    showAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    hideAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    popup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired,
    popupStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    popupClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    popupPlacement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    popupTransitionName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
    popupAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    zIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    focusDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    blurDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    getPopupContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    getDocument: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    mask: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    maskClosable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    onPopupAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    popupAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    popupVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    maskTransitionName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
    maskAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin___default()({
    autoMount: false,

    isVisible: function isVisible(instance) {
      return instance.state.popupVisible;
    },
    getContainer: function getContainer(instance) {
      var props = instance.props;

      var popupContainer = document.createElement('div');
                  popupContainer.style.position = 'absolute';
      popupContainer.style.top = '0';
      popupContainer.style.left = '0';
      popupContainer.style.width = '100%';
      var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(instance)) : props.getDocument().body;
      mountNode.appendChild(popupContainer);
      return popupContainer;
    }
  })],

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-trigger-popup',
      getPopupClassNameFromAlign: returnEmptyString,
      getDocument: returnDocument,
      onPopupVisibleChange: noop,
      afterPopupVisibleChange: noop,
      onPopupAlign: noop,
      popupClassName: '',
      mouseEnterDelay: 0,
      mouseLeaveDelay: 0.1,
      focusDelay: 0,
      blurDelay: 0.15,
      popupStyle: {},
      destroyPopupOnHide: false,
      popupAlign: {},
      defaultPopupVisible: false,
      mask: false,
      maskClosable: true,
      action: [],
      showAction: [],
      hideAction: []
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }
    return {
      popupVisible: popupVisible
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
  },
  componentDidMount: function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    this.renderComponent(null, function () {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    });

                    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && this.isClickToHide()) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default()(currentDocument, 'mousedown', this.onDocumentClick);
      }
                              if (!this.touchOutsideHandler && isMobile) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default()(currentDocument, 'click', this.onDocumentClick);
      }
      return;
    }

    this.clearOutsideHandler();
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
  },
  onMouseEnter: function onMouseEnter(e) {
    this.fireEvents('onMouseEnter', e);
    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
  },
  onMouseLeave: function onMouseLeave(e) {
    this.fireEvents('onMouseLeave', e);
    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
  },
  onPopupMouseEnter: function onPopupMouseEnter() {
    this.clearDelayTimer();
  },
  onPopupMouseLeave: function onPopupMouseLeave(e) {
            if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(this._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
  },
  onFocus: function onFocus(e) {
    this.fireEvents('onFocus', e);
        this.clearDelayTimer();
    if (this.isFocusToShow()) {
      this.focusTime = Date.now();
      this.delaySetPopupVisible(true, this.props.focusDelay);
    }
  },
  onMouseDown: function onMouseDown(e) {
    this.fireEvents('onMouseDown', e);
    this.preClickTime = Date.now();
  },
  onTouchStart: function onTouchStart(e) {
    this.fireEvents('onTouchStart', e);
    this.preTouchTime = Date.now();
  },
  onBlur: function onBlur(e) {
    this.fireEvents('onBlur', e);
    this.clearDelayTimer();
    if (this.isBlurToHide()) {
      this.delaySetPopupVisible(false, this.props.blurDelay);
    }
  },
  onClick: function onClick(event) {
    this.fireEvents('onClick', event);
        if (this.focusTime) {
      var preTime = void 0;
      if (this.preClickTime && this.preTouchTime) {
        preTime = Math.min(this.preClickTime, this.preTouchTime);
      } else if (this.preClickTime) {
        preTime = this.preClickTime;
      } else if (this.preTouchTime) {
        preTime = this.preTouchTime;
      }
      if (Math.abs(preTime - this.focusTime) < 20) {
        return;
      }
      this.focusTime = 0;
    }
    this.preClickTime = 0;
    this.preTouchTime = 0;
    event.preventDefault();
    var nextVisible = !this.state.popupVisible;
    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
      this.setPopupVisible(!this.state.popupVisible);
    }
  },
  onDocumentClick: function onDocumentClick(event) {
    if (this.props.mask && !this.props.maskClosable) {
      return;
    }
    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);
    var popupNode = this.getPopupDomNode();
    if (!Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target)) {
      this.close();
    }
  },
  getPopupDomNode: function getPopupDomNode() {
        if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  },
  getRootDomNode: function getRootDomNode() {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);
  },
  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
    var className = [];
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        builtinPlacements = props.builtinPlacements,
        prefixCls = props.prefixCls;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getPopupClassNameFromAlign */])(builtinPlacements, prefixCls, align));
    }
    if (props.getPopupClassNameFromAlign) {
      className.push(props.getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  },
  getPopupAlign: function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  },
  getComponent: function getComponent() {
    var props = this.props,
        state = this.state;

    var mouseProps = {};
    if (this.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = this.onPopupMouseEnter;
    }
    if (this.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = this.onPopupMouseLeave;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: props.prefixCls,
        destroyPopupOnHide: props.destroyPopupOnHide,
        visible: state.popupVisible,
        className: props.popupClassName,
        action: props.action,
        align: this.getPopupAlign(),
        onAlign: props.onPopupAlign,
        animation: props.popupAnimation,
        getClassNameFromAlign: this.getPopupClassNameFromAlign
      }, mouseProps, {
        getRootDomNode: this.getRootDomNode,
        style: props.popupStyle,
        mask: props.mask,
        zIndex: props.zIndex,
        transitionName: props.popupTransitionName,
        maskAnimation: props.maskAnimation,
        maskTransitionName: props.maskTransitionName
      }),
      typeof props.popup === 'function' ? props.popup() : props.popup
    );
  },
  setPopupVisible: function setPopupVisible(popupVisible) {
    this.clearDelayTimer();
    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({
          popupVisible: popupVisible
        });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }
  },
  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible);
    }
  },
  clearDelayTimer: function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  },
  clearOutsideHandler: function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  },
  createTwoChains: function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  },
  isClickToShow: function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  },
  isClickToHide: function isClickToHide() {
    var _props2 = this.props,
        action = _props2.action,
        hideAction = _props2.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  },
  isMouseEnterToShow: function isMouseEnterToShow() {
    var _props3 = this.props,
        action = _props3.action,
        showAction = _props3.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  },
  isMouseLeaveToHide: function isMouseLeaveToHide() {
    var _props4 = this.props,
        action = _props4.action,
        hideAction = _props4.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  },
  isFocusToShow: function isFocusToShow() {
    var _props5 = this.props,
        action = _props5.action,
        showAction = _props5.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  },
  isBlurToHide: function isBlurToHide() {
    var _props6 = this.props,
        action = _props6.action,
        hideAction = _props6.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  },
  forcePopupAlign: function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  },
  fireEvents: function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  },
  close: function close() {
    this.setPopupVisible(false);
  },
  render: function render() {
    var props = this.props;
    var children = props.children;
    var child = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children);
    var newChildProps = {};
    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(child, newChildProps);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (Trigger);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(331);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(39);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(333);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_align__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_animate__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PopupInner__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LazyRenderBox__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(139);














var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

    _initialiseProps.call(_this);

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_12__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_12__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Popup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rootNode = this.getPopupDomNode();
    }
  }, {
    key: 'getPopupDomNode',
    value: function getPopupDomNode() {
      return __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.popupInstance);
    }
  }, {
    key: 'getMaskTransitionName',
    value: function getMaskTransitionName() {
      var props = this.props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;
      if (!transitionName && animation) {
        transitionName = props.prefixCls + '-' + animation;
      }
      return transitionName;
    }
  }, {
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'getClassName',
    value: function getClassName(currentAlignClassName) {
      return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
    }
  }, {
    key: 'getPopupElement',
    value: function getPopupElement() {
      var savePopupRef = this.savePopupRef,
          props = this.props;
      var align = props.align,
          style = props.style,
          visible = props.visible,
          prefixCls = props.prefixCls,
          destroyPopupOnHide = props.destroyPopupOnHide;

      var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
      var hiddenClassName = prefixCls + '-hidden';
      if (!visible) {
        this.currentAlignClassName = null;
      }
      var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, this.getZIndexStyle());
      var popupInnerProps = {
        className: className,
        prefixCls: prefixCls,
        ref: savePopupRef,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: newStyle
      };
      if (destroyPopupOnHide) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
          {
            component: '',
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName()
          },
          visible ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */],
            {
              target: this.getTarget,
              key: 'popup',
              ref: this.saveAlignRef,
              monitorWindowResize: true,
              align: align,
              onAlign: this.onAlign
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__PopupInner__["a" /* default */],
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                visible: true
              }, popupInnerProps),
              props.children
            )
          ) : null
        );
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName(),
          showProp: 'xVisible'
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */],
          {
            target: this.getTarget,
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            xVisible: visible,
            childrenProps: { visible: 'xVisible' },
            disabled: !visible,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              hiddenClassName: hiddenClassName
            }, popupInnerProps),
            props.children
          )
        )
      );
    }
  }, {
    key: 'getZIndexStyle',
    value: function getZIndexStyle() {
      var style = {};
      var props = this.props;
      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }
      return style;
    }
  }, {
    key: 'getMaskElement',
    value: function getMaskElement() {
      var props = this.props;
      var maskElement = void 0;
      if (props.mask) {
        var maskTransition = this.getMaskTransitionName();
        maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LazyRenderBox__["a" /* default */], {
          style: this.getZIndexStyle(),
          key: 'mask',
          className: props.prefixCls + '-mask',
          hiddenClassName: props.prefixCls + '-mask-hidden',
          visible: props.visible
        });
        if (maskTransition) {
          maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
            {
              key: 'mask',
              showProp: 'visible',
              transitionAppear: true,
              component: '',
              transitionName: maskTransition
            },
            maskElement
          );
        }
      }
      return maskElement;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        this.getMaskElement(),
        this.getPopupElement()
      );
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this2.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this2.currentAlignClassName !== currentAlignClassName) {
      _this2.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this2.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.getTarget = function () {
    return _this2.props.getRootDomNode();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(336);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(339);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(134);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(137);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(137);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(136);
} catch (err) {
  var index = __webpack_require__(136);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LazyRenderBox__ = __webpack_require__(138);








var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PopupInner.__proto__ || Object.getPrototypeOf(PopupInner)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PopupInner, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var className = props.className;
      if (!props.visible) {
        className += ' ' + props.hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          className: className,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          style: props.style
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__LazyRenderBox__["a" /* default */],
          { className: props.prefixCls + '-content', visible: props.visible },
          props.children
        )
      );
    }
  }]);

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContainerRenderMixin;

var _reactDom = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function defaultGetContainer() {
  var container = document.createElement('div');
  document.body.appendChild(container);
  return container;
}

function getContainerRenderMixin(config) {
  var _config$autoMount = config.autoMount,
      autoMount = _config$autoMount === void 0 ? true : _config$autoMount,
      _config$autoDestroy = config.autoDestroy,
      autoDestroy = _config$autoDestroy === void 0 ? true : _config$autoDestroy,
      isVisible = config.isVisible,
      isForceRender = config.isForceRender,
      getComponent = config.getComponent,
      _config$getContainer = config.getContainer,
      getContainer = _config$getContainer === void 0 ? defaultGetContainer : _config$getContainer;
  var mixin;

  function _renderComponent(instance, componentArg, ready) {
    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
      if (!instance._container) {
        instance._container = getContainer(instance);
      }

      var component;

      if (instance.getComponent) {
        component = instance.getComponent(componentArg);
      } else {
        component = getComponent(instance, componentArg);
      }

      _reactDom.default.unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
        instance._component = this;

        if (ready) {
          ready.call(this);
        }
      });
    }
  }

  if (autoMount) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentDidMount: function componentDidMount() {
        _renderComponent(this);
      },
      componentDidUpdate: function componentDidUpdate() {
        _renderComponent(this);
      }
    });
  }

  if (!autoMount || !autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      renderComponent: function renderComponent(componentArg, ready) {
        _renderComponent(this, componentArg, ready);
      }
    });
  }

  function _removeContainer(instance) {
    if (instance._container) {
      var container = instance._container;

      _reactDom.default.unmountComponentAtNode(container);

      container.parentNode.removeChild(container);
      instance._container = null;
    }
  }

  if (autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentWillUnmount: function componentWillUnmount() {
        _removeContainer(this);
      }
    });
  } else {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      removeContainer: function removeContainer() {
        _removeContainer(this);
      }
    });
  }

  return mixin;
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated. It's used to publish CJS to npm.
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(79);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _color = __webpack_require__(66);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var WIDTH = 200;
var HEIGHT = 150;

var Board = function (_React$Component) {
  _inherits(Board, _React$Component);

  function Board(props) {
    _classCallCheck(this, Board);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onBoardMouseDown = function (e) {
      var buttons = e.buttons;

      // only work on left click
      // @see https://developer.mozilla.org/en-US/docs/Web/Events/mousedown
      if (buttons !== 1) return;

      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
      _this.dragListener = (0, _addEventListener2["default"])(window, 'mousemove', _this.onBoardDrag);
      _this.dragUpListener = (0, _addEventListener2["default"])(window, 'mouseup', _this.onBoardDragEnd);
    };

    _this.onBoardTouchStart = function (e) {
      if (e.touches.length !== 1) {
        return;
      }
      _this.removeTouchListeners();
      var x = e.targetTouches[0].clientX;
      var y = e.targetTouches[0].clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.touchMoveListener = (0, _addEventListener2["default"])(window, 'touchmove', _this.onBoardTouchMove);
      _this.touchEndListener = (0, _addEventListener2["default"])(window, 'touchend', _this.onBoardTouchEnd);
    };

    _this.onBoardTouchMove = function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      var x = e.targetTouches[0].clientX;
      var y = e.targetTouches[0].clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onBoardTouchEnd = function () {
      _this.removeTouchListeners();
    };

    _this.onBoardDrag = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onBoardDragEnd = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-board';
    };

    _this.removeTouchListeners = function () {
      if (_this.touchMoveListener) {
        _this.touchMoveListener.remove();
        _this.touchMoveListener = null;
      }
      if (_this.touchEndListener) {
        _this.touchEndListener.remove();
        _this.touchEndListener = null;
      }
    };

    _this.removeListeners = function () {
      if (_this.dragListener) {
        _this.dragListener.remove();
        _this.dragListener = null;
      }
      if (_this.dragUpListener) {
        _this.dragUpListener.remove();
        _this.dragUpListener = null;
      }
    };

    _this.pointMoveTo = function (pos) {
      var rect = _reactDom2["default"].findDOMNode(_this).getBoundingClientRect();
      var left = pos.x - rect.left;
      var top = pos.y - rect.top;

      var rWidth = rect.width || WIDTH;
      var rHeight = rect.height || HEIGHT;

      left = Math.max(0, left);
      left = Math.min(left, rWidth);
      top = Math.max(0, top);
      top = Math.min(top, rHeight);

      var color = _this.props.color;


      color.saturation = left / rWidth;
      color.brightness = 1 - top / rHeight;

      _this.props.onChange(color);
    };

    return _this;
  }

  Board.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeListeners();
    this.removeTouchListeners();
  };

  /**
   * 移动光标位置到
   * @param  {object} pos X Y 全局坐标点
   */


  Board.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    var color = this.props.color;

    var hueHsv = {
      h: color.hue,
      s: 1,
      v: 1
    };

    var hueColor = new _color2["default"](hueHsv).toHexString();

    var xRel = color.saturation * 100;
    var yRel = (1 - color.brightness) * 100;

    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-hsv', style: { backgroundColor: hueColor } },
        _react2["default"].createElement('div', { className: prefixCls + '-value' }),
        _react2["default"].createElement('div', { className: prefixCls + '-saturation' })
      ),
      _react2["default"].createElement('span', { style: { left: xRel + '%', top: yRel + '%' } }),
      _react2["default"].createElement('div', {
        className: prefixCls + '-handler',
        onMouseDown: this.onBoardMouseDown,
        onTouchStart: this.onBoardTouchStart
      })
    );
  };

  return Board;
}(_react2["default"].Component);

/**
 * hsv
 * h: range(0, 359)
 * s: range(0, 1)
 * v: range(0, 1)
 */

exports["default"] = Board;
Board.propTypes = {
  color: _propTypes2["default"].object,
  onChange: _propTypes2["default"].func,
  rootPrefixCls: _propTypes2["default"].string
};
module.exports = exports['default'];

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = __webpack_require__(66);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Preview = function (_React$Component) {
  _inherits(Preview, _React$Component);

  function Preview() {
    var _temp, _this, _ret;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onChange = function (e) {
      var value = e.target.value;
      var color = new _color2["default"](value);
      _this.props.onChange(color);
      e.stopPropagation();
    }, _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-preview';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Preview.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    var hex = this.props.color.toHexString();
    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement('span', {
        style: {
          backgroundColor: hex,
          opacity: this.props.alpha / 100
        }
      }),
      _react2["default"].createElement('input', {
        type: 'color',
        value: hex,
        onChange: this.onChange,
        onClick: this.props.onInputClick
      })
    );
  };

  return Preview;
}(_react2["default"].Component);

exports["default"] = Preview;


Preview.propTypes = {
  rootPrefixCls: _propTypes2["default"].string,
  color: _propTypes2["default"].object,
  alpha: _propTypes2["default"].number,
  onChange: _propTypes2["default"].func,
  onInputClick: _propTypes2["default"].func
};
module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(79);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Ribbon = function (_React$Component) {
  _inherits(Ribbon, _React$Component);

  function Ribbon(props) {
    _classCallCheck(this, Ribbon);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onMouseDown = function (e) {
      var x = e.clientX;
      var y = e.clientY;

      _this.pointMoveTo({
        x: x,
        y: y
      });

      _this.dragListener = (0, _addEventListener2["default"])(window, 'mousemove', _this.onDrag);
      _this.dragUpListener = (0, _addEventListener2["default"])(window, 'mouseup', _this.onDragEnd);
    };

    _this.onDrag = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onDragEnd = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-ribbon';
    };

    _this.pointMoveTo = function (coords) {
      var rect = _reactDom2["default"].findDOMNode(_this).getBoundingClientRect();
      var width = rect.width;
      var left = coords.x - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, width);

      var huePercent = left / width;
      var hue = huePercent * 360;

      var color = _this.props.color;


      color.hue = hue;

      _this.props.onChange(color);
    };

    _this.removeListeners = function () {
      if (_this.dragListener) {
        _this.dragListener.remove();
        _this.dragListener = null;
      }
      if (_this.dragUpListener) {
        _this.dragUpListener.remove();
        _this.dragUpListener = null;
      }
    };

    return _this;
  }

  Ribbon.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeListeners();
  };

  Ribbon.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    var hue = this.props.color.hue;
    var per = hue / 360 * 100;

    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement('span', { ref: 'point', style: { left: per + '%' } }),
      _react2["default"].createElement('div', { className: prefixCls + '-handler', onMouseDown: this.onMouseDown })
    );
  };

  return Ribbon;
}(_react2["default"].Component);

exports["default"] = Ribbon;


Ribbon.propTypes = {
  rootPrefixCls: _propTypes2["default"].string,
  color: _propTypes2["default"].object,
  onChange: _propTypes2["default"].func
};
module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(79);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function rgbaColor(r, g, b, a) {
  return 'rgba(' + [r, g, b, a / 100].join(',') + ')';
}

var Alpha = function (_React$Component) {
  _inherits(Alpha, _React$Component);

  function Alpha(props) {
    _classCallCheck(this, Alpha);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onMouseDown = function (e) {
      var x = e.clientX;
      var y = e.clientY;

      _this.pointMoveTo({
        x: x,
        y: y
      });

      _this.dragListener = (0, _addEventListener2["default"])(window, 'mousemove', _this.onDrag);
      _this.dragUpListener = (0, _addEventListener2["default"])(window, 'mouseup', _this.onDragEnd);
    };

    _this.onDrag = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onDragEnd = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
    };

    _this.getBackground = function () {
      var _this$props$color = _this.props.color,
          red = _this$props$color.red,
          green = _this$props$color.green,
          blue = _this$props$color.blue;

      var opacityGradient = 'linear-gradient(to right, ' + rgbaColor(red, green, blue, 0) + ' , ' + rgbaColor(red, green, blue, 100) + ')'; // eslint-disable-line max-len
      return opacityGradient;
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-alpha';
    };

    _this.pointMoveTo = function (coords) {
      var rect = (0, _reactDom.findDOMNode)(_this).getBoundingClientRect();
      var width = rect.width;
      var left = coords.x - rect.left;

      left = Math.max(0, left);
      left = Math.min(left, width);

      var alpha = Math.round(left / width * 100);

      _this.props.onChange(alpha);
    };

    _this.removeListeners = function () {
      if (_this.dragListener) {
        _this.dragListener.remove();
        _this.dragListener = null;
      }
      if (_this.dragUpListener) {
        _this.dragUpListener.remove();
        _this.dragUpListener = null;
      }
    };

    return _this;
  }

  Alpha.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeListeners();
  };

  Alpha.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement('div', { ref: 'bg', className: prefixCls + '-bg', style: { background: this.getBackground() } }),
      _react2["default"].createElement('span', { style: { left: this.props.alpha + '%' } }),
      _react2["default"].createElement('div', { className: prefixCls + '-handler', onMouseDown: this.onMouseDown })
    );
  };

  return Alpha;
}(_react2["default"].Component);

exports["default"] = Alpha;


Alpha.propTypes = {
  color: _propTypes2["default"].object,
  onChange: _propTypes2["default"].func,
  rootPrefixCls: _propTypes2["default"].string,
  alpha: _propTypes2["default"].number
};
module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(26);

var _classnames2 = _interopRequireDefault(_classnames);

var _color = __webpack_require__(66);

var _color2 = _interopRequireDefault(_color);

var _percentage = __webpack_require__(355);

var _percentage2 = _interopRequireDefault(_percentage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var modesMap = ['RGB', 'HSB'];

var Params = function (_React$Component) {
  _inherits(Params, _React$Component);

  function Params(props) {
    _classCallCheck(this, Params);

    // 管理 input 的状态
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getChannelInRange = function (value, index) {
      var channelMap = {
        RGB: [[0, 255], [0, 255], [0, 255]],
        HSB: [[0, 359], [0, 100], [0, 100]]
      };
      var mode = _this.state.mode;
      var range = channelMap[mode][index];
      var result = parseInt(value, 10);
      if (isNaN(result)) {
        result = 0;
      }
      result = Math.max(range[0], result);
      result = Math.min(result, range[1]);
      return result;
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-params';
    };

    _this.handleHexBlur = function () {
      var hex = _this.state.hex;

      var color = null;

      if (_color2["default"].isValidHex(hex)) {
        color = new _color2["default"](hex);
      }

      if (color !== null) {
        _this.setState({
          color: color,
          hex: hex
        });
        _this.props.onChange(color, false);
      }
    };

    _this.handleHexPress = function (event) {
      var hex = _this.state.hex;
      if (event.nativeEvent.which === 13) {
        var color = null;

        if (_color2["default"].isValidHex(hex)) {
          color = new _color2["default"](hex);
        }

        if (color !== null) {
          _this.setState({
            color: color,
            hex: hex
          });
          _this.props.onChange(color, false);
        }
      }
    };

    _this.handleHexChange = function (event) {
      var hex = event.target.value;

      _this.setState({
        hex: hex
      });
    };

    _this.handleModeChange = function () {
      var mode = _this.state.mode;

      var modeIndex = (modesMap.indexOf(mode) + 1) % modesMap.length;

      mode = modesMap[modeIndex];

      _this.setState({
        mode: mode
      });
    };

    _this.handleAlphaHandler = function (event) {
      var alpha = parseInt(event.target.value, 10);

      if (isNaN(alpha)) {
        alpha = 0;
      }
      alpha = Math.max(0, alpha);
      alpha = Math.min(alpha, 100);

      _this.props.onAlphaChange(alpha);
    };

    _this.updateColorByChanel = function (channel, value) {
      var color = _this.props.color;
      var mode = _this.state.mode;


      if (mode === 'HSB') {
        if (channel === 'H') {
          color.hue = parseInt(value, 10);
        } else if (channel === 'S') {
          color.saturation = parseInt(value, 10) / 100;
        } else if (channel === 'B') {
          color.brightness = parseInt(value, 10) / 100;
        }
      } else {
        if (channel === 'R') {
          color.red = parseInt(value, 10);
        } else if (channel === 'G') {
          color.green = parseInt(value, 10);
        } else if (channel === 'B') {
          color.blue = parseInt(value, 10);
        }
      }

      return color;
    };

    _this.handleColorChannelChange = function (index, event) {
      var value = _this.getChannelInRange(event.target.value, index);
      var mode = _this.state.mode;

      var channel = mode[index];

      var color = _this.updateColorByChanel(channel, value);

      _this.setState({
        hex: color.hex,
        color: color
      }, function () {
        _this.props.onChange(color, false);
      });
    };

    _this.state = {
      mode: props.mode,
      hex: props.color.hex,
      color: props.color // instanceof tinycolor
    };
    return _this;
  }

  Params.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextColor = nextProps.color;


    this.setState({
      color: nextColor,
      hex: nextColor.hex
    });
  };

  Params.prototype.render = function render() {
    var _cx;

    var prefixCls = this.getPrefixCls();

    var enableAlpha = this.props.enableAlpha;
    var _state = this.state,
        mode = _state.mode,
        color = _state.color;

    var colorChannel = color[mode];

    if (mode === 'HSB') {
      colorChannel[0] = parseInt(colorChannel[0], 10);
      colorChannel[1] = (0, _percentage2["default"])(colorChannel[1]);
      colorChannel[2] = (0, _percentage2["default"])(colorChannel[2]);
    }

    var paramsClasses = (0, _classnames2["default"])((_cx = {}, _defineProperty(_cx, prefixCls, true), _defineProperty(_cx, prefixCls + '-has-alpha', enableAlpha), _cx));

    return _react2["default"].createElement(
      'div',
      { className: paramsClasses },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-input' },
        _react2["default"].createElement('input', {
          className: prefixCls + '-hex',
          type: 'text',
          maxLength: '6',
          onKeyPress: this.handleHexPress,
          onBlur: this.handleHexBlur,
          onChange: this.handleHexChange,
          value: this.state.hex.toLowerCase()
        }),
        _react2["default"].createElement('input', {
          type: 'number',
          ref: 'channel_0',
          value: colorChannel[0],
          onChange: this.handleColorChannelChange.bind(null, 0)
        }),
        _react2["default"].createElement('input', {
          type: 'number',
          ref: 'channel_1',
          value: colorChannel[1],
          onChange: this.handleColorChannelChange.bind(null, 1)
        }),
        _react2["default"].createElement('input', {
          type: 'number',
          ref: 'channel_2',
          value: colorChannel[2],
          onChange: this.handleColorChannelChange.bind(null, 2)
        }),
        enableAlpha && _react2["default"].createElement('input', {
          type: 'number',
          value: Math.round(this.props.alpha),
          onChange: this.handleAlphaHandler
        })
      ),
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-lable' },
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-hex' },
          'Hex'
        ),
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-number', onClick: this.handleModeChange },
          mode[0]
        ),
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-number', onClick: this.handleModeChange },
          mode[1]
        ),
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-number', onClick: this.handleModeChange },
          mode[2]
        ),
        enableAlpha && _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-alpha' },
          'A'
        )
      )
    );
  };

  return Params;
}(_react2["default"].Component);

exports["default"] = Params;


Params.propTypes = {
  alpha: _propTypes2["default"].number,
  enableAlpha: _propTypes2["default"].bool,
  color: _propTypes2["default"].object.isRequired,
  mode: _propTypes2["default"].oneOf(modesMap),
  onAlphaChange: _propTypes2["default"].func,
  onChange: _propTypes2["default"].func,
  rootPrefixCls: _propTypes2["default"].string
};

Params.defaultProps = {
  mode: modesMap[0],
  enableAlpha: true
};
module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = percentage;
function percentage(input) {
  return Math.round(input * 100);
}
module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function validationColor(props, propName, componentName) {
  if (props[propName] && !/^#[0-9a-fA-F]{3,6}$/.test(props[propName])) {
    return new Error(componentName + ".props." + propName + " Validation failed!");
  }
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -5],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -5],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 5],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 5],
    targetOffset: targetOffset
  }
};

exports["default"] = placements;
module.exports = exports['default'];

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(359);

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 公司新闻
var Content_news=function(_React$Component){(0,_inherits3.default)(Content_news,_React$Component);function Content_news(){(0,_classCallCheck3.default)(this,Content_news);return(0,_possibleConstructorReturn3.default)(this,(Content_news.__proto__||(0,_getPrototypeOf2.default)(Content_news)).apply(this,arguments));}(0,_createClass3.default)(Content_news,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams,_props$eLinkMode=_props.eLinkMode,eLinkMode=_props$eLinkMode===undefined?{}:_props$eLinkMode;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:eLinkMode.options,value:eLinkMode.selected})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_news;}(_react2.default.Component);exports.default=Content_news;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(19);var _EField_New2=_interopRequireDefault(_EField_New);var _EShowHeader=__webpack_require__(35);var _EShowHeader2=_interopRequireDefault(_EShowHeader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 我的任务元素
var Content_ProcessTask=function(_React$Component){(0,_inherits3.default)(Content_ProcessTask,_React$Component);function Content_ProcessTask(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_ProcessTask);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_ProcessTask.__proto__||(0,_getPrototypeOf2.default)(Content_ProcessTask)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_ProcessTask,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected==''?'2':this.props.eLinkMode.selected}),_react2.default.createElement(_EShowHeader2.default,{ref:'eShowHeader',value:this.props.showHeader}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowHeader:this.refs['eShowHeader'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_ProcessTask;}(_react2.default.Component);exports.default=Content_ProcessTask;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 登录系统元素
var Content_login=function(_React$Component){(0,_inherits3.default)(Content_login,_React$Component);function Content_login(){(0,_classCallCheck3.default)(this,Content_login);return(0,_possibleConstructorReturn3.default)(this,(Content_login.__proto__||(0,_getPrototypeOf2.default)(Content_login)).apply(this,arguments));}(0,_createClass3.default)(Content_login,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues()};}}]);return Content_login;}(_react2.default.Component);exports.default=Content_login;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义元素
var Content_CustomElement=function(_React$Component){(0,_inherits3.default)(Content_CustomElement,_React$Component);function Content_CustomElement(props){(0,_classCallCheck3.default)(this,Content_CustomElement);return(0,_possibleConstructorReturn3.default)(this,(Content_CustomElement.__proto__||(0,_getPrototypeOf2.default)(Content_CustomElement)).call(this,props));}(0,_createClass3.default)(Content_CustomElement,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,_props$eCustom=_props.eCustom,eCustom=_props$eCustom===undefined?{}:_props$eCustom,_props$synergyParams=_props.synergyParams,synergyParams=_props$synergyParams===undefined?{}:_props$synergyParams;var packagename=eCustom.packagename,settingcompname=eCustom.settingcompname;var ECustomSetting=null;if(window.rewritePortalCusEleSetting&&typeof window.rewritePortalCusEleSetting=='function'){var props=(0,_extends3.default)({},this.props);var options={getInstance:function getInstance(eCustomSetting){return _this2.eCustomSetting=eCustomSetting;},id:eid,eid:eid,ebaseid:ebaseid,params:{hpid:hpid,eid:eid,ebaseid:ebaseid},synergyParams:synergyParams};ECustomSetting=window.rewritePortalCusEleSetting(props,options);}if(ECustomSetting==null&&window[packagename]&&window[packagename]['com']&&window[packagename]['com'][settingcompname]){var ECustomSettingTemp=window[packagename]['com'][settingcompname];ECustomSetting=_react2.default.createElement(ECustomSettingTemp,{getInstance:function getInstance(eCustomSetting){return _this2.eCustomSetting=eCustomSetting;},params:{hpid:hpid,eid:eid,ebaseid:ebaseid},synergyParams:synergyParams});}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle,hasLink:false}):''),this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(20885,'内容来源'),needTigger:true,showGroup:true},ECustomSetting));}},{key:'getSaveValues',value:function getSaveValues(){var result=this.eCustomSetting&&this.eCustomSetting.onSave();if(result===false){return null;}return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle};}}]);return Content_CustomElement;}(_react2.default.Component);exports.default=Content_CustomElement;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(17);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _ENewsMould=__webpack_require__(105);var _ENewsMould2=_interopRequireDefault(_ENewsMould);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 文档中心
var Content_dy=function(_React$Component){(0,_inherits3.default)(Content_dy,_React$Component);function Content_dy(){(0,_classCallCheck3.default)(this,Content_dy);return(0,_possibleConstructorReturn3.default)(this,(Content_dy.__proto__||(0,_getPrototypeOf2.default)(Content_dy)).apply(this,arguments));}(0,_createClass3.default)(Content_dy,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams,_props$dyParams=_props.dyParams,dyParams=_props$dyParams===undefined?[]:_props$dyParams,sebaseid=_props.sebaseid;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:sebaseid},this.props.eTabs,{synergyParams:synergyParams}));}var settingInfo=dyParams.map(function(dpitem){switch(dpitem.type){case'EShowNum':return _react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:_this2.props.eShowNum});break;case'ELinkMode':return _react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:_this2.props.eLinkMode.options,value:_this2.props.eLinkMode.selected});break;case'ERemindMode':return _react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:_this2.props.eRemindMode});break;default:return null;}});return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',settingInfo),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentRemindMode:this.refs['eRemindMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_dy;}(_react2.default.Component);exports.default=Content_dy;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(15);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EPortalBrowser=__webpack_require__(141);var _EPortalBrowser2=_interopRequireDefault(_EPortalBrowser);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);var _antd=__webpack_require__(7);var _weaPortalPublic=__webpack_require__(47);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 快捷入口元素
var Content_QuickEntry=function(_React$Component){(0,_inherits3.default)(Content_QuickEntry,_React$Component);function Content_QuickEntry(props){(0,_classCallCheck3.default)(this,Content_QuickEntry);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_QuickEntry.__proto__||(0,_getPrototypeOf2.default)(Content_QuickEntry)).call(this,props));_this.state={datas:_this.props.datas||[],eShowMode:_this.props.showMode||'1',eShowNum:_this.props.eShowNum||'5',eLayout:_this.props.eLayout||'0',eTitleColor:_this.props.eTitleColor||'#000'};_this.getColumns=_this.getColumns.bind(_this);_this.getRowSelection=_this.getRowSelection.bind(_this);return _this;}(0,_createClass3.default)(Content_QuickEntry,[{key:'getRowSelection',value:function getRowSelection(rowSelection){var _props$userid=this.props.userid,userid=_props$userid===undefined?'':_props$userid;var sel=(0,_extends3.default)({},rowSelection);sel.getCheckboxProps=function(record){return{disabled:userid!='1'&&record.userid==="1"};};return sel;}},{key:'getColumns',value:function getColumns(){var _this2=this;var _props$userid2=this.props.userid,userid=_props$userid2===undefined?'':_props$userid2;return[{title:getLabel(24986,'标题'),rowSpan:2,width:"20%",dataIndex:"title",com:[{type:'CUSTOM',key:"title",render:function render(text,record,index){var _datas=_this2.state.datas;var viewAttr='3';if(userid!='1'&&record.userid=='1'){viewAttr='1';}return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title,viewAttr:viewAttr,hasBorder:true,onChange:function onChange(value){_datas[index].title=value;_this2.setState({datas:_datas});}})));}}]},{title:getLabel(74,'图片'),rowSpan:2,dataIndex:"picture",width:"22%",com:[{key:'picture',type:'CUSTOM',viewAttr:'3',defaultValue:'',render:function render(text,record,index){var _datas=_this2.state.datas;var disabled=false;if(userid!='1'&&record.userid=='1'){disabled=true;}return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:false,disabled:disabled,value:record.picture,isShow:true,onChange:function onChange(value){_datas[index].picture=value;_this2.setState({datas:_datas});}})));}}]},{title:getLabel(16208,'链接地址'),rowSpan:2,width:"20%",dataIndex:"link",com:[{type:"CUSTOM",key:"link",defaultValue:'',render:function render(text,record,index){var _datas=_this2.state.datas;var viewAttr='2';if(userid!='1'&&record.userid=='1'){viewAttr='1';}return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},_react2.default.createElement(_ecCom.WeaInput,{value:record.link,hasBorder:true,viewAttr:viewAttr,onChange:function onChange(value){_datas[index].link=value;_this2.setState({datas:_datas});}})));}}]},{title:getLabel(128719,'显示顺序'),rowSpan:2,width:"20%",dataIndex:"ordernum",com:[{type:"CUSTOM",key:"ordernum",defaultValue:0,render:function render(text,record,index){var _datas=_this2.state.datas;var viewAttr='2';if(userid!='1'&&record.userid=='1'){viewAttr='1';}return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},_react2.default.createElement(_ecCom.WeaInput,{value:record.ordernum,viewAttr:viewAttr,hasBorder:true,onChange:function onChange(value){_datas[index].ordernum=value;_this2.setState({datas:_datas});}})));}}]},{title:getLabel(15603,'是否显示'),rowSpan:2,width:"15%",dataIndex:"ordernum",com:[{key:'isShow',type:'CUSTOM',viewAttr:'3',defaultValue:'1',render:function render(text,record,index){var disabled=false;if(record.userid!='1'||userid=='1'){disabled=true;record.isShow='1';}var _datas=_this2.state.datas;return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},_react2.default.createElement(_ecCom.WeaCheckbox,{value:record.isShow,disabled:disabled,onChange:function onChange(value){_datas[index].isShow=value;_this2.setState({datas:_datas});}})));}}]}];}},{key:'render',value:function render(){var _this3=this;var _state=this.state,datas=_state.datas,eShowMode=_state.eShowMode,eShowNum=_state.eShowNum,eTitleColor=_state.eTitleColor,eLayout=_state.eLayout;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams,userid=_props.userid;var __DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams,tabList:datas,userid:userid}));var itemData=[{id:"0",name:getLabel(515771,'上下布局-无背景色/分割线'),filepath:"/spa/portal/images/quickentry/showmoude0.png"},{id:"1",name:getLabel(515772,'上下布局-有分割线'),filepath:"/spa/portal/images/quickentry/showmoude1.png"},{id:"2",name:getLabel(515773,'上下布局-有背景色'),filepath:"/spa/portal/images/quickentry/showmoude2.png"},{id:"3",name:getLabel(515774,'左右布局-无背景色/分割线'),filepath:"/spa/portal/images/quickentry/showmoude3.png"},{id:"4",name:getLabel(515775,'左右布局-有分割线'),filepath:"/spa/portal/images/quickentry/showmoude4.png"},{id:"5",name:getLabel(515776,'左右布局-有背景色'),filepath:"/spa/portal/images/quickentry/showmoude5.png"}];var EPerNum=_react2.default.createElement('div',null);var ELayout=_react2.default.createElement('div',null);var EShowType=_react2.default.createElement('div',null);var ETitleColor=_react2.default.createElement('div',null);ELayout=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19407,'布局'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{value:eLayout,options:[{key:'0',showname:getLabel(515777,'靠左对齐'),selected:true},{key:'1',showname:getLabel(128965,'居中对齐')}],detailtype:3,onChange:function onChange(value){return _this3.setState({eLayout:value});}}));EPerNum=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(515778,'每行显示数量'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eShowNum,style:{width:'100px'},onChange:function onChange(value){return _this3.setState({eShowNum:value});}}),_react2.default.createElement(_ecCom.WeaHelpfulTip,{style:{marginLeft:'10px',marginBottom:'5px',display:'inline-block'},title:getLabel(515779,'为0时,根据元素宽度自动换行')}));EShowType=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23724,'显示样式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_EPortalBrowser2.default,{itemData:itemData,title:getLabel(515780,'选择元素样式'),multiCheck:false,disabled:false,value:eShowMode,isShow:true,onChange:function onChange(value){_this3.setState({eShowMode:value});}}));ETitleColor=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(2076,'字体颜色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaColorPicker,{value:eTitleColor,onChange:function onChange(v){return _this3.setState({eTitleColor:v});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',this.props.eShareLevel=='2'?EShowType:'',EPerNum,ELayout,ETitleColor,_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected!='1'?'2':this.props.eLinkMode.selected})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){var datas=this.state.datas.map(function(item,index){item.orderNum=index;item.data.orderNum=index;return item;});if(this.table&&!this.table.doValidate().pass)return;return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowMode:this.state.eShowMode,eContentTitleColor:this.state.eTitleColor,eContentLayout:this.state.eLayout,eContentShowNum:this.state.eShowNum,eContentDatas:datas};}}]);return Content_QuickEntry;}(_react2.default.Component);exports.default=Content_QuickEntry;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _DataSourceTable=__webpack_require__(25);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// ecode自定义元素
var Content_ecodeElement=function(_React$Component){(0,_inherits3.default)(Content_ecodeElement,_React$Component);function Content_ecodeElement(){(0,_classCallCheck3.default)(this,Content_ecodeElement);return(0,_possibleConstructorReturn3.default)(this,(Content_ecodeElement.__proto__||(0,_getPrototypeOf2.default)(Content_ecodeElement)).apply(this,arguments));}(0,_createClass3.default)(Content_ecodeElement,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){console.log("-----------this.props.eTabs :",this.props.eTabs);__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_ecodeElement;}(_react2.default.Component);exports.default=Content_ecodeElement;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);var _ETabWidth=__webpack_require__(368);var _ETabWidth2=_interopRequireDefault(_ETabWidth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Tab4Style=function(_React$Component){(0,_inherits3.default)(Tab4Style,_React$Component);function Tab4Style(props){(0,_classCallCheck3.default)(this,Tab4Style);var _this=(0,_possibleConstructorReturn3.default)(this,(Tab4Style.__proto__||(0,_getPrototypeOf2.default)(Tab4Style)).call(this,props));_this.state={eShareLevel:_this.props.eShareLevel,eStyleOptions:_this.props.eStyle.eStyleList.options,eStyleSelected:_this.props.eStyle.eStyleList.selected,eIcon:_this.props.eStyle.eIcon,eHeight:_this.props.eStyle.eHeight,eSpacing:_this.props.eStyle.eSpacing};_this.getSaveValues=_this.getSaveValues.bind(_this);return _this;}(0,_createClass3.default)(Tab4Style,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShareLevel=_state.eShareLevel,eStyleOptions=_state.eStyleOptions,eStyleSelected=_state.eStyleSelected,eIcon=_state.eIcon,eHeight=_state.eHeight,eSpacing=_state.eSpacing;var _props$eContent=this.props.eContent,eContent=_props$eContent===undefined?{}:_props$eContent;var disabled=!(eShareLevel=='2');return _react2.default.createElement('div',{className:'portal-mesetting-style'},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22913,'元素样式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:eStyleOptions.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eStyleSelected,style:{width:'200px'},disabled:disabled,onChange:function onChange(value){_this2.setState({eStyleSelected:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19492,'元素图标'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_WeaMaterialLib2.default,{value:eIcon,disabled:disabled,onChange:function onChange(value){return _this2.setState({eIcon:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(207,'高度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:''+eHeight,style:{width:'50px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eHeight:value});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386531,'自适应高度（0）'))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15932,'间距'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386532,'上间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.top,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{top:value})});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386533,'右间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.right,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{right:value})});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386534,'下间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.bottom,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{bottom:value})});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386535,'左间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.left,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{left:value})});}})),eContent.etabwidth&&eContent.methodvalue&&_react2.default.createElement(_ETabWidth2.default,{ref:'eTabWidth',tabwidth:eContent.etabwidth,methodvalue:eContent.methodvalue,disabled:disabled})));}},{key:'getSaveValues',value:function getSaveValues(){var _props$eContent2=this.props.eContent,eContent=_props$eContent2===undefined?{}:_props$eContent2;if(eContent.etabwidth&&eContent.methodvalue){return{eStyleList:this.state.eStyleSelected,eStyleIcon:this.state.eIcon,eStyleHeight:this.state.eHeight,eStyleSpacing:this.state.eSpacing,eContentTabWidth:this.refs['eTabWidth'].getSaveValues()};}else{return{eStyleList:this.state.eStyleSelected,eStyleIcon:this.state.eIcon,eStyleHeight:this.state.eHeight,eStyleSpacing:this.state.eSpacing};}}}]);return Tab4Style;}(_react2.default.Component);exports.default=Tab4Style;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ETabWidth=function(_React$Component){(0,_inherits3.default)(ETabWidth,_React$Component);function ETabWidth(props){(0,_classCallCheck3.default)(this,ETabWidth);var _this=(0,_possibleConstructorReturn3.default)(this,(ETabWidth.__proto__||(0,_getPrototypeOf2.default)(ETabWidth)).call(this,props));_this.state={tabwidth:_this.props.tabwidth||'76',methodvalue:_this.props.methodvalue||'2'};return _this;}(0,_createClass3.default)(ETabWidth,[{key:'getSaveValues',value:function getSaveValues(){var _state=this.state,tabwidth=_state.tabwidth,methodvalue=_state.methodvalue;var data={};if(methodvalue=='2'){data={tabwidth:'76',methodvalue:'2'};}else data={tabwidth:tabwidth,methodvalue:methodvalue};return data;}},{key:'render',value:function render(){var _this2=this;var _state2=this.state,tabwidth=_state2.tabwidth,methodvalue=_state2.methodvalue;var disabled=this.props.disabled;var options=[{key:"1",showname:getLabel(501539,'固定宽度')},{key:"2",selected:true,showname:getLabel(128975,'自适应')}];return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(501540,'tab页宽度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'90px',display:'inline-block',float:'left'}},_react2.default.createElement(_ecCom.WeaSelect,{options:options,value:methodvalue,onChange:function onChange(v){_this2.setState({methodvalue:v});},disabled:disabled})),methodvalue=='1'&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:tabwidth,disabled:disabled,style:{width:'54px',marginLeft:'15px'},onChange:function onChange(v){_this2.setState({tabwidth:v});}}),_react2.default.createElement('div',{style:{display:'inline-block',marginBottom:'6px',marginLeft:'15px'}},'px')));}}]);return ETabWidth;}(_react2.default.Component);exports.default=ETabWidth;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Tab4Share=function(_React$Component){(0,_inherits3.default)(Tab4Share,_React$Component);(0,_createClass3.default)(Tab4Share,[{key:'componentWillMount',value:function componentWillMount(){this.getYyfqData();}}]);function Tab4Share(props){(0,_classCallCheck3.default)(this,Tab4Share);var _this=(0,_possibleConstructorReturn3.default)(this,(Tab4Share.__proto__||(0,_getPrototypeOf2.default)(Tab4Share)).call(this,props));_this.state={key:0,sharetype:'3',sharevalue:'',includeSub:false,seclevelmin:0,seclevelmax:100,seclevel:'0-100',rolelevel:'0',jobtitlelevel:'1',jobtitlesharevalue:'',shareTypeName:'',shareValueName:'',jobtitlesharevaluename:'',objReplaceDatas:[],jobReplaceDatas:[],selectedRowKeys:[],eHasShareRight:_this.props.eShare.eHasShareRight,eOldShareList:_this.props.eShare.eOldShareList||[],// 老版共享数据
eShareList:_this.props.eShare.eShareList||[],// 新版共享数据
valueFlag:false};_this.getSaveValues=_this.getSaveValues.bind(_this);_this.getYyfqData=_this.getYyfqData.bind(_this);return _this;}(0,_createClass3.default)(Tab4Share,[{key:'render',value:function render(){var _this2=this;var eHasShareRight=this.state.eHasShareRight;if(eHasShareRight){var _state=this.state,sharetype=_state.sharetype,sharevalue=_state.sharevalue,shareValueName=_state.shareValueName,includeSub=_state.includeSub,seclevelmin=_state.seclevelmin,seclevelmax=_state.seclevelmax,rolelevel=_state.rolelevel,jobtitlelevel=_state.jobtitlelevel,jobtitlesharevalue=_state.jobtitlesharevalue,jobtitlesharevaluename=_state.jobtitlesharevaluename,objReplaceDatas=_state.objReplaceDatas,jobReplaceDatas=_state.jobReplaceDatas,selectedRowKeys=_state.selectedRowKeys,valueFlag=_state.valueFlag;var objItemVisible=true;var seclevelItemVisible=true;var rolelevelItemVisible=false;var jobtitlelevelItemVisible=false;var objItem='';var rolelevelItem='';var jobtitlelevelItem='';if(sharetype==='3'){// 部门
objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:57,isSingle:false,title:getLabel(27511,'部门'),replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],viewAttr:3,onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});}else if(sharetype==='2'){// 分部
objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:194,isSingle:false,title:getLabel(33553,'分部'),tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],viewAttr:3,onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});}else if(sharetype==='7'){// 安全级别
objItemVisible=false;}else if(sharetype==='1'){// 人力资源
seclevelItemVisible=false;objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:17,isSingle:false,title:getLabel(179,'人力资源'),viewAttr:3,replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});}else if(sharetype==='6'){// 角色
rolelevelItemVisible=true;objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:267,quickSearchName:'rolesmark',isSingle:true,title:getLabel(122,'角色'),viewAttr:3,replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});rolelevelItem=_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'0',selected:false,showname:getLabel(27511,'部门')},{key:'1',selected:false,showname:getLabel(33553,'分部')},{key:'2',selected:false,showname:getLabel(140,'总部')}],value:rolelevel,onChange:function onChange(value){return _this2.setState({rolelevel:value});}});}else if(sharetype==='8'){// 岗位
seclevelItemVisible=false;jobtitlelevelItemVisible=true;objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:278,isSingle:false,title:getLabel(6086,'岗位'),viewAttr:3,replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});var jobtitlelevelObj='';if(jobtitlelevel=='2'){jobtitlelevelObj=_react2.default.createElement(_ecCom.WeaBrowser,{type:57,isSingle:false,title:getLabel(27511,'部门'),tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],viewAttr:3,replaceDatas:jobtitlesharevalue!=''&&jobtitlesharevaluename!=''?[{id:jobtitlesharevalue,name:jobtitlesharevaluename}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({jobtitlesharevalue:ids,jobtitlesharevaluename:names});}});}else if(jobtitlelevel=='3'){jobtitlelevelObj=_react2.default.createElement(_ecCom.WeaBrowser,{type:194,isSingle:false,title:getLabel(33553,'分部'),tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],replaceDatas:jobtitlesharevalue!=''&&jobtitlesharevaluename!=''?[{id:jobtitlesharevalue,name:jobtitlesharevaluename}]:[],viewAttr:3,onChange:function onChange(ids,names,datas){return _this2.setState({jobtitlesharevalue:ids,jobtitlesharevaluename:names});}});}jobtitlelevelItem=_react2.default.createElement(_antd.Row,{gutter:16},_react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'1',selected:false,showname:getLabel(140,'总部')},{key:'2',selected:false,showname:getLabel(19438,'指定部门')},{key:'3',selected:false,showname:getLabel(19437,'指定分部')}],value:jobtitlelevel,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({jobtitlelevel:value,jobReplaceDatas:[],jobtitlesharevalue:'',jobtitlesharevaluename:''});}})),_react2.default.createElement(_antd.Col,{span:16},jobtitlelevelObj));}// 记录选中的tab数据行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){// if(selectedRowKeys==''){
//     $('#shareDel').css("background-color","");
// }else{
//     $('#shareDel').css("background-color","#55a1f8");
// }
_self.setState({selectedRowKeys:selectedRowKeys});}};// 表格数据源
var dataSource=this.state.eOldShareList.concat(this.state.eShareList);// 表格列
var columns=[{title:getLabel(21956,'对象类型'),dataIndex:'shareTypeName'},{title:getLabel(106,'对象'),dataIndex:'shareValueName'},{title:getLabel(683,'安全级别'),dataIndex:'securityLevel'}];return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21956,'对象类型'),labelCol:{span:6},wrapperCol:{span:16}},valueFlag==true?_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'3',selected:false,showname:getLabel(27511,'部门')},{key:'2',selected:false,showname:getLabel(33553,'分部')},{key:'1',selected:false,showname:getLabel(179,'人力资源')},{key:'6',selected:false,showname:getLabel(122,'角色')},{key:'8',selected:false,showname:getLabel(6086,'岗位')}],value:sharetype,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({sharetype:value,objReplaceDatas:[],jobReplaceDatas:[],sharevalue:'',shareValueName:'',jobtitlesharevalue:'',jobtitlesharevaluename:''});}}):_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'3',selected:false,showname:getLabel(27511,'部门')},{key:'2',selected:false,showname:getLabel(33553,'分部')},{key:'7',selected:false,showname:getLabel(1340,'所有人')},{key:'1',selected:false,showname:getLabel(179,'人力资源')},{key:'6',selected:false,showname:getLabel(122,'角色')},{key:'8',selected:false,showname:getLabel(6086,'岗位')}],value:sharetype,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({sharetype:value,objReplaceDatas:[],jobReplaceDatas:[],sharevalue:'',shareValueName:'',jobtitlesharevalue:'',jobtitlesharevaluename:''});}})),objItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(106,'对象'),labelCol:{span:6},wrapperCol:{span:16}},sharetype==='3'||sharetype==='2'?_react2.default.createElement(_antd.Row,{gutter:16},_react2.default.createElement(_antd.Col,{span:16},objItem),_react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Checkbox,{checked:includeSub,onChange:function onChange(e){return _this2.setState({includeSub:e.target.checked});}},getLabel(125963,'含下级')))):objItem):'',rolelevelItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21958,'角色级别'),labelCol:{span:6},wrapperCol:{span:16}},rolelevelItem):'',jobtitlelevelItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28169,'岗位级别'),labelCol:{span:6},wrapperCol:{span:16}},jobtitlelevelItem):'',seclevelItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(683,'安全级别'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.InputNumber,{defaultValue:seclevelmin,onChange:function onChange(value){return _this2.setState({seclevelmin:value});}}),_react2.default.createElement('span',{style:{margin:'0 5px'}},'-'),_react2.default.createElement(_antd.InputNumber,{defaultValue:seclevelmax,onChange:function onChange(value){return _this2.setState({seclevelmax:value});}})):''),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(1279,'共享信息'),needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',null,_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',onClick:this.onAdd.bind(this)},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),id:'shareDel',className:'portal-esetting-wsg-btn',onClick:this.onDelete.bind(this)},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,{rowSelection:rowSelection,columns:columns,dataSource:dataSource,pagination:false})));}else{return _react2.default.createElement('div',{style:{width:'100%',height:'50px',lineHeight:'50px',borderBottom:'1px solid #e9e9e9',textAlign:'center'}},_react2.default.createElement(_antd.Icon,{type:'exclamation-circle',style:{marginRight:'8px',color:'#fa0'}}),_react2.default.createElement('span',null,getLabel(2012,'对不起，您暂时没有权限！')));}}},{key:'onAdd',value:function onAdd(){var _state2=this.state,sharetype=_state2.sharetype,sharevalue=_state2.sharevalue,includeSub=_state2.includeSub,seclevelmin=_state2.seclevelmin,seclevelmax=_state2.seclevelmax,seclevel=_state2.seclevel,rolelevel=_state2.rolelevel,jobtitlelevel=_state2.jobtitlelevel,jobtitlesharevalue=_state2.jobtitlesharevalue,valueFlag=_state2.valueFlag;var _state3=this.state,key=_state3.key,shareTypeName=_state3.shareTypeName,shareValueName=_state3.shareValueName,jobtitlesharevaluename=_state3.jobtitlesharevaluename,eShareList=_state3.eShareList;if(sharetype!='7'&&(!sharevalue.trim()||jobtitlelevel!='1'&&!jobtitlesharevalue.trim())){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{// 部门(3)、分部(2)、所有人(7)、人力资源(1)、角色(6)、岗位(8)
if(valueFlag==true){shareTypeName={3:getLabel(27511,'部门'),2:getLabel(33553,'分部'),1:getLabel(179,'人力资源'),6:getLabel(122,'角色'),8:getLabel(6086,'岗位')}[sharetype];}else{shareTypeName={3:getLabel(27511,'部门'),2:getLabel(33553,'分部'),7:getLabel(1340,'所有人'),1:getLabel(179,'人力资源'),6:getLabel(122,'角色'),8:getLabel(6086,'岗位')}[sharetype];}if((sharetype=='3'||sharetype=='2')&&includeSub){shareValueName+='('+getLabel(125963,'含下级')+')';}else if(sharetype=='7'){shareValueName=getLabel(1340,'所有人');}else if(sharetype=='6'){if(rolelevel==2){shareValueName+='/'+getLabel(140,'总部');}else if(rolelevel==1){shareValueName+='/'+getLabel(33553,'分部');}else if(rolelevel==0){shareValueName+='/'+getLabel(27511,'部门');}}else if(sharetype=='8'){if(jobtitlelevel==1){shareValueName+='/'+getLabel(140,'总部');}else if(jobtitlelevel==2){shareValueName+='/'+getLabel(19438,'指定部门')+'/'+jobtitlesharevaluename;}else if(jobtitlelevel==3){shareValueName+='/'+getLabel(19437,'指定分部')+'/'+jobtitlesharevaluename;}}eShareList.push({key:--key,shareType:sharetype,shareValue:sharevalue,includeSub:includeSub,roleLevel:rolelevel,securityMinLevel:seclevelmin,securityMaxLevel:seclevelmax,securityLevel:sharetype=='1'||sharetype=='8'?'':seclevelmin+'-'+seclevelmax,jobShareLevel:jobtitlelevel,jobShareValue:jobtitlesharevalue,shareTypeName:shareTypeName,shareValueName:shareValueName});this.setState({key:key,eShareList:eShareList});}}},{key:'onDelete',value:function onDelete(){var _state4=this.state,selectedRowKeys=_state4.selectedRowKeys,eOldShareList=_state4.eOldShareList,eShareList=_state4.eShareList;var isOld=false;if(selectedRowKeys&&selectedRowKeys.length){var __selectedRowKeys=selectedRowKeys.slice();for(var i=0,len=__selectedRowKeys.length;i<len;i++){selectedRowKeys.splice(i,1);for(var j=0,len2=eOldShareList.length;j<len2;j++){if(eOldShareList[j].key==__selectedRowKeys[i]){eOldShareList.splice(j,1);isOld=true;break;}}if(!isOld){for(var k=0,len3=eShareList.length;k<len3;k++){if(eShareList[k].key==__selectedRowKeys[i]){eShareList.splice(k,1);break;}}}}}this.setState({eOldShareList:eOldShareList,eShareList:eShareList});}},{key:'getSaveValues',value:function getSaveValues(){return{eOldShareList:this.state.eOldShareList,eShareList:this.state.eShareList};}/*获取是否禁用“所有人”权限范围*/},{key:'getYyfqData',value:function getYyfqData(){var _this3=this;_ecCom.WeaTools.callApi('/api/hrm/common/appDetachDisableAll','get').then(function(result){if(result.status==true){_this3.setState({valueFlag:result.appDetachDisableAll});}});}}]);return Tab4Share;}(_react2.default.Component);exports.default=Tab4Share;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var ElementTemplate=function(_React$Component){(0,_inherits3.default)(ElementTemplate,_React$Component);function ElementTemplate(props){(0,_classCallCheck3.default)(this,ElementTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(ElementTemplate.__proto__||(0,_getPrototypeOf2.default)(ElementTemplate)).call(this,props));_this.state={visible:false,title:getLabel(386539,'元素模板'),templateTitle:props.templateTitle,desc:'',loading:false};_this.onShow=_this.onShow.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenus=_this.getRightMenus.bind(_this);return _this;}(0,_createClass3.default)(ElementTemplate,[{key:'onShow',value:function onShow(){this.setState({visible:true});}},{key:'onSave',value:function onSave(){this.setState({loading:true});var _props=this.props,eid=_props.eid,onSave=_props.onSave;var _state=this.state,templateTitle=_state.templateTitle,desc=_state.desc;if(!templateTitle.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(15859,'必要信息不完整！')});return;}onSave({type:'save&saveTemplate',templateTitle:templateTitle,desc:desc});}},{key:'getButtons',value:function getButtons(){var loading=this.state.loading;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{disabled:loading,type:'primary',onClick:this.onSave},getLabel(30986,'保存')));btns.push(_react2.default.createElement(_ecCom.WeaMoreButton,{datas:this.getRightMenus()}));return btns;}},{key:'getRightMenus',value:function getRightMenus(){var btns=[];btns.push({key:'1',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存'),onClick:this.onSave});return btns;}},{key:'render',value:function render(){var _this2=this;var _state2=this.state,visible=_state2.visible,title=_state2.title,templateTitle=_state2.templateTitle,desc=_state2.desc,loading=_state2.loading;return _react2.default.createElement(_ecCom.WeaDialog,{title:title,visible:visible,closable:true,loading:loading,onCancel:function onCancel(){return _this2.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:600}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenus()},_react2.default.createElement('div',{className:'portal-form-group'},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386540,'模板标题'),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:templateTitle,viewAttr:3,onChange:function onChange(value){return _this2.setState({templateTitle:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(433,'描述'),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaTextarea,{value:desc,minRows:4,onChange:function onChange(value){return _this2.setState({desc:value});}})))));}}]);return ElementTemplate;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ElementTemplate=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ElementTemplate);exports.default=ElementTemplate;

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPane__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContent__ = __webpack_require__(383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPane__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_2__TabContent__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__KeyCode__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TabPane__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Sentinel__ = __webpack_require__(143);

















function noop() {}

function getDefaultActiveKey(props) {
  var activeKey = void 0;
  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(props.children, function (child) {
    if (child && !activeKey && !child.props.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

function activeKeyIsValid(props, key) {
  var keys = __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(props.children, function (child) {
    return child && child.key;
  });
  return keys.indexOf(key) >= 0;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _initialiseProps.call(_this);

    var activeKey = void 0;
    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    _this.state = {
      activeKey: activeKey
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tabs, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy = true;
      __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
    }

    // Sentinel for tab index

  }, {
    key: 'updateSentinelContext',
    value: function updateSentinelContext() {
      var _this2 = this;

      if (this.destroy) return;

      __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
      this.sentinelId = __WEBPACK_IMPORTED_MODULE_10_raf___default()(function () {
        if (_this2.destroy) return;
        _this2.forceUpdate();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;

      var prefixCls = props.prefixCls,
          navWrapper = props.navWrapper,
          tabBarPosition = props.tabBarPosition,
          className = props.className,
          renderTabContent = props.renderTabContent,
          renderTabBar = props.renderTabBar,
          destroyInactiveTabPane = props.destroyInactiveTabPane,
          direction = props.direction,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane', 'direction']);

      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-' + tabBarPosition, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, !!className), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-rtl', direction === 'rtl'), _classnames));

      this.tabBar = renderTabBar();

      var tabBar = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(this.tabBar, {
        prefixCls: prefixCls,
        navWrapper: navWrapper,
        key: 'tabBar',
        onKeyDown: this.onNavKeyDown,
        tabBarPosition: tabBarPosition,
        onTabClick: this.onTabClick,
        panels: props.children,
        activeKey: this.state.activeKey,
        direction: this.props.direction
      });

      var tabContent = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(renderTabContent(), {
        prefixCls: prefixCls,
        tabBarPosition: tabBarPosition,
        activeKey: this.state.activeKey,
        destroyInactiveTabPane: destroyInactiveTabPane,
        children: props.children,
        onChange: this.setActiveKey,
        key: 'tabContent',
        direction: this.props.direction
      });

      var sentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Sentinel__["c" /* default */], {
        key: 'sentinelStart',
        setRef: this.setSentinelStart,
        nextElement: this.panelSentinelStart
      });
      var sentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Sentinel__["c" /* default */], {
        key: 'sentinelEnd',
        setRef: this.setSentinelEnd,
        prevElement: this.panelSentinelEnd
      });

      var contents = [];
      if (tabBarPosition === 'bottom') {
        contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
      } else {
        contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15__Sentinel__["b" /* SentinelProvider */],
        {
          value: {
            sentinelStart: this.sentinelStart,
            sentinelEnd: this.sentinelEnd,
            setPanelSentinelStart: this.setPanelSentinelStart,
            setPanelSentinelEnd: this.setPanelSentinelEnd
          }
        },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: cls,
            style: props.style
          }, Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* getDataAttr */])(restProps), {
            onScroll: this.onScroll
          }),
          contents
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var newState = {};
      if ('activeKey' in props) {
        newState.activeKey = props.activeKey;
      } else if (!activeKeyIsValid(props, state.activeKey)) {
        newState.activeKey = getDefaultActiveKey(props);
      }
      if (Object.keys(newState).length > 0) {
        return newState;
      }
      return null;
    }
  }]);

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onTabClick = function (activeKey, e) {
    if (_this3.tabBar.props.onTabClick) {
      _this3.tabBar.props.onTabClick(activeKey, e);
    }
    _this3.setActiveKey(activeKey);
  };

  this.onNavKeyDown = function (e) {
    var eventKeyCode = e.keyCode;
    if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_12__KeyCode__["a" /* default */].RIGHT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_12__KeyCode__["a" /* default */].DOWN) {
      e.preventDefault();
      var nextKey = _this3.getNextActiveKey(true);
      _this3.onTabClick(nextKey);
    } else if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_12__KeyCode__["a" /* default */].LEFT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_12__KeyCode__["a" /* default */].UP) {
      e.preventDefault();
      var previousKey = _this3.getNextActiveKey(false);
      _this3.onTabClick(previousKey);
    }
  };

  this.onScroll = function (_ref) {
    var target = _ref.target,
        currentTarget = _ref.currentTarget;

    if (target === currentTarget && target.scrollLeft > 0) {
      target.scrollLeft = 0;
    }
  };

  this.setSentinelStart = function (node) {
    _this3.sentinelStart = node;
  };

  this.setSentinelEnd = function (node) {
    _this3.sentinelEnd = node;
  };

  this.setPanelSentinelStart = function (node) {
    if (node !== _this3.panelSentinelStart) {
      _this3.updateSentinelContext();
    }
    _this3.panelSentinelStart = node;
  };

  this.setPanelSentinelEnd = function (node) {
    if (node !== _this3.panelSentinelEnd) {
      _this3.updateSentinelContext();
    }
    _this3.panelSentinelEnd = node;
  };

  this.setActiveKey = function (activeKey) {
    if (_this3.state.activeKey !== activeKey) {
      if (!('activeKey' in _this3.props)) {
        _this3.setState({
          activeKey: activeKey
        });
      }
      _this3.props.onChange(activeKey);
    }
  };

  this.getNextActiveKey = function (next) {
    var activeKey = _this3.state.activeKey;
    var children = [];
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(_this3.props.children, function (c) {
      if (c && !c.props.disabled) {
        if (next) {
          children.push(c);
        } else {
          children.unshift(c);
        }
      }
    });
    var length = children.length;
    var ret = length && children[0].key;
    children.forEach(function (child, i) {
      if (child.key === activeKey) {
        if (i === length - 1) {
          ret = children[0].key;
        } else {
          ret = children[i + 1].key;
        }
      }
    });
    return ret;
  };
};

Tabs.propTypes = {
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  renderTabBar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  renderTabContent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  navWrapper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

Tabs.defaultProps = {
  prefixCls: 'rc-tabs',
  destroyInactiveTabPane: false,
  onChange: noop,
  navWrapper: function navWrapper(arg) {
    return arg;
  },
  tabBarPosition: 'top',
  children: null,
  style: {},
  direction: 'ltr'
};

Tabs.TabPane = __WEBPACK_IMPORTED_MODULE_13__TabPane__["a" /* default */];

Object(__WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__["a" /* polyfill */])(Tabs);

/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(374)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(375)))

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(380);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(381);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(382);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(109);











var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          className = props.className,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin,
          direction = props.direction;
      var style = props.style;

      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-content', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
      if (animated) {
        var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getActiveIndex */])(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* getMarginStyle */])(activeIndex, tabBarPosition) : Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getTransformPropValue */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getTransformByIndex */])(activeIndex, tabBarPosition, direction));
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, animatedStyle);
        } else {
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
            display: 'none'
          });
        }
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabContent);


TabContent.propTypes = {
  animated: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animatedWithMargin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

TabContent.defaultProps = {
  animated: true
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(26);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabContent = function (_React$Component) {
  (0, _inherits3['default'])(TabContent, _React$Component);

  function TabContent() {
    (0, _classCallCheck3['default'])(this, TabContent);
    return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      _react2['default'].Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(_react2['default'].cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          className = props.className,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin,
          direction = props.direction;
      var style = props.style;

      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
      if (animated) {
        var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition, direction));
          style = (0, _extends3['default'])({}, style, animatedStyle);
        } else {
          style = (0, _extends3['default'])({}, style, {
            display: 'none'
          });
        }
      }
      return _react2['default'].createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);
  return TabContent;
}(_react2['default'].Component);

exports['default'] = TabContent;


TabContent.propTypes = {
  animated: _propTypes2['default'].bool,
  animatedWithMargin: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  children: _propTypes2['default'].node,
  activeKey: _propTypes2['default'].string,
  style: _propTypes2['default'].any,
  tabBarPosition: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  destroyInactiveTabPane: _propTypes2['default'].bool,
  direction: _propTypes2['default'].string
};

TabContent.defaultProps = {
  animated: true
};
module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InkTabBarNode = __webpack_require__(386);

var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);

var _TabBarTabsNode = __webpack_require__(387);

var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);

var _TabBarRootNode = __webpack_require__(389);

var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);

var _ScrollableTabBarNode = __webpack_require__(390);

var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);

var _SaveRef = __webpack_require__(399);

var _SaveRef2 = _interopRequireDefault(_SaveRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableInkTabBar = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);

  function ScrollableInkTabBar() {
    (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
    return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
  }

  (0, _createClass3['default'])(ScrollableInkTabBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          renderTabBarNode = _props.children,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['children']);


      return _react2['default'].createElement(
        _SaveRef2['default'],
        null,
        function (saveRef, getRef) {
          return _react2['default'].createElement(
            _TabBarRootNode2['default'],
            (0, _extends3['default'])({ saveRef: saveRef }, restProps),
            _react2['default'].createElement(
              _ScrollableTabBarNode2['default'],
              (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps),
              _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, renderTabBarNode: renderTabBarNode }, restProps)),
              _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps))
            )
          );
        }
      );
    }
  }]);
  return ScrollableInkTabBar;
}(_react2['default'].Component); /* eslint-disable react/prefer-stateless-function */


exports['default'] = ScrollableInkTabBar;


ScrollableInkTabBar.propTypes = {
  children: _propTypes2['default'].func
};
module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(26);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _componentDidUpdate(component, init) {
  var _component$props = component.props,
      styles = _component$props.styles,
      panels = _component$props.panels,
      activeKey = _component$props.activeKey,
      direction = _component$props.direction;

  var rootNode = component.props.getRef('root');
  var wrapNode = component.props.getRef('nav') || rootNode;
  var inkBarNode = component.props.getRef('inkBar');
  var activeTab = component.props.getRef('activeTab');
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.props.tabBarPosition;
  var activeIndex = (0, _utils.getActiveIndex)(panels, activeKey);
  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }
  if (activeTab) {
    var tabNode = activeTab;
    var transformSupported = (0, _utils.isTransform3dSupported)(inkBarNodeStyle);

    // Reset current style
    (0, _utils.setTransform)(inkBarNodeStyle, '');
    inkBarNodeStyle.width = '';
    inkBarNodeStyle.height = '';
    inkBarNodeStyle.left = '';
    inkBarNodeStyle.top = '';
    inkBarNodeStyle.bottom = '';
    inkBarNodeStyle.right = '';

    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var left = (0, _utils.getLeft)(tabNode, wrapNode);
      var width = tabNode.offsetWidth;

      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564
      if (width === rootNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);
        if (width) {
          left += (tabNode.offsetWidth - width) / 2;
        }
      }
      if (direction === 'rtl') {
        left = (0, _utils.getStyle)(tabNode, 'margin-left') - left;
      }
      // use 3d gpu to optimize render
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
      } else {
        inkBarNodeStyle.left = left + 'px';
      }
      inkBarNodeStyle.width = width + 'px';
    } else {
      var top = (0, _utils.getTop)(tabNode, wrapNode, true);
      var height = tabNode.offsetHeight;
      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);
        if (height) {
          top += (tabNode.offsetHeight - height) / 2;
        }
      }
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
        inkBarNodeStyle.top = '0';
      } else {
        inkBarNodeStyle.top = top + 'px';
      }
      inkBarNodeStyle.height = height + 'px';
    }
  }
  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
}

var InkTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(InkTabBarNode, _React$Component);

  function InkTabBarNode() {
    (0, _classCallCheck3['default'])(this, InkTabBarNode);
    return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(InkTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // ref https://github.com/ant-design/ant-design/issues/8678
      // ref https://github.com/react-component/tabs/issues/135
      // InkTabBarNode need parent/root ref for calculating position
      // since parent componentDidMount triggered after child componentDidMount
      // we're doing a quick fix here to use setTimeout to calculate position
      // after parent/root component mounted
      this.timeout = setTimeout(function () {
        _componentDidUpdate(_this2, true);
      }, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _componentDidUpdate(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          styles = _props.styles,
          inkBarAnimated = _props.inkBarAnimated;

      var className = prefixCls + '-ink-bar';
      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
      return _react2['default'].createElement('div', {
        style: styles.inkBar,
        className: classes,
        key: 'inkBar',
        ref: this.props.saveRef('inkBar')
      });
    }
  }]);
  return InkTabBarNode;
}(_react2['default'].Component);

exports['default'] = InkTabBarNode;


InkTabBarNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  styles: _propTypes2['default'].object,
  inkBarAnimated: _propTypes2['default'].bool,
  saveRef: _propTypes2['default'].func,
  direction: _propTypes2['default'].string
};

InkTabBarNode.defaultProps = {
  prefixCls: '',
  inkBarAnimated: true,
  styles: {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(388);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarTabsNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarTabsNode, _React$Component);

  function TabBarTabsNode() {
    (0, _classCallCheck3['default'])(this, TabBarTabsNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarTabsNode, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.panels,
          activeKey = _props.activeKey,
          prefixCls = _props.prefixCls,
          tabBarGutter = _props.tabBarGutter,
          saveRef = _props.saveRef,
          tabBarPosition = _props.tabBarPosition,
          renderTabBarNode = _props.renderTabBarNode,
          direction = _props.direction;

      var rst = [];

      _react2['default'].Children.forEach(children, function (child, index) {
        if (!child) {
          return;
        }
        var key = child.key;
        var cls = activeKey === key ? prefixCls + '-tab-active' : '';
        cls += ' ' + prefixCls + '-tab';
        var events = {};
        if (child.props.disabled) {
          cls += ' ' + prefixCls + '-tab-disabled';
        } else {
          events = {
            onClick: _this2.props.onTabClick.bind(_this2, key)
          };
        }
        var ref = {};
        if (activeKey === key) {
          ref.ref = saveRef('activeTab');
        }

        var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;

        var marginProperty = direction === 'rtl' ? 'marginLeft' : 'marginRight';
        var style = (0, _defineProperty3['default'])({}, (0, _utils.isVertical)(tabBarPosition) ? 'marginBottom' : marginProperty, gutter);
        (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');

        var node = _react2['default'].createElement(
          'div',
          (0, _extends3['default'])({
            role: 'tab',
            'aria-disabled': child.props.disabled ? 'true' : 'false',
            'aria-selected': activeKey === key ? 'true' : 'false'
          }, events, {
            className: cls,
            key: key,
            style: style
          }, ref),
          child.props.tab
        );

        if (renderTabBarNode) {
          node = renderTabBarNode(node);
        }

        rst.push(node);
      });

      return _react2['default'].createElement(
        'div',
        { ref: saveRef('navTabsContainer') },
        rst
      );
    }
  }]);
  return TabBarTabsNode;
}(_react2['default'].Component);

exports['default'] = TabBarTabsNode;


TabBarTabsNode.propTypes = {
  activeKey: _propTypes2['default'].string,
  panels: _propTypes2['default'].node,
  prefixCls: _propTypes2['default'].string,
  tabBarGutter: _propTypes2['default'].number,
  onTabClick: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func,
  renderTabBarNode: _propTypes2['default'].func,
  tabBarPosition: _propTypes2['default'].string,
  direction: _propTypes2['default'].string
};

TabBarTabsNode.defaultProps = {
  panels: [],
  prefixCls: [],
  tabBarGutter: null,
  onTabClick: function onTabClick() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(26);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarRootNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarRootNode, _React$Component);

  function TabBarRootNode() {
    (0, _classCallCheck3['default'])(this, TabBarRootNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarRootNode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          onKeyDown = _props.onKeyDown,
          className = _props.className,
          extraContent = _props.extraContent,
          style = _props.style,
          tabBarPosition = _props.tabBarPosition,
          children = _props.children,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);

      var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
      var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
      var newChildren = children;
      if (extraContent) {
        newChildren = [(0, _react.cloneElement)(extraContent, {
          key: 'extra',
          style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
        }), (0, _react.cloneElement)(children, { key: 'content' })];
        newChildren = topOrBottom ? newChildren : newChildren.reverse();
      }
      return _react2['default'].createElement(
        'div',
        (0, _extends3['default'])({
          role: 'tablist',
          className: cls,
          tabIndex: '0',
          ref: this.props.saveRef('root'),
          onKeyDown: onKeyDown,
          style: style
        }, (0, _utils.getDataAttr)(restProps)),
        newChildren
      );
    }
  }]);
  return TabBarRootNode;
}(_react2['default'].Component);

exports['default'] = TabBarRootNode;


TabBarRootNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].object,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  children: _propTypes2['default'].node,
  extraContent: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func
};

TabBarRootNode.defaultProps = {
  prefixCls: '',
  className: '',
  style: {},
  tabBarPosition: 'top',
  extraContent: null,
  children: null,
  onKeyDown: function onKeyDown() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames5 = __webpack_require__(26);

var _classnames6 = _interopRequireDefault(_classnames5);

var _debounce = __webpack_require__(391);

var _debounce2 = _interopRequireDefault(_debounce);

var _resizeObserverPolyfill = __webpack_require__(145);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _utils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);

  function ScrollableTabBarNode(props) {
    (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));

    _this.prevTransitionEnd = function (e) {
      if (e.propertyName !== 'opacity') {
        return;
      }
      var container = _this.props.getRef('container');
      _this.scrollToActiveTab({
        target: container,
        currentTarget: container
      });
    };

    _this.scrollToActiveTab = function (e) {
      var activeTab = _this.props.getRef('activeTab');
      var navWrap = _this.props.getRef('navWrap');
      if (e && e.target !== e.currentTarget || !activeTab) {
        return;
      }

      // when not scrollable or enter scrollable first time, don't emit scrolling
      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
      _this.lastNextPrevShown = _this.isNextPrevShown();
      if (!needToSroll) {
        return;
      }

      var activeTabWH = _this.getScrollWH(activeTab);
      var navWrapNodeWH = _this.getOffsetWH(navWrap);
      var offset = _this.offset;

      var wrapOffset = _this.getOffsetLT(navWrap);
      var activeTabOffset = _this.getOffsetLT(activeTab);
      if (wrapOffset > activeTabOffset) {
        offset += wrapOffset - activeTabOffset;
        _this.setOffset(offset);
      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
        _this.setOffset(offset);
      }
    };

    _this.prev = function (e) {
      _this.props.onPrevClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset + navWrapNodeWH);
    };

    _this.next = function (e) {
      _this.props.onNextClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset - navWrapNodeWH);
    };

    _this.offset = 0;

    _this.state = {
      next: false,
      prev: false
    };
    return _this;
  }

  (0, _createClass3['default'])(ScrollableTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.componentDidUpdate();
      this.debouncedResize = (0, _debounce2['default'])(function () {
        _this2.setNextPrev();
        _this2.scrollToActiveTab();
      }, 200);
      this.resizeObserver = new _resizeObserverPolyfill2['default'](this.debouncedResize);
      this.resizeObserver.observe(this.props.getRef('container'));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
        this.setOffset(0);
        return;
      }
      var nextPrev = this.setNextPrev();
      // wait next, prev show hide
      /* eslint react/no-did-update-set-state:0 */
      if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
        this.setState({}, this.scrollToActiveTab);
      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
        // can not use props.activeKey
        this.scrollToActiveTab();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.debouncedResize && this.debouncedResize.cancel) {
        this.debouncedResize.cancel();
      }
    }
  }, {
    key: 'setNextPrev',
    value: function setNextPrev() {
      var navNode = this.props.getRef('nav');
      var navTabsContainer = this.props.getRef('navTabsContainer');
      var navNodeWH = this.getScrollWH(navTabsContainer || navNode);
      // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
      // https://github.com/ant-design/ant-design/issues/13423
      var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
      var offset = this.offset;

      var minOffset = containerWH - navNodeWH;
      var _state = this.state,
          next = _state.next,
          prev = _state.prev;

      if (minOffset >= 0) {
        next = false;
        this.setOffset(0, false);
        offset = 0;
      } else if (minOffset < offset) {
        next = true;
      } else {
        next = false;
        // Fix https://github.com/ant-design/ant-design/issues/8861
        // Test with container offset which is stable
        // and set the offset of the nav wrap node
        var realOffset = navWrapNodeWH - navNodeWH;
        this.setOffset(realOffset, false);
        offset = realOffset;
      }

      if (offset < 0) {
        prev = true;
      } else {
        prev = false;
      }

      this.setNext(next);
      this.setPrev(prev);
      return {
        next: next,
        prev: prev
      };
    }
  }, {
    key: 'getOffsetWH',
    value: function getOffsetWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'offsetWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'offsetHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getScrollWH',
    value: function getScrollWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'scrollWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'scrollHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getOffsetLT',
    value: function getOffsetLT(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'left';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'top';
      }
      return node.getBoundingClientRect()[prop];
    }
  }, {
    key: 'setOffset',
    value: function setOffset(offset) {
      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var target = Math.min(0, offset);
      if (this.offset !== target) {
        this.offset = target;
        var navOffset = {};
        var tabBarPosition = this.props.tabBarPosition;
        var navStyle = this.props.getRef('nav').style;
        var transformSupported = (0, _utils.isTransform3dSupported)(navStyle);
        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          if (transformSupported) {
            navOffset = {
              value: 'translate3d(0,' + target + 'px,0)'
            };
          } else {
            navOffset = {
              name: 'top',
              value: target + 'px'
            };
          }
        } else if (transformSupported) {
          if (this.props.direction === 'rtl') {
            target = -target;
          }
          navOffset = {
            value: 'translate3d(' + target + 'px,0,0)'
          };
        } else {
          navOffset = {
            name: 'left',
            value: target + 'px'
          };
        }
        if (transformSupported) {
          (0, _utils.setTransform)(navStyle, navOffset.value);
        } else {
          navStyle[navOffset.name] = navOffset.value;
        }
        if (checkNextPrev) {
          this.setNextPrev();
        }
      }
    }
  }, {
    key: 'setPrev',
    value: function setPrev(v) {
      if (this.state.prev !== v) {
        this.setState({
          prev: v
        });
      }
    }
  }, {
    key: 'setNext',
    value: function setNext(v) {
      if (this.state.next !== v) {
        this.setState({
          next: v
        });
      }
    }
  }, {
    key: 'isNextPrevShown',
    value: function isNextPrevShown(state) {
      if (state) {
        return state.next || state.prev;
      }
      return this.state.next || this.state.prev;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4;

      var _state2 = this.state,
          next = _state2.next,
          prev = _state2.prev;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          scrollAnimated = _props.scrollAnimated,
          navWrapper = _props.navWrapper,
          prevIcon = _props.prevIcon,
          nextIcon = _props.nextIcon;

      var showNextPrev = prev || next;

      var prevButton = _react2['default'].createElement(
        'span',
        {
          onClick: prev ? this.prev : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
          onTransitionEnd: this.prevTransitionEnd
        },
        prevIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
      );

      var nextButton = _react2['default'].createElement(
        'span',
        {
          onClick: next ? this.next : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
        },
        nextIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
      );

      var navClassName = prefixCls + '-nav';
      var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));

      return _react2['default'].createElement(
        'div',
        {
          className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
          key: 'container',
          ref: this.props.saveRef('container')
        },
        prevButton,
        nextButton,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-nav-scroll' },
            _react2['default'].createElement(
              'div',
              { className: navClasses, ref: this.props.saveRef('nav') },
              navWrapper(this.props.children)
            )
          )
        )
      );
    }
  }]);
  return ScrollableTabBarNode;
}(_react2['default'].Component);

exports['default'] = ScrollableTabBarNode;


ScrollableTabBarNode.propTypes = {
  activeKey: _propTypes2['default'].string,
  getRef: _propTypes2['default'].func.isRequired,
  saveRef: _propTypes2['default'].func.isRequired,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  prefixCls: _propTypes2['default'].string,
  scrollAnimated: _propTypes2['default'].bool,
  onPrevClick: _propTypes2['default'].func,
  onNextClick: _propTypes2['default'].func,
  navWrapper: _propTypes2['default'].func,
  children: _propTypes2['default'].node,
  prevIcon: _propTypes2['default'].node,
  nextIcon: _propTypes2['default'].node,
  direction: _propTypes2['default'].node
};

ScrollableTabBarNode.defaultProps = {
  tabBarPosition: 'left',
  prefixCls: '',
  scrollAnimated: true,
  onPrevClick: function onPrevClick() {},
  onNextClick: function onNextClick() {},
  navWrapper: function navWrapper(ele) {
    return ele;
  }
};
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80),
    now = __webpack_require__(392),
    toNumber = __webpack_require__(393);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(394),
    isObject = __webpack_require__(80),
    isSymbol = __webpack_require__(396);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(395);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isObjectLike = __webpack_require__(69);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(110);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SaveRef = function (_React$Component) {
  (0, _inherits3['default'])(SaveRef, _React$Component);

  function SaveRef() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, SaveRef);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
      return _this[name];
    }, _this.saveRef = function (name) {
      return function (node) {
        if (node) {
          _this[name] = node;
        }
      };
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(SaveRef, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.saveRef, this.getRef);
    }
  }]);
  return SaveRef;
}(_react2['default'].Component);

exports['default'] = SaveRef;


SaveRef.propTypes = {
  children: _propTypes2['default'].func
};

SaveRef.defaultProps = {
  children: function children() {
    return null;
  }
};
module.exports = exports['default'];

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(402);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _common=__webpack_require__(10);var _WfCenterLogList=__webpack_require__(403);var _WfCenterLogList2=_interopRequireDefault(_WfCenterLogList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.openWfCenterLogList=_this.openWfCenterLogList.bind(_this);if(window.element_workflow_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_workflow_refresh[props.config.params.eid]=_this.handleTabData.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleTabData.bind(_this);window.element_workflow_refresh=obj;}return _this;}(0,_createClass3.default)(EContent,[{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);this.openWfCenterLogList();try{if(window._ListenerCtrl)_ListenerCtrl.bind();}catch(e){window.console?console.log(getLabel(388033,"流程元素Ctrl绑定出错了："),e):alert(getLabel(388033,"流程元素Ctrl绑定出错了：")+e);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){try{if(window._ListenerCtrl)_ListenerCtrl.unbind();}catch(e){window.console?console.log(getLabel(388034,"流程元素Ctrl解除绑定出错了："),e):alert(getLabel(388034,"流程元素Ctrl解除绑定出错了：")+e);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(!(0,_lodash.isEqual)(this.props,nextProps)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var tabid_fr=tabid;var config=this.props.config;var _state$tabdata=this.state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata;var _tabdata=tabdata,_tabdata$tabsetting=_tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var more=tabsetting.more;var params=config.params,isremembertab=config.isremembertab;var currentTab=this.state.currentTab;if(!tabid)tabid=currentTab;tabdata=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)==null?{}:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);// if(!tabid_fr){ // 点击流程列表标题时
//     if(tabdata){
//         if(more) {
//             let arr = more.split(',');
//             let pass = false;
//             //判断是否是待办
//             for(let i = 0; i<arr.length; i++){
//                 if(arr[i] == "\"viewType\":\"1\""){
//                     pass = true;
//                     break;
//                 }
//             }
//             if(!pass) return;
//         }
//     }
// }
this.setState({refresh:tabid!==currentTab,currentTab:tabid,tabdata:tabdata});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=tabdata;ls.set('edata-'+params.eid,edata);}}_ecCom.WeaTools.callApi('/api/portal/element/workflowtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var _edata=ls.getJSONObj('edata-'+params.eid);if(_edata){_edata.currenttab=tabid;_edata.data=result;ls.set('edata-'+params.eid,_edata);}}}});}},{key:'openWfCenterLogList',value:function openWfCenterLogList(params){this.refs.wfCenterLogList&&this.refs.wfCenterLogList.signviewPoistion(params);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,_state$tabdata2=_state.tabdata,tabdata=_state$tabdata2===undefined?{}:_state$tabdata2,currentTab=_state.currentTab,refresh=_state.refresh;var _tabdata$tabsetting2=tabdata.tabsetting,tabsetting=_tabdata$tabsetting2===undefined?{}:_tabdata$tabsetting2,_tabdata$dataColoums=tabdata.dataColoums,dataColoums=_tabdata$dataColoums===undefined?[]:_tabdata$dataColoums;var tabids=edata.tabids,titles=edata.titles,counts=edata.counts,viewtypes=edata.viewtypes,esetting=edata.esetting;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;esetting.dataColoums=dataColoums;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var more="{}";var currCount="";if(tabdata&&tabdata.data){for(var i=0;i<tabids.length;i++){currCount=tabsetting.count;if(currCount){var cc=parseInt(currCount);if(tabids[i]===currentTab){counts[i]=currCount;}}}more=tabsetting.more;var list=tabdata.data.map(function(item,index){return(0,_extends3.default)({key:index},item);});contentHtml=_react2.default.createElement(_MarqueeCom2.default,{tabdata:tabdata,eid:eid,scolltype:tabdata.tabsetting.scrollDirection,scrollSpeed:tabsetting.scrollSpeed,ebaseid:ebaseid},_react2.default.createElement('div',{className:'portal_element_workflow'},_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(list[0],esetting,this.openWfCenterLogList),showHeader:esetting.showHeader=='1',pagination:false,dataSource:list,size:'small'})));}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,counts:counts,more:more,currCount:currCount,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement('div',{className:'workflowtab'},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)),_react2.default.createElement(_WfCenterLogList2.default,{eid:eid,tabid:currentTab,refresh:refresh,more:more,ref:'wfCenterLogList'})));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;// WEBPACK FOOTER //
// ./pc/portal_fs/elements/components/workflow/EContent.js

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Base64=ecCom.WeaTools.Base64;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'setMoreHref',value:function setMoreHref(){//urger: 是否督办
var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;var paramsStr="&eid="+eid+"&tabid="+currentTab+"&synergyRequestid="+JSON.parse(more).requestid+"&formData="+Base64.encode(JSON.parse(more).formData)+"&synergyWorkflowid="+JSON.parse(more).workflowid+currentTab+"&tabTitle="+JSON.parse(more).tabTitle;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:paramsStr,urger:false};}else{window.elements_more_params[eid]={isRouteUrl:true,paramsStr:paramsStr,urger:true};}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,_props4$config=_props4.config,config=_props4$config===undefined?{}:_props4$config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,_props4$counts=_props4.counts,counts=_props4$counts===undefined?[]:_props4$counts,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _isEqual=__webpack_require__(404);var _isEqual2=_interopRequireDefault(_isEqual);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadjs=window.loadjs;var WfCenterLogList=function(_React$Component){(0,_inherits3.default)(WfCenterLogList,_React$Component);function WfCenterLogList(props){(0,_classCallCheck3.default)(this,WfCenterLogList);var _this=(0,_possibleConstructorReturn3.default)(this,(WfCenterLogList.__proto__||(0,_getPrototypeOf2.default)(WfCenterLogList)).call(this,props));_this.state={hasLoad:false,store:null,visiable:false,requestid:''};_this.signviewPoistion=_this.signviewPoistion.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(WfCenterLogList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props=this.props,eid=_props.eid,tabid=_props.tabid,refresh=_props.refresh;if(nextProps.tabid!==tabid||refresh!==nextProps.refresh){}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_isEqual2.default)(this.state,nextState)||!(0,_isEqual2.default)(this.props,nextProps);}},{key:'signviewPoistion',value:function signviewPoistion(value){var _this2=this;if(value){var init=function init(){var _props2=_this2.props,_props2$requestid=_props2.requestid,requestid=_props2$requestid===undefined?-1:_props2$requestid,_props2$visible=_props2.visible,visible=_props2$visible===undefined?false:_props2$visible;var WfCenterLogListStore=window.weaWorkflowPublic.WfCenterLogListStore;var store=new WfCenterLogListStore();_this2.setState({hasLoad:true,store:store});};loadjs.isDefined('workflowPublic')?loadjs.ready('workflowPublic',init):loadjs(["/spa/workflow/static4public/index.js","/spa/workflow/static4public/index.css"],'workflowPublic',init);}this.setState({visiable:true,requestid:value});}},{key:'onCancel',value:function onCancel(v){this.setState({visiable:false,requestid:-1});window.element_workflow_reLoad();}},{key:'render',value:function render(){var _this3=this;var _state=this.state,hasLoad=_state.hasLoad,store=_state.store,visiable=_state.visiable,requestid=_state.requestid;var more=this.props.more;if(hasLoad){var _WfCenterLogList=window.weaWorkflowPublic.WfCenterLogList;if(visiable&&requestid>-1){if(more&&JSON.parse(more).viewType!="6"){store.init({requestid:requestid},visiable);}else{store.init({requestid:requestid,urger:1},visiable);}}return _react2.default.createElement(_WfCenterLogList,{onCancel:function onCancel(v){return _this3.onCancel(v);},wfCenterLogListStore:store});}else{return _react2.default.createElement('div',null);}}}]);return WfCenterLogList;}(_react2.default.Component);exports.default=WfCenterLogList;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(405);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(406),
    isObjectLike = __webpack_require__(69);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(407),
    equalArrays = __webpack_require__(150),
    equalByTag = __webpack_require__(439),
    equalObjects = __webpack_require__(443),
    getTag = __webpack_require__(465),
    isArray = __webpack_require__(112),
    isBuffer = __webpack_require__(151),
    isTypedArray = __webpack_require__(152);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81),
    stackClear = __webpack_require__(413),
    stackDelete = __webpack_require__(414),
    stackGet = __webpack_require__(415),
    stackHas = __webpack_require__(416),
    stackSet = __webpack_require__(417);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81),
    Map = __webpack_require__(111),
    MapCache = __webpack_require__(149);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(147),
    isMasked = __webpack_require__(419),
    isObject = __webpack_require__(80),
    toSource = __webpack_require__(148);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(420);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(423),
    ListCache = __webpack_require__(81),
    Map = __webpack_require__(111);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(424),
    hashDelete = __webpack_require__(425),
    hashGet = __webpack_require__(426),
    hashHas = __webpack_require__(427),
    hashSet = __webpack_require__(428);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(149),
    setCacheAdd = __webpack_require__(435),
    setCacheHas = __webpack_require__(436);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(110),
    Uint8Array = __webpack_require__(440),
    eq = __webpack_require__(146),
    equalArrays = __webpack_require__(150),
    mapToArray = __webpack_require__(441),
    setToArray = __webpack_require__(442);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 442 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(444);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(445),
    getSymbols = __webpack_require__(447),
    keys = __webpack_require__(450);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(446),
    isArray = __webpack_require__(112);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(448),
    stubArray = __webpack_require__(449);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 449 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(451),
    baseKeys = __webpack_require__(460),
    isArrayLike = __webpack_require__(464);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(452),
    isArguments = __webpack_require__(453),
    isArray = __webpack_require__(112),
    isBuffer = __webpack_require__(151),
    isIndex = __webpack_require__(456),
    isTypedArray = __webpack_require__(152);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(454),
    isObjectLike = __webpack_require__(69);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isObjectLike = __webpack_require__(69);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isLength = __webpack_require__(153),
    isObjectLike = __webpack_require__(69);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(144);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(461),
    nativeKeys = __webpack_require__(462);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(463);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(147),
    isLength = __webpack_require__(153);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(466),
    Map = __webpack_require__(111),
    Promise = __webpack_require__(467),
    Set = __webpack_require__(468),
    WeakMap = __webpack_require__(469),
    baseGetTag = __webpack_require__(68),
    toSource = __webpack_require__(148);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(55),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _CalendarTemplate=__webpack_require__(471);var _CalendarTemplate2=_interopRequireDefault(_CalendarTemplate);__webpack_require__(474);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MyCalendar=function(_React$Component){(0,_inherits3.default)(MyCalendar,_React$Component);function MyCalendar(props){(0,_classCallCheck3.default)(this,MyCalendar);var _this=(0,_possibleConstructorReturn3.default)(this,(MyCalendar.__proto__||(0,_getPrototypeOf2.default)(MyCalendar)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MyCalendar,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/workplan/calendar/MyCalendar','POST',{viewType:'3',selectDate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd")}).then(function(data){ls.set('edata-'+eid,data);var dataNew={};dataNew=data;_ecCom.WeaTools.callApi(api||'/api/portal/element/mycalendar','POST',(0,_extends3.default)({},params)).then(function(data){var _data$esetting=data.esetting,esetting=_data$esetting===undefined?{}:_data$esetting;var _esetting$isShowLunar=esetting.isShowLunarDatas,isShowLunarDatas=_esetting$isShowLunar===undefined?'0':_esetting$isShowLunar;dataNew.isShowLunarDatas=isShowLunarDatas;_this2.setState({edata:dataNew,refresh:false});});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};console.log(!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config));return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params,layoutid=config.layoutid;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_CalendarTemplate2.default,(0,_defineProperty3.default)({eid:eid,data:edata,isShowLunarDatas:edata.isShowLunarDatas,hpid:params.hpid,layoutid:layoutid,subCompanyId:params.subCompanyId},'eid',eid));}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return MyCalendar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MyCalendar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MyCalendar);exports.default=MyCalendar;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _util=__webpack_require__(472);var _moment=__webpack_require__(473);var _moment2=_interopRequireDefault(_moment);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//日历日程元素
var CalendarTemplate=function(_React$Component){(0,_inherits3.default)(CalendarTemplate,_React$Component);function CalendarTemplate(props){(0,_classCallCheck3.default)(this,CalendarTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(CalendarTemplate.__proto__||(0,_getPrototypeOf2.default)(CalendarTemplate)).call(this,props));var _date=new Date();_this.state={weaWorkplanLoaded:false,refresh:false,data:props.data,workplanData:[],createVisible:false,createType:'create',workPlanId:'',currentDate:(0,_common.formatDate)(_date,"yyyy-MM-dd"),currentMonth:(0,_common.formatDate)(_date,"yyyy-MM"),activeKey:'1',type:'month',selectYear:(0,_common.formatDate)(_date,"yyyy")};_this.doAdd=_this.doAdd.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.onClickData=_this.onClickData.bind(_this);_this.dateCellRender=_this.dateCellRender.bind(_this);_this.monthCellRender=_this.monthCellRender.bind(_this);_this.clickCalendarMonth=_this.clickCalendarMonth.bind(_this);_this.getWorkplanData=_this.getWorkplanData.bind(_this);_this.clickCalendarDay=_this.clickCalendarDay.bind(_this);return _this;}(0,_createClass3.default)(CalendarTemplate,[{key:'onPanelChange',value:function onPanelChange(value,type){var _this2=this;var selectYear=(0,_common.formatDate)(new Date(),"yyyy");if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))=='object'){selectYear=value.fields[1];}this.setState({type:type,selectYear:selectYear});var _props=this.props,eid=_props.eid,hpid=_props.hpid,subCompanyId=_props.subCompanyId;var selectdate="";var viewType='3';if(type=='week'){var fields=value.fields;viewType='2';selectdate=fields[1]+'-'+parseInt(fields[2]+1)+'-'+fields[3];selectdate=(0,_common.formatDate)(new Date(selectdate.replace(new RegExp(/-/gm),"/")),"yyyy-MM-dd");this.setState({currentDate:selectdate});}else{if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))==='object'){var year=value.getYear();var month=value.getMonth()+1<10?'0'+(value.getMonth()+1):value.getMonth()+1;var currentMonth=year+'-'+month;selectdate=year+'-'+month+'-01';var _month=(0,_common.formatDate)(new Date(),"yyyy-MM");if(selectdate===_month+"-01"){this.setState({currentDate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),currentMonth:_month});}else{this.setState({currentDate:selectdate,currentMonth:year+'-'+month});}}else{selectdate=value;this.setState({currentDate:selectdate});}}_ecCom.WeaTools.callApi('/api/workplan/calendar/MyCalendar','POST',{viewType:viewType,selectDate:selectdate}).then(function(data){$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");$("#calendar_"+eid).find(".ant-fullcalendar-event").removeClass("ant-fullcalendar-event");$("#calendar_"+eid).find(".ant-fullcalendar-event-old").removeClass("ant-fullcalendar-event-old");ls.set('edata-'+eid,data);_this2.setState({data:data,refresh:false});});}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;// 异步加载日程模块静态资源
eventRegister.loadModule('f_workplan',function(){_this3.setState({weaWorkplanLoaded:true});},function(){});}},{key:'componentDidMount',value:function componentDidMount(){// $("#calendar_" + this.props.eid + " .ant-fullcalendar-cell").attr("onclick", "window_clickCalendarDay['fn"+this.props.eid+"'](this)");
this.getWorkplanData(new Date());}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.props,nextProps)){this.getWorkplanData(new Date());}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){// if(nextState.type == 'month' && this.state.type == 'year'){
//     this.setState( {type: nextState.type},() => {$("#calendar_" + this.props.eid + " .ant-fullcalendar-cell").attr("onclick", "window_clickCalendarDay['fn"+this.props.eid+"'](this)")})
// }else if(nextState.type == 'year' && this.state.type == 'month'){
//     this.setState( {type: nextState.type},() => {$("#calendar_" + this.props.eid + " .ant-fullcalendar-month-panel-cell").attr("onclick", "window_clickCalendarDay['fn"+this.props.eid+"'](this)")})
// }
if(nextState.type=='month'&&this.state.type=='year'){this.setState({type:nextState.type});}else if(nextState.type=='year'&&this.state.type=='month'){this.setState({type:nextState.type});}return true;}},{key:'doAdd',value:function doAdd(){this.setState({createVisible:true,createType:'create'});}},{key:'onClose',value:function onClose(){this.onPanelChange(this.state.currentDate);this.setState({createVisible:false,activeKey:'1'});this.getWorkplanData(this.state.currentDate);}},{key:'onClickData',value:function onClickData(id){this.setState({createVisible:true,createType:'preview',workPlanId:id});}},{key:'getWorkplanData',value:function getWorkplanData(currentDate){var _this4=this;_ecCom.WeaTools.callApi('/api/workplan/calendar/MyCalendar','POST',{viewType:'1',isCalendar:0,ismobile:1,selectDate:(0,_common.formatDate)(new Date(currentDate),"yyyy-MM-dd")}).then(function(data){_this4.setState({workplanData:data});});}},{key:'render',value:function render(){var _this5=this;var _props2=this.props,eid=_props2.eid,layoutid=_props2.layoutid,_props2$isShowLunarDa=_props2.isShowLunarDatas,isShowLunarDatas=_props2$isShowLunarDa===undefined?'0':_props2$isShowLunarDa;var className="";if(isShowLunarDatas=='1'){className="calendar_Lunar";}var _state=this.state,weaWorkplanLoaded=_state.weaWorkplanLoaded,type=_state.type,createVisible=_state.createVisible,createType=_state.createType,currentDate=_state.currentDate,workPlanId=_state.workPlanId,activeKey=_state.activeKey,data=_state.data,workplanData=_state.workplanData;var createConditionParams=['','',currentDate,(0,_common.formatDate)(new Date(),"hh:mm"),currentDate,'23:59','0'];return _react2.default.createElement('div',{id:'calendar_'+eid,className:className},_react2.default.createElement(_antd.Calendar,{showWeek:true,onSelect:this.clickCalendarDay,fullscreen:false,onPanelChange:this.onPanelChange.bind(this),monthCellRender:function monthCellRender(value){return _this5.monthCellRender(eid,value);},value:new Date(currentDate),dateCellRender:this.dateCellRender.bind(this,eid,this.props.data)}),_react2.default.createElement(CalendarData,{workplanData:workplanData,data:data,type:type,currentDate:currentDate,handleClick:this.onClickData}),_react2.default.createElement('div',{className:'portal-element-calender-add'},_react2.default.createElement(_antd.Icon,{type:'plus-circle-o',title:getLabel(611,'添加'),onClick:this.doAdd})),weaWorkplanLoaded&&window.weaWorkplan&&window.weaWorkplan.com?_react2.default.createElement(window.weaWorkplan.com.WorkPlanCreate,{isCustom:parseInt(layoutid)>5,type:createType//新建为'create',查看为'preview',编辑edit,共享share
,visible:createVisible//显隐受控
,doClose:this.onClose//关闭回调
,onlyClose:function onlyClose(){return _this5.setState({createVisible:false,activeKey:'1'});}//关闭回调
,workPlanId:workPlanId//日程id，查看日程时用到
,createConditionParams:createConditionParams//创建的默认值日期和时间,没有传[]
,activeKey:activeKey//查看页面显示的面板1是基本信息，7是相关交流
,changeTab:function changeTab(value){return _this5.setState({activeKey:value});}//查看页面切换面板的回调
,selectUser:''//新建日程的创建人id
}):'');}},{key:'dateCellRender',value:function dateCellRender(eid,data,value){var _props$isShowLunarDat=this.props.isShowLunarDatas,isShowLunarDatas=_props$isShowLunarDat===undefined?'0':_props$isShowLunarDat;var currentDate=this.state.currentDate;var portalNoCurrentMonth="";if((0,_common.formatDate)(new Date(value.time),'yyyy-MM')!=(0,_common.formatDate)(new Date(currentDate),'yyyy-MM')){portalNoCurrentMonth="portal-no-current-month";}var dataStr1=(0,_common.formatDate)(new Date(value.time),'yyyy-M-d');var dateStr=(0,_common.formatDate)(new Date(value.time),'yyyy-MM-dd');var lunarStr=(0,_util.getLunarDatas)().toLunar((0,_common.formatDate)(new Date(value.time),'yyyy'),(0,_common.formatDate)(new Date(value.time),'M'),(0,_common.formatDate)(new Date(value.time),'d'));// let dataStr2 = formatDate(new Date(lunarStr[0] + '-' + lunarStr[1] + '-' +lunarStr[2]), 'MM') + formatDate(new Date(lunarStr[0] + '-' + lunarStr[1] + '-' +lunarStr[2]), 'dd');
var dataStr2=(0,_util.getLunarDatas)().toLunarMonth(lunarStr.lunarMonth)+(0,_util.getLunarDatas)().toLunarNumber(lunarStr.lunarDay);var dataStr3=(0,_common.formatDate)(new Date(value.time),'MM')+(0,_common.formatDate)(new Date(value.time),'dd');var lunarDatas=lunarStr.lunarDay;if(lunarDatas=='初一'){lunarDatas=lunarStr.lunarMonth+'月';}var jq=(0,_util.getLunarDatas)().getjq((0,_common.formatDate)(new Date(value.time),'yyyy'),(0,_common.formatDate)(new Date(value.time),'MM'),(0,_common.formatDate)(new Date(value.time),'dd'));if(jq!=''){lunarDatas=jq;}if((0,_util.getLunarDatas)().holidayName((0,_common.formatDate)(new Date(value.time),'yyyy'),dataStr2,dataStr3)!==undefined){lunarDatas=(0,_util.getLunarDatas)().holidayName((0,_common.formatDate)(new Date(value.time),'yyyy'),dataStr2,dataStr3);}var events=this.state.data.events;var timer=setTimeout(function(){events&&events.map(function(arr){var startDate=(0,_common.formatDate)(new Date(arr[2]),'yyyy-MM-dd');var endDate=(0,_common.formatDate)(new Date(arr[3]),'yyyy-MM-dd');if(dateStr>=startDate&&dateStr<=endDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-event");}});if(dateStr===currentDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-current");}clearTimeout(timer);},100);if(isShowLunarDatas!='0'){return _react2.default.createElement('div',{className:'portal-element-calender-lunar '+portalNoCurrentMonth},lunarDatas);}}},{key:'monthCellRender',value:function monthCellRender(eid){$("#calendar_"+eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}},{key:'clickCalendarDay',value:function clickCalendarDay(obj){var eid=this.props.eid;var _state2=this.state,currentDate=_state2.currentDate,currentMonth=_state2.currentMonth,type=_state2.type;if(type=='year'){this.clickCalendarMonth(obj);return;}$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");var title=(0,_common.formatDate)(new Date(obj.time),"yyyy-MM-dd");var ndate="";var currentMonthStr="";if(title){var titlearr=title.split("-");ndate=titlearr[0];currentMonthStr=titlearr[0];ndate=ndate+"-"+titlearr[1];currentMonthStr=currentMonthStr+"-"+titlearr[1];ndate=ndate+"-"+titlearr[2];}if(ndate){this.setState({currentDate:ndate});}this.getWorkplanData(ndate);//判断点击的是否为当前显示月份，否的话刷新新月份的日历日程，并默认选中所点击的日期
if(currentMonthStr!==currentMonth){this.setState({currentMonth:currentMonthStr});this.onPanelChange(ndate,"month");}}},{key:'clickCalendarMonth',value:function clickCalendarMonth(obj){var _this6=this;var eid=this.props.eid;var selectYear=this.state.selectYear;var dateStr=(0,_common.formatDate)(new Date(),'MM');var date=(0,_common.formatDate)(new Date(obj.time),"MM");var _state3=this.state,currentDate=_state3.currentDate,currentMonth=_state3.currentMonth;var monthMatch={"01":getLabel("25825","1月"),"02":getLabel("25826","2月"),"03":getLabel("25827","3月"),"04":getLabel("25828","4月"),"05":getLabel("25829","5月"),"06":getLabel("25830","6月"),"07":getLabel("25831","7月"),"08":getLabel("25832","8月"),"09":getLabel("25833","9月"),"10":getLabel("25834","10月"),"11":getLabel("25835","11月"),"12":getLabel("25836","12月")};var x=Math.ceil(dateStr/3);var y=dateStr-(x-1)*3;var a=Math.ceil(date/3);var b=date-(a-1)*3;if(monthMatch[dateStr].trim()!==date+'月'){// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").addClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).addClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[a-1].children[b-1]).find('div')[0]).find(".ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}else{$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});// $("#calendar_" + eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).removeClass("ant-fullcalendar-month-panel-current-cell");// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").removeClass("ant-fullcalendar-month-panel-current-cell");
$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}var selectMonth='';for(var key in monthMatch){if(monthMatch[key]==date+'月'){selectMonth=key;break;}}var firstDay=(0,_common.formatDate)(new Date(selectYear,selectMonth-1,1),"yyyy-MM-dd");//这个月的第一天
_ecCom.WeaTools.callApi('/api/workplan/calendar/MyCalendar','POST',{viewType:'3',selectDate:firstDay}).then(function(data){ls.set('edata-'+eid,data);_this6.setState({data:data,refresh:false});});}}]);return CalendarTemplate;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CalendarTemplate=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CalendarTemplate);exports.default=CalendarTemplate;var CalendarData=function(_React$Component3){(0,_inherits3.default)(CalendarData,_React$Component3);function CalendarData(){(0,_classCallCheck3.default)(this,CalendarData);return(0,_possibleConstructorReturn3.default)(this,(CalendarData.__proto__||(0,_getPrototypeOf2.default)(CalendarData)).apply(this,arguments));}(0,_createClass3.default)(CalendarData,[{key:'tc',value:function tc(d){function zc(c,i){var d="666666888888aaaaaabbbbbbdddddda32929cc3333d96666e69999f0c2c2b1365fdd4477e67399eea2bbf5c7d67a367a994499b373b3cca2cce1c7e15229a36633cc8c66d9b399e6d1c2f029527a336699668cb399b3ccc2d1e12952a33366cc668cd999b3e6c2d1f01b887a22aa9959bfb391d5ccbde6e128754e32926265ad8999c9b1c2dfd00d78131096184cb05288cb8cb8e0ba52880066aa008cbf40b3d580d1e6b388880eaaaa11bfbf4dd5d588e6e6b8ab8b00d6ae00e0c240ebd780f3e7b3be6d00ee8800f2a640f7c480fadcb3b1440edd5511e6804deeaa88f5ccb8865a5aa87070be9494d4b8b8e5d4d47057708c6d8ca992a9c6b6c6ddd3dd4e5d6c6274878997a5b1bac3d0d6db5a69867083a894a2beb8c1d4d4dae54a716c5c8d8785aaa5aec6c3cedddb6e6e41898951a7a77dc4c4a8dcdccb8d6f47b08b59c4a883d8c5ace7dcce";return"#"+d.substring(c*30+i*6,c*30+(i+1)*6);}var c=d!=null&&d!=undefined?d:option.theme;return[zc(c,0),zc(c,1),zc(c,2),zc(c,3)];}},{key:'render',value:function render(){var _this9=this;var _props3=this.props,data=_props3.data,currentDate=_props3.currentDate,handleClick=_props3.handleClick,eid=_props3.eid,_props3$type=_props3.type,type=_props3$type===undefined?'month':_props3$type,workplanData=_props3.workplanData;var mobileEvents=workplanData.mobileEvents,start=workplanData.start;var events=data.events;var index=0;var color='#a32929';if(mobileEvents&&mobileEvents.length){if(type=='month'){var datas=[];var html=mobileEvents.map(function(arr){if(arr[7])color=arr[7];if(arr.color)color=arr.color;// let sdate = new Date(arr[2]);
// let edate = new Date(arr[3]);
var startStr=(0,_common.formatDate)(new Date(arr.beginDate),"yyyy-MM-dd");var endStr=(0,_common.formatDate)(new Date(arr.endDate),"yyyy-MM-dd");var id=arr.id;var name=arr.planName;var stime=arr.beginTime;var ss="";if(!isNaN(parseInt(stime))){ss=parseInt(stime)>=12?'PM':'AM';}if(currentDate>=startStr&&currentDate<=endStr){index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this9,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:color}}),_react2.default.createElement('div',{className:'dataEvent2'},_react2.default.createElement('div',{className:'dataEvent2_1'},stime,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));}});var height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html))));}else{var hasEvent=false;var _html=mobileEvents.map(function(arr){var sdate=new Date(arr.beginDate);var mdata=(0,_common.formatDate)(sdate,'MM-dd  hh:mm');var ss=parseInt((0,_common.formatDate)(sdate,'hh'))>=12?'PM':'AM';var id=arr.id;var name=arr.planName;if(arr.color)color=arr.color;hasEvent=true;index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this9,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:color}}),_react2.default.createElement('div',{className:'dataEvent2',style:{width:'111px'}},_react2.default.createElement('div',{className:'dataEvent2_1'},mdata,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));});var _height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html))));}}return _react2.default.createElement('div',null);}}]);return CalendarData;}(_react2.default.Component);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//获取当前时间戳(以s为单位)
var getLunarDatas=function getLunarDatas(){var _Lunar;//公历节日
var sFtv=new Array("0101 元旦","0214 情人节","0308 妇女节","0315 消费者日","0312 植树节","0401 愚人节","0501 劳动节","0504 青年节","0512 护士节","0601 儿童节","0701 建党节","0801 建军节","0910 教师节","1001 国庆节","1224 平安夜","1225 圣诞节");//农历节日
var lFtv=new Array("0101 春节","0202 龙抬头","0115 元宵节","0505 端午节","0624 火把节","0707 七夕","0715 中元节","0815 中秋节","0909 重阳","1208 腊八","1223 北方小年","1224 南方小年");var solarMonth=new Array(31,28,31,30,31,30,31,31,30,31,30,31);var lunarYearArr=[0x0b557,//1949
0x06ca0,0x0b550,0x15355,0x04da0,0x0a5b0,0x14573,0x052b0,0x0a9a8,0x0e950,0x06aa0,//1950-1959
0x0aea6,0x0ab50,0x04b60,0x0aae4,0x0a570,0x05260,0x0f263,0x0d950,0x05b57,0x056a0,//1960-1969
0x096d0,0x04dd5,0x04ad0,0x0a4d0,0x0d4d4,0x0d250,0x0d558,0x0b540,0x0b6a0,0x195a6,//1970-1979
0x095b0,0x049b0,0x0a974,0x0a4b0,0x0b27a,0x06a50,0x06d40,0x0af46,0x0ab60,0x09570,//1980-1989
0x04af5,0x04970,0x064b0,0x074a3,0x0ea50,0x06b58,0x055c0,0x0ab60,0x096d5,0x092e0,//1990-1999
0x0c960,0x0d954,0x0d4a0,0x0da50,0x07552,0x056a0,0x0abb7,0x025d0,0x092d0,0x0cab5,//2000-2009
0x0a950,0x0b4a0,0x0baa4,0x0ad50,0x055d9,0x04ba0,0x0a5b0,0x15176,0x052b0,0x0a930,//2010-2019
0x07954,0x06aa0,0x0ad50,0x05b52,0x04b60,0x0a6e6,0x0a4e0,0x0d260,0x0ea65,0x0d530,//2020-2029
0x05aa0,0x076a3,0x096d0,0x04afb,0x04ad0,0x0a4d0,0x1d0b6,0x0d250,0x0d520,0x0dd45,//2030-2039
0x0b5a0,0x056d0,0x055b2,0x049b0,0x0a577,0x0a4b0,0x0aa50,0x1b255,0x06d20,0x0ada0,//2040-2049
0x14b63,0x09370,0x049f8,0x04970,0x064b0,0x168a6,0x0ea50,0x06b20,0x1a6c4,0x0aae0,//2050-2059
0x0a2e0,0x0d2e3,0x0c960,0x0d557,0x0d4a0,0x0da50,0x05d55,0x056a0,0x0a6d0,0x055d4,//2060-2069
0x052d0,0x0a9b8,0x0a950,0x0b4a0,0x0b6a6,0x0ad50,0x055a0,0x0aba4,0x0a5b0,0x052b0,//2070-2079
0x0b273,0x06930,0x07337,0x06aa0,0x0ad50,0x14b55,0x04b60,0x0a570,0x054e4,0x0d160,//2080-2089
0x0e968,0x0d520,0x0daa0,0x16aa6,0x056d0,0x04ae0,0x0a9d4,0x0a2d0,0x0d150,0x0f252,//2090-2099
0x0d520//2100
],lunarMonth=['正','二','三','四','五','六','七','八','九','十','冬','腊'],lunarDay=['一','二','三','四','五','六','七','八','九','十','初','廿'],tianGan=['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'],diZhi=['子','丑','寅','卯','辰','巳','午','未','申','酉','戌','亥'];var MIN_YEAR=1891;var MAX_YEAR=2100;var lunarInfo=[[0,2,9,21936],[6,1,30,9656],[0,2,17,9584],[0,2,6,21168],[5,1,26,43344],[0,2,13,59728],[0,2,2,27296],[3,1,22,44368],[0,2,10,43856],[8,1,30,19304],[0,2,19,19168],[0,2,8,42352],[5,1,29,21096],[0,2,16,53856],[0,2,4,55632],[4,1,25,27304],[0,2,13,22176],[0,2,2,39632],[2,1,22,19176],[0,2,10,19168],[6,1,30,42200],[0,2,18,42192],[0,2,6,53840],[5,1,26,54568],[0,2,14,46400],[0,2,3,54944],[2,1,23,38608],[0,2,11,38320],[7,2,1,18872],[0,2,20,18800],[0,2,8,42160],[5,1,28,45656],[0,2,16,27216],[0,2,5,27968],[4,1,24,44456],[0,2,13,11104],[0,2,2,38256],[2,1,23,18808],[0,2,10,18800],[6,1,30,25776],[0,2,17,54432],[0,2,6,59984],[5,1,26,27976],[0,2,14,23248],[0,2,4,11104],[3,1,24,37744],[0,2,11,37600],[7,1,31,51560],[0,2,19,51536],[0,2,8,54432],[6,1,27,55888],[0,2,15,46416],[0,2,5,22176],[4,1,25,43736],[0,2,13,9680],[0,2,2,37584],[2,1,22,51544],[0,2,10,43344],[7,1,29,46248],[0,2,17,27808],[0,2,6,46416],[5,1,27,21928],[0,2,14,19872],[0,2,3,42416],[3,1,24,21176],[0,2,12,21168],[8,1,31,43344],[0,2,18,59728],[0,2,8,27296],[6,1,28,44368],[0,2,15,43856],[0,2,5,19296],[4,1,25,42352],[0,2,13,42352],[0,2,2,21088],[3,1,21,59696],[0,2,9,55632],[7,1,30,23208],[0,2,17,22176],[0,2,6,38608],[5,1,27,19176],[0,2,15,19152],[0,2,3,42192],[4,1,23,53864],[0,2,11,53840],[8,1,31,54568],[0,2,18,46400],[0,2,7,46752],[6,1,28,38608],[0,2,16,38320],[0,2,5,18864],[4,1,25,42168],[0,2,13,42160],[10,2,2,45656],[0,2,20,27216],[0,2,9,27968],[6,1,29,44448],[0,2,17,43872],[0,2,6,38256],[5,1,27,18808],[0,2,15,18800],[0,2,4,25776],[3,1,23,27216],[0,2,10,59984],[8,1,31,27432],[0,2,19,23232],[0,2,7,43872],[5,1,28,37736],[0,2,16,37600],[0,2,5,51552],[4,1,24,54440],[0,2,12,54432],[0,2,1,55888],[2,1,22,23208],[0,2,9,22176],[7,1,29,43736],[0,2,18,9680],[0,2,7,37584],[5,1,26,51544],[0,2,14,43344],[0,2,3,46240],[4,1,23,46416],[0,2,10,44368],[9,1,31,21928],[0,2,19,19360],[0,2,8,42416],[6,1,28,21176],[0,2,16,21168],[0,2,5,43312],[4,1,25,29864],[0,2,12,27296],[0,2,1,44368],[2,1,22,19880],[0,2,10,19296],[6,1,29,42352],[0,2,17,42208],[0,2,6,53856],[5,1,26,59696],[0,2,13,54576],[0,2,3,23200],[3,1,23,27472],[0,2,11,38608],[11,1,31,19176],[0,2,19,19152],[0,2,8,42192],[6,1,28,53848],[0,2,15,53840],[0,2,4,54560],[5,1,24,55968],[0,2,12,46496],[0,2,1,22224],[2,1,22,19160],[0,2,10,18864],[7,1,30,42168],[0,2,17,42160],[0,2,6,43600],[5,1,26,46376],[0,2,14,27936],[0,2,2,44448],[3,1,23,21936],[0,2,11,37744],[8,2,1,18808],[0,2,19,18800],[0,2,8,25776],[6,1,28,27216],[0,2,15,59984],[0,2,4,27424],[4,1,24,43872],[0,2,12,43744],[0,2,2,37600],[3,1,21,51568],[0,2,9,51552],[7,1,29,54440],[0,2,17,54432],[0,2,5,55888],[5,1,26,23208],[0,2,14,22176],[0,2,3,42704],[4,1,23,21224],[0,2,11,21200],[8,1,31,43352],[0,2,19,43344],[0,2,7,46240],[6,1,27,46416],[0,2,15,44368],[0,2,5,21920],[4,1,24,42448],[0,2,12,42416],[0,2,2,21168],[3,1,22,43320],[0,2,9,26928],[7,1,29,29336],[0,2,17,27296],[0,2,6,44368],[5,1,26,19880],[0,2,14,19296],[0,2,3,42352],[4,1,24,21104],[0,2,10,53856],[8,1,30,59696],[0,2,18,54560],[0,2,7,55968],[6,1,27,27472],[0,2,15,22224],[0,2,5,19168],[4,1,25,42216],[0,2,12,42192],[0,2,1,53584],[2,1,21,55592],[0,2,9,54560]];var Lunar=(_Lunar={//是否闰年
isLeapYear:function isLeapYear(year){return year%4==0&&year%100!=0||year%400==0;},//天干地支年
lunarYear:function lunarYear(year){var gan=['庚','辛','壬','癸','甲','乙','丙','丁','戊','己'],zhi=['申','酉','戌','亥','子','丑','寅','卯','辰','巳','午','未'],str=year.toString().split("");return gan[str[3]]+zhi[year%12];},//生肖年
zodiacYear:function zodiacYear(year){var zodiac=['猴','鸡','狗','猪','鼠','牛','虎','兔','龙','蛇','马','羊'];return zodiac[year%12];},//公历月份天数
//@param year 阳历-年
//@param month 阳历-月
solarMonthDays:function solarMonthDays(year,month){var FebDays=this.isLeapYear(year)?29:28;var monthHash=['',31,FebDays,31,30,31,30,31,31,30,31,30,31];return monthHash[month];},//农历月份天数
lunarMonthDays:function lunarMonthDays(year,month){var monthData=this.lunarMonths(year);return monthData[month-1];},//农历月份天数数组
lunarMonths:function lunarMonths(year){var yearData=this.lunarInfo[year-MIN_YEAR];var leapMonth=yearData[0];var bit=(+yearData[3]).toString(2);var months=[];for(var i=0;i<bit.length;i++){months[i]=bit.substr(i,1);}for(var k=0,len=16-months.length;k<len;k++){months.unshift('0');}months=months.slice(0,leapMonth==0?12:13);for(var i=0;i<months.length;i++){months[i]=+months[i]+29;}return months;},//农历每年的天数
//@param year 农历年份
// lunarYearDays : function(year) {
//     var monthArray = this.lunarYearMonths(year);
//     var len = monthArray.length;
//     return (monthArray[len-1] == 0 ? monthArray[len-2] : monthArray[len-1]);
// },
//
lunarYearMonths:function lunarYearMonths(year){var monthData=this.lunarMonths(year);var res=[];var temp=0;var yearData=lunarInfo[year-MIN_YEAR];var len=yearData[0]==0?12:13;for(var i=0;i<len;i++){temp=0;for(var j=0;j<=i;j++){temp+=monthData[j];}res.push(temp);}return res;},//获取闰月
//@param year 农历年份
leapMonth:function leapMonth(year){var yearData=lunarInfo[year-MIN_YEAR];return yearData[0];},//计算农历日期与正月初一相隔的天数
betweenLunarDays:function betweenLunarDays(year,month,day){var yearMonth=this.lunarMonths(year);var res=0;for(var i=1;i<month;i++){res+=yearMonth[i-1];}res+=day-1;return res;},//计算2个阳历日期之间的天数
//@param year 阳历年
//@param month
//@param day
//@param l_month 阴历正月对应的阳历月份
//@param l_day   阴历初一对应的阳历天
betweenSolarDays:function betweenSolarDays(year,month,day,l_month,l_day){var time1=new Date(year+"-"+month+"-"+day).getTime(),time2=new Date(year+"-"+l_month+"-"+l_day).getTime();return Math.ceil((time1-time2)/24/3600/1000);},//根据距离正月初一的天数计算阴历日期
//@param year 阳历年
//@param between 天数
lunarByBetween:function lunarByBetween(year,between){var lunarArray=[],yearMonth=[],t=0,e=0,leapMonth=0,m='';if(between==0){t=1;e=1;m='正月';}else{year=between>0?year:year-1;yearMonth=this.lunarYearMonths(year);leapMonth=this.leapMonth(year);between=between>0?between:this.lunarYearDays(year)+between;for(var i=0;i<13;i++){if(between==yearMonth[i]){t=i+2;e=1;break;}else if(between<yearMonth[i]){t=i+1;e=between-(yearMonth[i-1]?yearMonth[i-1]:0)+1;break;}}m=leapMonth!=0&&t==leapMonth+1?'闰'.this.chineseMonth(t-1):this.chineseMonth(leapMonth!=0&&leapMonth+1<t?t-1:t);}lunarArray.push(year,t,e);//年 月 日
lunarArray.push(this.lunarYear(year),this.zodiacYear(year),m,this.chineseNumber(e));//天干地支年 生肖年 月份 日
lunarArray.push(leapMonth);//闰几月
return lunarArray;},//中文月份
chineseMonth:function chineseMonth(month){var monthHash=['','正月','二月','三月','四月','五月','六月','七月','八月','九月','十月','冬月','腊月'];return monthHash[month];},//中文月份转普通月份
toLunarMonth:function toLunarMonth(month){var monthHash={"正":'01',"二":'02',"三":'03',"四":'04',"五":'05',"六":'06',"七":'07',"八":'08',"九":'09',"十":'10',"冬":'11',"腊":'12'// var monthHash = ['', '正月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '冬月', '腊月'];
};return monthHash[month];},//中文日期
chineseNumber:function chineseNumber(num){var dateHash=['','一','二','三','四','五','六','七','八','九','十'];var res="";if(num<=10){res='初'+dateHash[num];}else if(num>10&&num<20){res='十'+dateHash[num-10];}else if(num==20){res="二十";}else if(num>20&&num<30){res="廿"+dateHash[num-20];}else if(num==30){res="三十";}return res;},//中文日期转普通日期
toLunarNumber:function toLunarNumber(num){// var dateHash = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
var dateHash={'一':1,'二':2,'三':3,'四':4,'五':5,'六':6,'七':7,'八':8,'九':9,'十':0};var res="";if(num=='二十'||num=='三十'){if(num=='二十'){res='20';}else if(num=='三十'){res='30';}}else if(num.toString().indexOf("初")!=-1){var number=num.slice(num.indexOf("初")+1);res='0'+dateHash[number];if(num=='初十'){res='10';}}else if(num.toString().indexOf("廿")!=-1){var _number=num.slice(num.indexOf("廿")+1);res='2'+dateHash[_number];}else if(num.toString().indexOf("十")!=-1){var _number2=num.slice(num.indexOf("十")+1);res='1'+dateHash[_number2];}return res;},//转换农历
toLunar:function toLunar(sy,sm,sd){// 输入的月份减1处理
sm-=1;// 计算与公历基准的相差天数
// Date.UTC()返回的是距离公历1970年1月1日的毫秒数,传入的月份需要减1
var daySpan=(Date.UTC(sy,sm,sd)-Date.UTC(1949,0,29))/(24*60*60*1000)+1;var ly=void 0,lm=void 0,ld=void 0;// 确定输出的农历年份
for(var j=0;j<lunarYearArr.length;j++){daySpan-=this.lunarYearDays(lunarYearArr[j]);if(daySpan<=0){ly=1949+j;// 获取农历年份确定后的剩余天数
daySpan+=this.lunarYearDays(lunarYearArr[j]);break;}}// 确定输出的农历月份
for(var k=0;k<this.lunarYearMonths(lunarYearArr[ly-1949]).length;k++){daySpan-=this.lunarYearMonths(lunarYearArr[ly-1949])[k];if(daySpan<=0){// 有闰月时，月份的数组长度会变成13，因此，当闰月月份小于等于k时，lm不需要加1
if(this.hasLeapMonth(lunarYearArr[ly-1949])&&this.hasLeapMonth(lunarYearArr[ly-1949])<=k){if(this.hasLeapMonth(lunarYearArr[ly-1949])<k){lm=k;}else if(this.hasLeapMonth(lunarYearArr[ly-1949])===k){lm='闰'+k;}else{lm=k+1;}}else{lm=k+1;}// 获取农历月份确定后的剩余天数
daySpan+=this.lunarYearMonths(lunarYearArr[ly-1949])[k];break;}}// 确定输出农历哪一天
ld=daySpan;// 将计算出来的农历月份转换成汉字月份，闰月需要在前面加上闰字
if(this.hasLeapMonth(lunarYearArr[ly-1949])&&typeof lm==='string'&&lm.indexOf('闰')>-1){lm="\u95F0"+lunarMonth[/\d/.exec(lm)-1];}else{lm=lunarMonth[lm-1];}// 将计算出来的农历年份转换为天干地支年
ly=this.getTianGan(ly)+this.getDiZhi(ly);// 将计算出来的农历天数转换成汉字
if(ld<11){ld=""+lunarDay[10]+lunarDay[ld-1];}else if(ld>10&&ld<20){ld=""+lunarDay[9]+lunarDay[ld-11];}else if(ld===20){ld=""+lunarDay[1]+lunarDay[9];}else if(ld>20&&ld<30){ld=""+lunarDay[11]+lunarDay[ld-21];}else if(ld===30){ld=""+lunarDay[2]+lunarDay[9];}return{lunarYear:ly,lunarMonth:lm,lunarDay:ld};},//转换公历
//@param year  阴历-年
//@param month 阴历-月，闰月处理：例如如果当年闰五月，那么第二个五月就传六月，相当于阴历有13个月
//@param date  阴历-日
toSolar:function toSolar(year,month,day){var yearData=lunarInfo[year-MIN_YEAR];var between=this.betweenLunarDays(year,month,day);var ms=new Date(year+"-"+yearData[1]+"-"+yearData[2]).getTime();var s=ms+between*24*60*60*1000;var d=new Date();d.setTime(s);year=d.getFullYear();month=d.getMonth()+1;day=d.getDate();return[year,month,day];},//ndate:农历日期；
//gdate:公历日期
holidayName:function holidayName(year,ndate,gdate){for(var ipp=0;ipp<lFtv.length;ipp++){//农历节日
if(lFtv[ipp].substr(0,4)==ndate){return lFtv[ipp].substr(5);}if(12==ndate.substr(0,2)){//判断是否为除夕
var date=this.lunarYearMonths(year)[11];if(date==ndate.substr(2,2))return"除夕";}}for(var ipp=0;ipp<sFtv.length;ipp++){//公历节日
if(sFtv[ipp].substr(0,4)==gdate){return sFtv[ipp].substr(5);}}},getjq:function getjq(yyyy,mm,dd){mm=mm-1;var sTermInfo=new Array(0,21208,42467,63836,85337,107014,128867,150921,173149,195551,218072,240693,263343,285989,308563,331033,353350,375494,397447,419210,440795,462224,483532,504758);var solarTerm=new Array("小寒","大寒","立春","雨水","惊蛰","春分","清明","谷雨","立夏","小满","芒种","夏至","小暑","大暑","立秋","处暑","白露","秋分","寒露","霜降","立冬","小雪","大雪","冬至");var solarTerms="";//此方法是获取该日期是否为某节气
var tmp1=new Date(31556925974.7*(yyyy-1900)+sTermInfo[mm*2+1]*60000+Date.UTC(1900,0,6,2,5));var tmp2=tmp1.getUTCDate();if(tmp2==dd)solarTerms=solarTerm[mm*2+1];tmp1=new Date(31556925974.7*(yyyy-1900)+sTermInfo[mm*2]*60000+Date.UTC(1900,0,6,2,5));tmp2=tmp1.getUTCDate();if(tmp2==dd)solarTerms=solarTerm[mm*2];// //　　此方法可以获取该日期处于某节气
// while (solarTerms==""){
//     var tmp1 = new Date((31556925974.7*(yyyy-1900)+sTermInfo[mm*2+1]*60000)+Date.UTC(1900,0,6,2,5));
//     var tmp2 = tmp1.getUTCDate();
//     if (tmp2==dd) solarTerms = solarTerm[mm*2+1];
//     tmp1 = new Date((31556925974.7*(yyyy-1900)+sTermInfo[mm*2]*60000)+Date.UTC(1900,0,6,2,5));
//     tmp2= tmp1.getUTCDate(); if (tmp2==dd) solarTerms = solarTerm[mm*2];
//     console.log(dd)
//     if(dd>1){
//         dd=dd-1;
//     }else {
//         mm=mm-1;
//         if(mm<0){
//             yyyy=yyyy-1; mm=11;
//         }
//         dd=31;
//     }
// }
return solarTerms;},// 如果有闰月，计算农历闰月天数，参数为存储农历年的16进制
// 农历年份信息用16进制存储，其中16进制的第1位（0x除外）可以用于表示闰月是大月还是小月
leapMonthDays:function leapMonthDays(ly){if(this.hasLeapMonth(ly)){// 获取16进制的第1位（0x除外）
return ly&0xf0000?30:29;}else{return 0;}},// 计算农历一年的总天数，参数为存储农历年的16进制
// 农历年份信息用16进制存储，其中16进制的第2-4位（0x除外）可以用于表示正常月是大月还是小月
lunarYearDays:function lunarYearDays(ly){var totalDays=0;// 获取正常月的天数，并累加
// 获取16进制的第2-4位，需要用到>>移位运算符
for(var i=0x8000;i>0x8;i>>=1){var monthDays=ly&i?30:29;totalDays+=monthDays;}// 如果有闰月，需要把闰月的天数加上
if(this.hasLeapMonth(ly)){totalDays+=this.leapMonthDays(ly);}return totalDays;}},(0,_defineProperty3.default)(_Lunar,"lunarYearMonths",function lunarYearMonths(ly){var monthArr=[];// 获取正常月的天数，并添加到monthArr数组中
// 获取16进制的第2-4位，需要用到>>移位运算符
for(var i=0x8000;i>0x8;i>>=1){monthArr.push(ly&i?30:29);}// 如果有闰月，需要把闰月的天数加上
if(this.hasLeapMonth(ly)){monthArr.splice(this.hasLeapMonth(ly),0,this.leapMonthDays(ly));}return monthArr;}),(0,_defineProperty3.default)(_Lunar,"getTianGan",function getTianGan(ly){var tianGanKey=(ly-3)%10;if(tianGanKey===0)tianGanKey=10;return tianGan[tianGanKey-1];}),(0,_defineProperty3.default)(_Lunar,"getDiZhi",function getDiZhi(ly){var diZhiKey=(ly-3)%12;if(diZhiKey===0)diZhiKey=12;return diZhi[diZhiKey-1];}),(0,_defineProperty3.default)(_Lunar,"hasLeapMonth",function hasLeapMonth(ly){// 获取16进制的最后1位，需要用到&与运算符
if(ly&0xf){return ly&0xf;}else{return false;}}),_Lunar);return Lunar;};module.exports={getLunarDatas:getLunarDatas};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(476);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Rss=function(_React$Component){(0,_inherits3.default)(Rss,_React$Component);function Rss(props){(0,_classCallCheck3.default)(this,Rss);var _this=(0,_possibleConstructorReturn3.default)(this,(Rss.__proto__||(0,_getPrototypeOf2.default)(Rss)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Rss,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/rss','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);window.elements_more_params[eid]={isRouteUrl:true,tabid:result.currenttab||''};_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Rss;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Rss=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Rss);exports.default=Rss;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(477);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/rsstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});window.elements_more_params[params.eid]={isRouteUrl:true,tabid:tabid};if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _tabdata$dataColoums=tabdata.dataColoums,dataColoums=_tabdata$dataColoums===undefined?[]:_tabdata$dataColoums;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;esetting.dataColoums=dataColoums;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);if(tabdata){if(tabdata.data&&tabdata.data.length){contentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.data[0],esetting),showHeader:esetting.showHeader=='1',pagination:false,dataSource:tabdata.data,size:'small'});}else{contentHtml=_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,' ',_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));}var tabsetting=tabdata.tabsetting;var isIE=tabsetting.isIE,readType=tabsetting.readType,mess=tabsetting.mess;if(readType=='1'&&isIE!='true')contentHtml=_react2.default.createElement('div',null,'\xA0\xA0',mess);}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(479);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//元素组件
var CustomPage=function(_React$Component){(0,_inherits3.default)(CustomPage,_React$Component);function CustomPage(props){(0,_classCallCheck3.default)(this,CustomPage);var _this=(0,_possibleConstructorReturn3.default)(this,(CustomPage.__proto__||(0,_getPrototypeOf2.default)(CustomPage)).call(this,props));_this.state={edata:null};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(CustomPage,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});}},{key:'handleRefresh',value:function handleRefresh(){this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;if(this.refs.econtent){this.refs.econtent.handleRefresh(true);}_ecCom.WeaTools.callApi(api||'/api/portal/element/custompage','POST',(0,_extends3.default)({},params)).then(function(result){if(_this2.refs.econtent){_this2.refs.econtent.handleRefresh(false);}if(result.data){window.elements_more_params[eid]={isRouteUrl:true,moreurl:result.data.moreUrl};}if(!(0,_lodash.isEqual)(_this2.state.edata,result)){_this2.setState({edata:result});}});}},{key:'componentWillMount',value:function componentWillMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;if(!config.islsdata){this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,_item$contentview=item.contentview,contentview=_item$contentview===undefined?{}:_item$contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){var requestid='-1';if(edata.params&&edata.params.requestid){requestid=edata.params.requestid;}if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{ref:'econtent',onRef:this.onRef,requestid:requestid,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},EContentHtml),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return CustomPage;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomPage=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomPage);exports.default=CustomPage;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(480);var _Title2=_interopRequireDefault(_Title);var _Iframe=__webpack_require__(481);var _Iframe2=_interopRequireDefault(_Iframe);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'handleRefresh',value:function handleRefresh(refresh){this.setState({refresh:refresh});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.props.edata,nextProps.edata)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({currentTab:tabid,refresh:true});_ecCom.WeaTools.callApi('/api/portal/element/custompagetab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});window.elements_more_params[params.eid]={moreurl:result.moreUrl};}});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,requestid=_props.requestid,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _edata$tabids=edata.tabids,tabids=_edata$tabids===undefined?[]:_edata$tabids,_edata$titles=edata.titles,titles=_edata$titles===undefined?[]:_edata$titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);if(tabdata){var contenttype=tabdata.contenttype,componentName=tabdata.componentName;if(contenttype=='1'){contentHtml=_react2.default.createElement(_Iframe2.default,{isSetting:config.isSetting,config:config,requestid:requestid,refresh:refresh,data:tabdata,eid:eid,tabid:currentTab,cstyle:contentview.style});}else if(contenttype=='2'&&componentName){try{var componentModule=tabdata.componentModule,componentProps=tabdata.componentProps;if(componentModule){contentHtml=_react2.default.createElement('div',null,window[componentModule][componentName](componentProps));}else{contentHtml=_react2.default.createElement('div',null,window[componentName](componentProps));}}catch(e){window.console?console.log(getLabel(387999,"组件异常："),e):alert(getLabel(387999,"组件异常：")+e);}}}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//自定义页面元素
var Iframe=function(_React$Component){(0,_inherits3.default)(Iframe,_React$Component);function Iframe(props){(0,_classCallCheck3.default)(this,Iframe);var _this=(0,_possibleConstructorReturn3.default)(this,(Iframe.__proto__||(0,_getPrototypeOf2.default)(Iframe)).call(this,props));_this.setFrameData=_this.setFrameData.bind(_this);_this.wirteDataToFrame=_this.wirteDataToFrame.bind(_this);return _this;}(0,_createClass3.default)(Iframe,[{key:'setFrameData',value:function setFrameData(curProps){var that=this;var eid=curProps.eid,data=curProps.data,tabid=curProps.tabid,isSetting=curProps.isSetting,requestid=curProps.requestid;$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({scrolling:"auto",noresize:"noresize",border:"0"});var ifrmUrl=data.url;if(ifrmUrl){if(ifrmUrl.indexOf("?")==-1){ifrmUrl+='?requestid='+requestid;}else{ifrmUrl+='&requestid='+requestid;}if(ifrmUrl.indexOf("http://")==0||ifrmUrl.indexOf("https://")==0||data.showtype!='2'){var srcUrl=$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr("src");$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:ifrmUrl});}else{$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:'about:blank'});var arr=ifrmUrl.split(".");var last=arr[arr.length-1];var index=last.indexOf("htm");var ifrmsdata=ls.getStr("custompage-"+eid+"-"+tabid);var aa=ifrmsdata?true:false;if(ifrmsdata){//解决刷新加载缓存空白的问题
that.wirteDataToFrame(ifrmsdata,eid,isSetting);//解决改变url或URL返回的内容改变时不更新的问题
$.ajax({type:"GET",url:ifrmUrl,dataType:"html",success:function success(data){//判断返回的数据是否有变化，有的话更新缓存并重新渲染
if(data!==ifrmsdata){ls.set("custompage-"+eid+"-"+tabid,data);that.wirteDataToFrame(data,eid,isSetting);}},error:function error(xhr){that.wirteDataToFrame(xhr.responseText,eid,isSetting);}});}else{$.ajax({type:"GET",url:ifrmUrl,dataType:"html",success:function success(data){if(index>=0){ls.set("custompage-"+eid+"-"+tabid,data);}that.wirteDataToFrame(data,eid,isSetting);},error:function error(xhr){that.wirteDataToFrame(xhr.responseText,eid,isSetting);}});}}}else{$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:'about:blank'});}}},{key:'wirteDataToFrame',value:function wirteDataToFrame(data,eid,isSetting){var _ifrm=$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid)[0];if(_ifrm){_ifrm.contentWindow.document.write(data);_ifrm.contentWindow.document.close();try{_ifrm.contentWindow.customPageInit();}catch(e){}}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!nextProps.refresh;}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.props.refresh){try{var f=function f(){var _ifrm=$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid)[0];if(_ifrm){_ifrm.contentWindow.document.write("");_ifrm.contentWindow.document.close();}};{this.setFrameData(this.props);}}catch(e){}}}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,_props$config=_props.config,config=_props$config===undefined?{}:_props$config;var layoutid=config.layoutid,areaflag=config.areaflag,subCompanyId=config.subCompanyId;if(!this.props.refresh){try{this.setFrameData(this.props);}catch(e){}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _props2=this.props,eid=_props2.eid,isSetting=_props2.isSetting;$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:'about:blank'});}},{key:'render',value:function render(){var _props3=this.props,eid=_props3.eid,data=_props3.data,tabid=_props3.tabid,refresh=_props3.refresh,cstyle=_props3.cstyle;var html=_react2.default.createElement('iframe',{id:'ifrm_'+eid,frameBorder:'no',className:'custompageIframe',height:data.height==''?parseInt(cstyle.height)+'':data.height,src:'about:blank',style:{borderCollapse:'collapse',width:'100%',display:'block'},name:'ifrm_'+eid});return _react2.default.createElement('div',null,html);}}]);return Iframe;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Iframe=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Iframe);exports.default=Iframe;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(154);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var News=function(_React$Component){(0,_inherits3.default)(News,_React$Component);function News(props){(0,_classCallCheck3.default)(this,News);var _this=(0,_possibleConstructorReturn3.default)(this,(News.__proto__||(0,_getPrototypeOf2.default)(News)).call(this,props));_this.state={edata:null,refresh:false,color:'#939393',canEdit:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);_this.onChangeCanEdit=_this.onChangeCanEdit.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(News,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var _state$edata=this.state.edata,edata=_state$edata===undefined?{}:_state$edata;if(edata==null)edata={};var _edata=edata,_edata$currenttab=_edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/news','POST',(0,_extends3.default)({},params)).then(function(result){var edata_local=ls.getJSONObj('edata-'+eid);if(edata_local!=null){var _edata_local$data=edata_local.data,data=_edata_local$data===undefined?{}:_edata_local$data;var _result$data=result.data,data1=_result$data===undefined?{}:_result$data;var _data$docParams=data.docParams,docParams=_data$docParams===undefined?{}:_data$docParams;var _data1$docParams=data1.docParams,docParams1=_data1$docParams===undefined?{}:_data1$docParams;var _docParams$docCatalog=docParams.docCatalogIds,docCatalogIds=_docParams$docCatalog===undefined?[]:_docParams$docCatalog;var _docParams1$docCatalo=docParams1.docCatalogIds,docCatalogIds1=_docParams1$docCatalo===undefined?[]:_docParams1$docCatalo;var _self=_this2;if(!(0,_lodash.isEqual)(docCatalogIds,docCatalogIds1)){var paramsNew={ids:docCatalogIds1.join()};var rightArr=ls.getJSONObj('portal-doc-right');if(rightArr==null){if(!_this2.isTrue){_this2.isTrue=true;_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',paramsNew).then(function(result){var right=result.canEdit=='true'?true:false;_this2.onChangeCanEdit(right);ls.set('portal-doc-right',[{eid:eid,tabid:currenttab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right}]);_self.isTrue=false;});}}else{var isHave=false;_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',paramsNew).then(function(result){var right=result.canEdit=='true'?true:false;rightArr=rightArr.map(function(item){if(item==null){return item;}else if(item.eid==eid&&item.tabid==currenttab){isHave=true;item.right=right;}return item;});_self.onChangeCanEdit(right);ls.set('portal-doc-right',rightArr);if(!isHave){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',paramsNew).then(function(result){var right=result.canEdit=='true'?true:false;_self.onChangeCanEdit(right);rightArr.push({eid:eid,tabid:currenttab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right});ls.set('portal-doc-right',rightArr);});}});}}}ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'handleOpen',value:function handleOpen(){var edata=this.state.edata;var _edata$data=edata.data,data=_edata$data===undefined?{}:_edata$data;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'onChangeCanEdit',value:function onChangeCanEdit(value){this.setState({canEdit:value});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,_state$edata2=_state.edata,edata=_state$edata2===undefined?{}:_state$edata2,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab2=edata.currenttab,currenttab=_edata$currenttab2===undefined?'1':_edata$currenttab2,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting,counts=edata.counts,_edata$data2=edata.data,data=_edata$data2===undefined?{}:_edata$data2;var _data$tabsetting2=data.tabsetting,tabsetting=_data$tabsetting2===undefined?{}:_data$tabsetting2;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,counts:counts,isShowSettingShowType:tabsetting.isShowSettingShowType,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,isAlwaysShow:esetting.isAlwaysShow};var edata_img={data:{}};if(!(0,_lodash.isEmpty)(edata)&&isHasRight){edata_img=(0,_lodash.cloneDeep)(edata);if(edata_img.data&&edata_img.data.tabsetting)edata_img.data.tabsetting.imgs=[];}var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,ref:"eContent",fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:!refresh?edata:edata_img,onChangeCanEdit:this.onChangeCanEdit});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeM:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content portal-news-img-content',id:'content_'+eid,style:{width:'auto',height:'100%'}},_react2.default.createElement('div',{style:{width:'auto',height:'100%',position:'relative'}},this.state.canEdit&&_react2.default.createElement('div',(0,_defineProperty3.default)({title:'\u65B0\u5EFA\u6587\u6863',style:{right:'30px',bottom:'20px',position:'absolute'},className:'portal-element-news-doc-add-icon',onClick:function onClick(){_this3.refs&&_this3.refs.eContent.handleOpen();}},'style',{color:this.state.color}),_react2.default.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),edata.tabids&&edata.tabids.length>1?_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)):_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config})))));}}]);return News;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);News=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(News);exports.default=News;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Base64=ecCom.WeaTools.Base64;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&eid="+eid+"&tabid="+currentTab};}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&eid="+eid+"&tabid="+currentTab};}}},{key:'render',value:function render(){var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _reactSlick=__webpack_require__(113);var _reactSlick2=_interopRequireDefault(_reactSlick);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//文档中心元素
var NewsType=function(_React$Component){(0,_inherits3.default)(NewsType,_React$Component);function NewsType(props){(0,_classCallCheck3.default)(this,NewsType);var _this=(0,_possibleConstructorReturn3.default)(this,(NewsType.__proto__||(0,_getPrototypeOf2.default)(NewsType)).call(this,props));_this.state={count:0};return _this;}(0,_createClass3.default)(NewsType,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'componentDidMount',value:function componentDidMount(){var eid=this.props.eid;var pictureWidth=$('.homepage #news_'+eid+' div').width();var elementWidth=$('.homepage #content_view_id_'+eid).width();var count=0;if(pictureWidth!==null&&elementWidth!==null){count=parseInt(elementWidth/(pictureWidth+10));if(count!=0&&count!=this.state.count){this.setState({count:count});}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var eid=this.props.eid;var pictureWidth=$('.homepage #news_'+eid+' div').width();var elementWidth=$('.homepage #content_view_id_'+eid).width();var count=0;if(pictureWidth!==null&&elementWidth!==null){count=parseInt(elementWidth/(pictureWidth+20));if(count!=0&&count!=this.state.count){this.setState({count:count});}}}},{key:'render',value:function render(){var _this2=this,_ref;var _props=this.props,eid=_props.eid,_props$data=_props.data,data=_props$data===undefined?{}:_props$data,_props$esetting=_props.esetting,esetting=_props$esetting===undefined?{}:_props$esetting,canEdit=_props.canEdit,_props$contentview=_props.contentview,contentview=_props$contentview===undefined?{}:_props$contentview;var linkmode=esetting.linkmode,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting,_data$srcStyle=data.srcStyle,srcStyle=_data$srcStyle===undefined?{}:_data$srcStyle;var _tabsetting$style=tabsetting.style,dataStyle=_tabsetting$style===undefined?{}:_tabsetting$style,rollDirection=tabsetting.rollDirection,_tabsetting$scrollSpe=tabsetting.scrollSpeed,scrollSpeed=_tabsetting$scrollSpe===undefined?'2000':_tabsetting$scrollSpe;var _srcStyle$autoheight=srcStyle.autoheight,autoheight=_srcStyle$autoheight===undefined?'0':_srcStyle$autoheight,_srcStyle$pictureheig=srcStyle.pictureheight,pictureheight=_srcStyle$pictureheig===undefined?'108px':_srcStyle$pictureheig,_srcStyle$picturewidt=srcStyle.picturewidth,picturewidth=_srcStyle$picturewidt===undefined?'120px':_srcStyle$picturewidt;var _dataStyle$abstractCo=dataStyle.abstractColor,abstractColor=_dataStyle$abstractCo===undefined?'#797979':_dataStyle$abstractCo,_dataStyle$abstractFo=dataStyle.abstractFont,abstractFont=_dataStyle$abstractFo===undefined?'微软雅黑':_dataStyle$abstractFo,_dataStyle$abstractSi=dataStyle.abstractSize,abstractSize=_dataStyle$abstractSi===undefined?'12':_dataStyle$abstractSi,abstractstyle=dataStyle.abstractstyle,_dataStyle$abstractWe=dataStyle.abstractWeight,abstractWeight=_dataStyle$abstractWe===undefined?'0':_dataStyle$abstractWe,_dataStyle$titleColor=dataStyle.titleColor,titleColor=_dataStyle$titleColor===undefined?'#000000':_dataStyle$titleColor,_dataStyle$titleFont=dataStyle.titleFont,titleFont=_dataStyle$titleFont===undefined?'微软雅黑':_dataStyle$titleFont,_dataStyle$titleSize=dataStyle.titleSize,titleSize=_dataStyle$titleSize===undefined?'16':_dataStyle$titleSize,titlestyle=dataStyle.titlestyle,_dataStyle$titleWeigh=dataStyle.titleWeight,titleWeight=_dataStyle$titleWeigh===undefined?'0':_dataStyle$titleWeigh;var list=data.data;if(list&&list.length===0){return React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,' ',React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));}//tab设置信息
var height=tabsetting.height,width=tabsetting.width,showModeId=tabsetting.showModeId,imgs=tabsetting.imgs,_tabsetting$imgsWithD=tabsetting.imgsWithDocSubject,imgsWithDocSubject=_tabsetting$imgsWithD===undefined?[]:_tabsetting$imgsWithD;var columns=new Array();var imgStyle={width:picturewidth,height:pictureheight};var style={verticalAlign:'top',width:picturewidth,height:pictureheight};if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}var listStyle2={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1&&imgStyle.width.indexOf('px')!=-1){listStyle2={width:imgStyle.width,height:imgStyle.height};}var docHtml='';switch(parseInt(showModeId)){case 2://上图式
imgStyle['margin']='0 auto';var lHtml=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:img});}}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid,className:"portal-news-com"},React.createElement('div',{style:imgStyle},imghtml),React.createElement('div',{style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},item.docsubject?React.createElement('div',{style:{marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{display:'-webkit-box',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'2',WebkitBoxOrient:'vertical'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%',height:'32px'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px',width:'60px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',bottom:'15px',float:'right',width:'calc(100% - 60px - 10px)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',{className:"portal-news-content"},lHtml);break;case 3://左图式
var html=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){img=img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{style:{overflow:'auto',overflowY:'hidden',width:'100%',marginBottom:'10px'},className:"portal-news-com"},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},item.docsubject?React.createElement('div',{style:{marginTop:'10px',marginRight:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',null,React.createElement('span',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'2',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'},title:item.summary},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',position:'absolute',bottom:'15px',float:'right',width:'100%'}},list_new.map(function(item_new){if((typeof item_new==='undefined'?'undefined':(0,_typeof3.default)(item_new))=="object"){return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new.name);}return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',{className:"portal-news-content"},html);break;case 4://列表式2
var html4=null;var imghtml=null;var imghtml2=[];var j=0;var imgs_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs_new.length>1){imgs.map(function(item,i){imghtml2[j]=imgs[i];j++;});if(imghtml2.length==0){imghtml2[0]='/images/homepage/noimgdefault_wev8.jpg';}var ihtml=imghtml2.map(function(item,i){var img=imghtml2[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}// if (img.indexOf("|") !== -1) img = img.split("|")[0];
return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},ihtml));}else{var img=imgs_new[0];var x=0;imgs.map(function(item,index){if(item!='/images/homepage/noimgdefault_wev8.jpg'){x=index;}});if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[x]&&imgsWithDocSubject[x].docsubject&&imgsWithDocSubject[x].docsubject.link,style:listStyle2,eid:eid,src:img})));}}columns=(0,_common.formatData)(list[0],esetting);style['paddingTop']='6px';html4=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:esetting.showHeader=='1',pagination:false,dataSource:list,size:'small'}))));docHtml=React.createElement('div',null,html4);break;case 5://双列式
columns=(0,_common.formatData)(list[0],esetting);var evenData=new Array();var oddData=new Array();list.map(function(item,i){if(i%2===0){evenData.push(item);}else{oddData.push(item);}});if((0,_lodash.isEmpty)(evenData)&&(0,_lodash.isEmpty)(oddData)){docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')))));}else{docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12,order:1},!(0,_lodash.isEmpty)(evenData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:esetting.showHeader=='1',pagination:false,dataSource:evenData,size:'small'})),React.createElement(_antd.Col,{span:12,order:2},!(0,_lodash.isEmpty)(oddData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:esetting.showHeader=='1',pagination:false,dataSource:oddData,size:'small'}))));}break;case 6://摘要式
var html6=list.map(function(item,i){var docsubject=item.docsubject||{};var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var _img=imgs[i];if((typeof _img==='undefined'?'undefined':(0,_typeof3.default)(_img))=='object'&&_img.length>1){_img=_img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:_img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left'});return React.createElement('div',{className:"portal-news-com",style:{width:'100%',paddingBottom:'20px',marginBottom:'5px',borderBottom:i!==list.length-1?'1px solid #dedede':'',overflow:'hidden'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{whiteSpace:'nowrap',display:'inline-block',maxWidth:'calc(100% - 30px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{verticalAlign:'middle',marginTop:'-25px',marginLeft:'5px',cursor:'pointer'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{height:'60px',lineHeight:'30px',color:'rgb(105, 104, 104)',textOverflow:'ellipsis',width:'99%',overflow:'hidden',WebkitLineClamp:'2',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)));});docHtml=React.createElement('div',{className:"portal-news-content"},html6);break;case 7://摘要式2
var listStyle3={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1){listStyle3={width:'100%',height:imgStyle.height};}var imghtml7=null;var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var imghtml3=[];var m=0;var imgs2_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs2_new.length>1){imgs.map(function(item,i){imghtml3[m]=imgs[i];m++;});if(imghtml3.length==0){imghtml3=['/images/homepage/noimgdefault_wev8.jpg'];}var _ihtml=imghtml3.map(function(item,i){var img=imghtml3[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}if(img.indexOf("|")!==-1)img=img.split("|")[0];return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,style:listStyle3,eid:eid,src:img}));});imghtml7=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_ihtml));}else{var _x=0;imgs.map(function(item,index){if(item!='/images/homepage/noimgdefault_wev8.jpg'){_x=index;}});var _img2=imgs2_new[0];if(!_img2)_img2='/images/homepage/noimgdefault_wev8.jpg';if(_img2.indexOf("|")!==-1)_img2=_img2.split("|")[0];imghtml7=React.createElement('div',{style:{height:'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[_x]&&imgsWithDocSubject[_x].docsubject&&imgsWithDocSubject[_x].docsubject.link,style:listStyle3,eid:eid,src:_img2})));}}var html7=list.map(function(item,i){var docsubject=item.docsubject||{};return React.createElement('div',{className:"portal-news-com",style:{float:'left',paddingLeft:'10px',width:'100%',borderBottom:i!==list.length-1?'1px solid #dedede':''}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{whiteSpace:'nowrap',display:'inline-block',maxWidth:'calc(100% - 30px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{display:'-webkit-box',maxHeight:'60px',width:'99%',lineHeight:'30px',color:'#696868',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',marginBottom:'10px'}},item.summary));});docHtml=React.createElement('div',null,React.createElement('div',{style:{width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml7),React.createElement('div',{className:"portal-news-content",style:{overflow:'hidden'}},html7)));break;case 8://头条式
var item=list[0];var docsubject=item.docsubject||{};var tableHtml='';var newList=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns=(0,_common.formatData)(list[1],esetting);tableHtml=React.createElement(_ecCom.WeaTable,{columns:_columns,showHeader:esetting.showHeader=='1',pagination:false,dataSource:newList.slice(1,list.length),size:'small'});}docHtml=React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{className:'mews-summary',style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(this,docsubject.link,esetting.linkmode),style:{padding:'3px',whiteSpace:'nowrap',fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 30px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{verticalAlign:'middle',marginTop:'-25px',marginLeft:'5px',cursor:'pointer'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)))),tableHtml);break;case 9://头条式2
var item2=list[0];var docsubject2=item2.docsubject||{};var tableHtml2='';var newList2=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns2=(0,_common.formatData)(list[1],esetting);tableHtml2=React.createElement(_ecCom.WeaTable,{columns:_columns2,showHeader:esetting.showHeader=='1',pagination:false,dataSource:newList2.slice(1,list.length),size:'small'});}var imghtml9=[];var j9=0;var imgs9_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs9_new.length>1){imgs.map(function(item,i){imghtml9[j9]=imgs[i];j9++;});if(imghtml9.length==0){imghtml9[0]='/images/homepage/noimgdefault_wev8.jpg';}var _ihtml2=imghtml9.map(function(item,i){var img=imghtml9[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}// if (img.indexOf("|") !== -1) img = img.split("|")[0];
return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_ihtml2));}else{var _x2=0;imgs.map(function(item,index){if(item!='/images/homepage/noimgdefault_wev8.jpg'){_x2=index;}});var _img3=imgs9_new[0];if(!_img3)_img3='/images/homepage/noimgdefault_wev8.jpg';if(_img3.indexOf("|")!==-1)_img3=_img3.split("|")[0];imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[_x2]&&imgsWithDocSubject[_x2].docsubject&&imgsWithDocSubject[_x2].docsubject.link,style:listStyle2,eid:eid,src:_img3})));}}docHtml=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{className:'mews-summary',style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject2.name,onClick:_common.openLinkUrl.bind(this,docsubject2.link,esetting.linkmode),style:{padding:'3px',whiteSpace:'nowrap',fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 30px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject2.name),docsubject2.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{verticalAlign:'middle',marginTop:'-25px',marginLeft:'5px',cursor:'pointer'},alt:'',src:docsubject2.img}):''),React.createElement('div',{title:item2.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item2.summary)))),tableHtml2))));break;case 10://上图式2
imgStyle['margin']='0 auto';var item10=list[0];var tableHtml10='';var docsubject10=item10.docsubject||{};var newList10=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns3=(0,_common.formatData)(list[1],esetting);tableHtml10=React.createElement(_ecCom.WeaTable,{columns:_columns3,showHeader:esetting.showHeader=='1',pagination:false,dataSource:newList10.slice(1,list.length),size:'small'});}var imghtml10=null;if(!(0,_lodash.isEmpty)(imgs)){var _img4=imgs[0];if((typeof _img4==='undefined'?'undefined':(0,_typeof3.default)(_img4))=='object'&&_img4.length>1){imghtml10=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_img4.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[0]&&imgsWithDocSubject[0].docsubject&&imgsWithDocSubject[0].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml10=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[0]&&imgsWithDocSubject[0].docsubject&&imgsWithDocSubject[0].docsubject.link,eid:eid,src:_img4});}}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid},React.createElement('div',{className:"mews-img",style:imgStyle},imghtml10),React.createElement('div',{className:"mews-table",style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},React.createElement('td',{width:'*',style:{display:'block',width:'100%'},className:'valign'},React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:{width:'100%'}},React.createElement('div',{className:"mews-content",style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject10.name,onClick:_common.openLinkUrl.bind(this,docsubject10.link,esetting.linkmode),style:(_ref={fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer',width:'calc(100% - 90px)',WebkitBoxRrient:'vertical'},(0,_defineProperty3.default)(_ref,'display','-webkit-box'),(0,_defineProperty3.default)(_ref,'float','left'),(0,_defineProperty3.default)(_ref,'wordBreak','break-all'),_ref)},React.createElement('div',{title:docsubject10.name,style:{display:'flex'}},React.createElement('p',{style:{marginRight:'3px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}},docsubject10.name),docsubject10.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{},alt:'',src:docsubject10.img}):'')),item10.doccreatedate&&React.createElement('div',{title:item10.doccreatedate,style:{lineHeight:'32px',display:'inline-block',overflow:'hidden',marginLeft:'10px'}},item10.doccreatedate)),React.createElement('div',{title:item10.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item10.summary)))),tableHtml10))));docHtml=React.createElement('div',null,lHtml2);break;case 11://上图式3
imgStyle['margin']='0 auto';var settings={infinite:true,autoplaySpeed:parseInt(scrollSpeed),className:"center",dots:false,rtl:rollDirection=='right',slidesToShow:list.length<this.state.count?list.length:this.state.count,slidesToScroll:1,autoplay:rollDirection!='none',pauseOnHover:true,draggable:false};var lHtml11=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgsWithDocSubject)){var _img5=imgsWithDocSubject[i].imgs;if(!_img5)_img5='/images/homepage/noimgdefault_wev8.jpg';imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:_img5});}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid,className:"portal-news-com",style:{outline:'none!important',width:imgStyle.width}},React.createElement('div',{style:imgStyle},imghtml),React.createElement('div',{style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},item.docsubject?React.createElement('div',{style:{marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{display:'-webkit-box',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'2',WebkitBoxOrient:'vertical'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%',height:'32px'}},React.createElement('div',{style:{display:'inline-block',bottom:'15px',float:'right',width:'100%',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},list_new.map(function(item_new,o){var dotstr=o===0?"":" , ";if((typeof item_new==='undefined'?'undefined':(0,_typeof3.default)(item_new))=="object"&&item_new.userid){var ahtml="<a href='javascript:openhrm("+item_new.userid+");' onclick='pointerXY(event)' title="+item_new.name+"><font style='color:#000000;display: flex;' class='font wea-f"+contentfontsize+"'>"+dotstr+item_new.name+"</font></a>";if(item_new.usertype&&item_new.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+item_new.userid+"' title="+item_new.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+item_new.name+"</font></a>";}return React.createElement('div',{style:{display:'inline-block',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px',paddingRight:'5px'},dangerouslySetInnerHTML:{__html:ahtml}});}return React.createElement('div',{style:{display:'inline-block',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px',paddingRight:'5px'}},item_new);})))));});docHtml=React.createElement('div',{className:"portal-news-content",style:{overflowX:'hidden'}},React.createElement(_reactSlick2.default,settings,lHtml11));break;case 1://列表式
default:columns=(0,_common.formatData)(list[0],esetting);docHtml=React.createElement(_ecCom.WeaTable,{style:{fontSize:'20px'},columns:columns,showHeader:esetting.showHeader=='1',pagination:false,dataSource:list,size:'small'});break;}// return <AddNewCom canEdit={this.props.canEdit} catalogIds={tabsetting.catalogIds} catalogId={tabsetting.catalogId}>{docHtml}</AddNewCom>
return docHtml;}}]);return NewsType;}(React.Component);var AddNewCom=function(_React$Component2){(0,_inherits3.default)(AddNewCom,_React$Component2);function AddNewCom(props){(0,_classCallCheck3.default)(this,AddNewCom);var _this3=(0,_possibleConstructorReturn3.default)(this,(AddNewCom.__proto__||(0,_getPrototypeOf2.default)(AddNewCom)).call(this,props));_this3.state={isShowAdd:false,color:'#939393'};_this3.handleOpen=_this3.handleOpen.bind(_this3);return _this3;}(0,_createClass3.default)(AddNewCom,[{key:'handleOpen',value:function handleOpen(){var _props2=this.props,catalogId=_props2.catalogId,catalogIds=_props2.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,children=_props3.children,canEdit=_props3.canEdit;if(canEdit){return React.createElement('div',{className:' portal-element-news-doc-add',onMouseOver:function onMouseOver(){return _this4.setState({isShowAdd:true});},onMouseLeave:function onMouseLeave(){return _this4.setState({isShowAdd:false});}},React.createElement('div',{title:'\u65B0\u5EFA\u6587\u6863',className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){return _this4.setState({color:'#434343'});},onMouseLeave:function onMouseLeave(){return _this4.setState({color:'#939393'});},onClick:this.handleOpen,style:{color:this.state.color}},React.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),children);}return React.createElement('div',null,children);}}]);return AddNewCom;}(React.Component);var ImgCom=function(_React$Component3){(0,_inherits3.default)(ImgCom,_React$Component3);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this5=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this5.aClick=_this5.aClick.bind(_this5);return _this5;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props4=this.props,_props4$link=_props4.link,link=_props4$link===undefined?'':_props4$link,_props4$linkmode=_props4.linkmode,linkmode=_props4$linkmode===undefined?'1':_props4$linkmode;if(link!=''){(0,_common.openLinkUrl)(link,linkmode);// window.open(link, linkmode);
}else return false;}},{key:'render',value:function render(){var _props5=this.props,_props5$src=_props5.src,src=_props5$src===undefined?'':_props5$src,_props5$style=_props5.style,style=_props5$style===undefined?{width:'100%',height:'100%'}:_props5$style;return React.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},React.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(React.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);NewsType=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(NewsType);exports.default=NewsType;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(486);

var _json2mq = __webpack_require__(492);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(494);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(495);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(487);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(488);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(26);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(85);

var _track = __webpack_require__(489);

var _dots = __webpack_require__(490);

var _arrows = __webpack_require__(491);

var _resizeObserverPolyfill = __webpack_require__(145);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(26);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(26);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(26);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(493);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(496);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(497);
var Util = __webpack_require__(155);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(498);
var each = __webpack_require__(155).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(500);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var ReportForm=function(_React$Component){(0,_inherits3.default)(ReportForm,_React$Component);function ReportForm(props){(0,_classCallCheck3.default)(this,ReportForm);var _this=(0,_possibleConstructorReturn3.default)(this,(ReportForm.__proto__||(0,_getPrototypeOf2.default)(ReportForm)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(ReportForm,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/reportform','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,fontSizeMp:fontSizeMp,config:config,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return ReportForm;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ReportForm=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ReportForm);exports.default=ReportForm;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(501);var _Title2=_interopRequireDefault(_Title);var _echart=__webpack_require__(132);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/reportformtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{overflow:"auto"};var option=void 0;var contentHtml=_react2.default.createElement('div',null);var nowfontsize=parseInt($('body').css('font-size'));if(tabdata&&tabdata.series){option=(0,_echart.getEChartOption)(tabdata,nowfontsize);contentHtml=_react2.default.createElement(_echart.EchartView,{eid:eid,key:currentTab,width:tabdata.width,charttype:tabdata.charttype,height:tabdata.height,option:option});}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:cstyle},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(503);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var OutData=function(_React$Component){(0,_inherits3.default)(OutData,_React$Component);function OutData(props){(0,_classCallCheck3.default)(this,OutData);var _this=(0,_possibleConstructorReturn3.default)(this,(OutData.__proto__||(0,_getPrototypeOf2.default)(OutData)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(OutData,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/outdata','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);window.elements_more_params[config.params.eid]={isRouteUrl:true,tabid:edata.currenttab||'1'};if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return OutData;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OutData=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OutData);exports.default=OutData;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _Title=__webpack_require__(504);var _Title2=_interopRequireDefault(_Title);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/outdatatab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});window.elements_more_params[params.eid]={isRouteUrl:true,tabid:tabid};}},{key:'render',value:function render(){var _props=this.props,_props$config2=_props.config,config=_props$config2===undefined?{}:_props$config2,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=tabdata&&tabdata.data.length?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.data[0],esetting),showHeader:true,pagination:false,dataSource:tabdata.data,size:'small'}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(506);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);__webpack_require__(509);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var FormModeCustomSearch=function(_React$Component){(0,_inherits3.default)(FormModeCustomSearch,_React$Component);function FormModeCustomSearch(props){(0,_classCallCheck3.default)(this,FormModeCustomSearch);var _this=(0,_possibleConstructorReturn3.default)(this,(FormModeCustomSearch.__proto__||(0,_getPrototypeOf2.default)(FormModeCustomSearch)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(FormModeCustomSearch,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/formmodecustomsearch','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);window.elements_more_params[eid]={isRouteUrl:true,morehref:result.data&&result.data.morehref,customid:result.data&&result.data.customid||''};_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.econtent.handleTabData(tabid);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{ref:function ref(e){_this3.econtent=e;},onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return FormModeCustomSearch;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FormModeCustomSearch=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FormModeCustomSearch);exports.default=FormModeCustomSearch;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(507);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _FmcsTable=__webpack_require__(508);var _FmcsTable2=_interopRequireDefault(_FmcsTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/formmodecustomsearchtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);var customid=result.customid;var morehref=result.morehref;if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});window.elements_more_params[params.eid]={isRouteUrl:true,morehref:morehref,customid:customid};if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,_state$tabdata=_state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata,currentTab=_state.currentTab,refresh=_state.refresh;if(!tabdata)return _react2.default.createElement('div',null);var _tabdata$tabsetting=tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;esetting.widths=tabsetting.widths;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var rolltype='none';if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='1'){rolltype='up';}else if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='2'){rolltype='right';}else if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='3'){rolltype='down';}else if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='4'){rolltype='left';}var contentHtml=tabdata?_react2.default.createElement(_MarqueeCom2.default,{eid:eid,ebaseid:ebaseid,scolltype:rolltype},_react2.default.createElement(_FmcsTable2.default,{eid:eid,isshowtitle:tabdata.tabsetting?tabdata.tabsetting.isshowtitle:false,isPageAutoWrap:tabdata.isPageAutoWrap||'1',data:tabdata,esetting:esetting})):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var _tdStyle;var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle=(_tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',height:'32px',backgroundSize:'100% 100%'},(0,_defineProperty3.default)(_tdStyle,'height','32px'),(0,_defineProperty3.default)(_tdStyle,'marginTop','-16px'),_tdStyle);var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _loadjs=__webpack_require__(114);var _loadjs2=_interopRequireDefault(_loadjs);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//建模查询中心元素
var FmcsTable=function(_React$Component){(0,_inherits3.default)(FmcsTable,_React$Component);function FmcsTable(props){(0,_classCallCheck3.default)(this,FmcsTable);//this.imageCarousel = this.imageCarousel.bind(this);
var _this=(0,_possibleConstructorReturn3.default)(this,(FmcsTable.__proto__||(0,_getPrototypeOf2.default)(FmcsTable)).call(this,props));_this.playImg=function(e,fieldid,isdownload,formmode_authorizeUrl){// 图片轮播
var jq=_this.getCurrentJQuery();var currentWindow=_this.getCurrentWindow();var imgPool=[];var indexNum=0;var fieldids=fieldid.split(',');fieldids.map(function(item){imgPool.push(''+("/weaver/weaver.file.FileDownload?fileid="+item+formmode_authorizeUrl));});for(var i=0;i<imgPool.length;i++){if(jq(e.target).attr('data-imgsrc')===imgPool[i]){break;}else{indexNum++;}}window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,currentWindow.top);};_this.getCurrentJQuery=function(){var currentWindow=_this.getCurrentWindow();return currentWindow.$||currentWindow.jQuery;};_this.getCurrentWindow=function(){var WindowFunc=_ecCom.WeaTools.WindowFunc;return WindowFunc.getParent()!==window?WindowFunc.getTop():window;};_this.updateAutoWrap=function(){var isPageAutoWrap=_this.props.isPageAutoWrap;//需要某个td不受配置控制，则将对应column的className设为customWrap
var $td=jQuery(" table td:not(.wea-table-operates, .customWrap, .customWrap *)",ReactDOM.findDOMNode(_this));if(isPageAutoWrap=="0"){$td.find('font').css('white-space','nowrap').css('word-break','keep-all');$td.find(">div").removeClass("autoWrap").addClass("noWrap");$td.find("a").removeClass("autoWrap").addClass("noWrap");$td.removeClass("autoWrap").addClass("noWrap");$td.find("a").map(function(i,a){a.title=a.innerText;});$td.find(".wea-url").map(function(i,d){d.title=d.innerText;});}else{$td.find('font').css('white-space','normal').css('word-break','normal');$td.find(">div").removeClass("noWrap").addClass("autoWrap");$td.find("a").removeClass("noWrap").addClass("autoWrap");$td.removeClass("noWrap").addClass("autoWrap");}};_this.getColumns=function(){var _this$props=_this.props,data=_this$props.data,esetting=_this$props.esetting;var imgSymbol=esetting.imgSymbol,linkmode=esetting.linkmode,widths=esetting.widths,titles=esetting.titles,ebaseid=esetting.ebaseid,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var columns=new Array();var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var _tabsetting$alignment=tabsetting.alignmentList,alignmentList=_tabsetting$alignment===undefined?{}:_tabsetting$alignment;var _alignmentList$classn=alignmentList.classname,classname=_alignmentList$classn===undefined?[]:_alignmentList$classn;for(var i=0;i<alignmentList.length;i++){classname[i]=alignmentList[i]=='column-text-right'?'right':alignmentList[i]=='column-text-center'?'center':'left';// console.log(classname[i]);	//获取对齐方式
}//加载行小图标
if(imgSymbol){var iObj={dataIndex:'imgSymbol',key:'imgSymbol',width:ebaseid=='FormModeCustomSearch'?'1%':'8px',render:function render(){return _react2.default.createElement('img',{style:{marginBottom:'4px'},name:'esymbol',src:imgSymbol});}};columns.push(iObj);}if(!titles){return[];}var _loop=function _loop(_i){colObj=new Object();colObj={dataIndex:'value'+_i,key:'value'+_i,render:function render(text,record,index){if(text&&(typeof text==='undefined'?'undefined':(0,_typeof3.default)(text))==='object'&&text.constructor===Array){//链接字段
return _react2.default.createElement('div',{style:{textAlign:classname[_i]}},_this.loadListName(contentfontsize,text,linkmode));}else{//普通文本
if(typeof text==='string'){if(_this.isHtml(text)){//判断字符串是否含有html
return _react2.default.createElement('font',{style:{display:'block',textAlign:classname[_i]},className:text.indexOf("class='font'")==-1?'font wea-f'+contentfontsize:'wea-f'+contentfontsize,dangerouslySetInnerHTML:{__html:text}});}else{return _react2.default.createElement('font',{style:{display:'block',textAlign:classname[_i]},className:'font wea-f'+contentfontsize},text);}}else{return _react2.default.createElement('font',{style:{display:'block',textAlign:classname[_i]},className:'font wea-f'+contentfontsize});}}}};if(titles)colObj['title']=_react2.default.createElement('div',{style:{textAlign:classname[_i]}},titles[_i]);// if (titles) colObj['title'] = titles[i];
var width=colObj.dataIndex&&widths[colObj.dataIndex];if(widths[colObj.dataIndex]!=''&&widths[colObj.dataIndex]!='*'){if(width&&width.indexOf('%')==-1){width+='px';}}if(widths)colObj['width']=width;columns.push(colObj);};for(var _i=0;_i<titles.length;_i++){var colObj;_loop(_i);}return columns;};_this.loadListName=function(contentfontsize,list,linkmode){if(!list||list.length===0)return _react2.default.createElement('span',null);var html=list.map(function(obj,o){var dotstr=o===0?"":" , ";if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Object){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('font',null,dotstr,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return(0,_common.openLinkUrl)(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name)));}else if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Array){var shtml=obj.map(function(obj,s){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return(0,_common.openLinkUrl)(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name));});return _react2.default.createElement('font',null,dotstr,shtml);}});var flag=_react2.default.createElement('span',null);if(list[0].img){flag=_react2.default.createElement('span',{style:{verticalAlign:'top',marginLeft:3}},_react2.default.createElement('img',{src:list[0].img,title:list[0].desc,complete:'complete'}));}return _react2.default.createElement('span',{className:'td-span-formmodecustomsearch'},html,flag);};_this.isHtml=function(htmlStr){if(!htmlStr)return false;var reg=/<[^>]+>/g;return reg.test(htmlStr)||htmlStr.indexOf("&")>-1;};var staticVersion='?v'+(_ecCom.WeaTools&&_ecCom.WeaTools.ls&&_ecCom.WeaTools.ls.getStr("staticVersion")||0);(0,_loadjs2.default)(['/social/js/drageasy/drageasy.js'+staticVersion,'/social/js/bootstrap/js/bootstrap.js'+staticVersion,'/social/im/js/IMUtil_wev8.js'+staticVersion,'/social/js/imcarousel/imcarousel.js'+staticVersion]);return _this;}(0,_createClass3.default)(FmcsTable,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting,isshowtitle=_props.isshowtitle;if(data.isRight==false){return _react2.default.createElement('div',{style:{height:'40px',lineHeight:'40px',textAlign:'center'}},data.data);}var _data$tabsetting2=data.tabsetting,tabsetting=_data$tabsetting2===undefined?{}:_data$tabsetting2,_data$childrenColumnN=data.childrenColumnName,childrenColumnName=_data$childrenColumnN===undefined?'':_data$childrenColumnN,_data$treeList=data.treeList,treeList=_data$treeList===undefined?[]:_data$treeList;var list=data.data||[];var _tabsetting$widths=tabsetting.widths,widths=_tabsetting$widths===undefined?[]:_tabsetting$widths,titles=tabsetting.titles;esetting['widths']=widths;esetting['titles']=titles;var showHeader=true;var index=0;for(var k in list[0]){index+=1;}if(index===1){showHeader=false;}var html=void 0;if(childrenColumnName=='1'){html=_react2.default.createElement(_ecCom.WeaTable,{showHeader:isshowtitle=='1'?true:false,columns:treeList,pagination:false,dataSource:list,childrenColumnName:'sublist',className:'cube-list-table'});}else{html=_react2.default.createElement(_ecCom.WeaTable,{showHeader:isshowtitle=='1'?true:false,columns:this.getColumns(),pagination:false,dataSource:list,size:'small'});}return _react2.default.createElement('div',{className:'formmodesearch'},html);}},{key:'componentDidUpdate',value:function componentDidUpdate(){//this.updateAutoWrap();
}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window['cubeshowDdImg']=function(fieldids,w,h,isbatch,isdownload,docs,formmode_authorizeUrl){_this2.playImg(window.event,fieldids,isdownload,formmode_authorizeUrl);};//this.updateAutoWrap();
}// 获取 window
//处理属性为集合的数据
}]);return FmcsTable;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FmcsTable=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FmcsTable);exports.default=FmcsTable;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _Picture=__webpack_require__(511);var _Picture2=_interopRequireDefault(_Picture);var _Sliders=__webpack_require__(512);var _Sliders2=_interopRequireDefault(_Sliders);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Picture=function(_React$Component){(0,_inherits3.default)(Picture,_React$Component);function Picture(props){(0,_classCallCheck3.default)(this,Picture);var _this=(0,_possibleConstructorReturn3.default)(this,(Picture.__proto__||(0,_getPrototypeOf2.default)(Picture)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Picture,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/picture','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){// if(!isEmpty(edata)) EContentHtml = <PictureCom isSetting={config.isSetting} eid={eid} data={edata.data} esetting={edata.esetting}/>;
if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Sliders2.default,{isSetting:config.isSetting,eid:eid,data:edata.data,esetting:edata.esetting,height:style1.height});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view content_view_slider',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Picture;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Picture=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Picture);exports.default=Picture;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _loadjs=__webpack_require__(114);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//图片元素
global.globalIntervalVariable;var PictureCom=function(_React$Component){(0,_inherits3.default)(PictureCom,_React$Component);function PictureCom(props){(0,_classCallCheck3.default)(this,PictureCom);var _this=(0,_possibleConstructorReturn3.default)(this,(PictureCom.__proto__||(0,_getPrototypeOf2.default)(PictureCom)).call(this,props));_this.imageCarousel=_this.imageCarousel.bind(_this);var staticVersion='?v'+(_ecCom.WeaTools&&_ecCom.WeaTools.ls&&_ecCom.WeaTools.ls.getStr("staticVersion")||0);(0,_loadjs2.default)(['/social/js/drageasy/drageasy.js'+staticVersion,'/social/js/bootstrap/js/bootstrap.js'+staticVersion,'/social/im/js/IMUtil_wev8.js'+staticVersion,'/social/js/imcarousel/imcarousel.js'+staticVersion]);return _this;}(0,_createClass3.default)(PictureCom,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,eid=_props.eid,esetting=_props.esetting;var width=esetting.width,speed=esetting.speed,open=esetting.open;if(global.globalIntervalVariable){clearInterval(global.globalIntervalVariable);}global.globalIntervalVariable=loadPictureJs(eid,width,speed,open,"update");}},{key:'componentDidMount',value:function componentDidMount(){var _props2=this.props,eid=_props2.eid,esetting=_props2.esetting;var width=esetting.width,speed=esetting.speed,open=esetting.open;global.globalIntervalVariable=loadPictureJs(eid,width,speed,open,"mount");}//图片放大轮播
},{key:'imageCarousel',value:function imageCarousel(imgObj,e){var imgPool=[];var indexNum=0;jQuery(".portal-picture-img").each(function(){var imgsrc=!!jQuery(this).attr("data-imgsrc")?jQuery(this).attr("data-imgsrc"):jQuery(this).attr("src");imgPool.push(imgsrc);});var imgsrc=jQuery(e.target).attr("src");for(var i=0;i<imgPool.length;i++){if(imgsrc==imgPool[i]){indexNum=i;break;}}//console.log("imgPool--",imgPool,"indexNum--",indexNum);
window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);}},{key:'render',value:function render(){var _this2=this;var aStyle={cursor:'default'};var tdStyle={verticalAlign:'middle',width:'35px'};var _props3=this.props,eid=_props3.eid,data=_props3.data,esetting=_props3.esetting;var showType=esetting.showType,button=esetting.button,width=esetting.width,height=esetting.height,open=esetting.open;var cursor='default';var imgStyle={width:width+'px',height:height+'px'};var liStyle={overflow:'hidden',float:'left',width:width+'px',height:parseInt(height)+3+'px'};var html=null;if(showType==='1'){var item=data[0];var link=item.link;if(''===link){link='#';}else{cursor='pointer';}var img=_react2.default.createElement('img',{title:item.name,src:item.url,border:'0',style:imgStyle});html='1'===open?_react2.default.createElement('div',{className:'jCarouselLite'},''!==item.url?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:item.url,target:'_blank'},' ',img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img)):_react2.default.createElement('div',null,'#'!==link?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:link,target:'_blank'},img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img));}else{var btnBack=null;var btnNext=null;if('1'===button){btnBack=_react2.default.createElement('td',{style:tdStyle},_react2.default.createElement('div',{id:'pictureback_'+eid,className:'pictureback',style:{cursor:'hand'}}));btnNext=_react2.default.createElement('td',{style:tdStyle},_react2.default.createElement('div',{id:'picturenext_'+eid,className:'picturenext',style:{cursor:'hand'}}));}var liHtml=data.map(function(item,i){var link=''===item.link?'#':item.link;var img=_react2.default.createElement('img',{className:'portal-picture-img',title:item.name,src:item.url,border:'0',style:imgStyle,onClick:function onClick(e){return _this2.imageCarousel(_this2,e);}});return _react2.default.createElement('li',{style:liStyle},'1'===open?_react2.default.createElement('div',{className:'jCarouselLite'},''!==item.url?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:item.url,target:'_blank'},img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img)):_react2.default.createElement('div',null,'#'!==link?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:link,target:'_blank'},img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img)));});html=_react2.default.createElement('table',{width:'100%',style:{borderSpacing:'0'},border:'0'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,btnBack,_react2.default.createElement('td',{id:'picturetd_'+eid,nowrap:'nowrap',style:{overflow:'hidden',textAlign:'center'}},_react2.default.createElement('div',{className:'jCarouselLite',id:'jCarouselLite_'+eid},_react2.default.createElement('ul',null,liHtml))),btnNext)));}return _react2.default.createElement('div',{id:'pictureTable_'+eid,style:{backgroundColor:'#FFFFFF',height:height,width:'100%',margin:'0px',textAlign:'center'}},html);}}]);return PictureCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);PictureCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(PictureCom);exports.default=PictureCom;function loadPictureJs(eid,picturewidth,autoShowSpeed,highopen,loadStatus){var width=$("#jCarouselLite_"+eid).parent().width();var intervalVariable;var count=parseInt(width/picturewidth);if($('#jCarouselLite_'+eid).find("ul").length>0){var auto=autoShowSpeed*50;if($('#jCarouselLite_'+eid).find("li").length<count){auto=0;count=$('#jCarouselLite_'+eid).find("li").length;var temp=$('#jCarouselLite_'+eid);var ul=$("ul",temp),tLi=$("li",ul);if(loadStatus=="update"){for(var i=-count;i<=count;i++){tLi.eq(i).remove();}}temp.jCarouselLite({btnPrev:'#pictureback_'+eid,btnNext:'#picturenext_'+eid,auto:auto,speed:1000,visible:count,scroll:1,circular:false},temp);intervalVariable=temp.getInterval();/*			$("#pictureback_" + eid).hide();
			$("#picturenext_" + eid).hide();*/$("#picturetd_"+eid).attr("align","center");var settingWidth=parseInt(count*picturewidth);$("#jCarouselLite_"+eid).width(settingWidth);}else{var temp=$('#jCarouselLite_'+eid);var ul=$("ul",temp),tLi=$("li",ul);if(loadStatus=="update"){for(var _i=-count;_i<count;_i++){tLi.eq(_i).remove();}}temp.jCarouselLite({btnPrev:'#pictureback_'+eid,btnNext:'#picturenext_'+eid,auto:auto,speed:1000,visible:count,scroll:1,circular:true},temp);intervalVariable=temp.getInterval();$("#jCarouselLite_"+eid).width(width);}}if("1"===highopen){$('#jCarouselLite_'+eid).find("a").each(function(){var $img=$(this);$($img).fancybox({wrapCSS:'fancybox-custom',closeClick:true,closeBtn:false,openEffect:'none',helpers:{title:{type:'inside'},overlay:{css:{'background':'rgba(238,238,238,0.85)'}}},afterLoad:function afterLoad(){var refstr=$($img).attr("data-ref");if($.trim(refstr)!="#"){this.title='<a href="'+refstr+'" style="color:#000000!important;text-decoration:none!important;" target="_blank">'+this.title+'</a> ';}}});});}return intervalVariable;}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _parseFloat=__webpack_require__(513);var _parseFloat2=_interopRequireDefault(_parseFloat);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSlick=__webpack_require__(113);var _reactSlick2=_interopRequireDefault(_reactSlick);var _ecCom=__webpack_require__(5);var _loadjs=__webpack_require__(114);var _loadjs2=_interopRequireDefault(_loadjs);var _lodash=__webpack_require__(9);__webpack_require__(518);__webpack_require__(519);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import '../css/Sliders.css';
var Sliders=function(_Component){(0,_inherits3.default)(Sliders,_Component);function Sliders(){(0,_classCallCheck3.default)(this,Sliders);var _this=(0,_possibleConstructorReturn3.default)(this,(Sliders.__proto__||(0,_getPrototypeOf2.default)(Sliders)).call(this));_this.state={count:0,width:0};_this.imageCarousel=_this.imageCarousel.bind(_this);var staticVersion='?v'+(_ecCom.WeaTools&&_ecCom.WeaTools.ls&&_ecCom.WeaTools.ls.getStr("staticVersion")||0);(0,_loadjs2.default)(['/social/js/drageasy/drageasy.js'+staticVersion,'/social/js/bootstrap/js/bootstrap.js'+staticVersion,'/social/im/js/IMUtil_wev8.js'+staticVersion,'/social/js/imcarousel/imcarousel.js'+staticVersion]);return _this;}//图片放大轮播
(0,_createClass3.default)(Sliders,[{key:'imageCarousel',value:function imageCarousel(){var imgObj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var e=arguments[1];var imgPool=[];var indexNum=0;jQuery(".portal-picture-img").each(function(){var imgsrc=!!jQuery(this).attr("data-imgsrc")?jQuery(this).attr("data-imgsrc"):jQuery(this).attr("src");imgPool.push(imgsrc);});var imgsrc=jQuery(e.target).attr("src");var _imgPool=[];var data=imgObj.props.data;data.map(function(item){_imgPool.push(item.url);});for(var i=0;i<_imgPool.length;i++){if(imgsrc==_imgPool[i]){indexNum=i;break;}}window.IMCarousel.showImgScanner4Pool(true,_imgPool,indexNum,null,window.top);}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,esetting=_props.esetting,_props$height=_props.height,height=_props$height===undefined?$(this.refs.Slider).height():_props$height;var widthImg=this.state.width;var pictureWidth=esetting.width,_esetting$imageWidthU=esetting.imageWidthUnit,imageWidthUnit=_esetting$imageWidthU===undefined?'px':_esetting$imageWidthU,_esetting$rollingDire=esetting.rollingDirection,rollingDirection=_esetting$rollingDire===undefined?'1':_esetting$rollingDire,pictureHeight=esetting.height,_esetting$imageHeight=esetting.imageHeightUnit,imageHeightUnit=_esetting$imageHeight===undefined?'px':_esetting$imageHeight;var width=$(this.refs.Slider).width();var widthPicture=parseInt(pictureWidth);if(width!=0&&imageWidthUnit=='%'){widthPicture=parseInt(width*parseFloat(pictureWidth+''))/100;}if(imageWidthUnit=='px'&&pictureWidth>width){widthPicture=width;}var count=parseInt(width/widthPicture);if(rollingDirection=='2'&&height&&pictureHeight&&imageHeightUnit=='px'){count=parseInt(parseInt(height)/pictureHeight);}this.setState({count:count,width:width});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,esetting=_props2.esetting,_props2$height=_props2.height,height=_props2$height===undefined?200:_props2$height;var _state=this.state,counted=_state.count,widthed=_state.width;var pictureWidth=esetting.width,button=esetting.button,_esetting$rollingDire2=esetting.rollingDirection,rollingDirection=_esetting$rollingDire2===undefined?'1':_esetting$rollingDire2,_esetting$imageWidthU2=esetting.imageWidthUnit,imageWidthUnit=_esetting$imageWidthU2===undefined?'px':_esetting$imageWidthU2,pictureHeight=esetting.height,imageHeightUnit=esetting.imageHeightUnit;var width=$(this.refs.Slider).width();if(pictureWidth==0)return;var widthImg=parseInt(pictureWidth);if(width!=0&&imageWidthUnit=='%'){widthImg=parseInt(width*parseFloat(pictureWidth+''))/100;}if(imageWidthUnit=='px'&&pictureWidth>width){widthImg=parseInt(width);}var count=parseInt(width/widthImg);if(rollingDirection=='2'&&height&&imageHeightUnit=='px'){count=parseInt(parseInt(height)/pictureHeight);if(pictureHeight>parseInt(height)){count=1;}}if(!isNaN(count)&&count!==counted)this.setState({count:count});if(width!==widthed)this.setState({width:width});}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,eid=_props3.eid,data=_props3.data,esetting=_props3.esetting,isSetting=_props3.isSetting;var elementHeight=this.props.height;if((0,_lodash.isEmpty)(data))return _react2.default.createElement('div',null);var _state2=this.state,count=_state2.count,widthImg=_state2.width;var showType=esetting.showType,button=esetting.button,width=esetting.width,imageWidthUnit=esetting.imageWidthUnit,height=esetting.height,imageHeightUnit=esetting.imageHeightUnit,open=esetting.open,speed=esetting.speed,_esetting$rollingDire3=esetting.rollingDirection,rollingDirection=_esetting$rollingDire3===undefined?'1':_esetting$rollingDire3,_esetting$isAutoHiehg=esetting.isAutoHiehgt,isAutoHiehgt=_esetting$isAutoHiehg===undefined?'0':_esetting$isAutoHiehg;var _esetting$autoShow=esetting.autoShow,autoShow=_esetting$autoShow===undefined?'1':_esetting$autoShow,_esetting$showTitle=esetting.showTitle,showTitle=_esetting$showTitle===undefined?'1':_esetting$showTitle,_esetting$fontSize=esetting.fontSize,fontSize=_esetting$fontSize===undefined?'16':_esetting$fontSize;if(count>data.length){autoShow='0';count=data.length;}if(rollingDirection=='2'&&!elementHeight){elementHeight=200;}var style1={width:'100%',margin:'0 auto',height:elementHeight};// const style  = {width: showType == '1' ? '100%': divWidth2, margin: '0 auto', maxWidth: '92%'};
var style={width:divWidth2,margin:'0 auto',maxWidth:'87%',height:elementHeight};if(button=='0'){style={width:divWidth2,margin:'0 auto',maxWidth:'100%',height:elementHeight};}if(imageHeightUnit=='%'){style.height='100%';}if(imageHeightUnit=='px'){style1.height='100%';}var imgStyle={width:width+imageWidthUnit,height:height+imageHeightUnit,margin:'0 auto',display:'flex',alignItems:'center'};if(rollingDirection=='2'&&elementHeight&&imageHeightUnit=='px'&&parseInt(elementHeight)<parseInt(height)){imgStyle.height=elementHeight;}if(rollingDirection=='2'&&imageHeightUnit=='%'){var heigthPercent=parseFloat(height)/100;imgStyle.height=heigthPercent*parseInt(elementHeight);count=parseInt(1/heigthPercent);style.height=parseInt(elementHeight);}if(width>widthImg&&imageWidthUnit=='px'){imgStyle.width=widthImg+'px';}if(widthImg!=0&&imageWidthUnit=='%'){if(width>=100){count=1;imgStyle.width='100%';}else{imgStyle.width=width*parseFloat(widthImg+'')/100+'px';}}if(isAutoHiehgt=='1'&&rollingDirection!='2'){imgStyle.height='auto';}var divStyle={width:width+4+'px',height:height+'px',display:'flex',alignItems:'center'};var divWidth2=0;var sliderComs=data.map(function(item){divWidth2+=(0,_parseFloat2.default)(width)+5;if(open=='1'){return _react2.default.createElement('div',{title:item.name,style:divStyle},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',height:imgStyle.height,width:'100%'}},_react2.default.createElement('img',{className:'portal-picture-img',src:item.url,alt:'',style:(0,_extends3.default)({},imgStyle,{height:'100%'}),onClick:function onClick(e){return _this2.imageCarousel(_this2,e);}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},item.name))));}else{return _react2.default.createElement('div',{title:item.name,style:{display:'flex'},onClick:function onClick(){if(item.link==''){return;}else window.open(item.link,"target");}},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',height:imgStyle.height}},_react2.default.createElement('img',{className:'portal-picture-img',src:item.url,alt:'',style:(0,_extends3.default)({},imgStyle,{height:'100%'})}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}},item.name))));}});var settings={infinite:true,autoplaySpeed:parseInt(speed),className:"center",dots:false,slidesToShow:count,slidesToScroll:1,autoplay:autoShow=='1',vertical:rollingDirection=='2',pauseOnHover:true,draggable:false,nextArrow:_react2.default.createElement(SampleNextArrow,{button:button,eid:eid}),prevArrow:_react2.default.createElement(SamplePrevArrow,{button:button,eid:eid})};var divWidth="92%";if(button!=="1"){divWidth="100%";}else if(showType=="1"){divWidth="100%";}var carouselCom=_react2.default.createElement(_reactSlick2.default,settings,sliderComs);var className="";if(rollingDirection=='1'){className="portal-picture-slider-across";}return _react2.default.createElement('div',{ref:'Slider',className:'portal-picture-slider '+className,id:'Slider-'+eid+'-'+isSetting,style:showType=='1'?style1:style},showType=='2'?carouselCom:_react2.default.createElement('div',{style:{overflow:'hidden',height:'100%'}},open=='1'?_react2.default.createElement('div',{title:data[0].name,style:(0,_extends3.default)({},imgStyle,{margin:'0 auto',position:'relative'})},_react2.default.createElement('img',{className:'portal-picture-img',src:data[0].url,alt:'',style:{width:'100%',height:'100%'},onClick:function onClick(e){return _this2.imageCarousel(_this2,e);}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},data[0].name))):_react2.default.createElement('div',{style:(0,_extends3.default)({},imgStyle,{margin:'0 auto',position:'relative'})},data[0].link!=''?_react2.default.createElement('a',{title:data[0].name,href:data[0].link,target:'_blank',style:{width:'100%',height:'100%'}},_react2.default.createElement('img',{src:data[0].url,alt:'',style:{width:'100%',height:'100%'}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},data[0].name))):_react2.default.createElement('div',{title:data[0].name,style:{width:'100%',height:'100%'}},_react2.default.createElement('img',{src:data[0].url,alt:'',style:{width:'100%',height:'100%'}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},data[0].name))))));}}]);return Sliders;}(_react.Component);exports.default=Sliders;;function SampleNextArrow(props){var className=props.className,style=props.style,onClick=props.onClick,button=props.button,eid=props.eid;if('1'!==button)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/next-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px",right:"0px","margin-right":"-7%",cursor:"pointer"}),onClick:onClick}));}function SamplePrevArrow(props){var className=props.className,style=props.style,onClick=props.onClick,button=props.button,eid=props.eid;if('1'!==button)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/prev-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px","margin-left":"-7%",cursor:"pointer"}),onClick:onClick});}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(514), __esModule: true };

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(515);
module.exports = __webpack_require__(20).Number.parseFloat;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
var $parseFloat = __webpack_require__(516);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(27).parseFloat;
var $trim = __webpack_require__(517).trim;

module.exports = 1 / $parseFloat(__webpack_require__(156) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
var defined = __webpack_require__(45);
var fails = __webpack_require__(30);
var spaces = __webpack_require__(156);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var View=function(_React$Component){(0,_inherits3.default)(View,_React$Component);function View(props){(0,_classCallCheck3.default)(this,View);var _this=(0,_possibleConstructorReturn3.default)(this,(View.__proto__||(0,_getPrototypeOf2.default)(View)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(View,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){//  const { eid, api } = params;
//  this.setState({
//      edata: ls.getJSONObj('edata-'+eid),
//  });
//  WeaTools.callApi(api || '/api/portal/element/view', 'POST', {...params}).then(result=> {
//      ls.set('edata-'+eid, result);
//      this.setState({
//          edata: result,
//          refresh: false,
//      });
// });
this.setState({edata:[],refresh:false});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return View;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);View=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(View);exports.default=View;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MoreNews=function(_React$Component){(0,_inherits3.default)(MoreNews,_React$Component);function MoreNews(props){(0,_classCallCheck3.default)(this,MoreNews);var _this=(0,_possibleConstructorReturn3.default)(this,(MoreNews.__proto__||(0,_getPrototypeOf2.default)(MoreNews)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MoreNews,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/morenews','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){EContentHtml=edata.data.map(function(item){return _react2.default.createElement('div',{style:{marginBottom:'8px'}},item.img!==''?_react2.default.createElement('div',{style:{float:'left'}},_react2.default.createElement('img',{height:'142',width:'142',src:item.img})):null,_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(item.data?item.data[0]:{},edata.esetting),showHeader:false,pagination:false,dataSource:item.data,size:'small'}));});}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return MoreNews;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MoreNews=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MoreNews);exports.default=MoreNews;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Stock=function(_React$Component){(0,_inherits3.default)(Stock,_React$Component);function Stock(props){(0,_classCallCheck3.default)(this,Stock);var _this=(0,_possibleConstructorReturn3.default)(this,(Stock.__proto__||(0,_getPrototypeOf2.default)(Stock)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Stock,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/stock','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){var esetting=edata.esetting;var linkmode=esetting.linkmode,width=esetting.width,height=esetting.height,eAutoSwitch=esetting.eAutoSwitch,eSpeedSwitch=esetting.eSpeedSwitch;var tdata=edata.data;var carouselSettings={slidesToShow:1,slidesToScroll:1,autoplay:eAutoSwitch=='1',autoplaySpeed:eSpeedSwitch};EContentHtml=_react2.default.createElement('div',{style:{textAlign:'center'}},tdata.length==1?_react2.default.createElement('div',null,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(this,tdata[0].linkUrl,linkmode)},_react2.default.createElement('img',{style:{width:width+'px',height:height+'px',margin:'0 auto'},src:tdata[0].imgUrl,border:'0'}))):_react2.default.createElement(_antd.Carousel,carouselSettings,tdata.map(function(item){return _react2.default.createElement('div',null,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(_this3,item.linkUrl,linkmode)},_react2.default.createElement('img',{style:{width:width+'px',height:height+'px',margin:'0 auto'},src:item.imgUrl,border:'0'})));})));}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Stock;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Stock=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Stock);exports.default=Stock;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _Magazine=__webpack_require__(524);var _Magazine2=_interopRequireDefault(_Magazine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Magazine=function(_React$Component){(0,_inherits3.default)(Magazine,_React$Component);function Magazine(props){(0,_classCallCheck3.default)(this,Magazine);var _this=(0,_possibleConstructorReturn3.default)(this,(Magazine.__proto__||(0,_getPrototypeOf2.default)(Magazine)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Magazine,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/magazine','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Magazine2.default,{eid:eid,data:edata.data,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Magazine;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Magazine=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Magazine);exports.default=Magazine;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Option=_antd.Select.Option;//期刊中心
var MagazineCom=function(_React$Component){(0,_inherits3.default)(MagazineCom,_React$Component);function MagazineCom(){(0,_classCallCheck3.default)(this,MagazineCom);return(0,_possibleConstructorReturn3.default)(this,(MagazineCom.__proto__||(0,_getPrototypeOf2.default)(MagazineCom)).apply(this,arguments));}(0,_createClass3.default)(MagazineCom,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting;return _react2.default.createElement('table',{id:'_contenttable_'+eid,className:'Econtent',width:'100%',cellPadding:'0',cellSpacing:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:'1px'}),_react2.default.createElement('td',{width:'*',className:'valign'},_react2.default.createElement('table',{width:'100%',cellPadding:'0',cellSpacing:'0'},data.map(function(item){return _react2.default.createElement(MagazineItem,{item:item,esetting:esetting});}))),_react2.default.createElement('td',{width:'1px'})));}}]);return MagazineCom;}(_react2.default.Component);var MagazineItem=function(_React$Component2){(0,_inherits3.default)(MagazineItem,_React$Component2);function MagazineItem(props){(0,_classCallCheck3.default)(this,MagazineItem);var _this2=(0,_possibleConstructorReturn3.default)(this,(MagazineItem.__proto__||(0,_getPrototypeOf2.default)(MagazineItem)).call(this,props));_this2.state={linkUrl:''};_this2.handleChange=_this2.handleChange.bind(_this2);return _this2;}(0,_createClass3.default)(MagazineItem,[{key:'handleChange',value:function handleChange(key,value){var _this3=this;var list=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];list.map(function(item){if(item.id==key){_this3.setState({linkUrl:item.link});}});}},{key:'componentWillMount',value:function componentWillMount(){var item=this.props.item;var _item$list=item.list,list=_item$list===undefined?[]:_item$list;if(list.length>0){this.setState({linkUrl:list[0].link});}}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,_props2$item=_props2.item,item=_props2$item===undefined?{}:_props2$item,esetting=_props2.esetting;var width=esetting.width,height=esetting.height,linkmode=esetting.linkmode;var _item$docsubject=item.docsubject,docsubject=_item$docsubject===undefined?{}:_item$docsubject,_item$summary=item.summary,summary=_item$summary===undefined?'':_item$summary,_item$images=item.images,images=_item$images===undefined?[]:_item$images,_item$list2=item.list,list=_item$list2===undefined?[]:_item$list2;var link=docsubject.link,name=docsubject.name;var strImg='/images/go_wev8.gif';var style={tableLayout:'fixed'};var tstyle={tableLayout:'fixed',paddingBottom:'15px',paddingLeft:'3px'};var imgstyle={width:width};if(height!=='0'){imgstyle.height=height;}var imghtml=null;var imghtml1=[];var j=0;if(!(0,_lodash.isEmpty)(images)){if(images.length>1){images.map(function(item,i){if(images[i]!='/images/homepage/noimgdefault_wev8.jpg'){imghtml1[j]=images[i];j++;}});if(imghtml1.length==0){imghtml1=['/images/homepage/noimgdefault_wev8.jpg'];}var ihtml=imghtml1.map(function(item,i){var img=imghtml1[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];return _react2.default.createElement('div',null,_react2.default.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,style:{width:'100%',height:'100%'},src:img}));});imghtml=_react2.default.createElement('td',{className:'valign',width:parseInt(width)+5},_react2.default.createElement('div',{className:'news-silde',style:{marginBottom:'10px'}},_react2.default.createElement(_antd.Carousel,{autoplay:true},ihtml)));}else{var img=images[0];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=_react2.default.createElement('td',{className:'valign',width:parseInt(width)+5},_react2.default.createElement('div',{style:{height:'100%',marginBottom:'10px'},className:'news-silde'},_react2.default.createElement(_antd.Carousel,null,_react2.default.createElement('div',null,_react2.default.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[0]&&list[0].docsubject&&list[0].docsubject.link,style:{width:'100%',height:'100%'},src:img})))));}}else{var _img='/images/homepage/noimgdefault_wev8.jpg';imghtml=_react2.default.createElement('td',{className:'valign',width:parseInt(width)+5},_react2.default.createElement('div',{style:{height:'100%',marginBottom:'10px'},className:'news-silde'},_react2.default.createElement(_antd.Carousel,null,_react2.default.createElement('div',null,_react2.default.createElement(ImgCom,{style:{width:'100%',height:'100%'},src:_img})))));}return _react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('table',{width:'100%',className:'valign',style:style},_react2.default.createElement('tr',null,imghtml,_react2.default.createElement('td',{width:'*',className:'valign'},_react2.default.createElement('table',{width:'100%',className:'magzine',style:tstyle},_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('a',{href:'javascript:void(0);',style:{color:'#666'},onClick:_common.openLinkUrl.bind(this,link,linkmode)},name))),_react2.default.createElement('tr',{className:'sparator',style:{height:'1px'}},_react2.default.createElement('td',{style:{padding:'0px'}})),_react2.default.createElement('tr',null,_react2.default.createElement('td',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,webkitBoxOrient:'vertical',display:'-webkit-box'}},summary))),_react2.default.createElement('table',{width:'100%',cellPadding:'0',cellSpacing:'0',style:tstyle},_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement(_ecCom.WeaSelect,{style:{width:'90%'},options:list.map(function(item,index){var arr={key:item.id,showname:item.name};if(index==0){arr={key:item.id,showname:item.name,selected:true};}return arr;}),onChange:function onChange(key,value){return _this4.handleChange(key,value,list);}// hasAddBtn
// options={options}
// viewAttr={viewAttr}
// value={value}
// onSelectRepeat={(v=>{console.log('onSelectRepeat', v)})}
// onChange={this.handleChange.bind(this)}
}),'\xA0',_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(this,this.state.linkUrl,linkmode)},_react2.default.createElement('img',{style:{marginBottom:'-5px'},src:strImg}))))))))));}}]);return MagazineItem;}(_react2.default.Component);var ImgCom=function(_React$Component3){(0,_inherits3.default)(ImgCom,_React$Component3);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this5=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this5.aClick=_this5.aClick.bind(_this5);return _this5;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props$link=this.props.link,link=_props$link===undefined?'':_props$link;if(link!=''){window.open(link);}else return false;}},{key:'render',value:function render(){var _props3=this.props,_props3$src=_props3.src,src=_props3$src===undefined?'':_props3$src,_props3$style=_props3.style,style=_props3$style===undefined?{width:'100%',height:'100%'}:_props3$style;return _react2.default.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},_react2.default.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MagazineCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MagazineCom);exports.default=MagazineCom;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);__webpack_require__(526);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var DocContent=function(_React$Component){(0,_inherits3.default)(DocContent,_React$Component);function DocContent(props){(0,_classCallCheck3.default)(this,DocContent);var _this=(0,_possibleConstructorReturn3.default)(this,(DocContent.__proto__||(0,_getPrototypeOf2.default)(DocContent)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(DocContent,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/doccontent','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var item=this.props.config.item;var width=$("#content_view_id_"+item.eid).width()||0;this.setState({width:width});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement('div',{className:'portal-element-doc-content',style:{width:'auto'},id:'__content__'+eid,dangerouslySetInnerHTML:{__html:edata.data}});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return DocContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DocContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DocContent);exports.default=DocContent;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Audio=__webpack_require__(528);var _Audio2=_interopRequireDefault(_Audio);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Audio=function(_React$Component){(0,_inherits3.default)(Audio,_React$Component);function Audio(props){(0,_classCallCheck3.default)(this,Audio);var _this=(0,_possibleConstructorReturn3.default)(this,(Audio.__proto__||(0,_getPrototypeOf2.default)(Audio)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Audio,[{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/audio','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var config=this.props.config;var _state=this.state,edata=_state.edata,refresh=_state.refresh;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Audio2.default,{data:edata.data,eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Audio;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Audio=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Audio);exports.default=Audio;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//音频元素
var AudioCom=function(_React$Component){(0,_inherits3.default)(AudioCom,_React$Component);function AudioCom(){(0,_classCallCheck3.default)(this,AudioCom);return(0,_possibleConstructorReturn3.default)(this,(AudioCom.__proto__||(0,_getPrototypeOf2.default)(AudioCom)).apply(this,arguments));}(0,_createClass3.default)(AudioCom,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,esetting=_props.esetting;var autoPlay=esetting.autoPlay,isie=esetting.isie;if(!isie){var attrs={controls:'controls'};if(autoPlay==='on'){attrs['autoplay']='autoplay';}$("#audio_play_"+eid+" audio").attr(attrs);}else{var oAttrs={classid:'clsid:d27cdb6e-ae6d-11cf-96b8-444553540000',codebase:'https://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,0,0'};$("#audioplayer_"+eid).attr(oAttrs);var eAttrs={mce_src:'flash/top.swf',menu:'false',quality:'high',allowscriptaccess:'sameDomain',pluginspage:'https://www.macromedia.com/go/getflashplayer'};$("#audioplayer_"+eid+" embed").attr(eAttrs);}}},{key:'render',value:function render(){var _props2=this.props,eid=_props2.eid,data=_props2.data,esetting=_props2.esetting;var autoPlay=esetting.autoPlay,ePath=esetting.ePath,height=esetting.height,width=esetting.width,isie=esetting.isie;var html=null;var style={width:'100%',height:height};if(isie){html=_react2.default.createElement('object',{id:'audioplayer_'+eid,style:{height:height,textAlign:'middle',width:'100%'}},_react2.default.createElement('param',{name:'quality',value:'best'}),_react2.default.createElement('param',{name:'SAlign',value:'LT'}),_react2.default.createElement('param',{name:'allowScriptAccess',value:'never'}),_react2.default.createElement('param',{name:'wmode',value:'transparent'}),_react2.default.createElement('param',{name:'movie',value:ePath+'resource/js/audio-player.swf?audioUrl='+data.url+'&'+(autoPlay==='on'?'autoPlay=true':'')}),_react2.default.createElement('embed',{src:'"'+ePath+'resource/js/audio-player.swf?audioUrl='+data.url+'&'+(autoPlay==='on'?'autoPlay=true':''),wmode:'transparent',width:'100%',height:height,type:'application/x-shockwave-flash'}));}else{html=_react2.default.createElement('audio',{src:data.url,style:{width:'100%'},controlsList:'nodownload',height:height});}return _react2.default.createElement('div',{id:'audio_play_'+eid,style:style},html);}}]);return AudioCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);AudioCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(AudioCom);exports.default=AudioCom;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Favourite=function(_React$Component){(0,_inherits3.default)(Favourite,_React$Component);function Favourite(props){(0,_classCallCheck3.default)(this,Favourite);var _this=(0,_possibleConstructorReturn3.default)(this,(Favourite.__proto__||(0,_getPrototypeOf2.default)(Favourite)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Favourite,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/favourite','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Favourite;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Favourite=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Favourite);exports.default=Favourite;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Flash=function(_React$Component){(0,_inherits3.default)(Flash,_React$Component);function Flash(props){(0,_classCallCheck3.default)(this,Flash);var _this=(0,_possibleConstructorReturn3.default)(this,(Flash.__proto__||(0,_getPrototypeOf2.default)(Flash)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Flash,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/flash','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){var _edata$data=edata.data,height=_edata$data.height,url=_edata$data.url;var userAgent=navigator.userAgent;//取得浏览器的userAgent字符串
var isChrome=userAgent.indexOf("Chrome")>-1;//判断Chrome浏览器
if(isChrome){EContentHtml=_react2.default.createElement('div',{id:'flash_play_'+eid,style:{width:'100%',height:height+'px',overflowY:'hidden'}},_react2.default.createElement('video',{width:'100%',height:height+'px',src:url,autoplay:'autoplay',controls:'controls'}));}else{EContentHtml=_react2.default.createElement('div',{id:'flash_play_'+eid,style:{width:'100%',height:height+'px',overflowY:'hidden'}},_react2.default.createElement('embed',{width:'100%',height:height+'px',wmode:'opaque',name:'plugin',src:url,type:'application/x-shockwave-flash'}));}}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Flash;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Flash=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Flash);exports.default=Flash;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _immutable=__webpack_require__(532);var _immutable2=_interopRequireDefault(_immutable);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _ImgSlide=__webpack_require__(533);var _ImgSlide2=_interopRequireDefault(_ImgSlide);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var is=_immutable2.default.is,fromJS=_immutable2.default.fromJS;var ls=_ecCom.WeaTools.ls;//元素组件
var ImgSlide=function(_React$Component){(0,_inherits3.default)(ImgSlide,_React$Component);function ImgSlide(props){(0,_classCallCheck3.default)(this,ImgSlide);var _this=(0,_possibleConstructorReturn3.default)(this,(ImgSlide.__proto__||(0,_getPrototypeOf2.default)(ImgSlide)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(ImgSlide,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid;_ecCom.WeaTools.callApi('/api/portal/element/imgslide','POST',params).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var config=this.props.config;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,isSetting=config.isSetting;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ImgSlide2.default,{isSetting:isSetting,data:edata.data,eid:eid});// if(!isEmpty(edata)) EContentHtml = <Sliders isSetting={isSetting} data={edata.data} eid={eid}/>;
}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}if(refresh)EContentHtml=_react2.default.createElement(_antd.Spin,null,EContentHtml);return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},EContentHtml),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return ImgSlide;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:"对不起，流程元素加载异常，请联系管理员！"});}}]);return MyErrorHandler;}(_react2.default.Component);ImgSlide=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ImgSlide);exports.default=ImgSlide;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//多图元素
var ImgSlideCom=function(_React$Component){(0,_inherits3.default)(ImgSlideCom,_React$Component);function ImgSlideCom(props){(0,_classCallCheck3.default)(this,ImgSlideCom);var _this=(0,_possibleConstructorReturn3.default)(this,(ImgSlideCom.__proto__||(0,_getPrototypeOf2.default)(ImgSlideCom)).call(this,props));_this.state={ewidth:0,eheight:0};_this.aClick=_this.aClick.bind(_this);_this.autoCarousel=_this.autoCarousel.bind(_this);_this.initSlide=_this.initSlide.bind(_this);return _this;}(0,_createClass3.default)(ImgSlideCom,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,data=_props.data,isSetting=_props.isSetting;var imgsrclist=data.imgsrclist,imgdesclist=data.imgdesclist,height=data.height,displaydesc=data.displaydesc,cellwidth=data.cellwidth,autoSwitchTime=data.autoSwitchTime;var rowcount=parseInt(data.rowcount);this.initSlide(eid,rowcount,autoSwitchTime);var mleft="-"+18*rowcount/2+'px';$('#banner_'+eid+"_"+isSetting+' ul').css('margin-left',mleft);this.setState({ewidth:$('#content_'+eid).width(),eheight:$('#content_'+eid).height()});}},{key:'aClick',value:function aClick(){var link=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';if(link!=''){window.open(link);}else return false;}},{key:'autoCarousel',value:function autoCarousel(rowcount,autoSwitchTime,_n){var _props2=this.props,eid=_props2.eid,isSetting=_props2.isSetting;if(rowcount>1){clearInterval(window['_t_'+isSetting+'_'+eid]);window['_t_'+isSetting+'_'+eid]=setInterval(function(){_n=_n>=rowcount-1?0:++_n;// $("#banner_"+eid+"_"+isSetting+" li").eq(_n).trigger('click');
bannerClick(eid,_n,rowcount,isSetting);},autoSwitchTime);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'initSlide',value:function initSlide(eid,rowcount,autoSwitchTime){var _this2=this;var isSetting=this.props.isSetting;var _n=0;var _count=0;var temp=rowcount;_count=$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img").length;$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img:not(:first-child)").hide();$("#banner_info_"+eid+"_"+isSetting).click(function(){});$("#banner_"+eid+"_"+isSetting+" li, #banner_info_"+eid+"_"+isSetting+" .slidebox_info_item").click(function(){var i=$(this).attr("data-index")-1;//
_n=i;if(i>=rowcount)return;$("#banner_info_"+eid+"_"+isSetting).unbind().click(function(){});$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img").filter(":visible").css("display","none").parent().children().eq(i).css("display","block");// document.getElementById("banner_"+eid+"_"+isSetting).style.background = "";
if(document.getElementById("banner_"+eid+"_"+isSetting)){document.getElementById("banner_"+eid+"_"+isSetting).style.background="";}$("#banner_"+eid+"_"+isSetting+" li").eq(i).toggleClass("on");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").removeClass("slidebox_info_item_slt");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").eq(i).addClass("slidebox_info_item_slt");$(this).siblings().removeAttr("class");});if(rowcount>1){//_t = setInterval(showAuto.bind(this,eid), autoSwitchTime);
clearInterval(window['_t_'+isSetting+'_'+eid]);window['_t_'+isSetting+'_'+eid]=setInterval(function(){_n=_n>=rowcount-1?0:++_n;// $("#banner_"+eid+"_"+isSetting+" li").eq(_n).trigger('click');
bannerClick(eid,_n,rowcount,isSetting);},autoSwitchTime);}$("#banner_"+eid+"_"+isSetting).hover(function(){// clearInterval(this._t)
$("#settingico_"+eid).parent().show();},function(){_this2.autoCarousel(rowcount,autoSwitchTime,_n);});}},{key:'render',value:function render(){var _this3=this;var _props3=this.props,eid=_props3.eid,data=_props3.data,isSetting=_props3.isSetting;var _state=this.state,ewidth=_state.ewidth,eheight=_state.eheight;var imgsrclist=data.imgsrclist,imgdesclist=data.imgdesclist,_data$height=data.height,height=_data$height===undefined?'0':_data$height,rowcount=data.rowcount,displaydesc=data.displaydesc,cellwidth=data.cellwidth,type=data.type,imgAddress=data.imgAddress,_data$fontSize=data.fontSize,fontSize=_data$fontSize===undefined?'16':_data$fontSize;var style={fontFamily:'微软雅黑'};var style1={display:'none'};if(displaydesc!=1){style={fontFamily:'微软雅黑',display:'none'};style1={};}var col1=new Array();var col2=new Array();for(var j=0;j<parseInt(rowcount);j++){col1.push(_react2.default.createElement('col',{width:cellwidth+'%'}));col2.push(_react2.default.createElement('col',{width:'1px'}));}var liHtml=new Array();var aHtml=new Array();var dHtml=new Array();imgdesclist.map(function(item,i){var astyle={background:'url('+imgsrclist[i]+') center center no-repeat',backgroundSize:'100% 100%',height:'100%'};switch(type){case'adapt':astyle={background:'url('+imgsrclist[i]+') center center no-repeat',backgroundSize:'auto 100%',height:'100%'};break;case'fill':astyle.backgroundRepeat='no-repeat';astyle.backgroundSize='cover';// astyle.width = ewidth;
// astyle.height = eheight;
break;case'tile':astyle={background:'url('+imgsrclist[i]+') repeat',height:'100%'};break;case'stretch':astyle={background:'url('+imgsrclist[i]+') center center / 100% 100% no-repeat',height:'100%'};break;case'center':astyle={background:'url('+imgsrclist[i]+')',backgroundPosition:'center center',backgroundRepeat:'no-repeat'};break;default:astyle.backgroundRepeat='no-repeat';astyle.backgroundSize='100% 100%';astyle.mozBackgroundSize='100% 100%';break;}liHtml.push(_react2.default.createElement('li',{className:i===0?'on':'','data-index':i+1}));if(type=='adapt'){aHtml.push(_react2.default.createElement('div',{className:'portal-imgslide-img',onClick:function onClick(){return _this3.aClick(imgAddress[i]);}},_react2.default.createElement('img',{src:imgsrclist[i],style:{width:'100%'},alt:''})));{/*<a href="javascript:void(0)" onClick={()=>this.aClick(imgAddress[i])}>*/}{/*/!*aHtml.push(<a href={} target="_blank">*!/*/}{/*<div className="slidebox_list_item" style={astyle}>*/}{/*</div>*/}{/*</a>*/}}else{aHtml.push(_react2.default.createElement('a',{className:'portal-imgslide-img',href:'javascript:void(0)',onClick:function onClick(){return _this3.aClick(imgAddress[i]);}},_react2.default.createElement('div',{className:'slidebox_list_item',style:astyle})));}dHtml.push(_react2.default.createElement('td',null,_react2.default.createElement('div',{className:'slidebox_info_item '+(i===0?'slidebox_info_item_slt':''),style:{fontSize:fontSize+'px'},'data-index':i+1},item)));});return _react2.default.createElement('div',{id:'imgslide_'+eid,style:{width:'100%',height:type=='adapt'?'':height+'px'}},_react2.default.createElement('div',{id:'banner_'+eid+'_'+isSetting,className:'slidebox_block',style:{height:'100%'}},_react2.default.createElement('div',{id:'banner_info_'+eid+'_'+isSetting,className:'slidebox_info',style:style},_react2.default.createElement('table',{width:'100%',height:'100%',cellpadding:'0',cellspacing:'0'},_react2.default.createElement('colgroup',null,col1),_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,dHtml)))),_react2.default.createElement('ul',{style:style1},liHtml),_react2.default.createElement('div',{id:'banner_list_'+eid+'_'+isSetting,className:'slidebox_list',style:{height:'100%'}},aHtml)));}}]);return ImgSlideCom;}(_react2.default.Component);function bannerClick(eid,_n,rowcount,isSetting){var i=_n;//
if(i>=rowcount)return;$("#banner_info_"+eid+"_"+isSetting).unbind().click(function(){});$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img").filter(":visible").css("display","none").parent().children().eq(i).css("display","block");if(document.getElementById("banner_"+eid+"_"+isSetting)){document.getElementById("banner_"+eid+"_"+isSetting).style.background="";}$("#banner_"+eid+"_"+isSetting+" li").eq(i).toggleClass("on");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").removeClass("slidebox_info_item_slt");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").eq(i).addClass("slidebox_info_item_slt");$(this).siblings().removeAttr("class");}var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ImgSlideCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ImgSlideCom);exports.default=ImgSlideCom;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _DataCenter=__webpack_require__(535);var _DataCenter2=_interopRequireDefault(_DataCenter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var DataCenter=function(_React$Component){(0,_inherits3.default)(DataCenter,_React$Component);function DataCenter(props){(0,_classCallCheck3.default)(this,DataCenter);var _this=(0,_possibleConstructorReturn3.default)(this,(DataCenter.__proto__||(0,_getPrototypeOf2.default)(DataCenter)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(DataCenter,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/datacenter','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_DataCenter2.default,{config:config,data:edata.data,eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return DataCenter;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DataCenter=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DataCenter);exports.default=DataCenter;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//个人数据元素
var DataCenterCom=function(_React$Component){(0,_inherits3.default)(DataCenterCom,_React$Component);function DataCenterCom(props){(0,_classCallCheck3.default)(this,DataCenterCom);var _this=(0,_possibleConstructorReturn3.default)(this,(DataCenterCom.__proto__||(0,_getPrototypeOf2.default)(DataCenterCom)).call(this,props));_this.state={list:props.data,eContentShowType:_this.props.esetting.eContentShowType};_this.callBack=_this.callBack.bind(_this);return _this;}(0,_createClass3.default)(DataCenterCom,[{key:'componentDidMount',value:function componentDidMount(){this.callBack();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;this.setState({list:nextProps.data},function(){_this2.callBack();});}},{key:'callBack',value:function callBack(){var eid=this.props.eid;var openlink=this.props.esetting.linkmode;var eContentShowType=this.props.esetting.eContentShowType;if(eContentShowType!='1'){$('#content_view_id_'+eid+' .module').hover(function(dom){$(this).css("background-image","none");if(this.clientHeight==240){$(this).find(".mtitle").show().css("padding-top","104px");}else{$(this).find(".mtitle").show().css("padding-top","52px");}$(this).css("opacity",'0.8');},function(){$(this).css("background-image","url(/images/homepage/portalcenter/"+$(this).attr("data-type")+"_wev8.png)");$(this).find(".mtitle").hide();$(this).css("opacity",'1');});}else{$('#content_view_id_'+eid+' .module').hover(function(dom){$(this).css("background-image","none");if(this.clientHeight==240){$(this).find(".mtitle").show().css("padding-top","104px");}else{$(this).find(".mtitle").show().css("padding-top","52px");}$(this).css("opacity",'0.8');},function(){$(this).css("background-image","none");$(this).find(".mtitle").show();$(this).css("opacity",'1');});}//去除点击事件绑定
$('#content_view_id_'+eid+' .module').unbind("click");// $(".module").attr("onclick","");
//再绑定点击事件
$('#content_view_id_'+eid+' .module').click(function(){var dataUrl=$(this).attr("data-url");(0,_common.openLinkUrl)(dataUrl,openlink);});}},{key:'render',value:function render(){var list=this.state.list;var esetting=this.props.esetting;var html=null;switch(list.length){case 1:case 2:case 3:html=list.map(function(item){return _react2.default.createElement(_antd.Col,{span:24/list.length},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'240'}));});break;case 4:html=list.map(function(item){return _react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));});break;case 5:html=list.map(function(item,i){switch(i){case 0:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}),_react2.default.createElement(Module,{esetting:esetting,item:list[i+3],height:'120'}));case 1:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'240'}));case 2:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}),_react2.default.createElement(Module,{esetting:esetting,item:list[i+2],height:'120'}));default:return _react2.default.createElement('div',null);}});break;case 6:html=list.map(function(item,i){return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));});break;case 7:html=list.map(function(item,i){switch(i){case 1:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'})),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:list[i+1],height:'120'}))));case 2:return _react2.default.createElement('div',null);default:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));}});break;case 8:html=list.map(function(item,i){switch(i){case 1:case 4:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'})),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:list[i+1],height:'120'}))));case 2:case 5:return _react2.default.createElement('div',null);default:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));}});break;case 9:html=list.map(function(item,i){switch(i){case 1:case 4:case 7:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'})),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:list[i+1],height:'120'}))));case 2:case 5:case 8:return _react2.default.createElement('div',null);default:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));}});break;}return _react2.default.createElement(_antd.Row,null,html);}}]);return DataCenterCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DataCenterCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DataCenterCom);exports.default=DataCenterCom;var Module=function Module(_ref){var _ref$esetting=_ref.esetting,esetting=_ref$esetting===undefined?{}:_ref$esetting,item=_ref.item,height=_ref.height;var pTop='0px';if(height=='240'){pTop='104px';}else{pTop='52px';}if(esetting.eContentShowType=='1'){return _react2.default.createElement('div',{className:'module '+item.model,'data-type':item.model,'data-url':item.url,style:{backgroundColor:item.color,height:height+'px',backgroundImage:'none'}},_react2.default.createElement('div',{className:'num'},item.value),_react2.default.createElement('div',{className:'mtitle',style:{display:'block',paddingTop:pTop}},item.label));}else{return _react2.default.createElement('div',{className:'module '+item.model,'data-type':item.model,'data-url':item.url,style:{backgroundColor:item.color,height:height+'px'}},_react2.default.createElement('div',{className:'num'},item.value),_react2.default.createElement('div',{className:'mtitle'},item.label));}};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _Video=__webpack_require__(537);var _Video2=_interopRequireDefault(_Video);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Video=function(_React$Component){(0,_inherits3.default)(Video,_React$Component);function Video(props){(0,_classCallCheck3.default)(this,Video);var _this=(0,_possibleConstructorReturn3.default)(this,(Video.__proto__||(0,_getPrototypeOf2.default)(Video)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Video,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/video','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Video2.default,{data:edata.data,eid:eid,datas:edata.datas});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Video;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Video=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Video);exports.default=Video;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSlick=__webpack_require__(113);var _reactSlick2=_interopRequireDefault(_reactSlick);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//视频元素
var VideoCom=function(_React$Component){(0,_inherits3.default)(VideoCom,_React$Component);function VideoCom(props){(0,_classCallCheck3.default)(this,VideoCom);var _this=(0,_possibleConstructorReturn3.default)(this,(VideoCom.__proto__||(0,_getPrototypeOf2.default)(VideoCom)).call(this,props));_this.state={width:0};return _this;}(0,_createClass3.default)(VideoCom,[{key:'componentDidMount',value:function componentDidMount(){var eid=this.props.eid;var width=$('#content_view_id_'+eid).width();this.setState({width:parseInt(parseInt(width)*parseInt("87%")/100)});var fullScreen=this.props.data.fullScreen;if(fullScreen=='on'){}else{if($('#video_play_style_'+eid).length==0){$('<style id=\'video_play_style_'+eid+'\'>#video_play_'+eid+' video::-webkit-media-controls-fullscreen-button{ display: none; } </style>').appendTo('head');}}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var eid=this.props.eid;var nextfullScreen=nextProps.data.fullScreen;var fullScreen=this.props.data.fullScreen;if(fullScreen!=nextfullScreen){if(nextfullScreen=='on'){$('#video_play_style_'+eid).remove();}else{$('<style id=\'video_play_style_'+eid+'\'>#video_play_'+eid+' video::-webkit-media-controls-fullscreen-button{ display: none; } </style>').appendTo('head');}}return true;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,data=_props.data,datas=_props.datas;var width=this.state.width;var height=data.height,quality=data.quality,fullScreen=data.fullScreen,url=data.url,autoPlay=data.autoPlay,isie=data.isie,eVideoShowType=data.eVideoShowType,showMulitline=data.showMulitline,showNums=data.showNums,showTitle=data.showTitle,fontSize=data.fontSize;var isAutoPlay=autoPlay==='on';var isFullScreen=fullScreen==='on';// document.getElementById("myVideo").play()
var EVideoCom=_react2.default.createElement('div',null);if(eVideoShowType=='1'){//单个视频显示
EVideoCom=_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',marginLeft:'10px',marginRight:'10px'}},_react2.default.createElement(VideoItem,{props:this.props,data:data,datas:datas[0],videoRef:this.videoRef,vidRef:this.vidRef}),showTitle=='1'&&_react2.default.createElement('div',{style:(0,_defineProperty3.default)({height:'15%',fontSize:'16px',color:'black',textAlign:'center',width:'100%'},'fontSize',fontSize+'px')},_react2.default.createElement('div',{style:{margin:'0 auto',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},datas[0].title)));}else{//多个视频显示
var settings={className:"center",dots:false,infinite:true,slidesToShow:parseInt(showNums),slidesToScroll:1,autoplay:false,nextArrow:_react2.default.createElement(SampleNextArrow,{eid:eid}),prevArrow:_react2.default.createElement(SamplePrevArrow,{eid:eid})};var sliderComs=_react2.default.createElement('div',null);if(showMulitline){// 多行
EVideoCom=_react2.default.createElement('div',null,datas.map(function(item){return _react2.default.createElement('div',{title:item.title,style:{float:'left',width:parseInt((width-showNums*20)/showNums)+'px',display:'inline-block'}},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',marginLeft:'10px',marginRight:'10px'}},_react2.default.createElement(VideoItem,{props:_this2.props,data:data,datas:item}),showTitle=='1'&&_react2.default.createElement('div',{style:(0,_defineProperty3.default)({height:'15%',fontSize:'16px',color:'black',textAlign:'center',width:'100%'},'fontSize',fontSize+'px')},_react2.default.createElement('div',{style:{margin:'0 auto',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},item.title))));}));}else{//单行
sliderComs=datas.map(function(item){return _react2.default.createElement('div',{title:item.title},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',marginLeft:'10px',marginRight:'10px'}},_react2.default.createElement(VideoItem,{props:_this2.props,data:data,datas:item}),showTitle=='1'&&_react2.default.createElement('div',{style:(0,_defineProperty3.default)({height:'15%',fontSize:'16px',color:'black',textAlign:'center',width:'100%'},'fontSize',fontSize+'px')},_react2.default.createElement('div',{style:{margin:'0 auto',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},item.title))));});EVideoCom=_react2.default.createElement(_reactSlick2.default,settings,sliderComs);}}var style={width:'87%',margin:'0 auto'};if(eVideoShowType=='1')style={width:'100%',height:height};return _react2.default.createElement('div',{id:'video_play_'+eid,style:style},EVideoCom);}}]);return VideoCom;}(_react2.default.Component);var VideoItem=function(_React$Component2){(0,_inherits3.default)(VideoItem,_React$Component2);function VideoItem(){var _ref4;var _temp,_this3,_ret;(0,_classCallCheck3.default)(this,VideoItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=(0,_possibleConstructorReturn3.default)(this,(_ref4=VideoItem.__proto__||(0,_getPrototypeOf2.default)(VideoItem)).call.apply(_ref4,[this].concat(args))),_this3),_this3.videoRef=function(obj){if(obj!=null){obj.play();}},_this3.vidRef=function(obj){if(obj!=null){obj.pause();}},_temp),(0,_possibleConstructorReturn3.default)(_this3,_ret);}//开启自动播放 让video继续播放
//关闭自动播放 让video暂停
(0,_createClass3.default)(VideoItem,[{key:'render',value:function render(){var _props2=this.props,eid=_props2.eid,data=_props2.data,datas=_props2.datas,videoRef=_props2.videoRef,vidRef=_props2.vidRef;var height=data.height,quality=data.quality,fullScreen=data.fullScreen,url=data.url,autoPlay=data.autoPlay,isie=data.isie,eAutoHeight=data.eAutoHeight,eVideoShowType=data.eVideoShowType;var isAutoPlay=autoPlay==='on'&&eVideoShowType=='1';var isFullScreen=fullScreen==='on';return _react2.default.createElement('video',{ref:isAutoPlay?this.videoRef:this.vidRef,src:datas&&datas.videoUrl?datas.videoUrl:url,style:{width:'100%'},height:eAutoHeight?'auto':height,loop:'loop',controlsList:'nodownload',controls:'controls'});}}]);return VideoItem;}(_react2.default.Component);function SampleNextArrow(props){var className=props.className,style=props.style,onClick=props.onClick,eid=props.eid;return _react2.default.createElement('div',{style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/next-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px",right:"0px","margin-right":"-7%",cursor:"pointer"}),onClick:onClick}));}function SamplePrevArrow(props){var className=props.className,style=props.style,onClick=props.onClick,eid=props.eid;return _react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/prev-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px","margin-left":"-7%",cursor:"pointer"}),onClick:onClick});}var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);VideoCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(VideoCom);exports.default=VideoCom;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _Weather=__webpack_require__(539);var _Weather2=_interopRequireDefault(_Weather);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Weather=function(_React$Component){(0,_inherits3.default)(Weather,_React$Component);function Weather(props){(0,_classCallCheck3.default)(this,Weather);var _this=(0,_possibleConstructorReturn3.default)(this,(Weather.__proto__||(0,_getPrototypeOf2.default)(Weather)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Weather,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/weather','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Weather2.default,{data:edata.data,eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Weather;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Weather=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Weather);exports.default=Weather;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//天气元素
var WeatherCom=function(_React$Component){(0,_inherits3.default)(WeatherCom,_React$Component);function WeatherCom(){(0,_classCallCheck3.default)(this,WeatherCom);return(0,_possibleConstructorReturn3.default)(this,(WeatherCom.__proto__||(0,_getPrototypeOf2.default)(WeatherCom)).apply(this,arguments));}(0,_createClass3.default)(WeatherCom,[{key:'componentDidMount',value:function componentDidMount(){$("#weather_"+this.props.eid).attr("align","center");$("#asdad").attr("align","center");}},{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting;var width=esetting.width,autoScroll=esetting.autoScroll;var tabStyle={overflow:'hidden',backgroundColor:'#FFFFFF',width:'100%',tableLayout:'fixed',textAlign:'center'};var trHtml=_react2.default.createElement('td',{width:'*',align:'top'},_react2.default.createElement('span',{height:'20',style:{paddingTop:'5px'}},_react2.default.createElement('img',{src:'/images/icon_wev8.gif'}),'\xA0\xA0',getLabel(386599,'请确认服务器可以访问www.weather.com.cn')));if(data.length!==0){var tdHtml=data.map(function(item,i){return _react2.default.createElement('td',{width:'80',style:{textAlign:'center'}},_react2.default.createElement('div',{className:'wetCityName',style:{height:'20px'}},item.city),_react2.default.createElement('div',{className:'wetCityName',id:'curConditionDiv',style:{width:'80px',cursor:'pointer',height:'40px',lineHeight:'20px'}},_react2.default.createElement('p',{title:item.weather},item.weather)),_react2.default.createElement('div',{style:{width:'80px',bottom:'10px'}},item.img===''?null:_react2.default.createElement('img',{src:item.img,title:item.weather})),_react2.default.createElement('br',null),item.temperature);});var wHtml=_react2.default.createElement('table',{style:{textAlign:'center',margin:'0 auto'},cellpadding:'0',cellspace:'0',border:'0'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{id:'weather_'+eid+'_1',className:'valign',style:{float:'left'}},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,tdHtml)))),_react2.default.createElement('td',{id:'weather_'+eid+'_2',className:'valign'}))));if(autoScroll==='1'){wHtml=_react2.default.createElement('marquee',{direction:'left',scrollamount:'2',onMouseOver:stop(),onMouseOut:start()},wHtml);}trHtml=_react2.default.createElement('tr',null,_react2.default.createElement('td',{style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{id:'weatherback_'+eid,style:{cursor:'hand'},className:'',onClick:backWeatherMarquee(eid)})),_react2.default.createElement('td',{id:'asdad',style:{textAlign:'center'}},_react2.default.createElement('div',{id:'weather_'+eid,style:{textAlign:'center !important'}},_react2.default.createElement('div',{id:'weather_'+eid+'_0',style:{margin:'0 auto',overflow:'hidden',width:width+'px',textAlign:'center'}},wHtml))),_react2.default.createElement('td',{valign:'middle',style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{id:'weathernext_'+eid,className:'',style:{cursor:'hand'},onClick:nextWeatherMarquee(eid)})));}return _react2.default.createElement('table',{id:'weatherTable_'+eid,style:tabStyle,onresize:''},_react2.default.createElement('tbody',null,trHtml));}}]);return WeatherCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);WeatherCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(WeatherCom);exports.default=WeatherCom;function backWeatherMarquee(eid){$("weather_"+eid+"_0").attr("scrollLeft",parseInt($("weather_"+eid+"_0").attr("scrollLeft"))-75);}function start(){}function stop(){}function nextWeatherMarquee(eid){$("weather_"+eid+"_0").attr("scrollLeft",parseInt($("weather_"+eid+"_0").attr("scrollLeft"))+75);}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _OutterSys=__webpack_require__(541);var _OutterSys2=_interopRequireDefault(_OutterSys);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var OutterSys=function(_React$Component){(0,_inherits3.default)(OutterSys,_React$Component);function OutterSys(props){(0,_classCallCheck3.default)(this,OutterSys);var _this=(0,_possibleConstructorReturn3.default)(this,(OutterSys.__proto__||(0,_getPrototypeOf2.default)(OutterSys)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(OutterSys,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/outtersys','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_OutterSys2.default,{data:edata.data||[],eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return OutterSys;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OutterSys=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OutterSys);exports.default=OutterSys;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//集成登录元素
var OutterSysCom=function(_React$Component){(0,_inherits3.default)(OutterSysCom,_React$Component);function OutterSysCom(props){(0,_classCallCheck3.default)(this,OutterSysCom);var _this=(0,_possibleConstructorReturn3.default)(this,(OutterSysCom.__proto__||(0,_getPrototypeOf2.default)(OutterSysCom)).call(this,props));_this.handleOnClick=_this.handleOnClick.bind(_this);return _this;}(0,_createClass3.default)(OutterSysCom,[{key:'handleOnClick',value:function handleOnClick(routeUrl,linkUrl){var _props$esetting=this.props.esetting,esetting=_props$esetting===undefined?{}:_props$esetting;var _esetting$linkmode=esetting.linkmode,linkmode=_esetting$linkmode===undefined?'1':_esetting$linkmode;var url='';if(routeUrl!==''&&routeUrl!==undefined){// url = '/wui/index.jsp#/main' + routeUrl;
url='/spa/integration/static4engine/engine.html#/main'+routeUrl;}else{url=linkUrl;}if(url){if(linkmode=='1'){// 当前页打开
if(window.doThemeAction){window.doThemeAction('onLoadMain',{url:url});}else{window.location.href=url;}}else{window.open(url,'_blank');}}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,esetting=_props.esetting;var displaytype=esetting.displaytype,linkmode=esetting.linkmode,displayLayout=esetting.displayLayout;var num=parseInt(displayLayout);//显示布局 几列
var colArr=new Array();for(var i=0;i<num;i++){colArr.push(i);}var style={};if(num=='2'){style={width:'50%',float:'left',paddingLeft:'25%'};}else if(num=='3'){style={width:'33%',float:'left',paddingLeft:'11%'};}var html=colArr.map(function(i){if('1'===displaytype){//左图式
var dhtml=new Array();var ihtml=new Array();(0,_common.intervalMap)(data,function(obj,j){var n=i+j;var item=data[n];if(item){var name=item.name,routeUrl=item.routeUrl,linkUrl=item.linkUrl,url=item.url,width=item.width,height=item.height;height=height||'35';width=width||'35';name&&dhtml.push(_react2.default.createElement('div',{style:{height:parseInt(height)+3,lineHeight:parseInt(height)+3+'px',marginLeft:'10px'}},_react2.default.createElement('a',{style:{color:'#000000'},href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},name)));url&&ihtml.push(_react2.default.createElement('div',null,_react2.default.createElement('a',{target:Number(linkmode)===2?"_blank":"_self",href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},_react2.default.createElement('img',{height:height,width:width,src:url}))));}},num);return _react2.default.createElement('div',{style:style},_react2.default.createElement('div',{style:{float:'left'}},ihtml),_react2.default.createElement('div',{style:{float:'left'}},dhtml));}else{//上图式
var ohtml=(0,_common.intervalMap)(data,function(obj,j){var n=i+j;var item=data[n];var dHtml=_react2.default.createElement('div',null);var iHtml=_react2.default.createElement('div',null);if(item){var name=item.name,routeUrl=item.routeUrl,linkUrl=item.linkUrl,url=item.url,width=item.width,height=item.height;height=height||'35px';width=width||'35px';dHtml=_react2.default.createElement('div',{style:{height:height,lineHeight:height+'px'}},_react2.default.createElement('a',{style:{color:'#000000'},href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},name));iHtml=_react2.default.createElement('div',null,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},_react2.default.createElement('img',{height:height,width:width,src:url})));}return _react2.default.createElement('div',null,iHtml,dHtml);},num);return _react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_antd.Col,{span:24/num},ohtml));}});return _react2.default.createElement(_antd.Row,null,html);}}]);return OutterSysCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OutterSysCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OutterSysCom);exports.default=OutterSysCom;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _Scratchpad=__webpack_require__(543);var _Scratchpad2=_interopRequireDefault(_Scratchpad);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Scratchpad=function(_React$Component){(0,_inherits3.default)(Scratchpad,_React$Component);function Scratchpad(props){(0,_classCallCheck3.default)(this,Scratchpad);var _this=(0,_possibleConstructorReturn3.default)(this,(Scratchpad.__proto__||(0,_getPrototypeOf2.default)(Scratchpad)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Scratchpad,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/scratchpad','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Scratchpad2.default,{data:edata.data,eid:eid});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Scratchpad;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Scratchpad=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Scratchpad);exports.default=Scratchpad;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ls=_ecCom.WeaTools.ls;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//便签元素
var ScratchpadCom=function(_React$Component){(0,_inherits3.default)(ScratchpadCom,_React$Component);function ScratchpadCom(props){(0,_classCallCheck3.default)(this,ScratchpadCom);var _this=(0,_possibleConstructorReturn3.default)(this,(ScratchpadCom.__proto__||(0,_getPrototypeOf2.default)(ScratchpadCom)).call(this,props));_this.state={text:props.data.text,disabled:false};_this.getBytesLength=_this.getBytesLength.bind(_this);_this.subStringByBytes=_this.subStringByBytes.bind(_this);_this.saveScratchpad=_this.saveScratchpad.bind(_this);_this.saveContent=_this.saveContent.bind(_this);return _this;}(0,_createClass3.default)(ScratchpadCom,[{key:'getBytesLength',value:function getBytesLength(str){// 在GBK编码里，除了ASCII字符，其它都占两个字符宽
return str.replace(/[^\x00-\xff]/g,'xx').length;}},{key:'subStringByBytes',value:function subStringByBytes(val,maxBytesLen){var len=maxBytesLen;var result=val.slice(0,len);while(getBytesLength(result)>maxBytesLen){result=result.slice(0,--len);}return result;}},{key:'saveScratchpad',value:function saveScratchpad(padcontent){this.state={text:padcontent,disabled:true};this.onSave(padcontent);}},{key:'onSave',value:function onSave(text){var len=this.getBytesLength(text);if(len>4000){var reply=confirm(getLabel(388031,"便签内容超过4000字节,内容将被截取,是否保存?"));if(reply){text=subStringByBytes(padcontent,4000);this.saveContent(text);}else{this.state={disabled:false};}}else{this.saveContent(text);}}},{key:'saveContent',value:function saveContent(padcontent){var _this2=this;var _props=this.props,eid=_props.eid,data=_props.data;var userid=data.userid;ls.set('edata-'+eid,padcontent);_ecCom.WeaTools.callApi('/api/portal/scratchpad/saveScratchpad','POST',{eid:eid,userid:userid,operation:'save',padcontent:padcontent},'text').then(function(result){_this2.state={disabled:false};});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.state.text,nextProps.data.text)){this.setState({text:nextProps.data.text});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(!(0,_lodash.isEqual)(this.state.text,nextProps.data.text)||!(0,_lodash.isEqual)(this.props.data.height,nextProps.data.height)){return true;}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var text=this.state.text;this.onSave(text);}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,eid=_props2.eid,data=_props2.data;var _state=this.state,text=_state.text,disabled=_state.disabled;return _react2.default.createElement('div',{className:'scratchpad',id:'scratchpad_'+eid},_react2.default.createElement(_ecCom.WeaTextarea,{id:'scratchpadarea_'+eid,style:{height:data.height+'px'},value:text,viewAttr:disabled?1:2,onChange:function onChange(v){_this3.setState({text:v});},onBlur:this.saveScratchpad}));}}]);return ScratchpadCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ScratchpadCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ScratchpadCom);exports.default=ScratchpadCom;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _Slide=__webpack_require__(545);var _Slide2=_interopRequireDefault(_Slide);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Slide=function(_React$Component){(0,_inherits3.default)(Slide,_React$Component);function Slide(props){(0,_classCallCheck3.default)(this,Slide);var _this=(0,_possibleConstructorReturn3.default)(this,(Slide.__proto__||(0,_getPrototypeOf2.default)(Slide)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Slide,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/slide','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Slide2.default,{eid:eid,data:!refresh?edata.data:[],esetting:edata.esetting,isSetting:config.isSetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Slide;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Slide=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Slide);exports.default=Slide;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//幻灯片元素
var SlideCom=function(_React$Component){(0,_inherits3.default)(SlideCom,_React$Component);function SlideCom(){(0,_classCallCheck3.default)(this,SlideCom);return(0,_possibleConstructorReturn3.default)(this,(SlideCom.__proto__||(0,_getPrototypeOf2.default)(SlideCom)).apply(this,arguments));}(0,_createClass3.default)(SlideCom,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,eid=_props.eid,isSetting=_props.isSetting,esetting=_props.esetting;var iconImgList=esetting.iconImgList,iconImg_overList=esetting.iconImg_overList,values=esetting.values;if(values){loadSlideCss(eid,isSetting,iconImgList,iconImg_overList,values);}}},{key:'componentDidMount',value:function componentDidMount(){var _props2=this.props,eid=_props2.eid,isSetting=_props2.isSetting,esetting=_props2.esetting;var iconImgList=esetting.iconImgList,iconImg_overList=esetting.iconImg_overList,values=esetting.values;if(values){loadSlideCss(eid,isSetting,iconImgList,iconImg_overList,values);}}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,eid=_props3.eid,_props3$data=_props3.data,data=_props3$data===undefined?[]:_props3$data,_props3$esetting=_props3.esetting,esetting=_props3$esetting===undefined?{}:_props3$esetting;var values=esetting.values;var sposition=values?values['slide_t_position']:'0';var fontSize=values?values['fontSize']:'16';var showTitle=values?values['showTitle']:'0';var showType=values?values['showType']:'1';var titleStyle={backgroundColor:'#332a2a',color:'rgb(255, 255, 255)',fontSize:fontSize+'px'};if(showType=='2'){titleStyle={backgroundColor:'rgb(255, 255, 255)',color:'black',fontSize:fontSize+'px'};}var isAuto=values?values['slide_t_picShow']:'normal';var sdStyle={background:'url(\"\") no-repeat',cursor:'pointer',position:'relative'};var scStyle={cursor:'pointer'};var imgStyle=isAuto=='auto'?{}:{width:'100%',height:'100%'};var imgHtml=data.map(function(item,i){return _react2.default.createElement('div',{className:'slideDiv','data-index':i,alt:item.title+'...',style:sdStyle},_react2.default.createElement('img',{style:imgStyle,onClick:_common.openLinkUrl.bind(_this2,item.linkUrl,'3'),src:item.url,alt:''}),showTitle=='1'&&_react2.default.createElement('div',{className:'portal-slide-title',style:titleStyle},item.title),_react2.default.createElement('div',{className:'slideDiv',onClick:_common.openLinkUrl.bind(_this2,item.linkUrl,'3'),style:scStyle}));});var html=null;switch(sposition){case'1':html=_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{style:{width:'150px'}},_react2.default.createElement('div',{className:'slideTitle'},_react2.default.createElement('div',{className:'slideTitleFloat'}),_react2.default.createElement('div',{className:'slideTitleNavContainer'}))),_react2.default.createElement('td',{width:'*'},_react2.default.createElement('div',{className:'slideContinar',style:scStyle},imgHtml))));break;case'2':html=_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:'*'},_react2.default.createElement('div',{className:'slideContinar',style:scStyle},imgHtml)),_react2.default.createElement('td',{style:{width:'150px'}},_react2.default.createElement('div',{className:'slideTitle'},_react2.default.createElement('div',{className:'slideTitleFloat'}),_react2.default.createElement('div',{className:'slideTitleNavContainer'})))));break;default:html=_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('div',{className:'slideContinar',style:scStyle},imgHtml))),_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('div',{className:'slideTitle'},_react2.default.createElement('div',{className:'slideTitleFloat'}),_react2.default.createElement('div',{className:'slideTitleNavContainer'})))));break;}return _react2.default.createElement('table',{style:{width:'100%',height:'165px',tableLayout:'fixed',borderSpacing:0},id:'slideArea_'+eid,border:'0'},html);}}]);return SlideCom;}(_react2.default.Component);//幻灯片播放图片效果
var loadSlideCss=function loadSlideCss(eid){var isSetting=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var iconImgList=arguments[2];var iconImg_overList=arguments[3];var values=arguments[4];$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitleNavContainer').empty();$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').cycle({//turnUp   //fade  //uncover
fx:values['slide_t_changeStyle'],//blindX     * blindY    * blindZ    * cover    * curtainX    * curtainY    * fade    * fadeZoom    * growX    * growY    * none   * scrollUp    * scrollDown    * scrollLeft    * scrollRight    * scrollHorz    * scrollVert    * shuffle    * slideX    * lideY   * toss    * turnUp    * turnDown    * turnLeft    * turnRight    * uncover    * wipe    * zoom*/
timeout:(0,_common._s2Int)(values['slide_t_AutoChangeTime']),pager:'.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitleNavContainer',pagerAnchorBuilder:pagerFactory,before:function before(currSlideElement,nextSlideElement,options,forwardFlag){var nextIndex=$(nextSlideElement).attr("data-index");var slidnavtitleArray=$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slidnavtitle");var newTop=0;var newLeft=0;if(slidnavtitleArray.length!=0){var nextSlidnavtitle=$($(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slidnavtitle")[nextIndex]);newTop=nextSlidnavtitle.position().top;if(values['slide_t_position']==='2'){newLeft=nextSlidnavtitle.position().right;}else{newLeft=nextSlidnavtitle.position().left;}}var topvalue=values['slide_t_position']==='3'?newTop-10:newTop;var backgroundsize=values['slide_t_picShow']=="normal"?"100% 100% ":"";if(values['slide_t_position']==='2'){$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slideTitleFloat").css({"display":"block","top":topvalue,"right":newLeft,"background":"url("+iconImg_overList[nextIndex]+") no-repeat","background-size":backgroundsize});}else{$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slideTitleFloat").css({"display":"block","top":topvalue,"left":newLeft,"background":"url("+iconImg_overList[nextIndex]+") no-repeat","background-size":backgroundsize});}},fit:1,width:'100%',height:'100%'});$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').addClass("slideritem");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').css("width","100%");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').css("overflow","hidden");$('.homepage[data-isSetting='+isSetting+'] #content_view_id_'+eid).css("overflow","hidden");function pagerFactory(idx,slide){if(values['slide_t_position']==='3'){var s=idx>3?' style="display:true"':'';}else{var s=idx>3?' style="display:none"':'';}var className="";if(idx===0){className="activeSlide";}if(values['slide_t_picShow']=="normal"){return'<div '+s+' class="slidnavtitle '+className+'"  style="background:url('+iconImgList[idx]+') no-repeat;background-size:100% 100%;">&nbsp;</div>';}else{return'<div '+s+' class="slidnavtitle '+className+'"  style="background:url('+iconImgList[idx]+') no-repeat;">&nbsp;</div>';}};if(values['slide_t_position']==='3'){$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid).find(".slideTitleNavContainer").css({"margin":"0 auto"});$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slideTitleFloat").css({"margin":"0 auto","top":10+Math.round($(".slideTitleFloat").offset().top)+"px"});}$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("z-index","1001");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("position","relative");if(values['slide_t_position']==='1'){$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("width","150px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("float","left");}if(values['slide_t_position']==='2'){$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("width","150px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("float","right");}if(values['slide_t_position']==='3'){$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("height","40px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("padding-top","10px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("text-align","center");}var slidnavtitle=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle  .slidnavtitle');slidnavtitle.css("cursor","pointer");if(values['slide_t_position']==='3'){slidnavtitle.css("margin-right","5px");slidnavtitle.css("height","40px");slidnavtitle.css("width","75px");slidnavtitle.css("float","left");}else{slidnavtitle.css("height","40px");}var slidnavtitle=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitleFloat');slidnavtitle.css("position","absolute");slidnavtitle.css("display","block");if(values['slide_t_position']==='3'){slidnavtitle.css("height","40px");slidnavtitle.css("width","79px");}else{slidnavtitle.css("height","40px");slidnavtitle.css("width","165px");}var slideContinar=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar');var slideDev=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideDiv');slideContinar.css("padding","0");slideContinar.css("overflow","hidden");slideContinar.css("table-layout","fixed");slideContinar.css("width","100%");slideContinar.css("margin","0");if(values['slide_t_position']==='3'){slideContinar.css("height","220px");slideDev.css("height","220px");}else{slideContinar.css("height","160px");slideDev.css("height","160px");}var slideTitleNavContainer=$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid).find(".slideTitleNavContainer");if(values['slide_t_position']==='3'){slideTitleNavContainer.css("display","inline-block");slideTitleNavContainer.css("_display","block");}};var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SlideCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SlideCom);exports.default=SlideCom;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var JobsInfo=function(_React$Component){(0,_inherits3.default)(JobsInfo,_React$Component);function JobsInfo(props){(0,_classCallCheck3.default)(this,JobsInfo);var _this=(0,_possibleConstructorReturn3.default)(this,(JobsInfo.__proto__||(0,_getPrototypeOf2.default)(JobsInfo)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(JobsInfo,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/jobsinfo','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return JobsInfo;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);JobsInfo=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(JobsInfo);exports.default=JobsInfo;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _SearchEngine=__webpack_require__(548);var _SearchEngine2=_interopRequireDefault(_SearchEngine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var SearchEngine=function(_React$Component){(0,_inherits3.default)(SearchEngine,_React$Component);function SearchEngine(props){(0,_classCallCheck3.default)(this,SearchEngine);var _this=(0,_possibleConstructorReturn3.default)(this,(SearchEngine.__proto__||(0,_getPrototypeOf2.default)(SearchEngine)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(SearchEngine,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/searchengine','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_SearchEngine2.default,{data:edata.data,eid:eid});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return SearchEngine;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SearchEngine=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SearchEngine);exports.default=SearchEngine;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(26);var _classnames2=_interopRequireDefault(_classnames);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var InputGroup=_antd.Input.Group;//搜索元素
var SearchEngineCom=function(_React$Component){(0,_inherits3.default)(SearchEngineCom,_React$Component);function SearchEngineCom(){(0,_classCallCheck3.default)(this,SearchEngineCom);return(0,_possibleConstructorReturn3.default)(this,(SearchEngineCom.__proto__||(0,_getPrototypeOf2.default)(SearchEngineCom)).apply(this,arguments));}(0,_createClass3.default)(SearchEngineCom,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data;return _react2.default.createElement('div',{id:'searchengine_'+eid,style:{paddingTop:'10px',paddingBottom:"10px"}},_react2.default.createElement(SearchInput,{placeholder:getLabel(388032,"请输入您要搜索的内容"),onSearch:function onSearch(value){return window.open(data.url+'&keyword='+value);},style:{width:300}}));}}]);return SearchEngineCom;}(_react2.default.Component);var SearchInput=_react2.default.createClass({displayName:'SearchInput',getInitialState:function getInitialState(){return{value:'',focus:false};},handleInputChange:function handleInputChange(e){this.setState({value:e.target.value});},handleFocusBlur:function handleFocusBlur(e){this.setState({focus:e.target===document.activeElement});},handleSearch:function handleSearch(){if(this.props.onSearch){this.props.onSearch(this.state.value);}},render:function render(){var _props2=this.props,style=_props2.style,size=_props2.size,placeholder=_props2.placeholder;var btnCls=(0,_classnames2.default)({'ant-search-btn':true,'ant-search-btn-noempty':!!this.state.value.trim(),'portal-serachButton':true});var searchCls=(0,_classnames2.default)({'ant-search-input':true,'ant-search-input-focus':this.state.focus});return _react2.default.createElement('div',{className:'ant-search-input-wrapper',style:style},_react2.default.createElement(InputGroup,{className:searchCls},_react2.default.createElement(_antd.Input,{placeholder:placeholder,value:this.state.value,onChange:this.handleInputChange,onFocus:this.handleFocusBlur,onBlur:this.handleFocusBlur,onPressEnter:this.handleSearch}),_react2.default.createElement('div',{className:'ant-input-group-wrap'},_react2.default.createElement(_antd.Button,{icon:'search',height:'26px',className:btnCls,size:size,onClick:this.handleSearch}))));}});var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SearchEngineCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SearchEngineCom);exports.default=SearchEngineCom;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _CustomMenu=__webpack_require__(550);var _CustomMenu2=_interopRequireDefault(_CustomMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var CustomMenu=function(_React$Component){(0,_inherits3.default)(CustomMenu,_React$Component);function CustomMenu(props){(0,_classCallCheck3.default)(this,CustomMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(CustomMenu.__proto__||(0,_getPrototypeOf2.default)(CustomMenu)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(CustomMenu,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/custommenu','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var menuType=esetting.menuType;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_CustomMenu2.default,{config:config,data:edata.data,eid:eid,esetting:esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),// menuType && menuType =='menuh' ? <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%', minHeight: '46px'}}>
//     <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
//         <div style={{position: 'absolute', zIndex: '10'}}>
//             <Spin spinning={refresh}>{EContentHtml}</Spin>
//         </div>
//     </div>
//     <div style = {{textAlign:'right'}} id={`footer_${eid}`}></div>
// </div>
//     :
_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return CustomMenu;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomMenu=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomMenu);exports.default=CustomMenu;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);__webpack_require__(551);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//自定义菜单元素
var CustomMenuCom=function(_React$Component){(0,_inherits3.default)(CustomMenuCom,_React$Component);function CustomMenuCom(){(0,_classCallCheck3.default)(this,CustomMenuCom);return(0,_possibleConstructorReturn3.default)(this,(CustomMenuCom.__proto__||(0,_getPrototypeOf2.default)(CustomMenuCom)).apply(this,arguments));}(0,_createClass3.default)(CustomMenuCom,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,esetting=_props.esetting,data=_props.data;var menuType=esetting.menuType;var menuHtml='';if(menuType=='menuh'){menuHtml=getMenuHHtml(data,0);}else if(menuType=='menuv'){menuHtml=getMenuVHtml(data,0);}return _react2.default.createElement('div',{id:'menu_'+eid},_react2.default.createElement('div',{className:menuType},menuHtml));}}]);return CustomMenuCom;}(_react2.default.Component);var getMenuHHtml=function getMenuHHtml(data,level,linkmode){return _react2.default.createElement('ul',null,data.map(function(item){var status="";if(level==0){status="/js/jquery/plugins/menu/menuh/down_wev8.gif";}else{status="/js/jquery/plugins/menu/menuh/right_wev8.gif";}return _react2.default.createElement('li',null,_react2.default.createElement('a',{href:'javascript:;',onClick:function onClick(){return(0,_common.openLinkUrl)(item.href);},className:level==0?'main':'sub'},item.name,item.children.length!=0?_react2.default.createElement('img',{style:{position:"absolute",top:"10px",right:"10px"},src:status}):null),getMenuHHtml(item.children,level+1));}));};var getMenuVHtml=function getMenuVHtml(data,level){return data.map(function(item,index){return _react2.default.createElement('div',{className:index==0?'mainBg_top':'mainBg'},_react2.default.createElement('a',{href:'javascript:;',onClick:function onClick(){return(0,_common.openLinkUrl)(item.href,item.target=='mainFrame'?'1':'2');},className:'mainFont'},item.name),item.children.map(function(item){return _react2.default.createElement('a',{href:'javascript:;',onClick:function onClick(){return(0,_common.openLinkUrl)(item.href,item.target=='mainFrame'?'1':'2');},className:'sub'},item.name);}));});};var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomMenuCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomMenuCom);exports.default=CustomMenuCom;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(552);__webpack_require__(553);__webpack_require__(554);

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _Notice=__webpack_require__(556);var _Notice2=_interopRequireDefault(_Notice);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Notice=function(_React$Component){(0,_inherits3.default)(Notice,_React$Component);function Notice(props){(0,_classCallCheck3.default)(this,Notice);var _this=(0,_possibleConstructorReturn3.default)(this,(Notice.__proto__||(0,_getPrototypeOf2.default)(Notice)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Notice,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/notice','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Notice2.default,{data:edata.data,eid:eid});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Notice;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Notice=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Notice);exports.default=Notice;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//公告栏元素
var NoticeCom=function(_React$Component){(0,_inherits3.default)(NoticeCom,_React$Component);function NoticeCom(){(0,_classCallCheck3.default)(this,NoticeCom);return(0,_possibleConstructorReturn3.default)(this,(NoticeCom.__proto__||(0,_getPrototypeOf2.default)(NoticeCom)).apply(this,arguments));}(0,_createClass3.default)(NoticeCom,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,data=_props.data;var direction=data.direction,scrollDelay=data.scrollDelay;$("#notice_marq"+eid).attr({direction:direction,onmouseout:'this.start()',onmouseover:'this.stop()',scrollAmount:'1',align:'bottom',scrollDelay:scrollDelay,scrollleft:'0',scrolltop:'0'});}},{key:'render',value:function render(){var _props2=this.props,eid=_props2.eid,data=_props2.data;var content=data.content,onlytext=data.onlytext,title=data.title,img=data.img;var chtml=onlytext==='yes'?_react2.default.createElement('span',null,content):_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:content}});var width='95%';var thtml=null;if(title){width='75%';thtml=_react2.default.createElement('div',{style:{float:'left',marginLeft:'5px',width:'20%'}},title);}return _react2.default.createElement('div',null,_react2.default.createElement('div',{style:{float:'left',marginLeft:'5px'}},_react2.default.createElement('img',{src:img})),thtml,_react2.default.createElement('div',{style:{float:'right',marginLeft:'10px',width:width}},_react2.default.createElement('marquee',{id:'notice_marq'+eid},chtml)));}}]);return NoticeCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NoticeCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NoticeCom);exports.default=NoticeCom;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(558);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Mail=function(_React$Component){(0,_inherits3.default)(Mail,_React$Component);function Mail(props){(0,_classCallCheck3.default)(this,Mail);var _this=(0,_possibleConstructorReturn3.default)(this,(Mail.__proto__||(0,_getPrototypeOf2.default)(Mail)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Mail,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/mail','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'unread':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,getElementStyle:this.props.getElementStyle,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Mail;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Mail=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Mail);exports.default=Mail;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _Title=__webpack_require__(559);var _Title2=_interopRequireDefault(_Title);var _Mail=__webpack_require__(560);var _Mail2=_interopRequireDefault(_Mail);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));var currentTab=props.edata.currenttab||props.edata.tabids[0];_this.state={tabdata:props.edata.data[currentTab],currentTab:currentTab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){var currentTab=nextProps.edata.currenttab||nextProps.edata.tabids[0];this.setState({tabdata:nextProps.edata.data[currentTab],currentTab:currentTab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props=this.props,edata=_props.edata,config=_props.config;var params=config.params;var currentTab=this.state.currentTab;this.setState({currentTab:tabid,tabdata:edata.data[tabid],refresh:tabid===currentTab});setTimeout(function(){_this2.setState({refresh:false});},100);}},{key:'render',value:function render(){var contentHtml=_react2.default.createElement('div',null);var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting,data=edata.data;var goUrl=data.goUrl;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};if(tabdata){contentHtml=_react2.default.createElement(_Mail2.default,{list:tabdata,currTab:currentTab,esetting:esetting,olist:edata.data.oplist,goUrl:goUrl});}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//我的邮件
var MailCom=function(_React$Component){(0,_inherits3.default)(MailCom,_React$Component);function MailCom(){(0,_classCallCheck3.default)(this,MailCom);return(0,_possibleConstructorReturn3.default)(this,(MailCom.__proto__||(0,_getPrototypeOf2.default)(MailCom)).apply(this,arguments));}(0,_createClass3.default)(MailCom,[{key:'render',value:function render(){var _props=this.props,currTab=_props.currTab,list=_props.list,esetting=_props.esetting,olist=_props.olist,goUrl=_props.goUrl;var operHtml=null;var receiveUrl=goUrl+'&'+olist.map(function(item){return'receivemailid='+item.id;}).join('&');if(esetting.opershow&&currTab==='unread'){operHtml=_react2.default.createElement('div',{className:'mail-sparator'},_react2.default.createElement('font',{className:'mail-sparator-font'},getLabel(388018,"邮件服务器上的新邮件:"),'\xA0',olist.map(function(item){return _react2.default.createElement('span',null,item.name,'(',item.number,')');}),'\xA0',_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(this,receiveUrl)},getLabel(20267,"进入我的邮件收取"))));}return _react2.default.createElement('div',null,list.length!==0?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(list[0],esetting),showHeader:false,pagination:false,dataSource:list,size:'small'}):_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,' ',_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据'))),operHtml);}}]);return MailCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MailCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MailCom);exports.default=MailCom;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(53);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var CoreMail=function(_React$Component){(0,_inherits3.default)(CoreMail,_React$Component);function CoreMail(props){(0,_classCallCheck3.default)(this,CoreMail);var _this=(0,_possibleConstructorReturn3.default)(this,(CoreMail.__proto__||(0,_getPrototypeOf2.default)(CoreMail)).call(this,props));_this.state={edata:null,refresh:false,weaCoreMailLoaded:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(CoreMail,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/coremail','POST',(0,_extends3.default)({},params)).then(function(result){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+(0,_stringify2.default)(result)};ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;// 异步加载集成模块静态资源
eventRegister.loadModule('b_integration',function(){setTimeout(function(){return _this3.setState({weaCoreMailLoaded:true});},100);},function(){});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,weaCoreMailLoaded=_state.weaCoreMailLoaded;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=weaCoreMailLoaded&&window.weaIntegrationEngine&&window.weaIntegrationEngine.com?_react2.default.createElement(window.weaIntegrationEngine.com.CoremailForPortal,{params:edata}):_react2.default.createElement('div',null);}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return CoreMail;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CoreMail=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CoreMail);exports.default=CoreMail;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(563);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var BlogStatus=function(_React$Component){(0,_inherits3.default)(BlogStatus,_React$Component);function BlogStatus(props){(0,_classCallCheck3.default)(this,BlogStatus);var _this=(0,_possibleConstructorReturn3.default)(this,(BlogStatus.__proto__||(0,_getPrototypeOf2.default)(BlogStatus)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(BlogStatus,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/blogstatus','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var currenttab=edata.currenttab,tabids=edata.tabids,titles=edata.titles,counts=edata.counts,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,counts:counts,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return BlogStatus;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);BlogStatus=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(BlogStatus);exports.default=BlogStatus;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(564);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));var currentTab=props.edata.currenttab||props.edata.tabids[0];_this.state={tabdata:props.edata.data[currentTab],currentTab:currentTab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){var currentTab=nextProps.edata.currenttab||nextProps.edata.tabids[0];this.setState({tabdata:nextProps.edata.data[currentTab],currentTab:currentTab,refresh:false});}}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props=this.props,edata=_props.edata,config=_props.config;var params=config.params;var currentTab=this.state.currentTab;this.setState({currentTab:tabid,tabdata:edata.data[tabid],refresh:tabid===currentTab});setTimeout(function(){_this2.setState({refresh:false});},100);}},{key:'render',value:function render(){var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var eid=config.item.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting,counts=edata.counts;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var contentHtml=tabdata&&tabdata.length?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata[0],esetting),showHeader:false,pagination:false,dataSource:tabdata,size:'small'}):_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,' ',_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,counts:counts,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,_props3$counts=_props3.counts,counts=_props3$counts===undefined?[]:_props3$counts,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$item3=config.item,eid=_config$item3.eid,ebaseid=_config$item3.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);__webpack_require__(566);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(567);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Contacts=function(_React$Component){(0,_inherits3.default)(Contacts,_React$Component);function Contacts(props){(0,_classCallCheck3.default)(this,Contacts);var _this=(0,_possibleConstructorReturn3.default)(this,(Contacts.__proto__||(0,_getPrototypeOf2.default)(Contacts)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Contacts,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/contacts','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentWillMount',value:function componentWillMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,fontSizeMp:fontSizeMp,config:config,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height,overflowX:'auto'}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Contacts;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Contacts=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Contacts);exports.default=Contacts;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(568);var _Title2=_interopRequireDefault(_Title);var _Contacts=__webpack_require__(569);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.searchContacts=_this.searchContacts.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid,value){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/contactstab','POST',(0,_extends3.default)({},params,{tabid:tabid,key:typeof value=='string'?value:''})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'searchContacts',value:function searchContacts(value){this.handleTabData(this.state.currentTab,value);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var _tabdata$dataColoums=tabdata.dataColoums,dataColoums=_tabdata$dataColoums===undefined?[]:_tabdata$dataColoums;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;esetting.dataColoums=dataColoums;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=tabdata&&tabdata.data.length?_react2.default.createElement(_Contacts.ContactsCom,{eid:eid,list:tabdata.data,esetting:esetting}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,tabwimethodvaluedth:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Contacts.SearchInput,{placeholder:getLabel(83815,"搜索姓名/首字母/手机号"),type:'contacts',onSearch:this.searchContacts,style:{width:'300px',marginTop:'5px'}}),_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _classnames=__webpack_require__(26);var _classnames2=_interopRequireDefault(_classnames);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InputGroup=_antd.Input.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ContactsCom=function(_React$Component){(0,_inherits3.default)(ContactsCom,_React$Component);function ContactsCom(){(0,_classCallCheck3.default)(this,ContactsCom);return(0,_possibleConstructorReturn3.default)(this,(ContactsCom.__proto__||(0,_getPrototypeOf2.default)(ContactsCom)).apply(this,arguments));}(0,_createClass3.default)(ContactsCom,[{key:'openHrm',value:function openHrm(url){if(url)window.open(url);}},{key:'render',value:function render(){var _props=this.props,eid=_props.eid,list=_props.list,esetting=_props.esetting;var widths=esetting.widths,imgSymbol=esetting.imgSymbol,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle,dataColoums=esetting.dataColoums;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var trArr=new Array();var titleArr=new Array();var ContactHtml='';var columns=new Array();columns=(0,_common.formatData)(list[0],esetting);ContactHtml=_react2.default.createElement(_ecCom.WeaTable,{style:{fontSize:'20px'},columns:columns,showHeader:esetting.showHeader=='1',pagination:false,dataSource:list,size:'small'});// console.log(widths[companyworkyear])
//         titleArr.push(<td height="31" width="8px"></td>);
// dataColoums.map((item, index) => {
//     let size = 1;
//
//     let html1 = (<td  data-order={size-1} height="31" style={{textAlign:'left',minWidth:'50px'}}>
// 		<font className={`font wea-f${contentfontsize}`}>{item.fieldName}</font>
// 	</td>)
//     titleArr.push(html1);
// })
// let width = titleArr.dataIndex && widths[titleArr.dataIndex];
// console.log(width)
// list.map((item,i)=>{
// 	let size = 1;
// 	var tdArr = new Array;
// 	var index = 0;
// 	tdArr.push(<td height="31" width="8px">{imgSymbol ? <img style={{verticalAlign: 'super'}} name='esymbol' src={imgSymbol}/>: null}</td>);
// 	for (var k in item) {
// 		if('name'=== k) {
// 			tdArr.push(<td  height="31" style={{minWidth :"50px",width:widths.k}}  data-order={size - 1}>
// 				<a href="javascript:void(0);" onClick={this.openHrm.bind(this, item[k].link)}><font
// 					className={`font wea-f${contentfontsize}`} style={{cursor: 'pointer'}}>{item[k].name}</font></a>
// 			</td>);
// 		// }else{
// 		}else if('jobactivity'=== k){
// 			tdArr.push(<td width={widths[index]} data-order={size-1} height="31" style={{minWidth :"50px",textAlign:'left',width:widths.k}}>
// 				<font className={`font wea-f${contentfontsize}`}><div dangerouslySetInnerHTML={{ __html: item[k] }} /></font>
// 			</td>)
// 		}else if('id'=== k){
//             tdArr.push(<td width={widths[index]} height="31" data-order={size-1} style={{textAlign:'left',minWidth :"50px",width:widths.k}}>
//                 <font className={`font wea-f${contentfontsize}`}><div dangerouslySetInnerHTML={{ __html: item[k] }} /></font>
//             </td>)
// 			    }else if('orgidspan'=== k) {
// 			tdArr.push(<td width={widths[index]} height="31" data-order={size - 1}
// 						   style={{textAlign: 'left', minWidth: "50px", width: widths.k}}>
// 				<font className={`font wea-f${contentfontsize}`}>
// 					<div dangerouslySetInnerHTML={{__html: item[k]}}/>
// 				</font>
// 			</td>)
// 		}else if('orgid'=== k){
// 			tdArr.push(<td width={widths[index]} height="31" data-order={size-1} style={{textAlign:'left',minWidth :"50px",width:widths.k}}>
// 				<font className={`font wea-f${contentfontsize}`}><div dangerouslySetInnerHTML={{ __html: item[k] }} /></font>
// 			</td>)
//     }else if('subcompany'=== k){
//     tdArr.push(<td width={widths[index]} height="31" data-order={size-1} style={{textAlign:'left'}}>
//         <font className={`font wea-f${contentfontsize}`}>{item[k]}</font>
//     </td>)
// }else if('tel'=== k){
// 	tdArr.push(<td width={widths[index]} height="31" data-order={size-1} style={{textAlign:'left'}}>
// 		<font className={`font wea-f${contentfontsize}`}>{item[k]}</font>
// 	</td>)
// }else if('mobile'=== k){
// 	tdArr.push(<td width={widths[index]} height="31" data-order={size-1} style={{textAlign:'left'}}>
// 		<font className={`font wea-f${contentfontsize}`}>{item[k]}</font>
// 	</td>)
// }else if('email'=== k){
// 	tdArr.push(<td width={widths[index]} height="31" data-order={size-1} style={{textAlign:'left'}}>
// 		<font className={`font wea-f${contentfontsize}`}>{item[k]}</font>
// 	</td>)
// 		}else{
//             tdArr.push(<td style={{textAlign:'left',minWidth :"50px",width:widths.k+'px'}} height="31" data-order={size-1} >
//                 <font className={`font wea-f${contentfontsize}`}>{item[k]}</font>
//             </td>)
// 		}
// 		index+=1;
// 	}
// 	trArr.push(<tr height="31">{tdArr}</tr>);
// });
return _react2.default.createElement('table',{id:'_contenttable_'+eid,className:'Econtent elementdatatable contact-elementdatatable',style:{tableLayout:'auto',margin:0}},ContactHtml);}}]);return ContactsCom;}(_react2.default.Component);var SearchInput=_react2.default.createClass({displayName:'SearchInput',getInitialState:function getInitialState(){return{value:'',focus:false};},handleInputChange:function handleInputChange(e){var _this2=this;this.setState({value:e.target.value});setTimeout(function(){return _this2.props.onSearch(_this2.state.value);},500);},handleFocusBlur:function handleFocusBlur(e){this.setState({focus:e.target===document.activeElement});},handleSearch:function handleSearch(){if(this.props.onSearch){this.props.onSearch(this.state.value);}},render:function render(){var _props2=this.props,style=_props2.style,size=_props2.size,placeholder=_props2.placeholder;var btnCls=(0,_classnames2.default)({'ant-search-btn':true,'ant-search-btn-noempty':!!this.state.value.trim(),'portal-serachButton':true});var searchCls=(0,_classnames2.default)({'ant-search-input':true,'ant-search-input-focus':this.state.focus});return _react2.default.createElement('div',{className:'ant-search-input-wrapper',style:style},_react2.default.createElement(InputGroup,{className:searchCls},_react2.default.createElement(_antd.Input,{placeholder:placeholder,value:this.state.value,onChange:this.handleInputChange,onFocus:this.handleFocusBlur,onBlur:this.handleFocusBlur,onPressEnter:this.handleSearch}),_react2.default.createElement('div',{className:'ant-input-group-wrap'},_react2.default.createElement(_antd.Button,{icon:'search',className:btnCls,size:size,onClick:this.handleSearch}))));}});module.exports={ContactsCom:ContactsCom,SearchInput:SearchInput};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(571);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var AddWf=function(_React$Component){(0,_inherits3.default)(AddWf,_React$Component);function AddWf(props){(0,_classCallCheck3.default)(this,AddWf);var _this=(0,_possibleConstructorReturn3.default)(this,(AddWf.__proto__||(0,_getPrototypeOf2.default)(AddWf)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(AddWf,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/addwf','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return AddWf;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);AddWf=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(AddWf);exports.default=AddWf;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(572);var _Title2=_interopRequireDefault(_Title);var _lodash=__webpack_require__(9);var _AddWf=__webpack_require__(573);var _AddWf2=_interopRequireDefault(_AddWf);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/addwftab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var contentHtml=_react2.default.createElement('div',{width:'100%'});var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};if(!(0,_lodash.isEmpty)(tabdata)){contentHtml=_react2.default.createElement(_AddWf2.default,{eid:eid,data:tabdata,esetting:esetting,contentview:contentview});}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 新建流程元素
var AddWfCom=function(_React$Component){(0,_inherits3.default)(AddWfCom,_React$Component);function AddWfCom(props){(0,_classCallCheck3.default)(this,AddWfCom);var _this=(0,_possibleConstructorReturn3.default)(this,(AddWfCom.__proto__||(0,_getPrototypeOf2.default)(AddWfCom)).call(this,props));_this.state={height:40};return _this;}(0,_createClass3.default)(AddWfCom,[{key:'componentDidMount',value:function componentDidMount(){var _height=jQuery('#element_addwf_scrollId .ant-table-row').height();this.setState({height:_height});}},{key:'render',value:function render(){var _props=this.props,data=_props.data,esetting=_props.esetting,contentview=_props.contentview;var height=this.state.height;var __height=5*height;if(contentview&&contentview.style&&contentview.style.height){__height=contentview.style.height;}var list=data.data;var columns=(0,_common.formatData)(list[0],esetting);if("1"===esetting.displayLayout)return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_addwf_scrollId',height:__height},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}));var evenData=new Array();var oddData=new Array();(0,_common.intervalMap)(list,function(item,i){oddData.push(item);if(list[i+1]!==undefined)evenData.push(list[i+1]);},2);return _react2.default.createElement(_antd.Row,null,_react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_addwf_scrollId',height:__height},(0,_lodash.isEmpty)(evenData)&&(0,_lodash.isEmpty)(oddData)?_react2.default.createElement('div',null,_react2.default.createElement(_antd.Row,null,_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据'))))):_react2.default.createElement('div',null,_react2.default.createElement(_antd.Col,{span:12,order:1},!(0,_lodash.isEmpty)(oddData)&&_react2.default.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:oddData,size:'small'})),_react2.default.createElement(_antd.Col,{span:12,order:2},!(0,_lodash.isEmpty)(evenData)&&_react2.default.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:evenData,size:'small'})))));}}]);return AddWfCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);AddWfCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(AddWfCom);exports.default=AddWfCom;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(575);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Task=function(_React$Component){(0,_inherits3.default)(Task,_React$Component);function Task(props){(0,_classCallCheck3.default)(this,Task);var _this=(0,_possibleConstructorReturn3.default)(this,(Task.__proto__||(0,_getPrototypeOf2.default)(Task)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Task,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/task','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Task;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Task=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Task);exports.default=Task;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(576);var _Title2=_interopRequireDefault(_Title);var _Task=__webpack_require__(577);var _Task2=_interopRequireDefault(_Task);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/tasktab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,counts=edata.counts,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=tabdata?_react2.default.createElement(_Task2.default,{eid:eid,data:tabdata,esetting:esetting}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,counts:counts,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,counts=_props3.counts,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}// let tHtml=titles.map((title, i)=> {
//     if (!isEmpty(counts)) {
//         if ('0' !== counts[i]) {
//              title += ' (<font style="color:red">' + counts[i] + '</font>)';
//         }
//     }
//     let name = title;
//     title=title.replace(`<font style="color:red">`,"");
//     title=title.replace(`</font>`,"");
//     const className = tabids[i] == currentTab ? `tab2selected wea-f${fontStyle.tab1fontsize || 12}` : `tab2unselected wea-f${fontStyle.tab2fontsize || 12}`;
//     return <td title={title} data-tabid={tabids[i]} style={this.props.methodvalue == '2'? tdStyle1 : tdStyle} className={className} onClick={handleTabData.bind(this, tabids[i])} dangerouslySetInnerHTML={{__html:name}}></td>
// });
var className=tabids.length<=1?'nodisplay':'';return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//任务元素
var TaskCom=function(_React$Component){(0,_inherits3.default)(TaskCom,_React$Component);function TaskCom(){(0,_classCallCheck3.default)(this,TaskCom);return(0,_possibleConstructorReturn3.default)(this,(TaskCom.__proto__||(0,_getPrototypeOf2.default)(TaskCom)).apply(this,arguments));}(0,_createClass3.default)(TaskCom,[{key:'render',value:function render(){var _props=this.props,data=_props.data,esetting=_props.esetting;var display=esetting.display;var list=data.data;var nlist=new Array();list.map(function(item){var i=0;var obj=new Object();for(var k in item){if(display[i]===1){obj[k]=item[k];}i+=1;}nlist.push(obj);});return nlist.length?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(nlist[0],esetting),pagination:false,dataSource:nlist,size:'small'}):_react2.default.createElement('div',null);}}]);return TaskCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);TaskCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(TaskCom);exports.default=TaskCom;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _NewNotice=__webpack_require__(579);var _NewNotice2=_interopRequireDefault(_NewNotice);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;var Base64=ecCom.WeaTools.Base64;//元素组件
var NewNotice=function(_React$Component){(0,_inherits3.default)(NewNotice,_React$Component);function NewNotice(props){(0,_classCallCheck3.default)(this,NewNotice);var _this=(0,_possibleConstructorReturn3.default)(this,(NewNotice.__proto__||(0,_getPrototypeOf2.default)(NewNotice)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(NewNotice,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/newnotice','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);window.elements_more_params[eid]={canAddNotice:result.esetting&&result.esetting.canAddNotice,isRouteUrl:true,createMethod:result.esetting&&result.esetting.createMethod||'1',paramsStr:result.esetting&&result.esetting.createMethod=='2'?"&jsonstr="+Base64.encode(result.esetting.more.toString()):''};_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;if((0,_lodash.isEmpty)(edata))return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var _esetting$eScrollDire=esetting.eScrollDirection,eScrollDirection=_esetting$eScrollDire===undefined?{}:_esetting$eScrollDire,scrollSpeed=esetting.scrollSpeed,noticeIsText=esetting.noticeIsText;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);var scolltype='none';if(eScrollDirection.selected){switch(eScrollDirection.selected){case'1':scolltype='up';break;case'2':scolltype='right';break;case'3':scolltype='down';break;case'4':scolltype='left';break;default:scolltype='none';}}if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){// EContentHtml = <MarqueeCom tabdata={edata} eid={eid} scolltype={scolltype} scrollSpeed={scrollSpeed}><NewNoticeCom eid={eid} data={edata.data} esetting={edata.esetting} handleRefresh={this.handleRefresh} scolltype={scolltype} scrollSpeed={scrollSpeed}/></MarqueeCom>;
EContentHtml=_react2.default.createElement(_NewNotice2.default,{eid:eid,data:edata.data,esetting:edata.esetting,handleRefresh:this.handleRefresh,scolltype:scolltype,scrollSpeed:scrollSpeed});}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'ant-spin-container'}),_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement('div',{id:'tabcontant_'+eid},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml))),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return NewNotice;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewNotice=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewNotice);exports.default=NewNotice;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _weaPortalPublic=__webpack_require__(47);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//公告元素
var NewNoticeCom=function(_React$Component){(0,_inherits3.default)(NewNoticeCom,_React$Component);function NewNoticeCom(props){(0,_classCallCheck3.default)(this,NewNoticeCom);var _this=(0,_possibleConstructorReturn3.default)(this,(NewNoticeCom.__proto__||(0,_getPrototypeOf2.default)(NewNoticeCom)).call(this,props));_this.handleAddNotice=_this.handleAddNotice.bind(_this);_this.onSubmitDoc=_this.onSubmitDoc.bind(_this);return _this;}(0,_createClass3.default)(NewNoticeCom,[{key:'handleAddNotice',value:function handleAddNotice(state){this.refs.addNotice.onSetState(state);}},{key:'onSubmitDoc',value:function onSubmitDoc(ids,names,datas){var _props=this.props,eid=_props.eid,handleRefresh=_props.handleRefresh;_ecCom.WeaTools.callApi('/api/portal/noticeadd/addNotice','POST',{eid:eid,docids:ids}).then(function(result){if(result.status=='2'){_antd.message.error(result.errormsg);}else{_antd.message.success("添加成功！");handleRefresh();}});}// componentDidMount(){
// 	const { esetting } = this.props;
// 	const {  perpage} = esetting;
//
// 	let height = document.getElementsByClassName("tabContant")[0].offsetHeight
// 	let a = parseInt(height)+parseInt(perpage);
// 	console.log(height,"===");
//
// 	console.log(a,"===");
// 	// console.log(height);
// 	 document.getElementsByClassName("tabContant")[0].style.height=a+"px";
// }
},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,eid=_props2.eid,data=_props2.data,esetting=_props2.esetting,handleRefresh=_props2.handleRefresh,scolltype=_props2.scolltype,scrollSpeed=_props2.scrollSpeed;var canAddNotice=esetting.canAddNotice,showContent=esetting.showContent,showImg=esetting.showImg,noticeNew=esetting.noticeNew,showTitle=esetting.showTitle,createMethod=esetting.createMethod,pageSize=esetting.pageSize,multiPage=esetting.multiPage,noticeIsText=esetting.noticeIsText,eScrollDirection=esetting.eScrollDirection,linkmode=esetting.linkmode,perpage_old=esetting.perpage;var perpage=parseInt(pageSize);var __perpage=perpage;if(multiPage=='0'){perpage=parseInt(data.length);__perpage=perpage_old;};var __showImg=showImg;if(eScrollDirection.selected=='2'||eScrollDirection.selected=='4'){__perpage=1;__showImg=false;}var html=[];var repalceDatas=[];(0,_common.intervalMap)(data.slice(0,perpage_old),function(obj,i){var arr=[];for(var j=0;j<__perpage;j++){var _num=__perpage-1;var bool="false";if(j==_num){bool="true";}var n=i+j;var item=data.slice(0,perpage_old)[n];if(item){repalceDatas.push({id:item.id,name:item.title});arr.push(_react2.default.createElement(NoticeItem,{handleClick:_this2.handleAddNotice,bool:bool,showImg:__showImg,showTitle:showTitle,showContent:showContent,createMethod:createMethod,item:item,linkmode:linkmode}));// if(!isEqual('2',eScrollDirection.selected) && (!isEqual('4',eScrollDirection.selected ))) {
// 		arr.push(<div className='xian' style={{height:'1px',borderTop:'solid rgb(0,0,0,0.2) 1px'}}></div>);
// 	}
}}html.push(_react2.default.createElement('div',{className:"portal-element-newnotice-com"},arr));},perpage);var htmlMultiPage=_react2.default.createElement('div',null);if(multiPage=='0')htmlMultiPage=html;//不分页
else htmlMultiPage=_react2.default.createElement(_antd.Carousel,{autoplay:html.length>1,dots:html.length>1},html);// 分页
// 纯文本
if(noticeIsText=='1'&&data.length!==0){htmlMultiPage=_react2.default.createElement('div',{className:'portal-element-doc-content',id:'__content__'+eid,dangerouslySetInnerHTML:{__html:data[0].title+'&nbsp'+data[0].content}});}// 纯文本并且向左向右滚动
if(eScrollDirection.selected&&noticeIsText=='1'&&data.length!==0&&(eScrollDirection.selected=='2'||eScrollDirection.selected=='4')){htmlMultiPage=_react2.default.createElement('div',{className:'portal-element-doc-content',dangerouslySetInnerHTML:{__html:typeof data[0].title!=='undefined'?data[0].title:''+'&nbsp'+(0,_typeof3.default)(data[0].content)!=='undefined'?data[0].content:''}});}return _react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid},_react2.default.createElement(_MarqueeCom2.default,{tabdata:data,eid:eid,scolltype:scolltype,scrollSpeed:scrollSpeed,ebaseid:'notice'},_react2.default.createElement('div',{className:'newnotice-add-Carousel'},html.length?htmlMultiPage:'')),_react2.default.createElement(_weaPortalPublic.WeaAddNotice,{ref:'addNotice',eid:eid,handleRefresh:handleRefresh,canAddNotice:canAddNotice}),canAddNotice&&noticeNew=='1'&&createMethod=='2'?_react2.default.createElement('div',{className:'noticeitemnew'},_react2.default.createElement(_ecCom.WeaBrowser,{type:'37',title:getLabel(386382,"请选择"),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',onChange:this.onSubmitDoc,customized:true,memorise:true,isSingle:false,replaceDatas:repalceDatas},_react2.default.createElement('div',{className:'portal-element-newnotice-add'},_react2.default.createElement('img',{src:'/page/element/newNotice/resource/image/new.png',title:getLabel(388030,"添加公告"),alt:''})))):null,canAddNotice&&createMethod=='1'?_react2.default.createElement('div',{className:'noticeitemnew'},_react2.default.createElement('div',{className:'portal-element-newnotice-add',onClick:this.handleAddNotice.bind(this,{isNew:true,visible:true,isView:false,id:'',title:'',imgsrc:'',content:''})},_react2.default.createElement('img',{className:'portal-element-newnotice-add-icon',src:'/page/element/newNotice/resource/image/new.png',title:getLabel(388030,"添加公告"),alt:''}))):null);}}]);return NewNoticeCom;}(_react2.default.Component);var NoticeItem=function(_React$Component2){(0,_inherits3.default)(NoticeItem,_React$Component2);function NoticeItem(props){(0,_classCallCheck3.default)(this,NoticeItem);var _this3=(0,_possibleConstructorReturn3.default)(this,(NoticeItem.__proto__||(0,_getPrototypeOf2.default)(NoticeItem)).call(this,props));_this3.handleClick=_this3.handleClick.bind(_this3);return _this3;}(0,_createClass3.default)(NoticeItem,[{key:'handleClick',value:function handleClick(){var _props3=this.props,createMethod=_props3.createMethod,item=_props3.item,handleClick=_props3.handleClick,linkmode=_props3.linkmode;var imgsrc=item.imgsrc,title=item.title,content=item.content,id=item.id,linkUrl=item.linkUrl;if(createMethod=='1'){handleClick({imgsrc:imgsrc,title:title,content:content,id:id,visible:true,isView:true});}else if(createMethod=='2'&&linkUrl){(0,_common.openLinkUrl)(linkUrl,linkmode);}}},{key:'render',value:function render(){var _props4=this.props,showImg=_props4.showImg,showTitle=_props4.showTitle,showContent=_props4.showContent,item=_props4.item,handleClick=_props4.handleClick,bool=_props4.bool;var itemStyle={};if(bool==="false"){itemStyle={borderBottom:'1px solid rgb(176,224,230)'};}var imgsrc=item.imgsrc,title=item.title,content=item.content,id=item.id;var imgurl='';if(imgsrc==''){imgurl="/images/homepage/noimgdefault_wev8.jpg";}else{imgurl=imgsrc;}return _react2.default.createElement('div',{className:'portal-element-newnotice-item',style:(0,_extends3.default)({},itemStyle),onClick:this.handleClick},showImg?_react2.default.createElement('div',{className:'portal-element-newnotice-item-img'},_react2.default.createElement('img',{src:imgurl,alt:''})):'',_react2.default.createElement('div',{className:'portal-element-newnotice-item-content',style:{width:showImg?'calc(100% - 107px)':'100%'}},_react2.default.createElement('div',{className:'portal-element-newnotice-item-title'},showTitle?title:''),_react2.default.createElement('div',{className:'portal-element-newnotice-item-summary',style:{WebkitBoxOrient:'vertical'}},showContent?content.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig,"").replace(/&ldquo;/ig,'“').replace(/&rdquo;/ig,'”').replace(/&quot;/ig,'"').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&mdash;/g,'—').replace(/&hellip;/g,'…'):'')));}}]);return NoticeItem;}(_react2.default.Component);var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewNoticeCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewNoticeCom);exports.default=NewNoticeCom;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var WorkTask=function(_React$Component){(0,_inherits3.default)(WorkTask,_React$Component);function WorkTask(props){(0,_classCallCheck3.default)(this,WorkTask);var _this=(0,_possibleConstructorReturn3.default)(this,(WorkTask.__proto__||(0,_getPrototypeOf2.default)(WorkTask)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(WorkTask,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/worktask','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return WorkTask;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);WorkTask=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(WorkTask);exports.default=WorkTask;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var FnaBudgetAssistant=function(_React$Component){(0,_inherits3.default)(FnaBudgetAssistant,_React$Component);function FnaBudgetAssistant(props){(0,_classCallCheck3.default)(this,FnaBudgetAssistant);var _this=(0,_possibleConstructorReturn3.default)(this,(FnaBudgetAssistant.__proto__||(0,_getPrototypeOf2.default)(FnaBudgetAssistant)).call(this,props));_this.state={edata:null,refresh:false,weaFnaLoaded:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(FnaBudgetAssistant,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});ls.set('edata-'+eid,{});this.setState({edata:{},refresh:false});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载财务模块静态资源
eventRegister.loadModule('b_fna',function(){setTimeout(function(){return _this2.setState({weaFnaLoaded:true});},100);},function(){});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,weaFnaLoaded=_state.weaFnaLoaded;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=weaFnaLoaded&&window.weaFnaEngine&&window.weaFnaEngine.com?_react2.default.createElement(window.weaFnaEngine.com.BudgetAssistantPage,{queryData:params}):_react2.default.createElement('div',null);}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return FnaBudgetAssistant;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FnaBudgetAssistant=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FnaBudgetAssistant);exports.default=FnaBudgetAssistant;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var FnaBudgetAssistant1=function(_React$Component){(0,_inherits3.default)(FnaBudgetAssistant1,_React$Component);function FnaBudgetAssistant1(props){(0,_classCallCheck3.default)(this,FnaBudgetAssistant1);var _this=(0,_possibleConstructorReturn3.default)(this,(FnaBudgetAssistant1.__proto__||(0,_getPrototypeOf2.default)(FnaBudgetAssistant1)).call(this,props));_this.state={edata:null,refresh:false,weaFnaLoaded:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(FnaBudgetAssistant1,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});ls.set('edata-'+eid,{});this.setState({edata:{},refresh:false});}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载财务模块静态资源
eventRegister.loadModule('b_fna',function(){setTimeout(function(){return _this2.setState({weaFnaLoaded:true});},100);},function(){});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,weaFnaLoaded=_state.weaFnaLoaded;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=weaFnaLoaded&&window.weaFnaEngine&&window.weaFnaEngine.com?_react2.default.createElement(window.weaFnaEngine.com.ApprovalAssistantPage,{queryData:params}):_react2.default.createElement('div',null);}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return FnaBudgetAssistant1;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FnaBudgetAssistant1=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FnaBudgetAssistant1);exports.default=FnaBudgetAssistant1;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//元素组件
var NoReact=function(_React$Component){(0,_inherits3.default)(NoReact,_React$Component);function NoReact(props){(0,_classCallCheck3.default)(this,NoReact);var _this=(0,_possibleConstructorReturn3.default)(this,(NoReact.__proto__||(0,_getPrototypeOf2.default)(NoReact)).call(this,props));_this.state={edata:{}};_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.loadHtml=_this.loadHtml.bind(_this);return _this;}(0,_createClass3.default)(NoReact,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});}},{key:'handleRefresh',value:function handleRefresh(){var _props$config=this.props.config,item=_props$config.item,isSetting=_props$config.isSetting;var eid=item.eid,contentview=item.contentview;this.loadHtml(eid,contentview.url,isSetting);}},{key:'loadHtml',value:function loadHtml(eid,url,isSetting){var _this2=this;if(url){_ecCom.WeaTools.callApi(url,'GET',{},'html').then(function(result){if(_this2.props.config.isHasRight){$(".homepage[data-isSetting="+isSetting+"] #content_view_id_"+eid).html(result);}});}}},{key:'componentDidMount',value:function componentDidMount(){var _props$config2=this.props.config,item=_props$config2.item,isSetting=_props$config2.isSetting;var eid=item.eid,contentview=item.contentview;this.loadHtml(eid,contentview.url,isSetting);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight,isSetting=_props$config3.isSetting;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){var _nextProps$config$ite=nextProps.config.item,eid=_nextProps$config$ite.eid,contentview=_nextProps$config$ite.contentview;this.loadHtml(eid,contentview.url,isSetting);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config4=this.props.config,item=_props$config4.item,params=_props$config4.params,isHasRight=_props$config4.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(!isHasRight){EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return NoReact;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NoReact=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NoReact);exports.default=NoReact;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _cooperation=__webpack_require__(585);var _cooperation2=_interopRequireDefault(_cooperation);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Cooperation=function(_React$Component){(0,_inherits3.default)(Cooperation,_React$Component);function Cooperation(props){(0,_classCallCheck3.default)(this,Cooperation);var _this=(0,_possibleConstructorReturn3.default)(this,(Cooperation.__proto__||(0,_getPrototypeOf2.default)(Cooperation)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);if(window.element_cooperation_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_cooperation_refresh[props.config.params.eid]=_this.handleRefresh.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleRefresh.bind(_this);window.element_cooperation_refresh=obj;}return _this;}(0,_createClass3.default)(Cooperation,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/cooperation','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);// window.elements_more_params[config.params.eid] = {isRouteUrl: true, tabid: edata.currenttab || '1'};
if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_cooperation2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Cooperation;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Cooperation=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Cooperation);exports.default=Cooperation;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(586);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var CooperationCom=function(_React$Component){(0,_inherits3.default)(CooperationCom,_React$Component);function CooperationCom(props){(0,_classCallCheck3.default)(this,CooperationCom);var _this=(0,_possibleConstructorReturn3.default)(this,(CooperationCom.__proto__||(0,_getPrototypeOf2.default)(CooperationCom)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(CooperationCom,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/cooperationtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;var _tabdata$datas=tabdata.datas,datas=_tabdata$datas===undefined?{}:_tabdata$datas;var _datas$dataColoums=datas.dataColoums,dataColoums=_datas$dataColoums===undefined?[]:_datas$dataColoums;esetting.dataColoums=dataColoums;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var viewType='0';var typeid='0';var status='0';var jointype='0';if(tabdata){if(!$.isEmptyObject(tabdata)&&tabdata.datas.coworkList){contentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.datas.coworkList[0],esetting),showHeader:esetting.showHeader=='1',pagination:false,dataSource:tabdata.datas.coworkList,size:'small'});}viewType=tabdata.datas&&tabdata.datas.viewType;typeid=tabdata.datas&&tabdata.datas.typeid;status=tabdata.datas&&tabdata.datas.status;jointype=tabdata.datas&&tabdata.datas.jointype;}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,viewType:viewType,typeid:typeid,status:status,jointype:jointype,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return CooperationCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CooperationCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CooperationCom);exports.default=CooperationCom;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;// this.setMoreHref();
(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;// this.setMoreHref();
(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,viewType=_props3.viewType,typeid=_props3.typeid,status=_props3.status,jointype=_props3.jointype,currentTab=_props3.currentTab;var eid=config.item.eid;window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?viewType="+viewType+"&typeid="+typeid+"&jointype="+jointype+"&status="+status};}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _MeetingCalendar=__webpack_require__(588);var _MeetingCalendar2=_interopRequireDefault(_MeetingCalendar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MeetingCalendar=function(_React$Component){(0,_inherits3.default)(MeetingCalendar,_React$Component);function MeetingCalendar(props){(0,_classCallCheck3.default)(this,MeetingCalendar);var _this=(0,_possibleConstructorReturn3.default)(this,(MeetingCalendar.__proto__||(0,_getPrototypeOf2.default)(MeetingCalendar)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MeetingCalendar,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/meetingCalendar','POST',{eid:eid}).then(function(result){_ecCom.WeaTools.callApi('/api/meeting/calendar/getData','POST',{viewType:'3',selectdate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),meetingType:result.meetingtype}).then(function(data){ls.set('edata-'+eid,data);_this2.setState({edata:data,refresh:false});});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params,layoutid=config.layoutid;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_MeetingCalendar2.default,(0,_defineProperty3.default)({handleRefresh:this.handleRefresh,eid:eid,data:edata,hpid:params.hpid,layoutid:layoutid,subCompanyId:params.subCompanyId},'eid',eid));}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:true}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return MeetingCalendar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MeetingCalendar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MeetingCalendar);exports.default=MeetingCalendar;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//会议日历元素
var MeetingCalendarTemplate=function(_React$Component){(0,_inherits3.default)(MeetingCalendarTemplate,_React$Component);function MeetingCalendarTemplate(props){(0,_classCallCheck3.default)(this,MeetingCalendarTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(MeetingCalendarTemplate.__proto__||(0,_getPrototypeOf2.default)(MeetingCalendarTemplate)).call(this,props));var _date=new Date();_this.state={refresh:false,data:props.data,createVisible:false,createType:'create',currentDate:(0,_common.formatDate)(_date,"yyyy-MM-dd"),currentMonth:(0,_common.formatDate)(_date,"yyyy-MM"),activeKey:'1',meetingId:'',RoomPlanContainer:false,meetingtype:'0',weaMeetingLoaded:false,type:'month',selectYear:(0,_common.formatDate)(_date,"yyyy")};_this.doAdd=_this.doAdd.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.onClickData=_this.onClickData.bind(_this);_this.dateCellRender=_this.dateCellRender.bind(_this);_this.setAll=_this.setAll.bind(_this);_this.setMeetingId=_this.setMeetingId.bind(_this);_this.setRoomPlan=_this.setRoomPlan.bind(_this);_this.setDialog=_this.setDialog.bind(_this);_this.setType=_this.setType.bind(_this);_this.doRefesh=_this.doRefesh.bind(_this);_this.monthCellRender=_this.monthCellRender.bind(_this);_this.clickMeetingCalendarMonth=_this.clickMeetingCalendarMonth.bind(_this);// if(window.window_clickMeetingCalendarDay){
//     window.window_clickMeetingCalendarDay['fn'+props.eid] = this.clickMeetingCalendarDay.bind(this);
// }else{
//     let obj = {};
//     obj['fn'+props.eid] = this.clickMeetingCalendarDay.bind(this);
//     window.window_clickMeetingCalendarDay = obj;
// }
_this.clickMeetingCalendarDay=_this.clickMeetingCalendarDay.bind(_this);return _this;}(0,_createClass3.default)(MeetingCalendarTemplate,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载会议模块静态资源
eventRegister.loadModule('f_meeting',function(){_this2.setState({weaMeetingLoaded:true});},function(){});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){this.setState({data:newProps.data});}},{key:'onPanelChange',value:function onPanelChange(value,type){var _this3=this;var selectYear=(0,_common.formatDate)(new Date(),"yyyy");if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))=='object'){selectYear=value.fields[1];}this.setState({type:type,selectYear:selectYear});var meetingtype=this.state.meetingtype;var _props=this.props,eid=_props.eid,hpid=_props.hpid,subCompanyId=_props.subCompanyId;var selectdate="";if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))==='object'){var year=value.getYear();var month=value.getMonth()+1<10?'0'+(value.getMonth()+1):value.getMonth()+1;var currentMonth=year+'-'+month;selectdate=year+'-'+month+'-01';var _month=(0,_common.formatDate)(new Date(),"yyyy-MM");if(selectdate===_month+"-01"){this.setState({currentDate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),currentMonth:_month});}else{this.setState({currentDate:selectdate,currentMonth:year+'-'+month});}}else{selectdate=value;this.setState({currentDate:selectdate});}_ecCom.WeaTools.callApi('/api/meeting/calendar/getData','POST',{viewType:'3',selectDate:selectdate,meetingType:meetingtype}).then(function(data){ls.set('edata-'+eid,data);_this3.setState({data:data,refresh:false});});}// componentDidMount() {
//     $("#calendar_" + this.props.eid + " .ant-fullcalendar-cell").attr("onclick", "window_clickMeetingCalendarDay['fn"+this.props.eid+"'](this)");
// }
},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){// if(nextState.type == 'month' && this.state.type == 'year'){
//     this.setState( {type: nextState.type},() => {$("#calendar_" + this.props.eid + " .ant-fullcalendar-cell").attr("onclick", "window_clickMeetingCalendarDay['fn"+this.props.eid+"'](this)")})
// }else if(nextState.type == 'year' && this.state.type == 'month'){
//     this.setState( {type: nextState.type},() => {$("#calendar_" + this.props.eid + " .ant-fullcalendar-month-panel-cell").attr("onclick", "window_clickMeetingCalendarDay['fn"+this.props.eid+"'](this)")})
// }
if(nextState.type=='month'&&this.state.type=='year'){this.setState({type:nextState.type});}else if(nextState.type=='year'&&this.state.type=='month'){this.setState({type:nextState.type});}return true;}},{key:'doAdd',value:function doAdd(){this.setState({createVisible:true,createType:'create'});}},{key:'onClose',value:function onClose(){this.onPanelChange(this.state.currentDate);this.setState({createVisible:false,activeKey:'1'});}},{key:'onClickData',value:function onClickData(id){this.setState({createVisible:true,createType:'preview',meetingId:id});}},{key:'setAll',value:function setAll(meetingId,bool,type){this.setState({meetingId:meetingId,createVisible:bool,createType:type});}},{key:'setMeetingId',value:function setMeetingId(meetingId){this.setState({meetingId:meetingId});}},{key:'setRoomPlan',value:function setRoomPlan(bool){this.setState({RoomPlanContainer:bool});}},{key:'setDialog',value:function setDialog(bool){this.setState({createVisible:bool});}},{key:'setType',value:function setType(type){this.setState({createType:type});}},{key:'doRefesh',value:function doRefesh(){var handleRefresh=this.props.handleRefresh;handleRefresh();}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,eid=_props2.eid,layoutid=_props2.layoutid;var _state=this.state,createVisible=_state.createVisible,weaMeetingLoaded=_state.weaMeetingLoaded,createType=_state.createType,currentDate=_state.currentDate,workPlanId=_state.workPlanId,activeKey=_state.activeKey,data=_state.data,meetingId=_state.meetingId,_date=_state._date,RoomPlanContainer=_state.RoomPlanContainer,type=_state.type;var createConditionParams=['','',currentDate,(0,_common.formatDate)(new Date(),"hh:mm"),currentDate,'23:59','0'];return _react2.default.createElement('div',{id:'calendar_'+eid},_react2.default.createElement(_antd.Calendar,{onSelect:this.clickMeetingCalendarDay,fullscreen:false,onPanelChange:this.onPanelChange.bind(this),monthCellRender:this.monthCellRender(eid),value:new Date(currentDate),dateCellRender:this.dateCellRender.bind(this,eid,data)}),_react2.default.createElement(CalendarData,{data:data,type:type,currentDate:currentDate,handleClick:this.onClickData}),_react2.default.createElement('div',{className:'portal-element-calender-add'},_react2.default.createElement(_antd.Icon,{type:'plus-circle-o',title:getLabel(611,'添加'),onClick:this.doAdd})),weaMeetingLoaded&&window.weaMeeting&&window.weaMeeting.com?_react2.default.createElement(window.weaMeeting.com.MeetingDialog,{isCustom:true,setRoomPlan:this.setRoomPlan,setDialog:this.setDialog,setType:this.setType,setMeetingId:this.setMeetingId,setAll:this.setAll,type:createType//新建为'create',查看为'preview',编辑edit,会议决议---decision
,visible:createVisible//显隐受控
,doRefesh:function doRefesh(){_this4.doRefesh();}//自定义刷新页面，不会关掉弹出框
,meetingId:createType=='create'?'':meetingId//会议id，查看会议时用到
,isInterval:false//新建会议类型，true是周期会议， false是普通会议
,meetingDate:currentDate//新建日期
}):'',weaMeetingLoaded&&window.weaMeeting&&window.weaMeeting.com?_react2.default.createElement(window.weaMeeting.com.MeetingRoomPlan,{isCustom:true,setRoomPlan:this.setRoomPlan,canCreate:false,height:600,visible:RoomPlanContainer}):'');}},{key:'dateCellRender',value:function dateCellRender(eid,data,value){var _state2=this.state,currentDate=_state2.currentDate,currentMonth=_state2.currentMonth;$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");$("#calendar_"+eid).find(".ant-fullcalendar-event").removeClass("ant-fullcalendar-event");$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");var dataStr1=(0,_common.formatDate)(new Date(value.time),'yyyy-M-d');var dateStr=(0,_common.formatDate)(new Date(value.time),'yyyy-MM-dd');var events=data.events;var timer=setTimeout(function(){events.map(function(arr){var startDate=(0,_common.formatDate)(new Date(arr.begindate),'yyyy-MM-dd');var endDate=(0,_common.formatDate)(new Date(arr.enddate),'yyyy-MM-dd');if(dateStr>=startDate&&dateStr<=endDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-event");}});if(dateStr===currentDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-current");}clearTimeout(timer);},100);}},{key:'monthCellRender',value:function monthCellRender(eid){$("#calendar_"+eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}},{key:'clickMeetingCalendarDay',value:function clickMeetingCalendarDay(obj){var _state3=this.state,currentDate=_state3.currentDate,currentMonth=_state3.currentMonth,type=_state3.type;var eid=this.props.eid;if(type=='year'){this.clickMeetingCalendarMonth(obj);return;}var title=(0,_common.formatDate)(new Date(obj.time),"yyyy-MM-dd");var ndate="";var currentMonthStr="";if(title){var titlearr=title.split("-");ndate=titlearr[0];currentMonthStr=titlearr[0];ndate=ndate+"-"+titlearr[1];currentMonthStr=currentMonthStr+"-"+titlearr[1];ndate=ndate+"-"+titlearr[2];}if(ndate){this.setState({currentDate:ndate});}//判断点击的是否为当前显示月份，否的话刷新新月份的日历日程，并默认选中所点击的日期
if(currentMonthStr!==currentMonth){this.setState({currentMonth:currentMonthStr});this.onPanelChange(ndate,"month");}}},{key:'clickMeetingCalendarMonth',value:function clickMeetingCalendarMonth(obj){var _this5=this;var eid=this.props.eid;var _state4=this.state,selectYear=_state4.selectYear,meetingtype=_state4.meetingtype;var dateStr=(0,_common.formatDate)(new Date(),'MM');var date=(0,_common.formatDate)(new Date(obj.time),"MM");var _state5=this.state,currentDate=_state5.currentDate,currentMonth=_state5.currentMonth;var monthMatch={"01":getLabel("25825","1月"),"02":getLabel("25826","2月"),"03":getLabel("25827","3月"),"04":getLabel("25828","4月"),"05":getLabel("25829","5月"),"06":getLabel("25830","6月"),"07":getLabel("25831","7月"),"08":getLabel("25832","8月"),"09":getLabel("25833","9月"),"10":getLabel("25834","10月"),"11":getLabel("25835","11月"),"12":getLabel("25836","12月")};var x=Math.ceil(dateStr/3);var y=dateStr-(x-1)*3;var a=Math.ceil(date/3);var b=date-(a-1)*3;if(monthMatch[dateStr].trim()!==date+'月'){// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").addClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).addClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[a-1].children[b-1]).find('div')[0]).find(".ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}else{$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});// $("#calendar_" + eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).removeClass("ant-fullcalendar-month-panel-current-cell");// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").removeClass("ant-fullcalendar-month-panel-current-cell");
$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}var selectMonth='';for(var key in monthMatch){if(monthMatch[key]==date+'月'){selectMonth=key;break;}}var firstDay=(0,_common.formatDate)(new Date(selectYear,selectMonth-1,1),"yyyy-MM-dd");//这个月的第一天
_ecCom.WeaTools.callApi('/api/meeting/calendar/getData','POST',{viewType:'3',selectdate:firstDay,meetingType:meetingtype}).then(function(data){ls.set('edata-'+eid,data);_this5.setState({data:data,refresh:false});});}}]);return MeetingCalendarTemplate;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MeetingCalendarTemplate=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MeetingCalendarTemplate);exports.default=MeetingCalendarTemplate;var CalendarData=function(_React$Component3){(0,_inherits3.default)(CalendarData,_React$Component3);function CalendarData(){(0,_classCallCheck3.default)(this,CalendarData);return(0,_possibleConstructorReturn3.default)(this,(CalendarData.__proto__||(0,_getPrototypeOf2.default)(CalendarData)).apply(this,arguments));}(0,_createClass3.default)(CalendarData,[{key:'tc',value:function tc(d){function zc(c,i){var d="666666888888aaaaaabbbbbbdddddda32929cc3333d96666e69999f0c2c2b1365fdd4477e67399eea2bbf5c7d67a367a994499b373b3cca2cce1c7e15229a36633cc8c66d9b399e6d1c2f029527a336699668cb399b3ccc2d1e12952a33366cc668cd999b3e6c2d1f01b887a22aa9959bfb391d5ccbde6e128754e32926265ad8999c9b1c2dfd00d78131096184cb05288cb8cb8e0ba52880066aa008cbf40b3d580d1e6b388880eaaaa11bfbf4dd5d588e6e6b8ab8b00d6ae00e0c240ebd780f3e7b3be6d00ee8800f2a640f7c480fadcb3b1440edd5511e6804deeaa88f5ccb8865a5aa87070be9494d4b8b8e5d4d47057708c6d8ca992a9c6b6c6ddd3dd4e5d6c6274878997a5b1bac3d0d6db5a69867083a894a2beb8c1d4d4dae54a716c5c8d8785aaa5aec6c3cedddb6e6e41898951a7a77dc4c4a8dcdccb8d6f47b08b59c4a883d8c5ace7dcce";return"#"+d.substring(c*30+i*6,c*30+(i+1)*6);}var c=d!=null&&d!=undefined?d:option.theme;return[zc(c,0),zc(c,1),zc(c,2),zc(c,3)];}},{key:'render',value:function render(){var _this8=this;var _props3=this.props,data=_props3.data,currentDate=_props3.currentDate,handleClick=_props3.handleClick,eid=_props3.eid,_props3$type=_props3.type,type=_props3$type===undefined?'month':_props3$type;var events=data.events;var index=0;var color='#a32929';if(events&&events.length){if(type=='month'){var hasEvent=false;var datas=[];var html=events.map(function(arr){if(arr[7])color=_this8.tc(arr[7])[2];var sdate=new Date(arr.begindate);var edate=new Date(arr.enddate);var startStr=(0,_common.formatDate)(sdate,'yyyy-MM-dd');var endStr=(0,_common.formatDate)(edate,'yyyy-MM-dd');var id=arr.id;var name=arr.name;var stime=arr.begintime;var ss=parseInt(stime)>=12?'PM':'AM';if(currentDate>=startStr&&currentDate<=endStr){hasEvent=true;index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this8,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:color}}),_react2.default.createElement('div',{className:'dataEvent2'},_react2.default.createElement('div',{className:'dataEvent2_1'},stime,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));}});var height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html))));}else{if(events&&events.length){var _hasEvent=false;var _html=events.map(function(arr){var sdate=new Date(arr.begindate);var id=arr.id;var name=arr.name;var mdata=(0,_common.formatDate)(sdate,'MM-dd  hh:mm');var ss=parseInt((0,_common.formatDate)(sdate,'hh'))>=12?'PM':'AM';_hasEvent=true;index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this8,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:'#a32929'}}),_react2.default.createElement('div',{className:'dataEvent2',style:{width:'111px'}},_react2.default.createElement('div',{className:'dataEvent2_1'},mdata,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));});var _height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html))));}}}else{return _react2.default.createElement('div',null);}}}]);return CalendarData;}(_react2.default.Component);

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _MyProjects=__webpack_require__(590);var _MyProjects2=_interopRequireDefault(_MyProjects);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//我的项目元素组件
var MyProjects=function(_React$Component){(0,_inherits3.default)(MyProjects,_React$Component);function MyProjects(props){(0,_classCallCheck3.default)(this,MyProjects);var _this=(0,_possibleConstructorReturn3.default)(this,(MyProjects.__proto__||(0,_getPrototypeOf2.default)(MyProjects)).call(this,props));_this.state={edata:null,refresh:false,currentTab:'1',handleTabData:{}};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(MyProjects,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/projects','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp)||!this.econtent;}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData||function(){},tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_MyProjects2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return MyProjects;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MyProjects=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MyProjects);exports.default=MyProjects;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(591);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var MyProjectsCom=function(_React$Component){(0,_inherits3.default)(MyProjectsCom,_React$Component);function MyProjectsCom(props){(0,_classCallCheck3.default)(this,MyProjectsCom);var _this=(0,_possibleConstructorReturn3.default)(this,(MyProjectsCom.__proto__||(0,_getPrototypeOf2.default)(MyProjectsCom)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(MyProjectsCom,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// if(!isEqual(nextProps, this.props)){
this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});// }
}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/projectstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var datas=tabdata.datas;var _datas$dataColoums=datas.dataColoums,dataColoums=_datas$dataColoums===undefined?[]:_datas$dataColoums;esetting.dataColoums=dataColoums;var searchtype='';var cmanager='';var status='';var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);if(tabdata){if(tabdata.datas.coworkList){contentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.datas.coworkList[0],esetting),showHeader:esetting.showHeader=='1',pagination:false,dataSource:tabdata.datas.coworkList,size:'small'});}/*          const tabsetting = tabdata.tabsetting;
                        const { isIE, readType, mess } = tabsetting;
                        if(readType == '1' && isIE != 'true') contentHtml = <div>&nbsp;&nbsp;{mess}</div>;*/searchtype=tabdata.datas.searchtype;cmanager=tabdata.datas.cmanager;status=tabdata.datas.status;}var _titleProps={currentTab:currentTab,config:config,searchtype:searchtype,cmanager:cmanager,status:status,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return MyProjectsCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MyProjectsCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MyProjectsCom);exports.default=MyProjectsCom;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref=this.setMoreHref.bind(this);this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,searchtype=_props3.searchtype,cmanager=_props3.cmanager,status=_props3.status,currentTab=_props3.currentTab;var eid=config.item.eid;if(searchtype){if(status){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?searchtype="+searchtype+"&cmanager="+cmanager+"&status="+status};}else{window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?searchtype="+searchtype+"&cmanager="+cmanager};}}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}/*setMoreHref() {
        const { config, more, currentTab } = this.props;
        const { eid } = config.item;
        if (more) {
            window.elements_more_params[eid] = {isRouteUrl: true, paramsStr: "?searchtype=" + escape(more)};
        } else {
            window.elements_more_params[eid] = {isRouteUrl: false, paramsStr: "&tabid="+currentTab};
        }
    }*/},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;var header=config.item.header;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(593);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var LoginNews=function(_React$Component){(0,_inherits3.default)(LoginNews,_React$Component);function LoginNews(props){(0,_classCallCheck3.default)(this,LoginNews);var _this=(0,_possibleConstructorReturn3.default)(this,(LoginNews.__proto__||(0,_getPrototypeOf2.default)(LoginNews)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(LoginNews,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/loginnews','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var edata_img={};if(!(0,_lodash.isEmpty)(edata)&&isHasRight){edata_img=_.cloneDeep(edata);edata_img.data.tabsetting.imgs=[];}var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:!refresh?edata:edata_img});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return LoginNews;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);LoginNews=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(LoginNews);exports.default=LoginNews;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(594);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _NewsType=__webpack_require__(595);var _NewsType2=_interopRequireDefault(_NewsType);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.toggleTabPage=_this.toggleTabPage.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'toggleTabPage',value:function toggleTabPage(tabid){var currentTab=this.state.currentTab;this.setState({refresh:!(tabid===currentTab)});this.handleTabData(tabid);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/loginnewstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var more='';if(tabdata){more=tabdata.more;}var tabdata_img={};if(!(0,_lodash.isEmpty)(tabdata)){tabdata_img=_.cloneDeep(tabdata);tabdata_img.tabsetting.imgs=[];}var contentHtml=!(0,_lodash.isEmpty)(tabdata)?_react2.default.createElement(_NewsType2.default,{eid:eid,data:!refresh?tabdata:tabdata_img,esetting:esetting}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,more:more,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.toggleTabPage};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+escape(more)};}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,_props4$config=_props4.config,config=_props4$config===undefined?{}:_props4$config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//公司新闻元素
var NewsType=function(_React$Component){(0,_inherits3.default)(NewsType,_React$Component);function NewsType(props){(0,_classCallCheck3.default)(this,NewsType);return(0,_possibleConstructorReturn3.default)(this,(NewsType.__proto__||(0,_getPrototypeOf2.default)(NewsType)).call(this,props));}(0,_createClass3.default)(NewsType,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting;var tabsetting=data.tabsetting,_data$srcStyle=data.srcStyle,srcStyle=_data$srcStyle===undefined?{}:_data$srcStyle;var _srcStyle$autoheight=srcStyle.autoheight,autoheight=_srcStyle$autoheight===undefined?'0':_srcStyle$autoheight,_srcStyle$pictureheig=srcStyle.pictureheight,pictureheight=_srcStyle$pictureheig===undefined?'108px':_srcStyle$pictureheig,_srcStyle$picturewidt=srcStyle.picturewidth,picturewidth=_srcStyle$picturewidt===undefined?'120px':_srcStyle$picturewidt,tabid=srcStyle.tabid;var list=data.data;//tab设置信息
var height=tabsetting.height,width=tabsetting.width,showModeId=tabsetting.showModeId,imgs=tabsetting.imgs;var columns=new Array();var imgStyle={width:width,height:height==0?parseInt(width)*0.8:height};var style={verticalAlign:'top',width:picturewidth=='px'?'108px':picturewidth,height:pictureheight=='px'?'120px':pictureheight};var listStyle2={width:'100%',height:'100%'};if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1){listStyle2={width:imgStyle.width,height:imgStyle.height};}if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}var docHtml='';switch(parseInt(showModeId)){case 3://左图式
var html=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'){imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{style:{overflow:'auto',overflowY:'hidden',width:'100%',marginBottom:'10px'}},!(imgs.length==1&&imgs[0]=='/images/homepage/noimgdefault_wev8.jpg')&&React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},item.docsubject?React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'1',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',position:'absolute',bottom:'15px',float:'right',width:'100%'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,html);break;case 2://列表式2
var html4=null;var imghtml=null;var imghtml1=[];var j=0;if(!(0,_lodash.isEmpty)(imgs)){if(imgs.length>1){imgs.map(function(item,i){if(imgs[i]!='/images/homepage/noimgdefault_wev8.jpg'){imghtml1[j]=imgs[i];j++;}});if(imghtml1.length==0){imghtml1=['/images/homepage/noimgdefault_wev8.jpg'];}var ihtml=imghtml1.map(function(item,i){var img=imghtml1[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];return React.createElement('div',null,React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},ihtml));}else{var img=imgs[0];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=React.createElement('div',{style:{height:'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,null,React.createElement('div',null,React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[0]&&list[0].docsubject&&list[0].docsubject.link,style:listStyle2,eid:eid,src:img}))));}}columns=(0,_common.formatData)(list[0],esetting);style['paddingTop']='6px';html4=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}))));docHtml=React.createElement('div',null,html4);break;case 1://列表式
default:columns=(0,_common.formatData)(list[0],esetting);docHtml=React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'});break;}return React.createElement('div',null,docHtml);}}]);return NewsType;}(React.Component);var ImgCom=function(_React$Component2){(0,_inherits3.default)(ImgCom,_React$Component2);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this2=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this2.aClick=_this2.aClick.bind(_this2);return _this2;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props$link=this.props.link,link=_props$link===undefined?'':_props$link;if(link!=''){window.open(link);}else return false;}},{key:'render',value:function render(){var _props2=this.props,_props2$src=_props2.src,src=_props2$src===undefined?'':_props2$src,_props2$style=_props2.style,style=_props2$style===undefined?{width:'100%',height:'100%'}:_props2$style;return React.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},React.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(React.Component);var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);NewsType=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(NewsType);exports.default=NewsType;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _LoginUtil=__webpack_require__(597);var _E9QRCode=__webpack_require__(598);var _E9QRCode2=_interopRequireDefault(_E9QRCode);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);__webpack_require__(605);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Login=function(_React$Component){(0,_inherits3.default)(Login,_React$Component);function Login(props){(0,_classCallCheck3.default)(this,Login);var _this=(0,_possibleConstructorReturn3.default)(this,(Login.__proto__||(0,_getPrototypeOf2.default)(Login)).call(this,props));_this.state=(0,_objectAssign2.default)({},{edata:null,win_width:jQuery(window).width(),win_height:jQuery(window).height(),isLogging:false,hasMultiLang:false,multiLangVisible:false,loginFormHiddenItems:[],loginSetting:{},validateCode:'/weaver/weaver.file.MakeValidateCode',queryParams:{logintype:'1'},loginFormItems:[],multiLangs:[],refresh:false,qrCode:{}},(0,_objectAssign2.default)({},(0,_LoginUtil.getLSValue)('portal_login','loginCache'),{loginType:(0,_LoginUtil.getLSValue)('portal_login','loginType')||'form',langId:(0,_LoginUtil.getLSValue)('portal_login','langId')||_ecCom.WeaTools.ls.getJSONObj('languageidweaver')||'7',langText:(0,_LoginUtil.getLSValue)('portal_login','langText')||'简体中文',isRememberAccount:(0,_LoginUtil.getLSValue)('portal_login','isRememberAccount')||false,isRememberPassword:(0,_LoginUtil.getLSValue)('portal_login','isRememberPassword')||false,cacheAccount:(0,_LoginUtil.getLSValue)('portal_login','cacheAccount')||'',cachePassword:(0,_LoginUtil.getLSValue)('portal_login','cachePassword')||'',initialSlide:(0,_LoginUtil.getLSValue)('portal_login','initialSlide')||0,autoCarousel:(0,_LoginUtil.getLSValue)('portal_login','autoCarousel')||false,carouselTime:(0,_LoginUtil.getLSValue)('portal_login','carouselTime')||3}));_this.handleDelete=_this.handleDelete.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.onPasswordForget=_this.onPasswordForget.bind(_this);_this.onRememberChange=_this.onRememberChange.bind(_this);_this.onValidateCodeChange=_this.onValidateCodeChange.bind(_this);_this.getLoginForm=_this.getLoginForm.bind(_this);_this.onQCLogin=_this.onQCLogin.bind(_this);_this.getMultiLangs=_this.getMultiLangs.bind(_this);_this.onLogin=_this.onLogin.bind(_this);return _this;}(0,_createClass3.default)(Login,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _state=this.state,loginId=_state.cacheAccount,langId=_state.langId;_ecCom.WeaLocaleProvider.getLocaleLabelByLang(['common','portal'],langId).then(function(){_this2.getLoginForm({loginId:loginId,langId:langId});});this.getMultiLangs();}},{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.getLoginForm();}},{key:'getLoginForm',value:function getLoginForm(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({edata:ls.getJSONObj('edata-'+this.props.config.params.eid)});var _state2=this.state,queryParams=_state2.queryParams,langid=_state2.langId;var _queryParams$logintyp=queryParams.logintype,logintype=_queryParams$logintyp===undefined?'1':_queryParams$logintyp;var _params$loginId=params.loginId,loginId=_params$loginId===undefined?'':_params$loginId,_params$langId=params.langId,langId=_params$langId===undefined?langid:_params$langId;window.doLoginAction&&window.doLoginAction('getLoginForm',{queryParams:queryParams,logintype:logintype,loginid:loginId,langid:langId,callback:function callback(result){var _result$hasMultiLang=result.hasMultiLang,hasMultiLang=_result$hasMultiLang===undefined?false:_result$hasMultiLang,_result$loginFormItem=result.loginFormItems,loginFormItems=_result$loginFormItem===undefined?[]:_result$loginFormItem,_result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,_result$qrCode=result.qrCode,qrCode=_result$qrCode===undefined?{}:_result$qrCode;ls.set('edata-'+_this3.props.config.params.eid,result);_this3.setState({hasMultiLang:hasMultiLang,loginFormItems:loginFormItems,loginSetting:loginSetting,qrCode:qrCode,edata:result});}});}},{key:'onPasswordForget',value:function onPasswordForget(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _params$langId2=params.langId,langId=_params$langId2===undefined?this.state.langId:_params$langId2;window.doLoginAction&&window.doLoginAction('forgetPassword',{langid:langId});}},{key:'onRememberChange',value:function onRememberChange(type,checked){var _state3=this.state,isRememberAccount=_state3.isRememberAccount,isRememberPassword=_state3.isRememberPassword;if('account'==type){this.setState({isRememberAccount:checked,isRememberPassword:!checked?checked:isRememberPassword});}else if('password'==type){this.setState({isRememberAccount:checked?checked:isRememberAccount,isRememberPassword:checked});}}},{key:'onValidateCodeChange',value:function onValidateCodeChange(){var _this4=this;setTimeout(function(){return _this4.setState({validateCode:'/weaver/weaver.file.MakeValidateCode?seriesnum_='+ ++_this4.seriesnum_});},50);}},{key:'onQCLogin',value:function onQCLogin(){var _state4=this.state,langId=_state4.langId,langText=_state4.langText,qrCode=_state4.qrCode;_ecCom.WeaTools.callApi('/mobile/plugin/login/QCLoginStatus.jsp','POST',{langid:langId,loginkey:qrCode.loginkey,isie:!!_ecCom.WeaTools.ua.browser==="IE"},'text').then(function(result){if(jQuery.trim(result)!='0'&&jQuery.trim(result)!='9'&&jQuery.trim(result)!='-99'){jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();(0,_LoginUtil.setLSValue)('portal_login','langId',langId);(0,_LoginUtil.setLSValue)('portal_login','langText',langText);_ecCom.WeaTools.ls.set('languageidweaver',langId);window.open('/wui/index.html?#/main','_blank');}});}// getMultiLangs(params = {}) {
//     WeaTools.callApi('/api/system/language/base/getActiveLanguage', 'GET', params).then((result) => {
//         if (result.status == '1') {
//             const {activeLanguageInfo, activeLanguageIds, languageIdentify} = result;
//             this.multiLangs = activeLanguageInfo;
//         }
//     });
// }
},{key:'getMultiLangs',value:function getMultiLangs(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_ecCom.WeaTools.callApi('/api/system/language/base/getActiveLanguage','GET',params).then(function(result){if(result.status=='1'){var activeLanguageInfo=result.activeLanguageInfo,activeLanguageIds=result.activeLanguageIds,languageIdentify=result.languageIdentify;_this5.setState({multiLangs:activeLanguageInfo});(0,_LoginUtil.setLSValue)('portal_login','multiLangs',activeLanguageInfo);_ecCom.WeaTools.ls.set('activeLanguageIds',activeLanguageIds);_ecCom.WeaTools.ls.set('languageIdentify',languageIdentify);}});}},{key:'onLogin',value:function onLogin(){var _this6=this;var _state5=this.state,queryParams=_state5.queryParams,langId=_state5.langId,langText=_state5.langText,isRememberAccount=_state5.isRememberAccount,isRememberPassword=_state5.isRememberPassword,loginSetting=_state5.loginSetting;var _queryParams$logintyp2=queryParams.logintype,logintype=_queryParams$logintyp2===undefined?'1':_queryParams$logintyp2;this.setState({isLogging:true});window.doLoginAction&&window.doLoginAction('login',{queryParams:queryParams,logintype:logintype,langid:langId,loginSetting:loginSetting,success:function success(username,password){jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();var cacheAccount='';var cachePassword='';if(isRememberAccount)cacheAccount=username;if(isRememberPassword)cachePassword=password;_this6.setState({isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,cacheAccount:cacheAccount,cachePassword:cachePassword});(0,_LoginUtil.setLSValue)('portal_login','langId',langId);(0,_LoginUtil.setLSValue)('portal_login','langText',langText);(0,_LoginUtil.setLSValue)('portal_login','cacheAccount',cacheAccount);(0,_LoginUtil.setLSValue)('portal_login','cachePassword',cachePassword);(0,_LoginUtil.setLSValue)('portal_login','isRememberAccount',isRememberAccount);(0,_LoginUtil.setLSValue)('portal_login','isRememberPassword',isRememberPassword);(0,_LoginUtil.initLSValue)(username,langId);_ecCom.WeaTools.ls.set('languageidweaver',langId);if(logintype=='2'){window.location.href='/spa/crmPortal/mobx/index.html#/main';}else{// 判断当前登录日期和上次登录的日期是否为同一天，不是同一天则刷新页面
var date=new Date();var logindate=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();var _logindate=_ecCom.WeaTools.ls.getStr('logindate');if(logindate!=_logindate){_ecCom.WeaTools.ls.set('logindate',logindate);}window.open('/wui/index.html?#/main','_blank');}_this6.setState({isLogging:false});},failure:function failure(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(params.reflashValidateCode){_this6.onValidateCodeChange();}_this6.getLoginForm();_this6.setState({isLogging:false});}});}},{key:'render',value:function render(){var _this7=this;var _state6=this.state,isLogging=_state6.isLogging,isRememberPW=_state6.isRememberPW,isRememberAccount=_state6.isRememberAccount,isRememberPassword=_state6.isRememberPassword,cacheAccount=_state6.cacheAccount,cachePassword=_state6.cachePassword,langId=_state6.langId,_state6$loginSettingI=_state6.loginSettingInfo,loginSettingInfo=_state6$loginSettingI===undefined?{}:_state6$loginSettingI,loginFormHiddenItems=_state6.loginFormHiddenItems,_state6$loginSetting=_state6.loginSetting,loginSetting=_state6$loginSetting===undefined?{}:_state6$loginSetting,validateCode=_state6.validateCode,loginType=_state6.loginType,_state6$loginFormItem=_state6.loginFormItems,loginFormItems=_state6$loginFormItem===undefined?[]:_state6$loginFormItem,hasMultiLang=_state6.hasMultiLang,multiLangs=_state6.multiLangs,loginId=_state6.loginId,edata=_state6.edata;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config)return _react2.default.createElement('div',null);var item=config.item,isHasRight=config.isHasRight;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=loginForm.color,backgroundColor=loginForm.backgroundColor;var needforgotpassword=loginSetting.needforgotpassword;if(!config)return _react2.default.createElement('div',null);var EmultiLang='';if(isHasRight){if((0,_lodash.isEmpty)(edata))return _react2.default.createElement('div',null);}else{return _react2.default.createElement(_common.NoRightCom,null);}if(!hasMultiLang){EmultiLang=_react2.default.createElement('div',{className:'login-multiLang'});}else{var langlId=langId+"";EmultiLang=_react2.default.createElement('div',{className:'login-multiLang',style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaSelect,{value:langlId,style:{marginLeft:'10px',border:'none',width:'82px'},options:multiLangs.map(function(item){return{key:item.id,showname:item.language};}),onChange:function onChange(value,showname){_ecCom.WeaLocaleProvider.getLocaleLabelByLang(['common','portal'],value).then(function(){_this7.setState({langId:value,langText:showname});_this7.getLoginForm({langId:value});});}})),_react2.default.createElement('div',{className:'login-toggle login-draggable-display portal-login-element'},loginType=='form'?_react2.default.createElement('i',{className:'icon-coms-Scan',style:{color:'#BFBFBF'},onClick:function onClick(){return _this7.setState({loginType:'QRCode'});}}):_react2.default.createElement('i',{className:'icon-coms-Revoke2',style:{color:'#BFBFBF'},onClick:function onClick(){return _this7.setState({loginType:'form'});}})));}var verificationCode=_react2.default.createElement('div',null);loginFormItems.map(function(item,index){if(item.atype=='validatecode'){verificationCode=_react2.default.createElement('div',{key:index,className:'login-form-item',style:{color:color,borderBottom:'none',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{type:item.type,name:item.name,id:item.id,style:{width:'128px',display:'inline-block',position:'relative'},placeholder:item.label}),_react2.default.createElement('div',{style:{width:'112px',height:'38px',display:'inline-block',marginLeft:'20px',position:'absolute',top:'-4px'}},_react2.default.createElement('img',{src:validateCode,alt:'',onClick:_this7.onValidateCodeChange})));}});return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'login-form-box login-draggable-display portal-login-element'},EmultiLang,loginType=='form'?_react2.default.createElement('div',{className:'login-form'},loginFormItems.map(function(item,index){var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;}else if(item.atype=='password'){defaultValue=cachePassword;}var itemComp=_react2.default.createElement('div',{key:index,className:'login-form-item',style:{color:color}},_react2.default.createElement('span',{className:'login-form-label',onClick:_this7.onLabelClick},item.label,':'),_react2.default.createElement(_ecCom.WeaInput,{type:item.type,name:item.name,id:item.id,className:'login-form-input',defaultValue:defaultValue}));if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',null);}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,style:{display:'none'},dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'login-form-remember',style:{color:color}},needforgotpassword=='1'&&_react2.default.createElement('div',{className:'login-form-remember-forget',title:getLabel(81614,'忘记密码')},_react2.default.createElement('span',{onClick:function onClick(){return _this7.onPasswordForget();}},getLabel(81614,'忘记密码'))),_react2.default.createElement('div',{className:'login-form-remember-content'},_react2.default.createElement('div',{className:'login-form-remember-account',title:getLabel(381949,'记住账号')},_react2.default.createElement(_antd.Checkbox,{checked:isRememberAccount,onChange:function onChange(e){return _this7.onRememberChange('account',e.target.checked);}},getLabel(381949,'记住账号'))),_react2.default.createElement('div',{className:'login-form-remember-password',title:getLabel(25722,'记住密码')},_react2.default.createElement(_antd.Checkbox,{checked:isRememberPassword,onChange:function onChange(e){return _this7.onRememberChange('password',e.target.checked);}},getLabel(25722,'记住密码')))),_react2.default.createElement('div',{className:'login-form-clear'})),verificationCode,_react2.default.createElement('div',{className:'login-form-submit',style:{paddingLeft:'71px',marginTop:'32px'}},_react2.default.createElement(_antd.Button,{loading:isLogging,className:'login-form-submit-btn',onClick:this.onLogin},getLabel(388151,'登陆')))):_react2.default.createElement(_E9QRCode2.default,{datas:this.state,getLoginForm:this.getLoginForm,onQCLogin:this.onQCLogin}),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return Login;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Login=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Login);exports.default=Login;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLoginBgImageStyle=exports.getDefaultPathname=exports.initLSValue=exports.setLSValue=exports.getLSValue=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 获取本地缓存数据
 *
 * @param key1
 * @param key2
 * @returns {*}
 */var getLSValue=exports.getLSValue=function getLSValue(key1,key2){var obj=_ecCom.WeaTools.ls.getJSONObj(key1);return obj&&obj[key2];};/**
 * 设置本地缓存数据
 *
 * @param key1
 * @param key2
 * @param value
 * @returns {*}
 */var setLSValue=exports.setLSValue=function setLSValue(key1,key2,value){var obj=_ecCom.WeaTools.ls.getJSONObj(key1)||{};obj[key2]=value;_ecCom.WeaTools.ls.set(key1,obj);};/**
 * 初始化本地缓存数据
 *
 * @param loginid 登录账号
 * @param languageidweaver 登录语言
 */var initLSValue=exports.initLSValue=function initLSValue(loginid,languageidweaver){var _loginid=_ecCom.WeaTools.ls.getStr('loginid');var _languageidweaver=_ecCom.WeaTools.ls.getStr('languageidweaver');var ls=window.localStorage;var keys=[];if(loginid!=_loginid){for(var i=0,len=ls.length;i<len;i++){var key=ls.key(i);if(/^theme-/.test(key)||/^portal-/.test(key)||/^edata-/.test(key)||/^tabdata-/.test(key)){keys.push(key);}}}if(languageidweaver!=_languageidweaver){keys.push('theme-backEndMenu');keys.push('theme-topMenu');keys.push('theme-portalMenu');}for(var j=0,len2=keys.length;j<len2;j++){ls.removeItem(keys[j]);}_ecCom.WeaTools.ls.set('loginid',loginid);_ecCom.WeaTools.ls.set('languageidweaver',languageidweaver);};/**
 * 获取登录成功后跳转的默认路径名
 *
 * @returns {string}
 */var getDefaultPathname=exports.getDefaultPathname=function getDefaultPathname(){return'/main';};/**
 * 获取登录背景图片样式
 *
 * @param loginInfo 登录背景图片信息
 * @returns {*}
 */var getLoginBgImageStyle=exports.getLoginBgImageStyle=function getLoginBgImageStyle(loginInfo){var fillStyle=loginInfo.fillStyle;var src=getLSValue('login','loginBgImage')||loginInfo.imgsrc;var width=getLSValue('login','loginBgImageWidth')||loginInfo.width;var height=getLSValue('login','loginBgImageHeight')||loginInfo.height;var style={backgroundImage:'url('+src+')'};switch(fillStyle){case'adapt':case'fill':style.backgroundRepeat='no-repeat';style.backgroundSize='cover';var _style={};var win_width=jQuery(window).width();var win_height=jQuery(window).height();win_width=win_width<800?800:win_width;win_height=win_height<712?712:win_height;var rate=width/height;var _rate=win_width/win_height;if(rate>_rate){if(fillStyle=='adapt'){_style={width:win_width,height:win_width/rate,marginTop:(win_height-win_width/rate)/2};}if(fillStyle=='fill'){_style={width:win_height*rate,height:win_height,marginLeft:-((win_height*rate-win_width)/2)};}}else if(rate<_rate){if(fillStyle=='adapt'){_style={width:win_height*rate,height:win_height,marginLeft:(win_width-win_height*rate)/2};}if(fillStyle=='fill'){_style={width:win_width,height:win_width/rate};}}else{_style={width:win_width,height:win_height};}style=(0,_extends3.default)({},style,_style);break;case'tile':style.backgroundRepeat='repeat';break;case'center':style.backgroundPosition='center';style.backgroundRepeat='no-repeat';break;default:style.backgroundRepeat='no-repeat';style.backgroundSize='100% 100%';break;}return style;};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _qrcode=__webpack_require__(599);var _qrcode2=_interopRequireDefault(_qrcode);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9QRCode=function(_React$Component){(0,_inherits3.default)(E9QRCode,_React$Component);function E9QRCode(props){(0,_classCallCheck3.default)(this,E9QRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QRCode.__proto__||(0,_getPrototypeOf2.default)(E9QRCode)).call(this,props));_this.getQRCode=_this.getQRCode.bind(_this);_this.scanQRCode=_this.scanQRCode.bind(_this);return _this;}(0,_createClass3.default)(E9QRCode,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,getLoginForm=_props.getLoginForm,_props$datas=_props.datas,datas=_props$datas===undefined?{}:_props$datas;var loginId=datas.cacheAccount,langId=datas.langId;this.getQRCode();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.getQRCode();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.clearInterval(this.scanInterval);}},{key:'render',value:function render(){var _props$datas2=this.props.datas,datas=_props$datas2===undefined?{}:_props$datas2;var _datas$loginSettingIn=datas.loginSettingInfo,loginSettingInfo=_datas$loginSettingIn===undefined?{}:_datas$loginSettingIn,qrCode=datas.qrCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var size=this.props.size||180;var color=this.props.color||loginForm.color||'#fff';return _react2.default.createElement('div',{className:'login-QRCode'},_react2.default.createElement('div',{className:'login-QRCode-area'},!!qrCode?_react2.default.createElement(_qrcode2.default,{value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#eaeaea'}):''),_react2.default.createElement('div',{className:'login-QRCode-describe'},getLabel(84272,'请使用e-mobile扫描二维码以登录')));}},{key:'getQRCode',value:function getQRCode(){var _props$datas3=this.props.datas,datas=_props$datas3===undefined?{}:_props$datas3;var qrCode=datas.qrCode;if(!!qrCode){window.clearInterval(this.scanInterval);this.scanInterval=window.setInterval(this.scanQRCode.bind(this),1000);}}},{key:'scanQRCode',value:function scanQRCode(){var onQCLogin=this.props.onQCLogin;onQCLogin();}}]);return E9QRCode;}(_react2.default.Component);exports.default=E9QRCode;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = __webpack_require__(0);

var PropTypes = __webpack_require__(18); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(600);

var ErrorCorrectLevel = __webpack_require__(158);

function getBackingStorePixelRatio(ctx) {
  return (// $FlowFixMe
    ctx.webkitBackingStorePixelRatio || // $FlowFixMe
    ctx.mozBackingStorePixelRatio || // $FlowFixMe
    ctx.msBackingStorePixelRatio || // $FlowFixMe
    ctx.oBackingStorePixelRatio || // $FlowFixMe
    ctx.backingStorePixelRatio || 1
  );
} // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000'
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string
};

var QRCodeCanvas =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QRCodeCanvas, _React$Component);

  function QRCodeCanvas() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = QRCodeCanvas.__proto__ || Object.getPrototypeOf(QRCodeCanvas)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "_canvas", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    }), _temp));
  }

  _createClass(QRCodeCanvas, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this2.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _props = this.props,
          value = _props.value,
          size = _props.size,
          level = _props.level,
          bgColor = _props.bgColor,
          fgColor = _props.fgColor; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var tileW = size / cells.length;
        var tileH = size / cells.length;
        var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
        canvas.height = canvas.width = size * scale;
        ctx.scale(scale, scale);
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          value = _props2.value,
          size = _props2.size,
          level = _props2.level,
          bgColor = _props2.bgColor,
          fgColor = _props2.fgColor,
          style = _props2.style,
          otherProps = _objectWithoutProperties(_props2, ["value", "size", "level", "bgColor", "fgColor", "style"]);

      var canvasStyle = _extends({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this3._canvas = _ref2;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.Component);

Object.defineProperty(QRCodeCanvas, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeCanvas, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCodeSVG =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(QRCodeSVG, _React$Component2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, (QRCodeSVG.__proto__ || Object.getPrototypeOf(QRCodeSVG)).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this4 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this4.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          value = _props3.value,
          size = _props3.size,
          level = _props3.level,
          bgColor = _props3.bgColor,
          fgColor = _props3.fgColor,
          otherProps = _objectWithoutProperties(_props3, ["value", "size", "level", "bgColor", "fgColor"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return;
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var ops = [];
      cells.forEach(function (row, y) {
        var lastIsDark = false;
        var start = null;
        row.forEach(function (cell, x) {
          if (!cell && start !== null) {
            // M0 0h7v1H0z injects the space with the move and dropd the comma,
            // saving a char per operation
            ops.push("M".concat(start, " ").concat(y, "h").concat(x - start, "v1H").concat(start, "z"));
            start = null;
            return;
          } // end of row, clean up or skip


          if (x === row.length - 1) {
            if (!cell) {
              // We would have closed the op above already so this can only mean
              // 2+ light modules in a row.
              return;
            }

            if (start === null) {
              // Just a single dark module.
              ops.push("M".concat(x, ",").concat(y, " h1v1H").concat(x, "z"));
            } else {
              // Otherwise finish the current line.
              ops.push("M".concat(start, ",").concat(y, " h").concat(x + 1 - start, "v1H").concat(start, "z"));
            }

            return;
          }

          if (cell && start === null) {
            start = x;
          }
        });
      });
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(cells.length, " ").concat(cells.length)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(cells.length, "v").concat(cells.length, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: ops.join('')
      }));
    }
  }]);

  return QRCodeSVG;
}(React.Component);

Object.defineProperty(QRCodeSVG, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeSVG, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _extends({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(601);
var RSBlock = __webpack_require__(602);
var BitBuffer = __webpack_require__(603);
var util = __webpack_require__(604);
var Polynomial = __webpack_require__(159);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(157);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(158);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 603 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(157);
var Polynomial = __webpack_require__(159);
var math = __webpack_require__(160);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var NewMeeting=function(_React$Component){(0,_inherits3.default)(NewMeeting,_React$Component);function NewMeeting(props){(0,_classCallCheck3.default)(this,NewMeeting);var _this=(0,_possibleConstructorReturn3.default)(this,(NewMeeting.__proto__||(0,_getPrototypeOf2.default)(NewMeeting)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(NewMeeting,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/newmeeting','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:esetting.showHeader=='1',pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return NewMeeting;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewMeeting=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewMeeting);exports.default=NewMeeting;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var DayPlan=function(_React$Component){(0,_inherits3.default)(DayPlan,_React$Component);function DayPlan(props){(0,_classCallCheck3.default)(this,DayPlan);var _this=(0,_possibleConstructorReturn3.default)(this,(DayPlan.__proto__||(0,_getPrototypeOf2.default)(DayPlan)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(DayPlan,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/dayplan','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return DayPlan;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DayPlan=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DayPlan);exports.default=DayPlan;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var ProcessTask=function(_React$Component){(0,_inherits3.default)(ProcessTask,_React$Component);function ProcessTask(props){(0,_classCallCheck3.default)(this,ProcessTask);var _this=(0,_possibleConstructorReturn3.default)(this,(ProcessTask.__proto__||(0,_getPrototypeOf2.default)(ProcessTask)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(ProcessTask,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/view','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:esetting.showHeader=='1',pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid},' '),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return ProcessTask;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ProcessTask=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ProcessTask);exports.default=ProcessTask;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Base64=ecCom.WeaTools.Base64;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var UnreadDocs=function(_React$Component){(0,_inherits3.default)(UnreadDocs,_React$Component);function UnreadDocs(props){(0,_classCallCheck3.default)(this,UnreadDocs);var _this=(0,_possibleConstructorReturn3.default)(this,(UnreadDocs.__proto__||(0,_getPrototypeOf2.default)(UnreadDocs)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);if(window.element_unReadDoc_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_unReadDoc_refresh[props.config.params.eid]=_this.handleRefresh.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleRefresh.bind(_this);window.element_unReadDoc_refresh=obj;}return _this;}(0,_createClass3.default)(UnreadDocs,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/view','POST',(0,_extends3.default)({},params)).then(function(result){var more=result.more||"";window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+Base64.encode(more.toString())};ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],(0,_extends3.default)({eid:eid,ebaseid:ebaseid},esetting)),showHeader:esetting.showHeader=='1',pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid},' '),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return UnreadDocs;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);UnreadDocs=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(UnreadDocs);exports.default=UnreadDocs;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var NewCustomers=function(_React$Component){(0,_inherits3.default)(NewCustomers,_React$Component);function NewCustomers(props){(0,_classCallCheck3.default)(this,NewCustomers);var _this=(0,_possibleConstructorReturn3.default)(this,(NewCustomers.__proto__||(0,_getPrototypeOf2.default)(NewCustomers)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(NewCustomers,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/view','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:esetting.showHeader=='1',pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return NewCustomers;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewCustomers=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewCustomers);exports.default=NewCustomers;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MessageReminding=function(_React$Component){(0,_inherits3.default)(MessageReminding,_React$Component);function MessageReminding(props){(0,_classCallCheck3.default)(this,MessageReminding);var _this=(0,_possibleConstructorReturn3.default)(this,(MessageReminding.__proto__||(0,_getPrototypeOf2.default)(MessageReminding)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MessageReminding,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/dayplan','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:(0,_extends3.default)({},style,{height:style1.height,marginTop:'10px'}),id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return MessageReminding;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MessageReminding=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MessageReminding);exports.default=MessageReminding;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(613);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var News=function(_React$Component){(0,_inherits3.default)(News,_React$Component);function News(props){(0,_classCallCheck3.default)(this,News);var _this=(0,_possibleConstructorReturn3.default)(this,(News.__proto__||(0,_getPrototypeOf2.default)(News)).call(this,props));_this.state={edata:null,refresh:false,color:'#939393',isShowAdd:false,canEdit:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);_this.onChangeShowAdd=_this.onChangeShowAdd.bind(_this);_this.onChangeCanEdit=_this.onChangeCanEdit.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(News,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(window.element_news_refresh&&(0,_typeof3.default)(window.element_news_refresh)=='object'){delete element_news_refresh[this.props.config.params.eid];}}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/news','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'handleOpen',value:function handleOpen(){var edata=this.state.edata;var _edata$data=edata.data,data=_edata$data===undefined?{}:_edata$data;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'onChangeShowAdd',value:function onChangeShowAdd(value){this.setState({isShowAdd:value});}},{key:'onChangeCanEdit',value:function onChangeCanEdit(value){this.setState({canEdit:value});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eShowNum=esetting.eShowNum,eLinkMode=esetting.eLinkMode,eRemindMode=esetting.eRemindMode;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var dyParams=[{key:'1',type:'EShowNum',ref:'eShowNum',value:eShowNum},{key:'2',type:'ELinkMode',ref:'eLinkMode',value:eLinkMode},{key:'3',type:'ERemindMode',ref:'eRemindMode',value:eRemindMode}];var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,dyParams:dyParams,sebaseid:'7'};var edata_img={data:{}};if(!(0,_lodash.isEmpty)(edata)&&isHasRight){edata_img=(0,_lodash.cloneDeep)(edata);if(edata_img.data&&edata_img.data.tabsetting)edata_img.data.tabsetting.imgs=[];}var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,ref:"eContent",fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:!refresh?edata:edata_img,onChangeShowAdd:this.onChangeShowAdd,onChangeCanEdit:this.onChangeCanEdit});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeM:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',height:'100%'}},_react2.default.createElement('div',{style:{width:'auto',height:'100%',position:'relative'}},this.state.canEdit&&_react2.default.createElement('div',(0,_defineProperty3.default)({title:'\u65B0\u5EFA\u6587\u6863',style:{right:'30px',bottom:'20px',position:'absolute'},className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){_this3.setState({color:'#434343'});_this3.onChangeShowAdd(true);},onMouseLeave:function onMouseLeave(){_this3.setState({color:'#939393'});_this3.onChangeShowAdd(false);},onClick:function onClick(){_this3.refs&&_this3.refs.eContent.handleOpen();}},'style',{color:this.state.color}),_react2.default.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),edata.tabids&&edata.tabids.length>1?_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)):_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height},onMouseOver:function onMouseOver(){_this3.onChangeShowAdd(true);},onMouseLeave:function onMouseLeave(){return _this3.onChangeShowAdd(false);}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config})))));}}]);return News;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);News=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(News);exports.default=News;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(614);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _NewsType=__webpack_require__(615);var _NewsType2=_interopRequireDefault(_NewsType);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.toggleTabPage=_this.toggleTabPage.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);_this.canOnclick=_this.canOnclick.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);if(window.element_news_refresh&&(typeof element_news_refresh==='undefined'?'undefined':(0,_typeof3.default)(element_news_refresh))=='object'){window.element_news_refresh[props.config.params.eid]=_this.handleTabData.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleTabData.bind(_this);window.element_news_refresh=obj;}return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillMount',value:function componentWillMount(){this.canOnclick();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'toggleTabPage',value:function toggleTabPage(tabid){var currentTab=this.state.currentTab;this.setState({refresh:!(tabid===currentTab)});this.handleTabData(tabid);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;this.setState({currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/newstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'handleOpen',value:function handleOpen(){var tabdata=this.state.tabdata;var _tabdata$tabsetting=tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'canOnclick',value:function canOnclick(){var currentTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.state.currentTab;var _props=this.props,config=_props.config,edata=_props.edata,onChangeCanEdit=_props.onChangeCanEdit;var _state$tabdata=this.state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata;var data=edata.data;var eid=config.params.eid;var _tabdata$docParams=tabdata.docParams,docParams=_tabdata$docParams===undefined?{}:_tabdata$docParams;var docCatalogIds=docParams.docCatalogIds;if(docCatalogIds&&docCatalogIds.length>0){var rightArr=ls.getJSONObj('portal-doc-right');var params={ids:docCatalogIds.join()};if(rightArr==null){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);ls.set('portal-doc-right',[{eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right}]);});}else{var isHave=false;rightArr.map(function(item){if(item.eid==eid&&item.tabid==currentTab){onChangeCanEdit(item.right);isHave=true;return;}});if(!isHave){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);rightArr.push({eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right});ls.set('portal-doc-right',rightArr);});}}}else{onChangeCanEdit(false);}}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp,onChangeShowAdd=_props2.onChangeShowAdd;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _edata$tabids=edata.tabids,tabids=_edata$tabids===undefined?[]:_edata$tabids,_edata$titles=edata.titles,titles=_edata$titles===undefined?[]:_edata$titles,counts=edata.counts,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var more='';var tabdata_img={};if(!(0,_lodash.isEmpty)(tabdata)){tabdata_img=_.cloneDeep(tabdata);tabdata_img.tabsetting.imgs=[];}if(tabdata){more=tabdata.tabsetting.more;contentHtml=_react2.default.createElement(_MarqueeCom2.default,{tabdata:!refresh?tabdata:tabdata_img,eid:eid,scolltype:tabdata.tabsetting.rollDirection},_react2.default.createElement(_NewsType2.default,{eid:eid,data:!refresh?tabdata:tabdata_img,esetting:esetting}));}var _titleProps={currentTab:currentTab,config:config,titles:titles,counts:counts,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,more:more,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.toggleTabPage};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,onMouseOver:function onMouseOver(){_this3.canOnclick();onChangeShowAdd(true);},style:{height:cstyle.height},onMouseLeave:function onMouseLeave(){return onChangeShowAdd(false);}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+escape(more)};}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}},{key:'render',value:function render(){var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _typeof2=__webpack_require__(21);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _objectAssign=__webpack_require__(39);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//文档中心元素
var NewsType=function(_React$Component){(0,_inherits3.default)(NewsType,_React$Component);function NewsType(props){(0,_classCallCheck3.default)(this,NewsType);return(0,_possibleConstructorReturn3.default)(this,(NewsType.__proto__||(0,_getPrototypeOf2.default)(NewsType)).call(this,props));}(0,_createClass3.default)(NewsType,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,data=_props.data,_props$esetting=_props.esetting,esetting=_props$esetting===undefined?{}:_props$esetting,canEdit=_props.canEdit;var linkmode=esetting.linkmode;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting,_data$srcStyle=data.srcStyle,srcStyle=_data$srcStyle===undefined?{}:_data$srcStyle;var _srcStyle$autoheight=srcStyle.autoheight,autoheight=_srcStyle$autoheight===undefined?'0':_srcStyle$autoheight,_srcStyle$pictureheig=srcStyle.pictureheight,pictureheight=_srcStyle$pictureheig===undefined?'108px':_srcStyle$pictureheig,_srcStyle$picturewidt=srcStyle.picturewidth,picturewidth=_srcStyle$picturewidt===undefined?'120px':_srcStyle$picturewidt;var _tabsetting$style=tabsetting.style,_tabsetting$style$abs=_tabsetting$style.abstractColor,abstractColor=_tabsetting$style$abs===undefined?'#797979':_tabsetting$style$abs,_tabsetting$style$abs2=_tabsetting$style.abstractFont,abstractFont=_tabsetting$style$abs2===undefined?'微软雅黑':_tabsetting$style$abs2,_tabsetting$style$abs3=_tabsetting$style.abstractSize,abstractSize=_tabsetting$style$abs3===undefined?'12':_tabsetting$style$abs3,abstractstyle=_tabsetting$style.abstractstyle,_tabsetting$style$abs4=_tabsetting$style.abstractWeight,abstractWeight=_tabsetting$style$abs4===undefined?'0':_tabsetting$style$abs4,_tabsetting$style$tit=_tabsetting$style.titleColor,titleColor=_tabsetting$style$tit===undefined?'#000000':_tabsetting$style$tit,_tabsetting$style$tit2=_tabsetting$style.titleFont,titleFont=_tabsetting$style$tit2===undefined?'微软雅黑':_tabsetting$style$tit2,_tabsetting$style$tit3=_tabsetting$style.titleSize,titleSize=_tabsetting$style$tit3===undefined?'16':_tabsetting$style$tit3,titlestyle=_tabsetting$style.titlestyle,_tabsetting$style$tit4=_tabsetting$style.titleWeight,titleWeight=_tabsetting$style$tit4===undefined?'0':_tabsetting$style$tit4;var list=data.data;if(list.length===0){return React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,' ',React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));}//tab设置信息
var height=tabsetting.height,width=tabsetting.width,showModeId=tabsetting.showModeId,imgs=tabsetting.imgs;var columns=new Array();var imgStyle={width:picturewidth,height:pictureheight};var style={verticalAlign:'top',width:picturewidth,height:pictureheight};if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}var listStyle2={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1&&imgStyle.width.indexOf('px')!=-1){listStyle2={width:imgStyle.width,height:imgStyle.height};}var docHtml='';switch(parseInt(showModeId)){case 2://上图式
imgStyle['margin']='0 auto';var lHtml=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:img});}}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid},React.createElement('div',{style:imgStyle},imghtml),React.createElement('div',{style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},item.docsubject?React.createElement('div',{style:{marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{display:'-webkit-box',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'2',WebkitBoxOrient:'vertical'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%',height:'32px'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px',width:'60px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',bottom:'15px',float:'right',width:'calc(100% - 60px - 10px)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,lHtml);break;case 3://左图式
var html=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){img=img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{style:{overflow:'auto',overflowY:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},item.docsubject?React.createElement('div',{style:{marginTop:'10px',marginRight:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',null,React.createElement('span',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'1',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',position:'absolute',bottom:'15px',float:'right',width:'100%'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,html);break;case 4://列表式2
var html4=null;var imghtml=null;var imghtml2=[];var j=0;var imgs_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs_new.length>1){imgs.map(function(item,i){imghtml2[j]=imgs[i];j++;});if(imghtml2.length==0){imghtml2[0]='/images/homepage/noimgdefault_wev8.jpg';}var ihtml=imghtml2.map(function(item,i){var img=imghtml2[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}// if (img.indexOf("|") !== -1) img = img.split("|")[0];
return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},ihtml));}else{var img=imgs_new[0];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[0]&&list[0].docsubject&&list[0].docsubject.link,style:listStyle2,eid:eid,src:img})));}}columns=(0,_common.formatData)(list[0],esetting);style['paddingTop']='6px';html4=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}))));docHtml=React.createElement('div',null,html4);break;case 5://双列式
columns=(0,_common.formatData)(list[0],esetting);var evenData=new Array();var oddData=new Array();list.map(function(item,i){if(i%2===0){evenData.push(item);}else{oddData.push(item);}});if(!(0,_lodash.isEmpty)(evenData)&&!(0,_lodash.isEmpty)(oddData)){docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')))));}else{docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12,order:1},!(0,_lodash.isEmpty)(evenData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:evenData,size:'small'})),React.createElement(_antd.Col,{span:12,order:2},!(0,_lodash.isEmpty)(oddData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:oddData,size:'small'}))));}break;case 6://摘要式
var html6=list.map(function(item,i){var docsubject=item.docsubject||{};var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var _img=imgs[i];if((typeof _img==='undefined'?'undefined':(0,_typeof3.default)(_img))=='object'&&_img.length>1){_img=_img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:_img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left'});return React.createElement('div',{style:{width:'100%',paddingBottom:'20px',marginBottom:'5px',borderBottom:i!==list.length-1?'1px solid #dedede':'',overflow:'hidden'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{verticalAlign:'middle',marginTop:'-25px',marginLeft:'5px',cursor:'pointer'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{height:'60px',lineHeight:'30px',color:'rgb(105, 104, 104)',textOverflow:'ellipsis',width:'99%',overflow:'hidden',WebkitLineClamp:'2',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)));});docHtml=React.createElement('div',null,html6);break;case 7://摘要式2
var listStyle3={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1){listStyle3={width:'100%',height:imgStyle.height};}var imghtml7=null;var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var imghtml3=[];var m=0;if(!(0,_lodash.isEmpty)(imgs)){if(imgs.length>1){imgs.map(function(item,i){if(imgs[i]!='/images/homepage/noimgdefault_wev8.jpg'){imghtml3[m]=imgs[i];m++;}});if(imghtml3.length==0){imghtml3=['/images/homepage/noimgdefault_wev8.jpg'];}var _ihtml=imghtml3.map(function(item,i){var img=imghtml3[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,style:listStyle3,eid:eid,src:img}));});imghtml7=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_ihtml));}else{var _img2=imgs_new[0];if(!_img2)_img2='/images/homepage/noimgdefault_wev8.jpg';if(_img2.indexOf("|")!==-1)_img2=_img2.split("|")[0];imghtml7=React.createElement('div',{style:{height:'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[0]&&list[0].docsubject&&list[0].docsubject.link,style:listStyle3,eid:eid,src:_img2})));}}var html7=list.map(function(item,i){var docsubject=item.docsubject||{};return React.createElement('div',{style:{float:'left',paddingLeft:'10px',width:'100%',borderBottom:i!==list.length-1?'1px solid #dedede':''}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{display:'-webkit-box',maxHeight:'60px',width:'99%',lineHeight:'30px',color:'#696868',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',marginBottom:'10px'}},item.summary));});docHtml=React.createElement('div',null,React.createElement('div',{style:{width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml7),React.createElement('div',{style:{overflow:'hidden'}},html7)));break;case 8://头条式
var item=list[0];var docsubject=item.docsubject||{};var tableHtml='';var newList=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns=(0,_common.formatData)(list[1],esetting);tableHtml=React.createElement(_ecCom.WeaTable,{columns:_columns,showHeader:false,pagination:false,dataSource:newList.slice(1,list.length),size:'small'});}docHtml=React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(this,docsubject.link,esetting.linkmode),style:{fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer',width:'100%'}},docsubject.name,docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):'')),React.createElement('div',{title:item.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)))),tableHtml);break;case 1://列表式
default:columns=(0,_common.formatData)(list[0],esetting);docHtml=React.createElement(_ecCom.WeaTable,{style:{fontSize:'20px'},columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'});break;}// return <AddNewCom canEdit={this.props.canEdit} catalogIds={tabsetting.catalogIds} catalogId={tabsetting.catalogId}>{docHtml}</AddNewCom>
return docHtml;}}]);return NewsType;}(React.Component);var AddNewCom=function(_React$Component2){(0,_inherits3.default)(AddNewCom,_React$Component2);function AddNewCom(props){(0,_classCallCheck3.default)(this,AddNewCom);var _this3=(0,_possibleConstructorReturn3.default)(this,(AddNewCom.__proto__||(0,_getPrototypeOf2.default)(AddNewCom)).call(this,props));_this3.state={isShowAdd:false,color:'#939393'};_this3.handleOpen=_this3.handleOpen.bind(_this3);return _this3;}(0,_createClass3.default)(AddNewCom,[{key:'handleOpen',value:function handleOpen(){var _props2=this.props,catalogId=_props2.catalogId,catalogIds=_props2.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,children=_props3.children,canEdit=_props3.canEdit;if(canEdit){return React.createElement('div',{className:' portal-element-news-doc-add',onMouseOver:function onMouseOver(){return _this4.setState({isShowAdd:true});},onMouseLeave:function onMouseLeave(){return _this4.setState({isShowAdd:false});}},React.createElement('div',{title:'\u65B0\u5EFA\u6587\u6863',className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){return _this4.setState({color:'#434343'});},onMouseLeave:function onMouseLeave(){return _this4.setState({color:'#939393'});},onClick:this.handleOpen,style:{color:this.state.color}},React.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),children);}return React.createElement('div',null,children);}}]);return AddNewCom;}(React.Component);var ImgCom=function(_React$Component3){(0,_inherits3.default)(ImgCom,_React$Component3);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this5=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this5.aClick=_this5.aClick.bind(_this5);return _this5;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props4=this.props,_props4$link=_props4.link,link=_props4$link===undefined?'':_props4$link,_props4$linkmode=_props4.linkmode,linkmode=_props4$linkmode===undefined?'1':_props4$linkmode;if(link!=''){(0,_common.openLinkUrl)(link,linkmode);// window.open(link, linkmode);
}else return false;}},{key:'render',value:function render(){var _props5=this.props,_props5$src=_props5.src,src=_props5$src===undefined?'':_props5$src,_props5$style=_props5.style,style=_props5$style===undefined?{width:'100%',height:'100%'}:_props5$style;return React.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},React.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(React.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);NewsType=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(NewsType);exports.default=NewsType;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 自定义元素
var CustomElement=function(_React$Component){(0,_inherits3.default)(CustomElement,_React$Component);function CustomElement(props){(0,_classCallCheck3.default)(this,CustomElement);var _this=(0,_possibleConstructorReturn3.default)(this,(CustomElement.__proto__||(0,_getPrototypeOf2.default)(CustomElement)).call(this,props));_this.state={loading:false,deleted:false};_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(CustomElement,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$item=config.item,item=_config$item===undefined?{}:_config$item;var _item$custom=item.custom,custom=_item$custom===undefined?{}:_item$custom;var modulename=custom.modulename,packagename=custom.packagename;if(modulename&&!window[packagename]){this.setState({loading:true});_ecCom.WeaTools.loadDevModules(modulename,packagename).then(function(){var _interval=window.setInterval(function(){if(window[packagename]){_this2.setState({loading:false});window.clearInterval(_interval);}},100);});}}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,deleted=_state.deleted;// 元素已删除，返回空
if(deleted)return _react2.default.createElement('div',null);var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;var isHasRight=config.isHasRight,isSetting=config.isSetting,item=config.item,params=config.params,synergyParams=config.synergyParams;var eid=item.eid,ebaseid=item.ebaseid,style=item.style,contentview=item.contentview,_item$custom2=item.custom,custom=_item$custom2===undefined?{}:_item$custom2;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var packagename=custom.packagename,viewcompname=custom.viewcompname,moreurl=custom.moreurl;try{if(moreurl){if(config.item.header&&config.item.header.toolbar&&config.item.header.toolbar.more){if(moreurl.indexOf('?')!=-1){moreurl+='&eid='+eid;}else{moreurl+='?eid='+eid;}config.item.header.toolbar.more.morehref=moreurl;}}else{config.item.header.toolbar.more=null;}}catch(e){}var EContent=null;if(isHasRight){if(!loading){if(window.rewritePortalCusEle&&typeof rewritePortalCusEle=='function'){var props=(0,_extends3.default)({},this.props);var options={config:config,fontSizeMp:fontSizeMp,isSetting:isSetting,id:eid,eid:eid,ebaseid:ebaseid,params:params,synergyParams:synergyParams};EContent=window.rewritePortalCusEle(props,options);}if(EContent==null&&window[packagename]&&window[packagename]['com']&&window[packagename]['com'][viewcompname]){var EContentTemp=window[packagename]['com'][viewcompname];EContent=_react2.default.createElement(EContentTemp,(0,_extends3.default)({},this.props,{config:config,fontSizeMp:fontSizeMp,isSetting:isSetting,id:eid,eid:eid,params:params,synergyParams:synergyParams}));}}else{EContent=_react2.default.createElement('div',{style:{width:'100%',height:'60px'}});}}else{EContent=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:loading},EContent)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}},{key:'handleRefresh',value:function handleRefresh(){var _this3=this;this.setState({loading:true});setTimeout(function(){return _this3.setState({loading:false});},100);}},{key:'handleDelete',value:function handleDelete(){this.setState({deleted:true});}}]);return CustomElement;}(_react2.default.Component);exports.default=CustomElement;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _EContent=__webpack_require__(618);var _EContent2=_interopRequireDefault(_EContent);__webpack_require__(619);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//快捷入口元素
var QuickEntry=function(_React$Component){(0,_inherits3.default)(QuickEntry,_React$Component);function QuickEntry(props){(0,_classCallCheck3.default)(this,QuickEntry);var _this=(0,_possibleConstructorReturn3.default)(this,(QuickEntry.__proto__||(0,_getPrototypeOf2.default)(QuickEntry)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(QuickEntry,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/quickentry','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,refresh:refresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}}]);return QuickEntry;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);QuickEntry=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(QuickEntry);exports.default=QuickEntry;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={ewidth:0};return _this;}(0,_createClass3.default)(EContent,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var ewidth=this.state.ewidth;var eid=config.params.eid;if(!(0,_lodash.isEqual)(ewidth,$('#content_'+eid).width())){this.setState({ewidth:$('#content_'+eid).width()});}}},{key:'componentDidMount',value:function componentDidMount(){var _props$config2=this.props.config,config=_props$config2===undefined?{}:_props$config2;var eid=config.params.eid;this.setState({ewidth:$('#content_'+eid).width()});}},{key:'render',value:function render(){var ewidth=this.state.ewidth;var _props=this.props,_props$config3=_props.config,config=_props$config3===undefined?{}:_props$config3,edata=_props.edata,fontSizeMp=_props.fontSizeMp,refresh=_props.refresh;var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting,data=edata.data;var linkmode=esetting.linkmode,showMode=esetting.showMode,_esetting$eTitleColor=esetting.eTitleColor,eTitleColor=_esetting$eTitleColor===undefined?"":_esetting$eTitleColor,eLayout=esetting.eLayout;var perNum=esetting.perNum;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var lastLineStyle={};var num=(parseInt(perNum)+1)*10;var length=data.length;var widthAll=parseInt((ewidth-num)/perNum);var width=1/perNum*100+'%';var lineNum=Math.ceil(length/parseInt(perNum));if(perNum==0){width=0;}if((showMode=='0'||showMode=='1'||showMode=='2')&&width<75){width=75;perNum=parseInt(parseInt((ewidth-num)/75));lineNum=Math.ceil(length/parseInt(perNum));}else if((showMode=='3'||showMode=='4'||showMode=='5')&&width<150){perNum=parseInt(parseInt((ewidth-num)/150));lineNum=Math.ceil(length/parseInt(perNum));width=150;}var quickEntryCom=_react2.default.createElement('div',null);var quickEntryCom2=_react2.default.createElement('div',null);var lastLineIndex=(lineNum-1)*parseInt(perNum);var lastLineNum=length-lastLineIndex;var lastlieItemWidth=1/lastLineNum*100+'%';var itemStyle={borderBottom:'2px dashed #E9E9E9',borderRight:'2px dashed #E9E9E9'};if(eLayout&&eLayout=='1'&&lastLineIndex>0){lastLineStyle={display:'block',margin:'0 auto',width:(length-lastLineIndex)*widthAll+'px'};if(showMode=='2'||showMode=='5'){lastLineStyle.width=parseFloat(lastLineStyle.width)+parseInt(lastLineNum)*10+'px';}}var normalLineStyle={width:parseFloat(widthAll)*perNum+'px',margin:'0 auto'};if(showMode=='2'||showMode=='5'){normalLineStyle={width:parseFloat(widthAll)*perNum+parseInt(perNum)*10+'px',margin:'0 auto'};}if(eLayout=='0'){normalLineStyle={};}var lastLineItemStyle={width:width+''.indexOf('%')=='-1'?width+'px':width};if(eLayout=='1'){if(showMode=='2'||showMode=='5'){lastLineItemStyle={width:'calc('+lastlieItemWidth+' - 10px)'};}else{lastLineItemStyle={width:lastlieItemWidth};}}else{if(showMode=='2'||showMode=='5'){lastLineItemStyle={width:width+''.indexOf('%')=='-1'?width+'px':'calc('+width+' - 10px)'};}else{lastLineItemStyle={width:width+''.indexOf('%')=='-1'?width+'px':width};}}switch(showMode){case'0':// 上下布局-无背景色/分割线
quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:width+''.indexOf('%')=='-1'?width+'px':width,float:'left',cursor:'pointer',marginTop:'10px'}},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:lastLineItemStyle.width,float:'left',cursor:'pointer',marginTop:'10px'}},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));}});break;case'1':// 上下布局-有分割线
quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}else if((index+1)%parseInt(perNum)==0){itemStyle={borderBottom:'2px dashed #E9E9E9'};}else{itemStyle={borderBottom:'2px dashed #E9E9E9',borderRight:'2px dashed #E9E9E9'};}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:(0,_extends3.default)({width:width+''.indexOf('%')=='-1'?width+'px':width,float:'left',cursor:'pointer'},itemStyle)},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index+1==length){itemStyle={};}else{itemStyle={borderRight:'2px dashed #E9E9E9'};}if(index>=lastLineIndex){return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:(0,_extends3.default)({width:lastLineItemStyle.width,float:'left',cursor:'pointer'},itemStyle)},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));}});break;case'2':// 上下布局-有背景色
quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:width+''.indexOf('%')=='-1'?width+'px':'calc('+width+' - 10px)',float:'left',cursor:'pointer',marginTop:'10px',marginLeft:'10px',backgroundColor:item.backGroundColor}},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:lastLineItemStyle.width,float:'left',cursor:'pointer',marginTop:'10px',marginLeft:'10px',backgroundColor:item.backGroundColor}},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));}});break;case'3'://左右布局-无背景色/分割线
quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:width+''.indexOf('%')=='-1'?width+'px':width,float:'left',cursor:'pointer',marginTop:'10px'}},_react2.default.createElement('div',{style:{margin:'5px auto',width:'150px',height:'75px'}},_react2.default.createElement('img',{style:{display:'block',width:'75px',float:'left'},className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{style:(0,_defineProperty3.default)({width:'75px',color:'rgb(0, 0, 0)',cursor:'pointer',display:'block',float:'left',lineHeight:'75px'},'color',eTitleColor),className:'quickentry-title'},item.title)));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:lastLineItemStyle.width,float:'left',cursor:'pointer',marginTop:'10px'}},_react2.default.createElement('div',{style:{margin:'5px auto',width:'150px',height:'75px'}},_react2.default.createElement('img',{style:{display:'block',width:'75px',float:'left'},className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{style:(0,_defineProperty3.default)({width:'75px',color:'rgb(0, 0, 0)',cursor:'pointer',display:'block',float:'left',lineHeight:'75px'},'color',eTitleColor),className:'quickentry-title'},item.title)));}});break;case'4'://左右布局-有分割线
quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}else if((index+1)%parseInt(perNum)==0){itemStyle={borderBottom:'2px dashed #E9E9E9'};}else{itemStyle={borderBottom:'2px dashed #E9E9E9',borderRight:'2px dashed #E9E9E9'};}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:(0,_extends3.default)({width:width+''.indexOf('%')=='-1'?width+'px':width,float:'left',cursor:'pointer'},itemStyle)},_react2.default.createElement('div',{style:{margin:'5px auto',width:'150px',height:'75px'}},_react2.default.createElement('img',{style:{display:'block',width:'75px',float:'left',marginTop:'0px'},className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{style:(0,_defineProperty3.default)({width:'75px',color:'rgb(0, 0, 0)',cursor:'pointer',display:'block',float:'left',lineHeight:'75px'},'color',eTitleColor),className:'quickentry-title'},item.title)));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){if(index+1==length){itemStyle={};}else{itemStyle={borderRight:'2px dashed #E9E9E9'};}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:(0,_extends3.default)({width:lastLineItemStyle.width,float:'left',cursor:'pointer'},itemStyle)},_react2.default.createElement('div',{style:{margin:'5px auto',width:'150px',height:'75px'}},_react2.default.createElement('img',{style:{display:'block',width:'75px',float:'left',marginTop:'0px'},className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{style:(0,_defineProperty3.default)({width:'75px',color:'rgb(0, 0, 0)',cursor:'pointer',display:'block',float:'left',lineHeight:'75px'},'color',eTitleColor),className:'quickentry-title'},item.title)));}});break;case'5'://左右布局-有背景色
quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:width+''.indexOf('%')=='-1'?width+'px':'calc('+width+' - 10px)',float:'left',cursor:'pointer',marginTop:'10px',marginLeft:'10px',backgroundColor:item.backGroundColor}},_react2.default.createElement('div',{style:{margin:'5px auto',width:'150px',height:'75px'}},_react2.default.createElement('img',{style:{display:'block',width:'75px',float:'left',marginTop:'0px!important'},className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{style:(0,_defineProperty3.default)({width:'75px',color:'rgb(0, 0, 0)',cursor:'pointer',display:'block',float:'left',lineHeight:'75px'},'color',eTitleColor),className:'quickentry-title'},item.title)));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:lastLineItemStyle.width,float:'left',cursor:'pointer',marginTop:'10px',marginLeft:'10px',backgroundColor:item.backGroundColor}},_react2.default.createElement('div',{style:{margin:'5px auto',width:'150px',height:'75px'}},_react2.default.createElement('img',{style:{display:'block',width:'75px',float:'left',marginTop:'0px!important'},className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{style:(0,_defineProperty3.default)({width:'75px',color:'rgb(0, 0, 0)',cursor:'pointer',display:'block',float:'left',lineHeight:'75px'},'color',eTitleColor),className:'quickentry-title'},item.title)));}});break;default:quickEntryCom=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return;}return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:width+''.indexOf('%')=='-1'?width+'px':width,float:'left',cursor:'pointer',marginTop:'10px'}},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));});quickEntryCom2=data&&data.length>0&&data.map(function(item,index){if(index>=lastLineIndex){return _react2.default.createElement('div',{title:item.title,onClick:function onClick(){return(0,_common.openLinkUrl)(item.link,linkmode);},style:{width:lastLineItemStyle.width,float:'left',cursor:'pointer',marginTop:'10px'}},_react2.default.createElement('img',{className:'quickentry-img',src:item.picture,alt:true}),_react2.default.createElement('div',{className:'quickentry-title',style:{color:eTitleColor}},item.title));}});}return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},_react2.default.createElement('div',null,_react2.default.createElement('div',{style:normalLineStyle},quickEntryCom),_react2.default.createElement('div',{style:lastLineStyle},quickEntryCom2)))));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(621);var _EContent2=_interopRequireDefault(_EContent);var _FooterMore=__webpack_require__(14);var _FooterMore2=_interopRequireDefault(_FooterMore);var _common=__webpack_require__(10);var _EContent3=__webpack_require__(154);var _EContent4=_interopRequireDefault(_EContent3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;// ecode自定义元素
var EcodeElement=function(_React$Component){(0,_inherits3.default)(EcodeElement,_React$Component);function EcodeElement(props){(0,_classCallCheck3.default)(this,EcodeElement);var _this=(0,_possibleConstructorReturn3.default)(this,(EcodeElement.__proto__||(0,_getPrototypeOf2.default)(EcodeElement)).call(this,props));_this.state={loading:false,deleted:false};_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.handleEData=_this.handleEData.bind(_this);_this.onRef=_this.onRef.bind(_this);// this.handleTabData = this.handleTabData.bind(this);
return _this;}(0,_createClass3.default)(EcodeElement,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$item=config.item,item=_config$item===undefined?{}:_config$item;var _item$custom=item.custom,custom=_item$custom===undefined?{}:_item$custom;var modulename=custom.modulename,packagename=custom.packagename;if(modulename&&!window[packagename]){this.setState({loading:true});_ecCom.WeaTools.loadDevModules(modulename,packagename).then(function(){var _interval=window.setInterval(function(){if(window[packagename]){_this2.setState({loading:false});window.clearInterval(_interval);}},100);});}}},{key:'componentDidMount',value:function componentDidMount(){var _props$config2=this.props.config,config=_props$config2===undefined?{}:_props$config2;var _config$params=config.params,params=_config$params===undefined?{}:_config$params;var eid=params.eid;var edata=ls.getJSONObj('edata-'+eid);if(config.islsdata&&edata){this.setState({edata:edata});}else{this.handleEData(params);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config4=this.props.config,item=_props$config4.item,params=_props$config4.params,isHasRight=_props$config4.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleEData',value:function handleEData(params){var _this3=this;var eid=params.eid,api=params.api;_ecCom.WeaTools.callApi(api||'/api/portal/element/ecodeelement','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this3.setState({edata:result,loading:false});});}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,deleted=_state.deleted;// 元素已删除，返回空
if(deleted)return _react2.default.createElement('div',null);var _state$edata=this.state.edata,edata=_state$edata===undefined?{}:_state$edata;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,isSetting=config.isSetting,item=config.item,params=config.params,synergyParams=config.synergyParams;var eid=item.eid,ebaseid=item.ebaseid,style=item.style,contentview=item.contentview,_item$custom2=item.custom,custom=_item$custom2===undefined?{}:_item$custom2;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,ref:"eContent",fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:loading},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid},_react2.default.createElement(_FooterMore2.default,{config:this.props.config}))));}},{key:'handleRefresh',value:function handleRefresh(){this.setState({loading:true});this.handleEData(this.props.config.params);}},{key:'handleDelete',value:function handleDelete(){this.setState({deleted:true});}}]);return EcodeElement;}(_react2.default.Component);exports.default=EcodeElement;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(622);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.props.handleRefresh(this);this.setState({refresh:tabid!==currentTab,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/ecodeelementtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var ebaseid=tabdata.boundID,moreUrl=tabdata.moreUrl;var fontStyle=config.item.fontStyle;var isHasRight=config.isHasRight,isSetting=config.isSetting,item=config.item,params=config.params,synergyParams=config.synergyParams;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;var eid=item.eid,contentview=item.contentview,style=item.style,_item$custom=item.custom,custom=_item$custom===undefined?{}:_item$custom;esetting.fontStyle=fontStyle;var packagename=custom.packagename,viewcompname=custom.viewcompname;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};try{if(moreUrl){if(config.item.header&&config.item.header.toolbar&&config.item.header.toolbar.more){config.item.header.toolbar.more.morehref=moreUrl;}}else{config.item.header.toolbar.more=null;}}catch(e){}var EContent=null;if(isHasRight){if(!this.props.refresh){if(window.rewritePortalCusEle&&typeof rewritePortalCusEle=='function'){var props=(0,_extends3.default)({},this.props);var options={config:config,fontSizeMp:fontSizeMp,isSetting:isSetting,id:eid,eid:eid,ebaseid:ebaseid,params:params,synergyParams:synergyParams};EContent=window.rewritePortalCusEle(props,options);}if(EContent==null&&window[packagename]&&window[packagename]['com']&&window[packagename]['com'][viewcompname]){var EContentTemp=window[packagename]['com'][viewcompname];EContent=_react2.default.createElement(EContentTemp,(0,_extends3.default)({},this.props,{config:config,fontSizeMp:fontSizeMp,isSetting:isSetting,id:eid,eid:eid,params:params,synergyParams:synergyParams}));}}else{EContent=_react2.default.createElement('div',{style:{width:'100%',height:'60px'}});}}else{EContent=_react2.default.createElement(_common.NoRightCom,null);}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,status:status,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},EContent));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(24);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(23);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;// this.setMoreHref();
(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;// this.setMoreHref();
(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,viewType=_props3.viewType,typeid=_props3.typeid,status=_props3.status,jointype=_props3.jointype,currentTab=_props3.currentTab;var eid=config.item.eid;window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?viewType="+viewType+"&typeid="+typeid+"&jointype="+jointype+"&status="+status};}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _elements=__webpack_require__(98);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//引入元素组件
var ElementIndie=function(_React$Component){(0,_inherits3.default)(ElementIndie,_React$Component);function ElementIndie(props){(0,_classCallCheck3.default)(this,ElementIndie);var _this=(0,_possibleConstructorReturn3.default)(this,(ElementIndie.__proto__||(0,_getPrototypeOf2.default)(ElementIndie)).call(this,props));_this.state={config:null,eCss:''};_this.getElementData=_this.getElementData.bind(_this);return _this;}(0,_createClass3.default)(ElementIndie,[{key:'getElementData',value:function getElementData(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var url=params.elementtype=='elementtemplate'?'/api/portal/elementtemplate/preview':'/api/portal/elementindie/elementinfo';_ecCom.WeaTools.callApi(url,'POST',params).then(function(data){if(data.status==='2'){message.error(data.errormsg);}else{_this2.setState({config:data.config,eCss:data.eCss});}});}},{key:'componentWillMount',value:function componentWillMount(){this.getElementData(this.props.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.props.params,nextProps.params)){this.getElementData(nextProps.params);}}},{key:'render',value:function render(){var _state=this.state,config=_state.config,eCss=_state.eCss;if(!config)return _react2.default.createElement('div',null);var styleStr="<style type='text/css'>"+eCss.replace(/\"/g,"")+"</style>";return _react2.default.createElement('div',null,_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:styleStr}}),_react2.default.createElement(_elements.Element,{config:config}));}}]);return ElementIndie;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ElementIndie=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ElementIndie);exports.default=ElementIndie;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _Homepage=__webpack_require__(70);var _Homepage2=_interopRequireDefault(_Homepage);var _Synergy=__webpack_require__(625);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Synergy=function(_React$Component){(0,_inherits3.default)(Synergy,_React$Component);function Synergy(props){(0,_classCallCheck3.default)(this,Synergy);var _this=(0,_possibleConstructorReturn3.default)(this,(Synergy.__proto__||(0,_getPrototypeOf2.default)(Synergy)).call(this,props));_this.state={hpid:0,isuse:false,width:_Synergy.SYNERGY_WIDTH,visible:false,btnHover:false};_this.getSynergyPortal=_this.getSynergyPortal.bind(_this);_this.isShowSynergy=_this.isShowSynergy.bind(_this);return _this;}(0,_createClass3.default)(Synergy,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,pathname=_props.pathname,workflowid=_props.workflowid,requestid=_props.requestid;if(pathname!='/workflow/req'||pathname=='/workflow/req'&&!!workflowid&&!!requestid){this.getSynergyPortal(this.props);}}},{key:'componentDidMount',value:function componentDidMount(){window.isShowSynergy=this.isShowSynergy;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var isNeedReq=this.props.pathname!=nextProps.pathname||this.props.workflowid!=nextProps.workflowid||this.props.requestid!=nextProps.requestid||this.props.secid!=nextProps.secid||this.props.docid!=nextProps.docid;if(isNeedReq){this.getSynergyPortal(nextProps);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.state.hpid!=nextState.hpid||this.state.isuse!=nextState.isuse||this.state.visible!=nextState.visible||this.state.btnHover!=nextState.btnHover||this.props.formData!=nextProps.formData;}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,_props2$workflowid=_props2.workflowid,workflowid=_props2$workflowid===undefined?-1:_props2$workflowid,_props2$requestid=_props2.requestid,requestid=_props2$requestid===undefined?-1:_props2$requestid,_props2$formData=_props2.formData,formData=_props2$formData===undefined?{}:_props2$formData;var _state=this.state,hpid=_state.hpid,isuse=_state.isuse,width=_state.width,visible=_state.visible,btnHover=_state.btnHover;if(hpid!=0&&isuse){var content=_react2.default.createElement('div',null);if(visible){content=_react2.default.createElement('div',{style:{position:'absolute',top:0,right:0,zIndex:998,width:'100%',height:'100%',padding:'10px',overflow:'auto',background:'#f6f7f9',borderLeft:'1px solid #e2e2e2'}},_react2.default.createElement(_Homepage2.default,{hpid:hpid,workflowid:workflowid,requestid:requestid,formData:formData}));}var style={position:'absolute',top:'50%',left:'1px',zIndex:999,width:'16px',height:'60px',background:'url('+('/spa/portal/images/synergy/'+(visible?''+(btnHover?'right_hover.png':'right.png'):''+(btnHover?'left_hover.png':'left.png')))+') center no-repeat',cursor:'pointer'};if(!visible){style={position:'absolute',top:'50%',right:'0',zIndex:999,width:'16px',height:'60px',background:'url('+('/spa/portal/images/synergy/'+(visible?''+(btnHover?'right_hover.png':'right.png'):''+(btnHover?'left_hover.png':'left.png')))+') center no-repeat',cursor:'pointer'};}return _react2.default.createElement('div',{style:{position:'absolute',top:0,right:0,height:'100%',width:visible?width:0}},content,_react2.default.createElement('div',{style:style,title:visible?getLabel(387991,"隐藏协同区"):getLabel(387992,"显示协同区"),onClick:function onClick(){return _this2.setState({visible:!visible});},onMouseOver:function onMouseOver(){return _this2.setState({btnHover:true});},onMouseOut:function onMouseOut(){return _this2.setState({btnHover:false});}}));}else{return _react2.default.createElement('div',null);}}},{key:'getSynergyPortal',value:function getSynergyPortal(params){var _this3=this;var pathname=params.pathname,_params$workflowid=params.workflowid,workflowid=_params$workflowid===undefined?-1:_params$workflowid,_params$requestid=params.requestid,requestid=_params$requestid===undefined?-1:_params$requestid,_params$secid=params.secid,secid=_params$secid===undefined?-1:_params$secid,_params$docid=params.docid,docid=_params$docid===undefined?-1:_params$docid;if(pathname=='/workflow/req'&&requestid==-1){pathname='/workflow/req?iscreate=1';}var pathObj=_Synergy.SYNERGY_PATH_OBJ[pathname]||{};_ecCom.WeaTools.callApi('/api/portal/synergy/getSynergyPortal','GET',{path:pathObj.path||'',pathparam:pathObj.pathparam||'',workflowid:workflowid,requestid:requestid,secid:secid,docid:docid}).then(function(data){_this3.setState({hpid:data.hpid||0,isuse:data.isuse||false,width:data.width||_Synergy.SYNERGY_WIDTH,visible:data.defaultExpand==1?true:false});});}},{key:'isShowSynergy',value:function isShowSynergy(visible){this.setState({visible:visible});}}]);return Synergy;}(_react2.default.Component);exports.default=Synergy;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var SYNERGY_PATH_OBJ=exports.SYNERGY_PATH_OBJ={'/workflow/add':{path:'/workflow/request/RequestTypeShow.jsp',pathparam:''},'/workflow/listDoing':{path:'/workflow/search/WFSearchResult.jsp',pathparam:'scope=doing'},'/workflow/listDone':{path:'/workflow/search/WFSearchResult.jsp',pathparam:'scope=done'},'/workflow/listMine':{path:'/workflow/search/WFSearchResult.jsp',pathparam:'scope=mine'},'/workflow/supervise':{path:'/workflow/search/WFSuperviseList.jsp',pathparam:''},'/workflow/agent':{path:'/workflow/request/wfAgentList.jsp',pathparam:'scope=1'},'/workflow/monitorResult':{path:'/system/systemmonitor/workflow/WorkflowMonitorList.jsp',pathparam:''},'/workflow/queryFlowResult':{path:'/workflow/search/WFSearchShow.jsp',pathparam:''},'/workflow/req?iscreate=1':{path:'/workflow/request/AddRequest.jsp',pathparam:''},'/workflow/req':{path:'/workflow/request/ViewRequest.jsp',pathparam:''},'/document/add':{path:'/docs/docs/DocList.jsp',pathparam:''},'/document/center':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=5'},'/document/search':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=14'},'/document/dummy':{path:'/docs/docdummy/DocDummyRight.jsp',pathparam:''},'/document/subscribe':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=7'},'/document/share':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=13'},'/document/move':{path:'/docs/tools/DocCopyMove.jsp',pathparam:''},'/document/monitor':{path:'/system/systemmonitor/docs/DocMonitor.jsp',pathparam:''},'/document/edit':{path:'/docs/docs/DocAdd.jsp',pathparam:''},'/document/detail':{path:'/docs/docs/DocDsp.jsp',pathparam:''}};var SYNERGY_WIDTH=exports.SYNERGY_WIDTH='430px';

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _HpBaseElement=__webpack_require__(125);var _HpBaseElement2=_interopRequireDefault(_HpBaseElement);var _Homepage=__webpack_require__(70);var _Homepage2=_interopRequireDefault(_Homepage);var _rcmenu=__webpack_require__(77);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=_antd.Menu.Item;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var SynergyPortalSetting=function(_React$Component){(0,_inherits3.default)(SynergyPortalSetting,_React$Component);function SynergyPortalSetting(props){(0,_classCallCheck3.default)(this,SynergyPortalSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergyPortalSetting.__proto__||(0,_getPrototypeOf2.default)(SynergyPortalSetting)).call(this,props));_this.state={params:{},loading:false,data:{hpbaseelements:[],hpsettingmenu:[],rcmenu:[]},showLeft:true,showDrop:false,isShrink:false};_this.onChangeLabel=_this.onChangeLabel.bind(_this);_this.onShowDrop=_this.onShowDrop.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.handleRefreshPortal=_this.handleRefreshPortal.bind(_this);_this.handleAddElementToPortalStart=_this.handleAddElementToPortalStart.bind(_this);_this.handleAddElementToPortal=_this.handleAddElementToPortal.bind(_this);return _this;}(0,_createClass3.default)(SynergyPortalSetting,[{key:'onShowDrop',value:function onShowDrop(){this.setState({showDrop:!this.state.showDrop});}},{key:'getButtons',value:function getButtons(){var _this2=this;var btns=[];var hpsettingmenu=this.state.data.hpsettingmenu;hpsettingmenu.map(function(menu,i){if(menu.key=='more'){btns.push(_react2.default.createElement(OperateMenu,{dropMenuDatas:_this2.getRightMenu(),onShowDrop:_this2.onShowDrop,onDropMenuClick:_this2.onRightMenuClick,showDrop:_this2.state.showDrop},_react2.default.createElement(_antd.Button,{onClick:_this2.onShowDrop},menu.label)));}else{btns.push(_react2.default.createElement(_antd.Button,{type:i===4?'':'primary',onClick:_this2.onRightMenuClick.bind(_this2,menu.key)},menu.label));}});return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];var rcmenu=this.state.data.rcmenu;if(rcmenu){rcmenu.map(function(menu){btns.push({key:menu.key,icon:_react2.default.createElement('i',{className:menu.icon}),content:menu.label});});}return btns;}},{key:'onChangeLabel',value:function onChangeLabel(list,key,bool,label1,lable2){for(var i=0;i<list.length;i++){var item=list[i]||{};if(item.key==key){if(bool){item.label=label1;if(item.label==getLabel(18466,'全部收缩')){item.icon="icon-coms-All-contraction";}if(item.label==getLabel(19613,"显示元素库")){item.icon="icon-coms-display";}}else{item.label=lable2;if(item.label==getLabel(16216,'全部展开')){item.icon="icon-coms-All-unfolding";}if(item.label==getLabel(19614,"隐藏元素库")){item.icon="icon-coms-hide";}}break;}}}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var _state=this.state,params=_state.params,showLeft=_state.showLeft,isShrink=_state.isShrink,data=_state.data;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;switch(key){case'updatesynihp':case'completesynihp':(0,_rcmenu.handlePortalSynize)({hpid:hpid,subCompanyId:subCompanyId,method:key});break;case'shrinkAll':this.setState({isShrink:!isShrink});this.onChangeLabel(data.rcmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(16216,'全部展开'));this.onChangeLabel(data.hpsettingmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(16216,'全部展开'));(0,_rcmenu.onShowOrHideAllE)(isSetting);break;case'store':(0,_rcmenu.openFavouriteBrowser)();break;case'help':(0,_rcmenu.showHelp)();break;case'hiddenElementLib':this.setState({showLeft:!showLeft});this.onChangeLabel(data.rcmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));this.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));break;}}},{key:'componentWillMount',value:function componentWillMount(){var params=this.props.params;this.getData(params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var params=this.props.params;var nextParams=nextProps.params;if(params.hpid!=nextParams.hpid){this.getData(nextParams);}}},{key:'getData',value:function getData(params){var _this3=this;this.setState({loading:true});_ecCom.WeaTools.callApi('/api/portal/hpsetting/hpsettinginfo','POST',(0,_extends3.default)({},params,{isSynergySetting:true})).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);return;}_this3.setState({params:params,loading:false,data:data});});}},{key:'handleRefreshPortal',value:function handleRefreshPortal(params){this.refs.homepage.handleRefresh(params);}},{key:'handleAddElementToPortalStart',value:function handleAddElementToPortalStart(){this.setState({loading:true});}},{key:'handleAddElementToPortal',value:function handleAddElementToPortal(element,areaflag,index){this.setState({loading:false});this.refs.homepage.handleAddElement(element,areaflag,index);}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,params=_state2.params,data=_state2.data,showLeft=_state2.showLeft;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;if(!hpid)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement(_ecCom.WeaLeftRightLayout,{isNew:true,showLeft:showLeft,leftWidth:150,leftCom:_react2.default.createElement(_HpBaseElement2.default,{isSynergySetting:true,handleRefreshPortal:this.handleRefreshPortal,handleAddStart:this.handleAddElementToPortalStart,handleAdd:this.handleAddElementToPortal,params:params,list:data.hpbaseelements}),onCollapse:function onCollapse(bool){_this4.setState({showLeft:bool});_this4.onChangeLabel(data.rcmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel(19613,"显示元素库"));_this4.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel(19613,"显示元素库"));}},_react2.default.createElement('div',{id:'e9PortalSetting',className:'portal-e9setting',style:{height:'100%'}},_react2.default.createElement(_Homepage2.default,{ref:'homepage',hpid:hpid,isSetting:true,isSynergySetting:true,synergyParams:params})))));}}]);return SynergyPortalSetting;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SynergyPortalSetting=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SynergyPortalSetting);exports.default=SynergyPortalSetting;var OperateMenu=function(_React$Component3){(0,_inherits3.default)(OperateMenu,_React$Component3);function OperateMenu(){(0,_classCallCheck3.default)(this,OperateMenu);return(0,_possibleConstructorReturn3.default)(this,(OperateMenu.__proto__||(0,_getPrototypeOf2.default)(OperateMenu)).apply(this,arguments));}(0,_createClass3.default)(OperateMenu,[{key:'render',value:function render(){var _props=this.props,dropMenuDatas=_props.dropMenuDatas,onDropMenuClick=_props.onDropMenuClick,onShowDrop=_props.onShowDrop,showDrop=_props.showDrop,children=_props.children;var menu=dropMenuDatas?_react2.default.createElement(_antd.Menu,{mode:'vertical',onClick:function onClick(o){if(typeof onDropMenuClick==='function')onDropMenuClick(o.key);dropMenuDatas.forEach(function(d){if(d.key===o.key&&typeof d.onClick==='function')d.onClick(o.key);});}},dropMenuDatas.map(function(d,i){return _react2.default.createElement(Item,{key:d.key||i,disabled:d.disabled},_react2.default.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return _react2.default.createElement('div',{className:'portal-portalsetting-moremenu-pop'},_react2.default.createElement('div',{className:'wea-new-top-drop-menu wea-right-menu',style:{display:showDrop?'block':'none'},onMouseLeave:onShowDrop},_react2.default.createElement('div',{className:'wea-right-menu-icon-background'}),menu),children);}}]);return OperateMenu;}(_react2.default.Component);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js?v=b4e429bc